import React43, { createContext, useRef, useState, useEffect, useContext, useCallback, forwardRef, isValidElement, cloneElement, Children, useMemo, PureComponent, createElement, Component, useImperativeHandle } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { createVarsResolver, getSize, factory, useProps, useStyles, UnstyledButton, getSpacing, getFontSize, Box, useResolvedStylesApi, AccordionChevron, useInputProps, CloseButton, Input, Popover, Modal, rem, Button, Badge, ScrollArea, Select, Checkbox, InputLabel, Card, Tooltip, Menu, MantineProvider, Anchor, Breadcrumbs, Accordion, Table, Pagination } from '@mantine/core';
import { useUncontrolled, useDidUpdate, useClickOutside, clamp, useDisclosure } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod2) => function __require() {
  return mod2 || (0, cb[__getOwnPropNames(cb)[0]])((mod2 = { exports: {} }).exports, mod2), mod2.exports;
};
var __export = (target, all) => {
  for (var name2 in all)
    __defProp(target, name2, { get: all[name2], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key2 of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod2, isNodeMode, target) => (target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod2 || !mod2.__esModule ? __defProp(target, "default", { value: mod2, enumerable: true }) : target,
  mod2
));

// node_modules/.pnpm/lottie-web@5.12.2/node_modules/lottie-web/build/player/lottie.js
var require_lottie = __commonJS({
  "node_modules/.pnpm/lottie-web@5.12.2/node_modules/lottie-web/build/player/lottie.js"(exports, module) {
    typeof navigator !== "undefined" && function(global2, factory17) {
      typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory17() : typeof define === "function" && define.amd ? define(factory17) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.lottie = factory17());
    }(exports, function() {
      var svgNS = "http://www.w3.org/2000/svg";
      var locationHref = "";
      var _useWebWorker = false;
      var initialDefaultFrame = -999999;
      var setWebWorker = function setWebWorker2(flag) {
        _useWebWorker = !!flag;
      };
      var getWebWorker = function getWebWorker2() {
        return _useWebWorker;
      };
      var setLocationHref = function setLocationHref2(value2) {
        locationHref = value2;
      };
      var getLocationHref = function getLocationHref2() {
        return locationHref;
      };
      function createTag(type) {
        return document.createElement(type);
      }
      function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for (i = 0; i < len; i += 1) {
          sourcePrototype = sources[i].prototype;
          for (var attr in sourcePrototype) {
            if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
          }
        }
      }
      function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
      }
      function createProxyFunction(prototype) {
        function ProxyFunction() {
        }
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
      }
      var audioControllerFactory = function() {
        function AudioController(audioFactory) {
          this.audios = [];
          this.audioFactory = audioFactory;
          this._volume = 1;
          this._isMuted = false;
        }
        AudioController.prototype = {
          addAudio: function addAudio(audio) {
            this.audios.push(audio);
          },
          pause: function pause() {
            var i;
            var len = this.audios.length;
            for (i = 0; i < len; i += 1) {
              this.audios[i].pause();
            }
          },
          resume: function resume() {
            var i;
            var len = this.audios.length;
            for (i = 0; i < len; i += 1) {
              this.audios[i].resume();
            }
          },
          setRate: function setRate(rateValue) {
            var i;
            var len = this.audios.length;
            for (i = 0; i < len; i += 1) {
              this.audios[i].setRate(rateValue);
            }
          },
          createAudio: function createAudio(assetPath) {
            if (this.audioFactory) {
              return this.audioFactory(assetPath);
            }
            if (window.Howl) {
              return new window.Howl({
                src: [assetPath]
              });
            }
            return {
              isPlaying: false,
              play: function play() {
                this.isPlaying = true;
              },
              seek: function seek() {
                this.isPlaying = false;
              },
              playing: function playing() {
              },
              rate: function rate() {
              },
              setVolume: function setVolume() {
              }
            };
          },
          setAudioFactory: function setAudioFactory(audioFactory) {
            this.audioFactory = audioFactory;
          },
          setVolume: function setVolume(value2) {
            this._volume = value2;
            this._updateVolume();
          },
          mute: function mute() {
            this._isMuted = true;
            this._updateVolume();
          },
          unmute: function unmute() {
            this._isMuted = false;
            this._updateVolume();
          },
          getVolume: function getVolume() {
            return this._volume;
          },
          _updateVolume: function _updateVolume() {
            var i;
            var len = this.audios.length;
            for (i = 0; i < len; i += 1) {
              this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
          }
        };
        return function() {
          return new AudioController();
        };
      }();
      var createTypedArray = function() {
        function createRegularArray(type, len) {
          var i = 0;
          var arr = [];
          var value2;
          switch (type) {
            case "int16":
            case "uint8c":
              value2 = 1;
              break;
            default:
              value2 = 1.1;
              break;
          }
          for (i = 0; i < len; i += 1) {
            arr.push(value2);
          }
          return arr;
        }
        function createTypedArrayFactory(type, len) {
          if (type === "float32") {
            return new Float32Array(len);
          }
          if (type === "int16") {
            return new Int16Array(len);
          }
          if (type === "uint8c") {
            return new Uint8ClampedArray(len);
          }
          return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === "function" && typeof Float32Array === "function") {
          return createTypedArrayFactory;
        }
        return createRegularArray;
      }();
      function createSizedArray(len) {
        return Array.apply(null, {
          length: len
        });
      }
      function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$6 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$6 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$6(obj);
      }
      var subframeEnabled = true;
      var expressionsPlugin = null;
      var expressionsInterfaces = null;
      var idPrefix$1 = "";
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      var bmPow = Math.pow;
      var bmSqrt = Math.sqrt;
      var bmFloor = Math.floor;
      var bmMax = Math.max;
      var bmMin = Math.min;
      var BMMath = {};
      (function() {
        var propertyNames = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"];
        var i;
        var len = propertyNames.length;
        for (i = 0; i < len; i += 1) {
          BMMath[propertyNames[i]] = Math[propertyNames[i]];
        }
      })();
      BMMath.random = Math.random;
      BMMath.abs = function(val2) {
        var tOfVal = _typeof$6(val2);
        if (tOfVal === "object" && val2.length) {
          var absArr = createSizedArray(val2.length);
          var i;
          var len = val2.length;
          for (i = 0; i < len; i += 1) {
            absArr[i] = Math.abs(val2[i]);
          }
          return absArr;
        }
        return Math.abs(val2);
      };
      var defaultCurveSegments = 150;
      var degToRads = Math.PI / 180;
      var roundCorner = 0.5519;
      function styleDiv(element) {
        element.style.position = "absolute";
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = "block";
        element.style.transformOrigin = "0 0";
        element.style.webkitTransformOrigin = "0 0";
        element.style.backfaceVisibility = "visible";
        element.style.webkitBackfaceVisibility = "visible";
        element.style.transformStyle = "preserve-3d";
        element.style.webkitTransformStyle = "preserve-3d";
        element.style.mozTransformStyle = "preserve-3d";
      }
      function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
      }
      function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
      }
      function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
      }
      function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
      }
      function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
      }
      function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = "renderFrameError";
        this.nativeError = nativeError;
        this.currentTime = currentTime;
      }
      function BMConfigErrorEvent(nativeError) {
        this.type = "configError";
        this.nativeError = nativeError;
      }
      var createElementID = /* @__PURE__ */ function() {
        var _count = 0;
        return function createID() {
          _count += 1;
          return idPrefix$1 + "__lottie_element_" + _count;
        };
      }();
      function HSVtoRGB(h, s2, v) {
        var r2;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s2);
        q = v * (1 - f * s2);
        t = v * (1 - (1 - f) * s2);
        switch (i % 6) {
          case 0:
            r2 = v;
            g = t;
            b = p;
            break;
          case 1:
            r2 = q;
            g = v;
            b = p;
            break;
          case 2:
            r2 = p;
            g = v;
            b = t;
            break;
          case 3:
            r2 = p;
            g = q;
            b = v;
            break;
          case 4:
            r2 = t;
            g = p;
            b = v;
            break;
          case 5:
            r2 = v;
            g = p;
            b = q;
            break;
        }
        return [r2, g, b];
      }
      function RGBtoHSV(r2, g, b) {
        var max4 = Math.max(r2, g, b);
        var min3 = Math.min(r2, g, b);
        var d = max4 - min3;
        var h;
        var s2 = max4 === 0 ? 0 : d / max4;
        var v = max4 / 255;
        switch (max4) {
          case min3:
            h = 0;
            break;
          case r2:
            h = g - b + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
          case g:
            h = b - r2 + d * 2;
            h /= 6 * d;
            break;
          case b:
            h = r2 - g + d * 4;
            h /= 6 * d;
            break;
        }
        return [h, s2, v];
      }
      function addSaturationToRGB(color2, offset) {
        var hsv = RGBtoHSV(color2[0] * 255, color2[1] * 255, color2[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) {
          hsv[1] = 1;
        } else if (hsv[1] <= 0) {
          hsv[1] = 0;
        }
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
      }
      function addBrightnessToRGB(color2, offset) {
        var hsv = RGBtoHSV(color2[0] * 255, color2[1] * 255, color2[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) {
          hsv[2] = 1;
        } else if (hsv[2] < 0) {
          hsv[2] = 0;
        }
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
      }
      function addHueToRGB(color2, offset) {
        var hsv = RGBtoHSV(color2[0] * 255, color2[1] * 255, color2[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) {
          hsv[0] -= 1;
        } else if (hsv[0] < 0) {
          hsv[0] += 1;
        }
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
      }
      var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex2;
        for (i = 0; i < 256; i += 1) {
          hex2 = i.toString(16);
          colorMap[i] = hex2.length === 1 ? "0" + hex2 : hex2;
        }
        return function(r2, g, b) {
          if (r2 < 0) {
            r2 = 0;
          }
          if (g < 0) {
            g = 0;
          }
          if (b < 0) {
            b = 0;
          }
          return "#" + colorMap[r2] + colorMap[g] + colorMap[b];
        };
      }();
      var setSubframeEnabled = function setSubframeEnabled2(flag) {
        subframeEnabled = !!flag;
      };
      var getSubframeEnabled = function getSubframeEnabled2() {
        return subframeEnabled;
      };
      var setExpressionsPlugin = function setExpressionsPlugin2(value2) {
        expressionsPlugin = value2;
      };
      var getExpressionsPlugin = function getExpressionsPlugin2() {
        return expressionsPlugin;
      };
      var setExpressionInterfaces = function setExpressionInterfaces2(value2) {
        expressionsInterfaces = value2;
      };
      var getExpressionInterfaces = function getExpressionInterfaces2() {
        return expressionsInterfaces;
      };
      var setDefaultCurveSegments = function setDefaultCurveSegments2(value2) {
        defaultCurveSegments = value2;
      };
      var getDefaultCurveSegments = function getDefaultCurveSegments2() {
        return defaultCurveSegments;
      };
      var setIdPrefix = function setIdPrefix2(value2) {
        idPrefix$1 = value2;
      };
      function createNS(type) {
        return document.createElementNS(svgNS, type);
      }
      function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$5 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$5 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$5(obj);
      }
      var dataManager = /* @__PURE__ */ function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
          onmessage: function onmessage() {
          },
          postMessage: function postMessage(path2) {
            workerFn({
              data: path2
            });
          }
        };
        var _workerSelf = {
          postMessage: function postMessage(data2) {
            workerProxy.onmessage({
              data: data2
            });
          }
        };
        function createWorker(fn) {
          if (window.Worker && window.Blob && getWebWorker()) {
            var blob = new Blob(["var _workerSelf = self; self.onmessage = ", fn.toString()], {
              type: "text/javascript"
            });
            var url = URL.createObjectURL(blob);
            return new Worker(url);
          }
          workerFn = fn;
          return workerProxy;
        }
        function setupWorker() {
          if (!workerInstance) {
            workerInstance = createWorker(function workerStart(e) {
              function dataFunctionManager() {
                function completeLayers(layers, comps) {
                  var layerData;
                  var i;
                  var len = layers.length;
                  var j;
                  var jLen;
                  var k2;
                  var kLen;
                  for (i = 0; i < len; i += 1) {
                    layerData = layers[i];
                    if ("ks" in layerData && !layerData.completed) {
                      layerData.completed = true;
                      if (layerData.hasMask) {
                        var maskProps = layerData.masksProperties;
                        jLen = maskProps.length;
                        for (j = 0; j < jLen; j += 1) {
                          if (maskProps[j].pt.k.i) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k);
                          } else {
                            kLen = maskProps[j].pt.k.length;
                            for (k2 = 0; k2 < kLen; k2 += 1) {
                              if (maskProps[j].pt.k[k2].s) {
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k2].s[0]);
                              }
                              if (maskProps[j].pt.k[k2].e) {
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k2].e[0]);
                              }
                            }
                          }
                        }
                      }
                      if (layerData.ty === 0) {
                        layerData.layers = findCompLayers(layerData.refId, comps);
                        completeLayers(layerData.layers, comps);
                      } else if (layerData.ty === 4) {
                        completeShapes(layerData.shapes);
                      } else if (layerData.ty === 5) {
                        completeText(layerData);
                      }
                    }
                  }
                }
                function completeChars(chars, assets) {
                  if (chars) {
                    var i = 0;
                    var len = chars.length;
                    for (i = 0; i < len; i += 1) {
                      if (chars[i].t === 1) {
                        chars[i].data.layers = findCompLayers(chars[i].data.refId, assets);
                        completeLayers(chars[i].data.layers, assets);
                      }
                    }
                  }
                }
                function findComp(id, comps) {
                  var i = 0;
                  var len = comps.length;
                  while (i < len) {
                    if (comps[i].id === id) {
                      return comps[i];
                    }
                    i += 1;
                  }
                  return null;
                }
                function findCompLayers(id, comps) {
                  var comp2 = findComp(id, comps);
                  if (comp2) {
                    if (!comp2.layers.__used) {
                      comp2.layers.__used = true;
                      return comp2.layers;
                    }
                    return JSON.parse(JSON.stringify(comp2.layers));
                  }
                  return null;
                }
                function completeShapes(arr) {
                  var i;
                  var len = arr.length;
                  var j;
                  var jLen;
                  for (i = len - 1; i >= 0; i -= 1) {
                    if (arr[i].ty === "sh") {
                      if (arr[i].ks.k.i) {
                        convertPathsToAbsoluteValues(arr[i].ks.k);
                      } else {
                        jLen = arr[i].ks.k.length;
                        for (j = 0; j < jLen; j += 1) {
                          if (arr[i].ks.k[j].s) {
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                          }
                          if (arr[i].ks.k[j].e) {
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                          }
                        }
                      }
                    } else if (arr[i].ty === "gr") {
                      completeShapes(arr[i].it);
                    }
                  }
                }
                function convertPathsToAbsoluteValues(path2) {
                  var i;
                  var len = path2.i.length;
                  for (i = 0; i < len; i += 1) {
                    path2.i[i][0] += path2.v[i][0];
                    path2.i[i][1] += path2.v[i][1];
                    path2.o[i][0] += path2.v[i][0];
                    path2.o[i][1] += path2.v[i][1];
                  }
                }
                function checkVersion(minimum, animVersionString) {
                  var animVersion = animVersionString ? animVersionString.split(".") : [100, 100, 100];
                  if (minimum[0] > animVersion[0]) {
                    return true;
                  }
                  if (animVersion[0] > minimum[0]) {
                    return false;
                  }
                  if (minimum[1] > animVersion[1]) {
                    return true;
                  }
                  if (animVersion[1] > minimum[1]) {
                    return false;
                  }
                  if (minimum[2] > animVersion[2]) {
                    return true;
                  }
                  if (animVersion[2] > minimum[2]) {
                    return false;
                  }
                  return null;
                }
                var checkText = /* @__PURE__ */ function() {
                  var minimumVersion = [4, 4, 14];
                  function updateTextLayer(textLayer) {
                    var documentData = textLayer.t.d;
                    textLayer.t.d = {
                      k: [{
                        s: documentData,
                        t: 0
                      }]
                    };
                  }
                  function iterateLayers(layers) {
                    var i;
                    var len = layers.length;
                    for (i = 0; i < len; i += 1) {
                      if (layers[i].ty === 5) {
                        updateTextLayer(layers[i]);
                      }
                    }
                  }
                  return function(animationData2) {
                    if (checkVersion(minimumVersion, animationData2.v)) {
                      iterateLayers(animationData2.layers);
                      if (animationData2.assets) {
                        var i;
                        var len = animationData2.assets.length;
                        for (i = 0; i < len; i += 1) {
                          if (animationData2.assets[i].layers) {
                            iterateLayers(animationData2.assets[i].layers);
                          }
                        }
                      }
                    }
                  };
                }();
                var checkChars = /* @__PURE__ */ function() {
                  var minimumVersion = [4, 7, 99];
                  return function(animationData2) {
                    if (animationData2.chars && !checkVersion(minimumVersion, animationData2.v)) {
                      var i;
                      var len = animationData2.chars.length;
                      for (i = 0; i < len; i += 1) {
                        var charData = animationData2.chars[i];
                        if (charData.data && charData.data.shapes) {
                          completeShapes(charData.data.shapes);
                          charData.data.ip = 0;
                          charData.data.op = 99999;
                          charData.data.st = 0;
                          charData.data.sr = 1;
                          charData.data.ks = {
                            p: {
                              k: [0, 0],
                              a: 0
                            },
                            s: {
                              k: [100, 100],
                              a: 0
                            },
                            a: {
                              k: [0, 0],
                              a: 0
                            },
                            r: {
                              k: 0,
                              a: 0
                            },
                            o: {
                              k: 100,
                              a: 0
                            }
                          };
                          if (!animationData2.chars[i].t) {
                            charData.data.shapes.push({
                              ty: "no"
                            });
                            charData.data.shapes[0].it.push({
                              p: {
                                k: [0, 0],
                                a: 0
                              },
                              s: {
                                k: [100, 100],
                                a: 0
                              },
                              a: {
                                k: [0, 0],
                                a: 0
                              },
                              r: {
                                k: 0,
                                a: 0
                              },
                              o: {
                                k: 100,
                                a: 0
                              },
                              sk: {
                                k: 0,
                                a: 0
                              },
                              sa: {
                                k: 0,
                                a: 0
                              },
                              ty: "tr"
                            });
                          }
                        }
                      }
                    }
                  };
                }();
                var checkPathProperties = /* @__PURE__ */ function() {
                  var minimumVersion = [5, 7, 15];
                  function updateTextLayer(textLayer) {
                    var pathData = textLayer.t.p;
                    if (typeof pathData.a === "number") {
                      pathData.a = {
                        a: 0,
                        k: pathData.a
                      };
                    }
                    if (typeof pathData.p === "number") {
                      pathData.p = {
                        a: 0,
                        k: pathData.p
                      };
                    }
                    if (typeof pathData.r === "number") {
                      pathData.r = {
                        a: 0,
                        k: pathData.r
                      };
                    }
                  }
                  function iterateLayers(layers) {
                    var i;
                    var len = layers.length;
                    for (i = 0; i < len; i += 1) {
                      if (layers[i].ty === 5) {
                        updateTextLayer(layers[i]);
                      }
                    }
                  }
                  return function(animationData2) {
                    if (checkVersion(minimumVersion, animationData2.v)) {
                      iterateLayers(animationData2.layers);
                      if (animationData2.assets) {
                        var i;
                        var len = animationData2.assets.length;
                        for (i = 0; i < len; i += 1) {
                          if (animationData2.assets[i].layers) {
                            iterateLayers(animationData2.assets[i].layers);
                          }
                        }
                      }
                    }
                  };
                }();
                var checkColors = /* @__PURE__ */ function() {
                  var minimumVersion = [4, 1, 9];
                  function iterateShapes(shapes) {
                    var i;
                    var len = shapes.length;
                    var j;
                    var jLen;
                    for (i = 0; i < len; i += 1) {
                      if (shapes[i].ty === "gr") {
                        iterateShapes(shapes[i].it);
                      } else if (shapes[i].ty === "fl" || shapes[i].ty === "st") {
                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                          jLen = shapes[i].c.k.length;
                          for (j = 0; j < jLen; j += 1) {
                            if (shapes[i].c.k[j].s) {
                              shapes[i].c.k[j].s[0] /= 255;
                              shapes[i].c.k[j].s[1] /= 255;
                              shapes[i].c.k[j].s[2] /= 255;
                              shapes[i].c.k[j].s[3] /= 255;
                            }
                            if (shapes[i].c.k[j].e) {
                              shapes[i].c.k[j].e[0] /= 255;
                              shapes[i].c.k[j].e[1] /= 255;
                              shapes[i].c.k[j].e[2] /= 255;
                              shapes[i].c.k[j].e[3] /= 255;
                            }
                          }
                        } else {
                          shapes[i].c.k[0] /= 255;
                          shapes[i].c.k[1] /= 255;
                          shapes[i].c.k[2] /= 255;
                          shapes[i].c.k[3] /= 255;
                        }
                      }
                    }
                  }
                  function iterateLayers(layers) {
                    var i;
                    var len = layers.length;
                    for (i = 0; i < len; i += 1) {
                      if (layers[i].ty === 4) {
                        iterateShapes(layers[i].shapes);
                      }
                    }
                  }
                  return function(animationData2) {
                    if (checkVersion(minimumVersion, animationData2.v)) {
                      iterateLayers(animationData2.layers);
                      if (animationData2.assets) {
                        var i;
                        var len = animationData2.assets.length;
                        for (i = 0; i < len; i += 1) {
                          if (animationData2.assets[i].layers) {
                            iterateLayers(animationData2.assets[i].layers);
                          }
                        }
                      }
                    }
                  };
                }();
                var checkShapes = /* @__PURE__ */ function() {
                  var minimumVersion = [4, 4, 18];
                  function completeClosingShapes(arr) {
                    var i;
                    var len = arr.length;
                    var j;
                    var jLen;
                    for (i = len - 1; i >= 0; i -= 1) {
                      if (arr[i].ty === "sh") {
                        if (arr[i].ks.k.i) {
                          arr[i].ks.k.c = arr[i].closed;
                        } else {
                          jLen = arr[i].ks.k.length;
                          for (j = 0; j < jLen; j += 1) {
                            if (arr[i].ks.k[j].s) {
                              arr[i].ks.k[j].s[0].c = arr[i].closed;
                            }
                            if (arr[i].ks.k[j].e) {
                              arr[i].ks.k[j].e[0].c = arr[i].closed;
                            }
                          }
                        }
                      } else if (arr[i].ty === "gr") {
                        completeClosingShapes(arr[i].it);
                      }
                    }
                  }
                  function iterateLayers(layers) {
                    var layerData;
                    var i;
                    var len = layers.length;
                    var j;
                    var jLen;
                    var k2;
                    var kLen;
                    for (i = 0; i < len; i += 1) {
                      layerData = layers[i];
                      if (layerData.hasMask) {
                        var maskProps = layerData.masksProperties;
                        jLen = maskProps.length;
                        for (j = 0; j < jLen; j += 1) {
                          if (maskProps[j].pt.k.i) {
                            maskProps[j].pt.k.c = maskProps[j].cl;
                          } else {
                            kLen = maskProps[j].pt.k.length;
                            for (k2 = 0; k2 < kLen; k2 += 1) {
                              if (maskProps[j].pt.k[k2].s) {
                                maskProps[j].pt.k[k2].s[0].c = maskProps[j].cl;
                              }
                              if (maskProps[j].pt.k[k2].e) {
                                maskProps[j].pt.k[k2].e[0].c = maskProps[j].cl;
                              }
                            }
                          }
                        }
                      }
                      if (layerData.ty === 4) {
                        completeClosingShapes(layerData.shapes);
                      }
                    }
                  }
                  return function(animationData2) {
                    if (checkVersion(minimumVersion, animationData2.v)) {
                      iterateLayers(animationData2.layers);
                      if (animationData2.assets) {
                        var i;
                        var len = animationData2.assets.length;
                        for (i = 0; i < len; i += 1) {
                          if (animationData2.assets[i].layers) {
                            iterateLayers(animationData2.assets[i].layers);
                          }
                        }
                      }
                    }
                  };
                }();
                function completeData(animationData2) {
                  if (animationData2.__complete) {
                    return;
                  }
                  checkColors(animationData2);
                  checkText(animationData2);
                  checkChars(animationData2);
                  checkPathProperties(animationData2);
                  checkShapes(animationData2);
                  completeLayers(animationData2.layers, animationData2.assets);
                  completeChars(animationData2.chars, animationData2.assets);
                  animationData2.__complete = true;
                }
                function completeText(data2) {
                  if (data2.t.a.length === 0 && !("m" in data2.t.p)) ;
                }
                var moduleOb = {};
                moduleOb.completeData = completeData;
                moduleOb.checkColors = checkColors;
                moduleOb.checkChars = checkChars;
                moduleOb.checkPathProperties = checkPathProperties;
                moduleOb.checkShapes = checkShapes;
                moduleOb.completeLayers = completeLayers;
                return moduleOb;
              }
              if (!_workerSelf.dataManager) {
                _workerSelf.dataManager = dataFunctionManager();
              }
              if (!_workerSelf.assetLoader) {
                _workerSelf.assetLoader = /* @__PURE__ */ function() {
                  function formatResponse(xhr) {
                    var contentTypeHeader = xhr.getResponseHeader("content-type");
                    if (contentTypeHeader && xhr.responseType === "json" && contentTypeHeader.indexOf("json") !== -1) {
                      return xhr.response;
                    }
                    if (xhr.response && _typeof$5(xhr.response) === "object") {
                      return xhr.response;
                    }
                    if (xhr.response && typeof xhr.response === "string") {
                      return JSON.parse(xhr.response);
                    }
                    if (xhr.responseText) {
                      return JSON.parse(xhr.responseText);
                    }
                    return null;
                  }
                  function loadAsset(path2, fullPath, callback, errorCallback) {
                    var response;
                    var xhr = new XMLHttpRequest();
                    try {
                      xhr.responseType = "json";
                    } catch (err) {
                    }
                    xhr.onreadystatechange = function() {
                      if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                          response = formatResponse(xhr);
                          callback(response);
                        } else {
                          try {
                            response = formatResponse(xhr);
                            callback(response);
                          } catch (err) {
                            if (errorCallback) {
                              errorCallback(err);
                            }
                          }
                        }
                      }
                    };
                    try {
                      xhr.open(["G", "E", "T"].join(""), path2, true);
                    } catch (error) {
                      xhr.open(["G", "E", "T"].join(""), fullPath + "/" + path2, true);
                    }
                    xhr.send();
                  }
                  return {
                    load: loadAsset
                  };
                }();
              }
              if (e.data.type === "loadAnimation") {
                _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data2) {
                  _workerSelf.dataManager.completeData(data2);
                  _workerSelf.postMessage({
                    id: e.data.id,
                    payload: data2,
                    status: "success"
                  });
                }, function() {
                  _workerSelf.postMessage({
                    id: e.data.id,
                    status: "error"
                  });
                });
              } else if (e.data.type === "complete") {
                var animation = e.data.animation;
                _workerSelf.dataManager.completeData(animation);
                _workerSelf.postMessage({
                  id: e.data.id,
                  payload: animation,
                  status: "success"
                });
              } else if (e.data.type === "loadData") {
                _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data2) {
                  _workerSelf.postMessage({
                    id: e.data.id,
                    payload: data2,
                    status: "success"
                  });
                }, function() {
                  _workerSelf.postMessage({
                    id: e.data.id,
                    status: "error"
                  });
                });
              }
            });
            workerInstance.onmessage = function(event) {
              var data2 = event.data;
              var id = data2.id;
              var process2 = processes[id];
              processes[id] = null;
              if (data2.status === "success") {
                process2.onComplete(data2.payload);
              } else if (process2.onError) {
                process2.onError();
              }
            };
          }
        }
        function createProcess(onComplete, onError) {
          _counterId += 1;
          var id = "processId_" + _counterId;
          processes[id] = {
            onComplete,
            onError
          };
          return id;
        }
        function loadAnimation2(path2, onComplete, onError) {
          setupWorker();
          var processId = createProcess(onComplete, onError);
          workerInstance.postMessage({
            type: "loadAnimation",
            path: path2,
            fullPath: window.location.origin + window.location.pathname,
            id: processId
          });
        }
        function loadData(path2, onComplete, onError) {
          setupWorker();
          var processId = createProcess(onComplete, onError);
          workerInstance.postMessage({
            type: "loadData",
            path: path2,
            fullPath: window.location.origin + window.location.pathname,
            id: processId
          });
        }
        function completeAnimation(anim, onComplete, onError) {
          setupWorker();
          var processId = createProcess(onComplete, onError);
          workerInstance.postMessage({
            type: "complete",
            animation: anim,
            id: processId
          });
        }
        return {
          loadAnimation: loadAnimation2,
          loadData,
          completeAnimation
        };
      }();
      var ImagePreloader = function() {
        var proxyImage = function() {
          var canvas = createTag("canvas");
          canvas.width = 1;
          canvas.height = 1;
          var ctx = canvas.getContext("2d");
          ctx.fillStyle = "rgba(0,0,0,0)";
          ctx.fillRect(0, 0, 1, 1);
          return canvas;
        }();
        function imageLoaded() {
          this.loadedAssets += 1;
          if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
            if (this.imagesLoadedCb) {
              this.imagesLoadedCb(null);
            }
          }
        }
        function footageLoaded() {
          this.loadedFootagesCount += 1;
          if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
            if (this.imagesLoadedCb) {
              this.imagesLoadedCb(null);
            }
          }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
          var path2 = "";
          if (assetData.e) {
            path2 = assetData.p;
          } else if (assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf("images/") !== -1) {
              imagePath = imagePath.split("/")[1];
            }
            path2 = assetsPath + imagePath;
          } else {
            path2 = originalPath;
            path2 += assetData.u ? assetData.u : "";
            path2 += assetData.p;
          }
          return path2;
        }
        function testImageLoaded(img) {
          var _count = 0;
          var intervalId = setInterval(function() {
            var box = img.getBBox();
            if (box.width || _count > 500) {
              this._imageLoaded();
              clearInterval(intervalId);
            }
            _count += 1;
          }.bind(this), 50);
        }
        function createImageData(assetData) {
          var path2 = getAssetsPath(assetData, this.assetsPath, this.path);
          var img = createNS("image");
          if (isSafari) {
            this.testImageLoaded(img);
          } else {
            img.addEventListener("load", this._imageLoaded, false);
          }
          img.addEventListener("error", function() {
            ob2.img = proxyImage;
            this._imageLoaded();
          }.bind(this), false);
          img.setAttributeNS("http://www.w3.org/1999/xlink", "href", path2);
          if (this._elementHelper.append) {
            this._elementHelper.append(img);
          } else {
            this._elementHelper.appendChild(img);
          }
          var ob2 = {
            img,
            assetData
          };
          return ob2;
        }
        function createImgData(assetData) {
          var path2 = getAssetsPath(assetData, this.assetsPath, this.path);
          var img = createTag("img");
          img.crossOrigin = "anonymous";
          img.addEventListener("load", this._imageLoaded, false);
          img.addEventListener("error", function() {
            ob2.img = proxyImage;
            this._imageLoaded();
          }.bind(this), false);
          img.src = path2;
          var ob2 = {
            img,
            assetData
          };
          return ob2;
        }
        function createFootageData(data2) {
          var ob2 = {
            assetData: data2
          };
          var path2 = getAssetsPath(data2, this.assetsPath, this.path);
          dataManager.loadData(path2, function(footageData) {
            ob2.img = footageData;
            this._footageLoaded();
          }.bind(this), function() {
            ob2.img = {};
            this._footageLoaded();
          }.bind(this));
          return ob2;
        }
        function loadAssets(assets, cb) {
          this.imagesLoadedCb = cb;
          var i;
          var len = assets.length;
          for (i = 0; i < len; i += 1) {
            if (!assets[i].layers) {
              if (!assets[i].t || assets[i].t === "seq") {
                this.totalImages += 1;
                this.images.push(this._createImageData(assets[i]));
              } else if (assets[i].t === 3) {
                this.totalFootages += 1;
                this.images.push(this.createFootageData(assets[i]));
              }
            }
          }
        }
        function setPath(path2) {
          this.path = path2 || "";
        }
        function setAssetsPath(path2) {
          this.assetsPath = path2 || "";
        }
        function getAsset(assetData) {
          var i = 0;
          var len = this.images.length;
          while (i < len) {
            if (this.images[i].assetData === assetData) {
              return this.images[i].img;
            }
            i += 1;
          }
          return null;
        }
        function destroy() {
          this.imagesLoadedCb = null;
          this.images.length = 0;
        }
        function loadedImages() {
          return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
          return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
          if (type === "svg") {
            this._elementHelper = elementHelper;
            this._createImageData = this.createImageData.bind(this);
          } else {
            this._createImageData = this.createImgData.bind(this);
          }
        }
        function ImagePreloaderFactory() {
          this._imageLoaded = imageLoaded.bind(this);
          this._footageLoaded = footageLoaded.bind(this);
          this.testImageLoaded = testImageLoaded.bind(this);
          this.createFootageData = createFootageData.bind(this);
          this.assetsPath = "";
          this.path = "";
          this.totalImages = 0;
          this.totalFootages = 0;
          this.loadedAssets = 0;
          this.loadedFootagesCount = 0;
          this.imagesLoadedCb = null;
          this.images = [];
        }
        ImagePreloaderFactory.prototype = {
          loadAssets,
          setAssetsPath,
          setPath,
          loadedImages,
          loadedFootages,
          destroy,
          getAsset,
          createImgData,
          createImageData,
          imageLoaded,
          footageLoaded,
          setCacheType
        };
        return ImagePreloaderFactory;
      }();
      function BaseEvent() {
      }
      BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
          if (this._cbs[eventName]) {
            var callbacks = this._cbs[eventName];
            for (var i = 0; i < callbacks.length; i += 1) {
              callbacks[i](args);
            }
          }
        },
        addEventListener: function addEventListener(eventName, callback) {
          if (!this._cbs[eventName]) {
            this._cbs[eventName] = [];
          }
          this._cbs[eventName].push(callback);
          return function() {
            this.removeEventListener(eventName, callback);
          }.bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
          if (!callback) {
            this._cbs[eventName] = null;
          } else if (this._cbs[eventName]) {
            var i = 0;
            var len = this._cbs[eventName].length;
            while (i < len) {
              if (this._cbs[eventName][i] === callback) {
                this._cbs[eventName].splice(i, 1);
                i -= 1;
                len -= 1;
              }
              i += 1;
            }
            if (!this._cbs[eventName].length) {
              this._cbs[eventName] = null;
            }
          }
        }
      };
      var markerParser = /* @__PURE__ */ function() {
        function parsePayloadLines(payload) {
          var lines = payload.split("\r\n");
          var keys2 = {};
          var line;
          var keysCount = 0;
          for (var i = 0; i < lines.length; i += 1) {
            line = lines[i].split(":");
            if (line.length === 2) {
              keys2[line[0]] = line[1].trim();
              keysCount += 1;
            }
          }
          if (keysCount === 0) {
            throw new Error();
          }
          return keys2;
        }
        return function(_markers) {
          var markers = [];
          for (var i = 0; i < _markers.length; i += 1) {
            var _marker = _markers[i];
            var markerData = {
              time: _marker.tm,
              duration: _marker.dr
            };
            try {
              markerData.payload = JSON.parse(_markers[i].cm);
            } catch (_) {
              try {
                markerData.payload = parsePayloadLines(_markers[i].cm);
              } catch (__) {
                markerData.payload = {
                  name: _markers[i].cm
                };
              }
            }
            markers.push(markerData);
          }
          return markers;
        };
      }();
      var ProjectInterface = /* @__PURE__ */ function() {
        function registerComposition(comp2) {
          this.compositions.push(comp2);
        }
        return function() {
          function _thisProjectFunction(name2) {
            var i = 0;
            var len = this.compositions.length;
            while (i < len) {
              if (this.compositions[i].data && this.compositions[i].data.nm === name2) {
                if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
                  this.compositions[i].prepareFrame(this.currentFrame);
                }
                return this.compositions[i].compInterface;
              }
              i += 1;
            }
            return null;
          }
          _thisProjectFunction.compositions = [];
          _thisProjectFunction.currentFrame = 0;
          _thisProjectFunction.registerComposition = registerComposition;
          return _thisProjectFunction;
        };
      }();
      var renderers = {};
      var registerRenderer = function registerRenderer2(key2, value2) {
        renderers[key2] = value2;
      };
      function getRenderer(key2) {
        return renderers[key2];
      }
      function getRegisteredRenderer() {
        if (renderers.canvas) {
          return "canvas";
        }
        for (var key2 in renderers) {
          if (renderers[key2]) {
            return key2;
          }
        }
        return "";
      }
      function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$4 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$4 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$4(obj);
      }
      var AnimationItem = function AnimationItem2() {
        this._cbs = [];
        this.name = "";
        this.path = "";
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = "";
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
      };
      extendPrototype([BaseEvent], AnimationItem);
      AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) {
          this.wrapper = params.wrapper || params.container;
        }
        var animType = "svg";
        if (params.animType) {
          animType = params.animType;
        } else if (params.renderer) {
          animType = params.renderer;
        }
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === "" || params.loop === null || params.loop === void 0 || params.loop === true) {
          this.loop = true;
        } else if (params.loop === false) {
          this.loop = false;
        } else {
          this.loop = parseInt(params.loop, 10);
        }
        this.autoplay = "autoplay" in params ? params.autoplay : true;
        this.name = params.name ? params.name : "";
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, "autoloadSegments") ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) {
          this.audioController.setAudioFactory(params.audioFactory);
        }
        if (params.animationData) {
          this.setupAnimation(params.animationData);
        } else if (params.path) {
          if (params.path.lastIndexOf("\\") !== -1) {
            this.path = params.path.substr(0, params.path.lastIndexOf("\\") + 1);
          } else {
            this.path = params.path.substr(0, params.path.lastIndexOf("/") + 1);
          }
          this.fileName = params.path.substr(params.path.lastIndexOf("/") + 1);
          this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"));
          dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
      };
      AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
      };
      AnimationItem.prototype.setupAnimation = function(data2) {
        dataManager.completeAnimation(data2, this.configAnimation);
      };
      AnimationItem.prototype.setData = function(wrapper, animationData2) {
        if (animationData2) {
          if (_typeof$4(animationData2) !== "object") {
            animationData2 = JSON.parse(animationData2);
          }
        }
        var params = {
          wrapper,
          animationData: animationData2
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem("data-animation-path") ? wrapperAttributes.getNamedItem("data-animation-path").value : wrapperAttributes.getNamedItem("data-bm-path") ? wrapperAttributes.getNamedItem("data-bm-path").value : wrapperAttributes.getNamedItem("bm-path") ? wrapperAttributes.getNamedItem("bm-path").value : "";
        params.animType = wrapperAttributes.getNamedItem("data-anim-type") ? wrapperAttributes.getNamedItem("data-anim-type").value : wrapperAttributes.getNamedItem("data-bm-type") ? wrapperAttributes.getNamedItem("data-bm-type").value : wrapperAttributes.getNamedItem("bm-type") ? wrapperAttributes.getNamedItem("bm-type").value : wrapperAttributes.getNamedItem("data-bm-renderer") ? wrapperAttributes.getNamedItem("data-bm-renderer").value : wrapperAttributes.getNamedItem("bm-renderer") ? wrapperAttributes.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var loop = wrapperAttributes.getNamedItem("data-anim-loop") ? wrapperAttributes.getNamedItem("data-anim-loop").value : wrapperAttributes.getNamedItem("data-bm-loop") ? wrapperAttributes.getNamedItem("data-bm-loop").value : wrapperAttributes.getNamedItem("bm-loop") ? wrapperAttributes.getNamedItem("bm-loop").value : "";
        if (loop === "false") {
          params.loop = false;
        } else if (loop === "true") {
          params.loop = true;
        } else if (loop !== "") {
          params.loop = parseInt(loop, 10);
        }
        var autoplay = wrapperAttributes.getNamedItem("data-anim-autoplay") ? wrapperAttributes.getNamedItem("data-anim-autoplay").value : wrapperAttributes.getNamedItem("data-bm-autoplay") ? wrapperAttributes.getNamedItem("data-bm-autoplay").value : wrapperAttributes.getNamedItem("bm-autoplay") ? wrapperAttributes.getNamedItem("bm-autoplay").value : true;
        params.autoplay = autoplay !== "false";
        params.name = wrapperAttributes.getNamedItem("data-name") ? wrapperAttributes.getNamedItem("data-name").value : wrapperAttributes.getNamedItem("data-bm-name") ? wrapperAttributes.getNamedItem("data-bm-name").value : wrapperAttributes.getNamedItem("bm-name") ? wrapperAttributes.getNamedItem("bm-name").value : "";
        var prerender = wrapperAttributes.getNamedItem("data-anim-prerender") ? wrapperAttributes.getNamedItem("data-anim-prerender").value : wrapperAttributes.getNamedItem("data-bm-prerender") ? wrapperAttributes.getNamedItem("data-bm-prerender").value : wrapperAttributes.getNamedItem("bm-prerender") ? wrapperAttributes.getNamedItem("bm-prerender").value : "";
        if (prerender === "false") {
          params.prerender = false;
        }
        if (!params.path) {
          this.trigger("destroy");
        } else {
          this.setParams(params);
        }
      };
      AnimationItem.prototype.includeLayers = function(data2) {
        if (data2.op > this.animationData.op) {
          this.animationData.op = data2.op;
          this.totalFrames = Math.floor(data2.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data2.layers;
        var j;
        var jLen = newLayers.length;
        for (j = 0; j < jLen; j += 1) {
          i = 0;
          while (i < len) {
            if (layers[i].id === newLayers[j].id) {
              layers[i] = newLayers[j];
              break;
            }
            i += 1;
          }
        }
        if (data2.chars || data2.fonts) {
          this.renderer.globalData.fontManager.addChars(data2.chars);
          this.renderer.globalData.fontManager.addFonts(data2.fonts, this.renderer.globalData.defs);
        }
        if (data2.assets) {
          len = data2.assets.length;
          for (i = 0; i < len; i += 1) {
            this.animationData.assets.push(data2.assets[i]);
          }
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
      };
      AnimationItem.prototype.onSegmentComplete = function(data2) {
        this.animationData = data2;
        var expressionsPlugin2 = getExpressionsPlugin();
        if (expressionsPlugin2) {
          expressionsPlugin2.initExpressions(this);
        }
        this.loadNextSegment();
      };
      AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
          this.trigger("data_ready");
          this.timeCompleted = this.totalFrames;
          return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), function() {
          this.trigger("data_failed");
        }.bind(this));
      };
      AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) {
          this.timeCompleted = this.totalFrames;
        }
        this.loadNextSegment();
      };
      AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images");
        this.checkLoaded();
      };
      AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
      };
      AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) {
          return;
        }
        try {
          this.animationData = animData;
          if (this.initialSegment) {
            this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
            this.firstFrame = Math.round(this.initialSegment[0]);
          } else {
            this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
            this.firstFrame = Math.round(this.animationData.ip);
          }
          this.renderer.configAnimation(animData);
          if (!animData.assets) {
            animData.assets = [];
          }
          this.assets = this.animationData.assets;
          this.frameRate = this.animationData.fr;
          this.frameMult = this.animationData.fr / 1e3;
          this.renderer.searchExtraCompositions(animData.assets);
          this.markers = markerParser(animData.markers || []);
          this.trigger("config_ready");
          this.preloadImages();
          this.loadSegments();
          this.updaFrameModifier();
          this.waitForFontsLoaded();
          if (this.isPaused) {
            this.audioController.pause();
          }
        } catch (error) {
          this.triggerConfigError(error);
        }
      };
      AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) {
          return;
        }
        if (this.renderer.globalData.fontManager.isLoaded) {
          this.checkLoaded();
        } else {
          setTimeout(this.waitForFontsLoaded.bind(this), 20);
        }
      };
      AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
          this.isLoaded = true;
          var expressionsPlugin2 = getExpressionsPlugin();
          if (expressionsPlugin2) {
            expressionsPlugin2.initExpressions(this);
          }
          this.renderer.initItems();
          setTimeout(function() {
            this.trigger("DOMLoaded");
          }.bind(this), 0);
          this.gotoFrame();
          if (this.autoplay) {
            this.play();
          }
        }
      };
      AnimationItem.prototype.resize = function(width2, height2) {
        var _width = typeof width2 === "number" ? width2 : void 0;
        var _height = typeof height2 === "number" ? height2 : void 0;
        this.renderer.updateContainerSize(_width, _height);
      };
      AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
      };
      AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
          this.currentFrame = this.timeCompleted;
        }
        this.trigger("enterFrame");
        this.renderFrame();
        this.trigger("drawnFrame");
      };
      AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) {
          return;
        }
        try {
          if (this.expressionsPlugin) {
            this.expressionsPlugin.resetFrame();
          }
          this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
          this.triggerRenderFrameError(error);
        }
      };
      AnimationItem.prototype.play = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        if (this.isPaused === true) {
          this.isPaused = false;
          this.trigger("_play");
          this.audioController.resume();
          if (this._idle) {
            this._idle = false;
            this.trigger("_active");
          }
        }
      };
      AnimationItem.prototype.pause = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        if (this.isPaused === false) {
          this.isPaused = true;
          this.trigger("_pause");
          this._idle = true;
          this.trigger("_idle");
          this.audioController.pause();
        }
      };
      AnimationItem.prototype.togglePause = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        if (this.isPaused === true) {
          this.play();
        } else {
          this.pause();
        }
      };
      AnimationItem.prototype.stop = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
      };
      AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for (var i = 0; i < this.markers.length; i += 1) {
          marker = this.markers[i];
          if (marker.payload && marker.payload.name === markerName) {
            return marker;
          }
        }
        return null;
      };
      AnimationItem.prototype.goToAndStop = function(value2, isFrame, name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        var numValue = Number(value2);
        if (isNaN(numValue)) {
          var marker = this.getMarkerData(value2);
          if (marker) {
            this.goToAndStop(marker.time, true);
          }
        } else if (isFrame) {
          this.setCurrentRawFrameValue(value2);
        } else {
          this.setCurrentRawFrameValue(value2 * this.frameModifier);
        }
        this.pause();
      };
      AnimationItem.prototype.goToAndPlay = function(value2, isFrame, name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        var numValue = Number(value2);
        if (isNaN(numValue)) {
          var marker = this.getMarkerData(value2);
          if (marker) {
            if (!marker.duration) {
              this.goToAndStop(marker.time, true);
            } else {
              this.playSegments([marker.time, marker.time + marker.duration], true);
            }
          }
        } else {
          this.goToAndStop(numValue, isFrame, name2);
        }
        this.play();
      };
      AnimationItem.prototype.advanceTime = function(value2) {
        if (this.isPaused === true || this.isLoaded === false) {
          return;
        }
        var nextValue = this.currentRawFrame + value2 * this.frameModifier;
        var _isComplete = false;
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
          if (!this.loop || this.playCount === this.loop) {
            if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
              _isComplete = true;
              nextValue = this.totalFrames - 1;
            }
          } else if (nextValue >= this.totalFrames) {
            this.playCount += 1;
            if (!this.checkSegments(nextValue % this.totalFrames)) {
              this.setCurrentRawFrameValue(nextValue % this.totalFrames);
              this._completedLoop = true;
              this.trigger("loopComplete");
            }
          } else {
            this.setCurrentRawFrameValue(nextValue);
          }
        } else if (nextValue < 0) {
          if (!this.checkSegments(nextValue % this.totalFrames)) {
            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
              this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
              if (!this._completedLoop) {
                this._completedLoop = true;
              } else {
                this.trigger("loopComplete");
              }
            } else {
              _isComplete = true;
              nextValue = 0;
            }
          }
        } else {
          this.setCurrentRawFrameValue(nextValue);
        }
        if (_isComplete) {
          this.setCurrentRawFrameValue(nextValue);
          this.pause();
          this.trigger("complete");
        }
      };
      AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
          if (this.frameModifier > 0) {
            if (this.playSpeed < 0) {
              this.setSpeed(-this.playSpeed);
            } else {
              this.setDirection(-1);
            }
          }
          this.totalFrames = arr[0] - arr[1];
          this.timeCompleted = this.totalFrames;
          this.firstFrame = arr[1];
          this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - offset);
        } else if (arr[1] > arr[0]) {
          if (this.frameModifier < 0) {
            if (this.playSpeed < 0) {
              this.setSpeed(-this.playSpeed);
            } else {
              this.setDirection(1);
            }
          }
          this.totalFrames = arr[1] - arr[0];
          this.timeCompleted = this.totalFrames;
          this.firstFrame = arr[0];
          this.setCurrentRawFrameValue(1e-3 + offset);
        }
        this.trigger("segmentStart");
      };
      AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
          if (this.currentRawFrame + this.firstFrame < init) {
            pendingFrame = init;
          } else if (this.currentRawFrame + this.firstFrame > end) {
            pendingFrame = end - init;
          }
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) {
          this.goToAndStop(pendingFrame, true);
        }
      };
      AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) {
          this.segments.length = 0;
        }
        if (_typeof$4(arr[0]) === "object") {
          var i;
          var len = arr.length;
          for (i = 0; i < len; i += 1) {
            this.segments.push(arr[i]);
          }
        } else {
          this.segments.push(arr);
        }
        if (this.segments.length && forceFlag) {
          this.adjustSegment(this.segments.shift(), 0);
        }
        if (this.isPaused) {
          this.play();
        }
      };
      AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([this.animationData.ip, this.animationData.op]);
        if (forceFlag) {
          this.checkSegments(0);
        }
      };
      AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
          this.adjustSegment(this.segments.shift(), offset);
          return true;
        }
        return false;
      };
      AnimationItem.prototype.destroy = function(name2) {
        if (name2 && this.name !== name2 || !this.renderer) {
          return;
        }
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger("destroy");
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
      };
      AnimationItem.prototype.setCurrentRawFrameValue = function(value2) {
        this.currentRawFrame = value2;
        this.gotoFrame();
      };
      AnimationItem.prototype.setSpeed = function(val2) {
        this.playSpeed = val2;
        this.updaFrameModifier();
      };
      AnimationItem.prototype.setDirection = function(val2) {
        this.playDirection = val2 < 0 ? -1 : 1;
        this.updaFrameModifier();
      };
      AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
      };
      AnimationItem.prototype.setVolume = function(val2, name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        this.audioController.setVolume(val2);
      };
      AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
      };
      AnimationItem.prototype.mute = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        this.audioController.mute();
      };
      AnimationItem.prototype.unmute = function(name2) {
        if (name2 && this.name !== name2) {
          return;
        }
        this.audioController.unmute();
      };
      AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
      };
      AnimationItem.prototype.getPath = function() {
        return this.path;
      };
      AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path2 = "";
        if (assetData.e) {
          path2 = assetData.p;
        } else if (this.assetsPath) {
          var imagePath = assetData.p;
          if (imagePath.indexOf("images/") !== -1) {
            imagePath = imagePath.split("/")[1];
          }
          path2 = this.assetsPath + imagePath;
        } else {
          path2 = this.path;
          path2 += assetData.u ? assetData.u : "";
          path2 += assetData.p;
        }
        return path2;
      };
      AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while (i < len) {
          if (id === this.assets[i].id) {
            return this.assets[i];
          }
          i += 1;
        }
        return null;
      };
      AnimationItem.prototype.hide = function() {
        this.renderer.hide();
      };
      AnimationItem.prototype.show = function() {
        this.renderer.show();
      };
      AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
      };
      AnimationItem.prototype.updateDocumentData = function(path2, documentData, index2) {
        try {
          var element = this.renderer.getElementByPath(path2);
          element.updateDocumentData(documentData, index2);
        } catch (error) {
        }
      };
      AnimationItem.prototype.trigger = function(name2) {
        if (this._cbs && this._cbs[name2]) {
          switch (name2) {
            case "enterFrame":
              this.triggerEvent(name2, new BMEnterFrameEvent(name2, this.currentFrame, this.totalFrames, this.frameModifier));
              break;
            case "drawnFrame":
              this.drawnFrameEvent.currentTime = this.currentFrame;
              this.drawnFrameEvent.totalTime = this.totalFrames;
              this.drawnFrameEvent.direction = this.frameModifier;
              this.triggerEvent(name2, this.drawnFrameEvent);
              break;
            case "loopComplete":
              this.triggerEvent(name2, new BMCompleteLoopEvent(name2, this.loop, this.playCount, this.frameMult));
              break;
            case "complete":
              this.triggerEvent(name2, new BMCompleteEvent(name2, this.frameMult));
              break;
            case "segmentStart":
              this.triggerEvent(name2, new BMSegmentStartEvent(name2, this.firstFrame, this.totalFrames));
              break;
            case "destroy":
              this.triggerEvent(name2, new BMDestroyEvent(name2, this));
              break;
            default:
              this.triggerEvent(name2);
          }
        }
        if (name2 === "enterFrame" && this.onEnterFrame) {
          this.onEnterFrame.call(this, new BMEnterFrameEvent(name2, this.currentFrame, this.totalFrames, this.frameMult));
        }
        if (name2 === "loopComplete" && this.onLoopComplete) {
          this.onLoopComplete.call(this, new BMCompleteLoopEvent(name2, this.loop, this.playCount, this.frameMult));
        }
        if (name2 === "complete" && this.onComplete) {
          this.onComplete.call(this, new BMCompleteEvent(name2, this.frameMult));
        }
        if (name2 === "segmentStart" && this.onSegmentStart) {
          this.onSegmentStart.call(this, new BMSegmentStartEvent(name2, this.firstFrame, this.totalFrames));
        }
        if (name2 === "destroy" && this.onDestroy) {
          this.onDestroy.call(this, new BMDestroyEvent(name2, this));
        }
      };
      AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) {
          this.onError.call(this, error);
        }
      };
      AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) {
          this.onError.call(this, error);
        }
      };
      var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
          var i = 0;
          var animItem = ev.target;
          while (i < len) {
            if (registeredAnimations[i].animation === animItem) {
              registeredAnimations.splice(i, 1);
              i -= 1;
              len -= 1;
              if (!animItem.isPaused) {
                subtractPlayingCount();
              }
            }
            i += 1;
          }
        }
        function registerAnimation(element, animationData2) {
          if (!element) {
            return null;
          }
          var i = 0;
          while (i < len) {
            if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
              return registeredAnimations[i].animation;
            }
            i += 1;
          }
          var animItem = new AnimationItem();
          setupAnimation(animItem, element);
          animItem.setData(element, animationData2);
          return animItem;
        }
        function getRegisteredAnimations() {
          var i;
          var lenAnims = registeredAnimations.length;
          var animations = [];
          for (i = 0; i < lenAnims; i += 1) {
            animations.push(registeredAnimations[i].animation);
          }
          return animations;
        }
        function addPlayingCount() {
          playingAnimationsNum += 1;
          activate();
        }
        function subtractPlayingCount() {
          playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
          animItem.addEventListener("destroy", removeElement);
          animItem.addEventListener("_active", addPlayingCount);
          animItem.addEventListener("_idle", subtractPlayingCount);
          registeredAnimations.push({
            elem: element,
            animation: animItem
          });
          len += 1;
        }
        function loadAnimation2(params) {
          var animItem = new AnimationItem();
          setupAnimation(animItem, null);
          animItem.setParams(params);
          return animItem;
        }
        function setSpeed(val2, animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.setSpeed(val2, animation);
          }
        }
        function setDirection(val2, animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.setDirection(val2, animation);
          }
        }
        function play(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.play(animation);
          }
        }
        function resume(nowTime) {
          var elapsedTime = nowTime - initTime;
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.advanceTime(elapsedTime);
          }
          initTime = nowTime;
          if (playingAnimationsNum && !_isFrozen) {
            window.requestAnimationFrame(resume);
          } else {
            _stopped = true;
          }
        }
        function first(nowTime) {
          initTime = nowTime;
          window.requestAnimationFrame(resume);
        }
        function pause(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.pause(animation);
          }
        }
        function goToAndStop(value2, isFrame, animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.goToAndStop(value2, isFrame, animation);
          }
        }
        function stop(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.stop(animation);
          }
        }
        function togglePause(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.togglePause(animation);
          }
        }
        function destroy(animation) {
          var i;
          for (i = len - 1; i >= 0; i -= 1) {
            registeredAnimations[i].animation.destroy(animation);
          }
        }
        function searchAnimations2(animationData2, standalone2, renderer2) {
          var animElements = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin")));
          var i;
          var lenAnims = animElements.length;
          for (i = 0; i < lenAnims; i += 1) {
            if (renderer2) {
              animElements[i].setAttribute("data-bm-type", renderer2);
            }
            registerAnimation(animElements[i], animationData2);
          }
          if (standalone2 && lenAnims === 0) {
            if (!renderer2) {
              renderer2 = "svg";
            }
            var body = document.getElementsByTagName("body")[0];
            body.innerText = "";
            var div2 = createTag("div");
            div2.style.width = "100%";
            div2.style.height = "100%";
            div2.setAttribute("data-bm-type", renderer2);
            body.appendChild(div2);
            registerAnimation(div2, animationData2);
          }
        }
        function resize() {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.resize();
          }
        }
        function activate() {
          if (!_isFrozen && playingAnimationsNum) {
            if (_stopped) {
              window.requestAnimationFrame(first);
              _stopped = false;
            }
          }
        }
        function freeze() {
          _isFrozen = true;
        }
        function unfreeze() {
          _isFrozen = false;
          activate();
        }
        function setVolume(val2, animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.setVolume(val2, animation);
          }
        }
        function mute(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.mute(animation);
          }
        }
        function unmute(animation) {
          var i;
          for (i = 0; i < len; i += 1) {
            registeredAnimations[i].animation.unmute(animation);
          }
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation2;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations2;
        moduleOb.resize = resize;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
      }();
      var BezierFactory = function() {
        var ob2 = {};
        ob2.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a2, b, c2, d, nm) {
          var str = nm || ("bez_" + a2 + "_" + b + "_" + c2 + "_" + d).replace(/\./g, "p");
          if (beziers[str]) {
            return beziers[str];
          }
          var bezEasing = new BezierEasing([a2, b, c2, d]);
          beziers[str] = bezEasing;
          return bezEasing;
        }
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 1e-3;
        var SUBDIVISION_PRECISION = 1e-7;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1 / (kSplineTableSize - 1);
        var float32ArraySupported = typeof Float32Array === "function";
        function A(aA1, aA2) {
          return 1 - 3 * aA2 + 3 * aA1;
        }
        function B(aA1, aA2) {
          return 3 * aA2 - 6 * aA1;
        }
        function C(aA1) {
          return 3 * aA1;
        }
        function calcBezier(aT, aA1, aA2) {
          return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        }
        function getSlope(aT, aA1, aA2) {
          return 3 * A(aA1, aA2) * aT * aT + 2 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
          var currentX, currentT, i = 0;
          do {
            currentT = aA + (aB - aA) / 2;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0) {
              aB = currentT;
            } else {
              aA = currentT;
            }
          } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
          return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
          for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
          }
          return aGuessT;
        }
        function BezierEasing(points) {
          this._p = points;
          this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
          this._precomputed = false;
          this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
          get: function get8(x2) {
            var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
            if (!this._precomputed) this._precompute();
            if (mX1 === mY1 && mX2 === mY2) return x2;
            if (x2 === 0) return 0;
            if (x2 === 1) return 1;
            return calcBezier(this._getTForX(x2), mY1, mY2);
          },
          // Private part
          _precompute: function _precompute() {
            var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
            this._precomputed = true;
            if (mX1 !== mY1 || mX2 !== mY2) {
              this._calcSampleValues();
            }
          },
          _calcSampleValues: function _calcSampleValues() {
            var mX1 = this._p[0], mX2 = this._p[2];
            for (var i = 0; i < kSplineTableSize; ++i) {
              this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
          },
          /**
               * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
               */
          _getTForX: function _getTForX(aX) {
            var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
              intervalStart += kSampleStepSize;
            }
            --currentSample;
            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) {
              return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            }
            if (initialSlope === 0) {
              return guessForT;
            }
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
          }
        };
        return ob2;
      }();
      var pooling = /* @__PURE__ */ function() {
        function _double(arr) {
          return arr.concat(createSizedArray(arr.length));
        }
        return {
          "double": _double
        };
      }();
      var poolFactory = /* @__PURE__ */ function() {
        return function(initialLength, _create, _release) {
          var _length = 0;
          var _maxLength = initialLength;
          var pool = createSizedArray(_maxLength);
          var ob2 = {
            newElement,
            release
          };
          function newElement() {
            var element;
            if (_length) {
              _length -= 1;
              element = pool[_length];
            } else {
              element = _create();
            }
            return element;
          }
          function release(element) {
            if (_length === _maxLength) {
              pool = pooling["double"](pool);
              _maxLength *= 2;
            }
            if (_release) {
              _release(element);
            }
            pool[_length] = element;
            _length += 1;
          }
          return ob2;
        };
      }();
      var bezierLengthPool = function() {
        function create() {
          return {
            addedLength: 0,
            percents: createTypedArray("float32", getDefaultCurveSegments()),
            lengths: createTypedArray("float32", getDefaultCurveSegments())
          };
        }
        return poolFactory(8, create);
      }();
      var segmentsLengthPool = function() {
        function create() {
          return {
            lengths: [],
            totalLength: 0
          };
        }
        function release(element) {
          var i;
          var len = element.lengths.length;
          for (i = 0; i < len; i += 1) {
            bezierLengthPool.release(element.lengths[i]);
          }
          element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
      }();
      function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
          var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
          return det1 > -1e-3 && det1 < 1e-3;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
          if (z1 === 0 && z2 === 0 && z3 === 0) {
            return pointOnLine2D(x1, y1, x2, y2, x3, y3);
          }
          var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
          var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
          var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
          var diffDist;
          if (dist1 > dist2) {
            if (dist1 > dist3) {
              diffDist = dist1 - dist2 - dist3;
            } else {
              diffDist = dist3 - dist2 - dist1;
            }
          } else if (dist3 > dist2) {
            diffDist = dist3 - dist2 - dist1;
          } else {
            diffDist = dist2 - dist1 - dist3;
          }
          return diffDist > -1e-4 && diffDist < 1e-4;
        }
        var getBezierLength = /* @__PURE__ */ function() {
          return function(pt1, pt2, pt3, pt4) {
            var curveSegments = getDefaultCurveSegments();
            var k2;
            var i;
            var len;
            var ptCoord;
            var perc;
            var addedLength = 0;
            var ptDistance;
            var point4 = [];
            var lastPoint = [];
            var lengthData = bezierLengthPool.newElement();
            len = pt3.length;
            for (k2 = 0; k2 < curveSegments; k2 += 1) {
              perc = k2 / (curveSegments - 1);
              ptDistance = 0;
              for (i = 0; i < len; i += 1) {
                ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                point4[i] = ptCoord;
                if (lastPoint[i] !== null) {
                  ptDistance += bmPow(point4[i] - lastPoint[i], 2);
                }
                lastPoint[i] = point4[i];
              }
              if (ptDistance) {
                ptDistance = bmSqrt(ptDistance);
                addedLength += ptDistance;
              }
              lengthData.percents[k2] = perc;
              lengthData.lengths[k2] = addedLength;
            }
            lengthData.addedLength = addedLength;
            return lengthData;
          };
        }();
        function getSegmentsLength(shapeData) {
          var segmentsLength = segmentsLengthPool.newElement();
          var closed = shapeData.c;
          var pathV = shapeData.v;
          var pathO = shapeData.o;
          var pathI = shapeData.i;
          var i;
          var len = shapeData._length;
          var lengths = segmentsLength.lengths;
          var totalLength = 0;
          for (i = 0; i < len - 1; i += 1) {
            lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
            totalLength += lengths[i].addedLength;
          }
          if (closed && len) {
            lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
            totalLength += lengths[i].addedLength;
          }
          segmentsLength.totalLength = totalLength;
          return segmentsLength;
        }
        function BezierData(length2) {
          this.segmentLength = 0;
          this.points = new Array(length2);
        }
        function PointData(partial, point4) {
          this.partialLength = partial;
          this.point = point4;
        }
        var buildBezierData = /* @__PURE__ */ function() {
          var storedData = {};
          return function(pt1, pt2, pt3, pt4) {
            var bezierName = (pt1[0] + "_" + pt1[1] + "_" + pt2[0] + "_" + pt2[1] + "_" + pt3[0] + "_" + pt3[1] + "_" + pt4[0] + "_" + pt4[1]).replace(/\./g, "p");
            if (!storedData[bezierName]) {
              var curveSegments = getDefaultCurveSegments();
              var k2;
              var i;
              var len;
              var ptCoord;
              var perc;
              var addedLength = 0;
              var ptDistance;
              var point4;
              var lastPoint = null;
              if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
                curveSegments = 2;
              }
              var bezierData = new BezierData(curveSegments);
              len = pt3.length;
              for (k2 = 0; k2 < curveSegments; k2 += 1) {
                point4 = createSizedArray(len);
                perc = k2 / (curveSegments - 1);
                ptDistance = 0;
                for (i = 0; i < len; i += 1) {
                  ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                  point4[i] = ptCoord;
                  if (lastPoint !== null) {
                    ptDistance += bmPow(point4[i] - lastPoint[i], 2);
                  }
                }
                ptDistance = bmSqrt(ptDistance);
                addedLength += ptDistance;
                bezierData.points[k2] = new PointData(ptDistance, point4);
                lastPoint = point4;
              }
              bezierData.segmentLength = addedLength;
              storedData[bezierName] = bezierData;
            }
            return storedData[bezierName];
          };
        }();
        function getDistancePerc(perc, bezierData) {
          var percents = bezierData.percents;
          var lengths = bezierData.lengths;
          var len = percents.length;
          var initPos = bmFloor((len - 1) * perc);
          var lengthPos = perc * bezierData.addedLength;
          var lPerc = 0;
          if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
            return percents[initPos];
          }
          var dir = lengths[initPos] > lengthPos ? -1 : 1;
          var flag = true;
          while (flag) {
            if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
              lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
              flag = false;
            } else {
              initPos += dir;
            }
            if (initPos < 0 || initPos >= len - 1) {
              if (initPos === len - 1) {
                return percents[initPos];
              }
              flag = false;
            }
          }
          return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
          var t12 = getDistancePerc(percent, bezierData);
          var u1 = 1 - t12;
          var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t12 * u1 * u1 + u1 * t12 * u1 + u1 * u1 * t12) * pt3[0] + (t12 * t12 * u1 + u1 * t12 * t12 + t12 * u1 * t12) * pt4[0] + t12 * t12 * t12 * pt2[0]) * 1e3) / 1e3;
          var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t12 * u1 * u1 + u1 * t12 * u1 + u1 * u1 * t12) * pt3[1] + (t12 * t12 * u1 + u1 * t12 * t12 + t12 * u1 * t12) * pt4[1] + t12 * t12 * t12 * pt2[1]) * 1e3) / 1e3;
          return [ptX, ptY];
        }
        var bezierSegmentPoints = createTypedArray("float32", 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
          if (startPerc < 0) {
            startPerc = 0;
          } else if (startPerc > 1) {
            startPerc = 1;
          }
          var t02 = getDistancePerc(startPerc, bezierData);
          endPerc = endPerc > 1 ? 1 : endPerc;
          var t12 = getDistancePerc(endPerc, bezierData);
          var i;
          var len = pt1.length;
          var u0 = 1 - t02;
          var u1 = 1 - t12;
          var u0u0u0 = u0 * u0 * u0;
          var t0u0u0_3 = t02 * u0 * u0 * 3;
          var t0t0u0_3 = t02 * t02 * u0 * 3;
          var t0t0t0 = t02 * t02 * t02;
          var u0u0u1 = u0 * u0 * u1;
          var t0u0u1_3 = t02 * u0 * u1 + u0 * t02 * u1 + u0 * u0 * t12;
          var t0t0u1_3 = t02 * t02 * u1 + u0 * t02 * t12 + t02 * u0 * t12;
          var t0t0t1 = t02 * t02 * t12;
          var u0u1u1 = u0 * u1 * u1;
          var t0u1u1_3 = t02 * u1 * u1 + u0 * t12 * u1 + u0 * u1 * t12;
          var t0t1u1_3 = t02 * t12 * u1 + u0 * t12 * t12 + t02 * u1 * t12;
          var t0t1t1 = t02 * t12 * t12;
          var u1u1u1 = u1 * u1 * u1;
          var t1u1u1_3 = t12 * u1 * u1 + u1 * t12 * u1 + u1 * u1 * t12;
          var t1t1u1_3 = t12 * t12 * u1 + u1 * t12 * t12 + t12 * u1 * t12;
          var t1t1t1 = t12 * t12 * t12;
          for (i = 0; i < len; i += 1) {
            bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1e3) / 1e3;
            bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1e3) / 1e3;
            bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1e3) / 1e3;
            bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1e3) / 1e3;
          }
          return bezierSegmentPoints;
        }
        return {
          getSegmentsLength,
          getNewSegment,
          getPointInSegment,
          buildBezierData,
          pointOnLine2D,
          pointOnLine3D
        };
      }
      var bez = bezFunction();
      var initFrame = initialDefaultFrame;
      var mathAbs = Math.abs;
      function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === "multidimensional") {
          newValue = createTypedArray("float32", this.pv.length);
        }
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while (flag) {
          keyData = this.keyframes[i];
          nextKeyData = this.keyframes[i + 1];
          if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
            if (keyData.h) {
              keyData = nextKeyData;
            }
            iterationIndex = 0;
            break;
          }
          if (nextKeyData.t - offsetTime > frameNum) {
            iterationIndex = i;
            break;
          }
          if (i < len - 1) {
            i += 1;
          } else {
            iterationIndex = 0;
            flag = false;
          }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k2;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
          if (!keyframeMetadata.bezierData) {
            keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
          }
          var bezierData = keyframeMetadata.bezierData;
          if (frameNum >= nextKeyTime || frameNum < keyTime) {
            var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
            kLen = bezierData.points[ind].point.length;
            for (k2 = 0; k2 < kLen; k2 += 1) {
              newValue[k2] = bezierData.points[ind].point[k2];
            }
          } else {
            if (keyframeMetadata.__fnct) {
              fnc = keyframeMetadata.__fnct;
            } else {
              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
              keyframeMetadata.__fnct = fnc;
            }
            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            var distanceInLine = bezierData.segmentLength * perc;
            var segmentPerc;
            var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
            j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
            flag = true;
            jLen = bezierData.points.length;
            while (flag) {
              addedLength += bezierData.points[j].partialLength;
              if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                kLen = bezierData.points[j].point.length;
                for (k2 = 0; k2 < kLen; k2 += 1) {
                  newValue[k2] = bezierData.points[j].point[k2];
                }
                break;
              } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                kLen = bezierData.points[j].point.length;
                for (k2 = 0; k2 < kLen; k2 += 1) {
                  newValue[k2] = bezierData.points[j].point[k2] + (bezierData.points[j + 1].point[k2] - bezierData.points[j].point[k2]) * segmentPerc;
                }
                break;
              }
              if (j < jLen - 1) {
                j += 1;
              } else {
                flag = false;
              }
            }
            caching._lastPoint = j;
            caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
            caching._lastKeyframeIndex = i;
          }
        } else {
          var outX;
          var outY;
          var inX;
          var inY;
          var keyValue;
          len = keyData.s.length;
          endValue = nextKeyData.s || keyData.e;
          if (this.sh && keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              newValue[0] = endValue[0];
              newValue[1] = endValue[1];
              newValue[2] = endValue[2];
            } else if (frameNum <= keyTime) {
              newValue[0] = keyData.s[0];
              newValue[1] = keyData.s[1];
              newValue[2] = keyData.s[2];
            } else {
              var quatStart = createQuaternion(keyData.s);
              var quatEnd = createQuaternion(endValue);
              var time3 = (frameNum - keyTime) / (nextKeyTime - keyTime);
              quaternionToEuler(newValue, slerp(quatStart, quatEnd, time3));
            }
          } else {
            for (i = 0; i < len; i += 1) {
              if (keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                  perc = 1;
                } else if (frameNum < keyTime) {
                  perc = 0;
                } else {
                  if (keyData.o.x.constructor === Array) {
                    if (!keyframeMetadata.__fnct) {
                      keyframeMetadata.__fnct = [];
                    }
                    if (!keyframeMetadata.__fnct[i]) {
                      outX = keyData.o.x[i] === void 0 ? keyData.o.x[0] : keyData.o.x[i];
                      outY = keyData.o.y[i] === void 0 ? keyData.o.y[0] : keyData.o.y[i];
                      inX = keyData.i.x[i] === void 0 ? keyData.i.x[0] : keyData.i.x[i];
                      inY = keyData.i.y[i] === void 0 ? keyData.i.y[0] : keyData.i.y[i];
                      fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                      keyframeMetadata.__fnct[i] = fnc;
                    } else {
                      fnc = keyframeMetadata.__fnct[i];
                    }
                  } else if (!keyframeMetadata.__fnct) {
                    outX = keyData.o.x;
                    outY = keyData.o.y;
                    inX = keyData.i.x;
                    inY = keyData.i.y;
                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                    keyData.keyframeMetadata = fnc;
                  } else {
                    fnc = keyframeMetadata.__fnct;
                  }
                  perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                }
              }
              endValue = nextKeyData.s || keyData.e;
              keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
              if (this.propType === "multidimensional") {
                newValue[i] = keyValue;
              } else {
                newValue = keyValue;
              }
            }
          }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
      }
      function slerp(a2, b, t) {
        var out = [];
        var ax = a2[0];
        var ay = a2[1];
        var az = a2[2];
        var aw = a2[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0) {
          cosom = -cosom;
          bx = -bx;
          by = -by;
          bz = -bz;
          bw = -bw;
        }
        if (1 - cosom > 1e-6) {
          omega = Math.acos(cosom);
          sinom = Math.sin(omega);
          scale0 = Math.sin((1 - t) * omega) / sinom;
          scale1 = Math.sin(t * omega) / sinom;
        } else {
          scale0 = 1 - t;
          scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
      }
      function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
      }
      function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x2 = s1 * s2 * c3 + c1 * c2 * s3;
        var y2 = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [x2, y2, z, w];
      }
      function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
          if (this._caching.lastFrame >= frameNum) {
            this._caching._lastKeyframeIndex = -1;
            this._caching.lastIndex = 0;
          }
          var renderResult = this.interpolateValue(frameNum, this._caching);
          this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
      }
      function setVValue(val2) {
        var multipliedValue;
        if (this.propType === "unidimensional") {
          multipliedValue = val2 * this.mult;
          if (mathAbs(this.v - multipliedValue) > 1e-5) {
            this.v = multipliedValue;
            this._mdf = true;
          }
        } else {
          var i = 0;
          var len = this.v.length;
          while (i < len) {
            multipliedValue = val2[i] * this.mult;
            if (mathAbs(this.v[i] - multipliedValue) > 1e-5) {
              this.v[i] = multipliedValue;
              this._mdf = true;
            }
            i += 1;
          }
        }
      }
      function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
          return;
        }
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for (i = 0; i < len; i += 1) {
          finalValue = this.effectsSequence[i](finalValue);
        }
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
      }
      function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
      }
      function ValueProperty(elem2, data2, mult, container) {
        this.propType = "unidimensional";
        this.mult = mult || 1;
        this.data = data2;
        this.v = mult ? data2.k * mult : data2.k;
        this.pv = data2.k;
        this._mdf = false;
        this.elem = elem2;
        this.container = container;
        this.comp = elem2.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
      }
      function MultiDimensionalProperty(elem2, data2, mult, container) {
        this.propType = "multidimensional";
        this.mult = mult || 1;
        this.data = data2;
        this._mdf = false;
        this.elem = elem2;
        this.container = container;
        this.comp = elem2.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data2.k.length;
        this.v = createTypedArray("float32", len);
        this.pv = createTypedArray("float32", len);
        this.vel = createTypedArray("float32", len);
        for (i = 0; i < len; i += 1) {
          this.v[i] = data2.k[i] * this.mult;
          this.pv[i] = data2.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
      }
      function KeyframedValueProperty(elem2, data2, mult, container) {
        this.propType = "unidimensional";
        this.keyframes = data2.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem2.data.st;
        this.frameId = -1;
        this._caching = {
          lastFrame: initFrame,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data2;
        this.mult = mult || 1;
        this.elem = elem2;
        this.container = container;
        this.comp = elem2.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
        this.addEffect = addEffect;
      }
      function KeyframedMultidimensionalProperty(elem2, data2, mult, container) {
        this.propType = "multidimensional";
        var i;
        var len = data2.k.length;
        var s2;
        var e;
        var to;
        var ti;
        for (i = 0; i < len - 1; i += 1) {
          if (data2.k[i].to && data2.k[i].s && data2.k[i + 1] && data2.k[i + 1].s) {
            s2 = data2.k[i].s;
            e = data2.k[i + 1].s;
            to = data2.k[i].to;
            ti = data2.k[i].ti;
            if (s2.length === 2 && !(s2[0] === e[0] && s2[1] === e[1]) && bez.pointOnLine2D(s2[0], s2[1], e[0], e[1], s2[0] + to[0], s2[1] + to[1]) && bez.pointOnLine2D(s2[0], s2[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s2.length === 3 && !(s2[0] === e[0] && s2[1] === e[1] && s2[2] === e[2]) && bez.pointOnLine3D(s2[0], s2[1], s2[2], e[0], e[1], e[2], s2[0] + to[0], s2[1] + to[1], s2[2] + to[2]) && bez.pointOnLine3D(s2[0], s2[1], s2[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
              data2.k[i].to = null;
              data2.k[i].ti = null;
            }
            if (s2[0] === e[0] && s2[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
              if (s2.length === 2 || s2[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                data2.k[i].to = null;
                data2.k[i].ti = null;
              }
            }
          }
        }
        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
        this.data = data2;
        this.keyframes = data2.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem2.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem2;
        this.container = container;
        this.comp = elem2.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data2.k[0].s.length;
        this.v = createTypedArray("float32", arrLen);
        this.pv = createTypedArray("float32", arrLen);
        for (i = 0; i < arrLen; i += 1) {
          this.v[i] = initFrame;
          this.pv[i] = initFrame;
        }
        this._caching = {
          lastFrame: initFrame,
          lastIndex: 0,
          value: createTypedArray("float32", arrLen)
        };
        this.addEffect = addEffect;
      }
      var PropertyFactory = /* @__PURE__ */ function() {
        function getProp(elem2, data2, type, mult, container) {
          if (data2.sid) {
            data2 = elem2.globalData.slotManager.getProp(data2);
          }
          var p;
          if (!data2.k.length) {
            p = new ValueProperty(elem2, data2, mult, container);
          } else if (typeof data2.k[0] === "number") {
            p = new MultiDimensionalProperty(elem2, data2, mult, container);
          } else {
            switch (type) {
              case 0:
                p = new KeyframedValueProperty(elem2, data2, mult, container);
                break;
              case 1:
                p = new KeyframedMultidimensionalProperty(elem2, data2, mult, container);
                break;
            }
          }
          if (p.effectsSequence.length) {
            container.addDynamicProperty(p);
          }
          return p;
        }
        var ob2 = {
          getProp
        };
        return ob2;
      }();
      function DynamicPropertyContainer() {
      }
      DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
          if (this.dynamicProperties.indexOf(prop) === -1) {
            this.dynamicProperties.push(prop);
            this.container.addDynamicProperty(this);
            this._isAnimated = true;
          }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
          this._mdf = false;
          var i;
          var len = this.dynamicProperties.length;
          for (i = 0; i < len; i += 1) {
            this.dynamicProperties[i].getValue();
            if (this.dynamicProperties[i]._mdf) {
              this._mdf = true;
            }
          }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
          this.container = container;
          this.dynamicProperties = [];
          this._mdf = false;
          this._isAnimated = false;
        }
      };
      var pointPool = function() {
        function create() {
          return createTypedArray("float32", 2);
        }
        return poolFactory(8, create);
      }();
      function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
      }
      ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while (i < len) {
          this.v[i] = pointPool.newElement();
          this.o[i] = pointPool.newElement();
          this.i[i] = pointPool.newElement();
          i += 1;
        }
      };
      ShapePath.prototype.setLength = function(len) {
        while (this._maxLength < len) {
          this.doubleArrayLength();
        }
        this._length = len;
      };
      ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
      };
      ShapePath.prototype.setXYAt = function(x2, y2, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) {
          this.doubleArrayLength();
        }
        switch (type) {
          case "v":
            arr = this.v;
            break;
          case "i":
            arr = this.i;
            break;
          case "o":
            arr = this.o;
            break;
          default:
            arr = [];
            break;
        }
        if (!arr[pos] || arr[pos] && !replace) {
          arr[pos] = pointPool.newElement();
        }
        arr[pos][0] = x2;
        arr[pos][1] = y2;
      };
      ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, "v", pos, replace);
        this.setXYAt(oX, oY, "o", pos, replace);
        this.setXYAt(iX, iY, "i", pos, replace);
      };
      ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
          newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
          init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for (i = init; i < len; i += 1) {
          newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
          cnt -= 1;
        }
        return newPath;
      };
      ShapePath.prototype.length = function() {
        return this._length;
      };
      var shapePool = function() {
        function create() {
          return new ShapePath();
        }
        function release(shapePath) {
          var len = shapePath._length;
          var i;
          for (i = 0; i < len; i += 1) {
            pointPool.release(shapePath.v[i]);
            pointPool.release(shapePath.i[i]);
            pointPool.release(shapePath.o[i]);
            shapePath.v[i] = null;
            shapePath.i[i] = null;
            shapePath.o[i] = null;
          }
          shapePath._length = 0;
          shapePath.c = false;
        }
        function clone2(shape) {
          var cloned = factory17.newElement();
          var i;
          var len = shape._length === void 0 ? shape.v.length : shape._length;
          cloned.setLength(len);
          cloned.c = shape.c;
          for (i = 0; i < len; i += 1) {
            cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
          }
          return cloned;
        }
        var factory17 = poolFactory(4, create, release);
        factory17.clone = clone2;
        return factory17;
      }();
      function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
      }
      ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
          this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
          this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
      };
      ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for (i = 0; i < this._length; i += 1) {
          shapePool.release(this.shapes[i]);
        }
        this._length = 0;
      };
      var shapeCollectionPool = function() {
        var ob2 = {
          newShapeCollection,
          release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
          var shapeCollection;
          if (_length) {
            _length -= 1;
            shapeCollection = pool[_length];
          } else {
            shapeCollection = new ShapeCollection();
          }
          return shapeCollection;
        }
        function release(shapeCollection) {
          var i;
          var len = shapeCollection._length;
          for (i = 0; i < len; i += 1) {
            shapePool.release(shapeCollection.shapes[i]);
          }
          shapeCollection._length = 0;
          if (_length === _maxLength) {
            pool = pooling["double"](pool);
            _maxLength *= 2;
          }
          pool[_length] = shapeCollection;
          _length += 1;
        }
        return ob2;
      }();
      var ShapePropertyFactory = function() {
        var initFrame2 = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
          var iterationIndex = caching.lastIndex;
          var keyPropS;
          var keyPropE;
          var isHold;
          var j;
          var k2;
          var jLen;
          var kLen;
          var perc;
          var vertexValue;
          var kf = this.keyframes;
          if (frameNum < kf[0].t - this.offsetTime) {
            keyPropS = kf[0].s[0];
            isHold = true;
            iterationIndex = 0;
          } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
            keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
            isHold = true;
          } else {
            var i = iterationIndex;
            var len = kf.length - 1;
            var flag = true;
            var keyData;
            var nextKeyData;
            var keyframeMetadata;
            while (flag) {
              keyData = kf[i];
              nextKeyData = kf[i + 1];
              if (nextKeyData.t - this.offsetTime > frameNum) {
                break;
              }
              if (i < len - 1) {
                i += 1;
              } else {
                flag = false;
              }
            }
            keyframeMetadata = this.keyframesMetadata[i] || {};
            isHold = keyData.h === 1;
            iterationIndex = i;
            if (!isHold) {
              if (frameNum >= nextKeyData.t - this.offsetTime) {
                perc = 1;
              } else if (frameNum < keyData.t - this.offsetTime) {
                perc = 0;
              } else {
                var fnc;
                if (keyframeMetadata.__fnct) {
                  fnc = keyframeMetadata.__fnct;
                } else {
                  fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                  keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
              }
              keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
            }
            keyPropS = keyData.s[0];
          }
          jLen = previousValue._length;
          kLen = keyPropS.i[0].length;
          caching.lastIndex = iterationIndex;
          for (j = 0; j < jLen; j += 1) {
            for (k2 = 0; k2 < kLen; k2 += 1) {
              vertexValue = isHold ? keyPropS.i[j][k2] : keyPropS.i[j][k2] + (keyPropE.i[j][k2] - keyPropS.i[j][k2]) * perc;
              previousValue.i[j][k2] = vertexValue;
              vertexValue = isHold ? keyPropS.o[j][k2] : keyPropS.o[j][k2] + (keyPropE.o[j][k2] - keyPropS.o[j][k2]) * perc;
              previousValue.o[j][k2] = vertexValue;
              vertexValue = isHold ? keyPropS.v[j][k2] : keyPropS.v[j][k2] + (keyPropE.v[j][k2] - keyPropS.v[j][k2]) * perc;
              previousValue.v[j][k2] = vertexValue;
            }
          }
        }
        function interpolateShapeCurrentTime() {
          var frameNum = this.comp.renderedFrame - this.offsetTime;
          var initTime = this.keyframes[0].t - this.offsetTime;
          var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
          var lastFrame = this._caching.lastFrame;
          if (!(lastFrame !== initFrame2 && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
            this.interpolateShape(frameNum, this.pv, this._caching);
          }
          this._caching.lastFrame = frameNum;
          return this.pv;
        }
        function resetShape() {
          this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
          if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
            return false;
          }
          var i;
          var len = shape1._length;
          for (i = 0; i < len; i += 1) {
            if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
              return false;
            }
          }
          return true;
        }
        function setVValue2(newPath) {
          if (!shapesEqual(this.v, newPath)) {
            this.v = shapePool.clone(newPath);
            this.localShapeCollection.releaseShapes();
            this.localShapeCollection.addShape(this.v);
            this._mdf = true;
            this.paths = this.localShapeCollection;
          }
        }
        function processEffectsSequence2() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }
          if (!this.effectsSequence.length) {
            this._mdf = false;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = true;
          this._mdf = false;
          var finalValue;
          if (this.kf) {
            finalValue = this.pv;
          } else if (this.data.ks) {
            finalValue = this.data.ks.k;
          } else {
            finalValue = this.data.pt.k;
          }
          var i;
          var len = this.effectsSequence.length;
          for (i = 0; i < len; i += 1) {
            finalValue = this.effectsSequence[i](finalValue);
          }
          this.setVValue(finalValue);
          this.lock = false;
          this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem2, data2, type) {
          this.propType = "shape";
          this.comp = elem2.comp;
          this.container = elem2;
          this.elem = elem2;
          this.data = data2;
          this.k = false;
          this.kf = false;
          this._mdf = false;
          var pathData = type === 3 ? data2.pt.k : data2.ks.k;
          this.v = shapePool.clone(pathData);
          this.pv = shapePool.clone(this.v);
          this.localShapeCollection = shapeCollectionPool.newShapeCollection();
          this.paths = this.localShapeCollection;
          this.paths.addShape(this.v);
          this.reset = resetShape;
          this.effectsSequence = [];
        }
        function addEffect2(effectFunction) {
          this.effectsSequence.push(effectFunction);
          this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence2;
        ShapeProperty.prototype.setVValue = setVValue2;
        ShapeProperty.prototype.addEffect = addEffect2;
        function KeyframedShapeProperty(elem2, data2, type) {
          this.propType = "shape";
          this.comp = elem2.comp;
          this.elem = elem2;
          this.container = elem2;
          this.offsetTime = elem2.data.st;
          this.keyframes = type === 3 ? data2.pt.k : data2.ks.k;
          this.keyframesMetadata = [];
          this.k = true;
          this.kf = true;
          var len = this.keyframes[0].s[0].i.length;
          this.v = shapePool.newElement();
          this.v.setPathData(this.keyframes[0].s[0].c, len);
          this.pv = shapePool.clone(this.v);
          this.localShapeCollection = shapeCollectionPool.newShapeCollection();
          this.paths = this.localShapeCollection;
          this.paths.addShape(this.v);
          this.lastFrame = initFrame2;
          this.reset = resetShape;
          this._caching = {
            lastFrame: initFrame2,
            lastIndex: 0
          };
          this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence2;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue2;
        KeyframedShapeProperty.prototype.addEffect = addEffect2;
        var EllShapeProperty = function() {
          var cPoint = roundCorner;
          function EllShapePropertyFactory(elem2, data2) {
            this.v = shapePool.newElement();
            this.v.setPathData(true, 4);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.localShapeCollection.addShape(this.v);
            this.d = data2.d;
            this.elem = elem2;
            this.comp = elem2.comp;
            this.frameId = -1;
            this.initDynamicPropertyContainer(elem2);
            this.p = PropertyFactory.getProp(elem2, data2.p, 1, 0, this);
            this.s = PropertyFactory.getProp(elem2, data2.s, 1, 0, this);
            if (this.dynamicProperties.length) {
              this.k = true;
            } else {
              this.k = false;
              this.convertEllToPath();
            }
          }
          EllShapePropertyFactory.prototype = {
            reset: resetShape,
            getValue: function getValue() {
              if (this.elem.globalData.frameId === this.frameId) {
                return;
              }
              this.frameId = this.elem.globalData.frameId;
              this.iterateDynamicProperties();
              if (this._mdf) {
                this.convertEllToPath();
              }
            },
            convertEllToPath: function convertEllToPath() {
              var p0 = this.p.v[0];
              var p1 = this.p.v[1];
              var s0 = this.s.v[0] / 2;
              var s1 = this.s.v[1] / 2;
              var _cw = this.d !== 3;
              var _v = this.v;
              _v.v[0][0] = p0;
              _v.v[0][1] = p1 - s1;
              _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
              _v.v[1][1] = p1;
              _v.v[2][0] = p0;
              _v.v[2][1] = p1 + s1;
              _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
              _v.v[3][1] = p1;
              _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
              _v.i[0][1] = p1 - s1;
              _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
              _v.i[1][1] = p1 - s1 * cPoint;
              _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
              _v.i[2][1] = p1 + s1;
              _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
              _v.i[3][1] = p1 + s1 * cPoint;
              _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
              _v.o[0][1] = p1 - s1;
              _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
              _v.o[1][1] = p1 + s1 * cPoint;
              _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
              _v.o[2][1] = p1 + s1;
              _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
              _v.o[3][1] = p1 - s1 * cPoint;
            }
          };
          extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
          return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
          function StarShapePropertyFactory(elem2, data2) {
            this.v = shapePool.newElement();
            this.v.setPathData(true, 0);
            this.elem = elem2;
            this.comp = elem2.comp;
            this.data = data2;
            this.frameId = -1;
            this.d = data2.d;
            this.initDynamicPropertyContainer(elem2);
            if (data2.sy === 1) {
              this.ir = PropertyFactory.getProp(elem2, data2.ir, 0, 0, this);
              this.is = PropertyFactory.getProp(elem2, data2.is, 0, 0.01, this);
              this.convertToPath = this.convertStarToPath;
            } else {
              this.convertToPath = this.convertPolygonToPath;
            }
            this.pt = PropertyFactory.getProp(elem2, data2.pt, 0, 0, this);
            this.p = PropertyFactory.getProp(elem2, data2.p, 1, 0, this);
            this.r = PropertyFactory.getProp(elem2, data2.r, 0, degToRads, this);
            this.or = PropertyFactory.getProp(elem2, data2.or, 0, 0, this);
            this.os = PropertyFactory.getProp(elem2, data2.os, 0, 0.01, this);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            if (this.dynamicProperties.length) {
              this.k = true;
            } else {
              this.k = false;
              this.convertToPath();
            }
          }
          StarShapePropertyFactory.prototype = {
            reset: resetShape,
            getValue: function getValue() {
              if (this.elem.globalData.frameId === this.frameId) {
                return;
              }
              this.frameId = this.elem.globalData.frameId;
              this.iterateDynamicProperties();
              if (this._mdf) {
                this.convertToPath();
              }
            },
            convertStarToPath: function convertStarToPath() {
              var numPts = Math.floor(this.pt.v) * 2;
              var angle = Math.PI * 2 / numPts;
              var longFlag = true;
              var longRad = this.or.v;
              var shortRad = this.ir.v;
              var longRound = this.os.v;
              var shortRound = this.is.v;
              var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
              var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
              var i;
              var rad;
              var roundness;
              var perimSegment;
              var currentAng = -Math.PI / 2;
              currentAng += this.r.v;
              var dir = this.data.d === 3 ? -1 : 1;
              this.v._length = 0;
              for (i = 0; i < numPts; i += 1) {
                rad = longFlag ? longRad : shortRad;
                roundness = longFlag ? longRound : shortRound;
                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                var x2 = rad * Math.cos(currentAng);
                var y2 = rad * Math.sin(currentAng);
                var ox = x2 === 0 && y2 === 0 ? 0 : y2 / Math.sqrt(x2 * x2 + y2 * y2);
                var oy = x2 === 0 && y2 === 0 ? 0 : -x2 / Math.sqrt(x2 * x2 + y2 * y2);
                x2 += +this.p.v[0];
                y2 += +this.p.v[1];
                this.v.setTripleAt(x2, y2, x2 - ox * perimSegment * roundness * dir, y2 - oy * perimSegment * roundness * dir, x2 + ox * perimSegment * roundness * dir, y2 + oy * perimSegment * roundness * dir, i, true);
                longFlag = !longFlag;
                currentAng += angle * dir;
              }
            },
            convertPolygonToPath: function convertPolygonToPath() {
              var numPts = Math.floor(this.pt.v);
              var angle = Math.PI * 2 / numPts;
              var rad = this.or.v;
              var roundness = this.os.v;
              var perimSegment = 2 * Math.PI * rad / (numPts * 4);
              var i;
              var currentAng = -Math.PI * 0.5;
              var dir = this.data.d === 3 ? -1 : 1;
              currentAng += this.r.v;
              this.v._length = 0;
              for (i = 0; i < numPts; i += 1) {
                var x2 = rad * Math.cos(currentAng);
                var y2 = rad * Math.sin(currentAng);
                var ox = x2 === 0 && y2 === 0 ? 0 : y2 / Math.sqrt(x2 * x2 + y2 * y2);
                var oy = x2 === 0 && y2 === 0 ? 0 : -x2 / Math.sqrt(x2 * x2 + y2 * y2);
                x2 += +this.p.v[0];
                y2 += +this.p.v[1];
                this.v.setTripleAt(x2, y2, x2 - ox * perimSegment * roundness * dir, y2 - oy * perimSegment * roundness * dir, x2 + ox * perimSegment * roundness * dir, y2 + oy * perimSegment * roundness * dir, i, true);
                currentAng += angle * dir;
              }
              this.paths.length = 0;
              this.paths[0] = this.v;
            }
          };
          extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
          return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
          function RectShapePropertyFactory(elem2, data2) {
            this.v = shapePool.newElement();
            this.v.c = true;
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            this.elem = elem2;
            this.comp = elem2.comp;
            this.frameId = -1;
            this.d = data2.d;
            this.initDynamicPropertyContainer(elem2);
            this.p = PropertyFactory.getProp(elem2, data2.p, 1, 0, this);
            this.s = PropertyFactory.getProp(elem2, data2.s, 1, 0, this);
            this.r = PropertyFactory.getProp(elem2, data2.r, 0, 0, this);
            if (this.dynamicProperties.length) {
              this.k = true;
            } else {
              this.k = false;
              this.convertRectToPath();
            }
          }
          RectShapePropertyFactory.prototype = {
            convertRectToPath: function convertRectToPath() {
              var p0 = this.p.v[0];
              var p1 = this.p.v[1];
              var v0 = this.s.v[0] / 2;
              var v1 = this.s.v[1] / 2;
              var round2 = bmMin(v0, v1, this.r.v);
              var cPoint = round2 * (1 - roundCorner);
              this.v._length = 0;
              if (this.d === 2 || this.d === 1) {
                this.v.setTripleAt(p0 + v0, p1 - v1 + round2, p0 + v0, p1 - v1 + round2, p0 + v0, p1 - v1 + cPoint, 0, true);
                this.v.setTripleAt(p0 + v0, p1 + v1 - round2, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round2, 1, true);
                if (round2 !== 0) {
                  this.v.setTripleAt(p0 + v0 - round2, p1 + v1, p0 + v0 - round2, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                  this.v.setTripleAt(p0 - v0 + round2, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round2, p1 + v1, 3, true);
                  this.v.setTripleAt(p0 - v0, p1 + v1 - round2, p0 - v0, p1 + v1 - round2, p0 - v0, p1 + v1 - cPoint, 4, true);
                  this.v.setTripleAt(p0 - v0, p1 - v1 + round2, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round2, 5, true);
                  this.v.setTripleAt(p0 - v0 + round2, p1 - v1, p0 - v0 + round2, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                  this.v.setTripleAt(p0 + v0 - round2, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round2, p1 - v1, 7, true);
                } else {
                  this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                  this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                }
              } else {
                this.v.setTripleAt(p0 + v0, p1 - v1 + round2, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round2, 0, true);
                if (round2 !== 0) {
                  this.v.setTripleAt(p0 + v0 - round2, p1 - v1, p0 + v0 - round2, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                  this.v.setTripleAt(p0 - v0 + round2, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round2, p1 - v1, 2, true);
                  this.v.setTripleAt(p0 - v0, p1 - v1 + round2, p0 - v0, p1 - v1 + round2, p0 - v0, p1 - v1 + cPoint, 3, true);
                  this.v.setTripleAt(p0 - v0, p1 + v1 - round2, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round2, 4, true);
                  this.v.setTripleAt(p0 - v0 + round2, p1 + v1, p0 - v0 + round2, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                  this.v.setTripleAt(p0 + v0 - round2, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round2, p1 + v1, 6, true);
                  this.v.setTripleAt(p0 + v0, p1 + v1 - round2, p0 + v0, p1 + v1 - round2, p0 + v0, p1 + v1 - cPoint, 7, true);
                } else {
                  this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                  this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                  this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                }
              }
            },
            getValue: function getValue() {
              if (this.elem.globalData.frameId === this.frameId) {
                return;
              }
              this.frameId = this.elem.globalData.frameId;
              this.iterateDynamicProperties();
              if (this._mdf) {
                this.convertRectToPath();
              }
            },
            reset: resetShape
          };
          extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
          return RectShapePropertyFactory;
        }();
        function getShapeProp(elem2, data2, type) {
          var prop;
          if (type === 3 || type === 4) {
            var dataProp = type === 3 ? data2.pt : data2.ks;
            var keys2 = dataProp.k;
            if (keys2.length) {
              prop = new KeyframedShapeProperty(elem2, data2, type);
            } else {
              prop = new ShapeProperty(elem2, data2, type);
            }
          } else if (type === 5) {
            prop = new RectShapeProperty(elem2, data2);
          } else if (type === 6) {
            prop = new EllShapeProperty(elem2, data2);
          } else if (type === 7) {
            prop = new StarShapeProperty(elem2, data2);
          }
          if (prop.k) {
            elem2.addDynamicProperty(prop);
          }
          return prop;
        }
        function getConstructorFunction() {
          return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
          return KeyframedShapeProperty;
        }
        var ob2 = {};
        ob2.getShapeProp = getShapeProp;
        ob2.getConstructorFunction = getConstructorFunction;
        ob2.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob2;
      }();
      var Matrix = /* @__PURE__ */ function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
          this.props[0] = 1;
          this.props[1] = 0;
          this.props[2] = 0;
          this.props[3] = 0;
          this.props[4] = 0;
          this.props[5] = 1;
          this.props[6] = 0;
          this.props[7] = 0;
          this.props[8] = 0;
          this.props[9] = 0;
          this.props[10] = 1;
          this.props[11] = 0;
          this.props[12] = 0;
          this.props[13] = 0;
          this.props[14] = 0;
          this.props[15] = 1;
          return this;
        }
        function rotate(angle) {
          if (angle === 0) {
            return this;
          }
          var mCos = _cos(angle);
          var mSin = _sin(angle);
          return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
          if (angle === 0) {
            return this;
          }
          var mCos = _cos(angle);
          var mSin = _sin(angle);
          return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
          if (angle === 0) {
            return this;
          }
          var mCos = _cos(angle);
          var mSin = _sin(angle);
          return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
          if (angle === 0) {
            return this;
          }
          var mCos = _cos(angle);
          var mSin = _sin(angle);
          return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
          return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
          return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
          var mCos = _cos(angle);
          var mSin = _sin(angle);
          return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function scale2(sx, sy, sz) {
          if (!sz && sz !== 0) {
            sz = 1;
          }
          if (sx === 1 && sy === 1 && sz === 1) {
            return this;
          }
          return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a2, b, c2, d, e, f, g, h, i, j, k2, l, m, n, o, p) {
          this.props[0] = a2;
          this.props[1] = b;
          this.props[2] = c2;
          this.props[3] = d;
          this.props[4] = e;
          this.props[5] = f;
          this.props[6] = g;
          this.props[7] = h;
          this.props[8] = i;
          this.props[9] = j;
          this.props[10] = k2;
          this.props[11] = l;
          this.props[12] = m;
          this.props[13] = n;
          this.props[14] = o;
          this.props[15] = p;
          return this;
        }
        function translate(tx, ty, tz) {
          tz = tz || 0;
          if (tx !== 0 || ty !== 0 || tz !== 0) {
            return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
          }
          return this;
        }
        function transform2(a2, b2, c2, d2, e22, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
          var _p = this.props;
          if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e22 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
            _p[12] = _p[12] * a2 + _p[15] * m2;
            _p[13] = _p[13] * f2 + _p[15] * n2;
            _p[14] = _p[14] * k2 + _p[15] * o2;
            _p[15] *= p2;
            this._identityCalculated = false;
            return this;
          }
          var a1 = _p[0];
          var b1 = _p[1];
          var c1 = _p[2];
          var d1 = _p[3];
          var e1 = _p[4];
          var f1 = _p[5];
          var g1 = _p[6];
          var h1 = _p[7];
          var i1 = _p[8];
          var j1 = _p[9];
          var k1 = _p[10];
          var l1 = _p[11];
          var m1 = _p[12];
          var n1 = _p[13];
          var o1 = _p[14];
          var p1 = _p[15];
          _p[0] = a1 * a2 + b1 * e22 + c1 * i2 + d1 * m2;
          _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
          _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
          _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
          _p[4] = e1 * a2 + f1 * e22 + g1 * i2 + h1 * m2;
          _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
          _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
          _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
          _p[8] = i1 * a2 + j1 * e22 + k1 * i2 + l1 * m2;
          _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
          _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
          _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
          _p[12] = m1 * a2 + n1 * e22 + o1 * i2 + p1 * m2;
          _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
          _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
          _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
          this._identityCalculated = false;
          return this;
        }
        function multiply(matrix) {
          var matrixProps = matrix.props;
          return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
          if (!this._identityCalculated) {
            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
            this._identityCalculated = true;
          }
          return this._identity;
        }
        function equals(matr) {
          var i = 0;
          while (i < 16) {
            if (matr.props[i] !== this.props[i]) {
              return false;
            }
            i += 1;
          }
          return true;
        }
        function clone2(matr) {
          var i;
          for (i = 0; i < 16; i += 1) {
            matr.props[i] = this.props[i];
          }
          return matr;
        }
        function cloneFromProps(props) {
          var i;
          for (i = 0; i < 16; i += 1) {
            this.props[i] = props[i];
          }
        }
        function applyToPoint(x2, y2, z) {
          return {
            x: x2 * this.props[0] + y2 * this.props[4] + z * this.props[8] + this.props[12],
            y: x2 * this.props[1] + y2 * this.props[5] + z * this.props[9] + this.props[13],
            z: x2 * this.props[2] + y2 * this.props[6] + z * this.props[10] + this.props[14]
          };
        }
        function applyToX(x2, y2, z) {
          return x2 * this.props[0] + y2 * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x2, y2, z) {
          return x2 * this.props[1] + y2 * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x2, y2, z) {
          return x2 * this.props[2] + y2 * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
          var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
          var a2 = this.props[5] / determinant;
          var b = -this.props[1] / determinant;
          var c2 = -this.props[4] / determinant;
          var d = this.props[0] / determinant;
          var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
          var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
          var inverseMatrix = new Matrix();
          inverseMatrix.props[0] = a2;
          inverseMatrix.props[1] = b;
          inverseMatrix.props[4] = c2;
          inverseMatrix.props[5] = d;
          inverseMatrix.props[12] = e;
          inverseMatrix.props[13] = f;
          return inverseMatrix;
        }
        function inversePoint(pt) {
          var inverseMatrix = this.getInverseMatrix();
          return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
          var i;
          var len = pts.length;
          var retPts = [];
          for (i = 0; i < len; i += 1) {
            retPts[i] = inversePoint(pts[i]);
          }
          return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
          var arr = createTypedArray("float32", 6);
          if (this.isIdentity()) {
            arr[0] = pt1[0];
            arr[1] = pt1[1];
            arr[2] = pt2[0];
            arr[3] = pt2[1];
            arr[4] = pt3[0];
            arr[5] = pt3[1];
          } else {
            var p0 = this.props[0];
            var p1 = this.props[1];
            var p4 = this.props[4];
            var p5 = this.props[5];
            var p12 = this.props[12];
            var p13 = this.props[13];
            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
          }
          return arr;
        }
        function applyToPointArray(x2, y2, z) {
          var arr;
          if (this.isIdentity()) {
            arr = [x2, y2, z];
          } else {
            arr = [x2 * this.props[0] + y2 * this.props[4] + z * this.props[8] + this.props[12], x2 * this.props[1] + y2 * this.props[5] + z * this.props[9] + this.props[13], x2 * this.props[2] + y2 * this.props[6] + z * this.props[10] + this.props[14]];
          }
          return arr;
        }
        function applyToPointStringified(x2, y2) {
          if (this.isIdentity()) {
            return x2 + "," + y2;
          }
          var _p = this.props;
          return Math.round((x2 * _p[0] + y2 * _p[4] + _p[12]) * 100) / 100 + "," + Math.round((x2 * _p[1] + y2 * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
          var i = 0;
          var props = this.props;
          var cssValue = "matrix3d(";
          var v = 1e4;
          while (i < 16) {
            cssValue += _rnd(props[i] * v) / v;
            cssValue += i === 15 ? ")" : ",";
            i += 1;
          }
          return cssValue;
        }
        function roundMatrixProperty(val2) {
          var v = 1e4;
          if (val2 < 1e-6 && val2 > 0 || val2 > -1e-6 && val2 < 0) {
            return _rnd(val2 * v) / v;
          }
          return val2;
        }
        function to2dCSS() {
          var props = this.props;
          var _a = roundMatrixProperty(props[0]);
          var _b = roundMatrixProperty(props[1]);
          var _c = roundMatrixProperty(props[4]);
          var _d = roundMatrixProperty(props[5]);
          var _e = roundMatrixProperty(props[12]);
          var _f = roundMatrixProperty(props[13]);
          return "matrix(" + _a + "," + _b + "," + _c + "," + _d + "," + _e + "," + _f + ")";
        }
        return function() {
          this.reset = reset;
          this.rotate = rotate;
          this.rotateX = rotateX;
          this.rotateY = rotateY;
          this.rotateZ = rotateZ;
          this.skew = skew;
          this.skewFromAxis = skewFromAxis;
          this.shear = shear;
          this.scale = scale2;
          this.setTransform = setTransform;
          this.translate = translate;
          this.transform = transform2;
          this.multiply = multiply;
          this.applyToPoint = applyToPoint;
          this.applyToX = applyToX;
          this.applyToY = applyToY;
          this.applyToZ = applyToZ;
          this.applyToPointArray = applyToPointArray;
          this.applyToTriplePoints = applyToTriplePoints;
          this.applyToPointStringified = applyToPointStringified;
          this.toCSS = toCSS;
          this.to2dCSS = to2dCSS;
          this.clone = clone2;
          this.cloneFromProps = cloneFromProps;
          this.equals = equals;
          this.inversePoints = inversePoints;
          this.inversePoint = inversePoint;
          this.getInverseMatrix = getInverseMatrix;
          this._t = this.transform;
          this.isIdentity = isIdentity;
          this._identity = true;
          this._identityCalculated = false;
          this.props = createTypedArray("float32", 16);
          this.reset();
        };
      }();
      function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$3 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$3 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$3(obj);
      }
      var lottie = {};
      function setLocation(href) {
        setLocationHref(href);
      }
      function searchAnimations() {
        {
          animationManager.searchAnimations();
        }
      }
      function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
      }
      function setPrefix(prefix2) {
        setIdPrefix(prefix2);
      }
      function loadAnimation(params) {
        return animationManager.loadAnimation(params);
      }
      function setQuality(value2) {
        if (typeof value2 === "string") {
          switch (value2) {
            case "high":
              setDefaultCurveSegments(200);
              break;
            default:
            case "medium":
              setDefaultCurveSegments(50);
              break;
            case "low":
              setDefaultCurveSegments(10);
              break;
          }
        } else if (!isNaN(value2) && value2 > 1) {
          setDefaultCurveSegments(value2);
        }
      }
      function inBrowser() {
        return typeof navigator !== "undefined";
      }
      function installPlugin(type, plugin) {
        if (type === "expressions") {
          setExpressionsPlugin(plugin);
        }
      }
      function getFactory(name2) {
        switch (name2) {
          case "propertyFactory":
            return PropertyFactory;
          case "shapePropertyFactory":
            return ShapePropertyFactory;
          case "matrix":
            return Matrix;
          default:
            return null;
        }
      }
      lottie.play = animationManager.play;
      lottie.pause = animationManager.pause;
      lottie.setLocationHref = setLocation;
      lottie.togglePause = animationManager.togglePause;
      lottie.setSpeed = animationManager.setSpeed;
      lottie.setDirection = animationManager.setDirection;
      lottie.stop = animationManager.stop;
      lottie.searchAnimations = searchAnimations;
      lottie.registerAnimation = animationManager.registerAnimation;
      lottie.loadAnimation = loadAnimation;
      lottie.setSubframeRendering = setSubframeRendering;
      lottie.resize = animationManager.resize;
      lottie.goToAndStop = animationManager.goToAndStop;
      lottie.destroy = animationManager.destroy;
      lottie.setQuality = setQuality;
      lottie.inBrowser = inBrowser;
      lottie.installPlugin = installPlugin;
      lottie.freeze = animationManager.freeze;
      lottie.unfreeze = animationManager.unfreeze;
      lottie.setVolume = animationManager.setVolume;
      lottie.mute = animationManager.mute;
      lottie.unmute = animationManager.unmute;
      lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
      lottie.useWebWorker = setWebWorker;
      lottie.setIDPrefix = setPrefix;
      lottie.__getFactory = getFactory;
      lottie.version = "5.12.2";
      function checkReady() {
        if (document.readyState === "complete") {
          clearInterval(readyStateCheckInterval);
          searchAnimations();
        }
      }
      function getQueryVariable(variable) {
        var vars = queryString.split("&");
        for (var i = 0; i < vars.length; i += 1) {
          var pair = vars[i].split("=");
          if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
          }
        }
        return null;
      }
      var queryString = "";
      {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
          src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "";
        getQueryVariable("renderer");
      }
      var readyStateCheckInterval = setInterval(checkReady, 100);
      try {
        if (!((typeof exports === "undefined" ? "undefined" : _typeof$3(exports)) === "object" && typeof module !== "undefined") && !(typeof define === "function" && define.amd)) {
          window.bodymovin = lottie;
        }
      } catch (err) {
      }
      var ShapeModifiers = function() {
        var ob2 = {};
        var modifiers = {};
        ob2.registerModifier = registerModifier;
        ob2.getModifier = getModifier;
        function registerModifier(nm, factory17) {
          if (!modifiers[nm]) {
            modifiers[nm] = factory17;
          }
        }
        function getModifier(nm, elem2, data2) {
          return new modifiers[nm](elem2, data2);
        }
        return ob2;
      }();
      function ShapeModifier() {
      }
      ShapeModifier.prototype.initModifierProperties = function() {
      };
      ShapeModifier.prototype.addShapeToModifier = function() {
      };
      ShapeModifier.prototype.addShape = function(data2) {
        if (!this.closed) {
          data2.sh.container.addDynamicProperty(data2.sh);
          var shapeData = {
            shape: data2.sh,
            data: data2,
            localShapeCollection: shapeCollectionPool.newShapeCollection()
          };
          this.shapes.push(shapeData);
          this.addShapeToModifier(shapeData);
          if (this._isAnimated) {
            data2.setAsAnimated();
          }
        }
      };
      ShapeModifier.prototype.init = function(elem2, data2) {
        this.shapes = [];
        this.elem = elem2;
        this.initDynamicPropertyContainer(elem2);
        this.initModifierProperties(elem2, data2);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.getValue(true);
        }
      };
      ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
      };
      extendPrototype([DynamicPropertyContainer], ShapeModifier);
      function TrimModifier() {
      }
      extendPrototype([ShapeModifier], TrimModifier);
      TrimModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.s = PropertyFactory.getProp(elem2, data2.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem2, data2.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem2, data2.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data2.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
      };
      TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
      };
      TrimModifier.prototype.calculateShapeEdges = function(s2, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) {
          segments.push({
            s: s2,
            e
          });
        } else if (s2 >= 1) {
          segments.push({
            s: s2 - 1,
            e: e - 1
          });
        } else {
          segments.push({
            s: s2,
            e: 1
          });
          segments.push({
            s: 0,
            e: e - 1
          });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for (i = 0; i < len; i += 1) {
          segmentOb = segments[i];
          if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
            var shapeS;
            var shapeE;
            if (segmentOb.s * totalModifierLength <= addedLength) {
              shapeS = 0;
            } else {
              shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
            }
            if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
              shapeE = 1;
            } else {
              shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
            }
            shapeSegments.push([shapeS, shapeE]);
          }
        }
        if (!shapeSegments.length) {
          shapeSegments.push([0, 0]);
        }
        return shapeSegments;
      };
      TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for (i = 0; i < len; i += 1) {
          segmentsLengthPool.release(pathsData[i]);
        }
        pathsData.length = 0;
        return pathsData;
      };
      TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s2;
        var e;
        if (this._mdf || _isFirstFrame) {
          var o = this.o.v % 360 / 360;
          if (o < 0) {
            o += 1;
          }
          if (this.s.v > 1) {
            s2 = 1 + o;
          } else if (this.s.v < 0) {
            s2 = 0 + o;
          } else {
            s2 = this.s.v + o;
          }
          if (this.e.v > 1) {
            e = 1 + o;
          } else if (this.e.v < 0) {
            e = 0 + o;
          } else {
            e = this.e.v + o;
          }
          if (s2 > e) {
            var _s = s2;
            s2 = e;
            e = _s;
          }
          s2 = Math.round(s2 * 1e4) * 1e-4;
          e = Math.round(e * 1e4) * 1e-4;
          this.sValue = s2;
          this.eValue = e;
        } else {
          s2 = this.sValue;
          e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s2) {
          for (i = 0; i < len; i += 1) {
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) {
              this.shapes[i].pathsData.length = 0;
            }
          }
        } else if (!(e === 1 && s2 === 0 || e === 0 && s2 === 1)) {
          var segments = [];
          var shapeData;
          var localShapeCollection;
          for (i = 0; i < len; i += 1) {
            shapeData = this.shapes[i];
            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
              shapeData.shape.paths = shapeData.localShapeCollection;
            } else {
              shapePaths = shapeData.shape.paths;
              jLen = shapePaths._length;
              totalShapeLength = 0;
              if (!shapeData.shape._mdf && shapeData.pathsData.length) {
                totalShapeLength = shapeData.totalShapeLength;
              } else {
                pathsData = this.releasePathsData(shapeData.pathsData);
                for (j = 0; j < jLen; j += 1) {
                  pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                  pathsData.push(pathData);
                  totalShapeLength += pathData.totalLength;
                }
                shapeData.totalShapeLength = totalShapeLength;
                shapeData.pathsData = pathsData;
              }
              totalModifierLength += totalShapeLength;
              shapeData.shape._mdf = true;
            }
          }
          var shapeS = s2;
          var shapeE = e;
          var addedLength = 0;
          var edges;
          for (i = len - 1; i >= 0; i -= 1) {
            shapeData = this.shapes[i];
            if (shapeData.shape._mdf) {
              localShapeCollection = shapeData.localShapeCollection;
              localShapeCollection.releaseShapes();
              if (this.m === 2 && len > 1) {
                edges = this.calculateShapeEdges(s2, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                addedLength += shapeData.totalShapeLength;
              } else {
                edges = [[shapeS, shapeE]];
              }
              jLen = edges.length;
              for (j = 0; j < jLen; j += 1) {
                shapeS = edges[j][0];
                shapeE = edges[j][1];
                segments.length = 0;
                if (shapeE <= 1) {
                  segments.push({
                    s: shapeData.totalShapeLength * shapeS,
                    e: shapeData.totalShapeLength * shapeE
                  });
                } else if (shapeS >= 1) {
                  segments.push({
                    s: shapeData.totalShapeLength * (shapeS - 1),
                    e: shapeData.totalShapeLength * (shapeE - 1)
                  });
                } else {
                  segments.push({
                    s: shapeData.totalShapeLength * shapeS,
                    e: shapeData.totalShapeLength
                  });
                  segments.push({
                    s: 0,
                    e: shapeData.totalShapeLength * (shapeE - 1)
                  });
                }
                var newShapesData = this.addShapes(shapeData, segments[0]);
                if (segments[0].s !== segments[0].e) {
                  if (segments.length > 1) {
                    var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                    if (lastShapeInCollection.c) {
                      var lastShape = newShapesData.pop();
                      this.addPaths(newShapesData, localShapeCollection);
                      newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                    } else {
                      this.addPaths(newShapesData, localShapeCollection);
                      newShapesData = this.addShapes(shapeData, segments[1]);
                    }
                  }
                  this.addPaths(newShapesData, localShapeCollection);
                }
              }
              shapeData.shape.paths = localShapeCollection;
            }
          }
        } else if (this._mdf) {
          for (i = 0; i < len; i += 1) {
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
          }
        }
      };
      TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for (i = 0; i < len; i += 1) {
          localShapeCollection.addShape(newPaths[i]);
        }
      };
      TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], "o", pos);
        shapePath.setXYAt(pt3[0], pt3[1], "i", pos + 1);
        if (newShape) {
          shapePath.setXYAt(pt1[0], pt1[1], "v", pos);
        }
        shapePath.setXYAt(pt4[0], pt4[1], "v", pos + 1);
      };
      TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], "o", pos);
        shapePath.setXYAt(points[2], points[6], "i", pos + 1);
        if (newShape) {
          shapePath.setXYAt(points[0], points[4], "v", pos);
        }
        shapePath.setXYAt(points[3], points[7], "v", pos + 1);
      };
      TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
          shapePath = shapePool.newElement();
          segmentCount = 0;
          initPos = 0;
        } else {
          segmentCount = shapePath._length;
          initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for (i = 0; i < len; i += 1) {
          lengths = pathsData[i].lengths;
          shapePath.c = shapePaths[i].c;
          jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
          for (j = 1; j < jLen; j += 1) {
            currentLengthData = lengths[j - 1];
            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
              addedLength += currentLengthData.addedLength;
              shapePath.c = false;
            } else if (addedLength > shapeSegment.e) {
              shapePath.c = false;
              break;
            } else {
              if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                newShape = false;
              } else {
                segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                newShape = false;
                shapePath.c = false;
              }
              addedLength += currentLengthData.addedLength;
              segmentCount += 1;
            }
          }
          if (shapePaths[i].c && lengths.length) {
            currentLengthData = lengths[j - 1];
            if (addedLength <= shapeSegment.e) {
              var segmentLength = lengths[j - 1].addedLength;
              if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                newShape = false;
              } else {
                segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                newShape = false;
                shapePath.c = false;
              }
            } else {
              shapePath.c = false;
            }
            addedLength += currentLengthData.addedLength;
            segmentCount += 1;
          }
          if (shapePath._length) {
            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], "i", initPos);
            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], "o", shapePath._length - 1);
          }
          if (addedLength > shapeSegment.e) {
            break;
          }
          if (i < len - 1) {
            shapePath = shapePool.newElement();
            newShape = true;
            shapes.push(shapePath);
            segmentCount = 0;
          }
        }
        return shapes;
      };
      function PuckerAndBloatModifier() {
      }
      extendPrototype([ShapeModifier], PuckerAndBloatModifier);
      PuckerAndBloatModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem2, data2.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
      };
      PuckerAndBloatModifier.prototype.processPath = function(path2, amount) {
        var percent = amount / 100;
        var centerPoint = [0, 0];
        var pathLength = path2._length;
        var i = 0;
        for (i = 0; i < pathLength; i += 1) {
          centerPoint[0] += path2.v[i][0];
          centerPoint[1] += path2.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path2.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for (i = 0; i < pathLength; i += 1) {
          vX = path2.v[i][0] + (centerPoint[0] - path2.v[i][0]) * percent;
          vY = path2.v[i][1] + (centerPoint[1] - path2.v[i][1]) * percent;
          oX = path2.o[i][0] + (centerPoint[0] - path2.o[i][0]) * -percent;
          oY = path2.o[i][1] + (centerPoint[1] - path2.o[i][1]) * -percent;
          iX = path2.i[i][0] + (centerPoint[0] - path2.i[i][0]) * -percent;
          iY = path2.i[i][1] + (centerPoint[1] - path2.i[i][1]) * -percent;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
      };
      PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
          var shapeData;
          var localShapeCollection;
          for (i = 0; i < len; i += 1) {
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
              localShapeCollection.releaseShapes();
              shapeData.shape._mdf = true;
              shapePaths = shapeData.shape.paths.shapes;
              jLen = shapeData.shape.paths._length;
              for (j = 0; j < jLen; j += 1) {
                localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
              }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
          }
        }
        if (!this.dynamicProperties.length) {
          this._mdf = false;
        }
      };
      var TransformPropertyFactory = function() {
        var defaultVector = [0, 0];
        function applyToMatrix(mat) {
          var _mdf = this._mdf;
          this.iterateDynamicProperties();
          this._mdf = this._mdf || _mdf;
          if (this.a) {
            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
          }
          if (this.s) {
            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
          }
          if (this.sk) {
            mat.skewFromAxis(-this.sk.v, this.sa.v);
          }
          if (this.r) {
            mat.rotate(-this.r.v);
          } else {
            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
          }
          if (this.data.p.s) {
            if (this.data.p.z) {
              mat.translate(this.px.v, this.py.v, -this.pz.v);
            } else {
              mat.translate(this.px.v, this.py.v, 0);
            }
          } else {
            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
        }
        function processKeys(forceRender) {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }
          if (this._isDirty) {
            this.precalculateMatrix();
            this._isDirty = false;
          }
          this.iterateDynamicProperties();
          if (this._mdf || forceRender) {
            var frameRate;
            this.v.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
              this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            }
            if (this.appliedTransformations < 2) {
              this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            }
            if (this.sk && this.appliedTransformations < 3) {
              this.v.skewFromAxis(-this.sk.v, this.sa.v);
            }
            if (this.r && this.appliedTransformations < 4) {
              this.v.rotate(-this.r.v);
            } else if (!this.r && this.appliedTransformations < 4) {
              this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            }
            if (this.autoOriented) {
              var v1;
              var v2;
              frameRate = this.elem.globalData.frameRate;
              if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                  v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                  v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                  v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                  v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                } else {
                  v1 = this.p.pv;
                  v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                }
              } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                v1 = [];
                v2 = [];
                var px = this.px;
                var py = this.py;
                if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                  v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                  v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                  v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                  v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                  v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                  v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                  v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                  v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                } else {
                  v1 = [px.pv, py.pv];
                  v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                  v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                }
              } else {
                v2 = defaultVector;
                v1 = v2;
              }
              this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
            }
            if (this.data.p && this.data.p.s) {
              if (this.data.p.z) {
                this.v.translate(this.px.v, this.py.v, -this.pz.v);
              } else {
                this.v.translate(this.px.v, this.py.v, 0);
              }
            } else {
              this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
          }
          this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
          this.appliedTransformations = 0;
          this.pre.reset();
          if (!this.a.effectsSequence.length) {
            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            this.appliedTransformations = 1;
          } else {
            return;
          }
          if (!this.s.effectsSequence.length) {
            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            this.appliedTransformations = 2;
          } else {
            return;
          }
          if (this.sk) {
            if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
              this.pre.skewFromAxis(-this.sk.v, this.sa.v);
              this.appliedTransformations = 3;
            } else {
              return;
            }
          }
          if (this.r) {
            if (!this.r.effectsSequence.length) {
              this.pre.rotate(-this.r.v);
              this.appliedTransformations = 4;
            }
          } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            this.appliedTransformations = 4;
          }
        }
        function autoOrient() {
        }
        function addDynamicProperty(prop) {
          this._addDynamicProperty(prop);
          this.elem.addDynamicProperty(prop);
          this._isDirty = true;
        }
        function TransformProperty(elem2, data2, container) {
          this.elem = elem2;
          this.frameId = -1;
          this.propType = "transform";
          this.data = data2;
          this.v = new Matrix();
          this.pre = new Matrix();
          this.appliedTransformations = 0;
          this.initDynamicPropertyContainer(container || elem2);
          if (data2.p && data2.p.s) {
            this.px = PropertyFactory.getProp(elem2, data2.p.x, 0, 0, this);
            this.py = PropertyFactory.getProp(elem2, data2.p.y, 0, 0, this);
            if (data2.p.z) {
              this.pz = PropertyFactory.getProp(elem2, data2.p.z, 0, 0, this);
            }
          } else {
            this.p = PropertyFactory.getProp(elem2, data2.p || {
              k: [0, 0, 0]
            }, 1, 0, this);
          }
          if (data2.rx) {
            this.rx = PropertyFactory.getProp(elem2, data2.rx, 0, degToRads, this);
            this.ry = PropertyFactory.getProp(elem2, data2.ry, 0, degToRads, this);
            this.rz = PropertyFactory.getProp(elem2, data2.rz, 0, degToRads, this);
            if (data2.or.k[0].ti) {
              var i;
              var len = data2.or.k.length;
              for (i = 0; i < len; i += 1) {
                data2.or.k[i].to = null;
                data2.or.k[i].ti = null;
              }
            }
            this.or = PropertyFactory.getProp(elem2, data2.or, 1, degToRads, this);
            this.or.sh = true;
          } else {
            this.r = PropertyFactory.getProp(elem2, data2.r || {
              k: 0
            }, 0, degToRads, this);
          }
          if (data2.sk) {
            this.sk = PropertyFactory.getProp(elem2, data2.sk, 0, degToRads, this);
            this.sa = PropertyFactory.getProp(elem2, data2.sa, 0, degToRads, this);
          }
          this.a = PropertyFactory.getProp(elem2, data2.a || {
            k: [0, 0, 0]
          }, 1, 0, this);
          this.s = PropertyFactory.getProp(elem2, data2.s || {
            k: [100, 100, 100]
          }, 1, 0.01, this);
          if (data2.o) {
            this.o = PropertyFactory.getProp(elem2, data2.o, 0, 0.01, elem2);
          } else {
            this.o = {
              _mdf: false,
              v: 1
            };
          }
          this._isDirty = true;
          if (!this.dynamicProperties.length) {
            this.getValue(true);
          }
        }
        TransformProperty.prototype = {
          applyToMatrix,
          getValue: processKeys,
          precalculateMatrix,
          autoOrient
        };
        extendPrototype([DynamicPropertyContainer], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem2, data2, container) {
          return new TransformProperty(elem2, data2, container);
        }
        return {
          getTransformProperty
        };
      }();
      function RepeaterModifier() {
      }
      extendPrototype([ShapeModifier], RepeaterModifier);
      RepeaterModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem2, data2.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem2, data2.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem2, data2.tr, this);
        this.so = PropertyFactory.getProp(elem2, data2.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem2, data2.tr.eo, 0, 0.01, this);
        this.data = data2;
        if (!this.dynamicProperties.length) {
          this.getValue(true);
        }
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
      };
      RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform2, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform2.s.v[0] + (1 - transform2.s.v[0]) * (1 - perc);
        var scaleY = transform2.s.v[1] + (1 - transform2.s.v[1]) * (1 - perc);
        pMatrix.translate(transform2.p.v[0] * dir * perc, transform2.p.v[1] * dir * perc, transform2.p.v[2]);
        rMatrix.translate(-transform2.a.v[0], -transform2.a.v[1], transform2.a.v[2]);
        rMatrix.rotate(-transform2.r.v * dir * perc);
        rMatrix.translate(transform2.a.v[0], transform2.a.v[1], transform2.a.v[2]);
        sMatrix.translate(-transform2.a.v[0], -transform2.a.v[1], transform2.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform2.a.v[0], transform2.a.v[1], transform2.a.v[2]);
      };
      RepeaterModifier.prototype.init = function(elem2, arr, pos, elemsData) {
        this.elem = elem2;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem2);
        this.initModifierProperties(elem2, arr[pos]);
        while (pos > 0) {
          pos -= 1;
          this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.getValue(true);
        }
      };
      RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for (i = 0; i < len; i += 1) {
          elements[i]._processed = false;
          if (elements[i].ty === "gr") {
            this.resetElements(elements[i].it);
          }
        }
      };
      RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
      };
      RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for (i = 0; i < len; i += 1) {
          elements[i]._render = renderFlag;
          if (elements[i].ty === "gr") {
            this.changeGroupRender(elements[i].it, renderFlag);
          }
        }
      };
      RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
          var copies = Math.ceil(this.c.v);
          if (this._groups.length < copies) {
            while (this._groups.length < copies) {
              var group = {
                it: this.cloneElements(this._elements),
                ty: "gr"
              };
              group.it.push({
                a: {
                  a: 0,
                  ix: 1,
                  k: [0, 0]
                },
                nm: "Transform",
                o: {
                  a: 0,
                  ix: 7,
                  k: 100
                },
                p: {
                  a: 0,
                  ix: 2,
                  k: [0, 0]
                },
                r: {
                  a: 1,
                  ix: 6,
                  k: [{
                    s: 0,
                    e: 0,
                    t: 0
                  }, {
                    s: 0,
                    e: 0,
                    t: 1
                  }]
                },
                s: {
                  a: 0,
                  ix: 3,
                  k: [100, 100]
                },
                sa: {
                  a: 0,
                  ix: 5,
                  k: 0
                },
                sk: {
                  a: 0,
                  ix: 4,
                  k: 0
                },
                ty: "tr"
              });
              this.arr.splice(0, 0, group);
              this._groups.splice(0, 0, group);
              this._currentCopies += 1;
            }
            this.elem.reloadShapes();
            hasReloaded = true;
          }
          cont = 0;
          var renderFlag;
          for (i = 0; i <= this._groups.length - 1; i += 1) {
            renderFlag = cont < copies;
            this._groups[i]._render = renderFlag;
            this.changeGroupRender(this._groups[i].it, renderFlag);
            if (!renderFlag) {
              var elems = this.elemsData[i].it;
              var transformData = elems[elems.length - 1];
              if (transformData.transform.op.v !== 0) {
                transformData.transform.op._mdf = true;
                transformData.transform.op.v = 0;
              } else {
                transformData.transform.op._mdf = false;
              }
            }
            cont += 1;
          }
          this._currentCopies = copies;
          var offset = this.o.v;
          var offsetModulo = offset % 1;
          var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
          var pProps = this.pMatrix.props;
          var rProps = this.rMatrix.props;
          var sProps = this.sMatrix.props;
          this.pMatrix.reset();
          this.rMatrix.reset();
          this.sMatrix.reset();
          this.tMatrix.reset();
          this.matrix.reset();
          var iteration = 0;
          if (offset > 0) {
            while (iteration < roundOffset) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
              iteration += 1;
            }
            if (offsetModulo) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
              iteration += offsetModulo;
            }
          } else if (offset < 0) {
            while (iteration > roundOffset) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
              iteration -= 1;
            }
            if (offsetModulo) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
              iteration -= offsetModulo;
            }
          }
          i = this.data.m === 1 ? 0 : this._currentCopies - 1;
          dir = this.data.m === 1 ? 1 : -1;
          cont = this._currentCopies;
          var j;
          var jLen;
          while (cont) {
            items = this.elemsData[i].it;
            itemsTransform = items[items.length - 1].transform.mProps.v.props;
            jLen = itemsTransform.length;
            items[items.length - 1].transform.mProps._mdf = true;
            items[items.length - 1].transform.op._mdf = true;
            items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
            if (iteration !== 0) {
              if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
              }
              this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
              this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
              this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
              for (j = 0; j < jLen; j += 1) {
                itemsTransform[j] = this.matrix.props[j];
              }
              this.matrix.reset();
            } else {
              this.matrix.reset();
              for (j = 0; j < jLen; j += 1) {
                itemsTransform[j] = this.matrix.props[j];
              }
            }
            iteration += 1;
            cont -= 1;
            i += dir;
          }
        } else {
          cont = this._currentCopies;
          i = 0;
          dir = 1;
          while (cont) {
            items = this.elemsData[i].it;
            itemsTransform = items[items.length - 1].transform.mProps.v.props;
            items[items.length - 1].transform.mProps._mdf = false;
            items[items.length - 1].transform.op._mdf = false;
            cont -= 1;
            i += dir;
          }
        }
        return hasReloaded;
      };
      RepeaterModifier.prototype.addShape = function() {
      };
      function RoundCornersModifier() {
      }
      extendPrototype([ShapeModifier], RoundCornersModifier);
      RoundCornersModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem2, data2.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
      };
      RoundCornersModifier.prototype.processPath = function(path2, round2) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path2.c;
        var i;
        var len = path2._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index2 = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for (i = 0; i < len; i += 1) {
          currentV = path2.v[i];
          currentO = path2.o[i];
          currentI = path2.i[i];
          if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
            if ((i === 0 || i === len - 1) && !path2.c) {
              clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index2);
              index2 += 1;
            } else {
              if (i === 0) {
                closerV = path2.v[len - 1];
              } else {
                closerV = path2.v[i - 1];
              }
              distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
              newPosPerc = distance ? Math.min(distance / 2, round2) / distance : 0;
              iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
              vX = iX;
              iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
              vY = iY;
              oX = vX - (vX - currentV[0]) * roundCorner;
              oY = vY - (vY - currentV[1]) * roundCorner;
              clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index2);
              index2 += 1;
              if (i === len - 1) {
                closerV = path2.v[0];
              } else {
                closerV = path2.v[i + 1];
              }
              distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
              newPosPerc = distance ? Math.min(distance / 2, round2) / distance : 0;
              oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
              vX = oX;
              oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
              vY = oY;
              iX = vX - (vX - currentV[0]) * roundCorner;
              iY = vY - (vY - currentV[1]) * roundCorner;
              clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index2);
              index2 += 1;
            }
          } else {
            clonedPath.setTripleAt(path2.v[i][0], path2.v[i][1], path2.o[i][0], path2.o[i][1], path2.i[i][0], path2.i[i][1], index2);
            index2 += 1;
          }
        }
        return clonedPath;
      };
      RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
          var shapeData;
          var localShapeCollection;
          for (i = 0; i < len; i += 1) {
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
              localShapeCollection.releaseShapes();
              shapeData.shape._mdf = true;
              shapePaths = shapeData.shape.paths.shapes;
              jLen = shapeData.shape.paths._length;
              for (j = 0; j < jLen; j += 1) {
                localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
              }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
          }
        }
        if (!this.dynamicProperties.length) {
          this._mdf = false;
        }
      };
      function floatEqual(a2, b) {
        return Math.abs(a2 - b) * 1e5 <= Math.min(Math.abs(a2), Math.abs(b));
      }
      function floatZero(f) {
        return Math.abs(f) <= 1e-5;
      }
      function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
      }
      function lerpPoint(p0, p1, amount) {
        return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
      }
      function quadRoots(a2, b, c2) {
        if (a2 === 0) return [];
        var s2 = b * b - 4 * a2 * c2;
        if (s2 < 0) return [];
        var singleRoot = -b / (2 * a2);
        if (s2 === 0) return [singleRoot];
        var delta = Math.sqrt(s2) / (2 * a2);
        return [singleRoot - delta, singleRoot + delta];
      }
      function polynomialCoefficients(p0, p1, p2, p3) {
        return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
      }
      function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
      }
      function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) {
          p1 = lerpPoint(p0, p3, 1 / 3);
        }
        if (linearize && pointEqual(p2, p3)) {
          p2 = lerpPoint(p0, p3, 2 / 3);
        }
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [coeffx[0], coeffy[0]];
        this.b = [coeffx[1], coeffy[1]];
        this.c = [coeffx[2], coeffy[2]];
        this.d = [coeffx[3], coeffy[3]];
        this.points = [p0, p1, p2, p3];
      }
      PolynomialBezier.prototype.point = function(t) {
        return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
      };
      PolynomialBezier.prototype.derivative = function(t) {
        return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
      };
      PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
      };
      PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
      };
      PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square2 = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square2 < 0) return [];
        var root = Math.sqrt(square2);
        if (floatZero(root)) {
          if (root > 0 && root < 1) return [tcusp];
          return [];
        }
        return [tcusp - root, tcusp + root].filter(function(r2) {
          return r2 > 0 && r2 < 1;
        });
      };
      PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [singlePoint(this.points[0]), this];
        if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
      };
      function extrema(bez2, comp2) {
        var min3 = bez2.points[0][comp2];
        var max4 = bez2.points[bez2.points.length - 1][comp2];
        if (min3 > max4) {
          var e = max4;
          max4 = min3;
          min3 = e;
        }
        var f = quadRoots(3 * bez2.a[comp2], 2 * bez2.b[comp2], bez2.c[comp2]);
        for (var i = 0; i < f.length; i += 1) {
          if (f[i] > 0 && f[i] < 1) {
            var val2 = bez2.point(f[i])[comp2];
            if (val2 < min3) min3 = val2;
            else if (val2 > max4) max4 = val2;
          }
        }
        return {
          min: min3,
          max: max4
        };
      }
      PolynomialBezier.prototype.bounds = function() {
        return {
          x: extrema(this, 0),
          y: extrema(this, 1)
        };
      };
      PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
          left: bounds.x.min,
          right: bounds.x.max,
          top: bounds.y.min,
          bottom: bounds.y.max,
          width: bounds.x.max - bounds.x.min,
          height: bounds.y.max - bounds.y.min,
          cx: (bounds.x.max + bounds.x.min) / 2,
          cy: (bounds.y.max + bounds.y.min) / 2
        };
      };
      function intersectData(bez2, t12, t2) {
        var box = bez2.boundingBox();
        return {
          cx: box.cx,
          cy: box.cy,
          width: box.width,
          height: box.height,
          bez: bez2,
          t: (t12 + t2) / 2,
          t1: t12,
          t2
        };
      }
      function splitData(data2) {
        var split = data2.bez.split(0.5);
        return [intersectData(split[0], data2.t1, data2.t), intersectData(split[1], data2.t, data2.t2)];
      }
      function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
      }
      function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
          intersections.push([d1.t, d2.t]);
          return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
      }
      PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === void 0) tolerance = 2;
        if (maxRecursion === void 0) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
      };
      PolynomialBezier.shapeSegment = function(shapePath, index2) {
        var nextIndex = (index2 + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index2], shapePath.o[index2], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
      };
      PolynomialBezier.shapeSegmentInverted = function(shapePath, index2) {
        var nextIndex = (index2 + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index2], shapePath.v[index2], true);
      };
      function crossProduct(a2, b) {
        return [a2[1] * b[2] - a2[2] * b[1], a2[2] * b[0] - a2[0] * b[2], a2[0] * b[1] - a2[1] * b[0]];
      }
      function lineIntersection(start1, end1, start2, end2) {
        var v1 = [start1[0], start1[1], 1];
        var v2 = [end1[0], end1[1], 1];
        var v3 = [start2[0], start2[1], 1];
        var v4 = [end2[0], end2[1], 1];
        var r2 = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r2[2])) return null;
        return [r2[0] / r2[2], r2[1] / r2[2]];
      }
      function polarOffset(p, angle, length2) {
        return [p[0] + Math.cos(angle) * length2, p[1] - Math.sin(angle) * length2];
      }
      function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
      }
      function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
      }
      function ZigZagModifier() {
      }
      extendPrototype([ShapeModifier], ZigZagModifier);
      ZigZagModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem2, data2.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem2, data2.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem2, data2.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
      };
      function setPoint(outputBezier, point4, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point4[0] + Math.cos(angle) * direction * amplitude;
        var py = point4[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
      }
      function getPerpendicularVector(pt1, pt2) {
        var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
        return rotatedVector;
      }
      function getProjectingAngle(path2, cur) {
        var prevIndex = cur === 0 ? path2.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path2.length();
        var prevPoint = path2.v[prevIndex];
        var nextPoint = path2.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
      }
      function zigZagCorner(outputBezier, path2, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path2, cur);
        var point4 = path2.v[cur % path2._length];
        var prevPoint = path2.v[cur === 0 ? path2._length - 1 : cur - 1];
        var nextPoint = path2.v[(cur + 1) % path2._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point4[0] - prevPoint[0], 2) + Math.pow(point4[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point4[0] - nextPoint[0], 2) + Math.pow(point4[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path2.v[cur % path2._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2));
      }
      function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for (var i = 0; i < frequency; i += 1) {
          var t = (i + 1) / (frequency + 1);
          var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
          var angle = segment.normalAngle(t);
          var point4 = segment.point(t);
          setPoint(outputBezier, point4, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2));
          direction = -direction;
        }
        return direction;
      }
      ZigZagModifier.prototype.processPath = function(path2, amplitude, frequency, pointType) {
        var count = path2._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path2.c;
        if (!path2.c) {
          count -= 1;
        }
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path2, 0);
        zigZagCorner(clonedPath, path2, 0, amplitude, frequency, pointType, direction);
        for (var i = 0; i < count; i += 1) {
          direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
          if (i === count - 1 && !path2.c) {
            segment = null;
          } else {
            segment = PolynomialBezier.shapeSegment(path2, (i + 1) % count);
          }
          zigZagCorner(clonedPath, path2, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
      };
      ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
          var shapeData;
          var localShapeCollection;
          for (i = 0; i < len; i += 1) {
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
              localShapeCollection.releaseShapes();
              shapeData.shape._mdf = true;
              shapePaths = shapeData.shape.paths.shapes;
              jLen = shapeData.shape.paths._length;
              for (j = 0; j < jLen; j += 1) {
                localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
              }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
          }
        }
        if (!this.dynamicProperties.length) {
          this._mdf = false;
        }
      };
      function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
      }
      function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
      }
      function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0];
        if (lineJoin === 3) return p0;
        if (pointEqual(p0, p1)) return p0;
        if (lineJoin === 2) {
          var angleOut = -seg1.tangentAngle(1);
          var angleIn = -seg2.tangentAngle(0) + Math.PI;
          var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
          var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
          var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
          outputBezier.setXYAt(tan[0], tan[1], "o", outputBezier.length() - 1);
          tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
          outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
          return p1;
        }
        var t02 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t12 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t02, p0, p1, t12);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
          outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
          return intersection;
        }
        return p0;
      }
      function getIntersection(a2, b) {
        var intersect = a2.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
      }
      function pruneSegmentIntersection(a2, b) {
        var outa = a2.slice();
        var outb = b.slice();
        var intersect = getIntersection(a2[a2.length - 1], b[0]);
        if (intersect) {
          outa[a2.length - 1] = a2[a2.length - 1].split(intersect[0])[0];
          outb[0] = b[0].split(intersect[1])[1];
        }
        if (a2.length > 1 && b.length > 1) {
          intersect = getIntersection(a2[0], b[b.length - 1]);
          if (intersect) {
            return [[a2[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
          }
        }
        return [outa, outb];
      }
      function pruneIntersections(segments) {
        var e;
        for (var i = 1; i < segments.length; i += 1) {
          e = pruneSegmentIntersection(segments[i - 1], segments[i]);
          segments[i - 1] = e[0];
          segments[i] = e[1];
        }
        if (segments.length > 1) {
          e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
          segments[segments.length - 1] = e[0];
          segments[0] = e[1];
        }
        return segments;
      }
      function offsetSegmentSplit(segment, amount) {
        var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) {
          return [offsetSegment(segment, amount)];
        }
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
          split = segment.split(flex[0]);
          left = split[0];
          right = split[1];
          return [offsetSegment(left, amount), offsetSegment(right, amount)];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
      }
      function OffsetPathModifier() {
      }
      extendPrototype([ShapeModifier], OffsetPathModifier);
      OffsetPathModifier.prototype.initModifierProperties = function(elem2, data2) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem2, data2.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem2, data2.ml, 0, null, this);
        this.lineJoin = data2.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
      };
      OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) {
          count -= 1;
        }
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for (i = 0; i < count; i += 1) {
          segment = PolynomialBezier.shapeSegment(inputBezier, i);
          multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) {
          for (i = count - 1; i >= 0; i -= 1) {
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
          }
        }
        multiSegments = pruneIntersections(multiSegments);
        var lastPoint = null;
        var lastSeg = null;
        for (i = 0; i < multiSegments.length; i += 1) {
          var multiSegment = multiSegments[i];
          if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
          lastSeg = multiSegment[multiSegment.length - 1];
          for (j = 0; j < multiSegment.length; j += 1) {
            segment = multiSegment[j];
            if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
              outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], "o", outputBezier.length() - 1);
            } else {
              outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
            }
            outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
            lastPoint = segment.points[3];
          }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
      };
      OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
          var shapeData;
          var localShapeCollection;
          for (i = 0; i < len; i += 1) {
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
              localShapeCollection.releaseShapes();
              shapeData.shape._mdf = true;
              shapePaths = shapeData.shape.paths.shapes;
              jLen = shapeData.shape.paths._length;
              for (j = 0; j < jLen; j += 1) {
                localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
              }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
          }
        }
        if (!this.dynamicProperties.length) {
          this._mdf = false;
        }
      };
      function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(" ") : [];
        var fWeight = "normal";
        var fStyle = "normal";
        var len = styles.length;
        var styleName;
        for (var i = 0; i < len; i += 1) {
          styleName = styles[i].toLowerCase();
          switch (styleName) {
            case "italic":
              fStyle = "italic";
              break;
            case "bold":
              fWeight = "700";
              break;
            case "black":
              fWeight = "900";
              break;
            case "medium":
              fWeight = "500";
              break;
            case "regular":
            case "normal":
              fWeight = "400";
              break;
            case "light":
            case "thin":
              fWeight = "200";
              break;
          }
        }
        return {
          style: fStyle,
          weight: fontData.fWeight || fWeight
        };
      }
      var FontManager = function() {
        var maxWaitingTime = 5e3;
        var emptyChar = {
          w: 0,
          size: 0,
          shapes: [],
          data: {
            shapes: []
          }
        };
        var combinedCharacters = [];
        combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
        function trimFontOptions(font) {
          var familyArray = font.split(",");
          var i;
          var len = familyArray.length;
          var enabledFamilies = [];
          for (i = 0; i < len; i += 1) {
            if (familyArray[i] !== "sans-serif" && familyArray[i] !== "monospace") {
              enabledFamilies.push(familyArray[i]);
            }
          }
          return enabledFamilies.join(",");
        }
        function setUpNode(font, family) {
          var parentNode = createTag("span");
          parentNode.setAttribute("aria-hidden", true);
          parentNode.style.fontFamily = family;
          var node = createTag("span");
          node.innerText = "giItT1WQy@!-/#";
          parentNode.style.position = "absolute";
          parentNode.style.left = "-10000px";
          parentNode.style.top = "-10000px";
          parentNode.style.fontSize = "300px";
          parentNode.style.fontVariant = "normal";
          parentNode.style.fontStyle = "normal";
          parentNode.style.fontWeight = "normal";
          parentNode.style.letterSpacing = "0";
          parentNode.appendChild(node);
          document.body.appendChild(parentNode);
          var width2 = node.offsetWidth;
          node.style.fontFamily = trimFontOptions(font) + ", " + family;
          return {
            node,
            w: width2,
            parent: parentNode
          };
        }
        function checkLoadedFonts() {
          var i;
          var len = this.fonts.length;
          var node;
          var w;
          var loadedCount = len;
          for (i = 0; i < len; i += 1) {
            if (this.fonts[i].loaded) {
              loadedCount -= 1;
            } else if (this.fonts[i].fOrigin === "n" || this.fonts[i].origin === 0) {
              this.fonts[i].loaded = true;
            } else {
              node = this.fonts[i].monoCase.node;
              w = this.fonts[i].monoCase.w;
              if (node.offsetWidth !== w) {
                loadedCount -= 1;
                this.fonts[i].loaded = true;
              } else {
                node = this.fonts[i].sansCase.node;
                w = this.fonts[i].sansCase.w;
                if (node.offsetWidth !== w) {
                  loadedCount -= 1;
                  this.fonts[i].loaded = true;
                }
              }
              if (this.fonts[i].loaded) {
                this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
              }
            }
          }
          if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
            setTimeout(this.checkLoadedFontsBinded, 20);
          } else {
            setTimeout(this.setIsLoadedBinded, 10);
          }
        }
        function createHelper(fontData, def) {
          var engine = document.body && def ? "svg" : "canvas";
          var helper;
          var fontProps = getFontProperties(fontData);
          if (engine === "svg") {
            var tHelper = createNS("text");
            tHelper.style.fontSize = "100px";
            tHelper.setAttribute("font-family", fontData.fFamily);
            tHelper.setAttribute("font-style", fontProps.style);
            tHelper.setAttribute("font-weight", fontProps.weight);
            tHelper.textContent = "1";
            if (fontData.fClass) {
              tHelper.style.fontFamily = "inherit";
              tHelper.setAttribute("class", fontData.fClass);
            } else {
              tHelper.style.fontFamily = fontData.fFamily;
            }
            def.appendChild(tHelper);
            helper = tHelper;
          } else {
            var tCanvasHelper = new OffscreenCanvas(500, 500).getContext("2d");
            tCanvasHelper.font = fontProps.style + " " + fontProps.weight + " 100px " + fontData.fFamily;
            helper = tCanvasHelper;
          }
          function measure(text2) {
            if (engine === "svg") {
              helper.textContent = text2;
              return helper.getComputedTextLength();
            }
            return helper.measureText(text2).width;
          }
          return {
            measureText: measure
          };
        }
        function addFonts(fontData, defs) {
          if (!fontData) {
            this.isLoaded = true;
            return;
          }
          if (this.chars) {
            this.isLoaded = true;
            this.fonts = fontData.list;
            return;
          }
          if (!document.body) {
            this.isLoaded = true;
            fontData.list.forEach(function(data2) {
              data2.helper = createHelper(data2);
              data2.cache = {};
            });
            this.fonts = fontData.list;
            return;
          }
          var fontArr = fontData.list;
          var i;
          var len = fontArr.length;
          var _pendingFonts = len;
          for (i = 0; i < len; i += 1) {
            var shouldLoadFont = true;
            var loadedSelector;
            var j;
            fontArr[i].loaded = false;
            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, "monospace");
            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, "sans-serif");
            if (!fontArr[i].fPath) {
              fontArr[i].loaded = true;
              _pendingFonts -= 1;
            } else if (fontArr[i].fOrigin === "p" || fontArr[i].origin === 3) {
              loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
              if (loadedSelector.length > 0) {
                shouldLoadFont = false;
              }
              if (shouldLoadFont) {
                var s2 = createTag("style");
                s2.setAttribute("f-forigin", fontArr[i].fOrigin);
                s2.setAttribute("f-origin", fontArr[i].origin);
                s2.setAttribute("f-family", fontArr[i].fFamily);
                s2.type = "text/css";
                s2.innerText = "@font-face {font-family: " + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                defs.appendChild(s2);
              }
            } else if (fontArr[i].fOrigin === "g" || fontArr[i].origin === 1) {
              loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
              for (j = 0; j < loadedSelector.length; j += 1) {
                if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
                  shouldLoadFont = false;
                }
              }
              if (shouldLoadFont) {
                var l = createTag("link");
                l.setAttribute("f-forigin", fontArr[i].fOrigin);
                l.setAttribute("f-origin", fontArr[i].origin);
                l.type = "text/css";
                l.rel = "stylesheet";
                l.href = fontArr[i].fPath;
                document.body.appendChild(l);
              }
            } else if (fontArr[i].fOrigin === "t" || fontArr[i].origin === 2) {
              loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
              for (j = 0; j < loadedSelector.length; j += 1) {
                if (fontArr[i].fPath === loadedSelector[j].src) {
                  shouldLoadFont = false;
                }
              }
              if (shouldLoadFont) {
                var sc = createTag("link");
                sc.setAttribute("f-forigin", fontArr[i].fOrigin);
                sc.setAttribute("f-origin", fontArr[i].origin);
                sc.setAttribute("rel", "stylesheet");
                sc.setAttribute("href", fontArr[i].fPath);
                defs.appendChild(sc);
              }
            }
            fontArr[i].helper = createHelper(fontArr[i], defs);
            fontArr[i].cache = {};
            this.fonts.push(fontArr[i]);
          }
          if (_pendingFonts === 0) {
            this.isLoaded = true;
          } else {
            setTimeout(this.checkLoadedFonts.bind(this), 100);
          }
        }
        function addChars(chars) {
          if (!chars) {
            return;
          }
          if (!this.chars) {
            this.chars = [];
          }
          var i;
          var len = chars.length;
          var j;
          var jLen = this.chars.length;
          var found;
          for (i = 0; i < len; i += 1) {
            j = 0;
            found = false;
            while (j < jLen) {
              if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
                found = true;
              }
              j += 1;
            }
            if (!found) {
              this.chars.push(chars[i]);
              jLen += 1;
            }
          }
        }
        function getCharData(_char, style, font) {
          var i = 0;
          var len = this.chars.length;
          while (i < len) {
            if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
              return this.chars[i];
            }
            i += 1;
          }
          if ((typeof _char === "string" && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn && !this._warned) {
            this._warned = true;
            console.warn("Missing character from exported characters list: ", _char, style, font);
          }
          return emptyChar;
        }
        function measureText(_char2, fontName, size) {
          var fontData = this.getFontByName(fontName);
          var index2 = _char2;
          if (!fontData.cache[index2]) {
            var tHelper = fontData.helper;
            if (_char2 === " ") {
              var doubleSize = tHelper.measureText("|" + _char2 + "|");
              var singleSize = tHelper.measureText("||");
              fontData.cache[index2] = (doubleSize - singleSize) / 100;
            } else {
              fontData.cache[index2] = tHelper.measureText(_char2) / 100;
            }
          }
          return fontData.cache[index2] * size;
        }
        function getFontByName(name2) {
          var i = 0;
          var len = this.fonts.length;
          while (i < len) {
            if (this.fonts[i].fName === name2) {
              return this.fonts[i];
            }
            i += 1;
          }
          return this.fonts[0];
        }
        function getCodePoint(string) {
          var codePoint = 0;
          var first = string.charCodeAt(0);
          if (first >= 55296 && first <= 56319) {
            var second2 = string.charCodeAt(1);
            if (second2 >= 56320 && second2 <= 57343) {
              codePoint = (first - 55296) * 1024 + second2 - 56320 + 65536;
            }
          }
          return codePoint;
        }
        function isModifier(firstCharCode, secondCharCode) {
          var sum2 = firstCharCode.toString(16) + secondCharCode.toString(16);
          return surrogateModifiers.indexOf(sum2) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
          return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        }
        function isVariationSelector(charCode) {
          return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        }
        function isRegionalCode(string) {
          var codePoint = getCodePoint(string);
          if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
            return true;
          }
          return false;
        }
        function isFlagEmoji(string) {
          return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
          return combinedCharacters.indexOf(_char3) !== -1;
        }
        function isRegionalFlag(text2, index2) {
          var codePoint = getCodePoint(text2.substr(index2, 2));
          if (codePoint !== BLACK_FLAG_CODE_POINT) {
            return false;
          }
          var count = 0;
          index2 += 2;
          while (count < 5) {
            codePoint = getCodePoint(text2.substr(index2, 2));
            if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
              return false;
            }
            count += 1;
            index2 += 2;
          }
          return getCodePoint(text2.substr(index2, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
          this.isLoaded = true;
        }
        var Font = function Font2() {
          this.fonts = [];
          this.chars = null;
          this.typekitLoaded = 0;
          this.isLoaded = false;
          this._warned = false;
          this.initTime = Date.now();
          this.setIsLoadedBinded = this.setIsLoaded.bind(this);
          this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
          addChars,
          addFonts,
          getCharData,
          getFontByName,
          measureText,
          checkLoadedFonts,
          setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
      }();
      function SlotManager(animationData2) {
        this.animationData = animationData2;
      }
      SlotManager.prototype.getProp = function(data2) {
        if (this.animationData.slots && this.animationData.slots[data2.sid]) {
          return Object.assign(data2, this.animationData.slots[data2.sid].p);
        }
        return data2;
      };
      function slotFactory(animationData2) {
        return new SlotManager(animationData2);
      }
      function RenderableElement() {
      }
      RenderableElement.prototype = {
        initRenderable: function initRenderable() {
          this.isInRange = false;
          this.hidden = false;
          this.isTransparent = false;
          this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
          if (this.renderableComponents.indexOf(component) === -1) {
            this.renderableComponents.push(component);
          }
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
          if (this.renderableComponents.indexOf(component) !== -1) {
            this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
          }
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
          this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
          if (this.finalTransform.mProp.o.v <= 0) {
            if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
              this.isTransparent = true;
              this.hide();
            }
          } else if (this.isTransparent) {
            this.isTransparent = false;
            this.show();
          }
        },
        /**
           * @function
           * Initializes frame related properties.
           *
           * @param {number} num
           * current frame number in Layer's time
           *
           */
        checkLayerLimits: function checkLayerLimits(num) {
          if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
            if (this.isInRange !== true) {
              this.globalData._mdf = true;
              this._mdf = true;
              this.isInRange = true;
              this.show();
            }
          } else if (this.isInRange !== false) {
            this.globalData._mdf = true;
            this.isInRange = false;
            this.hide();
          }
        },
        renderRenderable: function renderRenderable() {
          var i;
          var len = this.renderableComponents.length;
          for (i = 0; i < len; i += 1) {
            this.renderableComponents[i].renderFrame(this._isFirstFrame);
          }
        },
        sourceRectAtTime: function sourceRectAtTime2() {
          return {
            top: 0,
            left: 0,
            width: 100,
            height: 100
          };
        },
        getLayerSize: function getLayerSize() {
          if (this.data.ty === 5) {
            return {
              w: this.data.textData.width,
              h: this.data.textData.height
            };
          }
          return {
            w: this.data.width,
            h: this.data.height
          };
        }
      };
      var getBlendMode = /* @__PURE__ */ function() {
        var blendModeEnums = {
          0: "source-over",
          1: "multiply",
          2: "screen",
          3: "overlay",
          4: "darken",
          5: "lighten",
          6: "color-dodge",
          7: "color-burn",
          8: "hard-light",
          9: "soft-light",
          10: "difference",
          11: "exclusion",
          12: "hue",
          13: "saturation",
          14: "color",
          15: "luminosity"
        };
        return function(mode) {
          return blendModeEnums[mode] || "";
        };
      }();
      function SliderEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 0, 0, container);
      }
      function AngleEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 0, 0, container);
      }
      function ColorEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 1, 0, container);
      }
      function PointEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 1, 0, container);
      }
      function LayerIndexEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 0, 0, container);
      }
      function MaskIndexEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 0, 0, container);
      }
      function CheckboxEffect(data2, elem2, container) {
        this.p = PropertyFactory.getProp(elem2, data2.v, 0, 0, container);
      }
      function NoValueEffect() {
        this.p = {};
      }
      function EffectsManager(data2, element) {
        var effects = data2.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for (i = 0; i < len; i += 1) {
          effectItem = new GroupEffect(effects[i], element);
          this.effectElements.push(effectItem);
        }
      }
      function GroupEffect(data2, element) {
        this.init(data2, element);
      }
      extendPrototype([DynamicPropertyContainer], GroupEffect);
      GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
      GroupEffect.prototype.init = function(data2, element) {
        this.data = data2;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for (i = 0; i < len; i += 1) {
          eff = null;
          switch (effects[i].ty) {
            case 0:
              eff = new SliderEffect(effects[i], element, this);
              break;
            case 1:
              eff = new AngleEffect(effects[i], element, this);
              break;
            case 2:
              eff = new ColorEffect(effects[i], element, this);
              break;
            case 3:
              eff = new PointEffect(effects[i], element, this);
              break;
            case 4:
            case 7:
              eff = new CheckboxEffect(effects[i], element, this);
              break;
            case 10:
              eff = new LayerIndexEffect(effects[i], element, this);
              break;
            case 11:
              eff = new MaskIndexEffect(effects[i], element, this);
              break;
            case 5:
              eff = new EffectsManager(effects[i], element);
              break;
            // case 6:
            default:
              eff = new NoValueEffect(effects[i]);
              break;
          }
          if (eff) {
            this.effectElements.push(eff);
          }
        }
      };
      function BaseElement() {
      }
      BaseElement.prototype = {
        checkMasks: function checkMasks() {
          if (!this.data.hasMask) {
            return false;
          }
          var i = 0;
          var len = this.data.masksProperties.length;
          while (i < len) {
            if (this.data.masksProperties[i].mode !== "n" && this.data.masksProperties[i].cl !== false) {
              return true;
            }
            i += 1;
          }
          return false;
        },
        initExpressions: function initExpressions() {
          var expressionsInterfaces2 = getExpressionInterfaces();
          if (!expressionsInterfaces2) {
            return;
          }
          var LayerExpressionInterface2 = expressionsInterfaces2("layer");
          var EffectsExpressionInterface2 = expressionsInterfaces2("effects");
          var ShapeExpressionInterface2 = expressionsInterfaces2("shape");
          var TextExpressionInterface2 = expressionsInterfaces2("text");
          var CompExpressionInterface2 = expressionsInterfaces2("comp");
          this.layerInterface = LayerExpressionInterface2(this);
          if (this.data.hasMask && this.maskManager) {
            this.layerInterface.registerMaskInterface(this.maskManager);
          }
          var effectsInterface = EffectsExpressionInterface2.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(effectsInterface);
          if (this.data.ty === 0 || this.data.xt) {
            this.compInterface = CompExpressionInterface2(this);
          } else if (this.data.ty === 4) {
            this.layerInterface.shapeInterface = ShapeExpressionInterface2(this.shapesData, this.itemsData, this.layerInterface);
            this.layerInterface.content = this.layerInterface.shapeInterface;
          } else if (this.data.ty === 5) {
            this.layerInterface.textInterface = TextExpressionInterface2(this);
            this.layerInterface.text = this.layerInterface.textInterface;
          }
        },
        setBlendMode: function setBlendMode() {
          var blendModeValue = getBlendMode(this.data.bm);
          var elem2 = this.baseElement || this.layerElement;
          elem2.style["mix-blend-mode"] = blendModeValue;
        },
        initBaseData: function initBaseData(data2, globalData2, comp2) {
          this.globalData = globalData2;
          this.comp = comp2;
          this.data = data2;
          this.layerId = createElementID();
          if (!this.data.sr) {
            this.data.sr = 1;
          }
          this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
          return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime2() {
        }
      };
      function FrameElement() {
      }
      FrameElement.prototype = {
        /**
           * @function
           * Initializes frame related properties.
           *
           */
        initFrame: function initFrame2() {
          this._isFirstFrame = false;
          this.dynamicProperties = [];
          this._mdf = false;
        },
        /**
           * @function
           * Calculates all dynamic values
           *
           * @param {number} num
           * current frame number in Layer's time
           * @param {boolean} isVisible
           * if layers is currently in range
           *
           */
        prepareProperties: function prepareProperties(num, isVisible2) {
          var i;
          var len = this.dynamicProperties.length;
          for (i = 0; i < len; i += 1) {
            if (isVisible2 || this._isParent && this.dynamicProperties[i].propType === "transform") {
              this.dynamicProperties[i].getValue();
              if (this.dynamicProperties[i]._mdf) {
                this.globalData._mdf = true;
                this._mdf = true;
              }
            }
          }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
          if (this.dynamicProperties.indexOf(prop) === -1) {
            this.dynamicProperties.push(prop);
          }
        }
      };
      function FootageElement(data2, globalData2, comp2) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData2.getAssetData(data2.refId);
        this.footageData = globalData2.imageLoader.getAsset(this.assetData);
        this.initBaseData(data2, globalData2, comp2);
      }
      FootageElement.prototype.prepareFrame = function() {
      };
      extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);
      FootageElement.prototype.getBaseElement = function() {
        return null;
      };
      FootageElement.prototype.renderFrame = function() {
      };
      FootageElement.prototype.destroy = function() {
      };
      FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces2 = getExpressionInterfaces();
        if (!expressionsInterfaces2) {
          return;
        }
        var FootageInterface2 = expressionsInterfaces2("footage");
        this.layerInterface = FootageInterface2(this);
      };
      FootageElement.prototype.getFootageData = function() {
        return this.footageData;
      };
      function AudioElement(data2, globalData2, comp2) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData2.getAssetData(data2.refId);
        this.initBaseData(data2, globalData2, comp2);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data2.tm ? PropertyFactory.getProp(this, data2.tm, 0, globalData2.frameRate, this) : {
          _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data2.au && data2.au.lv ? data2.au.lv : {
          k: [100]
        }, 1, 0.01, this);
      }
      AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
          var timeRemapped = this.tm.v;
          this._currentTime = timeRemapped;
        } else {
          this._currentTime = num / this.data.sr;
        }
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
          this._previousVolume = totalVolume;
          this.audio.volume(totalVolume);
        }
      };
      extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);
      AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
          if (!this._isPlaying) {
            this.audio.play();
            this.audio.seek(this._currentTime / this.globalData.frameRate);
            this._isPlaying = true;
          } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
            this.audio.seek(this._currentTime / this.globalData.frameRate);
          }
        }
      };
      AudioElement.prototype.show = function() {
      };
      AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
      };
      AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
      };
      AudioElement.prototype.resume = function() {
        this._canPlay = true;
      };
      AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
      };
      AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
      };
      AudioElement.prototype.getBaseElement = function() {
        return null;
      };
      AudioElement.prototype.destroy = function() {
      };
      AudioElement.prototype.sourceRectAtTime = function() {
      };
      AudioElement.prototype.initExpressions = function() {
      };
      function BaseRenderer() {
      }
      BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data2;
        this.completeLayers = true;
        for (i = len - 1; i >= 0; i -= 1) {
          if (!this.elements[i]) {
            data2 = this.layers[i];
            if (data2.ip - data2.st <= num - this.layers[i].st && data2.op - data2.st > num - this.layers[i].st) {
              this.buildItem(i);
            }
          }
          this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
      };
      BaseRenderer.prototype.createItem = function(layer) {
        switch (layer.ty) {
          case 2:
            return this.createImage(layer);
          case 0:
            return this.createComp(layer);
          case 1:
            return this.createSolid(layer);
          case 3:
            return this.createNull(layer);
          case 4:
            return this.createShape(layer);
          case 5:
            return this.createText(layer);
          case 6:
            return this.createAudio(layer);
          case 13:
            return this.createCamera(layer);
          case 15:
            return this.createFootage(layer);
          default:
            return this.createNull(layer);
        }
      };
      BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
      };
      BaseRenderer.prototype.createAudio = function(data2) {
        return new AudioElement(data2, this.globalData, this);
      };
      BaseRenderer.prototype.createFootage = function(data2) {
        return new FootageElement(data2, this.globalData, this);
      };
      BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for (i = 0; i < len; i += 1) {
          this.buildItem(i);
        }
        this.checkPendingElements();
      };
      BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for (i = 0; i < len; i += 1) {
          j = 0;
          while (j < jLen) {
            if (this.layers[j].id === newLayers[i].id) {
              this.layers[j] = newLayers[i];
              break;
            }
            j += 1;
          }
        }
      };
      BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
      };
      BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) {
          this.buildAllItems();
        }
      };
      BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while (i < len) {
          if (layers[i].ind == parentName) {
            if (!elements[i] || elements[i] === true) {
              this.buildItem(i);
              this.addPendingElement(element);
            } else {
              hierarchy.push(elements[i]);
              elements[i].setAsParent();
              if (layers[i].parent !== void 0) {
                this.buildElementParenting(element, layers[i].parent, hierarchy);
              } else {
                element.setHierarchy(hierarchy);
              }
            }
          }
          i += 1;
        }
      };
      BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
      };
      BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for (i = 0; i < len; i += 1) {
          if (assets[i].xt) {
            var comp2 = this.createComp(assets[i]);
            comp2.initExpressions();
            this.globalData.projectInterface.registerComposition(comp2);
          }
        }
      };
      BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for (i = 0; i < len; i += 1) {
          if (this.elements[i].data.ind === ind) {
            return this.elements[i];
          }
        }
        return null;
      };
      BaseRenderer.prototype.getElementByPath = function(path2) {
        var pathValue = path2.shift();
        var element;
        if (typeof pathValue === "number") {
          element = this.elements[pathValue];
        } else {
          var i;
          var len = this.elements.length;
          for (i = 0; i < len; i += 1) {
            if (this.elements[i].data.nm === pathValue) {
              element = this.elements[i];
              break;
            }
          }
        }
        if (path2.length === 0) {
          return element;
        }
        return element.getElementByPath(path2);
      };
      BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
          w: animData.w,
          h: animData.h
        };
      };
      var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
      };
      function TransformElement() {
      }
      TransformElement.prototype = {
        initTransform: function initTransform() {
          var mat = new Matrix();
          this.finalTransform = {
            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
              o: 0
            },
            _matMdf: false,
            _localMatMdf: false,
            _opMdf: false,
            mat,
            localMat: mat,
            localOpacity: 1
          };
          if (this.data.ao) {
            this.finalTransform.mProp.autoOriented = true;
          }
          if (this.data.ty !== 11) ;
        },
        renderTransform: function renderTransform() {
          this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
          this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
          if (this.hierarchy) {
            var mat;
            var finalMat = this.finalTransform.mat;
            var i = 0;
            var len = this.hierarchy.length;
            if (!this.finalTransform._matMdf) {
              while (i < len) {
                if (this.hierarchy[i].finalTransform.mProp._mdf) {
                  this.finalTransform._matMdf = true;
                  break;
                }
                i += 1;
              }
            }
            if (this.finalTransform._matMdf) {
              mat = this.finalTransform.mProp.v.props;
              finalMat.cloneFromProps(mat);
              for (i = 0; i < len; i += 1) {
                finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
              }
            }
          }
          if (this.finalTransform._matMdf) {
            this.finalTransform._localMatMdf = this.finalTransform._matMdf;
          }
          if (this.finalTransform._opMdf) {
            this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
          }
        },
        renderLocalTransform: function renderLocalTransform() {
          if (this.localTransforms) {
            var i = 0;
            var len = this.localTransforms.length;
            this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
              while (i < len) {
                if (this.localTransforms[i]._mdf) {
                  this.finalTransform._localMatMdf = true;
                }
                if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                  this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                  this.finalTransform._opMdf = true;
                }
                i += 1;
              }
            }
            if (this.finalTransform._localMatMdf) {
              var localMat = this.finalTransform.localMat;
              this.localTransforms[0].matrix.clone(localMat);
              for (i = 1; i < len; i += 1) {
                var lmat = this.localTransforms[i].matrix;
                localMat.multiply(lmat);
              }
              localMat.multiply(this.finalTransform.mat);
            }
            if (this.finalTransform._opMdf) {
              var localOp = this.finalTransform.localOpacity;
              for (i = 0; i < len; i += 1) {
                localOp *= this.localTransforms[i].opacity * 0.01;
              }
              this.finalTransform.localOpacity = localOp;
            }
          }
        },
        searchEffectTransforms: function searchEffectTransforms() {
          if (this.renderableEffectsManager) {
            var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            if (transformEffects.length) {
              this.localTransforms = [];
              this.finalTransform.localMat = new Matrix();
              var i = 0;
              var len = transformEffects.length;
              for (i = 0; i < len; i += 1) {
                this.localTransforms.push(transformEffects[i]);
              }
            }
          }
        },
        globalToLocal: function globalToLocal(pt) {
          var transforms = [];
          transforms.push(this.finalTransform);
          var flag = true;
          var comp2 = this.comp;
          while (flag) {
            if (comp2.finalTransform) {
              if (comp2.data.hasMask) {
                transforms.splice(0, 0, comp2.finalTransform);
              }
              comp2 = comp2.comp;
            } else {
              flag = false;
            }
          }
          var i;
          var len = transforms.length;
          var ptNew;
          for (i = 0; i < len; i += 1) {
            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
            pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
          }
          return pt;
        },
        mHelper: new Matrix()
      };
      function MaskElement(data2, element, globalData2) {
        this.data = data2;
        this.element = element;
        this.globalData = globalData2;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = "";
        var path2;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x2;
        var maskType = "clipPath";
        var maskRef = "clip-path";
        for (i = 0; i < len; i += 1) {
          if (properties[i].mode !== "a" && properties[i].mode !== "n" || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
            maskType = "mask";
            maskRef = "mask";
          }
          if ((properties[i].mode === "s" || properties[i].mode === "i") && count === 0) {
            rect = createNS("rect");
            rect.setAttribute("fill", "#ffffff");
            rect.setAttribute("width", this.element.comp.data.w || 0);
            rect.setAttribute("height", this.element.comp.data.h || 0);
            currentMasks.push(rect);
          } else {
            rect = null;
          }
          path2 = createNS("path");
          if (properties[i].mode === "n") {
            this.viewData[i] = {
              op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
              prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
              elem: path2,
              lastPath: ""
            };
            defs.appendChild(path2);
          } else {
            count += 1;
            path2.setAttribute("fill", properties[i].mode === "s" ? "#000000" : "#ffffff");
            path2.setAttribute("clip-rule", "nonzero");
            var filterID;
            if (properties[i].x.k !== 0) {
              maskType = "mask";
              maskRef = "mask";
              x2 = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
              filterID = createElementID();
              expansor = createNS("filter");
              expansor.setAttribute("id", filterID);
              feMorph = createNS("feMorphology");
              feMorph.setAttribute("operator", "erode");
              feMorph.setAttribute("in", "SourceGraphic");
              feMorph.setAttribute("radius", "0");
              expansor.appendChild(feMorph);
              defs.appendChild(expansor);
              path2.setAttribute("stroke", properties[i].mode === "s" ? "#000000" : "#ffffff");
            } else {
              feMorph = null;
              x2 = null;
            }
            this.storedData[i] = {
              elem: path2,
              x: x2,
              expan: feMorph,
              lastPath: "",
              lastOperator: "",
              filterId: filterID,
              lastRadius: 0
            };
            if (properties[i].mode === "i") {
              jLen = currentMasks.length;
              var g = createNS("g");
              for (j = 0; j < jLen; j += 1) {
                g.appendChild(currentMasks[j]);
              }
              var mask2 = createNS("mask");
              mask2.setAttribute("mask-type", "alpha");
              mask2.setAttribute("id", layerId + "_" + count);
              mask2.appendChild(path2);
              defs.appendChild(mask2);
              g.setAttribute("mask", "url(" + getLocationHref() + "#" + layerId + "_" + count + ")");
              currentMasks.length = 0;
              currentMasks.push(g);
            } else {
              currentMasks.push(path2);
            }
            if (properties[i].inv && !this.solidPath) {
              this.solidPath = this.createLayerSolidPath();
            }
            this.viewData[i] = {
              elem: path2,
              lastPath: "",
              op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
              prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
              invRect: rect
            };
            if (!this.viewData[i].prop.k) {
              this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
          }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for (i = 0; i < len; i += 1) {
          this.maskElement.appendChild(currentMasks[i]);
        }
        if (count > 0) {
          this.maskElement.setAttribute("id", layerId);
          this.element.maskedElement.setAttribute(maskRef, "url(" + getLocationHref() + "#" + layerId + ")");
          defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) {
          this.element.addRenderableComponent(this);
        }
      }
      MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
      };
      MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for (i = 0; i < len; i += 1) {
          if (this.viewData[i].prop._mdf || isFirstFrame) {
            this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
          }
          if (this.viewData[i].op._mdf || isFirstFrame) {
            this.viewData[i].elem.setAttribute("fill-opacity", this.viewData[i].op.v);
          }
          if (this.masksProperties[i].mode !== "n") {
            if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
              this.viewData[i].invRect.setAttribute("transform", finalMat.getInverseMatrix().to2dCSS());
            }
            if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
              var feMorph = this.storedData[i].expan;
              if (this.storedData[i].x.v < 0) {
                if (this.storedData[i].lastOperator !== "erode") {
                  this.storedData[i].lastOperator = "erode";
                  this.storedData[i].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i].filterId + ")");
                }
                feMorph.setAttribute("radius", -this.storedData[i].x.v);
              } else {
                if (this.storedData[i].lastOperator !== "dilate") {
                  this.storedData[i].lastOperator = "dilate";
                  this.storedData[i].elem.setAttribute("filter", null);
                }
                this.storedData[i].elem.setAttribute("stroke-width", this.storedData[i].x.v * 2);
              }
            }
          }
        }
      };
      MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
      };
      MaskElement.prototype.createLayerSolidPath = function() {
        var path2 = "M0,0 ";
        path2 += " h" + this.globalData.compSize.w;
        path2 += " v" + this.globalData.compSize.h;
        path2 += " h-" + this.globalData.compSize.w;
        path2 += " v-" + this.globalData.compSize.h + " ";
        return path2;
      };
      MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = " M" + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for (i = 1; i < len; i += 1) {
          pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[i][0] + "," + pathNodes.i[i][1] + " " + pathNodes.v[i][0] + "," + pathNodes.v[i][1];
        }
        if (pathNodes.c && len > 1) {
          pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[0][0] + "," + pathNodes.i[0][1] + " " + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
        }
        if (viewData.lastPath !== pathString) {
          var pathShapeValue = "";
          if (viewData.elem) {
            if (pathNodes.c) {
              pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
            }
            viewData.elem.setAttribute("d", pathShapeValue);
          }
          viewData.lastPath = pathString;
        }
      };
      MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
      };
      var filtersFactory = function() {
        var ob2 = {};
        ob2.createFilter = createFilter;
        ob2.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
          var fil = createNS("filter");
          fil.setAttribute("id", filId);
          if (skipCoordinates !== true) {
            fil.setAttribute("filterUnits", "objectBoundingBox");
            fil.setAttribute("x", "0%");
            fil.setAttribute("y", "0%");
            fil.setAttribute("width", "100%");
            fil.setAttribute("height", "100%");
          }
          return fil;
        }
        function createAlphaToLuminanceFilter() {
          var feColorMatrix = createNS("feColorMatrix");
          feColorMatrix.setAttribute("type", "matrix");
          feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
          feColorMatrix.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1");
          return feColorMatrix;
        }
        return ob2;
      }();
      var featureSupport = function() {
        var ob2 = {
          maskType: true,
          svgLumaHidden: true,
          offscreenCanvas: typeof OffscreenCanvas !== "undefined"
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
          ob2.maskType = false;
        }
        if (/firefox/i.test(navigator.userAgent)) {
          ob2.svgLumaHidden = false;
        }
        return ob2;
      }();
      var registeredEffects$1 = {};
      var idPrefix = "filter_result_";
      function SVGEffects(elem2) {
        var i;
        var source = "SourceGraphic";
        var len = elem2.data.ef ? elem2.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for (i = 0; i < len; i += 1) {
          filterManager = null;
          var type = elem2.data.ef[i].ty;
          if (registeredEffects$1[type]) {
            var Effect = registeredEffects$1[type].effect;
            filterManager = new Effect(fil, elem2.effectsManager.effectElements[i], elem2, idPrefix + count, source);
            source = idPrefix + count;
            if (registeredEffects$1[type].countsAsEffect) {
              count += 1;
            }
          }
          if (filterManager) {
            this.filters.push(filterManager);
          }
        }
        if (count) {
          elem2.globalData.defs.appendChild(fil);
          elem2.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
        }
        if (this.filters.length) {
          elem2.addRenderableComponent(this);
        }
      }
      SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for (i = 0; i < len; i += 1) {
          this.filters[i].renderFrame(_isFirstFrame);
        }
      };
      SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for (i = 0; i < len; i += 1) {
          if (this.filters[i].type === type) {
            effects.push(this.filters[i]);
          }
        }
        return effects;
      };
      function registerEffect$1(id, effect2, countsAsEffect) {
        registeredEffects$1[id] = {
          effect: effect2,
          countsAsEffect
        };
      }
      function SVGBaseElement() {
      }
      SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
          this.layerElement = createNS("g");
        },
        createContainerElements: function createContainerElements() {
          this.matteElement = createNS("g");
          this.transformedElement = this.layerElement;
          this.maskedElement = this.layerElement;
          this._sizeChanged = false;
          var layerElementParent = null;
          if (this.data.td) {
            this.matteMasks = {};
            var gg = createNS("g");
            gg.setAttribute("id", this.layerId);
            gg.appendChild(this.layerElement);
            layerElementParent = gg;
            this.globalData.defs.appendChild(gg);
          } else if (this.data.tt) {
            this.matteElement.appendChild(this.layerElement);
            layerElementParent = this.matteElement;
            this.baseElement = this.matteElement;
          } else {
            this.baseElement = this.layerElement;
          }
          if (this.data.ln) {
            this.layerElement.setAttribute("id", this.data.ln);
          }
          if (this.data.cl) {
            this.layerElement.setAttribute("class", this.data.cl);
          }
          if (this.data.ty === 0 && !this.data.hd) {
            var cp = createNS("clipPath");
            var pt = createNS("path");
            pt.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
            var clipId = createElementID();
            cp.setAttribute("id", clipId);
            cp.appendChild(pt);
            this.globalData.defs.appendChild(cp);
            if (this.checkMasks()) {
              var cpGroup = createNS("g");
              cpGroup.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
              cpGroup.appendChild(this.layerElement);
              this.transformedElement = cpGroup;
              if (layerElementParent) {
                layerElementParent.appendChild(this.transformedElement);
              } else {
                this.baseElement = this.transformedElement;
              }
            } else {
              this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
            }
          }
          if (this.data.bm !== 0) {
            this.setBlendMode();
          }
        },
        renderElement: function renderElement() {
          if (this.finalTransform._localMatMdf) {
            this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS());
          }
          if (this.finalTransform._opMdf) {
            this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
          }
        },
        destroyBaseElement: function destroyBaseElement() {
          this.layerElement = null;
          this.matteElement = null;
          this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
          if (this.data.hd) {
            return null;
          }
          return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
          this.maskManager = new MaskElement(this.data, this, this.globalData);
          this.renderableEffectsManager = new SVGEffects(this);
          this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
          if (!this.matteMasks) {
            this.matteMasks = {};
          }
          if (!this.matteMasks[matteType]) {
            var id = this.layerId + "_" + matteType;
            var filId;
            var fil;
            var useElement;
            var gg;
            if (matteType === 1 || matteType === 3) {
              var masker = createNS("mask");
              masker.setAttribute("id", id);
              masker.setAttribute("mask-type", matteType === 3 ? "luminance" : "alpha");
              useElement = createNS("use");
              useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
              masker.appendChild(useElement);
              this.globalData.defs.appendChild(masker);
              if (!featureSupport.maskType && matteType === 1) {
                masker.setAttribute("mask-type", "luminance");
                filId = createElementID();
                fil = filtersFactory.createFilter(filId);
                this.globalData.defs.appendChild(fil);
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                gg = createNS("g");
                gg.appendChild(useElement);
                masker.appendChild(gg);
                gg.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
              }
            } else if (matteType === 2) {
              var maskGroup = createNS("mask");
              maskGroup.setAttribute("id", id);
              maskGroup.setAttribute("mask-type", "alpha");
              var maskGrouper = createNS("g");
              maskGroup.appendChild(maskGrouper);
              filId = createElementID();
              fil = filtersFactory.createFilter(filId);
              var feCTr = createNS("feComponentTransfer");
              feCTr.setAttribute("in", "SourceGraphic");
              fil.appendChild(feCTr);
              var feFunc = createNS("feFuncA");
              feFunc.setAttribute("type", "table");
              feFunc.setAttribute("tableValues", "1.0 0.0");
              feCTr.appendChild(feFunc);
              this.globalData.defs.appendChild(fil);
              var alphaRect = createNS("rect");
              alphaRect.setAttribute("width", this.comp.data.w);
              alphaRect.setAttribute("height", this.comp.data.h);
              alphaRect.setAttribute("x", "0");
              alphaRect.setAttribute("y", "0");
              alphaRect.setAttribute("fill", "#ffffff");
              alphaRect.setAttribute("opacity", "0");
              maskGrouper.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
              maskGrouper.appendChild(alphaRect);
              useElement = createNS("use");
              useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
              maskGrouper.appendChild(useElement);
              if (!featureSupport.maskType) {
                maskGroup.setAttribute("mask-type", "luminance");
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                gg = createNS("g");
                maskGrouper.appendChild(alphaRect);
                gg.appendChild(this.layerElement);
                maskGrouper.appendChild(gg);
              }
              this.globalData.defs.appendChild(maskGroup);
            }
            this.matteMasks[matteType] = id;
          }
          return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
          if (!this.matteElement) {
            return;
          }
          this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
        }
      };
      function HierarchyElement() {
      }
      HierarchyElement.prototype = {
        /**
           * @function
           * Initializes hierarchy properties
           *
           */
        initHierarchy: function initHierarchy() {
          this.hierarchy = [];
          this._isParent = false;
          this.checkParenting();
        },
        /**
           * @function
           * Sets layer's hierarchy.
           * @param {array} hierarch
           * layer's parent list
           *
           */
        setHierarchy: function setHierarchy(hierarchy) {
          this.hierarchy = hierarchy;
        },
        /**
           * @function
           * Sets layer as parent.
           *
           */
        setAsParent: function setAsParent() {
          this._isParent = true;
        },
        /**
           * @function
           * Searches layer's parenting chain
           *
           */
        checkParenting: function checkParenting() {
          if (this.data.parent !== void 0) {
            this.comp.buildElementParenting(this, this.data.parent, []);
          }
        }
      };
      function RenderableDOMElement() {
      }
      (function() {
        var _prototype = {
          initElement: function initElement(data2, globalData2, comp2) {
            this.initFrame();
            this.initBaseData(data2, globalData2, comp2);
            this.initTransform(data2, globalData2, comp2);
            this.initHierarchy();
            this.initRenderable();
            this.initRendererElement();
            this.createContainerElements();
            this.createRenderableComponents();
            this.createContent();
            this.hide();
          },
          hide: function hide() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
              var elem2 = this.baseElement || this.layerElement;
              elem2.style.display = "none";
              this.hidden = true;
            }
          },
          show: function show() {
            if (this.isInRange && !this.isTransparent) {
              if (!this.data.hd) {
                var elem2 = this.baseElement || this.layerElement;
                elem2.style.display = "block";
              }
              this.hidden = false;
              this._isFirstFrame = true;
            }
          },
          renderFrame: function renderFrame() {
            if (this.data.hd || this.hidden) {
              return;
            }
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) {
              this._isFirstFrame = false;
            }
          },
          renderInnerContent: function renderInnerContent() {
          },
          prepareFrame: function prepareFrame(num) {
            this._mdf = false;
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
            this.checkTransparency();
          },
          destroy: function destroy() {
            this.innerElem = null;
            this.destroyBaseElement();
          }
        };
        extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
      })();
      function IImageElement(data2, globalData2, comp2) {
        this.assetData = globalData2.getAssetData(data2.refId);
        if (this.assetData && this.assetData.sid) {
          this.assetData = globalData2.slotManager.getProp(this.assetData);
        }
        this.initElement(data2, globalData2, comp2);
        this.sourceRect = {
          top: 0,
          left: 0,
          width: this.assetData.w,
          height: this.assetData.h
        };
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);
      IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image");
        this.innerElem.setAttribute("width", this.assetData.w + "px");
        this.innerElem.setAttribute("height", this.assetData.h + "px");
        this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
        this.layerElement.appendChild(this.innerElem);
      };
      IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
      };
      function ProcessedElement(element, position2) {
        this.elem = element;
        this.pos = position2;
      }
      function IShapeElement() {
      }
      IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data2) {
          var i;
          var len = this.shapeModifiers.length;
          for (i = 0; i < len; i += 1) {
            this.shapeModifiers[i].addShape(data2);
          }
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data2) {
          var i = 0;
          var len = this.shapeModifiers.length;
          while (i < len) {
            if (this.shapeModifiers[i].isAnimatedWithShape(data2)) {
              return true;
            }
          }
          return false;
        },
        renderModifiers: function renderModifiers() {
          if (!this.shapeModifiers.length) {
            return;
          }
          var i;
          var len = this.shapes.length;
          for (i = 0; i < len; i += 1) {
            this.shapes[i].sh.reset();
          }
          len = this.shapeModifiers.length;
          var shouldBreakProcess;
          for (i = len - 1; i >= 0; i -= 1) {
            shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
            if (shouldBreakProcess) {
              break;
            }
          }
        },
        searchProcessedElement: function searchProcessedElement(elem2) {
          var elements = this.processedElements;
          var i = 0;
          var len = elements.length;
          while (i < len) {
            if (elements[i].elem === elem2) {
              return elements[i].pos;
            }
            i += 1;
          }
          return 0;
        },
        addProcessedElement: function addProcessedElement(elem2, pos) {
          var elements = this.processedElements;
          var i = elements.length;
          while (i) {
            i -= 1;
            if (elements[i].elem === elem2) {
              elements[i].pos = pos;
              return;
            }
          }
          elements.push(new ProcessedElement(elem2, pos));
        },
        prepareFrame: function prepareFrame(num) {
          this.prepareRenderableFrame(num);
          this.prepareProperties(num, this.isInRange);
        }
      };
      var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
      };
      var lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
      };
      function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = "";
        this.sh = shape;
        this.lvl = level;
        this._isAnimated = !!shape.k;
        var i = 0;
        var len = transformers.length;
        while (i < len) {
          if (transformers[i].mProps.dynamicProperties.length) {
            this._isAnimated = true;
            break;
          }
          i += 1;
        }
      }
      SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
      };
      function SVGStyleData(data2, level) {
        this.data = data2;
        this.type = data2.ty;
        this.d = "";
        this.lvl = level;
        this._mdf = false;
        this.closed = data2.hd === true;
        this.pElem = createNS("path");
        this.msElem = null;
      }
      SVGStyleData.prototype.reset = function() {
        this.d = "";
        this._mdf = false;
      };
      function DashProperty(elem2, data2, renderer2, container) {
        this.elem = elem2;
        this.frameId = -1;
        this.dataProps = createSizedArray(data2.length);
        this.renderer = renderer2;
        this.k = false;
        this.dashStr = "";
        this.dashArray = createTypedArray("float32", data2.length ? data2.length - 1 : 0);
        this.dashoffset = createTypedArray("float32", 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data2.length || 0;
        var prop;
        for (i = 0; i < len; i += 1) {
          prop = PropertyFactory.getProp(elem2, data2[i].v, 0, 0, this);
          this.k = prop.k || this.k;
          this.dataProps[i] = {
            n: data2[i].n,
            p: prop
          };
        }
        if (!this.k) {
          this.getValue(true);
        }
        this._isAnimated = this.k;
      }
      DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
          var i = 0;
          var len = this.dataProps.length;
          if (this.renderer === "svg") {
            this.dashStr = "";
          }
          for (i = 0; i < len; i += 1) {
            if (this.dataProps[i].n !== "o") {
              if (this.renderer === "svg") {
                this.dashStr += " " + this.dataProps[i].p.v;
              } else {
                this.dashArray[i] = this.dataProps[i].p.v;
              }
            } else {
              this.dashoffset[0] = this.dataProps[i].p.v;
            }
          }
        }
      };
      extendPrototype([DynamicPropertyContainer], DashProperty);
      function SVGStrokeStyleData(elem2, data2, styleOb) {
        this.initDynamicPropertyContainer(elem2);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem2, data2.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem2, data2.w, 0, null, this);
        this.d = new DashProperty(elem2, data2.d || {}, "svg", this);
        this.c = PropertyFactory.getProp(elem2, data2.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
      }
      extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
      function SVGFillStyleData(elem2, data2, styleOb) {
        this.initDynamicPropertyContainer(elem2);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem2, data2.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem2, data2.c, 1, 255, this);
        this.style = styleOb;
      }
      extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
      function SVGNoStyleData(elem2, data2, styleOb) {
        this.initDynamicPropertyContainer(elem2);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
      }
      extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
      function GradientProperty(elem2, data2, container) {
        this.data = data2;
        this.c = createTypedArray("uint8c", data2.p * 4);
        var cLength = data2.k.k[0].s ? data2.k.k[0].s.length - data2.p * 4 : data2.k.k.length - data2.p * 4;
        this.o = createTypedArray("float32", cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem2, data2.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
      }
      GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while (i < len) {
          diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
          if (diff > 0.01) {
            return false;
          }
          i += 1;
        }
        return true;
      };
      GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) {
          return false;
        }
        if (this.data.k.k[0].s) {
          var i = 0;
          var len = this.data.k.k.length;
          while (i < len) {
            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
              return false;
            }
            i += 1;
          }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
          return false;
        }
        return true;
      };
      GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
          var i;
          var len = this.data.p * 4;
          var mult;
          var val2;
          for (i = 0; i < len; i += 1) {
            mult = i % 4 === 0 ? 100 : 255;
            val2 = Math.round(this.prop.v[i] * mult);
            if (this.c[i] !== val2) {
              this.c[i] = val2;
              this._cmdf = !forceRender;
            }
          }
          if (this.o.length) {
            len = this.prop.v.length;
            for (i = this.data.p * 4; i < len; i += 1) {
              mult = i % 2 === 0 ? 100 : 1;
              val2 = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
              if (this.o[i - this.data.p * 4] !== val2) {
                this.o[i - this.data.p * 4] = val2;
                this._omdf = !forceRender;
              }
            }
          }
          this._mdf = !forceRender;
        }
      };
      extendPrototype([DynamicPropertyContainer], GradientProperty);
      function SVGGradientFillStyleData(elem2, data2, styleOb) {
        this.initDynamicPropertyContainer(elem2);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem2, data2, styleOb);
      }
      SVGGradientFillStyleData.prototype.initGradientData = function(elem2, data2, styleOb) {
        this.o = PropertyFactory.getProp(elem2, data2.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem2, data2.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem2, data2.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem2, data2.h || {
          k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem2, data2.a || {
          k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem2, data2.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data2);
        this.setGradientOpacity(data2, styleOb);
        this._isAnimated = !!this._isAnimated;
      };
      SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data2) {
        var gradientId = createElementID();
        var gfill = createNS(data2.t === 1 ? "linearGradient" : "radialGradient");
        gfill.setAttribute("id", gradientId);
        gfill.setAttribute("spreadMethod", "pad");
        gfill.setAttribute("gradientUnits", "userSpaceOnUse");
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data2.g.p * 4;
        for (j = 0; j < jLen; j += 4) {
          stop = createNS("stop");
          gfill.appendChild(stop);
          stops.push(stop);
        }
        pathElement.setAttribute(data2.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + gradientId + ")");
        this.gf = gfill;
        this.cst = stops;
      };
      SVGGradientFillStyleData.prototype.setGradientOpacity = function(data2, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
          var stop;
          var j;
          var jLen;
          var mask2 = createNS("mask");
          var maskElement = createNS("path");
          mask2.appendChild(maskElement);
          var opacityId = createElementID();
          var maskId = createElementID();
          mask2.setAttribute("id", maskId);
          var opFill = createNS(data2.t === 1 ? "linearGradient" : "radialGradient");
          opFill.setAttribute("id", opacityId);
          opFill.setAttribute("spreadMethod", "pad");
          opFill.setAttribute("gradientUnits", "userSpaceOnUse");
          jLen = data2.g.k.k[0].s ? data2.g.k.k[0].s.length : data2.g.k.k.length;
          var stops = this.stops;
          for (j = data2.g.p * 4; j < jLen; j += 2) {
            stop = createNS("stop");
            stop.setAttribute("stop-color", "rgb(255,255,255)");
            opFill.appendChild(stop);
            stops.push(stop);
          }
          maskElement.setAttribute(data2.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + opacityId + ")");
          if (data2.ty === "gs") {
            maskElement.setAttribute("stroke-linecap", lineCapEnum[data2.lc || 2]);
            maskElement.setAttribute("stroke-linejoin", lineJoinEnum[data2.lj || 2]);
            if (data2.lj === 1) {
              maskElement.setAttribute("stroke-miterlimit", data2.ml);
            }
          }
          this.of = opFill;
          this.ms = mask2;
          this.ost = stops;
          this.maskId = maskId;
          styleOb.msElem = maskElement;
        }
      };
      extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
      function SVGGradientStrokeStyleData(elem2, data2, styleOb) {
        this.initDynamicPropertyContainer(elem2);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem2, data2.w, 0, null, this);
        this.d = new DashProperty(elem2, data2.d || {}, "svg", this);
        this.initGradientData(elem2, data2, styleOb);
        this._isAnimated = !!this._isAnimated;
      }
      extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
      function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS("g");
      }
      function SVGTransformData(mProps, op, container) {
        this.transform = {
          mProps,
          op,
          container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
      }
      var buildShapeString = function buildShapeString2(pathNodes, length2, closed, mat) {
        if (length2 === 0) {
          return "";
        }
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for (i = 1; i < length2; i += 1) {
          shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        }
        if (closed && length2) {
          shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
          shapeString += "z";
        }
        return shapeString;
      };
      var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob2 = {
          createRenderFunction
        };
        function createRenderFunction(data2) {
          switch (data2.ty) {
            case "fl":
              return renderFill;
            case "gf":
              return renderGradient;
            case "gs":
              return renderGradientStroke;
            case "st":
              return renderStroke;
            case "sh":
            case "el":
            case "rc":
            case "sr":
              return renderPath;
            case "tr":
              return renderContentTransform;
            case "no":
              return renderNoop;
            default:
              return null;
          }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
          if (isFirstFrame || itemData.transform.op._mdf) {
            itemData.transform.container.setAttribute("opacity", itemData.transform.op.v);
          }
          if (isFirstFrame || itemData.transform.mProps._mdf) {
            itemData.transform.container.setAttribute("transform", itemData.transform.mProps.v.to2dCSS());
          }
        }
        function renderNoop() {
        }
        function renderPath(styleData, itemData, isFirstFrame) {
          var j;
          var jLen;
          var pathStringTransformed;
          var redraw;
          var pathNodes;
          var l;
          var lLen = itemData.styles.length;
          var lvl = itemData.lvl;
          var paths;
          var mat;
          var iterations;
          var k2;
          for (l = 0; l < lLen; l += 1) {
            redraw = itemData.sh._mdf || isFirstFrame;
            if (itemData.styles[l].lvl < lvl) {
              mat = _matrixHelper.reset();
              iterations = lvl - itemData.styles[l].lvl;
              k2 = itemData.transformers.length - 1;
              while (!redraw && iterations > 0) {
                redraw = itemData.transformers[k2].mProps._mdf || redraw;
                iterations -= 1;
                k2 -= 1;
              }
              if (redraw) {
                iterations = lvl - itemData.styles[l].lvl;
                k2 = itemData.transformers.length - 1;
                while (iterations > 0) {
                  mat.multiply(itemData.transformers[k2].mProps.v);
                  iterations -= 1;
                  k2 -= 1;
                }
              }
            } else {
              mat = _identityMatrix;
            }
            paths = itemData.sh.paths;
            jLen = paths._length;
            if (redraw) {
              pathStringTransformed = "";
              for (j = 0; j < jLen; j += 1) {
                pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes._length) {
                  pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                }
              }
              itemData.caches[l] = pathStringTransformed;
            } else {
              pathStringTransformed = itemData.caches[l];
            }
            itemData.styles[l].d += styleData.hd === true ? "" : pathStringTransformed;
            itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
          }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
          var styleElem = itemData.style;
          if (itemData.c._mdf || isFirstFrame) {
            styleElem.pElem.setAttribute("fill", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
          }
          if (itemData.o._mdf || isFirstFrame) {
            styleElem.pElem.setAttribute("fill-opacity", itemData.o.v);
          }
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
          renderGradient(styleData, itemData, isFirstFrame);
          renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
          var gfill = itemData.gf;
          var hasOpacity = itemData.g._hasOpacity;
          var pt1 = itemData.s.v;
          var pt2 = itemData.e.v;
          if (itemData.o._mdf || isFirstFrame) {
            var attr = styleData.ty === "gf" ? "fill-opacity" : "stroke-opacity";
            itemData.style.pElem.setAttribute(attr, itemData.o.v);
          }
          if (itemData.s._mdf || isFirstFrame) {
            var attr1 = styleData.t === 1 ? "x1" : "cx";
            var attr2 = attr1 === "x1" ? "y1" : "cy";
            gfill.setAttribute(attr1, pt1[0]);
            gfill.setAttribute(attr2, pt1[1]);
            if (hasOpacity && !itemData.g._collapsable) {
              itemData.of.setAttribute(attr1, pt1[0]);
              itemData.of.setAttribute(attr2, pt1[1]);
            }
          }
          var stops;
          var i;
          var len;
          var stop;
          if (itemData.g._cmdf || isFirstFrame) {
            stops = itemData.cst;
            var cValues = itemData.g.c;
            len = stops.length;
            for (i = 0; i < len; i += 1) {
              stop = stops[i];
              stop.setAttribute("offset", cValues[i * 4] + "%");
              stop.setAttribute("stop-color", "rgb(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + ")");
            }
          }
          if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
            var oValues = itemData.g.o;
            if (itemData.g._collapsable) {
              stops = itemData.cst;
            } else {
              stops = itemData.ost;
            }
            len = stops.length;
            for (i = 0; i < len; i += 1) {
              stop = stops[i];
              if (!itemData.g._collapsable) {
                stop.setAttribute("offset", oValues[i * 2] + "%");
              }
              stop.setAttribute("stop-opacity", oValues[i * 2 + 1]);
            }
          }
          if (styleData.t === 1) {
            if (itemData.e._mdf || isFirstFrame) {
              gfill.setAttribute("x2", pt2[0]);
              gfill.setAttribute("y2", pt2[1]);
              if (hasOpacity && !itemData.g._collapsable) {
                itemData.of.setAttribute("x2", pt2[0]);
                itemData.of.setAttribute("y2", pt2[1]);
              }
            }
          } else {
            var rad;
            if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
              rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
              gfill.setAttribute("r", rad);
              if (hasOpacity && !itemData.g._collapsable) {
                itemData.of.setAttribute("r", rad);
              }
            }
            if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
              if (!rad) {
                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
              }
              var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
              var percent = itemData.h.v;
              if (percent >= 1) {
                percent = 0.99;
              } else if (percent <= -1) {
                percent = -0.99;
              }
              var dist = rad * percent;
              var x2 = Math.cos(ang + itemData.a.v) * dist + pt1[0];
              var y2 = Math.sin(ang + itemData.a.v) * dist + pt1[1];
              gfill.setAttribute("fx", x2);
              gfill.setAttribute("fy", y2);
              if (hasOpacity && !itemData.g._collapsable) {
                itemData.of.setAttribute("fx", x2);
                itemData.of.setAttribute("fy", y2);
              }
            }
          }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
          var styleElem = itemData.style;
          var d = itemData.d;
          if (d && (d._mdf || isFirstFrame) && d.dashStr) {
            styleElem.pElem.setAttribute("stroke-dasharray", d.dashStr);
            styleElem.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0]);
          }
          if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
            styleElem.pElem.setAttribute("stroke", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
          }
          if (itemData.o._mdf || isFirstFrame) {
            styleElem.pElem.setAttribute("stroke-opacity", itemData.o.v);
          }
          if (itemData.w._mdf || isFirstFrame) {
            styleElem.pElem.setAttribute("stroke-width", itemData.w.v);
            if (styleElem.msElem) {
              styleElem.msElem.setAttribute("stroke-width", itemData.w.v);
            }
          }
        }
        return ob2;
      }();
      function SVGShapeElement(data2, globalData2, comp2) {
        this.shapes = [];
        this.shapesData = data2.shapes;
        this.stylesList = [];
        this.shapeModifiers = [];
        this.itemsData = [];
        this.processedElements = [];
        this.animatedContents = [];
        this.initElement(data2, globalData2, comp2);
        this.prevViewData = [];
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);
      SVGShapeElement.prototype.initSecondaryElement = function() {
      };
      SVGShapeElement.prototype.identityMatrix = new Matrix();
      SVGShapeElement.prototype.buildExpressionInterface = function() {
      };
      SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
      };
      SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for (j = 0; j < jLen; j += 1) {
          style = this.stylesList[j];
          areAnimated = false;
          tempShapes.length = 0;
          for (i = 0; i < len; i += 1) {
            shape = this.shapes[i];
            if (shape.styles.indexOf(style) !== -1) {
              tempShapes.push(shape);
              areAnimated = shape._isAnimated || areAnimated;
            }
          }
          if (tempShapes.length > 1 && areAnimated) {
            this.setShapesAsAnimated(tempShapes);
          }
        }
      };
      SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for (i = 0; i < len; i += 1) {
          shapes[i].setAsAnimated();
        }
      };
      SVGShapeElement.prototype.createStyleElement = function(data2, level) {
        var elementData;
        var styleOb = new SVGStyleData(data2, level);
        var pathElement = styleOb.pElem;
        if (data2.ty === "st") {
          elementData = new SVGStrokeStyleData(this, data2, styleOb);
        } else if (data2.ty === "fl") {
          elementData = new SVGFillStyleData(this, data2, styleOb);
        } else if (data2.ty === "gf" || data2.ty === "gs") {
          var GradientConstructor = data2.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
          elementData = new GradientConstructor(this, data2, styleOb);
          this.globalData.defs.appendChild(elementData.gf);
          if (elementData.maskId) {
            this.globalData.defs.appendChild(elementData.ms);
            this.globalData.defs.appendChild(elementData.of);
            pathElement.setAttribute("mask", "url(" + getLocationHref() + "#" + elementData.maskId + ")");
          }
        } else if (data2.ty === "no") {
          elementData = new SVGNoStyleData(this, data2, styleOb);
        }
        if (data2.ty === "st" || data2.ty === "gs") {
          pathElement.setAttribute("stroke-linecap", lineCapEnum[data2.lc || 2]);
          pathElement.setAttribute("stroke-linejoin", lineJoinEnum[data2.lj || 2]);
          pathElement.setAttribute("fill-opacity", "0");
          if (data2.lj === 1) {
            pathElement.setAttribute("stroke-miterlimit", data2.ml);
          }
        }
        if (data2.r === 2) {
          pathElement.setAttribute("fill-rule", "evenodd");
        }
        if (data2.ln) {
          pathElement.setAttribute("id", data2.ln);
        }
        if (data2.cl) {
          pathElement.setAttribute("class", data2.cl);
        }
        if (data2.bm) {
          pathElement.style["mix-blend-mode"] = getBlendMode(data2.bm);
        }
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data2, elementData);
        return elementData;
      };
      SVGShapeElement.prototype.createGroupElement = function(data2) {
        var elementData = new ShapeGroupData();
        if (data2.ln) {
          elementData.gr.setAttribute("id", data2.ln);
        }
        if (data2.cl) {
          elementData.gr.setAttribute("class", data2.cl);
        }
        if (data2.bm) {
          elementData.gr.style["mix-blend-mode"] = getBlendMode(data2.bm);
        }
        return elementData;
      };
      SVGShapeElement.prototype.createTransformElement = function(data2, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data2, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data2, elementData);
        return elementData;
      };
      SVGShapeElement.prototype.createShapeElement = function(data2, ownTransformers, level) {
        var ty = 4;
        if (data2.ty === "rc") {
          ty = 5;
        } else if (data2.ty === "el") {
          ty = 6;
        } else if (data2.ty === "sr") {
          ty = 7;
        }
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data2, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data2, elementData);
        return elementData;
      };
      SVGShapeElement.prototype.addToAnimatedContents = function(data2, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while (i < len) {
          if (this.animatedContents[i].element === element) {
            return;
          }
          i += 1;
        }
        this.animatedContents.push({
          fn: SVGElementsRenderer.createRenderFunction(data2),
          element,
          data: data2
        });
      };
      SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for (j = 0; j < jLen; j += 1) {
          if (!this.stylesList[j].closed) {
            arr.push(this.stylesList[j]);
          }
        }
      };
      SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for (i = 0; i < len; i += 1) {
          this.prevViewData[i] = this.itemsData[i];
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for (i = 0; i < len; i += 1) {
          this.dynamicProperties[i].getValue();
        }
        this.renderModifiers();
      };
      SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for (i = len; i >= 0; i -= 1) {
          processedPos = this.searchProcessedElement(arr[i]);
          if (!processedPos) {
            arr[i]._render = render;
          } else {
            itemsData[i] = prevViewData[processedPos - 1];
          }
          if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs" || arr[i].ty === "no") {
            if (!processedPos) {
              itemsData[i] = this.createStyleElement(arr[i], level);
            } else {
              itemsData[i].style.closed = false;
            }
            if (arr[i]._render) {
              if (itemsData[i].style.pElem.parentNode !== container) {
                container.appendChild(itemsData[i].style.pElem);
              }
            }
            ownStyles.push(itemsData[i].style);
          } else if (arr[i].ty === "gr") {
            if (!processedPos) {
              itemsData[i] = this.createGroupElement(arr[i]);
            } else {
              jLen = itemsData[i].it.length;
              for (j = 0; j < jLen; j += 1) {
                itemsData[i].prevViewData[j] = itemsData[i].it[j];
              }
            }
            this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
            if (arr[i]._render) {
              if (itemsData[i].gr.parentNode !== container) {
                container.appendChild(itemsData[i].gr);
              }
            }
          } else if (arr[i].ty === "tr") {
            if (!processedPos) {
              itemsData[i] = this.createTransformElement(arr[i], container);
            }
            currentTransform = itemsData[i].transform;
            ownTransformers.push(currentTransform);
          } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
            if (!processedPos) {
              itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
            }
            this.setElementStyles(itemsData[i]);
          } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "ms" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
            if (!processedPos) {
              modifier = ShapeModifiers.getModifier(arr[i].ty);
              modifier.init(this, arr[i]);
              itemsData[i] = modifier;
              this.shapeModifiers.push(modifier);
            } else {
              modifier = itemsData[i];
              modifier.closed = false;
            }
            ownModifiers.push(modifier);
          } else if (arr[i].ty === "rp") {
            if (!processedPos) {
              modifier = ShapeModifiers.getModifier(arr[i].ty);
              itemsData[i] = modifier;
              modifier.init(this, arr, i, itemsData);
              this.shapeModifiers.push(modifier);
              render = false;
            } else {
              modifier = itemsData[i];
              modifier.closed = true;
            }
            ownModifiers.push(modifier);
          }
          this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for (i = 0; i < len; i += 1) {
          ownStyles[i].closed = true;
        }
        len = ownModifiers.length;
        for (i = 0; i < len; i += 1) {
          ownModifiers[i].closed = true;
        }
      };
      SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for (i = 0; i < len; i += 1) {
          this.stylesList[i].reset();
        }
        this.renderShape();
        for (i = 0; i < len; i += 1) {
          if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
              this.stylesList[i].msElem.setAttribute("d", this.stylesList[i].d);
              this.stylesList[i].d = "M0 0" + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute("d", this.stylesList[i].d || "M0 0");
          }
        }
      };
      SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for (i = 0; i < len; i += 1) {
          animatedContent = this.animatedContents[i];
          if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
            animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
          }
        }
      };
      SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
      };
      function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
          o: true,
          sw: !!sw,
          sc: !!sc,
          fc: !!fc,
          m: true,
          p: true
        };
      }
      LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
          this.o = o;
          this._mdf.o = true;
          updated = true;
        }
        if (this.sw !== sw) {
          this.sw = sw;
          this._mdf.sw = true;
          updated = true;
        }
        if (this.sc !== sc) {
          this.sc = sc;
          this._mdf.sc = true;
          updated = true;
        }
        if (this.fc !== fc) {
          this.fc = fc;
          this._mdf.fc = true;
          updated = true;
        }
        if (this.m !== m) {
          this.m = m;
          this._mdf.m = true;
          updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
          this.p = p;
          this._mdf.p = true;
          updated = true;
        }
        return updated;
      };
      function TextProperty(elem2, data2) {
        this._frameId = initialDefaultFrame;
        this.pv = "";
        this.v = "";
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data2.d && data2.d.sid) {
          data2.d = elem2.globalData.slotManager.getProp(data2.d);
        }
        this.data = data2;
        this.elem = elem2;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
          ascent: 0,
          boxWidth: this.defaultBoxWidth,
          f: "",
          fStyle: "",
          fWeight: "",
          fc: "",
          j: "",
          justifyOffset: "",
          l: [],
          lh: 0,
          lineWidths: [],
          ls: "",
          of: "",
          s: "",
          sc: "",
          sw: 0,
          t: 0,
          tr: 0,
          sz: 0,
          ps: null,
          fillColorAnim: false,
          strokeColorAnim: false,
          strokeWidthAnim: false,
          yOffset: 0,
          finalSize: 0,
          finalText: [],
          finalLineHeight: 0,
          __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) {
          this.completeTextData(this.currentData);
        }
      }
      TextProperty.prototype.defaultBoxWidth = [0, 0];
      TextProperty.prototype.copyData = function(obj, data2) {
        for (var s2 in data2) {
          if (Object.prototype.hasOwnProperty.call(data2, s2)) {
            obj[s2] = data2[s2];
          }
        }
        return obj;
      };
      TextProperty.prototype.setCurrentData = function(data2) {
        if (!data2.__complete) {
          this.completeTextData(data2);
        }
        this.currentData = data2;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
      };
      TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
      };
      TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) {
          this.addEffect(this.getKeyframeValue.bind(this));
        }
        return this.kf;
      };
      TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
      };
      TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
          return;
        }
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for (i = 0; i < len; i += 1) {
          if (currentIndex !== this.keysIndex) {
            finalValue = this.effectsSequence[i](finalValue, finalValue.t);
          } else {
            finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
          }
        }
        if (currentValue !== finalValue) {
          this.setCurrentData(finalValue);
        }
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
      };
      TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while (i <= len - 1) {
          if (i === len - 1 || textKeys[i + 1].t > frameNum) {
            break;
          }
          i += 1;
        }
        if (this.keysIndex !== i) {
          this.keysIndex = i;
        }
        return this.data.d.k[this.keysIndex].s;
      };
      TextProperty.prototype.buildFinalText = function(text2) {
        var charactersArray = [];
        var i = 0;
        var len = text2.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = "";
        while (i < len) {
          shouldCombine = shouldCombineNext;
          shouldCombineNext = false;
          charCode = text2.charCodeAt(i);
          currentChars = text2.charAt(i);
          if (FontManager.isCombinedCharacter(charCode)) {
            shouldCombine = true;
          } else if (charCode >= 55296 && charCode <= 56319) {
            if (FontManager.isRegionalFlag(text2, i)) {
              currentChars = text2.substr(i, 14);
            } else {
              secondCharCode = text2.charCodeAt(i + 1);
              if (secondCharCode >= 56320 && secondCharCode <= 57343) {
                if (FontManager.isModifier(charCode, secondCharCode)) {
                  currentChars = text2.substr(i, 2);
                  shouldCombine = true;
                } else if (FontManager.isFlagEmoji(text2.substr(i, 4))) {
                  currentChars = text2.substr(i, 4);
                } else {
                  currentChars = text2.substr(i, 2);
                }
              }
            }
          } else if (charCode > 56319) {
            secondCharCode = text2.charCodeAt(i + 1);
            if (FontManager.isVariationSelector(charCode)) {
              shouldCombine = true;
            }
          } else if (FontManager.isZeroWidthJoiner(charCode)) {
            shouldCombine = true;
            shouldCombineNext = true;
          }
          if (shouldCombine) {
            charactersArray[charactersArray.length - 1] += currentChars;
            shouldCombine = false;
          } else {
            charactersArray.push(currentChars);
          }
          i += currentChars.length;
        }
        return charactersArray;
      };
      TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data2 = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index2 = 0;
        var val2;
        var anchorGrouping = data2.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1e3 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
          var flag = true;
          var boxWidth = documentData.sz[0];
          var boxHeight = documentData.sz[1];
          var currentHeight;
          var finalText;
          while (flag) {
            finalText = this.buildFinalText(documentData.t);
            currentHeight = 0;
            lineWidth = 0;
            len = finalText.length;
            trackingOffset = documentData.tr / 1e3 * documentData.finalSize;
            var lastSpaceIndex = -1;
            for (i = 0; i < len; i += 1) {
              charCode = finalText[i].charCodeAt(0);
              newLineFlag = false;
              if (finalText[i] === " ") {
                lastSpaceIndex = i;
              } else if (charCode === 13 || charCode === 3) {
                lineWidth = 0;
                newLineFlag = true;
                currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
              }
              if (fontManager.chars) {
                charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
              } else {
                cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
              }
              if (lineWidth + cLength > boxWidth && finalText[i] !== " ") {
                if (lastSpaceIndex === -1) {
                  len += 1;
                } else {
                  i = lastSpaceIndex;
                }
                currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                finalText.splice(i, lastSpaceIndex === i ? 1 : 0, "\r");
                lastSpaceIndex = -1;
                lineWidth = 0;
              } else {
                lineWidth += cLength;
                lineWidth += trackingOffset;
              }
            }
            currentHeight += fontData.ascent * documentData.finalSize / 100;
            if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
              documentData.finalSize -= 1;
              documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
            } else {
              documentData.finalText = finalText;
              len = documentData.finalText.length;
              flag = false;
            }
          }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for (i = 0; i < len; i += 1) {
          newLineFlag = false;
          currentChar = documentData.finalText[i];
          charCode = currentChar.charCodeAt(0);
          if (charCode === 13 || charCode === 3) {
            uncollapsedSpaces = 0;
            lineWidths.push(lineWidth);
            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
            lineWidth = -2 * trackingOffset;
            val2 = "";
            newLineFlag = true;
            currentLine += 1;
          } else {
            val2 = currentChar;
          }
          if (fontManager.chars) {
            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
          } else {
            cLength = fontManager.measureText(val2, documentData.f, documentData.finalSize);
          }
          if (currentChar === " ") {
            uncollapsedSpaces += cLength + trackingOffset;
          } else {
            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
            uncollapsedSpaces = 0;
          }
          letters.push({
            l: cLength,
            an: cLength,
            add: currentSize,
            n: newLineFlag,
            anIndexes: [],
            val: val2,
            line: currentLine,
            animatorJustifyOffset: 0
          });
          if (anchorGrouping == 2) {
            currentSize += cLength;
            if (val2 === "" || val2 === " " || i === len - 1) {
              if (val2 === "" || val2 === " ") {
                currentSize -= cLength;
              }
              while (currentPos <= i) {
                letters[currentPos].an = currentSize;
                letters[currentPos].ind = index2;
                letters[currentPos].extra = cLength;
                currentPos += 1;
              }
              index2 += 1;
              currentSize = 0;
            }
          } else if (anchorGrouping == 3) {
            currentSize += cLength;
            if (val2 === "" || i === len - 1) {
              if (val2 === "") {
                currentSize -= cLength;
              }
              while (currentPos <= i) {
                letters[currentPos].an = currentSize;
                letters[currentPos].ind = index2;
                letters[currentPos].extra = cLength;
                currentPos += 1;
              }
              currentSize = 0;
              index2 += 1;
            }
          } else {
            letters[index2].ind = index2;
            letters[index2].extra = 0;
            index2 += 1;
          }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
          documentData.boxWidth = documentData.sz[0];
          documentData.justifyOffset = 0;
        } else {
          documentData.boxWidth = maxLineWidth;
          switch (documentData.j) {
            case 1:
              documentData.justifyOffset = -documentData.boxWidth;
              break;
            case 2:
              documentData.justifyOffset = -documentData.boxWidth / 2;
              break;
            default:
              documentData.justifyOffset = 0;
          }
        }
        documentData.lineWidths = lineWidths;
        var animators = data2.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for (j = 0; j < jLen; j += 1) {
          animatorData = animators[j];
          if (animatorData.a.sc) {
            documentData.strokeColorAnim = true;
          }
          if (animatorData.a.sw) {
            documentData.strokeWidthAnim = true;
          }
          if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
            documentData.fillColorAnim = true;
          }
          ind = 0;
          based = animatorData.s.b;
          for (i = 0; i < len; i += 1) {
            letterData = letters[i];
            letterData.anIndexes[j] = ind;
            if (based == 1 && letterData.val !== "" || based == 2 && letterData.val !== "" && letterData.val !== " " || based == 3 && (letterData.n || letterData.val == " " || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
              if (animatorData.s.rn === 1) {
                indexes.push(ind);
              }
              ind += 1;
            }
          }
          data2.a[j].s.totalChars = ind;
          var currentInd = -1;
          var newInd;
          if (animatorData.s.rn === 1) {
            for (i = 0; i < len; i += 1) {
              letterData = letters[i];
              if (currentInd != letterData.anIndexes[j]) {
                currentInd = letterData.anIndexes[j];
                newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
              }
              letterData.anIndexes[j] = newInd;
            }
          }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
      };
      TextProperty.prototype.updateDocumentData = function(newData, index2) {
        index2 = index2 === void 0 ? this.keysIndex : index2;
        var dData = this.copyData({}, this.data.d.k[index2].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index2].s = dData;
        this.recalculate(index2);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
      };
      TextProperty.prototype.recalculate = function(index2) {
        var dData = this.data.d.k[index2].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
      };
      TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
      };
      TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
      };
      var TextSelectorProp = function() {
        var max4 = Math.max;
        var min3 = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem2, data2) {
          this._currentTextLength = -1;
          this.k = false;
          this.data = data2;
          this.elem = elem2;
          this.comp = elem2.comp;
          this.finalS = 0;
          this.finalE = 0;
          this.initDynamicPropertyContainer(elem2);
          this.s = PropertyFactory.getProp(elem2, data2.s || {
            k: 0
          }, 0, 0, this);
          if ("e" in data2) {
            this.e = PropertyFactory.getProp(elem2, data2.e, 0, 0, this);
          } else {
            this.e = {
              v: 100
            };
          }
          this.o = PropertyFactory.getProp(elem2, data2.o || {
            k: 0
          }, 0, 0, this);
          this.xe = PropertyFactory.getProp(elem2, data2.xe || {
            k: 0
          }, 0, 0, this);
          this.ne = PropertyFactory.getProp(elem2, data2.ne || {
            k: 0
          }, 0, 0, this);
          this.sm = PropertyFactory.getProp(elem2, data2.sm || {
            k: 100
          }, 0, 0, this);
          this.a = PropertyFactory.getProp(elem2, data2.a, 0, 0.01, this);
          if (!this.dynamicProperties.length) {
            this.getValue();
          }
        }
        TextSelectorPropFactory.prototype = {
          getMult: function getMult(ind) {
            if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
              this.getValue();
            }
            var x1 = 0;
            var y1 = 0;
            var x2 = 1;
            var y2 = 1;
            if (this.ne.v > 0) {
              x1 = this.ne.v / 100;
            } else {
              y1 = -this.ne.v / 100;
            }
            if (this.xe.v > 0) {
              x2 = 1 - this.xe.v / 100;
            } else {
              y2 = 1 + this.xe.v / 100;
            }
            var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
            var mult = 0;
            var s2 = this.finalS;
            var e = this.finalE;
            var type = this.data.sh;
            if (type === 2) {
              if (e === s2) {
                mult = ind >= e ? 1 : 0;
              } else {
                mult = max4(0, min3(0.5 / (e - s2) + (ind - s2) / (e - s2), 1));
              }
              mult = easer(mult);
            } else if (type === 3) {
              if (e === s2) {
                mult = ind >= e ? 0 : 1;
              } else {
                mult = 1 - max4(0, min3(0.5 / (e - s2) + (ind - s2) / (e - s2), 1));
              }
              mult = easer(mult);
            } else if (type === 4) {
              if (e === s2) {
                mult = 0;
              } else {
                mult = max4(0, min3(0.5 / (e - s2) + (ind - s2) / (e - s2), 1));
                if (mult < 0.5) {
                  mult *= 2;
                } else {
                  mult = 1 - 2 * (mult - 0.5);
                }
              }
              mult = easer(mult);
            } else if (type === 5) {
              if (e === s2) {
                mult = 0;
              } else {
                var tot = e - s2;
                ind = min3(max4(0, ind + 0.5 - s2), e - s2);
                var x3 = -tot / 2 + ind;
                var a2 = tot / 2;
                mult = Math.sqrt(1 - x3 * x3 / (a2 * a2));
              }
              mult = easer(mult);
            } else if (type === 6) {
              if (e === s2) {
                mult = 0;
              } else {
                ind = min3(max4(0, ind + 0.5 - s2), e - s2);
                mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s2))) / 2;
              }
              mult = easer(mult);
            } else {
              if (ind >= floor(s2)) {
                if (ind - s2 < 0) {
                  mult = max4(0, min3(min3(e, 1) - (s2 - ind), 1));
                } else {
                  mult = max4(0, min3(e - ind, 1));
                }
              }
              mult = easer(mult);
            }
            if (this.sm.v !== 100) {
              var smoothness = this.sm.v * 0.01;
              if (smoothness === 0) {
                smoothness = 1e-8;
              }
              var threshold2 = 0.5 - smoothness * 0.5;
              if (mult < threshold2) {
                mult = 0;
              } else {
                mult = (mult - threshold2) / smoothness;
                if (mult > 1) {
                  mult = 1;
                }
              }
            }
            return mult * this.a.v;
          },
          getValue: function getValue(newCharsFlag) {
            this.iterateDynamicProperties();
            this._mdf = newCharsFlag || this._mdf;
            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
            if (newCharsFlag && this.data.r === 2) {
              this.e.v = this._currentTextLength;
            }
            var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
            var o = this.o.v / divisor;
            var s2 = this.s.v / divisor + o;
            var e = this.e.v / divisor + o;
            if (s2 > e) {
              var _s = s2;
              s2 = e;
              e = _s;
            }
            this.finalS = s2;
            this.finalE = e;
          }
        };
        extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);
        function getTextSelectorProp(elem2, data2, arr) {
          return new TextSelectorPropFactory(elem2, data2);
        }
        return {
          getTextSelectorProp
        };
      }();
      function TextAnimatorDataProperty(elem2, animatorProps, container) {
        var defaultData = {
          propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
          r: textAnimatorAnimatables.r ? getProp(elem2, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
          rx: textAnimatorAnimatables.rx ? getProp(elem2, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
          ry: textAnimatorAnimatables.ry ? getProp(elem2, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
          sk: textAnimatorAnimatables.sk ? getProp(elem2, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
          sa: textAnimatorAnimatables.sa ? getProp(elem2, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
          s: textAnimatorAnimatables.s ? getProp(elem2, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
          a: textAnimatorAnimatables.a ? getProp(elem2, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
          o: textAnimatorAnimatables.o ? getProp(elem2, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
          p: textAnimatorAnimatables.p ? getProp(elem2, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
          sw: textAnimatorAnimatables.sw ? getProp(elem2, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
          sc: textAnimatorAnimatables.sc ? getProp(elem2, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
          fc: textAnimatorAnimatables.fc ? getProp(elem2, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
          fh: textAnimatorAnimatables.fh ? getProp(elem2, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
          fs: textAnimatorAnimatables.fs ? getProp(elem2, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
          fb: textAnimatorAnimatables.fb ? getProp(elem2, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
          t: textAnimatorAnimatables.t ? getProp(elem2, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem2, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
      }
      function TextAnimatorProperty(textData, renderType, elem2) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem2;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
          alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem2);
      }
      TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for (i = 0; i < len; i += 1) {
          animatorProps = this._textData.a[i];
          this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && "m" in this._textData.p) {
          this._pathData = {
            a: getProp(this._elem, this._textData.p.a, 0, 0, this),
            f: getProp(this._elem, this._textData.p.f, 0, 0, this),
            l: getProp(this._elem, this._textData.p.l, 0, 0, this),
            r: getProp(this._elem, this._textData.p.r, 0, 0, this),
            p: getProp(this._elem, this._textData.p.p, 0, 0, this),
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
          };
          this._hasMaskedPath = true;
        } else {
          this._hasMaskedPath = false;
        }
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
      };
      TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
          return;
        }
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask2;
        if (this._hasMaskedPath) {
          mask2 = this._pathData.m;
          if (!this._pathData.n || this._pathData._mdf) {
            var paths = mask2.v;
            if (this._pathData.r.v) {
              paths = paths.reverse();
            }
            pathInfo = {
              tLength: 0,
              segments: []
            };
            len = paths._length - 1;
            var bezierData;
            totalLength = 0;
            for (i = 0; i < len; i += 1) {
              bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
              pathInfo.tLength += bezierData.segmentLength;
              pathInfo.segments.push(bezierData);
              totalLength += bezierData.segmentLength;
            }
            i = len;
            if (mask2.v.c) {
              bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
              pathInfo.tLength += bezierData.segmentLength;
              pathInfo.segments.push(bezierData);
              totalLength += bezierData.segmentLength;
            }
            this._pathData.pi = pathInfo;
          }
          pathInfo = this._pathData.pi;
          currentLength = this._pathData.f.v;
          segmentInd = 0;
          pointInd = 1;
          segmentLength = 0;
          flag = true;
          segments = pathInfo.segments;
          if (currentLength < 0 && mask2.v.c) {
            if (pathInfo.tLength < Math.abs(currentLength)) {
              currentLength = -Math.abs(currentLength) % pathInfo.tLength;
            }
            segmentInd = segments.length - 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
            while (currentLength < 0) {
              currentLength += points[pointInd].partialLength;
              pointInd -= 1;
              if (pointInd < 0) {
                segmentInd -= 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
              }
            }
          }
          points = segments[segmentInd].points;
          prevPoint = points[pointInd - 1];
          currentPoint = points[pointInd];
          partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k2;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = "";
        var letterP = this.defaultPropsArray;
        var letterO;
        if (documentData.j === 2 || documentData.j === 1) {
          var animatorJustifyOffset = 0;
          var animatorFirstCharOffset = 0;
          var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
          var lastIndex = 0;
          var isNewLine = true;
          for (i = 0; i < len; i += 1) {
            if (letters[i].n) {
              if (animatorJustifyOffset) {
                animatorJustifyOffset += animatorFirstCharOffset;
              }
              while (lastIndex < i) {
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
              }
              animatorJustifyOffset = 0;
              isNewLine = true;
            } else {
              for (j = 0; j < jLen; j += 1) {
                animatorProps = animators[j].a;
                if (animatorProps.t.propType) {
                  if (isNewLine && documentData.j === 2) {
                    animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                  }
                  animatorSelector = animators[j].s;
                  mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                  if (mult.length) {
                    animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                  } else {
                    animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                  }
                }
              }
              isNewLine = false;
            }
          }
          if (animatorJustifyOffset) {
            animatorJustifyOffset += animatorFirstCharOffset;
          }
          while (lastIndex < i) {
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
          }
        }
        for (i = 0; i < len; i += 1) {
          matrixHelper.reset();
          elemOpacity = 1;
          if (letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            currentLength = initPathPos;
            firstLine = false;
            if (this._hasMaskedPath) {
              segmentInd = initSegmentInd;
              pointInd = initPointInd;
              points = segments[segmentInd].points;
              prevPoint = points[pointInd - 1];
              currentPoint = points[pointInd];
              partialLength = currentPoint.partialLength;
              segmentLength = 0;
            }
            letterM = "";
            letterFc = "";
            letterSw = "";
            letterO = "";
            letterP = this.defaultPropsArray;
          } else {
            if (this._hasMaskedPath) {
              if (currentLine !== letters[i].line) {
                switch (documentData.j) {
                  case 1:
                    currentLength += totalLength - documentData.lineWidths[letters[i].line];
                    break;
                  case 2:
                    currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                    break;
                }
                currentLine = letters[i].line;
              }
              if (ind !== letters[i].ind) {
                if (letters[ind]) {
                  currentLength += letters[ind].extra;
                }
                currentLength += letters[i].an / 2;
                ind = letters[i].ind;
              }
              currentLength += alignment[0] * letters[i].an * 5e-3;
              var animatorOffset = 0;
              for (j = 0; j < jLen; j += 1) {
                animatorProps = animators[j].a;
                if (animatorProps.p.propType) {
                  animatorSelector = animators[j].s;
                  mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                  if (mult.length) {
                    animatorOffset += animatorProps.p.v[0] * mult[0];
                  } else {
                    animatorOffset += animatorProps.p.v[0] * mult;
                  }
                }
                if (animatorProps.a.propType) {
                  animatorSelector = animators[j].s;
                  mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                  if (mult.length) {
                    animatorOffset += animatorProps.a.v[0] * mult[0];
                  } else {
                    animatorOffset += animatorProps.a.v[0] * mult;
                  }
                }
              }
              flag = true;
              if (this._pathData.a.v) {
                currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                currentLength += this._pathData.f.v;
              }
              while (flag) {
                if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                  perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                  xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                  yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                  matrixHelper.translate(-alignment[0] * letters[i].an * 5e-3, -(alignment[1] * yOff) * 0.01);
                  flag = false;
                } else if (points) {
                  segmentLength += currentPoint.partialLength;
                  pointInd += 1;
                  if (pointInd >= points.length) {
                    pointInd = 0;
                    segmentInd += 1;
                    if (!segments[segmentInd]) {
                      if (mask2.v.c) {
                        pointInd = 0;
                        segmentInd = 0;
                        points = segments[segmentInd].points;
                      } else {
                        segmentLength -= currentPoint.partialLength;
                        points = null;
                      }
                    } else {
                      points = segments[segmentInd].points;
                    }
                  }
                  if (points) {
                    prevPoint = currentPoint;
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                  }
                }
              }
              offf = letters[i].an / 2 - letters[i].add;
              matrixHelper.translate(-offf, 0, 0);
            } else {
              offf = letters[i].an / 2 - letters[i].add;
              matrixHelper.translate(-offf, 0, 0);
              matrixHelper.translate(-alignment[0] * letters[i].an * 5e-3, -alignment[1] * yOff * 0.01, 0);
            }
            for (j = 0; j < jLen; j += 1) {
              animatorProps = animators[j].a;
              if (animatorProps.t.propType) {
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                if (xPos !== 0 || documentData.j !== 0) {
                  if (this._hasMaskedPath) {
                    if (mult.length) {
                      currentLength += animatorProps.t.v * mult[0];
                    } else {
                      currentLength += animatorProps.t.v * mult;
                    }
                  } else if (mult.length) {
                    xPos += animatorProps.t.v * mult[0];
                  } else {
                    xPos += animatorProps.t.v * mult;
                  }
                }
              }
            }
            if (documentData.strokeWidthAnim) {
              sw = documentData.sw || 0;
            }
            if (documentData.strokeColorAnim) {
              if (documentData.sc) {
                sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
              } else {
                sc = [0, 0, 0];
              }
            }
            if (documentData.fillColorAnim && documentData.fc) {
              fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
            }
            for (j = 0; j < jLen; j += 1) {
              animatorProps = animators[j].a;
              if (animatorProps.a.propType) {
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                if (mult.length) {
                  matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                } else {
                  matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                }
              }
            }
            for (j = 0; j < jLen; j += 1) {
              animatorProps = animators[j].a;
              if (animatorProps.s.propType) {
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                if (mult.length) {
                  matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                } else {
                  matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                }
              }
            }
            for (j = 0; j < jLen; j += 1) {
              animatorProps = animators[j].a;
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
              if (animatorProps.sk.propType) {
                if (mult.length) {
                  matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                } else {
                  matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                }
              }
              if (animatorProps.r.propType) {
                if (mult.length) {
                  matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                } else {
                  matrixHelper.rotateZ(-animatorProps.r.v * mult);
                }
              }
              if (animatorProps.ry.propType) {
                if (mult.length) {
                  matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                } else {
                  matrixHelper.rotateY(animatorProps.ry.v * mult);
                }
              }
              if (animatorProps.rx.propType) {
                if (mult.length) {
                  matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                } else {
                  matrixHelper.rotateX(animatorProps.rx.v * mult);
                }
              }
              if (animatorProps.o.propType) {
                if (mult.length) {
                  elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                } else {
                  elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                }
              }
              if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                if (mult.length) {
                  sw += animatorProps.sw.v * mult[0];
                } else {
                  sw += animatorProps.sw.v * mult;
                }
              }
              if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                for (k2 = 0; k2 < 3; k2 += 1) {
                  if (mult.length) {
                    sc[k2] += (animatorProps.sc.v[k2] - sc[k2]) * mult[0];
                  } else {
                    sc[k2] += (animatorProps.sc.v[k2] - sc[k2]) * mult;
                  }
                }
              }
              if (documentData.fillColorAnim && documentData.fc) {
                if (animatorProps.fc.propType) {
                  for (k2 = 0; k2 < 3; k2 += 1) {
                    if (mult.length) {
                      fc[k2] += (animatorProps.fc.v[k2] - fc[k2]) * mult[0];
                    } else {
                      fc[k2] += (animatorProps.fc.v[k2] - fc[k2]) * mult;
                    }
                  }
                }
                if (animatorProps.fh.propType) {
                  if (mult.length) {
                    fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                  } else {
                    fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                  }
                }
                if (animatorProps.fs.propType) {
                  if (mult.length) {
                    fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                  } else {
                    fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                  }
                }
                if (animatorProps.fb.propType) {
                  if (mult.length) {
                    fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                  } else {
                    fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                  }
                }
              }
            }
            for (j = 0; j < jLen; j += 1) {
              animatorProps = animators[j].a;
              if (animatorProps.p.propType) {
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                if (this._hasMaskedPath) {
                  if (mult.length) {
                    matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                  } else {
                    matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                  }
                } else if (mult.length) {
                  matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                } else {
                  matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                }
              }
            }
            if (documentData.strokeWidthAnim) {
              letterSw = sw < 0 ? 0 : sw;
            }
            if (documentData.strokeColorAnim) {
              letterSc = "rgb(" + Math.round(sc[0] * 255) + "," + Math.round(sc[1] * 255) + "," + Math.round(sc[2] * 255) + ")";
            }
            if (documentData.fillColorAnim && documentData.fc) {
              letterFc = "rgb(" + Math.round(fc[0] * 255) + "," + Math.round(fc[1] * 255) + "," + Math.round(fc[2] * 255) + ")";
            }
            if (this._hasMaskedPath) {
              matrixHelper.translate(0, -documentData.ls);
              matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
              if (this._pathData.p.v) {
                tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                var rot = Math.atan(tanAngle) * 180 / Math.PI;
                if (currentPoint.point[0] < prevPoint.point[0]) {
                  rot += 180;
                }
                matrixHelper.rotate(-rot * Math.PI / 180);
              }
              matrixHelper.translate(xPathPos, yPathPos, 0);
              currentLength -= alignment[0] * letters[i].an * 5e-3;
              if (letters[i + 1] && ind !== letters[i + 1].ind) {
                currentLength += letters[i].an / 2;
                currentLength += documentData.tr * 1e-3 * documentData.finalSize;
              }
            } else {
              matrixHelper.translate(xPos, yPos, 0);
              if (documentData.ps) {
                matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
              }
              switch (documentData.j) {
                case 1:
                  matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                  break;
                case 2:
                  matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                  break;
              }
              matrixHelper.translate(0, -documentData.ls);
              matrixHelper.translate(offf, 0, 0);
              matrixHelper.translate(alignment[0] * letters[i].an * 5e-3, alignment[1] * yOff * 0.01, 0);
              xPos += letters[i].l + documentData.tr * 1e-3 * documentData.finalSize;
            }
            if (renderType === "html") {
              letterM = matrixHelper.toCSS();
            } else if (renderType === "svg") {
              letterM = matrixHelper.to2dCSS();
            } else {
              letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
            }
            letterO = elemOpacity;
          }
          if (renderedLettersCount <= i) {
            letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
            this.renderedLetters.push(letterValue);
            renderedLettersCount += 1;
            this.lettersChangedFlag = true;
          } else {
            letterValue = this.renderedLetters[i];
            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
          }
        }
      };
      TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) {
          return;
        }
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
      };
      TextAnimatorProperty.prototype.mHelper = new Matrix();
      TextAnimatorProperty.prototype.defaultPropsArray = [];
      extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
      function ITextElement() {
      }
      ITextElement.prototype.initElement = function(data2, globalData2, comp2) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data2, globalData2, comp2);
        this.textProperty = new TextProperty(this, data2.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data2.t, this.renderType, this);
        this.initTransform(data2, globalData2, comp2);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
      };
      ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
      };
      ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = "";
        for (j = 0; j < jLen; j += 1) {
          if (shapes[j].ty === "sh") {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
          }
        }
        return shapeStr;
      };
      ITextElement.prototype.updateDocumentData = function(newData, index2) {
        this.textProperty.updateDocumentData(newData, index2);
      };
      ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
      };
      ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
      };
      ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) {
          matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        }
        matrixHelper.translate(0, -documentData.ls, 0);
        switch (documentData.j) {
          case 1:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
            break;
          case 2:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
            break;
        }
        matrixHelper.translate(xPos, yPos, 0);
      };
      ITextElement.prototype.buildColor = function(colorData) {
        return "rgb(" + Math.round(colorData[0] * 255) + "," + Math.round(colorData[1] * 255) + "," + Math.round(colorData[2] * 255) + ")";
      };
      ITextElement.prototype.emptyProp = new LetterProps();
      ITextElement.prototype.destroy = function() {
      };
      ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
          this.buildNewText();
          this.textProperty._isFirstFrame = false;
          this.textProperty._mdf = false;
        }
      };
      var emptyShapeData = {
        shapes: []
      };
      function SVGTextLottieElement(data2, globalData2, comp2) {
        this.textSpans = [];
        this.renderType = "svg";
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);
      SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) {
          this.textContainer = createNS("text");
        }
      };
      SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = "";
        while (i < len) {
          if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
            textContents.push(currentTextContent);
            currentTextContent = "";
          } else {
            currentTextContent += textArray[i];
          }
          i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
      };
      SVGTextLottieElement.prototype.buildShapeData = function(data2, scale2) {
        if (data2.shapes && data2.shapes.length) {
          var shape = data2.shapes[0];
          if (shape.it) {
            var shapeItem = shape.it[shape.it.length - 1];
            if (shapeItem.s) {
              shapeItem.s.k[0] = scale2;
              shapeItem.s.k[1] = scale2;
            }
          }
        }
        return data2;
      };
      SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) {
          this.layerElement.setAttribute("fill", this.buildColor(documentData.fc));
        } else {
          this.layerElement.setAttribute("fill", "rgba(0,0,0,0)");
        }
        if (documentData.sc) {
          this.layerElement.setAttribute("stroke", this.buildColor(documentData.sc));
          this.layerElement.setAttribute("stroke-width", documentData.sw);
        }
        this.layerElement.setAttribute("font-size", documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) {
          this.layerElement.setAttribute("class", fontData.fClass);
        } else {
          this.layerElement.setAttribute("font-family", fontData.fFamily);
          var fWeight = documentData.fWeight;
          var fStyle = documentData.fStyle;
          this.layerElement.setAttribute("font-style", fStyle);
          this.layerElement.setAttribute("font-weight", fWeight);
        }
        this.layerElement.setAttribute("aria-label", documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = "";
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 1e-3 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
          var tElement = this.textContainer;
          var justify = "start";
          switch (documentData.j) {
            case 1:
              justify = "end";
              break;
            case 2:
              justify = "middle";
              break;
            default:
              justify = "start";
              break;
          }
          tElement.setAttribute("text-anchor", justify);
          tElement.setAttribute("letter-spacing", trackingOffset);
          var textContent = this.buildTextContents(documentData.finalText);
          len = textContent.length;
          yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
          for (i = 0; i < len; i += 1) {
            tSpan = this.textSpans[i].span || createNS("tspan");
            tSpan.textContent = textContent[i];
            tSpan.setAttribute("x", 0);
            tSpan.setAttribute("y", yPos);
            tSpan.style.display = "inherit";
            tElement.appendChild(tSpan);
            if (!this.textSpans[i]) {
              this.textSpans[i] = {
                span: null,
                glyph: null
              };
            }
            this.textSpans[i].span = tSpan;
            yPos += documentData.finalLineHeight;
          }
          this.layerElement.appendChild(tElement);
        } else {
          var cachedSpansLength = this.textSpans.length;
          var charData;
          for (i = 0; i < len; i += 1) {
            if (!this.textSpans[i]) {
              this.textSpans[i] = {
                span: null,
                childSpan: null,
                glyph: null
              };
            }
            if (!usesGlyphs || !singleShape || i === 0) {
              tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? "g" : "text");
              if (cachedSpansLength <= i) {
                tSpan.setAttribute("stroke-linecap", "butt");
                tSpan.setAttribute("stroke-linejoin", "round");
                tSpan.setAttribute("stroke-miterlimit", "4");
                this.textSpans[i].span = tSpan;
                if (usesGlyphs) {
                  var childSpan = createNS("g");
                  tSpan.appendChild(childSpan);
                  this.textSpans[i].childSpan = childSpan;
                }
                this.textSpans[i].span = tSpan;
                this.layerElement.appendChild(tSpan);
              }
              tSpan.style.display = "inherit";
            }
            matrixHelper.reset();
            if (singleShape) {
              if (letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
              }
              this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
              xPos += letters[i].l || 0;
              xPos += trackingOffset;
            }
            if (usesGlyphs) {
              charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
              var glyphElement;
              if (charData.t === 1) {
                glyphElement = new SVGCompElement(charData.data, this.globalData, this);
              } else {
                var data2 = emptyShapeData;
                if (charData.data && charData.data.shapes) {
                  data2 = this.buildShapeData(charData.data, documentData.finalSize);
                }
                glyphElement = new SVGShapeElement(data2, this.globalData, this);
              }
              if (this.textSpans[i].glyph) {
                var glyph = this.textSpans[i].glyph;
                this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                glyph.destroy();
              }
              this.textSpans[i].glyph = glyphElement;
              glyphElement._debug = true;
              glyphElement.prepareFrame(0);
              glyphElement.renderFrame();
              this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);
              if (charData.t === 1) {
                this.textSpans[i].childSpan.setAttribute("transform", "scale(" + documentData.finalSize / 100 + "," + documentData.finalSize / 100 + ")");
              }
            } else {
              if (singleShape) {
                tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
              }
              tSpan.textContent = letters[i].val;
              tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
            }
          }
          if (singleShape && tSpan) {
            tSpan.setAttribute("d", shapeStr);
          }
        }
        while (i < this.textSpans.length) {
          this.textSpans[i].span.style.display = "none";
          i += 1;
        }
        this._sizeChanged = true;
      };
      SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
          this._sizeChanged = false;
          var textBox = this.layerElement.getBBox();
          this.bbox = {
            top: textBox.y,
            left: textBox.x,
            width: textBox.width,
            height: textBox.height
          };
        }
        return this.bbox;
      };
      SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for (i = 0; i < len; i += 1) {
          glyphElement = this.textSpans[i].glyph;
          if (glyphElement) {
            glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
            if (glyphElement._mdf) {
              this._mdf = true;
            }
          }
        }
      };
      SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
          this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
          if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
            this._sizeChanged = true;
            var i;
            var len;
            var renderedLetters = this.textAnimator.renderedLetters;
            var letters = this.textProperty.currentData.l;
            len = letters.length;
            var renderedLetter;
            var textSpan;
            var glyphElement;
            for (i = 0; i < len; i += 1) {
              if (!letters[i].n) {
                renderedLetter = renderedLetters[i];
                textSpan = this.textSpans[i].span;
                glyphElement = this.textSpans[i].glyph;
                if (glyphElement) {
                  glyphElement.renderFrame();
                }
                if (renderedLetter._mdf.m) {
                  textSpan.setAttribute("transform", renderedLetter.m);
                }
                if (renderedLetter._mdf.o) {
                  textSpan.setAttribute("opacity", renderedLetter.o);
                }
                if (renderedLetter._mdf.sw) {
                  textSpan.setAttribute("stroke-width", renderedLetter.sw);
                }
                if (renderedLetter._mdf.sc) {
                  textSpan.setAttribute("stroke", renderedLetter.sc);
                }
                if (renderedLetter._mdf.fc) {
                  textSpan.setAttribute("fill", renderedLetter.fc);
                }
              }
            }
          }
        }
      };
      function ISolidElement(data2, globalData2, comp2) {
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([IImageElement], ISolidElement);
      ISolidElement.prototype.createContent = function() {
        var rect = createNS("rect");
        rect.setAttribute("width", this.data.sw);
        rect.setAttribute("height", this.data.sh);
        rect.setAttribute("fill", this.data.sc);
        this.layerElement.appendChild(rect);
      };
      function NullElement(data2, globalData2, comp2) {
        this.initFrame();
        this.initBaseData(data2, globalData2, comp2);
        this.initFrame();
        this.initTransform(data2, globalData2, comp2);
        this.initHierarchy();
      }
      NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
      };
      NullElement.prototype.renderFrame = function() {
      };
      NullElement.prototype.getBaseElement = function() {
        return null;
      };
      NullElement.prototype.destroy = function() {
      };
      NullElement.prototype.sourceRectAtTime = function() {
      };
      NullElement.prototype.hide = function() {
      };
      extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
      function SVGRendererBase() {
      }
      extendPrototype([BaseRenderer], SVGRendererBase);
      SVGRendererBase.prototype.createNull = function(data2) {
        return new NullElement(data2, this.globalData, this);
      };
      SVGRendererBase.prototype.createShape = function(data2) {
        return new SVGShapeElement(data2, this.globalData, this);
      };
      SVGRendererBase.prototype.createText = function(data2) {
        return new SVGTextLottieElement(data2, this.globalData, this);
      };
      SVGRendererBase.prototype.createImage = function(data2) {
        return new IImageElement(data2, this.globalData, this);
      };
      SVGRendererBase.prototype.createSolid = function(data2) {
        return new ISolidElement(data2, this.globalData, this);
      };
      SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        if (this.renderConfig.viewBoxSize) {
          this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize);
        } else {
          this.svgElement.setAttribute("viewBox", "0 0 " + animData.w + " " + animData.h);
        }
        if (!this.renderConfig.viewBoxOnly) {
          this.svgElement.setAttribute("width", animData.w);
          this.svgElement.setAttribute("height", animData.h);
          this.svgElement.style.width = "100%";
          this.svgElement.style.height = "100%";
          this.svgElement.style.transform = "translate3d(0,0,0)";
          this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) {
          this.svgElement.setAttribute("width", this.renderConfig.width);
        }
        if (this.renderConfig.height) {
          this.svgElement.setAttribute("height", this.renderConfig.height);
        }
        if (this.renderConfig.className) {
          this.svgElement.setAttribute("class", this.renderConfig.className);
        }
        if (this.renderConfig.id) {
          this.svgElement.setAttribute("id", this.renderConfig.id);
        }
        if (this.renderConfig.focusable !== void 0) {
          this.svgElement.setAttribute("focusable", this.renderConfig.focusable);
        }
        this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio);
        this.animationItem.wrapper.appendChild(this.svgElement);
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS("clipPath");
        var rect = createNS("rect");
        rect.setAttribute("width", animData.w);
        rect.setAttribute("height", animData.h);
        rect.setAttribute("x", 0);
        rect.setAttribute("y", 0);
        var maskId = createElementID();
        maskElement.setAttribute("id", maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + maskId + ")");
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
      };
      SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) {
          this.animationItem.wrapper.innerText = "";
        }
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for (i = 0; i < len; i += 1) {
          if (this.elements[i] && this.elements[i].destroy) {
            this.elements[i].destroy();
          }
        }
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
      };
      SVGRendererBase.prototype.updateContainerSize = function() {
      };
      SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for (i = 0; i < len; i += 1) {
          if (this.layers[i].ind === ind) {
            return i;
          }
        }
        return -1;
      };
      SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) {
          return;
        }
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
          if (this.layers[pos].ty === 0) {
            this.globalData.projectInterface.registerComposition(element);
          }
          element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
          var elementIndex = "tp" in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
          if (elementIndex === -1) {
            return;
          }
          if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
            this.buildItem(elementIndex);
            this.addPendingElement(element);
          } else {
            var matteElement = elements[elementIndex];
            var matteMask = matteElement.getMatte(this.layers[pos].tt);
            element.setMatte(matteMask);
          }
        }
      };
      SVGRendererBase.prototype.checkPendingElements = function() {
        while (this.pendingElements.length) {
          var element = this.pendingElements.pop();
          element.checkParenting();
          if (element.data.tt) {
            var i = 0;
            var len = this.elements.length;
            while (i < len) {
              if (this.elements[i] === element) {
                var elementIndex = "tp" in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                var matteElement = this.elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[i].tt);
                element.setMatte(matteMask);
                break;
              }
              i += 1;
            }
          }
        }
      };
      SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) {
          return;
        }
        if (num === null) {
          num = this.renderedFrame;
        } else {
          this.renderedFrame = num;
        }
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) {
          this.checkLayers(num);
        }
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(num - this.layers[i].st);
          }
        }
        if (this.globalData._mdf) {
          for (i = 0; i < len; i += 1) {
            if (this.completeLayers || this.elements[i]) {
              this.elements[i].renderFrame();
            }
          }
        }
      };
      SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) {
          return;
        }
        var i = 0;
        var nextElement;
        while (i < pos) {
          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
            nextElement = this.elements[i].getBaseElement();
          }
          i += 1;
        }
        if (nextElement) {
          this.layerElement.insertBefore(newElement, nextElement);
        } else {
          this.layerElement.appendChild(newElement);
        }
      };
      SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
      };
      SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
      };
      function ICompElement() {
      }
      extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
      ICompElement.prototype.initElement = function(data2, globalData2, comp2) {
        this.initFrame();
        this.initBaseData(data2, globalData2, comp2);
        this.initTransform(data2, globalData2, comp2);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData2.progressiveLoad) {
          this.buildAllItems();
        }
        this.hide();
      };
      ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) {
          return;
        }
        if (!this.tm._placeholder) {
          var timeRemapped = this.tm.v;
          if (timeRemapped === this.data.op) {
            timeRemapped = this.data.op - 1;
          }
          this.renderedFrame = timeRemapped;
        } else {
          this.renderedFrame = num / this.data.sr;
        }
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) {
          this.checkLayers(this.renderedFrame);
        }
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) {
              this._mdf = true;
            }
          }
        }
      };
      ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for (i = 0; i < len; i += 1) {
          if (this.completeLayers || this.elements[i]) {
            this.elements[i].renderFrame();
          }
        }
      };
      ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
      };
      ICompElement.prototype.getElements = function() {
        return this.elements;
      };
      ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for (i = 0; i < len; i += 1) {
          if (this.elements[i]) {
            this.elements[i].destroy();
          }
        }
      };
      ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
      };
      function SVGCompElement(data2, globalData2, comp2) {
        this.layers = data2.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data2, globalData2, comp2);
        this.tm = data2.tm ? PropertyFactory.getProp(this, data2.tm, 0, globalData2.frameRate, this) : {
          _placeholder: true
        };
      }
      extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);
      SVGCompElement.prototype.createComp = function(data2) {
        return new SVGCompElement(data2, this.globalData, this);
      };
      function SVGRenderer(animationItem, config2) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS("svg");
        var ariaLabel = "";
        if (config2 && config2.title) {
          var titleElement = createNS("title");
          var titleId = createElementID();
          titleElement.setAttribute("id", titleId);
          titleElement.textContent = config2.title;
          this.svgElement.appendChild(titleElement);
          ariaLabel += titleId;
        }
        if (config2 && config2.description) {
          var descElement = createNS("desc");
          var descId = createElementID();
          descElement.setAttribute("id", descId);
          descElement.textContent = config2.description;
          this.svgElement.appendChild(descElement);
          ariaLabel += " " + descId;
        }
        if (ariaLabel) {
          this.svgElement.setAttribute("aria-labelledby", ariaLabel);
        }
        var defs = createNS("defs");
        this.svgElement.appendChild(defs);
        var maskElement = createNS("g");
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
          preserveAspectRatio: config2 && config2.preserveAspectRatio || "xMidYMid meet",
          imagePreserveAspectRatio: config2 && config2.imagePreserveAspectRatio || "xMidYMid slice",
          contentVisibility: config2 && config2.contentVisibility || "visible",
          progressiveLoad: config2 && config2.progressiveLoad || false,
          hideOnTransparent: !(config2 && config2.hideOnTransparent === false),
          viewBoxOnly: config2 && config2.viewBoxOnly || false,
          viewBoxSize: config2 && config2.viewBoxSize || false,
          className: config2 && config2.className || "",
          id: config2 && config2.id || "",
          focusable: config2 && config2.focusable,
          filterSize: {
            width: config2 && config2.filterSize && config2.filterSize.width || "100%",
            height: config2 && config2.filterSize && config2.filterSize.height || "100%",
            x: config2 && config2.filterSize && config2.filterSize.x || "0%",
            y: config2 && config2.filterSize && config2.filterSize.y || "0%"
          },
          width: config2 && config2.width,
          height: config2 && config2.height,
          runExpressions: !config2 || config2.runExpressions === void 0 || config2.runExpressions
        };
        this.globalData = {
          _mdf: false,
          frameNum: -1,
          defs,
          renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = "svg";
      }
      extendPrototype([SVGRendererBase], SVGRenderer);
      SVGRenderer.prototype.createComp = function(data2) {
        return new SVGCompElement(data2, this.globalData, this);
      };
      function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
      }
      ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
          var i;
          var len = transforms.length;
          var key2 = "_";
          for (i = 0; i < len; i += 1) {
            key2 += transforms[i].transform.key + "_";
          }
          var sequence = this.sequences[key2];
          if (!sequence) {
            sequence = {
              transforms: [].concat(transforms),
              finalTransform: new Matrix(),
              _mdf: false
            };
            this.sequences[key2] = sequence;
            this.sequenceList.push(sequence);
          }
          return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
          var i = 0;
          var len = sequence.transforms.length;
          var _mdf = isFirstFrame;
          while (i < len && !isFirstFrame) {
            if (sequence.transforms[i].transform.mProps._mdf) {
              _mdf = true;
              break;
            }
            i += 1;
          }
          if (_mdf) {
            sequence.finalTransform.reset();
            for (i = len - 1; i >= 0; i -= 1) {
              sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
          }
          sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
          var i;
          var len = this.sequenceList.length;
          for (i = 0; i < len; i += 1) {
            this.processSequence(this.sequenceList[i], isFirstFrame);
          }
        },
        getNewKey: function getNewKey() {
          this.transform_key_count += 1;
          return "_" + this.transform_key_count;
        }
      };
      var lumaLoader = function lumaLoader2() {
        var id = "__lottie_element_luma_buffer";
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null;
        function createLumaSvgFilter() {
          var _svg = createNS("svg");
          var fil = createNS("filter");
          var matrix = createNS("feColorMatrix");
          fil.setAttribute("id", id);
          matrix.setAttribute("type", "matrix");
          matrix.setAttribute("color-interpolation-filters", "sRGB");
          matrix.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0");
          fil.appendChild(matrix);
          _svg.appendChild(fil);
          _svg.setAttribute("id", id + "_svg");
          if (featureSupport.svgLumaHidden) {
            _svg.style.display = "none";
          }
          return _svg;
        }
        function loadLuma() {
          if (!lumaBuffer) {
            svg = createLumaSvgFilter();
            document.body.appendChild(svg);
            lumaBuffer = createTag("canvas");
            lumaBufferCtx = lumaBuffer.getContext("2d");
            lumaBufferCtx.filter = "url(#" + id + ")";
            lumaBufferCtx.fillStyle = "rgba(0,0,0,0)";
            lumaBufferCtx.fillRect(0, 0, 1, 1);
          }
        }
        function getLuma(canvas) {
          if (!lumaBuffer) {
            loadLuma();
          }
          lumaBuffer.width = canvas.width;
          lumaBuffer.height = canvas.height;
          lumaBufferCtx.filter = "url(#" + id + ")";
          return lumaBuffer;
        }
        return {
          load: loadLuma,
          get: getLuma
        };
      };
      function createCanvas(width2, height2) {
        if (featureSupport.offscreenCanvas) {
          return new OffscreenCanvas(width2, height2);
        }
        var canvas = createTag("canvas");
        canvas.width = width2;
        canvas.height = height2;
        return canvas;
      }
      var assetLoader = function() {
        return {
          loadLumaCanvas: lumaLoader.load,
          getLumaCanvas: lumaLoader.get,
          createCanvas
        };
      }();
      var registeredEffects = {};
      function CVEffects(elem2) {
        var i;
        var len = elem2.data.ef ? elem2.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for (i = 0; i < len; i += 1) {
          filterManager = null;
          var type = elem2.data.ef[i].ty;
          if (registeredEffects[type]) {
            var Effect = registeredEffects[type].effect;
            filterManager = new Effect(elem2.effectsManager.effectElements[i], elem2);
          }
          if (filterManager) {
            this.filters.push(filterManager);
          }
        }
        if (this.filters.length) {
          elem2.addRenderableComponent(this);
        }
      }
      CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for (i = 0; i < len; i += 1) {
          this.filters[i].renderFrame(_isFirstFrame);
        }
      };
      CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for (i = 0; i < len; i += 1) {
          if (this.filters[i].type === type) {
            effects.push(this.filters[i]);
          }
        }
        return effects;
      };
      function registerEffect(id, effect2) {
        registeredEffects[id] = {
          effect: effect2
        };
      }
      function CVMaskElement(data2, element) {
        this.data = data2;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for (i = 0; i < len; i += 1) {
          if (this.masksProperties[i].mode !== "n") {
            hasMasks = true;
          }
          this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) {
          this.element.addRenderableComponent(this);
        }
      }
      CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) {
          return;
        }
        var transform2 = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data2;
        ctx.beginPath();
        for (i = 0; i < len; i += 1) {
          if (this.masksProperties[i].mode !== "n") {
            if (this.masksProperties[i].inv) {
              ctx.moveTo(0, 0);
              ctx.lineTo(this.element.globalData.compSize.w, 0);
              ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
              ctx.lineTo(0, this.element.globalData.compSize.h);
              ctx.lineTo(0, 0);
            }
            data2 = this.viewData[i].v;
            pt = transform2.applyToPointArray(data2.v[0][0], data2.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data2._length;
            for (j = 1; j < jLen; j += 1) {
              pts = transform2.applyToTriplePoints(data2.o[j - 1], data2.i[j], data2.v[j]);
              ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform2.applyToTriplePoints(data2.o[j - 1], data2.i[0], data2.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
          }
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
      };
      CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
      CVMaskElement.prototype.destroy = function() {
        this.element = null;
      };
      function CVBaseElement() {
      }
      var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
      };
      CVBaseElement.prototype = {
        createElements: function createElements() {
        },
        initRendererElement: function initRendererElement() {
        },
        createContainerElements: function createContainerElements() {
          if (this.data.tt >= 1) {
            this.buffers = [];
            var canvasContext = this.globalData.canvasContext;
            var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
            this.buffers.push(bufferCanvas);
            var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
            this.buffers.push(bufferCanvas2);
            if (this.data.tt >= 3 && !document._isProxy) {
              assetLoader.loadLumaCanvas();
            }
          }
          this.canvasContext = this.globalData.canvasContext;
          this.transformCanvas = this.globalData.transformCanvas;
          this.renderableEffectsManager = new CVEffects(this);
          this.searchEffectTransforms();
        },
        createContent: function createContent() {
        },
        setBlendMode: function setBlendMode() {
          var globalData2 = this.globalData;
          if (globalData2.blendMode !== this.data.bm) {
            globalData2.blendMode = this.data.bm;
            var blendModeValue = getBlendMode(this.data.bm);
            globalData2.canvasContext.globalCompositeOperation = blendModeValue;
          }
        },
        createRenderableComponents: function createRenderableComponents() {
          this.maskManager = new CVMaskElement(this.data, this);
          this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            this.hidden = true;
          }
        },
        showElement: function showElement() {
          if (this.isInRange && !this.isTransparent) {
            this.hidden = false;
            this._isFirstFrame = true;
            this.maskManager._isFirstFrame = true;
          }
        },
        clearCanvas: function clearCanvas(canvasContext) {
          canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
          if (this.data.tt >= 1) {
            var buffer = this.buffers[0];
            var bufferCtx = buffer.getContext("2d");
            this.clearCanvas(bufferCtx);
            bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
            this.currentTransform = this.canvasContext.getTransform();
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
            this.clearCanvas(this.canvasContext);
            this.canvasContext.setTransform(this.currentTransform);
          }
        },
        exitLayer: function exitLayer() {
          if (this.data.tt >= 1) {
            var buffer = this.buffers[1];
            var bufferCtx = buffer.getContext("2d");
            this.clearCanvas(bufferCtx);
            bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
            this.clearCanvas(this.canvasContext);
            this.canvasContext.setTransform(this.currentTransform);
            var mask2 = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
            mask2.renderFrame(true);
            this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
            if (this.data.tt >= 3 && !document._isProxy) {
              var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
              var lumaBufferCtx = lumaBuffer.getContext("2d");
              lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
              this.clearCanvas(this.canvasContext);
              this.canvasContext.drawImage(lumaBuffer, 0, 0);
            }
            this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
            this.canvasContext.drawImage(buffer, 0, 0);
            this.canvasContext.globalCompositeOperation = "destination-over";
            this.canvasContext.drawImage(this.buffers[0], 0, 0);
            this.canvasContext.setTransform(this.currentTransform);
            this.canvasContext.globalCompositeOperation = "source-over";
          }
        },
        renderFrame: function renderFrame(forceRender) {
          if (this.hidden || this.data.hd) {
            return;
          }
          if (this.data.td === 1 && !forceRender) {
            return;
          }
          this.renderTransform();
          this.renderRenderable();
          this.renderLocalTransform();
          this.setBlendMode();
          var forceRealStack = this.data.ty === 0;
          this.prepareLayer();
          this.globalData.renderer.save(forceRealStack);
          this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
          this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
          this.renderInnerContent();
          this.globalData.renderer.restore(forceRealStack);
          this.exitLayer();
          if (this.maskManager.hasMasks) {
            this.globalData.renderer.restore(true);
          }
          if (this._isFirstFrame) {
            this._isFirstFrame = false;
          }
        },
        destroy: function destroy() {
          this.canvasContext = null;
          this.data = null;
          this.globalData = null;
          this.maskManager.destroy();
        },
        mHelper: new Matrix()
      };
      CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
      CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
      function CVShapeData(element, data2, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [0, 0, 0, 0, 0, 0];
        var ty = 4;
        if (data2.ty === "rc") {
          ty = 5;
        } else if (data2.ty === "el") {
          ty = 6;
        } else if (data2.ty === "sr") {
          ty = 7;
        }
        this.sh = ShapePropertyFactory.getShapeProp(element, data2, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for (i = 0; i < len; i += 1) {
          if (!styles[i].closed) {
            styledShape = {
              transforms: transformsManager.addTransformSequence(styles[i].transforms),
              trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
          }
        }
      }
      CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
      function CVShapeElement(data2, globalData2, comp2) {
        this.shapes = [];
        this.shapesData = data2.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
      CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
      CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
      };
      CVShapeElement.prototype.dashResetter = [];
      CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
      };
      CVShapeElement.prototype.createStyleElement = function(data2, transforms) {
        var styleElem = {
          data: data2,
          type: data2.ty,
          preTransforms: this.transformsManager.addTransformSequence(transforms),
          transforms: [],
          elements: [],
          closed: data2.hd === true
        };
        var elementData = {};
        if (data2.ty === "fl" || data2.ty === "st") {
          elementData.c = PropertyFactory.getProp(this, data2.c, 1, 255, this);
          if (!elementData.c.k) {
            styleElem.co = "rgb(" + bmFloor(elementData.c.v[0]) + "," + bmFloor(elementData.c.v[1]) + "," + bmFloor(elementData.c.v[2]) + ")";
          }
        } else if (data2.ty === "gf" || data2.ty === "gs") {
          elementData.s = PropertyFactory.getProp(this, data2.s, 1, null, this);
          elementData.e = PropertyFactory.getProp(this, data2.e, 1, null, this);
          elementData.h = PropertyFactory.getProp(this, data2.h || {
            k: 0
          }, 0, 0.01, this);
          elementData.a = PropertyFactory.getProp(this, data2.a || {
            k: 0
          }, 0, degToRads, this);
          elementData.g = new GradientProperty(this, data2.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data2.o, 0, 0.01, this);
        if (data2.ty === "st" || data2.ty === "gs") {
          styleElem.lc = lineCapEnum[data2.lc || 2];
          styleElem.lj = lineJoinEnum[data2.lj || 2];
          if (data2.lj == 1) {
            styleElem.ml = data2.ml;
          }
          elementData.w = PropertyFactory.getProp(this, data2.w, 0, null, this);
          if (!elementData.w.k) {
            styleElem.wi = elementData.w.v;
          }
          if (data2.d) {
            var d = new DashProperty(this, data2.d, "canvas", this);
            elementData.d = d;
            if (!elementData.d.k) {
              styleElem.da = elementData.d.dashArray;
              styleElem["do"] = elementData.d.dashoffset[0];
            }
          }
        } else {
          styleElem.r = data2.r === 2 ? "evenodd" : "nonzero";
        }
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
      };
      CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
          it: [],
          prevViewData: []
        };
        return elementData;
      };
      CVShapeElement.prototype.createTransformElement = function(data2) {
        var elementData = {
          transform: {
            opacity: 1,
            _opMdf: false,
            key: this.transformsManager.getNewKey(),
            op: PropertyFactory.getProp(this, data2.o, 0, 0.01, this),
            mProps: TransformPropertyFactory.getTransformProperty(this, data2, this)
          }
        };
        return elementData;
      };
      CVShapeElement.prototype.createShapeElement = function(data2) {
        var elementData = new CVShapeData(this, data2, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
      };
      CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for (i = 0; i < len; i += 1) {
          this.prevViewData[i] = this.itemsData[i];
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for (i = 0; i < len; i += 1) {
          this.dynamicProperties[i].getValue();
        }
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
      };
      CVShapeElement.prototype.addTransformToStyleList = function(transform2) {
        var i;
        var len = this.stylesList.length;
        for (i = 0; i < len; i += 1) {
          if (!this.stylesList[i].closed) {
            this.stylesList[i].transforms.push(transform2);
          }
        }
      };
      CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for (i = 0; i < len; i += 1) {
          if (!this.stylesList[i].closed) {
            this.stylesList[i].transforms.pop();
          }
        }
      };
      CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for (i = 0; i < len; i += 1) {
          styles[i].closed = true;
        }
      };
      CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for (i = len; i >= 0; i -= 1) {
          processedPos = this.searchProcessedElement(arr[i]);
          if (!processedPos) {
            arr[i]._shouldRender = shouldRender;
          } else {
            itemsData[i] = prevViewData[processedPos - 1];
          }
          if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs") {
            if (!processedPos) {
              itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
            } else {
              itemsData[i].style.closed = false;
            }
            ownStyles.push(itemsData[i].style);
          } else if (arr[i].ty === "gr") {
            if (!processedPos) {
              itemsData[i] = this.createGroupElement(arr[i]);
            } else {
              jLen = itemsData[i].it.length;
              for (j = 0; j < jLen; j += 1) {
                itemsData[i].prevViewData[j] = itemsData[i].it[j];
              }
            }
            this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
          } else if (arr[i].ty === "tr") {
            if (!processedPos) {
              currentTransform = this.createTransformElement(arr[i]);
              itemsData[i] = currentTransform;
            }
            ownTransforms.push(itemsData[i]);
            this.addTransformToStyleList(itemsData[i]);
          } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
            if (!processedPos) {
              itemsData[i] = this.createShapeElement(arr[i]);
            }
          } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
            if (!processedPos) {
              modifier = ShapeModifiers.getModifier(arr[i].ty);
              modifier.init(this, arr[i]);
              itemsData[i] = modifier;
              this.shapeModifiers.push(modifier);
            } else {
              modifier = itemsData[i];
              modifier.closed = false;
            }
            ownModifiers.push(modifier);
          } else if (arr[i].ty === "rp") {
            if (!processedPos) {
              modifier = ShapeModifiers.getModifier(arr[i].ty);
              itemsData[i] = modifier;
              modifier.init(this, arr, i, itemsData);
              this.shapeModifiers.push(modifier);
              shouldRender = false;
            } else {
              modifier = itemsData[i];
              modifier.closed = true;
            }
            ownModifiers.push(modifier);
          }
          this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for (i = 0; i < len; i += 1) {
          ownModifiers[i].closed = true;
        }
      };
      CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
      };
      CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
          groupTransform.opacity = parentTransform.opacity;
          groupTransform.opacity *= groupTransform.op.v;
          groupTransform._opMdf = true;
        }
      };
      CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k2;
        var kLen;
        var elems;
        var nodes;
        var renderer2 = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for (i = 0; i < len; i += 1) {
          currentStyle = this.stylesList[i];
          type = currentStyle.type;
          if (!((type === "st" || type === "gs") && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
            renderer2.save();
            elems = currentStyle.elements;
            if (type === "st" || type === "gs") {
              renderer2.ctxStrokeStyle(type === "st" ? currentStyle.co : currentStyle.grd);
              renderer2.ctxLineWidth(currentStyle.wi);
              renderer2.ctxLineCap(currentStyle.lc);
              renderer2.ctxLineJoin(currentStyle.lj);
              renderer2.ctxMiterLimit(currentStyle.ml || 0);
            } else {
              renderer2.ctxFillStyle(type === "fl" ? currentStyle.co : currentStyle.grd);
            }
            renderer2.ctxOpacity(currentStyle.coOp);
            if (type !== "st" && type !== "gs") {
              ctx.beginPath();
            }
            renderer2.ctxTransform(currentStyle.preTransforms.finalTransform.props);
            jLen = elems.length;
            for (j = 0; j < jLen; j += 1) {
              if (type === "st" || type === "gs") {
                ctx.beginPath();
                if (currentStyle.da) {
                  ctx.setLineDash(currentStyle.da);
                  ctx.lineDashOffset = currentStyle["do"];
                }
              }
              nodes = elems[j].trNodes;
              kLen = nodes.length;
              for (k2 = 0; k2 < kLen; k2 += 1) {
                if (nodes[k2].t === "m") {
                  ctx.moveTo(nodes[k2].p[0], nodes[k2].p[1]);
                } else if (nodes[k2].t === "c") {
                  ctx.bezierCurveTo(nodes[k2].pts[0], nodes[k2].pts[1], nodes[k2].pts[2], nodes[k2].pts[3], nodes[k2].pts[4], nodes[k2].pts[5]);
                } else {
                  ctx.closePath();
                }
              }
              if (type === "st" || type === "gs") {
                renderer2.ctxStroke();
                if (currentStyle.da) {
                  ctx.setLineDash(this.dashResetter);
                }
              }
            }
            if (type !== "st" && type !== "gs") {
              this.globalData.renderer.ctxFill(currentStyle.r);
            }
            renderer2.restore();
          }
        }
      };
      CVShapeElement.prototype.renderShape = function(parentTransform, items, data2, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for (i = len; i >= 0; i -= 1) {
          if (items[i].ty === "tr") {
            groupTransform = data2[i].transform;
            this.renderShapeTransform(parentTransform, groupTransform);
          } else if (items[i].ty === "sh" || items[i].ty === "el" || items[i].ty === "rc" || items[i].ty === "sr") {
            this.renderPath(items[i], data2[i]);
          } else if (items[i].ty === "fl") {
            this.renderFill(items[i], data2[i], groupTransform);
          } else if (items[i].ty === "st") {
            this.renderStroke(items[i], data2[i], groupTransform);
          } else if (items[i].ty === "gf" || items[i].ty === "gs") {
            this.renderGradientFill(items[i], data2[i], groupTransform);
          } else if (items[i].ty === "gr") {
            this.renderShape(groupTransform, items[i].it, data2[i].it);
          } else if (items[i].ty === "tm") ;
        }
        if (isMain) {
          this.drawLayer();
        }
      };
      CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
          var shapeNodes = styledShape.trNodes;
          var paths = shape.paths;
          var i;
          var len;
          var j;
          var jLen = paths._length;
          shapeNodes.length = 0;
          var groupTransformMat = styledShape.transforms.finalTransform;
          for (j = 0; j < jLen; j += 1) {
            var pathNodes = paths.shapes[j];
            if (pathNodes && pathNodes.v) {
              len = pathNodes._length;
              for (i = 1; i < len; i += 1) {
                if (i === 1) {
                  shapeNodes.push({
                    t: "m",
                    p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                  });
                }
                shapeNodes.push({
                  t: "c",
                  pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                });
              }
              if (len === 1) {
                shapeNodes.push({
                  t: "m",
                  p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                });
              }
              if (pathNodes.c && len) {
                shapeNodes.push({
                  t: "c",
                  pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                });
                shapeNodes.push({
                  t: "z"
                });
              }
            }
          }
          styledShape.trNodes = shapeNodes;
        }
      };
      CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
          var i;
          var len = itemData.styledShapes.length;
          for (i = 0; i < len; i += 1) {
            this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
          }
        }
      };
      CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) {
          styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        }
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
          styleElem.coOp = itemData.o.v * groupTransform.opacity;
        }
      };
      CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
          var ctx = this.globalData.canvasContext;
          var pt1 = itemData.s.v;
          var pt2 = itemData.e.v;
          if (styleData.t === 1) {
            grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
          } else {
            var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
            var percent = itemData.h.v;
            if (percent >= 1) {
              percent = 0.99;
            } else if (percent <= -1) {
              percent = -0.99;
            }
            var dist = rad * percent;
            var x2 = Math.cos(ang + itemData.a.v) * dist + pt1[0];
            var y2 = Math.sin(ang + itemData.a.v) * dist + pt1[1];
            grd = ctx.createRadialGradient(x2, y2, 0, pt1[0], pt1[1], rad);
          }
          var i;
          var len = styleData.g.p;
          var cValues = itemData.g.c;
          var opacity = 1;
          for (i = 0; i < len; i += 1) {
            if (itemData.g._hasOpacity && itemData.g._collapsable) {
              opacity = itemData.g.o[i * 2 + 1];
            }
            grd.addColorStop(cValues[i * 4] / 100, "rgba(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + "," + opacity + ")");
          }
          styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
      };
      CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
          styleElem.da = d.dashArray;
          styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) {
          styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        }
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
          styleElem.coOp = itemData.o.v * groupTransform.opacity;
        }
        if (itemData.w._mdf || this._isFirstFrame) {
          styleElem.wi = itemData.w.v;
        }
      };
      CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
      };
      function CVTextElement(data2, globalData2, comp2) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = "canvas";
        this.values = {
          fill: "rgba(0,0,0,0)",
          stroke: "rgba(0,0,0,0)",
          sWidth: 0,
          fValue: ""
        };
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
      CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
      CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
          hasFill = true;
          this.values.fill = this.buildColor(documentData.fc);
        } else {
          this.values.fill = "rgba(0,0,0,0)";
        }
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
          hasStroke = true;
          this.values.stroke = this.buildColor(documentData.sc);
          this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + "px " + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length;
        var charData;
        var shapeData;
        var k2;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 1e-3 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for (i = 0; i < len; i += 1) {
          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
          shapeData = charData && charData.data || {};
          matrixHelper.reset();
          if (singleShape && letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
          }
          shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
          jLen = shapes.length;
          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
          if (singleShape) {
            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
          }
          commands = createSizedArray(jLen - 1);
          var commandsCounter = 0;
          for (j = 0; j < jLen; j += 1) {
            if (shapes[j].ty === "sh") {
              kLen = shapes[j].ks.k.i.length;
              pathNodes = shapes[j].ks.k;
              pathArr = [];
              for (k2 = 1; k2 < kLen; k2 += 1) {
                if (k2 === 1) {
                  pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k2 - 1][0], pathNodes.o[k2 - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k2 - 1][0], pathNodes.o[k2 - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k2][0], pathNodes.i[k2][1], 0), matrixHelper.applyToY(pathNodes.i[k2][0], pathNodes.i[k2][1], 0), matrixHelper.applyToX(pathNodes.v[k2][0], pathNodes.v[k2][1], 0), matrixHelper.applyToY(pathNodes.v[k2][0], pathNodes.v[k2][1], 0));
              }
              pathArr.push(matrixHelper.applyToX(pathNodes.o[k2 - 1][0], pathNodes.o[k2 - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k2 - 1][0], pathNodes.o[k2 - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
              commands[commandsCounter] = pathArr;
              commandsCounter += 1;
            }
          }
          if (singleShape) {
            xPos += letters[i].l;
            xPos += trackingOffset;
          }
          if (this.textSpans[cnt]) {
            this.textSpans[cnt].elem = commands;
          } else {
            this.textSpans[cnt] = {
              elem: commands
            };
          }
          cnt += 1;
        }
      };
      CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap("butt");
        this.globalData.renderer.ctxLineJoin("miter");
        this.globalData.renderer.ctxMiterLimit(4);
        if (!this.data.singleShape) {
          this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        }
        var i;
        var len;
        var j;
        var jLen;
        var k2;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer2 = this.globalData.renderer;
        for (i = 0; i < len; i += 1) {
          if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
              renderer2.save();
              renderer2.ctxTransform(renderedLetter.p);
              renderer2.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
              if (renderedLetter && renderedLetter.fc) {
                if (lastFill !== renderedLetter.fc) {
                  renderer2.ctxFillStyle(renderedLetter.fc);
                  lastFill = renderedLetter.fc;
                }
              } else if (lastFill !== this.values.fill) {
                lastFill = this.values.fill;
                renderer2.ctxFillStyle(this.values.fill);
              }
              commands = this.textSpans[i].elem;
              jLen = commands.length;
              this.globalData.canvasContext.beginPath();
              for (j = 0; j < jLen; j += 1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k2 = 2; k2 < kLen; k2 += 6) {
                  this.globalData.canvasContext.bezierCurveTo(pathArr[k2], pathArr[k2 + 1], pathArr[k2 + 2], pathArr[k2 + 3], pathArr[k2 + 4], pathArr[k2 + 5]);
                }
              }
              this.globalData.canvasContext.closePath();
              renderer2.ctxFill();
            }
            if (this.stroke) {
              if (renderedLetter && renderedLetter.sw) {
                if (lastStrokeW !== renderedLetter.sw) {
                  lastStrokeW = renderedLetter.sw;
                  renderer2.ctxLineWidth(renderedLetter.sw);
                }
              } else if (lastStrokeW !== this.values.sWidth) {
                lastStrokeW = this.values.sWidth;
                renderer2.ctxLineWidth(this.values.sWidth);
              }
              if (renderedLetter && renderedLetter.sc) {
                if (lastStroke !== renderedLetter.sc) {
                  lastStroke = renderedLetter.sc;
                  renderer2.ctxStrokeStyle(renderedLetter.sc);
                }
              } else if (lastStroke !== this.values.stroke) {
                lastStroke = this.values.stroke;
                renderer2.ctxStrokeStyle(this.values.stroke);
              }
              commands = this.textSpans[i].elem;
              jLen = commands.length;
              this.globalData.canvasContext.beginPath();
              for (j = 0; j < jLen; j += 1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k2 = 2; k2 < kLen; k2 += 6) {
                  this.globalData.canvasContext.bezierCurveTo(pathArr[k2], pathArr[k2 + 1], pathArr[k2 + 2], pathArr[k2 + 3], pathArr[k2 + 4], pathArr[k2 + 5]);
                }
              }
              this.globalData.canvasContext.closePath();
              renderer2.ctxStroke();
            }
            if (renderedLetter) {
              this.globalData.renderer.restore();
            }
          }
        }
      };
      function CVImageElement(data2, globalData2, comp2) {
        this.assetData = globalData2.getAssetData(data2.refId);
        this.img = globalData2.imageLoader.getAsset(this.assetData);
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
      CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
      CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
      CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
          var canvas = createTag("canvas");
          canvas.width = this.assetData.w;
          canvas.height = this.assetData.h;
          var ctx = canvas.getContext("2d");
          var imgW = this.img.width;
          var imgH = this.img.height;
          var imgRel = imgW / imgH;
          var canvasRel = this.assetData.w / this.assetData.h;
          var widthCrop;
          var heightCrop;
          var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
          if (imgRel > canvasRel && par === "xMidYMid slice" || imgRel < canvasRel && par !== "xMidYMid slice") {
            heightCrop = imgH;
            widthCrop = heightCrop * canvasRel;
          } else {
            widthCrop = imgW;
            heightCrop = widthCrop / canvasRel;
          }
          ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
          this.img = canvas;
        }
      };
      CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
      };
      CVImageElement.prototype.destroy = function() {
        this.img = null;
      };
      function CVSolidElement(data2, globalData2, comp2) {
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
      CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
      CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
      CVSolidElement.prototype.renderInnerContent = function() {
        this.globalData.renderer.ctxFillStyle(this.data.sc);
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
      };
      function CanvasRendererBase() {
      }
      extendPrototype([BaseRenderer], CanvasRendererBase);
      CanvasRendererBase.prototype.createShape = function(data2) {
        return new CVShapeElement(data2, this.globalData, this);
      };
      CanvasRendererBase.prototype.createText = function(data2) {
        return new CVTextElement(data2, this.globalData, this);
      };
      CanvasRendererBase.prototype.createImage = function(data2) {
        return new CVImageElement(data2, this.globalData, this);
      };
      CanvasRendererBase.prototype.createSolid = function(data2) {
        return new CVSolidElement(data2, this.globalData, this);
      };
      CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
      CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
          return;
        }
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
      };
      CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
      };
      CanvasRendererBase.prototype.ctxFillStyle = function(value2) {
        this.canvasContext.fillStyle = value2;
      };
      CanvasRendererBase.prototype.ctxStrokeStyle = function(value2) {
        this.canvasContext.strokeStyle = value2;
      };
      CanvasRendererBase.prototype.ctxLineWidth = function(value2) {
        this.canvasContext.lineWidth = value2;
      };
      CanvasRendererBase.prototype.ctxLineCap = function(value2) {
        this.canvasContext.lineCap = value2;
      };
      CanvasRendererBase.prototype.ctxLineJoin = function(value2) {
        this.canvasContext.lineJoin = value2;
      };
      CanvasRendererBase.prototype.ctxMiterLimit = function(value2) {
        this.canvasContext.miterLimit = value2;
      };
      CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
      };
      CanvasRendererBase.prototype.ctxFillRect = function(x2, y2, w, h) {
        this.canvasContext.fillRect(x2, y2, w, h);
      };
      CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
      };
      CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.restore();
          return;
        }
        this.contextData.reset();
      };
      CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
      };
      CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.restore();
          return;
        }
        if (actionFlag) {
          this.globalData.blendMode = "source-over";
        }
        this.contextData.restore(actionFlag);
      };
      CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
          this.animationItem.container = createTag("canvas");
          var containerStyle = this.animationItem.container.style;
          containerStyle.width = "100%";
          containerStyle.height = "100%";
          var origin = "0px 0px 0px";
          containerStyle.transformOrigin = origin;
          containerStyle.mozTransformOrigin = origin;
          containerStyle.webkitTransformOrigin = origin;
          containerStyle["-webkit-transform"] = origin;
          containerStyle.contentVisibility = this.renderConfig.contentVisibility;
          this.animationItem.wrapper.appendChild(this.animationItem.container);
          this.canvasContext = this.animationItem.container.getContext("2d");
          if (this.renderConfig.className) {
            this.animationItem.container.setAttribute("class", this.renderConfig.className);
          }
          if (this.renderConfig.id) {
            this.animationItem.container.setAttribute("id", this.renderConfig.id);
          }
        } else {
          this.canvasContext = this.renderConfig.context;
        }
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
          w: animData.w,
          h: animData.h,
          sx: 0,
          sy: 0,
          tx: 0,
          ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
      };
      CanvasRendererBase.prototype.updateContainerSize = function(width2, height2) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width2) {
          elementWidth = width2;
          elementHeight = height2;
          this.canvasContext.canvas.width = elementWidth;
          this.canvasContext.canvas.height = elementHeight;
        } else {
          if (this.animationItem.wrapper && this.animationItem.container) {
            elementWidth = this.animationItem.wrapper.offsetWidth;
            elementHeight = this.animationItem.wrapper.offsetHeight;
          } else {
            elementWidth = this.canvasContext.canvas.width;
            elementHeight = this.canvasContext.canvas.height;
          }
          this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
          this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
          var par = this.renderConfig.preserveAspectRatio.split(" ");
          var fillType = par[1] || "meet";
          var pos = par[0] || "xMidYMid";
          var xPos = pos.substr(0, 4);
          var yPos = pos.substr(4);
          elementRel = elementWidth / elementHeight;
          animationRel = this.transformCanvas.w / this.transformCanvas.h;
          if (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice") {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
          } else {
            this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
          }
          if (xPos === "xMid" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) {
            this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
          } else if (xPos === "xMax" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) {
            this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
          } else {
            this.transformCanvas.tx = 0;
          }
          if (yPos === "YMid" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) {
            this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
          } else if (yPos === "YMax" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) {
            this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
          } else {
            this.transformCanvas.ty = 0;
          }
        } else if (this.renderConfig.preserveAspectRatio === "none") {
          this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
          this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
          this.transformCanvas.tx = 0;
          this.transformCanvas.ty = 0;
        } else {
          this.transformCanvas.sx = this.renderConfig.dpr;
          this.transformCanvas.sy = this.renderConfig.dpr;
          this.transformCanvas.tx = 0;
          this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
        this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
      };
      CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
          this.animationItem.wrapper.innerText = "";
        }
        var i;
        var len = this.layers ? this.layers.length : 0;
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.elements[i] && this.elements[i].destroy) {
            this.elements[i].destroy();
          }
        }
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
      };
      CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
          return;
        }
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) {
          this.checkLayers(num);
        }
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(num - this.layers[i].st);
          }
        }
        if (this.globalData._mdf) {
          if (this.renderConfig.clearCanvas === true) {
            this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
          } else {
            this.save();
          }
          for (i = len - 1; i >= 0; i -= 1) {
            if (this.completeLayers || this.elements[i]) {
              this.elements[i].renderFrame();
            }
          }
          if (this.renderConfig.clearCanvas !== true) {
            this.restore();
          }
        }
      };
      CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) {
          return;
        }
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
      };
      CanvasRendererBase.prototype.checkPendingElements = function() {
        while (this.pendingElements.length) {
          var element = this.pendingElements.pop();
          element.checkParenting();
        }
      };
      CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
      };
      CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
      };
      function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray("float32", 16);
        this.fillStyle = "";
        this.strokeStyle = "";
        this.lineWidth = "";
        this.lineCap = "";
        this.lineJoin = "";
        this.miterLimit = "";
        this.id = Math.random();
      }
      function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for (i = 0; i < len; i += 1) {
          var canvasContext = new CanvasContext();
          this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1;
        this.currentFillStyle = "";
        this.appliedFillStyle = "";
        this.currentStrokeStyle = "";
        this.appliedStrokeStyle = "";
        this.currentLineWidth = "";
        this.appliedLineWidth = "";
        this.currentLineCap = "";
        this.appliedLineCap = "";
        this.currentLineJoin = "";
        this.appliedLineJoin = "";
        this.appliedMiterLimit = "";
        this.currentMiterLimit = "";
      }
      CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for (i = this._length; i < newLength; i += 1) {
          this.stack[i] = new CanvasContext();
        }
        this._length = newLength;
      };
      CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
      };
      CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform2 = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for (i = 0; i < 16; i += 1) {
          arr[i] = transform2[i];
        }
        if (forceRestore) {
          this.nativeContext.restore();
          var prevStack = this.stack[this.cArrPos + 1];
          this.appliedFillStyle = prevStack.fillStyle;
          this.appliedStrokeStyle = prevStack.strokeStyle;
          this.appliedLineWidth = prevStack.lineWidth;
          this.appliedLineCap = prevStack.lineCap;
          this.appliedLineJoin = prevStack.lineJoin;
          this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform2[0], transform2[1], transform2[4], transform2[5], transform2[12], transform2[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
          this.nativeContext.globalAlpha = currentContext.opacity;
          this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
      };
      CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) {
          this.nativeContext.save();
        }
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) {
          this.duplicate();
        }
        var currentStack = this.stack[this.cArrPos];
        var i;
        for (i = 0; i < 16; i += 1) {
          currentStack.transform[i] = props[i];
        }
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
      };
      CVContextData.prototype.setOpacity = function(value2) {
        this.stack[this.cArrPos].opacity = value2;
      };
      CVContextData.prototype.setContext = function(value2) {
        this.nativeContext = value2;
      };
      CVContextData.prototype.fillStyle = function(value2) {
        if (this.stack[this.cArrPos].fillStyle !== value2) {
          this.currentFillStyle = value2;
          this.stack[this.cArrPos].fillStyle = value2;
        }
      };
      CVContextData.prototype.strokeStyle = function(value2) {
        if (this.stack[this.cArrPos].strokeStyle !== value2) {
          this.currentStrokeStyle = value2;
          this.stack[this.cArrPos].strokeStyle = value2;
        }
      };
      CVContextData.prototype.lineWidth = function(value2) {
        if (this.stack[this.cArrPos].lineWidth !== value2) {
          this.currentLineWidth = value2;
          this.stack[this.cArrPos].lineWidth = value2;
        }
      };
      CVContextData.prototype.lineCap = function(value2) {
        if (this.stack[this.cArrPos].lineCap !== value2) {
          this.currentLineCap = value2;
          this.stack[this.cArrPos].lineCap = value2;
        }
      };
      CVContextData.prototype.lineJoin = function(value2) {
        if (this.stack[this.cArrPos].lineJoin !== value2) {
          this.currentLineJoin = value2;
          this.stack[this.cArrPos].lineJoin = value2;
        }
      };
      CVContextData.prototype.miterLimit = function(value2) {
        if (this.stack[this.cArrPos].miterLimit !== value2) {
          this.currentMiterLimit = value2;
          this.stack[this.cArrPos].miterLimit = value2;
        }
      };
      CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props);
        var currentTransform = this.cTr;
        this.transformMat.multiply(currentTransform);
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props;
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
      };
      CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
          if (this.currentOpacity !== op) {
            this.nativeContext.globalAlpha = op;
            this.currentOpacity = op;
          }
          this.stack[this.cArrPos].opacity = currentOpacity;
        }
      };
      CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
          this.appliedFillStyle = this.currentFillStyle;
          this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
      };
      CVContextData.prototype.fillRect = function(x2, y2, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
          this.appliedFillStyle = this.currentFillStyle;
          this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x2, y2, w, h);
      };
      CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
          this.appliedStrokeStyle = this.currentStrokeStyle;
          this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
          this.appliedLineWidth = this.currentLineWidth;
          this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
          this.appliedLineCap = this.currentLineCap;
          this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
          this.appliedLineJoin = this.currentLineJoin;
          this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
          this.appliedMiterLimit = this.currentMiterLimit;
          this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
      };
      function CVCompElement(data2, globalData2, comp2) {
        this.completeLayers = false;
        this.layers = data2.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data2, globalData2, comp2);
        this.tm = data2.tm ? PropertyFactory.getProp(this, data2.tm, 0, globalData2.frameRate, this) : {
          _placeholder: true
        };
      }
      extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);
      CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.completeLayers || this.elements[i]) {
            this.elements[i].renderFrame();
          }
        }
      };
      CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for (i = len - 1; i >= 0; i -= 1) {
          if (this.elements[i]) {
            this.elements[i].destroy();
          }
        }
        this.layers = null;
        this.elements = null;
      };
      CVCompElement.prototype.createComp = function(data2) {
        return new CVCompElement(data2, this.globalData, this);
      };
      function CanvasRenderer(animationItem, config2) {
        this.animationItem = animationItem;
        this.renderConfig = {
          clearCanvas: config2 && config2.clearCanvas !== void 0 ? config2.clearCanvas : true,
          context: config2 && config2.context || null,
          progressiveLoad: config2 && config2.progressiveLoad || false,
          preserveAspectRatio: config2 && config2.preserveAspectRatio || "xMidYMid meet",
          imagePreserveAspectRatio: config2 && config2.imagePreserveAspectRatio || "xMidYMid slice",
          contentVisibility: config2 && config2.contentVisibility || "visible",
          className: config2 && config2.className || "",
          id: config2 && config2.id || "",
          runExpressions: !config2 || config2.runExpressions === void 0 || config2.runExpressions
        };
        this.renderConfig.dpr = config2 && config2.dpr || 1;
        if (this.animationItem.wrapper) {
          this.renderConfig.dpr = config2 && config2.dpr || window.devicePixelRatio || 1;
        }
        this.renderedFrame = -1;
        this.globalData = {
          frameNum: -1,
          _mdf: false,
          renderConfig: this.renderConfig,
          currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
        if (this.renderConfig.clearCanvas) {
          this.ctxTransform = this.contextData.transform.bind(this.contextData);
          this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
          this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
          this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
          this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
          this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
          this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
          this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
          this.ctxFill = this.contextData.fill.bind(this.contextData);
          this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
          this.ctxStroke = this.contextData.stroke.bind(this.contextData);
          this.save = this.contextData.save.bind(this.contextData);
        }
      }
      extendPrototype([CanvasRendererBase], CanvasRenderer);
      CanvasRenderer.prototype.createComp = function(data2) {
        return new CVCompElement(data2, this.globalData, this);
      };
      function HBaseElement() {
      }
      HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {
        },
        initRendererElement: function initRendererElement() {
          this.baseElement = createTag(this.data.tg || "div");
          if (this.data.hasMask) {
            this.svgElement = createNS("svg");
            this.layerElement = createNS("g");
            this.maskedElement = this.layerElement;
            this.svgElement.appendChild(this.layerElement);
            this.baseElement.appendChild(this.svgElement);
          } else {
            this.layerElement = this.baseElement;
          }
          styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
          this.renderableEffectsManager = new CVEffects(this);
          this.transformedElement = this.baseElement;
          this.maskedElement = this.layerElement;
          if (this.data.ln) {
            this.layerElement.setAttribute("id", this.data.ln);
          }
          if (this.data.cl) {
            this.layerElement.setAttribute("class", this.data.cl);
          }
          if (this.data.bm !== 0) {
            this.setBlendMode();
          }
        },
        renderElement: function renderElement() {
          var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
          if (this.finalTransform._matMdf) {
            var matrixValue = this.finalTransform.mat.toCSS();
            transformedElementStyle.transform = matrixValue;
            transformedElementStyle.webkitTransform = matrixValue;
          }
          if (this.finalTransform._opMdf) {
            transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
          }
        },
        renderFrame: function renderFrame() {
          if (this.data.hd || this.hidden) {
            return;
          }
          this.renderTransform();
          this.renderRenderable();
          this.renderElement();
          this.renderInnerContent();
          if (this._isFirstFrame) {
            this._isFirstFrame = false;
          }
        },
        destroy: function destroy() {
          this.layerElement = null;
          this.transformedElement = null;
          if (this.matteElement) {
            this.matteElement = null;
          }
          if (this.maskManager) {
            this.maskManager.destroy();
            this.maskManager = null;
          }
        },
        createRenderableComponents: function createRenderableComponents() {
          this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {
        },
        setMatte: function setMatte() {
        }
      };
      HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
      HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
      HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
      function HSolidElement(data2, globalData2, comp2) {
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);
      HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
          rect = createNS("rect");
          rect.setAttribute("width", this.data.sw);
          rect.setAttribute("height", this.data.sh);
          rect.setAttribute("fill", this.data.sc);
          this.svgElement.setAttribute("width", this.data.sw);
          this.svgElement.setAttribute("height", this.data.sh);
        } else {
          rect = createTag("div");
          rect.style.width = this.data.sw + "px";
          rect.style.height = this.data.sh + "px";
          rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
      };
      function HShapeElement(data2, globalData2, comp2) {
        this.shapes = [];
        this.shapesData = data2.shapes;
        this.stylesList = [];
        this.shapeModifiers = [];
        this.itemsData = [];
        this.processedElements = [];
        this.animatedContents = [];
        this.shapesContainer = createNS("g");
        this.initElement(data2, globalData2, comp2);
        this.prevViewData = [];
        this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        };
      }
      extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
      HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
      HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
          this.layerElement.appendChild(this.shapesContainer);
          cont = this.svgElement;
        } else {
          cont = createNS("svg");
          var size = this.comp.data ? this.comp.data : this.globalData.compSize;
          cont.setAttribute("width", size.w);
          cont.setAttribute("height", size.h);
          cont.appendChild(this.shapesContainer);
          this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
      };
      HShapeElement.prototype.getTransformedPoint = function(transformers, point4) {
        var i;
        var len = transformers.length;
        for (i = 0; i < len; i += 1) {
          point4 = transformers[i].mProps.v.applyToPointArray(point4[0], point4[1], 0);
        }
        return point4;
      };
      HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) {
          return;
        }
        for (i = 0; i < len - 1; i += 1) {
          vPoint = this.getTransformedPoint(transformers, shape.v[i]);
          oPoint = this.getTransformedPoint(transformers, shape.o[i]);
          nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
          nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
          this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
          vPoint = this.getTransformedPoint(transformers, shape.v[i]);
          oPoint = this.getTransformedPoint(transformers, shape.o[i]);
          nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
          nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
          this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
      };
      HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
      };
      HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      };
      HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
      };
      HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];
        for (var a2, b, c2, t, b2ac, t12, t2, i = 0; i < 2; ++i) {
          b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
          a2 = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
          c2 = 3 * p1[i] - 3 * p0[i];
          b |= 0;
          a2 |= 0;
          c2 |= 0;
          if (a2 === 0 && b === 0) ; else if (a2 === 0) {
            t = -c2 / b;
            if (t > 0 && t < 1) {
              bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            }
          } else {
            b2ac = b * b - 4 * c2 * a2;
            if (b2ac >= 0) {
              t12 = (-b + bmSqrt(b2ac)) / (2 * a2);
              if (t12 > 0 && t12 < 1) bounds[i].push(this.calculateF(t12, p0, p1, p2, p3, i));
              t2 = (-b - bmSqrt(b2ac)) / (2 * a2);
              if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
            }
          }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
      };
      HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
      };
      HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for (i = 0; i < len; i += 1) {
          if (itemsData[i] && itemsData[i].sh) {
            this.calculateShapeBoundingBox(itemsData[i], boundingBox);
          } else if (itemsData[i] && itemsData[i].it) {
            this.calculateBoundingBox(itemsData[i].it, boundingBox);
          } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
            this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
          }
        }
      };
      HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width2 = 0;
        if (widthProperty.keyframes) {
          for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
            var kfw = widthProperty.keyframes[i].s;
            if (kfw > width2) {
              width2 = kfw;
            }
          }
          width2 *= widthProperty.mult;
        } else {
          width2 = widthProperty.v * widthProperty.mult;
        }
        boundingBox.x -= width2;
        boundingBox.xMax += width2;
        boundingBox.y -= width2;
        boundingBox.yMax += width2;
      };
      HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
      };
      HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
          var tempBoundingBox = this.tempBoundingBox;
          var max4 = 999999;
          tempBoundingBox.x = max4;
          tempBoundingBox.xMax = -max4;
          tempBoundingBox.y = max4;
          tempBoundingBox.yMax = -max4;
          this.calculateBoundingBox(this.itemsData, tempBoundingBox);
          tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
          tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
          if (this.currentBoxContains(tempBoundingBox)) {
            return;
          }
          var changed = false;
          if (this.currentBBox.w !== tempBoundingBox.width) {
            this.currentBBox.w = tempBoundingBox.width;
            this.shapeCont.setAttribute("width", tempBoundingBox.width);
            changed = true;
          }
          if (this.currentBBox.h !== tempBoundingBox.height) {
            this.currentBBox.h = tempBoundingBox.height;
            this.shapeCont.setAttribute("height", tempBoundingBox.height);
            changed = true;
          }
          if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
            this.currentBBox.w = tempBoundingBox.width;
            this.currentBBox.h = tempBoundingBox.height;
            this.currentBBox.x = tempBoundingBox.x;
            this.currentBBox.y = tempBoundingBox.y;
            this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
            var shapeStyle = this.shapeCont.style;
            var shapeTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            shapeStyle.transform = shapeTransform;
            shapeStyle.webkitTransform = shapeTransform;
          }
        }
      };
      function HTextElement(data2, globalData2, comp2) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        };
        this.renderType = "svg";
        this.isMasked = false;
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);
      HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
          this.renderType = "svg";
          this.compW = this.comp.data.w;
          this.compH = this.comp.data.h;
          this.svgElement.setAttribute("width", this.compW);
          this.svgElement.setAttribute("height", this.compH);
          var g = createNS("g");
          this.maskedElement.appendChild(g);
          this.innerElem = g;
        } else {
          this.renderType = "html";
          this.innerElem = this.layerElement;
        }
        this.checkParenting();
      };
      HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : "rgba(0,0,0,0)";
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
          innerElemStyle.stroke = this.buildColor(documentData.sc);
          innerElemStyle.strokeWidth = documentData.sw + "px";
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
          innerElemStyle.fontSize = documentData.finalSize + "px";
          innerElemStyle.lineHeight = documentData.finalSize + "px";
          if (fontData.fClass) {
            this.innerElem.className = fontData.fClass;
          } else {
            innerElemStyle.fontFamily = fontData.fFamily;
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            innerElemStyle.fontStyle = fStyle;
            innerElemStyle.fontWeight = fWeight;
          }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = "";
        var cnt = 0;
        for (i = 0; i < len; i += 1) {
          if (this.globalData.fontManager.chars) {
            if (!this.textPaths[cnt]) {
              tSpan = createNS("path");
              tSpan.setAttribute("stroke-linecap", lineCapEnum[1]);
              tSpan.setAttribute("stroke-linejoin", lineJoinEnum[2]);
              tSpan.setAttribute("stroke-miterlimit", "4");
            } else {
              tSpan = this.textPaths[cnt];
            }
            if (!this.isMasked) {
              if (this.textSpans[cnt]) {
                tParent = this.textSpans[cnt];
                tCont = tParent.children[0];
              } else {
                tParent = createTag("div");
                tParent.style.lineHeight = 0;
                tCont = createNS("svg");
                tCont.appendChild(tSpan);
                styleDiv(tParent);
              }
            }
          } else if (!this.isMasked) {
            if (this.textSpans[cnt]) {
              tParent = this.textSpans[cnt];
              tSpan = this.textPaths[cnt];
            } else {
              tParent = createTag("span");
              styleDiv(tParent);
              tSpan = createTag("span");
              styleDiv(tSpan);
              tParent.appendChild(tSpan);
            }
          } else {
            tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS("text");
          }
          if (this.globalData.fontManager.chars) {
            var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if (charData) {
              shapeData = charData.data;
            } else {
              shapeData = null;
            }
            matrixHelper.reset();
            if (shapeData && shapeData.shapes && shapeData.shapes.length) {
              shapes = shapeData.shapes[0].it;
              matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
              shapeStr = this.createPathShape(matrixHelper, shapes);
              tSpan.setAttribute("d", shapeStr);
            }
            if (!this.isMasked) {
              this.innerElem.appendChild(tParent);
              if (shapeData && shapeData.shapes) {
                document.body.appendChild(tCont);
                var boundingBox = tCont.getBBox();
                tCont.setAttribute("width", boundingBox.width + 2);
                tCont.setAttribute("height", boundingBox.height + 2);
                tCont.setAttribute("viewBox", boundingBox.x - 1 + " " + (boundingBox.y - 1) + " " + (boundingBox.width + 2) + " " + (boundingBox.height + 2));
                var tContStyle = tCont.style;
                var tContTranslation = "translate(" + (boundingBox.x - 1) + "px," + (boundingBox.y - 1) + "px)";
                tContStyle.transform = tContTranslation;
                tContStyle.webkitTransform = tContTranslation;
                letters[i].yOffset = boundingBox.y - 1;
              } else {
                tCont.setAttribute("width", 1);
                tCont.setAttribute("height", 1);
              }
              tParent.appendChild(tCont);
            } else {
              this.innerElem.appendChild(tSpan);
            }
          } else {
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
            if (!this.isMasked) {
              this.innerElem.appendChild(tParent);
              var tStyle = tSpan.style;
              var tSpanTranslation = "translate3d(0," + -documentData.finalSize / 1.2 + "px,0)";
              tStyle.transform = tSpanTranslation;
              tStyle.webkitTransform = tSpanTranslation;
            } else {
              this.innerElem.appendChild(tSpan);
            }
          }
          if (!this.isMasked) {
            this.textSpans[cnt] = tParent;
          } else {
            this.textSpans[cnt] = tSpan;
          }
          this.textSpans[cnt].style.display = "block";
          this.textPaths[cnt] = tSpan;
          cnt += 1;
        }
        while (cnt < this.textSpans.length) {
          this.textSpans[cnt].style.display = "none";
          cnt += 1;
        }
      };
      HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
          if (!this._isFirstFrame && !this.lettersChangedFlag) {
            return;
          }
          if (this.isMasked && this.finalTransform._matMdf) {
            this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH);
            svgStyle = this.svgElement.style;
            var translation = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
            svgStyle.transform = translation;
            svgStyle.webkitTransform = translation;
          }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
          return;
        }
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for (i = 0; i < len; i += 1) {
          if (letters[i].n) {
            count += 1;
          } else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
              if (!this.isMasked) {
                textSpan.style.webkitTransform = renderedLetter.m;
                textSpan.style.transform = renderedLetter.m;
              } else {
                textSpan.setAttribute("transform", renderedLetter.m);
              }
            }
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) {
              textPath.setAttribute("stroke-width", renderedLetter.sw);
            }
            if (renderedLetter.sc && renderedLetter._mdf.sc) {
              textPath.setAttribute("stroke", renderedLetter.sc);
            }
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
              textPath.setAttribute("fill", renderedLetter.fc);
              textPath.style.color = renderedLetter.fc;
            }
          }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var boundingBox = this.innerElem.getBBox();
          if (this.currentBBox.w !== boundingBox.width) {
            this.currentBBox.w = boundingBox.width;
            this.svgElement.setAttribute("width", boundingBox.width);
          }
          if (this.currentBBox.h !== boundingBox.height) {
            this.currentBBox.h = boundingBox.height;
            this.svgElement.setAttribute("height", boundingBox.height);
          }
          var margin = 1;
          if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
            this.currentBBox.w = boundingBox.width + margin * 2;
            this.currentBBox.h = boundingBox.height + margin * 2;
            this.currentBBox.x = boundingBox.x - margin;
            this.currentBBox.y = boundingBox.y - margin;
            this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
            svgStyle = this.svgElement.style;
            var svgTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            svgStyle.transform = svgTransform;
            svgStyle.webkitTransform = svgTransform;
          }
        }
      };
      function HCameraElement(data2, globalData2, comp2) {
        this.initFrame();
        this.initBaseData(data2, globalData2, comp2);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data2.pe, 0, 0, this);
        if (data2.ks.p.s) {
          this.px = getProp(this, data2.ks.p.x, 1, 0, this);
          this.py = getProp(this, data2.ks.p.y, 1, 0, this);
          this.pz = getProp(this, data2.ks.p.z, 1, 0, this);
        } else {
          this.p = getProp(this, data2.ks.p, 1, 0, this);
        }
        if (data2.ks.a) {
          this.a = getProp(this, data2.ks.a, 1, 0, this);
        }
        if (data2.ks.or.k.length && data2.ks.or.k[0].to) {
          var i;
          var len = data2.ks.or.k.length;
          for (i = 0; i < len; i += 1) {
            data2.ks.or.k[i].to = null;
            data2.ks.or.k[i].ti = null;
          }
        }
        this.or = getProp(this, data2.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data2.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data2.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data2.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true;
        this.finalTransform = {
          mProp: this
        };
      }
      extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
      HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp2;
        var perspectiveStyle;
        var containerStyle;
        for (i = 0; i < len; i += 1) {
          comp2 = this.comp.threeDElements[i];
          if (comp2.type === "3d") {
            perspectiveStyle = comp2.perspectiveElem.style;
            containerStyle = comp2.container.style;
            var perspective = this.pe.v + "px";
            var origin = "0px 0px 0px";
            var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            perspectiveStyle.perspective = perspective;
            perspectiveStyle.webkitPerspective = perspective;
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            perspectiveStyle.transform = matrix;
            perspectiveStyle.webkitTransform = matrix;
          }
        }
      };
      HCameraElement.prototype.createElements = function() {
      };
      HCameraElement.prototype.hide = function() {
      };
      HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
          len = this.hierarchy.length;
          for (i = 0; i < len; i += 1) {
            _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
          }
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
          this.mat.reset();
          if (this.hierarchy) {
            len = this.hierarchy.length - 1;
            for (i = len; i >= 0; i -= 1) {
              var mTransf = this.hierarchy[i].finalTransform.mProp;
              this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
              this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
              this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
              this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
              this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
            }
          }
          if (this.p) {
            this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
          } else {
            this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
          }
          if (this.a) {
            var diffVector;
            if (this.p) {
              diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
            } else {
              diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
            }
            var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
            var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
            var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
            var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
            var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
            this.mat.rotateY(mRotationY).rotateX(-mRotationX);
          }
          this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
          this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
          this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
          this.mat.translate(0, 0, this.pe.v);
          var hasMatrixChanged = !this._prevMat.equals(this.mat);
          if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
            len = this.comp.threeDElements.length;
            var comp2;
            var perspectiveStyle;
            var containerStyle;
            for (i = 0; i < len; i += 1) {
              comp2 = this.comp.threeDElements[i];
              if (comp2.type === "3d") {
                if (hasMatrixChanged) {
                  var matValue = this.mat.toCSS();
                  containerStyle = comp2.container.style;
                  containerStyle.transform = matValue;
                  containerStyle.webkitTransform = matValue;
                }
                if (this.pe._mdf) {
                  perspectiveStyle = comp2.perspectiveElem.style;
                  perspectiveStyle.perspective = this.pe.v + "px";
                  perspectiveStyle.webkitPerspective = this.pe.v + "px";
                }
              }
            }
            this.mat.clone(this._prevMat);
          }
        }
        this._isFirstFrame = false;
      };
      HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
      };
      HCameraElement.prototype.destroy = function() {
      };
      HCameraElement.prototype.getBaseElement = function() {
        return null;
      };
      function HImageElement(data2, globalData2, comp2) {
        this.assetData = globalData2.getAssetData(data2.refId);
        this.initElement(data2, globalData2, comp2);
      }
      extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);
      HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
          this.imageElem = createNS("image");
          this.imageElem.setAttribute("width", this.assetData.w + "px");
          this.imageElem.setAttribute("height", this.assetData.h + "px");
          this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
          this.layerElement.appendChild(this.imageElem);
          this.baseElement.setAttribute("width", this.assetData.w);
          this.baseElement.setAttribute("height", this.assetData.h);
        } else {
          this.layerElement.appendChild(img);
        }
        img.crossOrigin = "anonymous";
        img.src = assetPath;
        if (this.data.ln) {
          this.baseElement.setAttribute("id", this.data.ln);
        }
      };
      function HybridRendererBase(animationItem, config2) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
          className: config2 && config2.className || "",
          imagePreserveAspectRatio: config2 && config2.imagePreserveAspectRatio || "xMidYMid slice",
          hideOnTransparent: !(config2 && config2.hideOnTransparent === false),
          filterSize: {
            width: config2 && config2.filterSize && config2.filterSize.width || "400%",
            height: config2 && config2.filterSize && config2.filterSize.height || "400%",
            x: config2 && config2.filterSize && config2.filterSize.x || "-100%",
            y: config2 && config2.filterSize && config2.filterSize.y || "-100%"
          }
        };
        this.globalData = {
          _mdf: false,
          frameNum: -1,
          renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
      }
      extendPrototype([BaseRenderer], HybridRendererBase);
      HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
      HybridRendererBase.prototype.checkPendingElements = function() {
        while (this.pendingElements.length) {
          var element = this.pendingElements.pop();
          element.checkParenting();
        }
      };
      HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) {
          return;
        }
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
          if (this.threeDElements) {
            this.addTo3dContainer(newDOMElement, pos);
          } else {
            var i = 0;
            var nextDOMElement;
            var nextLayer;
            var tmpDOMElement;
            while (i < pos) {
              if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                nextLayer = this.elements[i];
                tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                nextDOMElement = tmpDOMElement || nextDOMElement;
              }
              i += 1;
            }
            if (nextDOMElement) {
              if (!layer.ddd || !this.supports3d) {
                this.layerElement.insertBefore(newDOMElement, nextDOMElement);
              }
            } else if (!layer.ddd || !this.supports3d) {
              this.layerElement.appendChild(newDOMElement);
            }
          }
        } else {
          this.addTo3dContainer(newDOMElement, pos);
        }
      };
      HybridRendererBase.prototype.createShape = function(data2) {
        if (!this.supports3d) {
          return new SVGShapeElement(data2, this.globalData, this);
        }
        return new HShapeElement(data2, this.globalData, this);
      };
      HybridRendererBase.prototype.createText = function(data2) {
        if (!this.supports3d) {
          return new SVGTextLottieElement(data2, this.globalData, this);
        }
        return new HTextElement(data2, this.globalData, this);
      };
      HybridRendererBase.prototype.createCamera = function(data2) {
        this.camera = new HCameraElement(data2, this.globalData, this);
        return this.camera;
      };
      HybridRendererBase.prototype.createImage = function(data2) {
        if (!this.supports3d) {
          return new IImageElement(data2, this.globalData, this);
        }
        return new HImageElement(data2, this.globalData, this);
      };
      HybridRendererBase.prototype.createSolid = function(data2) {
        if (!this.supports3d) {
          return new ISolidElement(data2, this.globalData, this);
        }
        return new HSolidElement(data2, this.globalData, this);
      };
      HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
      HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while (i < len) {
          if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
            return this.threeDElements[i].perspectiveElem;
          }
          i += 1;
        }
        return null;
      };
      HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag("div");
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag("div");
        styleDiv(container);
        if (type === "3d") {
          style = perspectiveElem.style;
          style.width = this.globalData.compSize.w + "px";
          style.height = this.globalData.compSize.h + "px";
          var center = "50% 50%";
          style.webkitTransformOrigin = center;
          style.mozTransformOrigin = center;
          style.transformOrigin = center;
          containerStyle = container.style;
          var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          containerStyle.transform = matrix;
          containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container);
        var threeDContainerData = {
          container,
          perspectiveElem,
          startPos: pos,
          endPos: pos,
          type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
      };
      HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = "";
        for (i = 0; i < len; i += 1) {
          if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== "3d") {
              currentContainer = "3d";
              lastThreeDContainerData = this.createThreeDContainer(i, "3d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
          } else {
            if (currentContainer !== "2d") {
              currentContainer = "2d";
              lastThreeDContainerData = this.createThreeDContainer(i, "2d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
          }
        }
        len = this.threeDElements.length;
        for (i = len - 1; i >= 0; i -= 1) {
          this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
        }
      };
      HybridRendererBase.prototype.addTo3dContainer = function(elem2, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while (i < len) {
          if (pos <= this.threeDElements[i].endPos) {
            var j = this.threeDElements[i].startPos;
            var nextElement;
            while (j < pos) {
              if (this.elements[j] && this.elements[j].getBaseElement) {
                nextElement = this.elements[j].getBaseElement();
              }
              j += 1;
            }
            if (nextElement) {
              this.threeDElements[i].container.insertBefore(elem2, nextElement);
            } else {
              this.threeDElements[i].container.appendChild(elem2);
            }
            break;
          }
          i += 1;
        }
      };
      HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag("div");
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + "px";
        style.height = animData.h + "px";
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = "flat";
        style.mozTransformStyle = "flat";
        style.webkitTransformStyle = "flat";
        if (this.renderConfig.className) {
          resizerElem.setAttribute("class", this.renderConfig.className);
        }
        wrapper.appendChild(resizerElem);
        style.overflow = "hidden";
        var svg = createNS("svg");
        svg.setAttribute("width", "1");
        svg.setAttribute("height", "1");
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS("defs");
        svg.appendChild(defs);
        this.data = animData;
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
      };
      HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) {
          this.animationItem.wrapper.innerText = "";
        }
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for (i = 0; i < len; i += 1) {
          if (this.elements[i] && this.elements[i].destroy) {
            this.elements[i].destroy();
          }
        }
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
      };
      HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
          sx = elementWidth / this.globalData.compSize.w;
          sy = elementWidth / this.globalData.compSize.w;
          tx = 0;
          ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
          sx = elementHeight / this.globalData.compSize.h;
          sy = elementHeight / this.globalData.compSize.h;
          tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
          ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = "matrix3d(" + sx + ",0,0,0,0," + sy + ",0,0,0,0,1,0," + tx + "," + ty + ",0,1)";
        style.transform = style.webkitTransform;
      };
      HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
      HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
      };
      HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
      };
      HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) {
          this.camera.setup();
        } else {
          var cWidth = this.globalData.compSize.w;
          var cHeight = this.globalData.compSize.h;
          var i;
          var len = this.threeDElements.length;
          for (i = 0; i < len; i += 1) {
            var style = this.threeDElements[i].perspectiveElem.style;
            style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + "px";
            style.perspective = style.webkitPerspective;
          }
        }
      };
      HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag("div");
        for (i = 0; i < len; i += 1) {
          if (assets[i].xt) {
            var comp2 = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp2.initExpressions();
            this.globalData.projectInterface.registerComposition(comp2);
          }
        }
      };
      function HCompElement(data2, globalData2, comp2) {
        this.layers = data2.layers;
        this.supports3d = !data2.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data2, globalData2, comp2);
        this.tm = data2.tm ? PropertyFactory.getProp(this, data2.tm, 0, globalData2.frameRate, this) : {
          _placeholder: true
        };
      }
      extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
      HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
      HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements();
        if (this.data.hasMask) {
          this.svgElement.setAttribute("width", this.data.w);
          this.svgElement.setAttribute("height", this.data.h);
          this.transformedElement = this.baseElement;
        } else {
          this.transformedElement = this.layerElement;
        }
      };
      HCompElement.prototype.addTo3dContainer = function(elem2, pos) {
        var j = 0;
        var nextElement;
        while (j < pos) {
          if (this.elements[j] && this.elements[j].getBaseElement) {
            nextElement = this.elements[j].getBaseElement();
          }
          j += 1;
        }
        if (nextElement) {
          this.layerElement.insertBefore(elem2, nextElement);
        } else {
          this.layerElement.appendChild(elem2);
        }
      };
      HCompElement.prototype.createComp = function(data2) {
        if (!this.supports3d) {
          return new SVGCompElement(data2, this.globalData, this);
        }
        return new HCompElement(data2, this.globalData, this);
      };
      function HybridRenderer(animationItem, config2) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
          className: config2 && config2.className || "",
          imagePreserveAspectRatio: config2 && config2.imagePreserveAspectRatio || "xMidYMid slice",
          hideOnTransparent: !(config2 && config2.hideOnTransparent === false),
          filterSize: {
            width: config2 && config2.filterSize && config2.filterSize.width || "400%",
            height: config2 && config2.filterSize && config2.filterSize.height || "400%",
            x: config2 && config2.filterSize && config2.filterSize.x || "-100%",
            y: config2 && config2.filterSize && config2.filterSize.y || "-100%"
          },
          runExpressions: !config2 || config2.runExpressions === void 0 || config2.runExpressions
        };
        this.globalData = {
          _mdf: false,
          frameNum: -1,
          renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
      }
      extendPrototype([HybridRendererBase], HybridRenderer);
      HybridRenderer.prototype.createComp = function(data2) {
        if (!this.supports3d) {
          return new SVGCompElement(data2, this.globalData, this);
        }
        return new HCompElement(data2, this.globalData, this);
      };
      var CompExpressionInterface = /* @__PURE__ */ function() {
        return function(comp2) {
          function _thisLayerFunction(name2) {
            var i = 0;
            var len = comp2.layers.length;
            while (i < len) {
              if (comp2.layers[i].nm === name2 || comp2.layers[i].ind === name2) {
                return comp2.elements[i].layerInterface;
              }
              i += 1;
            }
            return null;
          }
          Object.defineProperty(_thisLayerFunction, "_name", {
            value: comp2.data.nm
          });
          _thisLayerFunction.layer = _thisLayerFunction;
          _thisLayerFunction.pixelAspect = 1;
          _thisLayerFunction.height = comp2.data.h || comp2.globalData.compSize.h;
          _thisLayerFunction.width = comp2.data.w || comp2.globalData.compSize.w;
          _thisLayerFunction.pixelAspect = 1;
          _thisLayerFunction.frameDuration = 1 / comp2.globalData.frameRate;
          _thisLayerFunction.displayStartTime = 0;
          _thisLayerFunction.numLayers = comp2.layers.length;
          return _thisLayerFunction;
        };
      }();
      function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$2 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$2 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$2(obj);
      }
      function seedRandom(pool, math) {
        var global2 = this, width2 = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width2, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask2 = width2 - 1, nodecrypto;
        function seedrandom(seed, options, callback) {
          var key2 = [];
          options = options === true ? {
            entropy: true
          } : options || {};
          var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key2);
          var arc4 = new ARC4(key2);
          var prng = function prng2() {
            var n = arc4.g(chunks), d = startdenom, x2 = 0;
            while (n < significance) {
              n = (n + x2) * width2;
              d *= width2;
              x2 = arc4.g(1);
            }
            while (n >= overflow) {
              n /= 2;
              d /= 2;
              x2 >>>= 1;
            }
            return (n + x2) / d;
          };
          prng.int32 = function() {
            return arc4.g(4) | 0;
          };
          prng.quick = function() {
            return arc4.g(4) / 4294967296;
          };
          prng["double"] = prng;
          mixkey(tostring(arc4.S), pool);
          return (options.pass || callback || function(prng2, seed2, is_math_call, state) {
            if (state) {
              if (state.S) {
                copy3(state, arc4);
              }
              prng2.state = function() {
                return copy3(arc4, {});
              };
            }
            if (is_math_call) {
              math[rngname] = prng2;
              return seed2;
            } else return prng2;
          })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
        }
        math["seed" + rngname] = seedrandom;
        function ARC4(key2) {
          var t, keylen = key2.length, me = this, i = 0, j = me.i = me.j = 0, s2 = me.S = [];
          if (!keylen) {
            key2 = [keylen++];
          }
          while (i < width2) {
            s2[i] = i++;
          }
          for (i = 0; i < width2; i++) {
            s2[i] = s2[j = mask2 & j + key2[i % keylen] + (t = s2[i])];
            s2[j] = t;
          }
          me.g = function(count) {
            var t2, r2 = 0, i2 = me.i, j2 = me.j, s3 = me.S;
            while (count--) {
              t2 = s3[i2 = mask2 & i2 + 1];
              r2 = r2 * width2 + s3[mask2 & (s3[i2] = s3[j2 = mask2 & j2 + t2]) + (s3[j2] = t2)];
            }
            me.i = i2;
            me.j = j2;
            return r2;
          };
        }
        function copy3(f, t) {
          t.i = f.i;
          t.j = f.j;
          t.S = f.S.slice();
          return t;
        }
        function flatten(obj, depth) {
          var result = [], typ = _typeof$2(obj), prop;
          if (depth && typ == "object") {
            for (prop in obj) {
              try {
                result.push(flatten(obj[prop], depth - 1));
              } catch (e) {
              }
            }
          }
          return result.length ? result : typ == "string" ? obj : obj + "\0";
        }
        function mixkey(seed, key2) {
          var stringseed = seed + "", smear, j = 0;
          while (j < stringseed.length) {
            key2[mask2 & j] = mask2 & (smear ^= key2[mask2 & j] * 19) + stringseed.charCodeAt(j++);
          }
          return tostring(key2);
        }
        function autoseed() {
          try {
            if (nodecrypto) ;
            var out = new Uint8Array(width2);
            (global2.crypto || global2.msCrypto).getRandomValues(out);
            return tostring(out);
          } catch (e) {
            var browser = global2.navigator, plugins = browser && browser.plugins;
            return [+/* @__PURE__ */ new Date(), global2, plugins, global2.screen, tostring(pool)];
          }
        }
        function tostring(a2) {
          return String.fromCharCode.apply(0, a2);
        }
        mixkey(math.random(), pool);
      }
      function initialize$2(BMMath2) {
        seedRandom([], BMMath2);
      }
      var propTypes = {
        SHAPE: "shape"
      };
      function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof$1 = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof$1 = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof$1(obj);
      }
      var ExpressionManager = function() {
        var ob = {};
        var Math = BMMath;
        var window = null;
        var document = null;
        var XMLHttpRequest = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
          _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
          return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
          return tOfV === "number" || v instanceof Number || tOfV === "boolean" || tOfV === "string";
        }
        function $bm_neg(a2) {
          var tOfA = _typeof$1(a2);
          if (tOfA === "number" || a2 instanceof Number || tOfA === "boolean") {
            return -a2;
          }
          if ($bm_isInstanceOfArray(a2)) {
            var i;
            var lenA = a2.length;
            var retArr = [];
            for (i = 0; i < lenA; i += 1) {
              retArr[i] = -a2[i];
            }
            return retArr;
          }
          if (a2.propType) {
            return a2.v;
          }
          return -a2;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(a2, b) {
          var tOfA = _typeof$1(a2);
          var tOfB = _typeof$1(b);
          if (isNumerable(tOfA, a2) && isNumerable(tOfB, b) || tOfA === "string" || tOfB === "string") {
            return a2 + b;
          }
          if ($bm_isInstanceOfArray(a2) && isNumerable(tOfB, b)) {
            a2 = a2.slice(0);
            a2[0] += b;
            return a2;
          }
          if (isNumerable(tOfA, a2) && $bm_isInstanceOfArray(b)) {
            b = b.slice(0);
            b[0] = a2 + b[0];
            return b;
          }
          if ($bm_isInstanceOfArray(a2) && $bm_isInstanceOfArray(b)) {
            var i = 0;
            var lenA = a2.length;
            var lenB = b.length;
            var retArr = [];
            while (i < lenA || i < lenB) {
              if ((typeof a2[i] === "number" || a2[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) {
                retArr[i] = a2[i] + b[i];
              } else {
                retArr[i] = b[i] === void 0 ? a2[i] : a2[i] || b[i];
              }
              i += 1;
            }
            return retArr;
          }
          return 0;
        }
        var add = sum;
        function sub(a2, b) {
          var tOfA = _typeof$1(a2);
          var tOfB = _typeof$1(b);
          if (isNumerable(tOfA, a2) && isNumerable(tOfB, b)) {
            if (tOfA === "string") {
              a2 = parseInt(a2, 10);
            }
            if (tOfB === "string") {
              b = parseInt(b, 10);
            }
            return a2 - b;
          }
          if ($bm_isInstanceOfArray(a2) && isNumerable(tOfB, b)) {
            a2 = a2.slice(0);
            a2[0] -= b;
            return a2;
          }
          if (isNumerable(tOfA, a2) && $bm_isInstanceOfArray(b)) {
            b = b.slice(0);
            b[0] = a2 - b[0];
            return b;
          }
          if ($bm_isInstanceOfArray(a2) && $bm_isInstanceOfArray(b)) {
            var i = 0;
            var lenA = a2.length;
            var lenB = b.length;
            var retArr = [];
            while (i < lenA || i < lenB) {
              if ((typeof a2[i] === "number" || a2[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) {
                retArr[i] = a2[i] - b[i];
              } else {
                retArr[i] = b[i] === void 0 ? a2[i] : a2[i] || b[i];
              }
              i += 1;
            }
            return retArr;
          }
          return 0;
        }
        function mul(a2, b) {
          var tOfA = _typeof$1(a2);
          var tOfB = _typeof$1(b);
          var arr;
          if (isNumerable(tOfA, a2) && isNumerable(tOfB, b)) {
            return a2 * b;
          }
          var i;
          var len;
          if ($bm_isInstanceOfArray(a2) && isNumerable(tOfB, b)) {
            len = a2.length;
            arr = createTypedArray("float32", len);
            for (i = 0; i < len; i += 1) {
              arr[i] = a2[i] * b;
            }
            return arr;
          }
          if (isNumerable(tOfA, a2) && $bm_isInstanceOfArray(b)) {
            len = b.length;
            arr = createTypedArray("float32", len);
            for (i = 0; i < len; i += 1) {
              arr[i] = a2 * b[i];
            }
            return arr;
          }
          return 0;
        }
        function div(a2, b) {
          var tOfA = _typeof$1(a2);
          var tOfB = _typeof$1(b);
          var arr;
          if (isNumerable(tOfA, a2) && isNumerable(tOfB, b)) {
            return a2 / b;
          }
          var i;
          var len;
          if ($bm_isInstanceOfArray(a2) && isNumerable(tOfB, b)) {
            len = a2.length;
            arr = createTypedArray("float32", len);
            for (i = 0; i < len; i += 1) {
              arr[i] = a2[i] / b;
            }
            return arr;
          }
          if (isNumerable(tOfA, a2) && $bm_isInstanceOfArray(b)) {
            len = b.length;
            arr = createTypedArray("float32", len);
            for (i = 0; i < len; i += 1) {
              arr[i] = a2 / b[i];
            }
            return arr;
          }
          return 0;
        }
        function mod(a2, b) {
          if (typeof a2 === "string") {
            a2 = parseInt(a2, 10);
          }
          if (typeof b === "string") {
            b = parseInt(b, 10);
          }
          return a2 % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min3, max4) {
          if (min3 > max4) {
            var mm = max4;
            max4 = min3;
            min3 = mm;
          }
          return Math.min(Math.max(num, min3), max4);
        }
        function radiansToDegrees(val2) {
          return val2 / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val2) {
          return val2 * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [0, 0, 0, 0, 0, 0];
        function length(arr1, arr2) {
          if (typeof arr1 === "number" || arr1 instanceof Number) {
            arr2 = arr2 || 0;
            return Math.abs(arr1 - arr2);
          }
          if (!arr2) {
            arr2 = helperLengthArray;
          }
          var i;
          var len = Math.min(arr1.length, arr2.length);
          var addedLength = 0;
          for (i = 0; i < len; i += 1) {
            addedLength += Math.pow(arr2[i] - arr1[i], 2);
          }
          return Math.sqrt(addedLength);
        }
        function normalize(vec) {
          return div(vec, length(vec));
        }
        function rgbToHsl(val2) {
          var r2 = val2[0];
          var g = val2[1];
          var b = val2[2];
          var max4 = Math.max(r2, g, b);
          var min3 = Math.min(r2, g, b);
          var h;
          var s2;
          var l = (max4 + min3) / 2;
          if (max4 === min3) {
            h = 0;
            s2 = 0;
          } else {
            var d = max4 - min3;
            s2 = l > 0.5 ? d / (2 - max4 - min3) : d / (max4 + min3);
            switch (max4) {
              case r2:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
              case g:
                h = (b - r2) / d + 2;
                break;
              case b:
                h = (r2 - g) / d + 4;
                break;
            }
            h /= 6;
          }
          return [h, s2, l, val2[3]];
        }
        function hue2rgb(p, q, t) {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        }
        function hslToRgb(val2) {
          var h = val2[0];
          var s2 = val2[1];
          var l = val2[2];
          var r2;
          var g;
          var b;
          if (s2 === 0) {
            r2 = l;
            b = l;
            g = l;
          } else {
            var q = l < 0.5 ? l * (1 + s2) : l + s2 - l * s2;
            var p = 2 * l - q;
            r2 = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
          }
          return [r2, g, b, val2[3]];
        }
        function linear(t, tMin, tMax, value1, value2) {
          if (value1 === void 0 || value2 === void 0) {
            value1 = tMin;
            value2 = tMax;
            tMin = 0;
            tMax = 1;
          }
          if (tMax < tMin) {
            var _tMin = tMax;
            tMax = tMin;
            tMin = _tMin;
          }
          if (t <= tMin) {
            return value1;
          }
          if (t >= tMax) {
            return value2;
          }
          var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
          if (!value1.length) {
            return value1 + (value2 - value1) * perc;
          }
          var i;
          var len = value1.length;
          var arr = createTypedArray("float32", len);
          for (i = 0; i < len; i += 1) {
            arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
          }
          return arr;
        }
        function random(min3, max4) {
          if (max4 === void 0) {
            if (min3 === void 0) {
              min3 = 0;
              max4 = 1;
            } else {
              max4 = min3;
              min3 = void 0;
            }
          }
          if (max4.length) {
            var i;
            var len = max4.length;
            if (!min3) {
              min3 = createTypedArray("float32", len);
            }
            var arr = createTypedArray("float32", len);
            var rnd = BMMath.random();
            for (i = 0; i < len; i += 1) {
              arr[i] = min3[i] + rnd * (max4[i] - min3[i]);
            }
            return arr;
          }
          if (min3 === void 0) {
            min3 = 0;
          }
          var rndm = BMMath.random();
          return min3 + rndm * (max4 - min3);
        }
        function createPath(points, inTangents, outTangents, closed) {
          var i;
          var len = points.length;
          var path2 = shapePool.newElement();
          path2.setPathData(!!closed, len);
          var arrPlaceholder = [0, 0];
          var inVertexPoint;
          var outVertexPoint;
          for (i = 0; i < len; i += 1) {
            inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
            outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
            path2.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
          }
          return path2;
        }
        function initiateExpression(elem, data, property) {
          function noOp(_value) {
            return _value;
          }
          if (!elem.globalData.renderConfig.runExpressions) {
            return noOp;
          }
          var val = data.x;
          var needsVelocity = /velocity(?![\w\d])/.test(val);
          var _needsRandom = val.indexOf("random") !== -1;
          var elemType = elem.data.ty;
          var transform;
          var $bm_transform;
          var content;
          var effect;
          var thisProperty = property;
          thisProperty.valueAtTime = thisProperty.getValueAtTime;
          Object.defineProperty(thisProperty, "value", {
            get: function get8() {
              return thisProperty.v;
            }
          });
          elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
          elem.comp.displayStartTime = 0;
          var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
          var outPoint = elem.data.op / elem.comp.globalData.frameRate;
          var width = elem.data.sw ? elem.data.sw : 0;
          var height = elem.data.sh ? elem.data.sh : 0;
          var name = elem.data.nm;
          var loopIn;
          var loop_in;
          var loopOut;
          var loop_out;
          var smooth;
          var toWorld;
          var fromWorld;
          var fromComp;
          var toComp;
          var fromCompToSurface;
          var position;
          var rotation;
          var anchorPoint;
          var scale;
          var thisLayer;
          var thisComp;
          var mask;
          var valueAtTime;
          var velocityAtTime;
          var scoped_bm_rt;
          var expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0];
          var numKeys = property.kf ? data.k.length : 0;
          var active = !this.data || this.data.hd !== true;
          var wiggle = function wiggle2(freq, amp) {
            var iWiggle;
            var j;
            var lenWiggle = this.pv.length ? this.pv.length : 1;
            var addedAmps = createTypedArray("float32", lenWiggle);
            freq = 5;
            var iterations = Math.floor(time * freq);
            iWiggle = 0;
            j = 0;
            while (iWiggle < iterations) {
              for (j = 0; j < lenWiggle; j += 1) {
                addedAmps[j] += -amp + amp * 2 * BMMath.random();
              }
              iWiggle += 1;
            }
            var periods = time * freq;
            var perc = periods - Math.floor(periods);
            var arr = createTypedArray("float32", lenWiggle);
            if (lenWiggle > 1) {
              for (j = 0; j < lenWiggle; j += 1) {
                arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
              }
              return arr;
            }
            return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
          }.bind(this);
          if (thisProperty.loopIn) {
            loopIn = thisProperty.loopIn.bind(thisProperty);
            loop_in = loopIn;
          }
          if (thisProperty.loopOut) {
            loopOut = thisProperty.loopOut.bind(thisProperty);
            loop_out = loopOut;
          }
          if (thisProperty.smooth) {
            smooth = thisProperty.smooth.bind(thisProperty);
          }
          function loopInDuration(type, duration) {
            return loopIn(type, duration, true);
          }
          function loopOutDuration(type, duration) {
            return loopOut(type, duration, true);
          }
          if (this.getValueAtTime) {
            valueAtTime = this.getValueAtTime.bind(this);
          }
          if (this.getVelocityAtTime) {
            velocityAtTime = this.getVelocityAtTime.bind(this);
          }
          var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
          function lookAt(elem1, elem2) {
            var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
            var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
            var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
            return [yaw, pitch, 0];
          }
          function easeOut(t, tMin, tMax, val1, val2) {
            return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
          }
          function easeIn(t, tMin, tMax, val1, val2) {
            return applyEase(easeInBez, t, tMin, tMax, val1, val2);
          }
          function ease(t, tMin, tMax, val1, val2) {
            return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
          }
          function applyEase(fn, t, tMin, tMax, val1, val2) {
            if (val1 === void 0) {
              val1 = tMin;
              val2 = tMax;
            } else {
              t = (t - tMin) / (tMax - tMin);
            }
            if (t > 1) {
              t = 1;
            } else if (t < 0) {
              t = 0;
            }
            var mult = fn(t);
            if ($bm_isInstanceOfArray(val1)) {
              var iKey;
              var lenKey = val1.length;
              var arr = createTypedArray("float32", lenKey);
              for (iKey = 0; iKey < lenKey; iKey += 1) {
                arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
              }
              return arr;
            }
            return (val2 - val1) * mult + val1;
          }
          function nearestKey(time3) {
            var iKey;
            var lenKey = data.k.length;
            var index2;
            var keyTime;
            if (!data.k.length || typeof data.k[0] === "number") {
              index2 = 0;
              keyTime = 0;
            } else {
              index2 = -1;
              time3 *= elem.comp.globalData.frameRate;
              if (time3 < data.k[0].t) {
                index2 = 1;
                keyTime = data.k[0].t;
              } else {
                for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
                  if (time3 === data.k[iKey].t) {
                    index2 = iKey + 1;
                    keyTime = data.k[iKey].t;
                    break;
                  } else if (time3 > data.k[iKey].t && time3 < data.k[iKey + 1].t) {
                    if (time3 - data.k[iKey].t > data.k[iKey + 1].t - time3) {
                      index2 = iKey + 2;
                      keyTime = data.k[iKey + 1].t;
                    } else {
                      index2 = iKey + 1;
                      keyTime = data.k[iKey].t;
                    }
                    break;
                  }
                }
                if (index2 === -1) {
                  index2 = iKey + 1;
                  keyTime = data.k[iKey].t;
                }
              }
            }
            var obKey = {};
            obKey.index = index2;
            obKey.time = keyTime / elem.comp.globalData.frameRate;
            return obKey;
          }
          function key(ind) {
            var obKey;
            var iKey;
            var lenKey;
            if (!data.k.length || typeof data.k[0] === "number") {
              throw new Error("The property has no keyframe at index " + ind);
            }
            ind -= 1;
            obKey = {
              time: data.k[ind].t / elem.comp.globalData.frameRate,
              value: []
            };
            var arr = Object.prototype.hasOwnProperty.call(data.k[ind], "s") ? data.k[ind].s : data.k[ind - 1].e;
            lenKey = arr.length;
            for (iKey = 0; iKey < lenKey; iKey += 1) {
              obKey[iKey] = arr[iKey];
              obKey.value[iKey] = arr[iKey];
            }
            return obKey;
          }
          function framesToTime(fr, fps) {
            if (!fps) {
              fps = elem.comp.globalData.frameRate;
            }
            return fr / fps;
          }
          function timeToFrames(t, fps) {
            if (!t && t !== 0) {
              t = time;
            }
            if (!fps) {
              fps = elem.comp.globalData.frameRate;
            }
            return t * fps;
          }
          function seedRandom(seed) {
            BMMath.seedrandom(randSeed + seed);
          }
          function sourceRectAtTime() {
            return elem.sourceRectAtTime();
          }
          function substring(init, end) {
            if (typeof value === "string") {
              if (end === void 0) {
                return value.substring(init);
              }
              return value.substring(init, end);
            }
            return "";
          }
          function substr(init, end) {
            if (typeof value === "string") {
              if (end === void 0) {
                return value.substr(init);
              }
              return value.substr(init, end);
            }
            return "";
          }
          function posterizeTime(framesPerSecond) {
            time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
            value = valueAtTime(time);
          }
          var time;
          var velocity;
          var value;
          var text;
          var textIndex;
          var textTotal;
          var selectorValue;
          var index = elem.data.ind;
          var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
          var parent;
          var randSeed = Math.floor(Math.random() * 1e6);
          var globalData = elem.globalData;
          function executeExpression(_value) {
            value = _value;
            if (this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector") {
              return value;
            }
            if (this.propType === "textSelector") {
              textIndex = this.textIndex;
              textTotal = this.textTotal;
              selectorValue = this.selectorValue;
            }
            if (!thisLayer) {
              text = elem.layerInterface.text;
              thisLayer = elem.layerInterface;
              thisComp = elem.comp.compInterface;
              toWorld = thisLayer.toWorld.bind(thisLayer);
              fromWorld = thisLayer.fromWorld.bind(thisLayer);
              fromComp = thisLayer.fromComp.bind(thisLayer);
              toComp = thisLayer.toComp.bind(thisLayer);
              mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
              fromCompToSurface = fromComp;
            }
            if (!transform) {
              transform = elem.layerInterface("ADBE Transform Group");
              $bm_transform = transform;
              if (transform) {
                anchorPoint = transform.anchorPoint;
              }
            }
            if (elemType === 4 && !content) {
              content = thisLayer("ADBE Root Vectors Group");
            }
            if (!effect) {
              effect = thisLayer(4);
            }
            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            if (hasParent && !parent) {
              parent = elem.hierarchy[0].layerInterface;
            }
            time = this.comp.renderedFrame / this.comp.globalData.frameRate;
            if (_needsRandom) {
              seedRandom(randSeed + time);
            }
            if (needsVelocity) {
              velocity = velocityAtTime(time);
            }
            expression_function();
            this.frameExpressionId = elem.globalData.frameId;
            scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
            return scoped_bm_rt;
          }
          executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
          return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
        ob.resetFrame = resetFrame;
        return ob;
      }();
      var Expressions = function() {
        var ob2 = {};
        ob2.initExpressions = initExpressions;
        ob2.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
          var stackCount = 0;
          var registers = [];
          function pushExpression() {
            stackCount += 1;
          }
          function popExpression() {
            stackCount -= 1;
            if (stackCount === 0) {
              releaseInstances();
            }
          }
          function registerExpressionProperty(expression) {
            if (registers.indexOf(expression) === -1) {
              registers.push(expression);
            }
          }
          function releaseInstances() {
            var i;
            var len = registers.length;
            for (i = 0; i < len; i += 1) {
              registers[i].release();
            }
            registers.length = 0;
          }
          animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
          animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
          animation.renderer.globalData.pushExpression = pushExpression;
          animation.renderer.globalData.popExpression = popExpression;
          animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob2;
      }();
      var MaskManagerInterface = function() {
        function MaskInterface(mask2, data2) {
          this._mask = mask2;
          this._data = data2;
        }
        Object.defineProperty(MaskInterface.prototype, "maskPath", {
          get: function get8() {
            if (this._mask.prop.k) {
              this._mask.prop.getValue();
            }
            return this._mask.prop;
          }
        });
        Object.defineProperty(MaskInterface.prototype, "maskOpacity", {
          get: function get8() {
            if (this._mask.op.k) {
              this._mask.op.getValue();
            }
            return this._mask.op.v * 100;
          }
        });
        var MaskManager = function MaskManager2(maskManager) {
          var _masksInterfaces = createSizedArray(maskManager.viewData.length);
          var i;
          var len = maskManager.viewData.length;
          for (i = 0; i < len; i += 1) {
            _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
          }
          var maskFunction = function maskFunction2(name2) {
            i = 0;
            while (i < len) {
              if (maskManager.masksProperties[i].nm === name2) {
                return _masksInterfaces[i];
              }
              i += 1;
            }
            return null;
          };
          return maskFunction;
        };
        return MaskManager;
      }();
      var ExpressionPropertyInterface = /* @__PURE__ */ function() {
        var defaultUnidimensionalValue = {
          pv: 0,
          v: 0,
          mult: 1
        };
        var defaultMultidimensionalValue = {
          pv: [0, 0, 0],
          v: [0, 0, 0],
          mult: 1
        };
        function completeProperty(expressionValue, property2, type) {
          Object.defineProperty(expressionValue, "velocity", {
            get: function get8() {
              return property2.getVelocityAtTime(property2.comp.currentFrame);
            }
          });
          expressionValue.numKeys = property2.keyframes ? property2.keyframes.length : 0;
          expressionValue.key = function(pos) {
            if (!expressionValue.numKeys) {
              return 0;
            }
            var value2 = "";
            if ("s" in property2.keyframes[pos - 1]) {
              value2 = property2.keyframes[pos - 1].s;
            } else if ("e" in property2.keyframes[pos - 2]) {
              value2 = property2.keyframes[pos - 2].e;
            } else {
              value2 = property2.keyframes[pos - 2].s;
            }
            var valueProp = type === "unidimensional" ? new Number(value2) : Object.assign({}, value2);
            valueProp.time = property2.keyframes[pos - 1].t / property2.elem.comp.globalData.frameRate;
            valueProp.value = type === "unidimensional" ? value2[0] : value2;
            return valueProp;
          };
          expressionValue.valueAtTime = property2.getValueAtTime;
          expressionValue.speedAtTime = property2.getSpeedAtTime;
          expressionValue.velocityAtTime = property2.getVelocityAtTime;
          expressionValue.propertyGroup = property2.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property2) {
          if (!property2 || !("pv" in property2)) {
            property2 = defaultUnidimensionalValue;
          }
          var mult = 1 / property2.mult;
          var val2 = property2.pv * mult;
          var expressionValue = new Number(val2);
          expressionValue.value = val2;
          completeProperty(expressionValue, property2, "unidimensional");
          return function() {
            if (property2.k) {
              property2.getValue();
            }
            val2 = property2.v * mult;
            if (expressionValue.value !== val2) {
              expressionValue = new Number(val2);
              expressionValue.value = val2;
              completeProperty(expressionValue, property2, "unidimensional");
            }
            return expressionValue;
          };
        }
        function MultidimensionalPropertyInterface(property2) {
          if (!property2 || !("pv" in property2)) {
            property2 = defaultMultidimensionalValue;
          }
          var mult = 1 / property2.mult;
          var len = property2.data && property2.data.l || property2.pv.length;
          var expressionValue = createTypedArray("float32", len);
          var arrValue = createTypedArray("float32", len);
          expressionValue.value = arrValue;
          completeProperty(expressionValue, property2, "multidimensional");
          return function() {
            if (property2.k) {
              property2.getValue();
            }
            for (var i = 0; i < len; i += 1) {
              arrValue[i] = property2.v[i] * mult;
              expressionValue[i] = arrValue[i];
            }
            return expressionValue;
          };
        }
        function defaultGetter() {
          return defaultUnidimensionalValue;
        }
        return function(property2) {
          if (!property2) {
            return defaultGetter;
          }
          if (property2.propType === "unidimensional") {
            return UnidimensionalPropertyInterface(property2);
          }
          return MultidimensionalPropertyInterface(property2);
        };
      }();
      var TransformExpressionInterface = /* @__PURE__ */ function() {
        return function(transform2) {
          function _thisFunction(name2) {
            switch (name2) {
              case "scale":
              case "Scale":
              case "ADBE Scale":
              case 6:
                return _thisFunction.scale;
              case "rotation":
              case "Rotation":
              case "ADBE Rotation":
              case "ADBE Rotate Z":
              case 10:
                return _thisFunction.rotation;
              case "ADBE Rotate X":
                return _thisFunction.xRotation;
              case "ADBE Rotate Y":
                return _thisFunction.yRotation;
              case "position":
              case "Position":
              case "ADBE Position":
              case 2:
                return _thisFunction.position;
              case "ADBE Position_0":
                return _thisFunction.xPosition;
              case "ADBE Position_1":
                return _thisFunction.yPosition;
              case "ADBE Position_2":
                return _thisFunction.zPosition;
              case "anchorPoint":
              case "AnchorPoint":
              case "Anchor Point":
              case "ADBE AnchorPoint":
              case 1:
                return _thisFunction.anchorPoint;
              case "opacity":
              case "Opacity":
              case 11:
                return _thisFunction.opacity;
              default:
                return null;
            }
          }
          Object.defineProperty(_thisFunction, "rotation", {
            get: ExpressionPropertyInterface(transform2.r || transform2.rz)
          });
          Object.defineProperty(_thisFunction, "zRotation", {
            get: ExpressionPropertyInterface(transform2.rz || transform2.r)
          });
          Object.defineProperty(_thisFunction, "xRotation", {
            get: ExpressionPropertyInterface(transform2.rx)
          });
          Object.defineProperty(_thisFunction, "yRotation", {
            get: ExpressionPropertyInterface(transform2.ry)
          });
          Object.defineProperty(_thisFunction, "scale", {
            get: ExpressionPropertyInterface(transform2.s)
          });
          var _px;
          var _py;
          var _pz;
          var _transformFactory;
          if (transform2.p) {
            _transformFactory = ExpressionPropertyInterface(transform2.p);
          } else {
            _px = ExpressionPropertyInterface(transform2.px);
            _py = ExpressionPropertyInterface(transform2.py);
            if (transform2.pz) {
              _pz = ExpressionPropertyInterface(transform2.pz);
            }
          }
          Object.defineProperty(_thisFunction, "position", {
            get: function get8() {
              if (transform2.p) {
                return _transformFactory();
              }
              return [_px(), _py(), _pz ? _pz() : 0];
            }
          });
          Object.defineProperty(_thisFunction, "xPosition", {
            get: ExpressionPropertyInterface(transform2.px)
          });
          Object.defineProperty(_thisFunction, "yPosition", {
            get: ExpressionPropertyInterface(transform2.py)
          });
          Object.defineProperty(_thisFunction, "zPosition", {
            get: ExpressionPropertyInterface(transform2.pz)
          });
          Object.defineProperty(_thisFunction, "anchorPoint", {
            get: ExpressionPropertyInterface(transform2.a)
          });
          Object.defineProperty(_thisFunction, "opacity", {
            get: ExpressionPropertyInterface(transform2.o)
          });
          Object.defineProperty(_thisFunction, "skew", {
            get: ExpressionPropertyInterface(transform2.sk)
          });
          Object.defineProperty(_thisFunction, "skewAxis", {
            get: ExpressionPropertyInterface(transform2.sa)
          });
          Object.defineProperty(_thisFunction, "orientation", {
            get: ExpressionPropertyInterface(transform2.or)
          });
          return _thisFunction;
        };
      }();
      var LayerExpressionInterface = /* @__PURE__ */ function() {
        function getMatrix(time3) {
          var toWorldMat = new Matrix();
          if (time3 !== void 0) {
            var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time3);
            propMatrix.clone(toWorldMat);
          } else {
            var transformMat = this._elem.finalTransform.mProp;
            transformMat.applyToMatrix(toWorldMat);
          }
          return toWorldMat;
        }
        function toWorldVec(arr, time3) {
          var toWorldMat = this.getMatrix(time3);
          toWorldMat.props[12] = 0;
          toWorldMat.props[13] = 0;
          toWorldMat.props[14] = 0;
          return this.applyPoint(toWorldMat, arr);
        }
        function toWorld2(arr, time3) {
          var toWorldMat = this.getMatrix(time3);
          return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time3) {
          var toWorldMat = this.getMatrix(time3);
          toWorldMat.props[12] = 0;
          toWorldMat.props[13] = 0;
          toWorldMat.props[14] = 0;
          return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld2(arr, time3) {
          var toWorldMat = this.getMatrix(time3);
          return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var i;
            var len = this._elem.hierarchy.length;
            for (i = 0; i < len; i += 1) {
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
          }
          return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var i;
            var len = this._elem.hierarchy.length;
            for (i = 0; i < len; i += 1) {
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
          }
          return matrix.inversePoint(arr);
        }
        function fromComp2(arr) {
          var toWorldMat = new Matrix();
          toWorldMat.reset();
          this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var i;
            var len = this._elem.hierarchy.length;
            for (i = 0; i < len; i += 1) {
              this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.inversePoint(arr);
          }
          return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
          return [1, 1, 1, 1];
        }
        return function(elem2) {
          var transformInterface;
          function _registerMaskInterface(maskManager) {
            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem2);
          }
          function _registerEffectsInterface(effects) {
            _thisLayerFunction.effect = effects;
          }
          function _thisLayerFunction(name2) {
            switch (name2) {
              case "ADBE Root Vectors Group":
              case "Contents":
              case 2:
                return _thisLayerFunction.shapeInterface;
              case 1:
              case 6:
              case "Transform":
              case "transform":
              case "ADBE Transform Group":
                return transformInterface;
              case 4:
              case "ADBE Effect Parade":
              case "effects":
              case "Effects":
                return _thisLayerFunction.effect;
              case "ADBE Text Properties":
                return _thisLayerFunction.textInterface;
              default:
                return null;
            }
          }
          _thisLayerFunction.getMatrix = getMatrix;
          _thisLayerFunction.invertPoint = invertPoint;
          _thisLayerFunction.applyPoint = applyPoint;
          _thisLayerFunction.toWorld = toWorld2;
          _thisLayerFunction.toWorldVec = toWorldVec;
          _thisLayerFunction.fromWorld = fromWorld2;
          _thisLayerFunction.fromWorldVec = fromWorldVec;
          _thisLayerFunction.toComp = toWorld2;
          _thisLayerFunction.fromComp = fromComp2;
          _thisLayerFunction.sampleImage = sampleImage;
          _thisLayerFunction.sourceRectAtTime = elem2.sourceRectAtTime.bind(elem2);
          _thisLayerFunction._elem = elem2;
          transformInterface = TransformExpressionInterface(elem2.finalTransform.mProp);
          var anchorPointDescriptor = getDescriptor(transformInterface, "anchorPoint");
          Object.defineProperties(_thisLayerFunction, {
            hasParent: {
              get: function get8() {
                return elem2.hierarchy.length;
              }
            },
            parent: {
              get: function get8() {
                return elem2.hierarchy[0].layerInterface;
              }
            },
            rotation: getDescriptor(transformInterface, "rotation"),
            scale: getDescriptor(transformInterface, "scale"),
            position: getDescriptor(transformInterface, "position"),
            opacity: getDescriptor(transformInterface, "opacity"),
            anchorPoint: anchorPointDescriptor,
            anchor_point: anchorPointDescriptor,
            transform: {
              get: function get8() {
                return transformInterface;
              }
            },
            active: {
              get: function get8() {
                return elem2.isInRange;
              }
            }
          });
          _thisLayerFunction.startTime = elem2.data.st;
          _thisLayerFunction.index = elem2.data.ind;
          _thisLayerFunction.source = elem2.data.refId;
          _thisLayerFunction.height = elem2.data.ty === 0 ? elem2.data.h : 100;
          _thisLayerFunction.width = elem2.data.ty === 0 ? elem2.data.w : 100;
          _thisLayerFunction.inPoint = elem2.data.ip / elem2.comp.globalData.frameRate;
          _thisLayerFunction.outPoint = elem2.data.op / elem2.comp.globalData.frameRate;
          _thisLayerFunction._name = elem2.data.nm;
          _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
          _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
          return _thisLayerFunction;
        };
      }();
      var propertyGroupFactory = /* @__PURE__ */ function() {
        return function(interfaceFunction, parentPropertyGroup) {
          return function(val2) {
            val2 = val2 === void 0 ? 1 : val2;
            if (val2 <= 0) {
              return interfaceFunction;
            }
            return parentPropertyGroup(val2 - 1);
          };
        };
      }();
      var PropertyInterface = /* @__PURE__ */ function() {
        return function(propertyName, propertyGroup) {
          var interfaceFunction = {
            _name: propertyName
          };
          function _propertyGroup(val2) {
            val2 = val2 === void 0 ? 1 : val2;
            if (val2 <= 0) {
              return interfaceFunction;
            }
            return propertyGroup(val2 - 1);
          }
          return _propertyGroup;
        };
      }();
      var EffectsExpressionInterface = /* @__PURE__ */ function() {
        var ob2 = {
          createEffectsInterface
        };
        function createEffectsInterface(elem2, propertyGroup) {
          if (elem2.effectsManager) {
            var effectElements = [];
            var effectsData = elem2.data.ef;
            var i;
            var len = elem2.effectsManager.effectElements.length;
            for (i = 0; i < len; i += 1) {
              effectElements.push(createGroupInterface(effectsData[i], elem2.effectsManager.effectElements[i], propertyGroup, elem2));
            }
            var effects = elem2.data.ef || [];
            var groupInterface = function groupInterface2(name2) {
              i = 0;
              len = effects.length;
              while (i < len) {
                if (name2 === effects[i].nm || name2 === effects[i].mn || name2 === effects[i].ix) {
                  return effectElements[i];
                }
                i += 1;
              }
              return null;
            };
            Object.defineProperty(groupInterface, "numProperties", {
              get: function get8() {
                return effects.length;
              }
            });
            return groupInterface;
          }
          return null;
        }
        function createGroupInterface(data2, elements, propertyGroup, elem2) {
          function groupInterface(name2) {
            var effects = data2.ef;
            var i2 = 0;
            var len2 = effects.length;
            while (i2 < len2) {
              if (name2 === effects[i2].nm || name2 === effects[i2].mn || name2 === effects[i2].ix) {
                if (effects[i2].ty === 5) {
                  return effectElements[i2];
                }
                return effectElements[i2]();
              }
              i2 += 1;
            }
            throw new Error();
          }
          var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
          var effectElements = [];
          var i;
          var len = data2.ef.length;
          for (i = 0; i < len; i += 1) {
            if (data2.ef[i].ty === 5) {
              effectElements.push(createGroupInterface(data2.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem2));
            } else {
              effectElements.push(createValueInterface(elements.effectElements[i], data2.ef[i].ty, elem2, _propertyGroup));
            }
          }
          if (data2.mn === "ADBE Color Control") {
            Object.defineProperty(groupInterface, "color", {
              get: function get8() {
                return effectElements[0]();
              }
            });
          }
          Object.defineProperties(groupInterface, {
            numProperties: {
              get: function get8() {
                return data2.np;
              }
            },
            _name: {
              value: data2.nm
            },
            propertyGroup: {
              value: _propertyGroup
            }
          });
          groupInterface.enabled = data2.en !== 0;
          groupInterface.active = groupInterface.enabled;
          return groupInterface;
        }
        function createValueInterface(element, type, elem2, propertyGroup) {
          var expressionProperty = ExpressionPropertyInterface(element.p);
          function interfaceFunction() {
            if (type === 10) {
              return elem2.comp.compInterface(element.p.v);
            }
            return expressionProperty();
          }
          if (element.p.setGroupProperty) {
            element.p.setGroupProperty(PropertyInterface("", propertyGroup));
          }
          return interfaceFunction;
        }
        return ob2;
      }();
      var ShapePathInterface = /* @__PURE__ */ function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
          var prop = view.sh;
          function interfaceFunction(val2) {
            if (val2 === "Shape" || val2 === "shape" || val2 === "Path" || val2 === "path" || val2 === "ADBE Vector Shape" || val2 === 2) {
              return interfaceFunction.path;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          prop.setGroupProperty(PropertyInterface("Path", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            path: {
              get: function get8() {
                if (prop.k) {
                  prop.getValue();
                }
                return prop;
              }
            },
            shape: {
              get: function get8() {
                if (prop.k) {
                  prop.getValue();
                }
                return prop;
              }
            },
            _name: {
              value: shape.nm
            },
            ix: {
              value: shape.ix
            },
            propertyIndex: {
              value: shape.ix
            },
            mn: {
              value: shape.mn
            },
            propertyGroup: {
              value: propertyGroup
            }
          });
          return interfaceFunction;
        };
      }();
      var ShapeExpressionInterface = /* @__PURE__ */ function() {
        function iterateElements(shapes, view, propertyGroup) {
          var arr = [];
          var i;
          var len = shapes ? shapes.length : 0;
          for (i = 0; i < len; i += 1) {
            if (shapes[i].ty === "gr") {
              arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "fl") {
              arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "st") {
              arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "tm") {
              arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "tr") ; else if (shapes[i].ty === "el") {
              arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "sr") {
              arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "sh") {
              arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "rc") {
              arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "rd") {
              arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "rp") {
              arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else if (shapes[i].ty === "gf") {
              arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
            } else {
              arr.push(defaultInterfaceFactory(shapes[i], view[i]));
            }
          }
          return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
          var interfaces2;
          var interfaceFunction = function _interfaceFunction(value2) {
            var i = 0;
            var len = interfaces2.length;
            while (i < len) {
              if (interfaces2[i]._name === value2 || interfaces2[i].mn === value2 || interfaces2[i].propertyIndex === value2 || interfaces2[i].ix === value2 || interfaces2[i].ind === value2) {
                return interfaces2[i];
              }
              i += 1;
            }
            if (typeof value2 === "number") {
              return interfaces2[value2 - 1];
            }
            return null;
          };
          interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          interfaces2 = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
          interfaceFunction.numProperties = interfaces2.length;
          var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
          interfaceFunction.transform = transformInterface;
          interfaceFunction.propertyIndex = shape.cix;
          interfaceFunction._name = shape.nm;
          return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
          var interfaceFunction = function _interfaceFunction(value2) {
            switch (value2) {
              case "ADBE Vectors Group":
              case "Contents":
              case 2:
                return interfaceFunction.content;
              // Not necessary for now. Keeping them here in case a new case appears
              // case 'ADBE Vector Transform Group':
              // case 3:
              default:
                return interfaceFunction.transform;
            }
          };
          interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var content2 = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
          var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
          interfaceFunction.content = content2;
          interfaceFunction.transform = transformInterface;
          Object.defineProperty(interfaceFunction, "_name", {
            get: function get8() {
              return shape.nm;
            }
          });
          interfaceFunction.numProperties = shape.np;
          interfaceFunction.propertyIndex = shape.ix;
          interfaceFunction.nm = shape.nm;
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(val2) {
            if (val2 === "Color" || val2 === "color") {
              return interfaceFunction.color;
            }
            if (val2 === "Opacity" || val2 === "opacity") {
              return interfaceFunction.opacity;
            }
            return null;
          }
          Object.defineProperties(interfaceFunction, {
            color: {
              get: ExpressionPropertyInterface(view.c)
            },
            opacity: {
              get: ExpressionPropertyInterface(view.o)
            },
            _name: {
              value: shape.nm
            },
            mn: {
              value: shape.mn
            }
          });
          view.c.setGroupProperty(PropertyInterface("Color", propertyGroup));
          view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
          return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(val2) {
            if (val2 === "Start Point" || val2 === "start point") {
              return interfaceFunction.startPoint;
            }
            if (val2 === "End Point" || val2 === "end point") {
              return interfaceFunction.endPoint;
            }
            if (val2 === "Opacity" || val2 === "opacity") {
              return interfaceFunction.opacity;
            }
            return null;
          }
          Object.defineProperties(interfaceFunction, {
            startPoint: {
              get: ExpressionPropertyInterface(view.s)
            },
            endPoint: {
              get: ExpressionPropertyInterface(view.e)
            },
            opacity: {
              get: ExpressionPropertyInterface(view.o)
            },
            type: {
              get: function get8() {
                return "a";
              }
            },
            _name: {
              value: shape.nm
            },
            mn: {
              value: shape.mn
            }
          });
          view.s.setGroupProperty(PropertyInterface("Start Point", propertyGroup));
          view.e.setGroupProperty(PropertyInterface("End Point", propertyGroup));
          view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
          return interfaceFunction;
        }
        function defaultInterfaceFactory() {
          function interfaceFunction() {
            return null;
          }
          return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
          function addPropertyToDashOb(i2) {
            Object.defineProperty(dashOb, shape.d[i2].nm, {
              get: ExpressionPropertyInterface(view.d.dataProps[i2].p)
            });
          }
          var i;
          var len = shape.d ? shape.d.length : 0;
          var dashOb = {};
          for (i = 0; i < len; i += 1) {
            addPropertyToDashOb(i);
            view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
          }
          function interfaceFunction(val2) {
            if (val2 === "Color" || val2 === "color") {
              return interfaceFunction.color;
            }
            if (val2 === "Opacity" || val2 === "opacity") {
              return interfaceFunction.opacity;
            }
            if (val2 === "Stroke Width" || val2 === "stroke width") {
              return interfaceFunction.strokeWidth;
            }
            return null;
          }
          Object.defineProperties(interfaceFunction, {
            color: {
              get: ExpressionPropertyInterface(view.c)
            },
            opacity: {
              get: ExpressionPropertyInterface(view.o)
            },
            strokeWidth: {
              get: ExpressionPropertyInterface(view.w)
            },
            dash: {
              get: function get8() {
                return dashOb;
              }
            },
            _name: {
              value: shape.nm
            },
            mn: {
              value: shape.mn
            }
          });
          view.c.setGroupProperty(PropertyInterface("Color", _propertyGroup));
          view.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
          view.w.setGroupProperty(PropertyInterface("Stroke Width", _propertyGroup));
          return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(val2) {
            if (val2 === shape.e.ix || val2 === "End" || val2 === "end") {
              return interfaceFunction.end;
            }
            if (val2 === shape.s.ix) {
              return interfaceFunction.start;
            }
            if (val2 === shape.o.ix) {
              return interfaceFunction.offset;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          interfaceFunction.propertyIndex = shape.ix;
          view.s.setGroupProperty(PropertyInterface("Start", _propertyGroup));
          view.e.setGroupProperty(PropertyInterface("End", _propertyGroup));
          view.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
          interfaceFunction.propertyIndex = shape.ix;
          interfaceFunction.propertyGroup = propertyGroup;
          Object.defineProperties(interfaceFunction, {
            start: {
              get: ExpressionPropertyInterface(view.s)
            },
            end: {
              get: ExpressionPropertyInterface(view.e)
            },
            offset: {
              get: ExpressionPropertyInterface(view.o)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.a.ix === value2 || value2 === "Anchor Point") {
              return interfaceFunction.anchorPoint;
            }
            if (shape.o.ix === value2 || value2 === "Opacity") {
              return interfaceFunction.opacity;
            }
            if (shape.p.ix === value2 || value2 === "Position") {
              return interfaceFunction.position;
            }
            if (shape.r.ix === value2 || value2 === "Rotation" || value2 === "ADBE Vector Rotation") {
              return interfaceFunction.rotation;
            }
            if (shape.s.ix === value2 || value2 === "Scale") {
              return interfaceFunction.scale;
            }
            if (shape.sk && shape.sk.ix === value2 || value2 === "Skew") {
              return interfaceFunction.skew;
            }
            if (shape.sa && shape.sa.ix === value2 || value2 === "Skew Axis") {
              return interfaceFunction.skewAxis;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          view.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
          view.transform.mProps.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
          view.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", _propertyGroup));
          view.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", _propertyGroup));
          view.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
          if (view.transform.mProps.sk) {
            view.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", _propertyGroup));
            view.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", _propertyGroup));
          }
          view.transform.op.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            opacity: {
              get: ExpressionPropertyInterface(view.transform.mProps.o)
            },
            position: {
              get: ExpressionPropertyInterface(view.transform.mProps.p)
            },
            anchorPoint: {
              get: ExpressionPropertyInterface(view.transform.mProps.a)
            },
            scale: {
              get: ExpressionPropertyInterface(view.transform.mProps.s)
            },
            rotation: {
              get: ExpressionPropertyInterface(view.transform.mProps.r)
            },
            skew: {
              get: ExpressionPropertyInterface(view.transform.mProps.sk)
            },
            skewAxis: {
              get: ExpressionPropertyInterface(view.transform.mProps.sa)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.ty = "tr";
          interfaceFunction.mn = shape.mn;
          interfaceFunction.propertyGroup = propertyGroup;
          return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.p.ix === value2) {
              return interfaceFunction.position;
            }
            if (shape.s.ix === value2) {
              return interfaceFunction.size;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          interfaceFunction.propertyIndex = shape.ix;
          var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
          prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
          prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            size: {
              get: ExpressionPropertyInterface(prop.s)
            },
            position: {
              get: ExpressionPropertyInterface(prop.p)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.p.ix === value2) {
              return interfaceFunction.position;
            }
            if (shape.r.ix === value2) {
              return interfaceFunction.rotation;
            }
            if (shape.pt.ix === value2) {
              return interfaceFunction.points;
            }
            if (shape.or.ix === value2 || value2 === "ADBE Vector Star Outer Radius") {
              return interfaceFunction.outerRadius;
            }
            if (shape.os.ix === value2) {
              return interfaceFunction.outerRoundness;
            }
            if (shape.ir && (shape.ir.ix === value2 || value2 === "ADBE Vector Star Inner Radius")) {
              return interfaceFunction.innerRadius;
            }
            if (shape.is && shape.is.ix === value2) {
              return interfaceFunction.innerRoundness;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
          interfaceFunction.propertyIndex = shape.ix;
          prop.or.setGroupProperty(PropertyInterface("Outer Radius", _propertyGroup));
          prop.os.setGroupProperty(PropertyInterface("Outer Roundness", _propertyGroup));
          prop.pt.setGroupProperty(PropertyInterface("Points", _propertyGroup));
          prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
          prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
          if (shape.ir) {
            prop.ir.setGroupProperty(PropertyInterface("Inner Radius", _propertyGroup));
            prop.is.setGroupProperty(PropertyInterface("Inner Roundness", _propertyGroup));
          }
          Object.defineProperties(interfaceFunction, {
            position: {
              get: ExpressionPropertyInterface(prop.p)
            },
            rotation: {
              get: ExpressionPropertyInterface(prop.r)
            },
            points: {
              get: ExpressionPropertyInterface(prop.pt)
            },
            outerRadius: {
              get: ExpressionPropertyInterface(prop.or)
            },
            outerRoundness: {
              get: ExpressionPropertyInterface(prop.os)
            },
            innerRadius: {
              get: ExpressionPropertyInterface(prop.ir)
            },
            innerRoundness: {
              get: ExpressionPropertyInterface(prop.is)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.p.ix === value2) {
              return interfaceFunction.position;
            }
            if (shape.r.ix === value2) {
              return interfaceFunction.roundness;
            }
            if (shape.s.ix === value2 || value2 === "Size" || value2 === "ADBE Vector Rect Size") {
              return interfaceFunction.size;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
          interfaceFunction.propertyIndex = shape.ix;
          prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
          prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
          prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            position: {
              get: ExpressionPropertyInterface(prop.p)
            },
            roundness: {
              get: ExpressionPropertyInterface(prop.r)
            },
            size: {
              get: ExpressionPropertyInterface(prop.s)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.r.ix === value2 || value2 === "Round Corners 1") {
              return interfaceFunction.radius;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var prop = view;
          interfaceFunction.propertyIndex = shape.ix;
          prop.rd.setGroupProperty(PropertyInterface("Radius", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            radius: {
              get: ExpressionPropertyInterface(prop.rd)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
          function interfaceFunction(value2) {
            if (shape.c.ix === value2 || value2 === "Copies") {
              return interfaceFunction.copies;
            }
            if (shape.o.ix === value2 || value2 === "Offset") {
              return interfaceFunction.offset;
            }
            return null;
          }
          var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
          var prop = view;
          interfaceFunction.propertyIndex = shape.ix;
          prop.c.setGroupProperty(PropertyInterface("Copies", _propertyGroup));
          prop.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
          Object.defineProperties(interfaceFunction, {
            copies: {
              get: ExpressionPropertyInterface(prop.c)
            },
            offset: {
              get: ExpressionPropertyInterface(prop.o)
            },
            _name: {
              value: shape.nm
            }
          });
          interfaceFunction.mn = shape.mn;
          return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
          var interfaces2;
          function _interfaceFunction(value2) {
            if (typeof value2 === "number") {
              value2 = value2 === void 0 ? 1 : value2;
              if (value2 === 0) {
                return propertyGroup;
              }
              return interfaces2[value2 - 1];
            }
            var i = 0;
            var len = interfaces2.length;
            while (i < len) {
              if (interfaces2[i]._name === value2) {
                return interfaces2[i];
              }
              i += 1;
            }
            return null;
          }
          function parentGroupWrapper() {
            return propertyGroup;
          }
          _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
          interfaces2 = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
          _interfaceFunction.numProperties = interfaces2.length;
          _interfaceFunction._name = "Contents";
          return _interfaceFunction;
        };
      }();
      var TextExpressionInterface = /* @__PURE__ */ function() {
        return function(elem2) {
          var _sourceText;
          function _thisLayerFunction(name2) {
            switch (name2) {
              case "ADBE Text Document":
                return _thisLayerFunction.sourceText;
              default:
                return null;
            }
          }
          Object.defineProperty(_thisLayerFunction, "sourceText", {
            get: function get8() {
              elem2.textProperty.getValue();
              var stringValue = elem2.textProperty.currentData.t;
              if (!_sourceText || stringValue !== _sourceText.value) {
                _sourceText = new String(stringValue);
                _sourceText.value = stringValue || new String(stringValue);
                Object.defineProperty(_sourceText, "style", {
                  get: function get9() {
                    return {
                      fillColor: elem2.textProperty.currentData.fc
                    };
                  }
                });
              }
              return _sourceText;
            }
          });
          return _thisLayerFunction;
        };
      }();
      function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof52(obj2) {
            return typeof obj2;
          };
        } else {
          _typeof = function _typeof52(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
        }
        return _typeof(obj);
      }
      var FootageInterface = /* @__PURE__ */ function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory2(elem2) {
          var currentPropertyName = "";
          var currentProperty = elem2.getFootageData();
          function init() {
            currentPropertyName = "";
            currentProperty = elem2.getFootageData();
            return searchProperty;
          }
          function searchProperty(value2) {
            if (currentProperty[value2]) {
              currentPropertyName = value2;
              currentProperty = currentProperty[value2];
              if (_typeof(currentProperty) === "object") {
                return searchProperty;
              }
              return currentProperty;
            }
            var propertyNameIndex = value2.indexOf(currentPropertyName);
            if (propertyNameIndex !== -1) {
              var index2 = parseInt(value2.substr(propertyNameIndex + currentPropertyName.length), 10);
              currentProperty = currentProperty[index2];
              if (_typeof(currentProperty) === "object") {
                return searchProperty;
              }
              return currentProperty;
            }
            return "";
          }
          return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory2(elem2) {
          function interfaceFunction(value2) {
            if (value2 === "Outline") {
              return interfaceFunction.outlineInterface();
            }
            return null;
          }
          interfaceFunction._name = "Outline";
          interfaceFunction.outlineInterface = outlineInterfaceFactory(elem2);
          return interfaceFunction;
        };
        return function(elem2) {
          function _interfaceFunction(value2) {
            if (value2 === "Data") {
              return _interfaceFunction.dataInterface;
            }
            return null;
          }
          _interfaceFunction._name = "Data";
          _interfaceFunction.dataInterface = dataInterfaceFactory(elem2);
          return _interfaceFunction;
        };
      }();
      var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
      };
      function getInterface(type) {
        return interfaces[type] || null;
      }
      var expressionHelpers = /* @__PURE__ */ function() {
        function searchExpressions(elem2, data2, prop) {
          if (data2.x) {
            prop.k = true;
            prop.x = true;
            prop.initiateExpression = ExpressionManager.initiateExpression;
            prop.effectsSequence.push(prop.initiateExpression(elem2, data2, prop).bind(prop));
          }
        }
        function getValueAtTime(frameNum) {
          frameNum *= this.elem.globalData.frameRate;
          frameNum -= this.offsetTime;
          if (frameNum !== this._cachingAtTime.lastFrame) {
            this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
            this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
            this._cachingAtTime.lastFrame = frameNum;
          }
          return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
          var delta = -0.01;
          var v1 = this.getValueAtTime(frameNum);
          var v2 = this.getValueAtTime(frameNum + delta);
          var speed = 0;
          if (v1.length) {
            var i;
            for (i = 0; i < v1.length; i += 1) {
              speed += Math.pow(v2[i] - v1[i], 2);
            }
            speed = Math.sqrt(speed) * 100;
          } else {
            speed = 0;
          }
          return speed;
        }
        function getVelocityAtTime(frameNum) {
          if (this.vel !== void 0) {
            return this.vel;
          }
          var delta = -1e-3;
          var v1 = this.getValueAtTime(frameNum);
          var v2 = this.getValueAtTime(frameNum + delta);
          var velocity2;
          if (v1.length) {
            velocity2 = createTypedArray("float32", v1.length);
            var i;
            for (i = 0; i < v1.length; i += 1) {
              velocity2[i] = (v2[i] - v1[i]) / delta;
            }
          } else {
            velocity2 = (v2 - v1) / delta;
          }
          return velocity2;
        }
        function getStaticValueAtTime() {
          return this.pv;
        }
        function setGroupProperty(propertyGroup) {
          this.propertyGroup = propertyGroup;
        }
        return {
          searchExpressions,
          getSpeedAtTime,
          getVelocityAtTime,
          getValueAtTime,
          getStaticValueAtTime,
          setGroupProperty
        };
      }();
      function addPropertyDecorator() {
        function loopOut2(type, duration, durationFlag) {
          if (!this.k || !this.keyframes) {
            return this.pv;
          }
          type = type ? type.toLowerCase() : "";
          var currentFrame = this.comp.renderedFrame;
          var keyframes = this.keyframes;
          var lastKeyFrame = keyframes[keyframes.length - 1].t;
          if (currentFrame <= lastKeyFrame) {
            return this.pv;
          }
          var cycleDuration;
          var firstKeyFrame;
          if (!durationFlag) {
            if (!duration || duration > keyframes.length - 1) {
              duration = keyframes.length - 1;
            }
            firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
            cycleDuration = lastKeyFrame - firstKeyFrame;
          } else {
            if (!duration) {
              cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
            } else {
              cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
            }
            firstKeyFrame = lastKeyFrame - cycleDuration;
          }
          var i;
          var len;
          var ret;
          if (type === "pingpong") {
            var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
            if (iterations % 2 !== 0) {
              return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
          } else if (type === "offset") {
            var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
            var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
            var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
            var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
            if (this.pv.length) {
              ret = new Array(initV.length);
              len = ret.length;
              for (i = 0; i < len; i += 1) {
                ret[i] = (endV[i] - initV[i]) * repeats + current[i];
              }
              return ret;
            }
            return (endV - initV) * repeats + current;
          } else if (type === "continue") {
            var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
            var nextLastValue = this.getValueAtTime((lastKeyFrame - 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              ret = new Array(lastValue.length);
              len = ret.length;
              for (i = 0; i < len; i += 1) {
                ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 5e-4;
              }
              return ret;
            }
            return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 1e-3);
          }
          return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
        }
        function loopIn2(type, duration, durationFlag) {
          if (!this.k) {
            return this.pv;
          }
          type = type ? type.toLowerCase() : "";
          var currentFrame = this.comp.renderedFrame;
          var keyframes = this.keyframes;
          var firstKeyFrame = keyframes[0].t;
          if (currentFrame >= firstKeyFrame) {
            return this.pv;
          }
          var cycleDuration;
          var lastKeyFrame;
          if (!durationFlag) {
            if (!duration || duration > keyframes.length - 1) {
              duration = keyframes.length - 1;
            }
            lastKeyFrame = keyframes[duration].t;
            cycleDuration = lastKeyFrame - firstKeyFrame;
          } else {
            if (!duration) {
              cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
            } else {
              cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
            }
            lastKeyFrame = firstKeyFrame + cycleDuration;
          }
          var i;
          var len;
          var ret;
          if (type === "pingpong") {
            var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
            if (iterations % 2 === 0) {
              return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
          } else if (type === "offset") {
            var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
            var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
            var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
            var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
            if (this.pv.length) {
              ret = new Array(initV.length);
              len = ret.length;
              for (i = 0; i < len; i += 1) {
                ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
              }
              return ret;
            }
            return current - (endV - initV) * repeats;
          } else if (type === "continue") {
            var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
            var nextFirstValue = this.getValueAtTime((firstKeyFrame + 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              ret = new Array(firstValue.length);
              len = ret.length;
              for (i = 0; i < len; i += 1) {
                ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 1e-3;
              }
              return ret;
            }
            return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 1e-3;
          }
          return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0);
        }
        function smooth2(width2, samples) {
          if (!this.k) {
            return this.pv;
          }
          width2 = (width2 || 0.4) * 0.5;
          samples = Math.floor(samples || 5);
          if (samples <= 1) {
            return this.pv;
          }
          var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
          var initFrame2 = currentTime - width2;
          var endFrame = currentTime + width2;
          var sampleFrequency = samples > 1 ? (endFrame - initFrame2) / (samples - 1) : 1;
          var i = 0;
          var j = 0;
          var value2;
          if (this.pv.length) {
            value2 = createTypedArray("float32", this.pv.length);
          } else {
            value2 = 0;
          }
          var sampleValue;
          while (i < samples) {
            sampleValue = this.getValueAtTime(initFrame2 + i * sampleFrequency);
            if (this.pv.length) {
              for (j = 0; j < this.pv.length; j += 1) {
                value2[j] += sampleValue[j];
              }
            } else {
              value2 += sampleValue;
            }
            i += 1;
          }
          if (this.pv.length) {
            for (j = 0; j < this.pv.length; j += 1) {
              value2[j] /= samples;
            }
          } else {
            value2 /= samples;
          }
          return value2;
        }
        function getTransformValueAtTime(time3) {
          if (!this._transformCachingAtTime) {
            this._transformCachingAtTime = {
              v: new Matrix()
            };
          }
          var matrix = this._transformCachingAtTime.v;
          matrix.cloneFromProps(this.pre.props);
          if (this.appliedTransformations < 1) {
            var anchor = this.a.getValueAtTime(time3);
            matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
          }
          if (this.appliedTransformations < 2) {
            var scale2 = this.s.getValueAtTime(time3);
            matrix.scale(scale2[0] * this.s.mult, scale2[1] * this.s.mult, scale2[2] * this.s.mult);
          }
          if (this.sk && this.appliedTransformations < 3) {
            var skew = this.sk.getValueAtTime(time3);
            var skewAxis = this.sa.getValueAtTime(time3);
            matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
          }
          if (this.r && this.appliedTransformations < 4) {
            var rotation2 = this.r.getValueAtTime(time3);
            matrix.rotate(-rotation2 * this.r.mult);
          } else if (!this.r && this.appliedTransformations < 4) {
            var rotationZ = this.rz.getValueAtTime(time3);
            var rotationY = this.ry.getValueAtTime(time3);
            var rotationX = this.rx.getValueAtTime(time3);
            var orientation = this.or.getValueAtTime(time3);
            matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
          }
          if (this.data.p && this.data.p.s) {
            var positionX = this.px.getValueAtTime(time3);
            var positionY = this.py.getValueAtTime(time3);
            if (this.data.p.z) {
              var positionZ = this.pz.getValueAtTime(time3);
              matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
            } else {
              matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            }
          } else {
            var position2 = this.p.getValueAtTime(time3);
            matrix.translate(position2[0] * this.p.mult, position2[1] * this.p.mult, -position2[2] * this.p.mult);
          }
          return matrix;
        }
        function getTransformStaticValueAtTime() {
          return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem2, data2, container) {
          var prop = getTransformProperty(elem2, data2, container);
          if (prop.dynamicProperties.length) {
            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
          } else {
            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
          }
          prop.setGroupProperty = expressionHelpers.setGroupProperty;
          return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem2, data2, type, mult, container) {
          var prop = propertyGetProp(elem2, data2, type, mult, container);
          if (prop.kf) {
            prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
          } else {
            prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
          }
          prop.setGroupProperty = expressionHelpers.setGroupProperty;
          prop.loopOut = loopOut2;
          prop.loopIn = loopIn2;
          prop.smooth = smooth2;
          prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
          prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
          prop.numKeys = data2.a === 1 ? data2.k.length : 0;
          prop.propertyIndex = data2.ix;
          var value2 = 0;
          if (type !== 0) {
            value2 = createTypedArray("float32", data2.a === 1 ? data2.k[0].s.length : data2.k.length);
          }
          prop._cachingAtTime = {
            lastFrame: initialDefaultFrame,
            lastIndex: 0,
            value: value2
          };
          expressionHelpers.searchExpressions(elem2, data2, prop);
          if (prop.k) {
            container.addDynamicProperty(prop);
          }
          return prop;
        };
        function getShapeValueAtTime(frameNum) {
          if (!this._cachingAtTime) {
            this._cachingAtTime = {
              shapeValue: shapePool.clone(this.pv),
              lastIndex: 0,
              lastTime: initialDefaultFrame
            };
          }
          frameNum *= this.elem.globalData.frameRate;
          frameNum -= this.offsetTime;
          if (frameNum !== this._cachingAtTime.lastTime) {
            this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
            this._cachingAtTime.lastTime = frameNum;
            this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
          }
          return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {
        }
        ShapeExpressions.prototype = {
          vertices: function vertices(prop, time3) {
            if (this.k) {
              this.getValue();
            }
            var shapePath = this.v;
            if (time3 !== void 0) {
              shapePath = this.getValueAtTime(time3, 0);
            }
            var i;
            var len = shapePath._length;
            var vertices2 = shapePath[prop];
            var points = shapePath.v;
            var arr = createSizedArray(len);
            for (i = 0; i < len; i += 1) {
              if (prop === "i" || prop === "o") {
                arr[i] = [vertices2[i][0] - points[i][0], vertices2[i][1] - points[i][1]];
              } else {
                arr[i] = [vertices2[i][0], vertices2[i][1]];
              }
            }
            return arr;
          },
          points: function points(time3) {
            return this.vertices("v", time3);
          },
          inTangents: function inTangents(time3) {
            return this.vertices("i", time3);
          },
          outTangents: function outTangents(time3) {
            return this.vertices("o", time3);
          },
          isClosed: function isClosed() {
            return this.v.c;
          },
          pointOnPath: function pointOnPath(perc, time3) {
            var shapePath = this.v;
            if (time3 !== void 0) {
              shapePath = this.getValueAtTime(time3, 0);
            }
            if (!this._segmentsLength) {
              this._segmentsLength = bez.getSegmentsLength(shapePath);
            }
            var segmentsLength = this._segmentsLength;
            var lengths = segmentsLength.lengths;
            var lengthPos = segmentsLength.totalLength * perc;
            var i = 0;
            var len = lengths.length;
            var accumulatedLength = 0;
            var pt;
            while (i < len) {
              if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                var initIndex = i;
                var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                break;
              } else {
                accumulatedLength += lengths[i].addedLength;
              }
              i += 1;
            }
            if (!pt) {
              pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
            }
            return pt;
          },
          vectorOnPath: function vectorOnPath(perc, time3, vectorType) {
            if (perc == 1) {
              perc = this.v.c;
            } else if (perc == 0) {
              perc = 0.999;
            }
            var pt1 = this.pointOnPath(perc, time3);
            var pt2 = this.pointOnPath(perc + 1e-3, time3);
            var xLength = pt2[0] - pt1[0];
            var yLength = pt2[1] - pt1[1];
            var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
            if (magnitude === 0) {
              return [0, 0];
            }
            var unitVector = vectorType === "tangent" ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
            return unitVector;
          },
          tangentOnPath: function tangentOnPath(perc, time3) {
            return this.vectorOnPath(perc, time3, "tangent");
          },
          normalOnPath: function normalOnPath(perc, time3) {
            return this.vectorOnPath(perc, time3, "normal");
          },
          setGroupProperty: expressionHelpers.setGroupProperty,
          getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
        extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem2, data2, type, arr, trims) {
          var prop = propertyGetShapeProp(elem2, data2, type, arr, trims);
          prop.propertyIndex = data2.ix;
          prop.lock = false;
          if (type === 3) {
            expressionHelpers.searchExpressions(elem2, data2.pt, prop);
          } else if (type === 4) {
            expressionHelpers.searchExpressions(elem2, data2.ks, prop);
          }
          if (prop.k) {
            elem2.addDynamicProperty(prop);
          }
          return prop;
        };
      }
      function initialize$1() {
        addPropertyDecorator();
      }
      function addDecorator() {
        function searchExpressions() {
          if (this.data.d.x) {
            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
            this.addEffect(this.getExpressionValue.bind(this));
            return true;
          }
          return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text2) {
          var newValue = this.calculateExpression(text2);
          if (currentValue.t !== newValue) {
            var newData = {};
            this.copyData(newData, currentValue);
            newData.t = newValue.toString();
            newData.__complete = false;
            return newData;
          }
          return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
          var isKeyframed = this.searchKeyframes();
          var hasExpressions = this.searchExpressions();
          this.kf = isKeyframed || hasExpressions;
          return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
      }
      function initialize() {
        addDecorator();
      }
      function SVGComposableEffect() {
      }
      SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
          var feMerge = createNS("feMerge");
          feMerge.setAttribute("result", resultId);
          var feMergeNode;
          var i;
          for (i = 0; i < ins.length; i += 1) {
            feMergeNode = createNS("feMergeNode");
            feMergeNode.setAttribute("in", ins[i]);
            feMerge.appendChild(feMergeNode);
            feMerge.appendChild(feMergeNode);
          }
          return feMerge;
        }
      };
      var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
      function SVGTintFilter(filter, filterManager, elem2, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", linearFilterValue + " 1 0");
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute("result", id + "_tint_1");
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id + "_tint_2");
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [source, id + "_tint_1", id + "_tint_2"]);
        filter.appendChild(feMerge);
      }
      extendPrototype([SVGComposableEffect], SVGTintFilter);
      SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          var colorBlack = this.filterManager.effectElements[0].p.v;
          var colorWhite = this.filterManager.effectElements[1].p.v;
          var opacity = this.filterManager.effectElements[2].p.v / 100;
          this.linearFilter.setAttribute("values", linearFilterValue + " " + opacity + " 0");
          this.matrixFilter.setAttribute("values", colorWhite[0] - colorBlack[0] + " 0 0 0 " + colorBlack[0] + " " + (colorWhite[1] - colorBlack[1]) + " 0 0 0 " + colorBlack[1] + " " + (colorWhite[2] - colorBlack[2]) + " 0 0 0 " + colorBlack[2] + " 0 0 0 1 0");
        }
      };
      function SVGFillFilter(filter, filterManager, elem2, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
      }
      SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          var color2 = this.filterManager.effectElements[2].p.v;
          var opacity = this.filterManager.effectElements[6].p.v;
          this.matrixFilter.setAttribute("values", "0 0 0 0 " + color2[0] + " 0 0 0 0 " + color2[1] + " 0 0 0 0 " + color2[2] + " 0 0 0 " + opacity + " 0");
        }
      };
      function SVGStrokeEffect(fil, filterManager, elem2) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem2;
        this.paths = [];
      }
      SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path2;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
          len = this.elem.maskManager.masksProperties.length;
          i = 0;
        } else {
          i = this.filterManager.effectElements[0].p.v - 1;
          len = i + 1;
        }
        groupPath = createNS("g");
        groupPath.setAttribute("fill", "none");
        groupPath.setAttribute("stroke-linecap", "round");
        groupPath.setAttribute("stroke-dashoffset", 1);
        for (i; i < len; i += 1) {
          path2 = createNS("path");
          groupPath.appendChild(path2);
          this.paths.push({
            p: path2,
            m: i
          });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
          var mask2 = createNS("mask");
          var id = createElementID();
          mask2.setAttribute("id", id);
          mask2.setAttribute("mask-type", "alpha");
          mask2.appendChild(groupPath);
          this.elem.globalData.defs.appendChild(mask2);
          var g = createNS("g");
          g.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
          while (elemChildren[0]) {
            g.appendChild(elemChildren[0]);
          }
          this.elem.layerElement.appendChild(g);
          this.masker = mask2;
          groupPath.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
          if (this.filterManager.effectElements[10].p.v === 2) {
            elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            while (elemChildren.length) {
              this.elem.layerElement.removeChild(elemChildren[0]);
            }
          }
          this.elem.layerElement.appendChild(groupPath);
          this.elem.layerElement.removeAttribute("mask");
          groupPath.setAttribute("stroke", "#fff");
        }
        this.initialized = true;
        this.pathMasker = groupPath;
      };
      SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) {
          this.initialize();
        }
        var i;
        var len = this.paths.length;
        var mask2;
        var path2;
        for (i = 0; i < len; i += 1) {
          if (this.paths[i].m !== -1) {
            mask2 = this.elem.maskManager.viewData[this.paths[i].m];
            path2 = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask2.prop._mdf) {
              path2.setAttribute("d", mask2.lastPath);
            }
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask2.prop._mdf) {
              var dasharrayValue;
              if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                var s2 = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                var l = path2.getTotalLength();
                dasharrayValue = "0 0 0 " + l * s2 + " ";
                var lineLength = l * (e - s2);
                var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                var units = Math.floor(lineLength / segment);
                var j;
                for (j = 0; j < units; j += 1) {
                  dasharrayValue += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                }
                dasharrayValue += "0 " + l * 10 + " 0 0";
              } else {
                dasharrayValue = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
              }
              path2.setAttribute("stroke-dasharray", dasharrayValue);
            }
          }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) {
          this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2);
        }
        if (forceRender || this.filterManager.effectElements[6].p._mdf) {
          this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v);
        }
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
          if (forceRender || this.filterManager.effectElements[3].p._mdf) {
            var color2 = this.filterManager.effectElements[3].p.v;
            this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(color2[0] * 255) + "," + bmFloor(color2[1] * 255) + "," + bmFloor(color2[2] * 255) + ")");
          }
        }
      };
      function SVGTritoneFilter(filter, filterManager, elem2, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS("feComponentTransfer");
        feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
        feComponentTransfer.setAttribute("result", id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS("feFuncR");
        feFuncR.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS("feFuncG");
        feFuncG.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS("feFuncB");
        feFuncB.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
      }
      SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          var color1 = this.filterManager.effectElements[0].p.v;
          var color2 = this.filterManager.effectElements[1].p.v;
          var color3 = this.filterManager.effectElements[2].p.v;
          var tableR = color3[0] + " " + color2[0] + " " + color1[0];
          var tableG = color3[1] + " " + color2[1] + " " + color1[1];
          var tableB = color3[2] + " " + color2[2] + " " + color1[2];
          this.feFuncR.setAttribute("tableValues", tableR);
          this.feFuncG.setAttribute("tableValues", tableG);
          this.feFuncB.setAttribute("tableValues", tableB);
        }
      };
      function SVGProLevelsFilter(filter, filterManager, elem2, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS("feComponentTransfer");
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
          this.feFuncR = this.createFeFunc("feFuncR", feComponentTransfer);
        }
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
          this.feFuncG = this.createFeFunc("feFuncG", feComponentTransfer);
        }
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
          this.feFuncB = this.createFeFunc("feFuncB", feComponentTransfer);
        }
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
          this.feFuncA = this.createFeFunc("feFuncA", feComponentTransfer);
        }
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
          feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
          filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
          feComponentTransfer = createNS("feComponentTransfer");
          feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
          feComponentTransfer.setAttribute("result", id);
          filter.appendChild(feComponentTransfer);
          this.feFuncRComposed = this.createFeFunc("feFuncR", feComponentTransfer);
          this.feFuncGComposed = this.createFeFunc("feFuncG", feComponentTransfer);
          this.feFuncBComposed = this.createFeFunc("feFuncB", feComponentTransfer);
        }
      }
      SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
      };
      SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma2, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min3 = Math.min(inputBlack, inputWhite);
        var max4 = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
          length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while (cnt <= 256) {
          perc = cnt / 256;
          if (perc <= min3) {
            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
          } else if (perc >= max4) {
            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
          } else {
            colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma2);
          }
          table[pos] = colorValue;
          pos += 1;
          cnt += 256 / (segments - 1);
        }
        return table.join(" ");
      };
      SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          var val2;
          var effectElements = this.filterManager.effectElements;
          if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
            val2 = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
            this.feFuncRComposed.setAttribute("tableValues", val2);
            this.feFuncGComposed.setAttribute("tableValues", val2);
            this.feFuncBComposed.setAttribute("tableValues", val2);
          }
          if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
            val2 = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
            this.feFuncR.setAttribute("tableValues", val2);
          }
          if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
            val2 = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
            this.feFuncG.setAttribute("tableValues", val2);
          }
          if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
            val2 = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
            this.feFuncB.setAttribute("tableValues", val2);
          }
          if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
            val2 = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
            this.feFuncA.setAttribute("tableValues", val2);
          }
        }
      };
      function SVGDropShadowEffect(filter, filterManager, elem2, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute("x", filterSize.x || globalFilterSize.x);
        filter.setAttribute("y", filterSize.y || globalFilterSize.y);
        filter.setAttribute("width", filterSize.width || globalFilterSize.width);
        filter.setAttribute("height", filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("in", "SourceAlpha");
        feGaussianBlur.setAttribute("result", id + "_drop_shadow_1");
        feGaussianBlur.setAttribute("stdDeviation", "0");
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS("feOffset");
        feOffset.setAttribute("dx", "25");
        feOffset.setAttribute("dy", "0");
        feOffset.setAttribute("in", id + "_drop_shadow_1");
        feOffset.setAttribute("result", id + "_drop_shadow_2");
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS("feFlood");
        feFlood.setAttribute("flood-color", "#00ff00");
        feFlood.setAttribute("flood-opacity", "1");
        feFlood.setAttribute("result", id + "_drop_shadow_3");
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS("feComposite");
        feComposite.setAttribute("in", id + "_drop_shadow_3");
        feComposite.setAttribute("in2", id + "_drop_shadow_2");
        feComposite.setAttribute("operator", "in");
        feComposite.setAttribute("result", id + "_drop_shadow_4");
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [id + "_drop_shadow_4", source]);
        filter.appendChild(feMerge);
      }
      extendPrototype([SVGComposableEffect], SVGDropShadowEffect);
      SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          if (forceRender || this.filterManager.effectElements[4].p._mdf) {
            this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4);
          }
          if (forceRender || this.filterManager.effectElements[0].p._mdf) {
            var col = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
          }
          if (forceRender || this.filterManager.effectElements[1].p._mdf) {
            this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255);
          }
          if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
            var distance = this.filterManager.effectElements[3].p.v;
            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
            var x2 = distance * Math.cos(angle);
            var y2 = distance * Math.sin(angle);
            this.feOffset.setAttribute("dx", x2);
            this.feOffset.setAttribute("dy", y2);
          }
        }
      };
      var _svgMatteSymbols = [];
      function SVGMatte3Effect(filterElem, filterManager, elem2) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem2;
        elem2.matteElement = createNS("g");
        elem2.matteElement.appendChild(elem2.layerElement);
        elem2.matteElement.appendChild(elem2.transformedElement);
        elem2.baseElement = elem2.matteElement;
      }
      SVGMatte3Effect.prototype.findSymbol = function(mask2) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while (i < len) {
          if (_svgMatteSymbols[i] === mask2) {
            return _svgMatteSymbols[i];
          }
          i += 1;
        }
        return null;
      };
      SVGMatte3Effect.prototype.replaceInParent = function(mask2, symbolId) {
        var parentNode = mask2.layerElement.parentNode;
        if (!parentNode) {
          return;
        }
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while (i < len) {
          if (children[i] === mask2.layerElement) {
            break;
          }
          i += 1;
        }
        var nextChild;
        if (i <= len - 2) {
          nextChild = children[i + 1];
        }
        var useElem = createNS("use");
        useElem.setAttribute("href", "#" + symbolId);
        if (nextChild) {
          parentNode.insertBefore(useElem, nextChild);
        } else {
          parentNode.appendChild(useElem);
        }
      };
      SVGMatte3Effect.prototype.setElementAsMask = function(elem2, mask2) {
        if (!this.findSymbol(mask2)) {
          var symbolId = createElementID();
          var masker = createNS("mask");
          masker.setAttribute("id", mask2.layerId);
          masker.setAttribute("mask-type", "alpha");
          _svgMatteSymbols.push(mask2);
          var defs = elem2.globalData.defs;
          defs.appendChild(masker);
          var symbol = createNS("symbol");
          symbol.setAttribute("id", symbolId);
          this.replaceInParent(mask2, symbolId);
          symbol.appendChild(mask2.layerElement);
          defs.appendChild(symbol);
          var useElem = createNS("use");
          useElem.setAttribute("href", "#" + symbolId);
          masker.appendChild(useElem);
          mask2.data.hd = false;
          mask2.show();
        }
        elem2.setMatte(mask2.layerId);
      };
      SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while (i < len) {
          if (elements[i] && elements[i].data.ind === ind) {
            this.setElementAsMask(this.elem, elements[i]);
          }
          i += 1;
        }
        this.initialized = true;
      };
      SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) {
          this.initialize();
        }
      };
      function SVGGaussianBlurEffect(filter, filterManager, elem2, id) {
        filter.setAttribute("x", "-100%");
        filter.setAttribute("y", "-100%");
        filter.setAttribute("width", "300%");
        filter.setAttribute("height", "300%");
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("result", id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
      }
      SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
          var kBlurrinessToSigma = 0.3;
          var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;
          var dimensions = this.filterManager.effectElements[1].p.v;
          var sigmaX = dimensions == 3 ? 0 : sigma;
          var sigmaY = dimensions == 2 ? 0 : sigma;
          this.feGaussianBlur.setAttribute("stdDeviation", sigmaX + " " + sigmaY);
          var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
          this.feGaussianBlur.setAttribute("edgeMode", edgeMode);
        }
      };
      function TransformEffect() {
      }
      TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
      };
      TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
          var effectElements = this.effectsManager.effectElements;
          var anchor = effectElements[0].p.v;
          var position2 = effectElements[1].p.v;
          var isUniformScale = effectElements[2].p.v === 1;
          var scaleHeight = effectElements[3].p.v;
          var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
          var skew = effectElements[5].p.v;
          var skewAxis = effectElements[6].p.v;
          var rotation2 = effectElements[7].p.v;
          this.matrix.reset();
          this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
          this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
          this.matrix.rotate(-rotation2 * degToRads);
          this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
          this.matrix.translate(position2[0], position2[1], 0);
          this._mdf = true;
          if (this.opacity !== effectElements[8].p.v) {
            this.opacity = effectElements[8].p.v;
            this._opMdf = true;
          }
        }
      };
      function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
      }
      extendPrototype([TransformEffect], SVGTransformEffect);
      function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
      }
      extendPrototype([TransformEffect], CVTransformEffect);
      registerRenderer("canvas", CanvasRenderer);
      registerRenderer("html", HybridRenderer);
      registerRenderer("svg", SVGRenderer);
      ShapeModifiers.registerModifier("tm", TrimModifier);
      ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
      ShapeModifiers.registerModifier("rp", RepeaterModifier);
      ShapeModifiers.registerModifier("rd", RoundCornersModifier);
      ShapeModifiers.registerModifier("zz", ZigZagModifier);
      ShapeModifiers.registerModifier("op", OffsetPathModifier);
      setExpressionsPlugin(Expressions);
      setExpressionInterfaces(getInterface);
      initialize$1();
      initialize();
      registerEffect$1(20, SVGTintFilter, true);
      registerEffect$1(21, SVGFillFilter, true);
      registerEffect$1(22, SVGStrokeEffect, false);
      registerEffect$1(23, SVGTritoneFilter, true);
      registerEffect$1(24, SVGProLevelsFilter, true);
      registerEffect$1(25, SVGDropShadowEffect, true);
      registerEffect$1(28, SVGMatte3Effect, false);
      registerEffect$1(29, SVGGaussianBlurEffect, true);
      registerEffect$1(35, SVGTransformEffect, false);
      registerEffect(35, CVTransformEffect);
      return lottie;
    });
  }
});

// node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js"(exports2, module2) {
    !function(t, e) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports2, function() {
      var t = 1e3, e = 6e4, n = 36e5, r2 = "millisecond", i = "second", s2 = "minute", u = "hour", a2 = "day", o = "week", c2 = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e3 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e3[(n2 - 20) % 10] || e3[n2] || e3[0]) + "]";
      } }, m = function(t2, e3, n2) {
        var r3 = String(t2);
        return !r3 || r3.length >= e3 ? t2 : "" + Array(e3 + 1 - r3.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e3 = -t2.utcOffset(), n2 = Math.abs(e3), r3 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e3 <= 0 ? "+" : "-") + m(r3, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e3, n2) {
        if (e3.date() < n2.date()) return -t2(n2, e3);
        var r3 = 12 * (n2.year() - e3.year()) + (n2.month() - e3.month()), i2 = e3.clone().add(r3, c2), s3 = n2 - i2 < 0, u2 = e3.clone().add(r3 + (s3 ? -1 : 1), c2);
        return +(-(r3 + (n2 - i2) / (s3 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c2, y: h, w: o, d: a2, D: d, h: u, m: s2, s: i, ms: r2, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, w = function t2(e3, n2, r3) {
        var i2;
        if (!e3) return g;
        if ("string" == typeof e3) {
          var s3 = e3.toLowerCase();
          D[s3] && (i2 = s3), n2 && (D[s3] = n2, i2 = s3);
          var u2 = e3.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a3 = e3.name;
          D[a3] = e3, i2 = a3;
        }
        return !r3 && i2 && (g = i2), i2 || !r3 && g;
      }, O = function(t2, e3) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e3 ? e3 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e3) {
        return O(t2, { locale: e3.$L, utc: e3.$u, x: e3.$x, $offset: e3.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e3 = t3.date, n2 = t3.utc;
            if (null === e3) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e3)) return /* @__PURE__ */ new Date();
            if (e3 instanceof Date) return new Date(e3);
            if ("string" == typeof e3 && !/Z$/i.test(e3)) {
              var r3 = e3.match($);
              if (r3) {
                var i2 = r3[2] - 1 || 0, s3 = (r3[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3)) : new Date(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3);
              }
            }
            return new Date(e3);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e3) {
          var n2 = O(t2);
          return this.startOf(e3) <= n2 && n2 <= this.endOf(e3);
        }, m2.isAfter = function(t2, e3) {
          return O(t2) < this.startOf(e3);
        }, m2.isBefore = function(t2, e3) {
          return this.endOf(e3) < O(t2);
        }, m2.$g = function(t2, e3, n2) {
          return b.u(t2) ? this[e3] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e3) {
          var n2 = this, r3 = !!b.u(e3) || e3, f2 = b.p(t2), l2 = function(t3, e4) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e4, t3) : new Date(n2.$y, e4, t3), n2);
            return r3 ? i2 : i2.endOf(a2);
          }, $2 = function(t3, e4) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n2);
          }, y3 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r3 ? l2(1, 0) : l2(31, 11);
            case c2:
              return r3 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y3 < g2 ? y3 + 7 : y3) - g2;
              return l2(r3 ? m3 - D2 : m3 + (6 - D2), M3);
            case a2:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s2:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e3) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a2] = f2 + "Date", n2[d] = f2 + "Date", n2[c2] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s2] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r2] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a2 ? this.$D + (e3 - this.$W) : e3;
          if (o2 === c2 || o2 === h) {
            var y3 = this.clone().set(d, 1);
            y3.$d[l2]($2), y3.init(), this.$d = y3.set(d, Math.min(this.$D, y3.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e3) {
          return this.clone().$set(t2, e3);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r3, f2) {
          var d2, l2 = this;
          r3 = Number(r3);
          var $2 = b.p(f2), y3 = function(t2) {
            var e3 = O(l2);
            return b.w(e3.date(e3.date() + Math.round(t2 * r3)), l2);
          };
          if ($2 === c2) return this.set(c2, this.$M + r3);
          if ($2 === h) return this.set(h, this.$y + r3);
          if ($2 === a2) return y3(1);
          if ($2 === o) return y3(7);
          var M3 = (d2 = {}, d2[s2] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r3 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e3) {
          return this.add(-1 * t2, e3);
        }, m2.format = function(t2) {
          var e3 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r3 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s3 = this.$H, u2 = this.$m, a3 = this.$M, o2 = n2.weekdays, c3 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s4) {
            return t3 && (t3[n3] || t3(e3, r3)) || i3[n3].slice(0, s4);
          }, d2 = function(t3) {
            return b.s(s3 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e4, n3) {
            var r4 = t3 < 12 ? "AM" : "PM";
            return n3 ? r4.toLowerCase() : r4;
          };
          return r3.replace(y2, function(t3, r4) {
            return r4 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e3.$y).slice(-2);
                case "YYYY":
                  return b.s(e3.$y, 4, "0");
                case "M":
                  return a3 + 1;
                case "MM":
                  return b.s(a3 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a3, c3, 3);
                case "MMMM":
                  return h2(c3, a3);
                case "D":
                  return e3.$D;
                case "DD":
                  return b.s(e3.$D, 2, "0");
                case "d":
                  return String(e3.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e3.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e3.$W, o2, 3);
                case "dddd":
                  return o2[e3.$W];
                case "H":
                  return String(s3);
                case "HH":
                  return b.s(s3, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s3, u2, true);
                case "A":
                  return $2(s3, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e3.$s);
                case "ss":
                  return b.s(e3.$s, 2, "0");
                case "SSS":
                  return b.s(e3.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r3, d2, l2) {
          var $2, y3 = this, M3 = b.p(d2), m3 = O(r3), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y3, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c2:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a2:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s2:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c2).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e3) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r3 = w(t2, e3, true);
          return r3 && (n2.$L = r3), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k2 = _.prototype;
      return O.prototype = k2, [["$ms", r2], ["$s", i], ["$m", s2], ["$H", u], ["$W", a2], ["$M", c2], ["$y", h], ["$D", d]].forEach(function(t2) {
        k2[t2[1]] = function(e3) {
          return this.$g(e3, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e3) {
        return t2.$i || (t2(e3, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/timezone.js
var require_timezone = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/timezone.js"(exports2, module2) {
    !function(t, e) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_timezone = e();
    }(exports2, function() {
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
      return function(n, i, o) {
        var r2, a2 = function(t2, n2, i2) {
          void 0 === i2 && (i2 = {});
          var o2 = new Date(t2), r3 = function(t3, n3) {
            void 0 === n3 && (n3 = {});
            var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r4 = e[o3];
            return r4 || (r4 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r4), r4;
          }(n2, i2);
          return r3.formatToParts(o2);
        }, u = function(e3, n2) {
          for (var i2 = a2(e3, n2), r3 = [], u2 = 0; u2 < i2.length; u2 += 1) {
            var f2 = i2[u2], s3 = f2.type, m = f2.value, c2 = t[s3];
            c2 >= 0 && (r3[c2] = parseInt(m, 10));
          }
          var d = r3[3], l = 24 === d ? 0 : d, h = r3[0] + "-" + r3[1] + "-" + r3[2] + " " + l + ":" + r3[4] + ":" + r3[5] + ":000", v = +e3;
          return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t2, e3) {
          void 0 === t2 && (t2 = r2);
          var n2, i2 = this.utcOffset(), a3 = this.toDate(), u2 = a3.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a3 - new Date(u2)) / 1e3 / 60), s3 = 15 * -Math.round(a3.getTimezoneOffset() / 15) - f2;
          if (!Number(s3)) n2 = this.utcOffset(0, e3);
          else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s3, true), e3) {
            var m = n2.utcOffset();
            n2 = n2.add(i2 - m, "minute");
          }
          return n2.$x.$timezone = t2, n2;
        }, f.offsetName = function(t2) {
          var e3 = this.$x.$timezone || o.tz.guess(), n2 = a2(this.valueOf(), e3, { timeZoneName: t2 }).find(function(t3) {
            return "timezonename" === t3.type.toLowerCase();
          });
          return n2 && n2.value;
        };
        var s2 = f.startOf;
        f.startOf = function(t2, e3) {
          if (!this.$x || !this.$x.$timezone) return s2.call(this, t2, e3);
          var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return s2.call(n2, t2, e3).tz(this.$x.$timezone, true);
        }, o.tz = function(t2, e3, n2) {
          var i2 = n2 && e3, a3 = n2 || e3 || r2, f2 = u(+o(), a3);
          if ("string" != typeof t2) return o(t2).tz(a3);
          var s3 = function(t3, e4, n3) {
            var i3 = t3 - 60 * e4 * 1e3, o2 = u(i3, n3);
            if (e4 === o2) return [i3, e4];
            var r3 = u(i3 -= 60 * (o2 - e4) * 1e3, n3);
            return o2 === r3 ? [i3, o2] : [t3 - 60 * Math.min(o2, r3) * 1e3, Math.max(o2, r3)];
          }(o.utc(t2, i2).valueOf(), f2, a3), m = s3[0], c2 = s3[1], d = o(m).utcOffset(c2);
          return d.$x.$timezone = a3, d;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t2) {
          r2 = t2;
        };
      };
    });
  }
});

// node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/utc.js
var require_utc = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/utc.js"(exports2, module2) {
    !function(t, i) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
    }(exports2, function() {
      var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
      return function(s2, f, n) {
        var u = f.prototype;
        n.utc = function(t2) {
          var i2 = { date: t2, utc: true, args: arguments };
          return new f(i2);
        }, u.utc = function(i2) {
          var e3 = n(this.toDate(), { locale: this.$L, utc: true });
          return i2 ? e3.add(this.utcOffset(), t) : e3;
        }, u.local = function() {
          return n(this.toDate(), { locale: this.$L, utc: false });
        };
        var o = u.parse;
        u.parse = function(t2) {
          t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), o.call(this, t2);
        };
        var r2 = u.init;
        u.init = function() {
          if (this.$u) {
            var t2 = this.$d;
            this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
          } else r2.call(this);
        };
        var a2 = u.utcOffset;
        u.utcOffset = function(s3, f2) {
          var n2 = this.$utils().u;
          if (n2(s3)) return this.$u ? 0 : n2(this.$offset) ? a2.call(this) : this.$offset;
          if ("string" == typeof s3 && (s3 = function(t2) {
            void 0 === t2 && (t2 = "");
            var s4 = t2.match(i);
            if (!s4) return null;
            var f3 = ("" + s4[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
            return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
          }(s3), null === s3)) return this;
          var u2 = Math.abs(s3) <= 16 ? 60 * s3 : s3, o2 = this;
          if (f2) return o2.$offset = u2, o2.$u = 0 === s3, o2;
          if (0 !== s3) {
            var r3 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (o2 = this.local().add(u2 + r3, t)).$offset = u2, o2.$x.$localOffset = r3;
          } else o2 = this.utc();
          return o2;
        };
        var h = u.format;
        u.format = function(t2) {
          var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i2);
        }, u.valueOf = function() {
          var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t2;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t2) {
          return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c2 = u.diff;
        u.diff = function(t2, i2, e3) {
          if (t2 && this.$u === t2.$u) return c2.call(this, t2, i2, e3);
          var s3 = this.local(), f2 = n(t2).local();
          return c2.call(s3, f2, i2, e3);
        };
      };
    });
  }
});

// node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isoWeek.js
var require_isoWeek = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isoWeek.js"(exports2, module2) {
    !function(e, t) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isoWeek = t();
    }(exports2, function() {
      var e = "day";
      return function(t, i, s2) {
        var a2 = function(t2) {
          return t2.add(4 - t2.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
          return a2(this).year();
        }, d.isoWeek = function(t2) {
          if (!this.$utils().u(t2)) return this.add(7 * (t2 - this.isoWeek()), e);
          var i2, d2, n2, o, r2 = a2(this), u = (i2 = this.isoWeekYear(), d2 = this.$u, n2 = (d2 ? s2.utc : s2)().year(i2).startOf("year"), o = 4 - n2.isoWeekday(), n2.isoWeekday() > 4 && (o += 7), n2.add(o, e));
          return r2.diff(u, "week") + 1;
        }, d.isoWeekday = function(e3) {
          return this.$utils().u(e3) ? this.day() || 7 : this.day(this.day() % 7 ? e3 : e3 - 7);
        };
        var n = d.startOf;
        d.startOf = function(e3, t2) {
          var i2 = this.$utils(), s3 = !!i2.u(t2) || t2;
          return "isoweek" === i2.p(e3) ? s3 ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e3, t2);
        };
      };
    });
  }
});

// node_modules/.pnpm/picocolors@1.1.1/node_modules/picocolors/picocolors.js
var require_picocolors = __commonJS({
  "node_modules/.pnpm/picocolors@1.1.1/node_modules/picocolors/picocolors.js"(exports2, module2) {
    var p = process || {};
    var argv = p.argv || [];
    var env = p.env || {};
    var isColorSupported = !(!!env.NO_COLOR || argv.includes("--no-color")) && (!!env.FORCE_COLOR || argv.includes("--color") || p.platform === "win32" || (p.stdout || {}).isTTY && env.TERM !== "dumb" || !!env.CI);
    var formatter = (open, close, replace = open) => (input) => {
      let string = "" + input, index2 = string.indexOf(close, open.length);
      return ~index2 ? open + replaceClose(string, close, replace, index2) + close : open + string + close;
    };
    var replaceClose = (string, close, replace, index2) => {
      let result = "", cursor = 0;
      do {
        result += string.substring(cursor, index2) + replace;
        cursor = index2 + close.length;
        index2 = string.indexOf(close, cursor);
      } while (~index2);
      return result + string.substring(cursor);
    };
    var createColors = (enabled = isColorSupported) => {
      let f = enabled ? formatter : () => String;
      return {
        isColorSupported: enabled,
        reset: f("\x1B[0m", "\x1B[0m"),
        bold: f("\x1B[1m", "\x1B[22m", "\x1B[22m\x1B[1m"),
        dim: f("\x1B[2m", "\x1B[22m", "\x1B[22m\x1B[2m"),
        italic: f("\x1B[3m", "\x1B[23m"),
        underline: f("\x1B[4m", "\x1B[24m"),
        inverse: f("\x1B[7m", "\x1B[27m"),
        hidden: f("\x1B[8m", "\x1B[28m"),
        strikethrough: f("\x1B[9m", "\x1B[29m"),
        black: f("\x1B[30m", "\x1B[39m"),
        red: f("\x1B[31m", "\x1B[39m"),
        green: f("\x1B[32m", "\x1B[39m"),
        yellow: f("\x1B[33m", "\x1B[39m"),
        blue: f("\x1B[34m", "\x1B[39m"),
        magenta: f("\x1B[35m", "\x1B[39m"),
        cyan: f("\x1B[36m", "\x1B[39m"),
        white: f("\x1B[37m", "\x1B[39m"),
        gray: f("\x1B[90m", "\x1B[39m"),
        bgBlack: f("\x1B[40m", "\x1B[49m"),
        bgRed: f("\x1B[41m", "\x1B[49m"),
        bgGreen: f("\x1B[42m", "\x1B[49m"),
        bgYellow: f("\x1B[43m", "\x1B[49m"),
        bgBlue: f("\x1B[44m", "\x1B[49m"),
        bgMagenta: f("\x1B[45m", "\x1B[49m"),
        bgCyan: f("\x1B[46m", "\x1B[49m"),
        bgWhite: f("\x1B[47m", "\x1B[49m"),
        blackBright: f("\x1B[90m", "\x1B[39m"),
        redBright: f("\x1B[91m", "\x1B[39m"),
        greenBright: f("\x1B[92m", "\x1B[39m"),
        yellowBright: f("\x1B[93m", "\x1B[39m"),
        blueBright: f("\x1B[94m", "\x1B[39m"),
        magentaBright: f("\x1B[95m", "\x1B[39m"),
        cyanBright: f("\x1B[96m", "\x1B[39m"),
        whiteBright: f("\x1B[97m", "\x1B[39m"),
        bgBlackBright: f("\x1B[100m", "\x1B[49m"),
        bgRedBright: f("\x1B[101m", "\x1B[49m"),
        bgGreenBright: f("\x1B[102m", "\x1B[49m"),
        bgYellowBright: f("\x1B[103m", "\x1B[49m"),
        bgBlueBright: f("\x1B[104m", "\x1B[49m"),
        bgMagentaBright: f("\x1B[105m", "\x1B[49m"),
        bgCyanBright: f("\x1B[106m", "\x1B[49m"),
        bgWhiteBright: f("\x1B[107m", "\x1B[49m")
      };
    };
    module2.exports = createColors();
    module2.exports.createColors = createColors;
  }
});

// node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/lib/util/log.js
var require_log = __commonJS({
  "node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/lib/util/log.js"(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    function _export(target, all) {
      for (var name2 in all) Object.defineProperty(target, name2, {
        enumerable: true,
        get: all[name2]
      });
    }
    _export(exports2, {
      dim: function() {
        return dim;
      },
      default: function() {
        return _default;
      }
    });
    var _picocolors = /* @__PURE__ */ _interop_require_default(require_picocolors());
    function _interop_require_default(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var alreadyShown = /* @__PURE__ */ new Set();
    function log2(type, messages, key2) {
      if (typeof process !== "undefined" && process.env.JEST_WORKER_ID) return;
      if (key2 && alreadyShown.has(key2)) return;
      if (key2) alreadyShown.add(key2);
      console.warn("");
      messages.forEach((message) => console.warn(type, "-", message));
    }
    function dim(input) {
      return _picocolors.default.dim(input);
    }
    var _default = {
      info(key2, messages) {
        log2(_picocolors.default.bold(_picocolors.default.cyan("info")), ...Array.isArray(key2) ? [
          key2
        ] : [
          messages,
          key2
        ]);
      },
      warn(key2, messages) {
        log2(_picocolors.default.bold(_picocolors.default.yellow("warn")), ...Array.isArray(key2) ? [
          key2
        ] : [
          messages,
          key2
        ]);
      },
      risk(key2, messages) {
        log2(_picocolors.default.bold(_picocolors.default.magenta("risk")), ...Array.isArray(key2) ? [
          key2
        ] : [
          messages,
          key2
        ]);
      }
    };
  }
});

// node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/lib/public/colors.js
var require_colors = __commonJS({
  "node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/lib/public/colors.js"(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    Object.defineProperty(exports2, "default", {
      enumerable: true,
      get: function() {
        return _default;
      }
    });
    var _log = /* @__PURE__ */ _interop_require_default(require_log());
    function _interop_require_default(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function warn5({ version, from, to }) {
      _log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    var _default = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        warn5({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        });
        return this.sky;
      },
      get warmGray() {
        warn5({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        });
        return this.stone;
      },
      get trueGray() {
        warn5({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        });
        return this.neutral;
      },
      get coolGray() {
        warn5({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        });
        return this.gray;
      },
      get blueGray() {
        warn5({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        });
        return this.slate;
      }
    };
  }
});

// node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/colors.js
var require_colors2 = __commonJS({
  "node_modules/.pnpm/tailwindcss@3.4.17/node_modules/tailwindcss/colors.js"(exports2, module2) {
    var colors2 = require_colors();
    module2.exports = (colors2.__esModule ? colors2 : { default: colors2 }).default;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"(exports2, module2) {
    var isArray2 = Array.isArray;
    module2.exports = isArray2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js"(exports2, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js"(exports2, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"(exports2, module2) {
    var root = require_root();
    var Symbol3 = root.Symbol;
    module2.exports = Symbol3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol3 ? Symbol3.toStringTag : void 0;
    function getRawTag(value2) {
      var isOwn = hasOwnProperty2.call(value2, symToStringTag), tag = value2[symToStringTag];
      try {
        value2[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value2);
      if (unmasked) {
        if (isOwn) {
          value2[symToStringTag] = tag;
        } else {
          delete value2[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js"(exports2, module2) {
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value2) {
      return nativeObjectToString.call(value2);
    }
    module2.exports = objectToString;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol3 ? Symbol3.toStringTag : void 0;
    function baseGetTag(value2) {
      if (value2 == null) {
        return value2 === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString(value2);
    }
    module2.exports = baseGetTag;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js"(exports2, module2) {
    function isObjectLike(value2) {
      return value2 != null && typeof value2 == "object";
    }
    module2.exports = isObjectLike;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value2) {
      return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag(value2) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js
var require_isKey = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js"(exports2, module2) {
    var isArray2 = require_isArray();
    var isSymbol = require_isSymbol();
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    function isKey(value2, object) {
      if (isArray2(value2)) {
        return false;
      }
      var type = typeof value2;
      if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol(value2)) {
        return true;
      }
      return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
    }
    module2.exports = isKey;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js"(exports2, module2) {
    function isObject5(value2) {
      var type = typeof value2;
      return value2 != null && (type == "object" || type == "function");
    }
    module2.exports = isObject5;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isObject5 = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction23(value2) {
      if (!isObject5(value2)) {
        return false;
      }
      var tag = baseGetTag(value2);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module2.exports = isFunction23;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js"(exports2, module2) {
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module2.exports = coreJsData;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js"(exports2, module2) {
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module2.exports = isMasked;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js"(exports2, module2) {
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module2.exports = toSource;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js"(exports2, module2) {
    var isFunction23 = require_isFunction();
    var isMasked = require_isMasked();
    var isObject5 = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value2) {
      if (!isObject5(value2) || isMasked(value2)) {
        return false;
      }
      var pattern = isFunction23(value2) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value2));
    }
    module2.exports = baseIsNative;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js"(exports2, module2) {
    function getValue(object, key2) {
      return object == null ? void 0 : object[key2];
    }
    module2.exports = getValue;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"(exports2, module2) {
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key2) {
      var value2 = getValue(object, key2);
      return baseIsNative(value2) ? value2 : void 0;
    }
    module2.exports = getNative;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js"(exports2, module2) {
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module2.exports = nativeCreate;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js"(exports2, module2) {
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module2.exports = hashClear;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js"(exports2, module2) {
    function hashDelete(key2) {
      var result = this.has(key2) && delete this.__data__[key2];
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = hashDelete;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js"(exports2, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashGet(key2) {
      var data2 = this.__data__;
      if (nativeCreate) {
        var result = data2[key2];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty2.call(data2, key2) ? data2[key2] : void 0;
    }
    module2.exports = hashGet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js"(exports2, module2) {
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashHas(key2) {
      var data2 = this.__data__;
      return nativeCreate ? data2[key2] !== void 0 : hasOwnProperty2.call(data2, key2);
    }
    module2.exports = hashHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js"(exports2, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key2, value2) {
      var data2 = this.__data__;
      this.size += this.has(key2) ? 0 : 1;
      data2[key2] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
      return this;
    }
    module2.exports = hashSet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js"(exports2, module2) {
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module2.exports = Hash;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js"(exports2, module2) {
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module2.exports = listCacheClear;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js
var require_eq = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js"(exports2, module2) {
    function eq(value2, other) {
      return value2 === other || value2 !== value2 && other !== other;
    }
    module2.exports = eq;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js"(exports2, module2) {
    var eq = require_eq();
    function assocIndexOf(array, key2) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key2)) {
          return length2;
        }
      }
      return -1;
    }
    module2.exports = assocIndexOf;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js"(exports2, module2) {
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key2) {
      var data2 = this.__data__, index2 = assocIndexOf(data2, key2);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data2.length - 1;
      if (index2 == lastIndex) {
        data2.pop();
      } else {
        splice.call(data2, index2, 1);
      }
      --this.size;
      return true;
    }
    module2.exports = listCacheDelete;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js"(exports2, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key2) {
      var data2 = this.__data__, index2 = assocIndexOf(data2, key2);
      return index2 < 0 ? void 0 : data2[index2][1];
    }
    module2.exports = listCacheGet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js"(exports2, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key2) {
      return assocIndexOf(this.__data__, key2) > -1;
    }
    module2.exports = listCacheHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js"(exports2, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key2, value2) {
      var data2 = this.__data__, index2 = assocIndexOf(data2, key2);
      if (index2 < 0) {
        ++this.size;
        data2.push([key2, value2]);
      } else {
        data2[index2][1] = value2;
      }
      return this;
    }
    module2.exports = listCacheSet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"(exports2, module2) {
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module2.exports = ListCache;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js"(exports2, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module2.exports = Map2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js"(exports2, module2) {
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module2.exports = mapCacheClear;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js"(exports2, module2) {
    function isKeyable(value2) {
      var type = typeof value2;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
    }
    module2.exports = isKeyable;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js"(exports2, module2) {
    var isKeyable = require_isKeyable();
    function getMapData(map3, key2) {
      var data2 = map3.__data__;
      return isKeyable(key2) ? data2[typeof key2 == "string" ? "string" : "hash"] : data2.map;
    }
    module2.exports = getMapData;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js"(exports2, module2) {
    var getMapData = require_getMapData();
    function mapCacheDelete(key2) {
      var result = getMapData(this, key2)["delete"](key2);
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = mapCacheDelete;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js"(exports2, module2) {
    var getMapData = require_getMapData();
    function mapCacheGet(key2) {
      return getMapData(this, key2).get(key2);
    }
    module2.exports = mapCacheGet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js"(exports2, module2) {
    var getMapData = require_getMapData();
    function mapCacheHas(key2) {
      return getMapData(this, key2).has(key2);
    }
    module2.exports = mapCacheHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js"(exports2, module2) {
    var getMapData = require_getMapData();
    function mapCacheSet(key2, value2) {
      var data2 = getMapData(this, key2), size = data2.size;
      data2.set(key2, value2);
      this.size += data2.size == size ? 0 : 1;
      return this;
    }
    module2.exports = mapCacheSet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js"(exports2, module2) {
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module2.exports = MapCache;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js"(exports2, module2) {
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize4(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key2)) {
          return cache.get(key2);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key2, result) || cache;
        return result;
      };
      memoized.cache = new (memoize4.Cache || MapCache)();
      return memoized;
    }
    memoize4.Cache = MapCache;
    module2.exports = memoize4;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js
var require_memoizeCapped = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js"(exports2, module2) {
    var memoize4 = require_memoize();
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize4(func, function(key2) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key2;
      });
      var cache = result.cache;
      return result;
    }
    module2.exports = memoizeCapped;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js
var require_stringToPath = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js"(exports2, module2) {
    var memoizeCapped = require_memoizeCapped();
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46) {
        result.push("");
      }
      string.replace(rePropName, function(match, number4, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match);
      });
      return result;
    });
    module2.exports = stringToPath;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js"(exports2, module2) {
    function arrayMap(array, iteratee) {
      var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
      while (++index2 < length2) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    module2.exports = arrayMap;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray2 = require_isArray();
    var isSymbol = require_isSymbol();
    var symbolProto = Symbol3 ? Symbol3.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value2) {
      if (typeof value2 == "string") {
        return value2;
      }
      if (isArray2(value2)) {
        return arrayMap(value2, baseToString) + "";
      }
      if (isSymbol(value2)) {
        return symbolToString ? symbolToString.call(value2) : "";
      }
      var result = value2 + "";
      return result == "0" && 1 / value2 == -Infinity ? "-0" : result;
    }
    module2.exports = baseToString;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js
var require_toString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js"(exports2, module2) {
    var baseToString = require_baseToString();
    function toString2(value2) {
      return value2 == null ? "" : baseToString(value2);
    }
    module2.exports = toString2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js
var require_castPath = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js"(exports2, module2) {
    var isArray2 = require_isArray();
    var isKey = require_isKey();
    var stringToPath = require_stringToPath();
    var toString2 = require_toString();
    function castPath(value2, object) {
      if (isArray2(value2)) {
        return value2;
      }
      return isKey(value2, object) ? [value2] : stringToPath(toString2(value2));
    }
    module2.exports = castPath;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js
var require_toKey = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js"(exports2, module2) {
    var isSymbol = require_isSymbol();
    function toKey(value2) {
      if (typeof value2 == "string" || isSymbol(value2)) {
        return value2;
      }
      var result = value2 + "";
      return result == "0" && 1 / value2 == -Infinity ? "-0" : result;
    }
    module2.exports = toKey;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js
var require_baseGet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js"(exports2, module2) {
    var castPath = require_castPath();
    var toKey = require_toKey();
    function baseGet(object, path2) {
      path2 = castPath(path2, object);
      var index2 = 0, length2 = path2.length;
      while (object != null && index2 < length2) {
        object = object[toKey(path2[index2++])];
      }
      return index2 && index2 == length2 ? object : void 0;
    }
    module2.exports = baseGet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js
var require_get = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js"(exports2, module2) {
    var baseGet = require_baseGet();
    function get8(object, path2, defaultValue) {
      var result = object == null ? void 0 : baseGet(object, path2);
      return result === void 0 ? defaultValue : result;
    }
    module2.exports = get8;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNil.js
var require_isNil = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNil.js"(exports2, module2) {
    function isNil13(value2) {
      return value2 == null;
    }
    module2.exports = isNil13;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js
var require_isString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isArray2 = require_isArray();
    var isObjectLike = require_isObjectLike();
    var stringTag = "[object String]";
    function isString4(value2) {
      return typeof value2 == "string" || !isArray2(value2) && isObjectLike(value2) && baseGetTag(value2) == stringTag;
    }
    module2.exports = isString4;
  }
});

// node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/cjs/react-is.production.min.js"(exports2) {
    var b = Symbol.for("react.element");
    var c2 = Symbol.for("react.portal");
    var d = Symbol.for("react.fragment");
    var e = Symbol.for("react.strict_mode");
    var f = Symbol.for("react.profiler");
    var g = Symbol.for("react.provider");
    var h = Symbol.for("react.context");
    var k2 = Symbol.for("react.server_context");
    var l = Symbol.for("react.forward_ref");
    var m = Symbol.for("react.suspense");
    var n = Symbol.for("react.suspense_list");
    var p = Symbol.for("react.memo");
    var q = Symbol.for("react.lazy");
    var t = Symbol.for("react.offscreen");
    var u;
    u = Symbol.for("react.module.reference");
    function v(a2) {
      if ("object" === typeof a2 && null !== a2) {
        var r2 = a2.$$typeof;
        switch (r2) {
          case b:
            switch (a2 = a2.type, a2) {
              case d:
              case f:
              case e:
              case m:
              case n:
                return a2;
              default:
                switch (a2 = a2 && a2.$$typeof, a2) {
                  case k2:
                  case h:
                  case l:
                  case q:
                  case p:
                  case g:
                    return a2;
                  default:
                    return r2;
                }
            }
          case c2:
            return r2;
        }
      }
    }
    exports2.ContextConsumer = h;
    exports2.ContextProvider = g;
    exports2.Element = b;
    exports2.ForwardRef = l;
    exports2.Fragment = d;
    exports2.Lazy = q;
    exports2.Memo = p;
    exports2.Portal = c2;
    exports2.Profiler = f;
    exports2.StrictMode = e;
    exports2.Suspense = m;
    exports2.SuspenseList = n;
    exports2.isAsyncMode = function() {
      return false;
    };
    exports2.isConcurrentMode = function() {
      return false;
    };
    exports2.isContextConsumer = function(a2) {
      return v(a2) === h;
    };
    exports2.isContextProvider = function(a2) {
      return v(a2) === g;
    };
    exports2.isElement = function(a2) {
      return "object" === typeof a2 && null !== a2 && a2.$$typeof === b;
    };
    exports2.isForwardRef = function(a2) {
      return v(a2) === l;
    };
    exports2.isFragment = function(a2) {
      return v(a2) === d;
    };
    exports2.isLazy = function(a2) {
      return v(a2) === q;
    };
    exports2.isMemo = function(a2) {
      return v(a2) === p;
    };
    exports2.isPortal = function(a2) {
      return v(a2) === c2;
    };
    exports2.isProfiler = function(a2) {
      return v(a2) === f;
    };
    exports2.isStrictMode = function(a2) {
      return v(a2) === e;
    };
    exports2.isSuspense = function(a2) {
      return v(a2) === m;
    };
    exports2.isSuspenseList = function(a2) {
      return v(a2) === n;
    };
    exports2.isValidElementType = function(a2) {
      return "string" === typeof a2 || "function" === typeof a2 || a2 === d || a2 === f || a2 === e || a2 === m || a2 === n || a2 === t || "object" === typeof a2 && null !== a2 && (a2.$$typeof === q || a2.$$typeof === p || a2.$$typeof === g || a2.$$typeof === h || a2.$$typeof === l || a2.$$typeof === u || void 0 !== a2.getModuleId) ? true : false;
    };
    exports2.typeOf = v;
  }
});

// node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/cjs/react-is.development.js"(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var REACT_ELEMENT_TYPE = Symbol.for("react.element");
        var REACT_PORTAL_TYPE = Symbol.for("react.portal");
        var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
        var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
        var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
        var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
        var REACT_CONTEXT_TYPE = Symbol.for("react.context");
        var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
        var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
        var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
        var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
        var REACT_MEMO_TYPE = Symbol.for("react.memo");
        var REACT_LAZY_TYPE = Symbol.for("react.lazy");
        var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
        var enableScopeAPI = false;
        var enableCacheElement = false;
        var enableTransitionTracing = false;
        var enableLegacyHidden = false;
        var enableDebugTracing = false;
        var REACT_MODULE_REFERENCE;
        {
          REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
        }
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_SERVER_CONTEXT_TYPE:
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment4 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment2(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        function isSuspenseList(object) {
          return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
        }
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element;
        exports2.ForwardRef = ForwardRef;
        exports2.Fragment = Fragment4;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.SuspenseList = SuspenseList;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment2;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isSuspenseList = isSuspenseList;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/.pnpm/react-is@18.3.1/node_modules/react-is/index.js"(exports2, module2) {
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_is_production_min();
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNumber.js
var require_isNumber = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNumber.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var numberTag = "[object Number]";
    function isNumber3(value2) {
      return typeof value2 == "number" || isObjectLike(value2) && baseGetTag(value2) == numberTag;
    }
    module2.exports = isNumber3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNaN.js
var require_isNaN = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNaN.js"(exports2, module2) {
    var isNumber3 = require_isNumber();
    function isNaN2(value2) {
      return isNumber3(value2) && value2 != +value2;
    }
    module2.exports = isNaN2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js
var require_baseSlice = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js"(exports2, module2) {
    function baseSlice(array, start, end) {
      var index2 = -1, length2 = array.length;
      if (start < 0) {
        start = -start > length2 ? 0 : length2 + start;
      }
      end = end > length2 ? length2 : end;
      if (end < 0) {
        end += length2;
      }
      length2 = start > end ? 0 : end - start >>> 0;
      start >>>= 0;
      var result = Array(length2);
      while (++index2 < length2) {
        result[index2] = array[index2 + start];
      }
      return result;
    }
    module2.exports = baseSlice;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js
var require_castSlice = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js"(exports2, module2) {
    var baseSlice = require_baseSlice();
    function castSlice(array, start, end) {
      var length2 = array.length;
      end = end === void 0 ? length2 : end;
      return !start && end >= length2 ? array : baseSlice(array, start, end);
    }
    module2.exports = castSlice;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js
var require_hasUnicode = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js"(exports2, module2) {
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsZWJ = "\\u200d";
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    module2.exports = hasUnicode;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js
var require_asciiToArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js"(exports2, module2) {
    function asciiToArray(string) {
      return string.split("");
    }
    module2.exports = asciiToArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js
var require_unicodeToArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js"(exports2, module2) {
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    module2.exports = unicodeToArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js
var require_stringToArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js"(exports2, module2) {
    var asciiToArray = require_asciiToArray();
    var hasUnicode = require_hasUnicode();
    var unicodeToArray = require_unicodeToArray();
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    module2.exports = stringToArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createCaseFirst.js
var require_createCaseFirst = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createCaseFirst.js"(exports2, module2) {
    var castSlice = require_castSlice();
    var hasUnicode = require_hasUnicode();
    var stringToArray = require_stringToArray();
    var toString2 = require_toString();
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString2(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
      };
    }
    module2.exports = createCaseFirst;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/upperFirst.js
var require_upperFirst = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/upperFirst.js"(exports2, module2) {
    var createCaseFirst = require_createCaseFirst();
    var upperFirst4 = createCaseFirst("toUpperCase");
    module2.exports = upperFirst4;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js"(exports2, module2) {
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module2.exports = stackClear;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js"(exports2, module2) {
    function stackDelete(key2) {
      var data2 = this.__data__, result = data2["delete"](key2);
      this.size = data2.size;
      return result;
    }
    module2.exports = stackDelete;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js"(exports2, module2) {
    function stackGet(key2) {
      return this.__data__.get(key2);
    }
    module2.exports = stackGet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js"(exports2, module2) {
    function stackHas(key2) {
      return this.__data__.has(key2);
    }
    module2.exports = stackHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js"(exports2, module2) {
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key2, value2) {
      var data2 = this.__data__;
      if (data2 instanceof ListCache) {
        var pairs = data2.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key2, value2]);
          this.size = ++data2.size;
          return this;
        }
        data2 = this.__data__ = new MapCache(pairs);
      }
      data2.set(key2, value2);
      this.size = data2.size;
      return this;
    }
    module2.exports = stackSet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js"(exports2, module2) {
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data2 = this.__data__ = new ListCache(entries);
      this.size = data2.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module2.exports = Stack;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js
var require_setCacheAdd = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js"(exports2, module2) {
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(value2) {
      this.__data__.set(value2, HASH_UNDEFINED);
      return this;
    }
    module2.exports = setCacheAdd;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js
var require_setCacheHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js"(exports2, module2) {
    function setCacheHas(value2) {
      return this.__data__.has(value2);
    }
    module2.exports = setCacheHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js
var require_SetCache = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js"(exports2, module2) {
    var MapCache = require_MapCache();
    var setCacheAdd = require_setCacheAdd();
    var setCacheHas = require_setCacheHas();
    function SetCache(values) {
      var index2 = -1, length2 = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index2 < length2) {
        this.add(values[index2]);
      }
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module2.exports = SetCache;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js
var require_arraySome = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js"(exports2, module2) {
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    module2.exports = arraySome;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js
var require_cacheHas = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js"(exports2, module2) {
    function cacheHas(cache, key2) {
      return cache.has(key2);
    }
    module2.exports = cacheHas;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js
var require_equalArrays = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js"(exports2, module2) {
    var SetCache = require_SetCache();
    var arraySome = require_arraySome();
    var cacheHas = require_cacheHas();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index2 < arrLength) {
        var arrValue = array[index2], othValue = other[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    module2.exports = equalArrays;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js"(exports2, module2) {
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module2.exports = Uint8Array2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js
var require_mapToArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js"(exports2, module2) {
    function mapToArray(map3) {
      var index2 = -1, result = Array(map3.size);
      map3.forEach(function(value2, key2) {
        result[++index2] = [key2, value2];
      });
      return result;
    }
    module2.exports = mapToArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js
var require_setToArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js"(exports2, module2) {
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value2) {
        result[++index2] = value2;
      });
      return result;
    }
    module2.exports = setToArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js
var require_equalByTag = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var Uint8Array2 = require_Uint8Array();
    var eq = require_eq();
    var equalArrays = require_equalArrays();
    var mapToArray = require_mapToArray();
    var setToArray = require_setToArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var symbolProto = Symbol3 ? Symbol3.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    module2.exports = equalByTag;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js"(exports2, module2) {
    function arrayPush(array, values) {
      var index2 = -1, length2 = values.length, offset = array.length;
      while (++index2 < length2) {
        array[offset + index2] = values[index2];
      }
      return array;
    }
    module2.exports = arrayPush;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js
var require_baseGetAllKeys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js"(exports2, module2) {
    var arrayPush = require_arrayPush();
    var isArray2 = require_isArray();
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    module2.exports = baseGetAllKeys;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js
var require_arrayFilter = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js"(exports2, module2) {
    function arrayFilter(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value2 = array[index2];
        if (predicate(value2, index2, array)) {
          result[resIndex++] = value2;
        }
      }
      return result;
    }
    module2.exports = arrayFilter;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js
var require_stubArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js"(exports2, module2) {
    function stubArray() {
      return [];
    }
    module2.exports = stubArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js
var require_getSymbols = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js"(exports2, module2) {
    var arrayFilter = require_arrayFilter();
    var stubArray = require_stubArray();
    var objectProto = Object.prototype;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    module2.exports = getSymbols;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js"(exports2, module2) {
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    module2.exports = baseTimes;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value2) {
      return isObjectLike(value2) && baseGetTag(value2) == argsTag;
    }
    module2.exports = baseIsArguments;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js"(exports2, module2) {
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value2) {
      return isObjectLike(value2) && hasOwnProperty2.call(value2, "callee") && !propertyIsEnumerable.call(value2, "callee");
    };
    module2.exports = isArguments;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js"(exports2, module2) {
    function stubFalse() {
      return false;
    }
    module2.exports = stubFalse;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js"(exports2, module2) {
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module2.exports = isBuffer;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js"(exports2, module2) {
    var MAX_SAFE_INTEGER2 = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value2, length2) {
      var type = typeof value2;
      length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
      return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
    }
    module2.exports = isIndex;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js"(exports2, module2) {
    var MAX_SAFE_INTEGER2 = 9007199254740991;
    function isLength(value2) {
      return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
    }
    module2.exports = isLength;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value2) {
      return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
    }
    module2.exports = baseIsTypedArray;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js"(exports2, module2) {
    function baseUnary(func) {
      return function(value2) {
        return func(value2);
      };
    }
    module2.exports = baseUnary;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js"(exports2, module2) {
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module2.exports = nodeUtil;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js"(exports2, module2) {
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module2.exports = isTypedArray2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js"(exports2, module2) {
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray2 = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray2 = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function arrayLikeKeys(value2, inherited) {
      var isArr = isArray2(value2), isArg = !isArr && isArguments(value2), isBuff = !isArr && !isArg && isBuffer(value2), isType = !isArr && !isArg && !isBuff && isTypedArray2(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value2.length, String) : [], length2 = result.length;
      for (var key2 in value2) {
        if ((inherited || hasOwnProperty2.call(value2, key2)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key2 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key2 == "offset" || key2 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || // Skip index properties.
        isIndex(key2, length2)))) {
          result.push(key2);
        }
      }
      return result;
    }
    module2.exports = arrayLikeKeys;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js"(exports2, module2) {
    var objectProto = Object.prototype;
    function isPrototype(value2) {
      var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value2 === proto;
    }
    module2.exports = isPrototype;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js"(exports2, module2) {
    function overArg(func, transform2) {
      return function(arg) {
        return func(transform2(arg));
      };
    }
    module2.exports = overArg;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js
var require_nativeKeys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js"(exports2, module2) {
    var overArg = require_overArg();
    var nativeKeys = overArg(Object.keys, Object);
    module2.exports = nativeKeys;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js
var require_baseKeys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js"(exports2, module2) {
    var isPrototype = require_isPrototype();
    var nativeKeys = require_nativeKeys();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key2 in Object(object)) {
        if (hasOwnProperty2.call(object, key2) && key2 != "constructor") {
          result.push(key2);
        }
      }
      return result;
    }
    module2.exports = baseKeys;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js"(exports2, module2) {
    var isFunction23 = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value2) {
      return value2 != null && isLength(value2.length) && !isFunction23(value2);
    }
    module2.exports = isArrayLike;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js
var require_keys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js"(exports2, module2) {
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeys = require_baseKeys();
    var isArrayLike = require_isArrayLike();
    function keys2(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    module2.exports = keys2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js
var require_getAllKeys = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js"(exports2, module2) {
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbols = require_getSymbols();
    var keys2 = require_keys();
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys2, getSymbols);
    }
    module2.exports = getAllKeys;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js
var require_equalObjects = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js"(exports2, module2) {
    var getAllKeys = require_getAllKeys();
    var COMPARE_PARTIAL_FLAG = 1;
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key2 = objProps[index2];
        if (!(isPartial ? key2 in other : hasOwnProperty2.call(other, key2))) {
          return false;
        }
      }
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key2 = objProps[index2];
        var objValue = object[key2], othValue = other[key2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key2, other, object, stack) : customizer(objValue, othValue, key2, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key2 == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    module2.exports = equalObjects;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js
var require_DataView = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js"(exports2, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var DataView2 = getNative(root, "DataView");
    module2.exports = DataView2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js
var require_Promise = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js"(exports2, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Promise2 = getNative(root, "Promise");
    module2.exports = Promise2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js
var require_Set = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js"(exports2, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Set2 = getNative(root, "Set");
    module2.exports = Set2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js"(exports2, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap2 = getNative(root, "WeakMap");
    module2.exports = WeakMap2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js
var require_getTag = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js"(exports2, module2) {
    var DataView2 = require_DataView();
    var Map2 = require_Map();
    var Promise2 = require_Promise();
    var Set2 = require_Set();
    var WeakMap2 = require_WeakMap();
    var baseGetTag = require_baseGetTag();
    var toSource = require_toSource();
    var mapTag = "[object Map]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var setTag = "[object Set]";
    var weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var dataViewCtorString = toSource(DataView2);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap2);
    var getTag2 = baseGetTag;
    if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag2(new Map2()) != mapTag || Promise2 && getTag2(Promise2.resolve()) != promiseTag || Set2 && getTag2(new Set2()) != setTag || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag) {
      getTag2 = function(value2) {
        var result = baseGetTag(value2), Ctor = result == objectTag ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module2.exports = getTag2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js
var require_baseIsEqualDeep = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js"(exports2, module2) {
    var Stack = require_Stack();
    var equalArrays = require_equalArrays();
    var equalByTag = require_equalByTag();
    var equalObjects = require_equalObjects();
    var getTag2 = require_getTag();
    var isArray2 = require_isArray();
    var isBuffer = require_isBuffer();
    var isTypedArray2 = require_isTypedArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var objectTag = "[object Object]";
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag2(object), othTag = othIsArr ? arrayTag : getTag2(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    module2.exports = baseIsEqualDeep;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js
var require_baseIsEqual = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js"(exports2, module2) {
    var baseIsEqualDeep = require_baseIsEqualDeep();
    var isObjectLike = require_isObjectLike();
    function baseIsEqual(value2, other, bitmask, customizer, stack) {
      if (value2 === other) {
        return true;
      }
      if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
        return value2 !== value2 && other !== other;
      }
      return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
    }
    module2.exports = baseIsEqual;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js
var require_baseIsMatch = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js"(exports2, module2) {
    var Stack = require_Stack();
    var baseIsEqual = require_baseIsEqual();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseIsMatch(object, source, matchData, customizer) {
      var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
      if (object == null) {
        return !length2;
      }
      object = Object(object);
      while (index2--) {
        var data2 = matchData[index2];
        if (noCustomizer && data2[2] ? data2[1] !== object[data2[0]] : !(data2[0] in object)) {
          return false;
        }
      }
      while (++index2 < length2) {
        data2 = matchData[index2];
        var key2 = data2[0], objValue = object[key2], srcValue = data2[1];
        if (noCustomizer && data2[2]) {
          if (objValue === void 0 && !(key2 in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key2, object, source, stack);
          }
          if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    module2.exports = baseIsMatch;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js
var require_isStrictComparable = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js"(exports2, module2) {
    var isObject5 = require_isObject();
    function isStrictComparable(value2) {
      return value2 === value2 && !isObject5(value2);
    }
    module2.exports = isStrictComparable;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js
var require_getMatchData = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js"(exports2, module2) {
    var isStrictComparable = require_isStrictComparable();
    var keys2 = require_keys();
    function getMatchData(object) {
      var result = keys2(object), length2 = result.length;
      while (length2--) {
        var key2 = result[length2], value2 = object[key2];
        result[length2] = [key2, value2, isStrictComparable(value2)];
      }
      return result;
    }
    module2.exports = getMatchData;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js
var require_matchesStrictComparable = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js"(exports2, module2) {
    function matchesStrictComparable(key2, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key2] === srcValue && (srcValue !== void 0 || key2 in Object(object));
      };
    }
    module2.exports = matchesStrictComparable;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js
var require_baseMatches = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js"(exports2, module2) {
    var baseIsMatch = require_baseIsMatch();
    var getMatchData = require_getMatchData();
    var matchesStrictComparable = require_matchesStrictComparable();
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }
    module2.exports = baseMatches;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js
var require_baseHasIn = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js"(exports2, module2) {
    function baseHasIn(object, key2) {
      return object != null && key2 in Object(object);
    }
    module2.exports = baseHasIn;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js
var require_hasPath = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js"(exports2, module2) {
    var castPath = require_castPath();
    var isArguments = require_isArguments();
    var isArray2 = require_isArray();
    var isIndex = require_isIndex();
    var isLength = require_isLength();
    var toKey = require_toKey();
    function hasPath(object, path2, hasFunc) {
      path2 = castPath(path2, object);
      var index2 = -1, length2 = path2.length, result = false;
      while (++index2 < length2) {
        var key2 = toKey(path2[index2]);
        if (!(result = object != null && hasFunc(object, key2))) {
          break;
        }
        object = object[key2];
      }
      if (result || ++index2 != length2) {
        return result;
      }
      length2 = object == null ? 0 : object.length;
      return !!length2 && isLength(length2) && isIndex(key2, length2) && (isArray2(object) || isArguments(object));
    }
    module2.exports = hasPath;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js
var require_hasIn = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js"(exports2, module2) {
    var baseHasIn = require_baseHasIn();
    var hasPath = require_hasPath();
    function hasIn(object, path2) {
      return object != null && hasPath(object, path2, baseHasIn);
    }
    module2.exports = hasIn;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js
var require_baseMatchesProperty = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js"(exports2, module2) {
    var baseIsEqual = require_baseIsEqual();
    var get8 = require_get();
    var hasIn = require_hasIn();
    var isKey = require_isKey();
    var isStrictComparable = require_isStrictComparable();
    var matchesStrictComparable = require_matchesStrictComparable();
    var toKey = require_toKey();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseMatchesProperty(path2, srcValue) {
      if (isKey(path2) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path2), srcValue);
      }
      return function(object) {
        var objValue = get8(object, path2);
        return objValue === void 0 && objValue === srcValue ? hasIn(object, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }
    module2.exports = baseMatchesProperty;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js
var require_identity = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js"(exports2, module2) {
    function identity7(value2) {
      return value2;
    }
    module2.exports = identity7;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js
var require_baseProperty = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js"(exports2, module2) {
    function baseProperty(key2) {
      return function(object) {
        return object == null ? void 0 : object[key2];
      };
    }
    module2.exports = baseProperty;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js
var require_basePropertyDeep = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js"(exports2, module2) {
    var baseGet = require_baseGet();
    function basePropertyDeep(path2) {
      return function(object) {
        return baseGet(object, path2);
      };
    }
    module2.exports = basePropertyDeep;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js
var require_property = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js"(exports2, module2) {
    var baseProperty = require_baseProperty();
    var basePropertyDeep = require_basePropertyDeep();
    var isKey = require_isKey();
    var toKey = require_toKey();
    function property2(path2) {
      return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
    }
    module2.exports = property2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js
var require_baseIteratee = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js"(exports2, module2) {
    var baseMatches = require_baseMatches();
    var baseMatchesProperty = require_baseMatchesProperty();
    var identity7 = require_identity();
    var isArray2 = require_isArray();
    var property2 = require_property();
    function baseIteratee(value2) {
      if (typeof value2 == "function") {
        return value2;
      }
      if (value2 == null) {
        return identity7;
      }
      if (typeof value2 == "object") {
        return isArray2(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
      }
      return property2(value2);
    }
    module2.exports = baseIteratee;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js
var require_baseFindIndex = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js"(exports2, module2) {
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    module2.exports = baseFindIndex;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js
var require_baseIsNaN = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js"(exports2, module2) {
    function baseIsNaN(value2) {
      return value2 !== value2;
    }
    module2.exports = baseIsNaN;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js
var require_strictIndexOf = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js"(exports2, module2) {
    function strictIndexOf(array, value2, fromIndex) {
      var index2 = fromIndex - 1, length2 = array.length;
      while (++index2 < length2) {
        if (array[index2] === value2) {
          return index2;
        }
      }
      return -1;
    }
    module2.exports = strictIndexOf;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js
var require_baseIndexOf = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js"(exports2, module2) {
    var baseFindIndex = require_baseFindIndex();
    var baseIsNaN = require_baseIsNaN();
    var strictIndexOf = require_strictIndexOf();
    function baseIndexOf(array, value2, fromIndex) {
      return value2 === value2 ? strictIndexOf(array, value2, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    module2.exports = baseIndexOf;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludes.js
var require_arrayIncludes = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludes.js"(exports2, module2) {
    var baseIndexOf = require_baseIndexOf();
    function arrayIncludes(array, value2) {
      var length2 = array == null ? 0 : array.length;
      return !!length2 && baseIndexOf(array, value2, 0) > -1;
    }
    module2.exports = arrayIncludes;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludesWith.js
var require_arrayIncludesWith = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludesWith.js"(exports2, module2) {
    function arrayIncludesWith(array, value2, comparator) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (comparator(value2, array[index2])) {
          return true;
        }
      }
      return false;
    }
    module2.exports = arrayIncludesWith;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/noop.js
var require_noop = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/noop.js"(exports2, module2) {
    function noop() {
    }
    module2.exports = noop;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createSet.js
var require_createSet = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createSet.js"(exports2, module2) {
    var Set2 = require_Set();
    var noop = require_noop();
    var setToArray = require_setToArray();
    var INFINITY = 1 / 0;
    var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values) {
      return new Set2(values);
    };
    module2.exports = createSet;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUniq.js
var require_baseUniq = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUniq.js"(exports2, module2) {
    var SetCache = require_SetCache();
    var arrayIncludes = require_arrayIncludes();
    var arrayIncludesWith = require_arrayIncludesWith();
    var cacheHas = require_cacheHas();
    var createSet = require_createSet();
    var setToArray = require_setToArray();
    var LARGE_ARRAY_SIZE = 200;
    function baseUniq(array, iteratee, comparator) {
      var index2 = -1, includes = arrayIncludes, length2 = array.length, isCommon = true, result = [], seen = result;
      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      } else if (length2 >= LARGE_ARRAY_SIZE) {
        var set2 = iteratee ? null : createSet(array);
        if (set2) {
          return setToArray(set2);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache();
      } else {
        seen = iteratee ? [] : result;
      }
      outer:
        while (++index2 < length2) {
          var value2 = array[index2], computed = iteratee ? iteratee(value2) : value2;
          value2 = comparator || value2 !== 0 ? value2 : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value2);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value2);
          }
        }
      return result;
    }
    module2.exports = baseUniq;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniqBy.js
var require_uniqBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniqBy.js"(exports2, module2) {
    var baseIteratee = require_baseIteratee();
    var baseUniq = require_baseUniq();
    function uniqBy2(array, iteratee) {
      return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
    }
    module2.exports = uniqBy2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isFlattenable.js
var require_isFlattenable = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isFlattenable.js"(exports2, module2) {
    var Symbol3 = require_Symbol();
    var isArguments = require_isArguments();
    var isArray2 = require_isArray();
    var spreadableSymbol = Symbol3 ? Symbol3.isConcatSpreadable : void 0;
    function isFlattenable(value2) {
      return isArray2(value2) || isArguments(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
    }
    module2.exports = isFlattenable;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFlatten.js
var require_baseFlatten = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFlatten.js"(exports2, module2) {
    var arrayPush = require_arrayPush();
    var isFlattenable = require_isFlattenable();
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index2 = -1, length2 = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index2 < length2) {
        var value2 = array[index2];
        if (depth > 0 && predicate(value2)) {
          if (depth > 1) {
            baseFlatten(value2, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value2);
          }
        } else if (!isStrict) {
          result[result.length] = value2;
        }
      }
      return result;
    }
    module2.exports = baseFlatten;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js"(exports2, module2) {
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index2 = -1, iterable = Object(object), props = keysFunc(object), length2 = props.length;
        while (length2--) {
          var key2 = props[fromRight ? length2 : ++index2];
          if (iteratee(iterable[key2], key2, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module2.exports = createBaseFor;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js"(exports2, module2) {
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module2.exports = baseFor;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js
var require_baseForOwn = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js"(exports2, module2) {
    var baseFor = require_baseFor();
    var keys2 = require_keys();
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys2);
    }
    module2.exports = baseForOwn;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js
var require_createBaseEach = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js"(exports2, module2) {
    var isArrayLike = require_isArrayLike();
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
        while (fromRight ? index2-- : ++index2 < length2) {
          if (iteratee(iterable[index2], index2, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }
    module2.exports = createBaseEach;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js
var require_baseEach = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js"(exports2, module2) {
    var baseForOwn = require_baseForOwn();
    var createBaseEach = require_createBaseEach();
    var baseEach = createBaseEach(baseForOwn);
    module2.exports = baseEach;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js
var require_baseMap = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js"(exports2, module2) {
    var baseEach = require_baseEach();
    var isArrayLike = require_isArrayLike();
    function baseMap(collection, iteratee) {
      var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
      baseEach(collection, function(value2, key2, collection2) {
        result[++index2] = iteratee(value2, key2, collection2);
      });
      return result;
    }
    module2.exports = baseMap;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSortBy.js
var require_baseSortBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSortBy.js"(exports2, module2) {
    function baseSortBy(array, comparer) {
      var length2 = array.length;
      array.sort(comparer);
      while (length2--) {
        array[length2] = array[length2].value;
      }
      return array;
    }
    module2.exports = baseSortBy;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareAscending.js
var require_compareAscending = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareAscending.js"(exports2, module2) {
    var isSymbol = require_isSymbol();
    function compareAscending(value2, other) {
      if (value2 !== other) {
        var valIsDefined = value2 !== void 0, valIsNull = value2 === null, valIsReflexive = value2 === value2, valIsSymbol = isSymbol(value2);
        var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value2 > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
          return 1;
        }
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value2 < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }
    module2.exports = compareAscending;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareMultiple.js
var require_compareMultiple = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareMultiple.js"(exports2, module2) {
    var compareAscending = require_compareAscending();
    function compareMultiple(object, other, orders) {
      var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
      while (++index2 < length2) {
        var result = compareAscending(objCriteria[index2], othCriteria[index2]);
        if (result) {
          if (index2 >= ordersLength) {
            return result;
          }
          var order = orders[index2];
          return result * (order == "desc" ? -1 : 1);
        }
      }
      return object.index - other.index;
    }
    module2.exports = compareMultiple;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseOrderBy.js
var require_baseOrderBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseOrderBy.js"(exports2, module2) {
    var arrayMap = require_arrayMap();
    var baseGet = require_baseGet();
    var baseIteratee = require_baseIteratee();
    var baseMap = require_baseMap();
    var baseSortBy = require_baseSortBy();
    var baseUnary = require_baseUnary();
    var compareMultiple = require_compareMultiple();
    var identity7 = require_identity();
    var isArray2 = require_isArray();
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray2(iteratee)) {
            return function(value2) {
              return baseGet(value2, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity7];
      }
      var index2 = -1;
      iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
      var result = baseMap(collection, function(value2, key2, collection2) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value2);
        });
        return { "criteria": criteria, "index": ++index2, "value": value2 };
      });
      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }
    module2.exports = baseOrderBy;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_apply.js"(exports2, module2) {
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module2.exports = apply;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overRest.js"(exports2, module2) {
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform2) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index2 = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
        while (++index2 < length2) {
          array[index2] = args[start + index2];
        }
        index2 = -1;
        var otherArgs = Array(start + 1);
        while (++index2 < start) {
          otherArgs[index2] = args[index2];
        }
        otherArgs[start] = transform2(array);
        return apply(func, this, otherArgs);
      };
    }
    module2.exports = overRest;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/constant.js
var require_constant = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/constant.js"(exports2, module2) {
    function constant(value2) {
      return function() {
        return value2;
      };
    }
    module2.exports = constant;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_defineProperty.js"(exports2, module2) {
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module2.exports = defineProperty;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSetToString.js"(exports2, module2) {
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity7 = require_identity();
    var baseSetToString = !defineProperty ? identity7 : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module2.exports = baseSetToString;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_shortOut.js"(exports2, module2) {
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module2.exports = shortOut;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToString.js"(exports2, module2) {
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module2.exports = setToString;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRest.js"(exports2, module2) {
    var identity7 = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity7), func + "");
    }
    module2.exports = baseRest;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIterateeCall.js
var require_isIterateeCall = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIterateeCall.js"(exports2, module2) {
    var eq = require_eq();
    var isArrayLike = require_isArrayLike();
    var isIndex = require_isIndex();
    var isObject5 = require_isObject();
    function isIterateeCall(value2, index2, object) {
      if (!isObject5(object)) {
        return false;
      }
      var type = typeof index2;
      if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
        return eq(object[index2], value2);
      }
      return false;
    }
    module2.exports = isIterateeCall;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/sortBy.js
var require_sortBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/sortBy.js"(exports2, module2) {
    var baseFlatten = require_baseFlatten();
    var baseOrderBy = require_baseOrderBy();
    var baseRest = require_baseRest();
    var isIterateeCall = require_isIterateeCall();
    var sortBy4 = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length2 = iteratees.length;
      if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });
    module2.exports = sortBy4;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/now.js
var require_now = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/now.js"(exports2, module2) {
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js"(exports2, module2) {
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    module2.exports = trimmedEndIndex;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js"(exports2, module2) {
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module2.exports = baseTrim;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js"(exports2, module2) {
    var baseTrim = require_baseTrim();
    var isObject5 = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value2) {
      if (typeof value2 == "number") {
        return value2;
      }
      if (isSymbol(value2)) {
        return NAN;
      }
      if (isObject5(value2)) {
        var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
        value2 = isObject5(other) ? other + "" : other;
      }
      if (typeof value2 != "string") {
        return value2 === 0 ? value2 : +value2;
      }
      value2 = baseTrim(value2);
      var isBinary = reIsBinary.test(value2);
      return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
    }
    module2.exports = toNumber;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js"(exports2, module2) {
    var isObject5 = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject5(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time3) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time3;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time3) {
        lastInvokeTime = time3;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time3) : result;
      }
      function remainingWait(time3) {
        var timeSinceLastCall = time3 - lastCallTime, timeSinceLastInvoke = time3 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time3) {
        var timeSinceLastCall = time3 - lastCallTime, timeSinceLastInvoke = time3 - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time3 = now();
        if (shouldInvoke(time3)) {
          return trailingEdge(time3);
        }
        timerId = setTimeout(timerExpired, remainingWait(time3));
      }
      function trailingEdge(time3) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time3);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time3 = now(), isInvoking = shouldInvoke(time3);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time3;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var require_throttle = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js"(exports2, module2) {
    var debounce = require_debounce();
    var isObject5 = require_isObject();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle3(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject5(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module2.exports = throttle3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseExtremum.js
var require_baseExtremum = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseExtremum.js"(exports2, module2) {
    var isSymbol = require_isSymbol();
    function baseExtremum(array, iteratee, comparator) {
      var index2 = -1, length2 = array.length;
      while (++index2 < length2) {
        var value2 = array[index2], current = iteratee(value2);
        if (current != null && (computed === void 0 ? current === current && !isSymbol(current) : comparator(current, computed))) {
          var computed = current, result = value2;
        }
      }
      return result;
    }
    module2.exports = baseExtremum;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGt.js
var require_baseGt = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGt.js"(exports2, module2) {
    function baseGt(value2, other) {
      return value2 > other;
    }
    module2.exports = baseGt;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/max.js
var require_max = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/max.js"(exports2, module2) {
    var baseExtremum = require_baseExtremum();
    var baseGt = require_baseGt();
    var identity7 = require_identity();
    function max4(array) {
      return array && array.length ? baseExtremum(array, identity7, baseGt) : void 0;
    }
    module2.exports = max4;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseLt.js
var require_baseLt = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseLt.js"(exports2, module2) {
    function baseLt(value2, other) {
      return value2 < other;
    }
    module2.exports = baseLt;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/min.js
var require_min = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/min.js"(exports2, module2) {
    var baseExtremum = require_baseExtremum();
    var baseLt = require_baseLt();
    var identity7 = require_identity();
    function min3(array) {
      return array && array.length ? baseExtremum(array, identity7, baseLt) : void 0;
    }
    module2.exports = min3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js
var require_map = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js"(exports2, module2) {
    var arrayMap = require_arrayMap();
    var baseIteratee = require_baseIteratee();
    var baseMap = require_baseMap();
    var isArray2 = require_isArray();
    function map3(collection, iteratee) {
      var func = isArray2(collection) ? arrayMap : baseMap;
      return func(collection, baseIteratee(iteratee, 3));
    }
    module2.exports = map3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatMap.js
var require_flatMap = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatMap.js"(exports2, module2) {
    var baseFlatten = require_baseFlatten();
    var map3 = require_map();
    function flatMap2(collection, iteratee) {
      return baseFlatten(map3(collection, iteratee), 1);
    }
    module2.exports = flatMap2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var require_isEqual = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js"(exports2, module2) {
    var baseIsEqual = require_baseIsEqual();
    function isEqual7(value2, other) {
      return baseIsEqual(value2, other);
    }
    module2.exports = isEqual7;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/last.js
var require_last = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/last.js"(exports2, module2) {
    function last2(array) {
      var length2 = array == null ? 0 : array.length;
      return length2 ? array[length2 - 1] : void 0;
    }
    module2.exports = last2;
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min2 = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js"(exports2) {
    var b = "function" === typeof Symbol && Symbol.for;
    var c2 = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k2 = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r2 = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x2 = b ? Symbol.for("react.responder") : 60118;
    var y2 = b ? Symbol.for("react.scope") : 60119;
    function z(a2) {
      if ("object" === typeof a2 && null !== a2) {
        var u = a2.$$typeof;
        switch (u) {
          case c2:
            switch (a2 = a2.type, a2) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a2;
              default:
                switch (a2 = a2 && a2.$$typeof, a2) {
                  case k2:
                  case n:
                  case t:
                  case r2:
                  case h:
                    return a2;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a2) {
      return z(a2) === m;
    }
    exports2.AsyncMode = l;
    exports2.ConcurrentMode = m;
    exports2.ContextConsumer = k2;
    exports2.ContextProvider = h;
    exports2.Element = c2;
    exports2.ForwardRef = n;
    exports2.Fragment = e;
    exports2.Lazy = t;
    exports2.Memo = r2;
    exports2.Portal = d;
    exports2.Profiler = g;
    exports2.StrictMode = f;
    exports2.Suspense = p;
    exports2.isAsyncMode = function(a2) {
      return A(a2) || z(a2) === l;
    };
    exports2.isConcurrentMode = A;
    exports2.isContextConsumer = function(a2) {
      return z(a2) === k2;
    };
    exports2.isContextProvider = function(a2) {
      return z(a2) === h;
    };
    exports2.isElement = function(a2) {
      return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
    };
    exports2.isForwardRef = function(a2) {
      return z(a2) === n;
    };
    exports2.isFragment = function(a2) {
      return z(a2) === e;
    };
    exports2.isLazy = function(a2) {
      return z(a2) === t;
    };
    exports2.isMemo = function(a2) {
      return z(a2) === r2;
    };
    exports2.isPortal = function(a2) {
      return z(a2) === d;
    };
    exports2.isProfiler = function(a2) {
      return z(a2) === g;
    };
    exports2.isStrictMode = function(a2) {
      return z(a2) === f;
    };
    exports2.isSuspense = function(a2) {
      return z(a2) === p;
    };
    exports2.isValidElementType = function(a2) {
      return "string" === typeof a2 || "function" === typeof a2 || a2 === e || a2 === m || a2 === g || a2 === f || a2 === p || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t || a2.$$typeof === r2 || a2.$$typeof === h || a2.$$typeof === k2 || a2.$$typeof === n || a2.$$typeof === w || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v);
    };
    exports2.typeOf = z;
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development2 = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js"(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment4 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment2(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports2.AsyncMode = AsyncMode;
        exports2.ConcurrentMode = ConcurrentMode;
        exports2.ContextConsumer = ContextConsumer;
        exports2.ContextProvider = ContextProvider;
        exports2.Element = Element;
        exports2.ForwardRef = ForwardRef;
        exports2.Fragment = Fragment4;
        exports2.Lazy = Lazy;
        exports2.Memo = Memo;
        exports2.Portal = Portal;
        exports2.Profiler = Profiler;
        exports2.StrictMode = StrictMode;
        exports2.Suspense = Suspense;
        exports2.isAsyncMode = isAsyncMode;
        exports2.isConcurrentMode = isConcurrentMode;
        exports2.isContextConsumer = isContextConsumer;
        exports2.isContextProvider = isContextProvider;
        exports2.isElement = isElement;
        exports2.isForwardRef = isForwardRef;
        exports2.isFragment = isFragment2;
        exports2.isLazy = isLazy;
        exports2.isMemo = isMemo;
        exports2.isPortal = isPortal;
        exports2.isProfiler = isProfiler;
        exports2.isStrictMode = isStrictMode;
        exports2.isSuspense = isSuspense;
        exports2.isValidElementType = isValidElementType;
        exports2.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var require_react_is2 = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js"(exports2, module2) {
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_is_production_min2();
    } else {
      module2.exports = require_react_is_development2();
    }
  }
});

// node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js"(exports2, module2) {
    var getOwnPropertySymbols2 = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val2) {
      if (val2 === null || val2 === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val2);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s2 = 1; s2 < arguments.length; s2++) {
        from = Object(arguments[s2]);
        for (var key2 in from) {
          if (hasOwnProperty2.call(from, key2)) {
            to[key2] = from[key2];
          }
        }
        if (getOwnPropertySymbols2) {
          symbols = getOwnPropertySymbols2(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports2, module2) {
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module2.exports = ReactPropTypesSecret;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js"(exports2, module2) {
    module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js"(exports2, module2) {
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x2) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module2.exports = checkPropTypes;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js"(exports2, module2) {
    var ReactIs = require_react_is2();
    var assign2 = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x2) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module2.exports = function(isValidElement8, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x2, y2) {
        if (x2 === y2) {
          return x2 !== 0 || 1 / x2 === 1 / y2;
        } else {
          return x2 !== x2 && y2 !== y2;
        }
      }
      function PropTypeError(message, data2) {
        this.message = message;
        this.data = data2 && typeof data2 === "object" ? data2 : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement8(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key2, value2) {
            var type = getPreciseType(value2);
            if (type === "symbol") {
              return String(value2);
            }
            return value2;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key2 in propValue) {
            if (has(propValue, key2)) {
              var error = typeChecker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key2, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key2 in shapeTypes) {
            var checker = shapeTypes[key2];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key2, getPreciseType(checker));
            }
            var error = checker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key2 in allKeys) {
            var checker = shapeTypes[key2];
            if (has(shapeTypes, key2) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key2, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key2 + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key2, componentName, location2, propFullName + "." + key2, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement8(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value2) {
        var type = getPreciseType(value2);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithThrowingShims.js"(exports2, module2) {
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module2.exports = function() {
      function shim(props, propName, componentName, location2, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"(exports2, module2) {
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is2();
      throwOnDirectAccess = true;
      module2.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module2.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/maxBy.js
var require_maxBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/maxBy.js"(exports2, module2) {
    var baseExtremum = require_baseExtremum();
    var baseGt = require_baseGt();
    var baseIteratee = require_baseIteratee();
    function maxBy2(array, iteratee) {
      return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt) : void 0;
    }
    module2.exports = maxBy2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/minBy.js
var require_minBy = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/minBy.js"(exports2, module2) {
    var baseExtremum = require_baseExtremum();
    var baseIteratee = require_baseIteratee();
    var baseLt = require_baseLt();
    function minBy2(array, iteratee) {
      return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt) : void 0;
    }
    module2.exports = minBy2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getPrototype.js
var require_getPrototype = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getPrototype.js"(exports2, module2) {
    var overArg = require_overArg();
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module2.exports = getPrototype;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isPlainObject.js
var require_isPlainObject = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isPlainObject.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var getPrototype = require_getPrototype();
    var isObjectLike = require_isObjectLike();
    var objectTag = "[object Object]";
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject2(value2) {
      if (!isObjectLike(value2) || baseGetTag(value2) != objectTag) {
        return false;
      }
      var proto = getPrototype(value2);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module2.exports = isPlainObject2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBoolean.js
var require_isBoolean = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBoolean.js"(exports2, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var boolTag = "[object Boolean]";
    function isBoolean2(value2) {
      return value2 === true || value2 === false || isObjectLike(value2) && baseGetTag(value2) == boolTag;
    }
    module2.exports = isBoolean2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRange.js
var require_baseRange = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRange.js"(exports2, module2) {
    var nativeCeil = Math.ceil;
    var nativeMax = Math.max;
    function baseRange(start, end, step, fromRight) {
      var index2 = -1, length2 = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length2);
      while (length2--) {
        result[fromRight ? length2 : ++index2] = start;
        start += step;
      }
      return result;
    }
    module2.exports = baseRange;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js
var require_toFinite = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js"(exports2, module2) {
    var toNumber = require_toNumber();
    var INFINITY = 1 / 0;
    var MAX_INTEGER = 17976931348623157e292;
    function toFinite(value2) {
      if (!value2) {
        return value2 === 0 ? value2 : 0;
      }
      value2 = toNumber(value2);
      if (value2 === INFINITY || value2 === -Infinity) {
        var sign2 = value2 < 0 ? -1 : 1;
        return sign2 * MAX_INTEGER;
      }
      return value2 === value2 ? value2 : 0;
    }
    module2.exports = toFinite;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createRange.js
var require_createRange = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createRange.js"(exports2, module2) {
    var baseRange = require_baseRange();
    var isIterateeCall = require_isIterateeCall();
    var toFinite = require_toFinite();
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
          end = step = void 0;
        }
        start = toFinite(start);
        if (end === void 0) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === void 0 ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }
    module2.exports = createRange;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/range.js
var require_range = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/range.js"(exports2, module2) {
    var createRange = require_createRange();
    var range6 = createRange();
    module2.exports = range6;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSome.js
var require_baseSome = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSome.js"(exports2, module2) {
    var baseEach = require_baseEach();
    function baseSome(collection, predicate) {
      var result;
      baseEach(collection, function(value2, index2, collection2) {
        result = predicate(value2, index2, collection2);
        return !result;
      });
      return !!result;
    }
    module2.exports = baseSome;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/some.js
var require_some = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/some.js"(exports2, module2) {
    var arraySome = require_arraySome();
    var baseIteratee = require_baseIteratee();
    var baseSome = require_baseSome();
    var isArray2 = require_isArray();
    var isIterateeCall = require_isIterateeCall();
    function some2(collection, predicate, guard) {
      var func = isArray2(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = void 0;
      }
      return func(collection, baseIteratee(predicate, 3));
    }
    module2.exports = some2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignValue.js"(exports2, module2) {
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key2, value2) {
      if (key2 == "__proto__" && defineProperty) {
        defineProperty(object, key2, {
          "configurable": true,
          "enumerable": true,
          "value": value2,
          "writable": true
        });
      } else {
        object[key2] = value2;
      }
    }
    module2.exports = baseAssignValue;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mapValues.js
var require_mapValues = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mapValues.js"(exports2, module2) {
    var baseAssignValue = require_baseAssignValue();
    var baseForOwn = require_baseForOwn();
    var baseIteratee = require_baseIteratee();
    function mapValues2(object, iteratee) {
      var result = {};
      iteratee = baseIteratee(iteratee, 3);
      baseForOwn(object, function(value2, key2, object2) {
        baseAssignValue(result, key2, iteratee(value2, key2, object2));
      });
      return result;
    }
    module2.exports = mapValues2;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEvery.js
var require_arrayEvery = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEvery.js"(exports2, module2) {
    function arrayEvery(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    module2.exports = arrayEvery;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEvery.js
var require_baseEvery = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEvery.js"(exports2, module2) {
    var baseEach = require_baseEach();
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value2, index2, collection2) {
        result = !!predicate(value2, index2, collection2);
        return result;
      });
      return result;
    }
    module2.exports = baseEvery;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/every.js
var require_every = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/every.js"(exports2, module2) {
    var arrayEvery = require_arrayEvery();
    var baseEvery = require_baseEvery();
    var baseIteratee = require_baseIteratee();
    var isArray2 = require_isArray();
    var isIterateeCall = require_isIterateeCall();
    function every3(collection, predicate, guard) {
      var func = isArray2(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = void 0;
      }
      return func(collection, baseIteratee(predicate, 3));
    }
    module2.exports = every3;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createFind.js
var require_createFind = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createFind.js"(exports2, module2) {
    var baseIteratee = require_baseIteratee();
    var isArrayLike = require_isArrayLike();
    var keys2 = require_keys();
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = baseIteratee(predicate, 3);
          collection = keys2(collection);
          predicate = function(key2) {
            return iteratee(iterable[key2], key2, iterable);
          };
        }
        var index2 = findIndexFunc(collection, predicate, fromIndex);
        return index2 > -1 ? iterable[iteratee ? collection[index2] : index2] : void 0;
      };
    }
    module2.exports = createFind;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js
var require_toInteger = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js"(exports2, module2) {
    var toFinite = require_toFinite();
    function toInteger(value2) {
      var result = toFinite(value2), remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    module2.exports = toInteger;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findIndex.js
var require_findIndex = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findIndex.js"(exports2, module2) {
    var baseFindIndex = require_baseFindIndex();
    var baseIteratee = require_baseIteratee();
    var toInteger = require_toInteger();
    var nativeMax = Math.max;
    function findIndex(array, predicate, fromIndex) {
      var length2 = array == null ? 0 : array.length;
      if (!length2) {
        return -1;
      }
      var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index2 < 0) {
        index2 = nativeMax(length2 + index2, 0);
      }
      return baseFindIndex(array, baseIteratee(predicate, 3), index2);
    }
    module2.exports = findIndex;
  }
});

// node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/find.js
var require_find = __commonJS({
  "node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/find.js"(exports2, module2) {
    var createFind = require_createFind();
    var findIndex = require_findIndex();
    var find2 = createFind(findIndex);
    module2.exports = find2;
  }
});

// node_modules/.pnpm/eventemitter3@4.0.7/node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
  "node_modules/.pnpm/eventemitter3@4.0.7/node_modules/eventemitter3/index.js"(exports2, module2) {
    var has = Object.prototype.hasOwnProperty;
    var prefix2 = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix2 = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function addListener(emitter, event, fn, context, once) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once), evt = prefix2 ? prefix2 + event : event;
      if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
      else emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0) emitter._events = new Events();
      else delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events, name2;
      if (this._eventsCount === 0) return names;
      for (name2 in events = this._events) {
        if (has.call(events, name2)) names.push(prefix2 ? name2.slice(1) : name2);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix2 ? prefix2 + event : event, handlers = this._events[evt];
      if (!handlers) return [];
      if (handlers.fn) return [handlers.fn];
      for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
        ee[i] = handlers[i].fn;
      }
      return ee;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix2 ? prefix2 + event : event, listeners = this._events[evt];
      if (!listeners) return 0;
      if (listeners.fn) return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a2), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for (i = 1, args = new Array(len - 1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length2 = listeners.length, j;
        for (i = 0; i < length2; i++) {
          if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i].fn.call(listeners[i].context);
              break;
            case 2:
              listeners[i].fn.call(listeners[i].context, a1);
              break;
            case 3:
              listeners[i].fn.call(listeners[i].context, a1, a2);
              break;
            case 4:
              listeners[i].fn.call(listeners[i].context, a1, a2, a3);
              break;
            default:
              if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i = 0, events = [], length2 = listeners.length; i < length2; i++) {
          if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
            events.push(listeners[i]);
          }
        }
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix2 ? prefix2 + event : event;
        if (this._events[evt]) clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix2;
    EventEmitter2.EventEmitter = EventEmitter2;
    if ("undefined" !== typeof module2) {
      module2.exports = EventEmitter2;
    }
  }
});
var TextInput = (props) => {
  const { name: name2, value: value2, onChange, error, type, label, leftSection, className, inputClassName, alwaysFocused, ...rest } = props;
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const onFocus = (_e) => {
    setFocused(!focused);
    inputRef.current?.focus();
  };
  const focusText = error ? "text-main-red" : "text-dark-blue";
  const focusBg = error ? "bg-main-red/5" : "bg-blue-50/70";
  const focusBorder = error ? "border-main-red" : "border-dark-blue";
  return /* @__PURE__ */ jsxs("div", { className: ["relative flex flex-col text-gray-500 w-full", className, rest.hidden ? "hidden" : ""].join(" "), children: [
    /* @__PURE__ */ jsx(
      "label",
      {
        "data-testid": "custom-input-label",
        onClick: props.children ? (e) => onFocus() : (_e) => {
        },
        onFocus: props.children ? null : (e) => onFocus(),
        tabIndex: 0,
        htmlFor: name2,
        className: ` p-3 px-1 cursor-pointer font-medium ${focused || alwaysFocused ? `py-2 ${focusText}` : "py-3"} ${props.labelClassName}`,
        children: label ?? props.name ?? props.placeholder
      }
    ),
    props.description && /* @__PURE__ */ jsx("p", { className: "text-sm p-1 text-gray-500", children: props.description }),
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: `flex items-center duration-150 w-full overflow-hidden ${focusBg} ${focused || alwaysFocused || alwaysFocused ? "h-11" : "h-0"}`,
        children: [
          props.children ?? /* @__PURE__ */ jsx(
            "input",
            {
              "data-testid": "custom-input",
              ref: inputRef,
              autoFocus: true,
              type: type ?? "text",
              className: [
                ` top-0 left-0 w-full h-full p-2 pt-4 border-none bg-transparent focus:border-none outline-none`,
                inputClassName
              ].join(" "),
              onChange,
              value: value2,
              name: name2,
              ...rest
            }
          ),
          leftSection && /* @__PURE__ */ jsx("div", { className: "", children: leftSection })
        ]
      }
    ),
    /* @__PURE__ */ jsx("hr", { className: `${focused || alwaysFocused ? focusBorder : ""} h-[2px] appearance-none` }),
    error && /* @__PURE__ */ jsx("span", { className: "text-red-500 text-sm", children: error })
  ] });
};

// node_modules/.pnpm/lottie-react@2.4.1_react-dom@19.0.0_react@19.0.0/node_modules/lottie-react/build/index.es.js
var import_lottie_web = __toESM(require_lottie());
__toESM(require_lottie());
function _arrayLikeToArray(r2, a2) {
  (null == a2 || a2 > r2.length) && (a2 = r2.length);
  for (var e = 0, n = Array(a2); e < a2; e++) n[e] = r2[e];
  return n;
}
function _arrayWithHoles(r2) {
  if (Array.isArray(r2)) return r2;
}
function _defineProperty(e, r2, t) {
  return (r2 = _toPropertyKey(r2)) in e ? Object.defineProperty(e, r2, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r2] = t, e;
}
function _iterableToArrayLimit(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t), true).forEach(function(r3) {
      _defineProperty(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r2, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s2 = Object.getOwnPropertySymbols(e);
    for (r2 = 0; r2 < s2.length; r2++) o = s2[r2], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r2, e) {
  if (null == r2) return {};
  var t = {};
  for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
    if (e.includes(n)) continue;
    t[n] = r2[n];
  }
  return t;
}
function _slicedToArray(r2, e) {
  return _arrayWithHoles(r2) || _iterableToArrayLimit(r2, e) || _unsupportedIterableToArray(r2, e) || _nonIterableRest();
}
function _toPrimitive(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r2, a2) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a2);
    var t = {}.toString.call(r2).slice(8, -1);
    return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r2, a2) : void 0;
  }
}
var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"];
var useLottie = function useLottie2(props, style) {
  var animationData2 = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
  props.lottieRef;
  props.renderer;
  props.name;
  props.assetsPath;
  props.rendererSettings;
  var rest = _objectWithoutProperties(props, _excluded$1);
  var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
  var animationInstanceRef = useRef();
  var animationContainer = useRef(null);
  var play = function play2() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.play();
  };
  var stop = function stop2() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.stop();
  };
  var pause = function pause2() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.pause();
  };
  var setSpeed = function setSpeed2(speed) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSpeed(speed);
  };
  var goToAndPlay = function goToAndPlay2(value2, isFrame) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndPlay(value2, isFrame);
  };
  var goToAndStop = function goToAndStop2(value2, isFrame) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(value2, isFrame);
  };
  var setDirection = function setDirection2(direction) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(direction);
  };
  var playSegments = function playSegments2(segments, forceFlag) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.playSegments(segments, forceFlag);
  };
  var setSubframe = function setSubframe2(useSubFrames) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSubframe(useSubFrames);
  };
  var getDuration = function getDuration2(inFrames) {
    var _a;
    return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
  };
  var destroy = function destroy2() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    animationInstanceRef.current = void 0;
  };
  var loadAnimation2 = function loadAnimation3() {
    var forcedConfigs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _a;
    if (!animationContainer.current) {
      return;
    }
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    var config2 = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
      container: animationContainer.current
    });
    animationInstanceRef.current = import_lottie_web.default.loadAnimation(config2);
    setAnimationLoaded(!!animationInstanceRef.current);
    return function() {
      var _a2;
      (_a2 = animationInstanceRef.current) === null || _a2 === void 0 ? void 0 : _a2.destroy();
      animationInstanceRef.current = void 0;
    };
  };
  useEffect(function() {
    var onUnmount = loadAnimation2();
    return function() {
      return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
    };
  }, [animationData2, loop]);
  useEffect(function() {
    if (!animationInstanceRef.current) {
      return;
    }
    animationInstanceRef.current.autoplay = !!autoplay;
  }, [autoplay]);
  useEffect(function() {
    if (!animationInstanceRef.current) {
      return;
    }
    if (!initialSegment) {
      animationInstanceRef.current.resetSegments(true);
      return;
    }
    if (!Array.isArray(initialSegment) || !initialSegment.length) {
      return;
    }
    if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) {
      animationInstanceRef.current.currentRawFrame = initialSegment[0];
    }
    animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
  }, [initialSegment]);
  useEffect(function() {
    var partialListeners = [{
      name: "complete",
      handler: onComplete
    }, {
      name: "loopComplete",
      handler: onLoopComplete
    }, {
      name: "enterFrame",
      handler: onEnterFrame
    }, {
      name: "segmentStart",
      handler: onSegmentStart
    }, {
      name: "config_ready",
      handler: onConfigReady
    }, {
      name: "data_ready",
      handler: onDataReady
    }, {
      name: "data_failed",
      handler: onDataFailed
    }, {
      name: "loaded_images",
      handler: onLoadedImages
    }, {
      name: "DOMLoaded",
      handler: onDOMLoaded
    }, {
      name: "destroy",
      handler: onDestroy
    }];
    var listeners = partialListeners.filter(function(listener) {
      return listener.handler != null;
    });
    if (!listeners.length) {
      return;
    }
    var deregisterList = listeners.map(
      /**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */
      function(listener) {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(listener.name, listener.handler);
        return function() {
          var _a2;
          (_a2 = animationInstanceRef.current) === null || _a2 === void 0 ? void 0 : _a2.removeEventListener(listener.name, listener.handler);
        };
      }
    );
    return function() {
      deregisterList.forEach(function(deregister) {
        return deregister();
      });
    };
  }, [onComplete, onLoopComplete, onEnterFrame, onSegmentStart, onConfigReady, onDataReady, onDataFailed, onLoadedImages, onDOMLoaded, onDestroy]);
  var View = /* @__PURE__ */ React43.createElement("div", _objectSpread2({
    style,
    ref: animationContainer
  }, rest));
  return {
    View,
    play,
    stop,
    pause,
    setSpeed,
    goToAndStop,
    goToAndPlay,
    setDirection,
    playSegments,
    setSubframe,
    getDuration,
    destroy,
    animationContainerRef: animationContainer,
    animationLoaded,
    animationItem: animationInstanceRef.current
  };
};
function getContainerVisibility(container) {
  var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height2 = _container$getBoundin.height;
  var current = window.innerHeight - top;
  var max4 = window.innerHeight + height2;
  return current / max4;
}
function getContainerCursorPosition(container, cursorX, cursorY) {
  var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width2 = _container$getBoundin2.width, height2 = _container$getBoundin2.height;
  var x2 = (cursorX - left) / width2;
  var y2 = (cursorY - top) / height2;
  return {
    x: x2,
    y: y2
  };
}
var useInitInteractivity = function useInitInteractivity2(_ref) {
  var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
  useEffect(function() {
    var wrapper = wrapperRef.current;
    if (!wrapper || !animationItem || !actions.length) {
      return;
    }
    animationItem.stop();
    var scrollModeHandler = function scrollModeHandler2() {
      var assignedSegment = null;
      var scrollHandler = function scrollHandler2() {
        var currentPercent = getContainerVisibility(wrapper);
        var action = actions.find(function(_ref2) {
          var visibility = _ref2.visibility;
          return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
        });
        if (!action) {
          return;
        }
        if (action.type === "seek" && action.visibility && action.frames.length === 2) {
          var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
          animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
        }
        if (action.type === "loop") {
          if (assignedSegment === null) {
            animationItem.playSegments(action.frames, true);
            assignedSegment = action.frames;
          } else {
            if (assignedSegment !== action.frames) {
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            } else if (animationItem.isPaused) {
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            }
          }
        }
        if (action.type === "play" && animationItem.isPaused) {
          animationItem.resetSegments(true);
          animationItem.play();
        }
        if (action.type === "stop") {
          animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
        }
      };
      document.addEventListener("scroll", scrollHandler);
      return function() {
        document.removeEventListener("scroll", scrollHandler);
      };
    };
    var cursorModeHandler = function cursorModeHandler2() {
      var handleCursor = function handleCursor2(_x, _y) {
        var x2 = _x;
        var y2 = _y;
        if (x2 !== -1 && y2 !== -1) {
          var pos = getContainerCursorPosition(wrapper, x2, y2);
          x2 = pos.x;
          y2 = pos.y;
        }
        var action = actions.find(function(_ref3) {
          var position2 = _ref3.position;
          if (position2 && Array.isArray(position2.x) && Array.isArray(position2.y)) {
            return x2 >= position2.x[0] && x2 <= position2.x[1] && y2 >= position2.y[0] && y2 <= position2.y[1];
          }
          if (position2 && !Number.isNaN(position2.x) && !Number.isNaN(position2.y)) {
            return x2 === position2.x && y2 === position2.y;
          }
          return false;
        });
        if (!action) {
          return;
        }
        if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
          var xPercent = (x2 - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
          var yPercent = (y2 - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
          animationItem.playSegments(action.frames, true);
          animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
        }
        if (action.type === "loop") {
          animationItem.playSegments(action.frames, true);
        }
        if (action.type === "play") {
          if (animationItem.isPaused) {
            animationItem.resetSegments(false);
          }
          animationItem.playSegments(action.frames);
        }
        if (action.type === "stop") {
          animationItem.goToAndStop(action.frames[0], true);
        }
      };
      var mouseMoveHandler = function mouseMoveHandler2(ev) {
        handleCursor(ev.clientX, ev.clientY);
      };
      var mouseOutHandler = function mouseOutHandler2() {
        handleCursor(-1, -1);
      };
      wrapper.addEventListener("mousemove", mouseMoveHandler);
      wrapper.addEventListener("mouseout", mouseOutHandler);
      return function() {
        wrapper.removeEventListener("mousemove", mouseMoveHandler);
        wrapper.removeEventListener("mouseout", mouseOutHandler);
      };
    };
    switch (mode) {
      case "scroll":
        return scrollModeHandler();
      case "cursor":
        return cursorModeHandler();
    }
  }, [mode, animationItem]);
};
var useLottieInteractivity = function useLottieInteractivity2(_ref4) {
  var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
  var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
  useInitInteractivity({
    actions,
    animationItem,
    mode,
    wrapperRef: animationContainerRef
  });
  return View;
};
var _excluded = ["style", "interactivity"];
var Lottie = function Lottie2(props) {
  var _a, _b, _c;
  var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
  var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
  useEffect(function() {
    if (props.lottieRef) {
      props.lottieRef.current = {
        play,
        stop,
        pause,
        setSpeed,
        goToAndPlay,
        goToAndStop,
        setDirection,
        playSegments,
        setSubframe,
        getDuration,
        destroy,
        animationContainerRef,
        animationLoaded,
        animationItem
      };
    }
  }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);
  return useLottieInteractivity({
    lottieObj: {
      View,
      play,
      stop,
      pause,
      setSpeed,
      goToAndStop,
      goToAndPlay,
      setDirection,
      playSegments,
      setSubframe,
      getDuration,
      destroy,
      animationContainerRef,
      animationLoaded,
      animationItem
    },
    actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
    mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
  });
};

// src/components/atoms/verified-animation/verified-animation.json
var verified_animation_default = {
  v: "4.10.2",
  fr: 29.9700012207031,
  ip: 0,
  op: 59.0000024031193,
  w: 500,
  h: 500,
  nm: "comp1",
  ddd: 0,
  assets: [
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 0,
          nm: "pre3",
          refId: "comp_1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [27, 27, 0], ix: 2 },
            a: { a: 0, k: [54, 54, 0], ix: 1 },
            s: { a: 0, k: [50, 50, 100], ix: 6 }
          },
          ao: 0,
          w: 108,
          h: 108,
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        }
      ]
    },
    {
      id: "comp_1",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "\xC3\xA3\xC2\x82\xC2\xB7\xC3\xA3\xC2\x82\xC2\xA7\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\x97\xC3\xA3\xC2\x83\xC2\xAC\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\xA4\xC3\xA3\xC2\x83\xC2\xBC 4",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  n: ["0p833_0p833_0p167_0p167"],
                  t: 1,
                  s: [-68],
                  e: [292]
                },
                { t: 17.0000006924242 }
              ],
              ix: 10
            },
            p: { a: 0, k: [54, 54, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [100, 100], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "????? 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.9450980392156862, 0.596078431372549, 0.43529411764705883, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 5, ix: 5 },
                  lc: 2,
                  lj: 2,
                  nm: "? 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform"
                }
              ],
              nm: "??? 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            },
            {
              ty: "tm",
              s: { a: 0, k: 0, ix: 1 },
              e: { a: 0, k: 20, ix: 2 },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "???????? 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            }
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "\xC3\xA3\xC2\x82\xC2\xB7\xC3\xA3\xC2\x82\xC2\xA7\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\x97\xC3\xA3\xC2\x83\xC2\xAC\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\xA4\xC3\xA3\xC2\x83\xC2\xBC 3",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: -68, ix: 10 },
            p: { a: 0, k: [54, 54, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [100, 100], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "????? 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.6392156862745098, 0.6392156862745098, 0.6470588235294118, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 5, ix: 5 },
                  lc: 2,
                  lj: 2,
                  nm: "? 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform"
                }
              ],
              nm: "??? 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            },
            {
              ty: "tm",
              s: { a: 0, k: 0, ix: 1 },
              e: { a: 0, k: 100, ix: 2 },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "???????? 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            }
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        }
      ]
    },
    {
      id: "comp_2",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 0,
          nm: "pre2",
          refId: "comp_3",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [27, 27, 0], ix: 2 },
            a: { a: 0, k: [54, 54, 0], ix: 1 },
            s: { a: 0, k: [50, 50, 100], ix: 6 }
          },
          ao: 0,
          w: 108,
          h: 108,
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        }
      ]
    },
    {
      id: "comp_3",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "check_long\xC3\xA3\xC2\x82\xC2\xA2\xC3\xA3\xC2\x82\xC2\xA6\xC3\xA3\xC2\x83\xC2\x88\xC3\xA3\xC2\x83\xC2\xA9\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\xB3",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [54, 54, 0], ix: 2 },
            a: { a: 0, k: [54, 54, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [7.474, 35.526],
                    [43.075, 71],
                    [76, 39]
                  ],
                  c: false
                },
                ix: 2
              },
              nm: "?? 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ["0p833_0p833_0p167_0p167"],
                    t: 21,
                    s: [0],
                    e: [30]
                  },
                  { t: 25.0000010182709 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ["0p833_0p833_0p167_0p167"],
                    t: 16,
                    s: [0],
                    e: [100]
                  },
                  { t: 24.00000097754 }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "???????? 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.0784313725490196, 0.45098039215686275, 0.9019607843137255, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 6, ix: 5 },
              lc: 2,
              lj: 2,
              nm: "? 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            }
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "\xC3\xA3\xC2\x82\xC2\xB7\xC3\xA3\xC2\x82\xC2\xA7\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\x97\xC3\xA3\xC2\x83\xC2\xAC\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\xA4\xC3\xA3\xC2\x83\xC2\xBC 4",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  n: ["0p833_0p833_0p167_0p167"],
                  t: 0,
                  s: [-68],
                  e: [220]
                },
                { t: 16.0000006516934 }
              ],
              ix: 10
            },
            p: { a: 0, k: [54, 54, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [100, 100], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "????? 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 5, ix: 5 },
                  lc: 2,
                  lj: 2,
                  nm: "? 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform"
                }
              ],
              nm: "??? 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ["0p833_0p833_0p167_0p167"],
                    t: 16,
                    s: [0],
                    e: [20]
                  },
                  { t: 21.0000008553475 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ["0p833_0p833_0p167_0p167"],
                    t: 0,
                    s: [20],
                    e: [20]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ["0p833_0p833_0p167_0p167"],
                    t: 16,
                    s: [20],
                    e: [20]
                  },
                  { t: 21.0000008553475 }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "???????? 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            }
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "\xC3\xA3\xC2\x82\xC2\xB7\xC3\xA3\xC2\x82\xC2\xA7\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\x97\xC3\xA3\xC2\x83\xC2\xAC\xC3\xA3\xC2\x82\xC2\xA4\xC3\xA3\xC2\x83\xC2\xA4\xC3\xA3\xC2\x83\xC2\xBC 3",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: -68, ix: 10 },
            p: { a: 0, k: [54, 54, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [100, 100], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "????? 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.0784313725490196, 0.45098039215686275, 0.9019607843137255, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 5, ix: 5 },
                  lc: 2,
                  lj: 2,
                  nm: "? 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform"
                }
              ],
              nm: "??? 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false
            },
            {
              ty: "tm",
              s: { a: 0, k: 0, ix: 1 },
              e: { a: 0, k: 100, ix: 2 },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "???????? 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            }
          ],
          ip: 0,
          op: 90.0000036657751,
          st: 0,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "loading",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [250, 250, 0], ix: 2 },
        a: { a: 0, k: [27, 27, 0], ix: 1 },
        s: { a: 0, k: [459.259, 459.259, 100], ix: 6 }
      },
      ao: 0,
      w: 54,
      h: 54,
      ip: 0,
      op: 17.0000006924242,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: "done",
      refId: "comp_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [250, 250, 0], ix: 2 },
        a: { a: 0, k: [27, 27, 0], ix: 1 },
        s: { a: 0, k: [459.259, 459.259, 100], ix: 6 }
      },
      ao: 0,
      w: 54,
      h: 54,
      ip: 17.0000006924242,
      op: 107.000004358199,
      st: 17.0000006924242,
      bm: 0
    }
  ]
};
function VerifiedAnimation() {
  return /* @__PURE__ */ jsx(Lottie, { animationData: verified_animation_default });
}

// node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_default = clsx;
function Logo({ showText = true, direction = "horizontal", subtitle, svgProps, onClick, customLogo, title = "Ministry of Health" }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx_default("flex items-center gap-4", direction === "horizontal" ? "flex-row" : "flex-col", onClick ? "cursor-pointer" : ""),
      onClick,
      children: [
        customLogo || /* @__PURE__ */ jsxs(
          "svg",
          {
            width: "41",
            height: "43",
            viewBox: "0 0 41 43",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            ...svgProps,
            children: [
              /* @__PURE__ */ jsx("rect", { x: "0.5", width: "40", height: "43", fill: "url(#pattern0)" }),
              /* @__PURE__ */ jsxs("defs", { children: [
                /* @__PURE__ */ jsx("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: "1", height: "1", children: /* @__PURE__ */ jsx("use", { xlinkHref: "#image0_1323_909", transform: "matrix(0.00149254 0 0 0.00138841 0 -0.00815689)" }) }),
                /* @__PURE__ */ jsx("image", { id: "image0_1323_909", width: "670", height: "732", xlinkHref: "data:image/png;base64,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" })
              ] })
            ]
          }
        ),
        showText && /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "font-semibold", children: title }),
          subtitle && /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-600", children: subtitle })
        ] })
      ]
    }
  );
}
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React43.createContext && /* @__PURE__ */ React43.createContext(DefaultContext);

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/lib/iconBase.mjs
var _excluded2 = ["attr", "size", "title"];
function _objectWithoutProperties2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys2(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys2(Object(t), true).forEach(function(r3) {
      _defineProperty2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty2(obj, key2, value2) {
  key2 = _toPropertyKey2(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive2(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /* @__PURE__ */ React43.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data2) {
  return (props) => /* @__PURE__ */ React43.createElement(IconBase, _extends({
    attr: _objectSpread({}, data2.attr)
  }, props), Tree2Element(data2.child));
}
function IconBase(props) {
  var elem2 = (conf) => {
    var {
      attr,
      size,
      title
    } = props, svgProps = _objectWithoutProperties2(props, _excluded2);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /* @__PURE__ */ React43.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ React43.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React43.createElement(IconContext.Consumer, null, (conf) => elem2(conf)) : elem2(DefaultContext);
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/cg/index.mjs
function CgCreditCard(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none" }, "child": [{ "tag": "path", "attr": { "d": "M4 9C4 8.44772 4.44772 8 5 8H9C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10H5C4.44772 10 4 9.55228 4 9Z", "fill": "currentColor" }, "child": [] }, { "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M4 3C1.79086 3 0 4.79086 0 7V17C0 19.2091 1.79086 21 4 21H20C22.2091 21 24 19.2091 24 17V7C24 4.79086 22.2091 3 20 3H4ZM20 5H4C2.89543 5 2 5.89543 2 7V14H22V7C22 5.89543 21.1046 5 20 5ZM22 16H2V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V16Z", "fill": "currentColor" }, "child": [] }] })(props);
}
function StatCard({ title, value: price, subtitle, color: color2, link, LinkComponent }) {
  const Tag = useMemo(() => {
    return link && LinkComponent ? LinkComponent : "div";
  }, [link, LinkComponent]);
  if (!title && !price)
    return null;
  const linkProps = link ? {
    // Support both Next.js (href) and React Router (to)
    href: link.href,
    to: link.href
  } : {};
  return /* @__PURE__ */ jsxs(
    Tag,
    {
      ...linkProps,
      className: `px-4 py-6 rounded-lg bg-white w-full border-2 border-transparent transition-colors duration-200 ${link ? "hover:border-blue-200" : ""}`,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-row gap-2 justify-between", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                "data-testid": "color-bar",
                className: "rounded-full h-18 w-1",
                style: {
                  backgroundColor: color2
                }
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ jsx("span", { className: "text-slate-600 font-medium text-sm", children: title }),
              /* @__PURE__ */ jsx("span", { className: "font-semibold text-3xl", children: String(price) })
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            "div",
            {
              "data-testid": "icon-wrapper",
              className: "p-1 rounded-md w-fit h-fit",
              style: {
                backgroundColor: `${color2}10`
              },
              children: /* @__PURE__ */ jsx(
                CgCreditCard,
                {
                  style: {
                    color: color2
                  }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-col mt-1", children: subtitle && /* @__PURE__ */ jsx(
          "span",
          {
            className: "font-[500] text-sm",
            style: {
              color: color2
            },
            children: subtitle
          }
        ) })
      ]
    }
  );
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/io5/index.mjs
function IoCheckmarkDone(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M464 128 240 384l-96-96m0 96-96-96m320-160L232 284" }, "child": [] }] })(props);
}
function IoChevronDown(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "48", "d": "m112 184 144 144 144-144" }, "child": [] }] })(props);
}
function IoChevronUp(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "48", "d": "m112 328 144-144 144 144" }, "child": [] }] })(props);
}
function IoDocumentOutline(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z" }, "child": [] }, { "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M256 56v120a32 32 0 0 0 32 32h120" }, "child": [] }] })(props);
}
function IoFilterOutline(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M32 144h448M112 256h288M208 368h96" }, "child": [] }] })(props);
}
function IoNotificationsOutline(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 0 1-128 0v-16" }, "child": [] }] })(props);
}
function IoSearchOutline(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeMiterlimit": "10", "strokeWidth": "32", "d": "M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64z" }, "child": [] }, { "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeMiterlimit": "10", "strokeWidth": "32", "d": "M338.29 338.29 448 448" }, "child": [] }] })(props);
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/pi/index.mjs
function PiFileJpg(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 256 256", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M120,144H104a8,8,0,0,0-8,8v56a8,8,0,0,0,16,0v-8h8a28,28,0,0,0,0-56Zm0,40h-8V160h8a12,12,0,0,1,0,24Zm96,0v16.87a8,8,0,0,1-2.22,5.53A30.06,30.06,0,0,1,192,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a29.38,29.38,0,0,1,16.48,5.12,8,8,0,0,1-9,13.26A13.21,13.21,0,0,0,192,160c-8.82,0-16,9-16,20s7.18,20,16,20a13.63,13.63,0,0,0,8-2.71V192a8,8,0,0,1,0-16h8A8,8,0,0,1,216,184ZM80,152v38a26,26,0,0,1-52,0,8,8,0,0,1,16,0,10,10,0,0,0,20,0V152a8,8,0,0,1,16,0ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,80V51.31L188.69,80Z" }, "child": [] }] })(props);
}
function PiFilePdf(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 256 256", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M224,152a8,8,0,0,1-8,8H192v16h16a8,8,0,0,1,0,16H192v16a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h32A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm88,8a36,36,0,0,1-36,36H112a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8h16A36,36,0,0,1,164,180Zm-16,0a20,20,0,0,0-20-20h-8v40h8A20,20,0,0,0,148,180ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z" }, "child": [] }] })(props);
}
function PiFilePng(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 256 256", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M60,144H44a8,8,0,0,0-8,8v56a8,8,0,0,0,16,0v-8h8a28,28,0,0,0,0-56Zm0,40H52V160h8a12,12,0,0,1,0,24Zm164,16.87a8,8,0,0,1-2.22,5.53A30.06,30.06,0,0,1,200,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a29.45,29.45,0,0,1,16.48,5.11,8,8,0,0,1-9,13.27A13.21,13.21,0,0,0,200,160c-8.82,0-16,9-16,20s7.18,20,16,20a13.57,13.57,0,0,0,8-2.72V192a8,8,0,0,1,0-16h8a8,8,0,0,1,8,8ZM156,152v56a8,8,0,0,1-5.56,7.62A7.91,7.91,0,0,1,148,216a8,8,0,0,1-6.51-3.35L116,177v31a8,8,0,0,1-16,0V152a8,8,0,0,1,14.51-4.65L140,183V152a8,8,0,0,1,16,0ZM48,120a8,8,0,0,0,8-8V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88a8,8,0,0,0-2.34-5.66l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72A8,8,0,0,0,48,120ZM160,51.31,188.69,80H160Z" }, "child": [] }] })(props);
}
function PiWarningCircle(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 256 256", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }, "child": [] }] })(props);
}

// src/lib/utils/index.ts
function imageFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
function getObjValue(key2, obj) {
  const keys2 = key2.toString().split(".");
  let result = obj;
  for (const key3 of keys2) {
    if (result && Object.prototype.hasOwnProperty.call(result, key3)) {
      result = result[key3];
    } else {
      return void 0;
    }
  }
  return result;
}
var mime_to_icon = {
  "image/png": PiFilePng,
  "image/jpg": PiFileJpg,
  "application/pdf": PiFilePdf,
  "unknown": IoDocumentOutline
};
function FilePreview({ name: name2, mimetype, className, file }) {
  const Icon = mime_to_icon[mimetype ?? ""] ?? mime_to_icon.unknown;
  const [base64, setBase64] = React43.useState(null);
  useEffect(() => {
    if (file && mimetype?.startsWith("image"))
      imageFileToBase64(file).then(setBase64);
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: [
        "h-[10em] w-[10em] rounded-md flex flex-col bg-white items-center justify-center relative overflow-hidden",
        className
      ].join(" "),
      children: [
        !base64 && /* @__PURE__ */ jsx(Icon, { className: "w-10 h-10 text-color-a2" }),
        base64 && /* @__PURE__ */ jsx("img", { src: base64, alt: name2, className: "w-full h-full object-cover rounded-md" }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: [
              "block overflow-hidden overflow-ellipsis w-full text-center p-1",
              base64 ? "absolute bottom-0 left-0 w-full text-white" : ""
            ].join(" "),
            style: base64 ? { background: "linear-gradient(#00000092, #000000e6)" } : {},
            title: name2,
            children: name2
          }
        )
      ]
    }
  );
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/ai/index.mjs
function AiOutlineUpload(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 1024 1024" }, "child": [{ "tag": "path", "attr": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" }, "child": [] }] })(props);
}
var FileInput = (props) => {
  const {
    name: name2,
    value: value2,
    onChange,
    error,
    multiple,
    label,
    leftSection,
    files: initialFiles = [],
    accept,
    alwaysFocused = false,
    ...rest
  } = props;
  const [focused, setFocused] = useState(alwaysFocused);
  const inputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState(initialFiles);
  const onFocus = () => {
    setFocused(!focused);
    inputRef.current?.focus();
  };
  const handleOnChange = async (e) => {
    const _files = e.target.files;
    if (_files && _files.length > 0) {
      const validFiles = Array.from(_files);
      if (validFiles.length === 0) {
        return;
      }
      setSelectedFiles(validFiles);
    }
    onChange && onChange(e);
  };
  const focusText = error ? "text-main-red" : "text-dark-blue";
  const focusBg = error ? "bg-main-red/5" : "bg-blue-50/70";
  const focusBorder = error ? "border-main-red" : "border-dark-blue";
  return /* @__PURE__ */ jsxs("div", { className: "relative flex flex-col text-gray-500", children: [
    /* @__PURE__ */ jsxs(
      "label",
      {
        onFocus: alwaysFocused ? onFocus : void 0,
        onClick: () => setFocused(!focused),
        tabIndex: 0,
        htmlFor: name2,
        className: ` flex flex-row items-center justify-between p-3 cursor-pointer font-medium ${focused ? `py-2 ${focusText}` : "py-3"}`,
        children: [
          label ?? props.name ?? props.placeholder,
          /* @__PURE__ */ jsx(AiOutlineUpload, { className: "w-6 h-6" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: `flex items-center duration-150 w-full overflow-hidden ${focusBg} ${focused ? "h-fit" : "h-0"}`,
        onClick: () => {
          inputRef.current?.click();
        },
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: inputRef,
              autoFocus: true,
              type: "file",
              multiple: multiple ?? false,
              className: ` top-0 left-0 w-full h-full p-2 pt-4 border-none bg-transparent focus:border-none outline-none hidden`,
              onChange: handleOnChange,
              value: value2,
              accept,
              ...rest
            }
          ),
          leftSection && /* @__PURE__ */ jsx("div", { className: "px-2", children: leftSection }),
          /* @__PURE__ */ jsxs("section", { className: "flex flex-col gap-2 px-4 py-2", children: [
            /* @__PURE__ */ jsxs("span", { className: "", children: [
              selectedFiles.length,
              " ",
              "File",
              selectedFiles.length !== 1 ? "s" : "",
              " ",
              "Selected. Click to choose."
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex flex-row gap-2 flex-wrap pb-6", children: selectedFiles.map((file, index2) => /* @__PURE__ */ jsx(FilePreview, { name: file.name, mimetype: file.type, file, className: "h-[8em] w-auto" }, index2)) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx("hr", { className: `${focused ? focusBorder : ""} h-[2px] appearance-none` }),
    error && /* @__PURE__ */ jsx("span", { className: "text-red-500 text-sm", children: error })
  ] });
};
function ModalLayout(props) {
  const { children, open, size, centered = true, closeOnClickOutside = true, onClose, radius, padding, ...rest } = props;
  return /* @__PURE__ */ jsx(
    Modal,
    {
      opened: open,
      size: size ?? 500,
      onClose,
      centered,
      radius: radius ?? 10,
      closeOnClickOutside,
      withCloseButton: false,
      padding: padding ?? rem(25),
      ...rest,
      children
    }
  );
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/io/index.mjs
function IoIosRefresh(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M433 288.8c-7.7 0-14.3 5.9-14.9 13.6-6.9 83.1-76.8 147.9-161.8 147.9-89.5 0-162.4-72.4-162.4-161.4 0-87.6 70.6-159.2 158.2-161.4 2.3-.1 4.1 1.7 4.1 4v50.3c0 12.6 13.9 20.2 24.6 13.5L377 128c10-6.3 10-20.8 0-27.1l-96.1-66.4c-10.7-6.7-24.6.9-24.6 13.5v45.7c0 2.2-1.7 4-3.9 4C148 99.8 64 184.6 64 288.9 64 394.5 150.1 480 256.3 480c100.8 0 183.4-76.7 191.6-175.1.8-8.7-6.2-16.1-14.9-16.1z" }, "child": [] }] })(props);
}
function EmptyView({
  message,
  minHeight,
  buttonLabel,
  buttonAction,
  size = "large",
  svgWidth = "300.5",
  svgHeight = "350.5"
}) {
  return /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${minHeight || (size === "small" ? "min-h-[20vh]" : size === "medium" ? "min-h-[35vh]" : "min-h-[60vh]")} bg-gray-50 rounded-lg mt-6 py-6 flex flex-col items-center justify-center gap-6`,
      children: [
        /* @__PURE__ */ jsx(EmptySvg, { width: svgWidth, height: svgHeight }),
        /* @__PURE__ */ jsx("h1", { className: "text-xl font-semibold text-gray-700", children: message }),
        buttonLabel && buttonAction && /* @__PURE__ */ jsx(Button, { onClick: buttonAction, children: buttonLabel })
      ]
    }
  ) });
}
function EmptySvg({ width: width2 = "797.5", height: height2 = "834.5" }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "Layer 1",
      width: width2,
      height: height2,
      viewBox: "0 0 797.5 834.5",
      children: [
        /* @__PURE__ */ jsx("title", { children: "void" }),
        /* @__PURE__ */ jsx("ellipse", { cx: "308.5", cy: "780", rx: "308.5", ry: "54.5", fill: "#3f3d56" }),
        /* @__PURE__ */ jsx("circle", { cx: "496", cy: "301.5", r: "301.5", fill: "#3f3d56" }),
        /* @__PURE__ */ jsx("circle", { cx: "496", cy: "301.5", r: "248.89787", opacity: "0.05" }),
        /* @__PURE__ */ jsx("circle", { cx: "496", cy: "301.5", r: "203.99362", opacity: "0.05" }),
        /* @__PURE__ */ jsx("circle", { cx: "496", cy: "301.5", r: "146.25957", opacity: "0.05" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M398.42029,361.23224s-23.70394,66.72221-13.16886,90.42615,27.21564,46.52995,27.21564,46.52995S406.3216,365.62186,398.42029,361.23224Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#d0cde1"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M398.42029,361.23224s-23.70394,66.72221-13.16886,90.42615,27.21564,46.52995,27.21564,46.52995S406.3216,365.62186,398.42029,361.23224Z",
            transform: "translate(-201.25 -32.75)",
            opacity: "0.1"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M415.10084,515.74682s-1.75585,16.68055-2.63377,17.55847.87792,2.63377,0,5.26754-1.75585,6.14547,0,7.02339-9.65716,78.13521-9.65716,78.13521-28.09356,36.8728-16.68055,94.81576l3.51169,58.82089s27.21564,1.75585,27.21564-7.90132c0,0-1.75585-11.413-1.75585-16.68055s4.38962-5.26754,1.75585-7.90131-2.63377-4.38962-2.63377-4.38962,4.38961-3.51169,3.51169-4.38962,7.90131-63.2105,7.90131-63.2105,9.65716-9.65716,9.65716-14.92471v-5.26754s4.38962-11.413,4.38962-12.29093,23.70394-54.43127,23.70394-54.43127l9.65716,38.62864,10.53509,55.3092s5.26754,50.04165,15.80262,69.356c0,0,18.4364,63.21051,18.4364,61.45466s30.72733-6.14547,29.84941-14.04678-18.4364-118.5197-18.4364-118.5197L533.62054,513.991Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M391.3969,772.97846s-23.70394,46.53-7.90131,48.2858,21.94809,1.75585,28.97148-5.26754c3.83968-3.83968,11.61528-8.99134,17.87566-12.87285a23.117,23.117,0,0,0,10.96893-21.98175c-.463-4.29531-2.06792-7.83444-6.01858-8.16366-10.53508-.87792-22.826-10.53508-22.826-10.53508Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M522.20753,807.21748s-23.70394,46.53-7.90131,48.28581,21.94809,1.75584,28.97148-5.26754c3.83968-3.83969,11.61528-8.99134,17.87566-12.87285a23.117,23.117,0,0,0,10.96893-21.98175c-.463-4.29531-2.06792-7.83444-6.01857-8.16367-10.53509-.87792-22.826-10.53508-22.826-10.53508Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: "295.90488", cy: "215.43252", r: "36.90462", fill: "#ffb8b8" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M473.43048,260.30832S447.07,308.81154,444.9612,308.81154,492.41,324.62781,492.41,324.62781s13.70743-46.39439,15.81626-50.61206Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#ffb8b8"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M513.86726,313.3854s-52.67543-28.97148-57.943-28.09356-61.45466,50.04166-60.57673,70.2339,7.90131,53.55335,7.90131,53.55335,2.63377,93.05991,7.90131,93.93783-.87792,16.68055.87793,16.68055,122.90931,0,123.78724-2.63377S513.86726,313.3854,513.86726,313.3854Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#d0cde1"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M543.2777,521.89228s16.68055,50.91958,2.63377,49.16373-20.19224-43.89619-20.19224-43.89619Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#ffb8b8"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M498.50359,310.31267s-32.48318,7.02339-27.21563,50.91957,14.9247,87.79237,14.9247,87.79237l32.48318,71.11182,3.51169,13.16886,23.70394-6.14547L528.353,425.32067s-6.14547-108.86253-14.04678-112.37423A33.99966,33.99966,0,0,0,498.50359,310.31267Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#d0cde1"
          }
        ),
        /* @__PURE__ */ jsx("polygon", { points: "277.5 414.958 317.885 486.947 283.86 411.09 277.5 414.958", opacity: "0.1" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M533.896,237.31585l.122-2.82012,5.6101,1.39632a6.26971,6.26971,0,0,0-2.5138-4.61513l5.97581-.33413a64.47667,64.47667,0,0,0-43.1245-26.65136c-12.92583-1.87346-27.31837.83756-36.182,10.43045-4.29926,4.653-7.00067,10.57018-8.92232,16.60685-3.53926,11.11821-4.26038,24.3719,3.11964,33.40938,7.5006,9.18513,20.602,10.98439,32.40592,12.12114,4.15328.4,8.50581.77216,12.35457-.83928a29.721,29.721,0,0,0-1.6539-13.03688,8.68665,8.68665,0,0,1-.87879-4.15246c.5247-3.51164,5.20884-4.39635,8.72762-3.9219s7.74984,1.20031,10.062-1.49432c1.59261-1.85609,1.49867-4.559,1.70967-6.99575C521.28248,239.785,533.83587,238.70653,533.896,237.31585Z",
            transform: "translate(-201.25 -32.75)",
            fill: "#2f2e41"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: "559", cy: "744.5", r: "43", fill: "#518DC8" }),
        /* @__PURE__ */ jsx("circle", { cx: "54", cy: "729.5", r: "43", fill: "#518DC8" }),
        /* @__PURE__ */ jsx("circle", { cx: "54", cy: "672.5", r: "31", fill: "#518DC8" }),
        /* @__PURE__ */ jsx("circle", { cx: "54", cy: "624.5", r: "22", fill: "#518DC8" })
      ]
    }
  );
}
function getFilterItemDirectionStyle(direction = "inline-checkbox") {
  switch (direction) {
    case "checkbox":
      return "flex flex-col gap-2";
    case "inline-checkbox":
    default:
      return "flex flex-row flex-wrap gap-2";
  }
}
function getSelectOptions(items) {
  return items.map((item) => ({
    label: typeof item.label === "string" ? item.label : "Option",
    value: item.value
  }));
}
function getInitialSelected(filters) {
  if (filters && filters.length > 0) {
    const initialSelectedFilters = {};
    filters.forEach((filter) => {
      if (filter.isMulti && filter.items.some((item) => item?.checked)) {
        initialSelectedFilters[filter.name] = filter.items.filter((item) => item.checked).map((item) => item.value);
      } else {
        const checkedItem = filter.items.find((item) => item.checked);
        if (checkedItem) {
          initialSelectedFilters[filter.name] = checkedItem.value;
        }
      }
    });
    return initialSelectedFilters;
  }
  return {};
}
function FiltersDropdown({
  filters,
  onFiltersChange,
  onApplyFilters,
  onClearFilters,
  totalResults = 0,
  label = "Filters",
  maxHeight = 400,
  maxWidth = 400,
  externalSelectedFilters
}) {
  const init = getInitialSelected(filters);
  const [selectedFilters, setSelectedFilters] = useState(init);
  const [opened, setOpened] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const filtersCount = Object.keys(selectedFilters).length;
  useEffect(() => {
    if (filters.length > 0) {
      setOpenSections({ 0: true });
    }
  }, [filters.length]);
  const handleFilterChange = (name2, value2, isMulti = false) => {
    const updatedFilters = { ...selectedFilters };
    if (isMulti) {
      if (Array.isArray(value2)) {
        if (value2.length === 0) {
          delete updatedFilters[name2];
        } else {
          updatedFilters[name2] = value2;
        }
      } else {
        const currentValues = updatedFilters[name2] || [];
        const valueExists = currentValues.includes(value2);
        if (valueExists) {
          const newValues = currentValues.filter((v) => v !== value2);
          if (newValues.length === 0) {
            delete updatedFilters[name2];
          } else {
            updatedFilters[name2] = newValues;
          }
        } else {
          updatedFilters[name2] = [...currentValues, value2];
        }
      }
    } else {
      if (updatedFilters[name2] === value2) {
        delete updatedFilters[name2];
      } else {
        updatedFilters[name2] = value2;
      }
    }
    setSelectedFilters(updatedFilters);
  };
  const toggleSection = (index2) => {
    setOpenSections((prev) => ({
      ...prev,
      [index2]: !prev[index2]
    }));
  };
  const handleClearFilters = () => {
    setSelectedFilters({});
    if (onClearFilters) {
      onClearFilters({});
    }
  };
  const handleApplyFilters = () => {
    setOpened(false);
    if (onApplyFilters) {
      onApplyFilters(selectedFilters);
    }
  };
  useEffect(() => {
    if (Object.keys(selectedFilters).length > 0 && onFiltersChange) {
      onFiltersChange(selectedFilters);
    }
  }, [selectedFilters, onFiltersChange]);
  useEffect(() => {
    if (externalSelectedFilters) {
      setSelectedFilters((prev) => ({
        ...prev,
        ...externalSelectedFilters
      }));
    }
  }, [externalSelectedFilters]);
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      opened,
      onChange: setOpened,
      width: maxWidth,
      position: "bottom",
      shadow: "md",
      children: [
        /* @__PURE__ */ jsx(Popover.Target, { children: /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "outline",
            onClick: () => setOpened((o) => !o),
            leftSection: /* @__PURE__ */ jsx(IoFilterOutline, {}),
            className: "border-zinc-200 text-neutral-400",
            children: [
              label,
              " ",
              filtersCount > 0 && `(${filtersCount})`
            ]
          }
        ) }),
        /* @__PURE__ */ jsx(Popover.Dropdown, { children: /* @__PURE__ */ jsxs("div", { className: "p-2", children: [
          /* @__PURE__ */ jsx("div", { className: "flex justify-between items-center mb-4", children: /* @__PURE__ */ jsxs("h3", { className: "text-lg font-semibold", children: [
            "Filters",
            filtersCount > 0 && /* @__PURE__ */ jsx(Badge, { ml: "xs", size: "sm", children: filtersCount })
          ] }) }),
          /* @__PURE__ */ jsx(ScrollArea, { h: maxHeight, scrollbarSize: 8, children: filters.map((filter, index2) => /* @__PURE__ */ jsxs("div", { className: "mb-4 border-b pb-2", children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: "flex justify-between items-center cursor-pointer",
                onClick: () => toggleSection(index2),
                children: [
                  /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
                    filter.icon && /* @__PURE__ */ jsx("span", { className: "mr-2", children: filter.icon }),
                    /* @__PURE__ */ jsx("span", { className: "font-medium pl-2", children: filter.title })
                  ] }),
                  openSections[index2] ? /* @__PURE__ */ jsx(IoChevronUp, {}) : /* @__PURE__ */ jsx(IoChevronDown, {})
                ]
              }
            ),
            openSections[index2] && /* @__PURE__ */ jsxs("div", { className: "mt-2", children: [
              filter.filterElement === "select" ? /* @__PURE__ */ jsx(
                Select,
                {
                  data: getSelectOptions(filter.items),
                  value: selectedFilters[filter.name],
                  onChange: (value2) => handleFilterChange(filter.name, value2 || ""),
                  clearable: true,
                  searchable: filter.items.length > 10,
                  placeholder: "Select option"
                }
              ) : /* @__PURE__ */ jsx("div", { className: getFilterItemDirectionStyle(filter.filterElement), children: filter.items.map((item, itemIndex) => {
                const isChecked = filter.isMulti ? Array.isArray(selectedFilters[filter.name]) && selectedFilters[filter.name]?.includes(item.value) : selectedFilters[filter.name] === item.value;
                return /* @__PURE__ */ jsxs("div", { className: "mr-4 mb-2", children: [
                  /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      label: item.label,
                      checked: isChecked,
                      onChange: () => handleFilterChange(filter.name, item.value, filter.isMulti)
                    }
                  ),
                  isChecked && item.custom && /* @__PURE__ */ jsx("div", { className: "mt-1 ml-6", children: item.custom })
                ] }, itemIndex);
              }) }),
              filter.custom && /* @__PURE__ */ jsx("div", { className: "mt-2", children: filter.custom })
            ] })
          ] }, index2)) }),
          /* @__PURE__ */ jsxs("div", { className: "flex justify-between mt-4", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "subtle",
                onClick: handleClearFilters,
                children: "Clear Filters"
              }
            ),
            /* @__PURE__ */ jsxs(
              Button,
              {
                onClick: handleApplyFilters,
                disabled: filtersCount === 0,
                children: [
                  "Apply Filters",
                  " ",
                  totalResults > 0 ? `(${totalResults})` : ""
                ]
              }
            )
          ] })
        ] }) })
      ]
    }
  );
}
function LoadingView({
  message,
  minHeight,
  className = "",
  spinnerSize = "medium",
  variant = "light"
}) {
  const spinnerSizes = {
    small: "h-12 w-12",
    medium: "h-16 w-16",
    large: "h-24 w-24"
  };
  const variantClasses = {
    light: "bg-gray-50 text-black",
    dark: "bg-gray-800 text-white",
    transparent: "bg-transparent"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `w-full ${minHeight || "min-h-[30vh]"} 
        ${variantClasses[variant]} rounded-lg py-6 
        flex flex-col items-center justify-center gap-4 
        ${className}`,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": "loading-spinner",
            className: `animate-spin rounded-full 
          ${spinnerSizes[spinnerSize]} 
          border-4 border-t-4 
          border-gray-200 border-t-dark-blue
          ${variant === "dark" ? "border-gray-700 border-t-gray-300" : "border-gray-200 border-t-dark-blue"} 
          shadow-sm`
          }
        ),
        /* @__PURE__ */ jsx(
          "p",
          {
            className: `font-medium ${spinnerSize === "small" ? "text-base" : "text-xl"} 
        ${variant === "dark" ? "text-gray-100" : "text-gray-700"}`,
            children: message
          }
        )
      ]
    }
  );
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/fa/index.mjs
function FaChevronRight(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" }, "child": [] }] })(props);
}
function FaSortDown(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z" }, "child": [] }] })(props);
}
function FaSortUp(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z" }, "child": [] }] })(props);
}
function FaSort(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" }, "child": [] }] })(props);
}
function SortableTH({
  children,
  onSort,
  reversed = false,
  sorted = false,
  className,
  iconClassName,
  style,
  iconStyle
}) {
  const Icon = sorted ? reversed ? FaSortUp : FaSortDown : FaSort;
  return /* @__PURE__ */ jsx(Table.Th, { className: ` ${className}`, style, children: /* @__PURE__ */ jsxs("div", { className: "group flex items-center justify-between gap-2 cursor-pointer", onClick: onSort, children: [
    /* @__PURE__ */ jsx("span", { className: "font-bold", children }),
    !!onSort && /* @__PURE__ */ jsx(
      Icon,
      {
        className: [
          "inline-block duration-150",
          !sorted ? "opacity-0 group-hover:opacity-100" : "",
          iconClassName
        ].join(" "),
        style: iconStyle,
        "data-testid": "sort-icon"
      }
    )
  ] }) });
}
function CustomTable({
  columns,
  data: data2,
  selection,
  setSelection,
  sortedData,
  sortBy: sortBy4,
  reverseSortDirection,
  onSort,
  pageSize = 10,
  page = 1,
  setPage,
  errorFetching = false,
  loading,
  paginated = false,
  pagination,
  size,
  accent = "primary"
}) {
  const toggleRow = (id) => setSelection((current) => current.includes(id) ? current.filter((item) => item !== id) : [...current, id]);
  const toggleAll = () => setSelection((current) => current.length === data2.length ? [] : data2.map((item) => item.id));
  const rows = !paginated ? Array.isArray(sortedData) && sortedData.length > 0 ? sortedData.slice((page - 1) * pageSize, page * pageSize).map((item, item_index) => {
    return /* @__PURE__ */ jsxs(Table.Tr, { role: "data-rows", className: "", children: [
      /* @__PURE__ */ jsx(Table.Td, { children: /* @__PURE__ */ jsx(Checkbox, { checked: selection.includes(item.id), onChange: () => toggleRow(item.id) }) }),
      columns.map((column, i) => {
        return /* @__PURE__ */ jsx(Table.Td, { "data-test-id": item[column.key], align: column.align, children: column.Element ? /* @__PURE__ */ jsx(
          column.Element,
          {
            ...{
              selected: selection.includes(item.id),
              row: item,
              rows: data2,
              value: getObjValue(column.key, item) ?? ""
            }
          }
        ) : String(getObjValue(column.key, item) ?? "") }, i);
      })
    ] }, item_index);
  }) : [] : sortedData.map((item, item_index) => {
    return /* @__PURE__ */ jsxs(Table.Tr, { role: "data-rows", className: "", children: [
      /* @__PURE__ */ jsx(Table.Td, { children: /* @__PURE__ */ jsx(Checkbox, { checked: selection.includes(item.id), onChange: () => toggleRow(item.id) }) }),
      columns.map((column, i) => {
        return /* @__PURE__ */ jsx(Table.Td, { "data-test-id": item[column.key], align: column.align, children: column.Element ? /* @__PURE__ */ jsx(
          column.Element,
          {
            ...{
              selected: selection.includes(item.id),
              row: item,
              rows: data2,
              value: getObjValue(column.key, item) ?? ""
            }
          }
        ) : String(getObjValue(column.key, item)) }, i);
      })
    ] }, item_index);
  });
  return /* @__PURE__ */ jsxs("div", { className: "overflow-x-auto mt-2 space-y-3 rounded-t-md", children: [
    /* @__PURE__ */ jsxs(Table, { miw: 800, verticalSpacing: "sm", striped: "even", children: [
      /* @__PURE__ */ jsx(Table.Thead, { children: /* @__PURE__ */ jsxs(
        Table.Tr,
        {
          className: `${accent === "primary" ? "bg-[#518DC8] border-[#518DC8] text-white" : "text-gray-600"} text-[1rem]  border  `,
          children: [
            /* @__PURE__ */ jsx(Table.Th, { style: { width: rem(40) }, children: /* @__PURE__ */ jsx(
              Checkbox,
              {
                onChange: toggleAll,
                checked: selection.length === data2.length,
                indeterminate: selection.length > 0 && selection.length !== data2.length
              }
            ) }),
            columns.map((column, i) => {
              return /* @__PURE__ */ jsx(
                SortableTH,
                {
                  className: "whitespace-nowrap",
                  ...column.sortable && {
                    onSort: onSort.bind(null, column.key),
                    sorted: sortBy4 === column.key,
                    reversed: reverseSortDirection
                  },
                  children: column.title
                },
                i
              );
            })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Table.Tbody, { children: rows.length ? rows : !loading ? /* @__PURE__ */ jsx(Table.Tr, { children: /* @__PURE__ */ jsx(Table.Td, { colSpan: columns.length + 1, children: /* @__PURE__ */ jsx(EmptyView, { size, message: errorFetching ? "Error Fetching Data" : "No Data To Show" }) }) }) : null })
    ] }),
    /* @__PURE__ */ jsx(
      Pagination,
      {
        total: paginated ? pagination.totalPages : Math.ceil(sortedData.length / pageSize),
        value: page,
        onChange: setPage,
        color: "#518DC8"
      }
    )
  ] });
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/utils/handle-control-key-down.mjs
function getNextIndex({ direction, levelIndex, rowIndex, cellIndex, size }) {
  switch (direction) {
    case "up":
      if (levelIndex === 0 && rowIndex === 0) {
        return null;
      }
      if (rowIndex === 0) {
        return {
          levelIndex: levelIndex - 1,
          rowIndex: cellIndex <= size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1 ? size[levelIndex - 1].length - 1 : size[levelIndex - 1].length - 2,
          cellIndex
        };
      }
      return {
        levelIndex,
        rowIndex: rowIndex - 1,
        cellIndex
      };
    case "down":
      if (rowIndex === size[levelIndex].length - 1) {
        return {
          levelIndex: levelIndex + 1,
          rowIndex: 0,
          cellIndex
        };
      }
      if (rowIndex === size[levelIndex].length - 2 && cellIndex >= size[levelIndex][size[levelIndex].length - 1]) {
        return {
          levelIndex: levelIndex + 1,
          rowIndex: 0,
          cellIndex
        };
      }
      return {
        levelIndex,
        rowIndex: rowIndex + 1,
        cellIndex
      };
    case "left":
      if (levelIndex === 0 && rowIndex === 0 && cellIndex === 0) {
        return null;
      }
      if (rowIndex === 0 && cellIndex === 0) {
        return {
          levelIndex: levelIndex - 1,
          rowIndex: size[levelIndex - 1].length - 1,
          cellIndex: size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1
        };
      }
      if (cellIndex === 0) {
        return {
          levelIndex,
          rowIndex: rowIndex - 1,
          cellIndex: size[levelIndex][rowIndex - 1] - 1
        };
      }
      return {
        levelIndex,
        rowIndex,
        cellIndex: cellIndex - 1
      };
    case "right":
      if (rowIndex === size[levelIndex].length - 1 && cellIndex === size[levelIndex][rowIndex] - 1) {
        return {
          levelIndex: levelIndex + 1,
          rowIndex: 0,
          cellIndex: 0
        };
      }
      if (cellIndex === size[levelIndex][rowIndex] - 1) {
        return {
          levelIndex,
          rowIndex: rowIndex + 1,
          cellIndex: 0
        };
      }
      return {
        levelIndex,
        rowIndex,
        cellIndex: cellIndex + 1
      };
    default:
      return { levelIndex, rowIndex, cellIndex };
  }
}
function focusOnNextFocusableControl({
  controlsRef,
  direction,
  levelIndex,
  rowIndex,
  cellIndex,
  size
}) {
  const nextIndex = getNextIndex({ direction, size, rowIndex, cellIndex, levelIndex });
  if (!nextIndex) {
    return;
  }
  const controlToFocus = controlsRef.current?.[nextIndex.levelIndex]?.[nextIndex.rowIndex]?.[nextIndex.cellIndex];
  if (!controlToFocus) {
    return;
  }
  if (controlToFocus.disabled || controlToFocus.getAttribute("data-hidden") || controlToFocus.getAttribute("data-outside")) {
    focusOnNextFocusableControl({
      controlsRef,
      direction,
      levelIndex: nextIndex.levelIndex,
      cellIndex: nextIndex.cellIndex,
      rowIndex: nextIndex.rowIndex,
      size
    });
  } else {
    controlToFocus.focus();
  }
}
function getDirection(key2) {
  switch (key2) {
    case "ArrowDown":
      return "down";
    case "ArrowUp":
      return "up";
    case "ArrowRight":
      return "right";
    case "ArrowLeft":
      return "left";
    default:
      return null;
  }
}
function getControlsSize(controlsRef) {
  return controlsRef.current?.map((column) => column.map((row) => row.length));
}
function handleControlKeyDown({
  controlsRef,
  levelIndex,
  rowIndex,
  cellIndex,
  event
}) {
  const direction = getDirection(event.key);
  if (direction) {
    event.preventDefault();
    const size = getControlsSize(controlsRef);
    focusOnNextFocusableControl({
      controlsRef,
      direction,
      levelIndex,
      rowIndex,
      cellIndex,
      size
    });
  }
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/utils/assign-time/assign-time.mjs
function assignTime(originalDate, resultDate) {
  if (!originalDate || !resultDate) {
    return resultDate;
  }
  const hours = originalDate.getHours();
  const minutes = originalDate.getMinutes();
  const seconds2 = originalDate.getSeconds();
  const ms = originalDate.getMilliseconds();
  const result = new Date(resultDate);
  result.setHours(hours);
  result.setMinutes(minutes);
  result.setSeconds(seconds2);
  result.setMilliseconds(ms);
  return result;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/utils/shift-timezone.mjs
var import_dayjs2 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/utils/get-timezone-offset.mjs
var import_dayjs = __toESM(require_dayjs_min(), 1);
var import_timezone = __toESM(require_timezone(), 1);
var import_utc = __toESM(require_utc(), 1);
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_timezone.default);
function getTimezoneOffset(date2, timezone) {
  if (timezone) {
    return (0, import_dayjs.default)(date2).tz(timezone).utcOffset() + date2.getTimezoneOffset();
  }
  return 0;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/utils/shift-timezone.mjs
var updateTimezone = (date2, timezone, direction) => {
  if (!date2) {
    return null;
  }
  if (!timezone) {
    return date2;
  }
  let offset = getTimezoneOffset(date2, timezone);
  if (direction === "remove") {
    offset *= -1;
  }
  return (0, import_dayjs2.default)(date2).add(offset, "minutes").toDate();
};
function shiftTimezone(direction, date2, timezone, disabled) {
  if (disabled || !date2) {
    return date2;
  }
  if (Array.isArray(date2)) {
    return date2.map((d) => updateTimezone(d, timezone, direction));
  }
  return updateTimezone(date2, timezone, direction);
}
var DATES_PROVIDER_DEFAULT_SETTINGS = {
  locale: "en",
  timezone: null,
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "\u2013",
  consistentWeeks: false
};
var DatesProviderContext = createContext(DATES_PROVIDER_DEFAULT_SETTINGS);
function useDatesContext() {
  const ctx = useContext(DatesProviderContext);
  const getLocale = useCallback((input) => input || ctx.locale, [ctx.locale]);
  const getTimezone = useCallback(
    (input) => input || ctx.timezone || void 0,
    [ctx.timezone]
  );
  const getFirstDayOfWeek = useCallback(
    (input) => typeof input === "number" ? input : ctx.firstDayOfWeek,
    [ctx.firstDayOfWeek]
  );
  const getWeekendDays = useCallback(
    (input) => Array.isArray(input) ? input : ctx.weekendDays,
    [ctx.weekendDays]
  );
  const getLabelSeparator = useCallback(
    (input) => typeof input === "string" ? input : ctx.labelSeparator,
    [ctx.labelSeparator]
  );
  return {
    ...ctx,
    getLocale,
    getTimezone,
    getFirstDayOfWeek,
    getWeekendDays,
    getLabelSeparator
  };
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/HiddenDatesInput/HiddenDatesInput.mjs
__toESM(require_dayjs_min(), 1);
function formatValue(value2, type) {
  const ctx = useDatesContext();
  const formatDateWithTimezone = (date2) => {
    return shiftTimezone("remove", date2, ctx.getTimezone()).toISOString();
  };
  if (type === "range" && Array.isArray(value2)) {
    const [startDate, endDate] = value2;
    if (!startDate) {
      return "";
    }
    if (!endDate) {
      return `${formatDateWithTimezone(startDate)} \u2013`;
    }
    return `${formatDateWithTimezone(startDate)} \u2013 ${formatDateWithTimezone(endDate)}`;
  }
  if (type === "multiple" && Array.isArray(value2)) {
    return value2.map((date2) => date2 && formatDateWithTimezone(date2)).filter(Boolean).join(", ");
  }
  if (!Array.isArray(value2) && value2) {
    return formatDateWithTimezone(value2);
  }
  return "";
}
function HiddenDatesInput({ value: value2, type, name: name2, form }) {
  return /* @__PURE__ */ jsx("input", { type: "hidden", value: formatValue(value2, type), name: name2, form });
}
HiddenDatesInput.displayName = "@mantine/dates/HiddenDatesInput";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Day/Day.mjs
var import_dayjs4 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Day/Day.module.css.mjs
var classes = { "day": "m_396ce5cb" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Day/Day.mjs
var defaultProps = {};
var varsResolver = createVarsResolver((_, { size }) => ({
  day: {
    "--day-size": getSize(size, "day-size")
  }
}));
var Day = factory((_props, ref) => {
  const props = useProps("Day", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    date: date2,
    disabled,
    __staticSelector,
    weekend,
    outside,
    selected,
    renderDay,
    inRange,
    firstInRange,
    lastInRange,
    hidden,
    static: isStatic,
    highlightToday,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "Day",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "day"
  });
  const ctx = useDatesContext();
  return /* @__PURE__ */ jsx(
    UnstyledButton,
    {
      ...getStyles("day", { style: hidden ? { display: "none" } : void 0 }),
      component: isStatic ? "div" : "button",
      ref,
      disabled,
      "data-today": (0, import_dayjs4.default)(date2).isSame(shiftTimezone("add", /* @__PURE__ */ new Date(), ctx.getTimezone()), "day") || void 0,
      "data-hidden": hidden || void 0,
      "data-highlight-today": highlightToday || void 0,
      "data-disabled": disabled || void 0,
      "data-weekend": !disabled && !outside && weekend || void 0,
      "data-outside": !disabled && outside || void 0,
      "data-selected": !disabled && selected || void 0,
      "data-in-range": inRange && !disabled || void 0,
      "data-first-in-range": firstInRange && !disabled || void 0,
      "data-last-in-range": lastInRange && !disabled || void 0,
      "data-static": isStatic || void 0,
      unstyled,
      ...others,
      children: renderDay?.(date2) || (0, import_dayjs4.default)(date2).date()
    }
  );
});
Day.classes = classes;
Day.displayName = "@mantine/dates/Day";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/WeekdaysRow/get-weekdays-names/get-weekdays-names.mjs
var import_dayjs5 = __toESM(require_dayjs_min(), 1);
function getWeekdayNames({
  locale: locale3,
  format: format2 = "dd",
  firstDayOfWeek = 1
}) {
  const baseDate = (0, import_dayjs5.default)().day(firstDayOfWeek);
  const labels = [];
  for (let i = 0; i < 7; i += 1) {
    if (typeof format2 === "string") {
      labels.push((0, import_dayjs5.default)(baseDate).add(i, "days").locale(locale3).format(format2));
    } else {
      labels.push(format2((0, import_dayjs5.default)(baseDate).add(i, "days").toDate()));
    }
  }
  return labels;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/WeekdaysRow/WeekdaysRow.module.css.mjs
var classes2 = { "weekday": "m_18a3eca" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/WeekdaysRow/WeekdaysRow.mjs
var defaultProps2 = {};
var varsResolver2 = createVarsResolver((_, { size }) => ({
  weekdaysRow: {
    "--wr-fz": getFontSize(size),
    "--wr-spacing": getSpacing(size)
  }
}));
var WeekdaysRow = factory((_props, ref) => {
  const props = useProps("WeekdaysRow", defaultProps2, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    locale: locale3,
    firstDayOfWeek,
    weekdayFormat,
    cellComponent: CellComponent = "th",
    __staticSelector,
    withWeekNumbers,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "WeekdaysRow",
    classes: classes2,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: varsResolver2,
    rootSelector: "weekdaysRow"
  });
  const ctx = useDatesContext();
  const weekdays = getWeekdayNames({
    locale: ctx.getLocale(locale3),
    format: weekdayFormat,
    firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek)
  }).map((weekday, index2) => /* @__PURE__ */ jsx(CellComponent, { ...getStyles("weekday"), children: weekday }, index2));
  return /* @__PURE__ */ jsxs(Box, { component: "tr", ref, ...getStyles("weekdaysRow"), ...others, children: [
    withWeekNumbers && /* @__PURE__ */ jsx(CellComponent, { ...getStyles("weekday"), children: "#" }),
    weekdays
  ] });
});
WeekdaysRow.classes = classes2;
WeekdaysRow.displayName = "@mantine/dates/WeekdaysRow";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-end-of-week/get-end-of-week.mjs
var import_dayjs6 = __toESM(require_dayjs_min(), 1);
function getEndOfWeek(date2, firstDayOfWeek = 1) {
  let value2 = (0, import_dayjs6.default)(date2);
  const lastDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
  while (value2.day() !== lastDayOfWeek) {
    value2 = value2.add(1, "day");
  }
  return value2.toDate();
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-start-of-week/get-start-of-week.mjs
var import_dayjs7 = __toESM(require_dayjs_min(), 1);
function getStartOfWeek(date2, firstDayOfWeek = 1) {
  let value2 = (0, import_dayjs7.default)(date2);
  while (value2.day() !== firstDayOfWeek) {
    value2 = value2.subtract(1, "day");
  }
  return value2.toDate();
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-month-days/get-month-days.mjs
var import_dayjs8 = __toESM(require_dayjs_min(), 1);
function getMonthDays({
  month,
  firstDayOfWeek = 1,
  consistentWeeks
}) {
  const day = (0, import_dayjs8.default)(month).subtract((0, import_dayjs8.default)(month).date() - 1, "day");
  const start = (0, import_dayjs8.default)(day).startOf("day");
  const startOfMonth = start.toDate();
  const endOfMonth = start.add(+start.daysInMonth() - 1, "day").toDate();
  const endDate = getEndOfWeek(endOfMonth, firstDayOfWeek);
  const date2 = getStartOfWeek(startOfMonth, firstDayOfWeek);
  const weeks = [];
  while (date2 <= endDate) {
    const days = [];
    for (let i = 0; i < 7; i += 1) {
      days.push(new Date(date2));
      date2.setDate(date2.getDate() + 1);
    }
    weeks.push(days);
  }
  if (consistentWeeks && weeks.length < 6) {
    const lastWeek = weeks[weeks.length - 1];
    const lastDay = lastWeek[lastWeek.length - 1];
    const nextDay = new Date(lastDay);
    nextDay.setDate(nextDay.getDate() + 1);
    while (weeks.length < 6) {
      const days = [];
      for (let i = 0; i < 7; i += 1) {
        days.push(new Date(nextDay));
        nextDay.setDate(nextDay.getDate() + 1);
      }
      weeks.push(days);
    }
  }
  return weeks;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/Month.mjs
var import_dayjs13 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-date-in-tab-order/get-date-in-tab-order.mjs
var import_dayjs11 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/is-after-min-date/is-after-min-date.mjs
var import_dayjs9 = __toESM(require_dayjs_min(), 1);
function isAfterMinDate(date2, minDate) {
  return minDate instanceof Date ? (0, import_dayjs9.default)(date2).isAfter((0, import_dayjs9.default)(minDate).subtract(1, "day"), "day") : true;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/is-before-max-date/is-before-max-date.mjs
var import_dayjs10 = __toESM(require_dayjs_min(), 1);
function isBeforeMaxDate(date2, maxDate) {
  return maxDate instanceof Date ? (0, import_dayjs10.default)(date2).isBefore((0, import_dayjs10.default)(maxDate).add(1, "day"), "day") : true;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-date-in-tab-order/get-date-in-tab-order.mjs
function getDateInTabOrder(dates, minDate, maxDate, getDateControlProps, excludeDate, hideOutsideDates, month) {
  const enabledDates = dates.flat().filter(
    (date2) => isBeforeMaxDate(date2, maxDate) && isAfterMinDate(date2, minDate) && !excludeDate?.(date2) && !getDateControlProps?.(date2)?.disabled && (!hideOutsideDates || (0, import_dayjs11.default)(date2).isSame((0, import_dayjs11.default)(month), "month"))
  );
  const selectedDate = enabledDates.find((date2) => getDateControlProps?.(date2)?.selected);
  if (selectedDate) {
    return selectedDate;
  }
  const currentDate = enabledDates.find((date2) => (0, import_dayjs11.default)().isSame(date2, "date"));
  if (currentDate) {
    return currentDate;
  }
  return enabledDates[0];
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/get-week-number/get-week-number.mjs
var import_dayjs12 = __toESM(require_dayjs_min(), 1);
var import_isoWeek = __toESM(require_isoWeek(), 1);
import_dayjs12.default.extend(import_isoWeek.default);
function getWeekNumber(week) {
  const monday = week.find((date2) => (0, import_dayjs12.default)(date2).day() === 1);
  return (0, import_dayjs12.default)(monday).isoWeek();
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/Month.module.css.mjs
var classes3 = { "month": "m_cc9820d3", "monthCell": "m_8f457cd5", "weekNumber": "m_6cff9dea" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Month/Month.mjs
var defaultProps3 = {
  withCellSpacing: true
};
var varsResolver3 = createVarsResolver((_, { size }) => ({
  weekNumber: {
    "--wn-fz": getFontSize(size),
    "--wn-size": getSize(size, "wn-size")
  }
}));
var Month = factory((_props, ref) => {
  const props = useProps("Month", defaultProps3, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    __staticSelector,
    locale: locale3,
    firstDayOfWeek,
    weekdayFormat,
    month,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    static: isStatic,
    __getDayRef,
    __onDayKeyDown,
    __onDayClick,
    __onDayMouseEnter,
    __preventFocus,
    __stopPropagation,
    withCellSpacing,
    size,
    highlightToday,
    withWeekNumbers,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "Month",
    classes: classes3,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: varsResolver3,
    rootSelector: "month"
  });
  const ctx = useDatesContext();
  const dates = getMonthDays({
    month,
    firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek),
    consistentWeeks: ctx.consistentWeeks
  });
  const dateInTabOrder = getDateInTabOrder(
    dates,
    minDate,
    maxDate,
    getDayProps,
    excludeDate,
    hideOutsideDates,
    month
  );
  const { resolvedClassNames, resolvedStyles } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  const rows = dates.map((row, rowIndex) => {
    const cells = row.map((date2, cellIndex) => {
      const outside = !(0, import_dayjs13.default)(date2).isSame((0, import_dayjs13.default)(month), "month");
      const ariaLabel = getDayAriaLabel?.(date2) || (0, import_dayjs13.default)(date2).locale(locale3 || ctx.locale).format("D MMMM YYYY");
      const dayProps = getDayProps?.(date2);
      const isDateInTabOrder = (0, import_dayjs13.default)(date2).isSame(dateInTabOrder, "date");
      return /* @__PURE__ */ jsx(
        "td",
        {
          ...getStyles("monthCell"),
          "data-with-spacing": withCellSpacing || void 0,
          children: /* @__PURE__ */ jsx(
            Day,
            {
              __staticSelector: __staticSelector || "Month",
              classNames: resolvedClassNames,
              styles: resolvedStyles,
              unstyled,
              "data-mantine-stop-propagation": __stopPropagation || void 0,
              highlightToday,
              renderDay,
              date: date2,
              size,
              weekend: ctx.getWeekendDays(weekendDays).includes(date2.getDay()),
              outside,
              hidden: hideOutsideDates ? outside : false,
              "aria-label": ariaLabel,
              static: isStatic,
              disabled: excludeDate?.(date2) || !isBeforeMaxDate(date2, maxDate) || !isAfterMinDate(date2, minDate),
              ref: (node) => __getDayRef?.(rowIndex, cellIndex, node),
              ...dayProps,
              onKeyDown: (event) => {
                dayProps?.onKeyDown?.(event);
                __onDayKeyDown?.(event, { rowIndex, cellIndex, date: date2 });
              },
              onMouseEnter: (event) => {
                dayProps?.onMouseEnter?.(event);
                __onDayMouseEnter?.(event, date2);
              },
              onClick: (event) => {
                dayProps?.onClick?.(event);
                __onDayClick?.(event, date2);
              },
              onMouseDown: (event) => {
                dayProps?.onMouseDown?.(event);
                __preventFocus && event.preventDefault();
              },
              tabIndex: __preventFocus || !isDateInTabOrder ? -1 : 0
            }
          )
        },
        date2.toString()
      );
    });
    return /* @__PURE__ */ jsxs("tr", { ...getStyles("monthRow"), children: [
      withWeekNumbers && /* @__PURE__ */ jsx("td", { ...getStyles("weekNumber"), children: getWeekNumber(row) }),
      cells
    ] }, rowIndex);
  });
  return /* @__PURE__ */ jsxs(Box, { component: "table", ...getStyles("month"), size, ref, ...others, children: [
    !hideWeekdays && /* @__PURE__ */ jsx("thead", { ...getStyles("monthThead"), children: /* @__PURE__ */ jsx(
      WeekdaysRow,
      {
        __staticSelector: __staticSelector || "Month",
        locale: locale3,
        firstDayOfWeek,
        weekdayFormat,
        size,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled,
        withWeekNumbers
      }
    ) }),
    /* @__PURE__ */ jsx("tbody", { ...getStyles("monthTbody"), children: rows })
  ] });
});
Month.classes = classes3;
Month.displayName = "@mantine/dates/Month";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/PickerControl/PickerControl.module.css.mjs
var classes4 = { "pickerControl": "m_dc6a3c71" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/PickerControl/PickerControl.mjs
var defaultProps4 = {};
var varsResolver4 = createVarsResolver((_, { size }) => ({
  pickerControl: {
    "--dpc-fz": getFontSize(size),
    "--dpc-size": getSize(size, "dpc-size")
  }
}));
var PickerControl = factory((_props, ref) => {
  const props = useProps("PickerControl", defaultProps4, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    firstInRange,
    lastInRange,
    inRange,
    __staticSelector,
    selected,
    disabled,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "PickerControl",
    classes: classes4,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: varsResolver4,
    rootSelector: "pickerControl"
  });
  return /* @__PURE__ */ jsx(
    UnstyledButton,
    {
      ...getStyles("pickerControl"),
      ref,
      unstyled,
      "data-picker-control": true,
      "data-selected": selected && !disabled || void 0,
      "data-disabled": disabled || void 0,
      "data-in-range": inRange && !disabled && !selected || void 0,
      "data-first-in-range": firstInRange && !disabled || void 0,
      "data-last-in-range": lastInRange && !disabled || void 0,
      disabled,
      ...others
    }
  );
});
PickerControl.classes = classes4;
PickerControl.displayName = "@mantine/dates/PickerControl";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/YearsList.mjs
var import_dayjs16 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/get-year-in-tab-order/get-year-in-tab-order.mjs
var import_dayjs15 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/is-year-disabled/is-year-disabled.mjs
var import_dayjs14 = __toESM(require_dayjs_min(), 1);
function isYearDisabled(year, minDate, maxDate) {
  if (!minDate && !maxDate) {
    return false;
  }
  if (minDate && (0, import_dayjs14.default)(year).isBefore(minDate, "year")) {
    return true;
  }
  if (maxDate && (0, import_dayjs14.default)(year).isAfter(maxDate, "year")) {
    return true;
  }
  return false;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/get-year-in-tab-order/get-year-in-tab-order.mjs
function getYearInTabOrder(years, minDate, maxDate, getYearControlProps) {
  const enabledYears = years.flat().filter(
    (year) => !isYearDisabled(year, minDate, maxDate) && !getYearControlProps?.(year)?.disabled
  );
  const selectedYear = enabledYears.find((year) => getYearControlProps?.(year)?.selected);
  if (selectedYear) {
    return selectedYear;
  }
  const currentYear = enabledYears.find((year) => (0, import_dayjs15.default)().isSame(year, "year"));
  if (currentYear) {
    return currentYear;
  }
  return enabledYears[0];
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/get-years-data/get-years-data.mjs
function getYearsData(decade) {
  const year = decade.getFullYear();
  const rounded = year - year % 10;
  let currentYearIndex = 0;
  const results = [[], [], [], []];
  for (let i = 0; i < 4; i += 1) {
    const max4 = i === 3 ? 1 : 3;
    for (let j = 0; j < max4; j += 1) {
      results[i].push(new Date(rounded + currentYearIndex, 0));
      currentYearIndex += 1;
    }
  }
  return results;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/YearsList.module.css.mjs
var classes5 = { "yearsList": "m_9206547b", "yearsListCell": "m_c5a19c7d" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearsList/YearsList.mjs
var defaultProps5 = {
  yearsListFormat: "YYYY",
  withCellSpacing: true
};
var YearsList = factory((_props, ref) => {
  const props = useProps("YearsList", defaultProps5, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    decade,
    yearsListFormat,
    locale: locale3,
    minDate,
    maxDate,
    getYearControlProps,
    __staticSelector,
    __getControlRef,
    __onControlKeyDown,
    __onControlClick,
    __onControlMouseEnter,
    __preventFocus,
    __stopPropagation,
    withCellSpacing,
    size,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "YearsList",
    classes: classes5,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "yearsList"
  });
  const ctx = useDatesContext();
  const years = getYearsData(decade);
  const yearInTabOrder = getYearInTabOrder(years, minDate, maxDate, getYearControlProps);
  const rows = years.map((yearsRow, rowIndex) => {
    const cells = yearsRow.map((year, cellIndex) => {
      const controlProps = getYearControlProps?.(year);
      const isYearInTabOrder = (0, import_dayjs16.default)(year).isSame(yearInTabOrder, "year");
      return /* @__PURE__ */ jsx(
        "td",
        {
          ...getStyles("yearsListCell"),
          "data-with-spacing": withCellSpacing || void 0,
          children: /* @__PURE__ */ jsx(
            PickerControl,
            {
              ...getStyles("yearsListControl"),
              size,
              unstyled,
              "data-mantine-stop-propagation": __stopPropagation || void 0,
              disabled: isYearDisabled(year, minDate, maxDate),
              ref: (node) => __getControlRef?.(rowIndex, cellIndex, node),
              ...controlProps,
              onKeyDown: (event) => {
                controlProps?.onKeyDown?.(event);
                __onControlKeyDown?.(event, { rowIndex, cellIndex, date: year });
              },
              onClick: (event) => {
                controlProps?.onClick?.(event);
                __onControlClick?.(event, year);
              },
              onMouseEnter: (event) => {
                controlProps?.onMouseEnter?.(event);
                __onControlMouseEnter?.(event, year);
              },
              onMouseDown: (event) => {
                controlProps?.onMouseDown?.(event);
                __preventFocus && event.preventDefault();
              },
              tabIndex: __preventFocus || !isYearInTabOrder ? -1 : 0,
              children: (0, import_dayjs16.default)(year).locale(ctx.getLocale(locale3)).format(yearsListFormat)
            }
          )
        },
        cellIndex
      );
    });
    return /* @__PURE__ */ jsx("tr", { ...getStyles("yearsListRow"), children: cells }, rowIndex);
  });
  return /* @__PURE__ */ jsx(Box, { component: "table", ref, size, ...getStyles("yearsList"), ...others, children: /* @__PURE__ */ jsx("tbody", { children: rows }) });
});
YearsList.classes = classes5;
YearsList.displayName = "@mantine/dates/YearsList";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/MonthsList.mjs
var import_dayjs20 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/get-month-in-tab-order/get-month-in-tab-order.mjs
var import_dayjs18 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/is-month-disabled/is-month-disabled.mjs
var import_dayjs17 = __toESM(require_dayjs_min(), 1);
function isMonthDisabled(month, minDate, maxDate) {
  if (!minDate && !maxDate) {
    return false;
  }
  if (minDate && (0, import_dayjs17.default)(month).isBefore(minDate, "month")) {
    return true;
  }
  if (maxDate && (0, import_dayjs17.default)(month).isAfter(maxDate, "month")) {
    return true;
  }
  return false;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/get-month-in-tab-order/get-month-in-tab-order.mjs
function getMonthInTabOrder(months, minDate, maxDate, getMonthControlProps) {
  const enabledMonths = months.flat().filter(
    (month) => !isMonthDisabled(month, minDate, maxDate) && !getMonthControlProps?.(month)?.disabled
  );
  const selectedMonth = enabledMonths.find((month) => getMonthControlProps?.(month)?.selected);
  if (selectedMonth) {
    return selectedMonth;
  }
  const currentMonth = enabledMonths.find((month) => (0, import_dayjs18.default)().isSame(month, "month"));
  if (currentMonth) {
    return currentMonth;
  }
  return enabledMonths[0];
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/get-months-data/get-months-data.mjs
var import_dayjs19 = __toESM(require_dayjs_min(), 1);
function getMonthsData(year) {
  const startOfYear = (0, import_dayjs19.default)(year).startOf("year").toDate();
  const results = [[], [], [], []];
  let currentMonthIndex = 0;
  for (let i = 0; i < 4; i += 1) {
    for (let j = 0; j < 3; j += 1) {
      results[i].push((0, import_dayjs19.default)(startOfYear).add(currentMonthIndex, "months").toDate());
      currentMonthIndex += 1;
    }
  }
  return results;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/MonthsList.module.css.mjs
var classes6 = { "monthsList": "m_2a6c32d", "monthsListCell": "m_fe27622f" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthsList/MonthsList.mjs
var defaultProps6 = {
  monthsListFormat: "MMM",
  withCellSpacing: true
};
var MonthsList = factory((_props, ref) => {
  const props = useProps("MonthsList", defaultProps6, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    __staticSelector,
    year,
    monthsListFormat,
    locale: locale3,
    minDate,
    maxDate,
    getMonthControlProps,
    __getControlRef,
    __onControlKeyDown,
    __onControlClick,
    __onControlMouseEnter,
    __preventFocus,
    __stopPropagation,
    withCellSpacing,
    size,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "MonthsList",
    classes: classes6,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "monthsList"
  });
  const ctx = useDatesContext();
  const months = getMonthsData(year);
  const monthInTabOrder = getMonthInTabOrder(months, minDate, maxDate, getMonthControlProps);
  const rows = months.map((monthsRow, rowIndex) => {
    const cells = monthsRow.map((month, cellIndex) => {
      const controlProps = getMonthControlProps?.(month);
      const isMonthInTabOrder = (0, import_dayjs20.default)(month).isSame(monthInTabOrder, "month");
      return /* @__PURE__ */ jsx(
        "td",
        {
          ...getStyles("monthsListCell"),
          "data-with-spacing": withCellSpacing || void 0,
          children: /* @__PURE__ */ jsx(
            PickerControl,
            {
              ...getStyles("monthsListControl"),
              size,
              unstyled,
              __staticSelector: __staticSelector || "MonthsList",
              "data-mantine-stop-propagation": __stopPropagation || void 0,
              disabled: isMonthDisabled(month, minDate, maxDate),
              ref: (node) => __getControlRef?.(rowIndex, cellIndex, node),
              ...controlProps,
              onKeyDown: (event) => {
                controlProps?.onKeyDown?.(event);
                __onControlKeyDown?.(event, { rowIndex, cellIndex, date: month });
              },
              onClick: (event) => {
                controlProps?.onClick?.(event);
                __onControlClick?.(event, month);
              },
              onMouseEnter: (event) => {
                controlProps?.onMouseEnter?.(event);
                __onControlMouseEnter?.(event, month);
              },
              onMouseDown: (event) => {
                controlProps?.onMouseDown?.(event);
                __preventFocus && event.preventDefault();
              },
              tabIndex: __preventFocus || !isMonthInTabOrder ? -1 : 0,
              children: (0, import_dayjs20.default)(month).locale(ctx.getLocale(locale3)).format(monthsListFormat)
            }
          )
        },
        cellIndex
      );
    });
    return /* @__PURE__ */ jsx("tr", { ...getStyles("monthsListRow"), children: cells }, rowIndex);
  });
  return /* @__PURE__ */ jsx(Box, { component: "table", ref, size, ...getStyles("monthsList"), ...others, children: /* @__PURE__ */ jsx("tbody", { children: rows }) });
});
MonthsList.classes = classes6;
MonthsList.displayName = "@mantine/dates/MonthsList";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/CalendarHeader/CalendarHeader.module.css.mjs
var classes7 = { "calendarHeader": "m_730a79ed", "calendarHeaderLevel": "m_f6645d97", "calendarHeaderControl": "m_2351eeb0", "calendarHeaderControlIcon": "m_367dc749" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/CalendarHeader/CalendarHeader.mjs
var defaultProps7 = {
  nextDisabled: false,
  previousDisabled: false,
  hasNextLevel: true,
  withNext: true,
  withPrevious: true
};
var varsResolver5 = createVarsResolver((_, { size }) => ({
  calendarHeader: {
    "--dch-control-size": getSize(size, "dch-control-size"),
    "--dch-fz": getFontSize(size)
  }
}));
var CalendarHeader = factory((_props, ref) => {
  const props = useProps("CalendarHeader", defaultProps7, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    label,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    __staticSelector,
    __preventFocus,
    __stopPropagation,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "CalendarHeader",
    classes: classes7,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: varsResolver5,
    rootSelector: "calendarHeader"
  });
  const preventFocus = __preventFocus ? (event) => event.preventDefault() : void 0;
  return /* @__PURE__ */ jsxs(Box, { ...getStyles("calendarHeader"), ref, ...others, children: [
    withPrevious && /* @__PURE__ */ jsx(
      UnstyledButton,
      {
        ...getStyles("calendarHeaderControl"),
        "data-direction": "previous",
        "aria-label": previousLabel,
        onClick: onPrevious,
        unstyled,
        onMouseDown: preventFocus,
        disabled: previousDisabled,
        "data-disabled": previousDisabled || void 0,
        tabIndex: __preventFocus || previousDisabled ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0,
        children: previousIcon || /* @__PURE__ */ jsx(
          AccordionChevron,
          {
            ...getStyles("calendarHeaderControlIcon"),
            "data-direction": "previous",
            size: "45%"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      UnstyledButton,
      {
        component: hasNextLevel ? "button" : "div",
        ...getStyles("calendarHeaderLevel"),
        onClick: hasNextLevel ? onLevelClick : void 0,
        unstyled,
        onMouseDown: hasNextLevel ? preventFocus : void 0,
        disabled: !hasNextLevel,
        "data-static": !hasNextLevel || void 0,
        "aria-label": levelControlAriaLabel,
        tabIndex: __preventFocus || !hasNextLevel ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0,
        children: label
      }
    ),
    withNext && /* @__PURE__ */ jsx(
      UnstyledButton,
      {
        ...getStyles("calendarHeaderControl"),
        "data-direction": "next",
        "aria-label": nextLabel,
        onClick: onNext,
        unstyled,
        onMouseDown: preventFocus,
        disabled: nextDisabled,
        "data-disabled": nextDisabled || void 0,
        tabIndex: __preventFocus || nextDisabled ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0,
        children: nextIcon || /* @__PURE__ */ jsx(
          AccordionChevron,
          {
            ...getStyles("calendarHeaderControlIcon"),
            "data-direction": "next",
            size: "45%"
          }
        )
      }
    )
  ] });
});
CalendarHeader.classes = classes7;
CalendarHeader.displayName = "@mantine/dates/CalendarHeader";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DecadeLevel/DecadeLevel.mjs
var import_dayjs21 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DecadeLevel/get-decade-range/get-decade-range.mjs
function getDecadeRange(decade) {
  const years = getYearsData(decade);
  return [years[0][0], years[3][0]];
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DecadeLevel/DecadeLevel.mjs
var defaultProps8 = {
  decadeLabelFormat: "YYYY"
};
var DecadeLevel = factory((_props, ref) => {
  const props = useProps("DecadeLevel", defaultProps8, _props);
  const {
    // YearsList settings
    decade,
    locale: locale3,
    minDate,
    maxDate,
    yearsListFormat,
    getYearControlProps,
    __getControlRef,
    __onControlKeyDown,
    __onControlClick,
    __onControlMouseEnter,
    withCellSpacing,
    // CalendarHeader settings
    __preventFocus,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    nextDisabled,
    previousDisabled,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    // Other props
    decadeLabelFormat,
    classNames,
    styles,
    unstyled,
    __staticSelector,
    __stopPropagation,
    size,
    ...others
  } = props;
  const ctx = useDatesContext();
  const [startOfDecade, endOfDecade] = getDecadeRange(decade);
  const stylesApiProps = {
    __staticSelector: __staticSelector || "DecadeLevel",
    classNames,
    styles,
    unstyled,
    size
  };
  const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, import_dayjs21.default)(endOfDecade).endOf("year").isBefore(maxDate) : false;
  const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, import_dayjs21.default)(startOfDecade).startOf("year").isAfter(minDate) : false;
  const formatDecade = (date2, format2) => (0, import_dayjs21.default)(date2).locale(locale3 || ctx.locale).format(format2);
  return /* @__PURE__ */ jsxs(Box, { "data-decade-level": true, size, ref, ...others, children: [
    /* @__PURE__ */ jsx(
      CalendarHeader,
      {
        label: typeof decadeLabelFormat === "function" ? decadeLabelFormat(startOfDecade, endOfDecade) : `${formatDecade(startOfDecade, decadeLabelFormat)} \u2013 ${formatDecade(
          endOfDecade,
          decadeLabelFormat
        )}`,
        __preventFocus,
        __stopPropagation,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel: false,
        levelControlAriaLabel,
        withNext,
        withPrevious,
        ...stylesApiProps
      }
    ),
    /* @__PURE__ */ jsx(
      YearsList,
      {
        decade,
        locale: locale3,
        minDate,
        maxDate,
        yearsListFormat,
        getYearControlProps,
        __getControlRef,
        __onControlKeyDown,
        __onControlClick,
        __onControlMouseEnter,
        __preventFocus,
        __stopPropagation,
        withCellSpacing,
        ...stylesApiProps
      }
    )
  ] });
});
DecadeLevel.classes = { ...YearsList.classes, ...CalendarHeader.classes };
DecadeLevel.displayName = "@mantine/dates/DecadeLevel";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearLevel/YearLevel.mjs
var import_dayjs22 = __toESM(require_dayjs_min(), 1);
var defaultProps9 = {
  yearLabelFormat: "YYYY"
};
var YearLevel = factory((_props, ref) => {
  const props = useProps("YearLevel", defaultProps9, _props);
  const {
    // MonthsList settings
    year,
    locale: locale3,
    minDate,
    maxDate,
    monthsListFormat,
    getMonthControlProps,
    __getControlRef,
    __onControlKeyDown,
    __onControlClick,
    __onControlMouseEnter,
    withCellSpacing,
    // CalendarHeader settings
    __preventFocus,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    // Other props
    yearLabelFormat,
    __staticSelector,
    __stopPropagation,
    size,
    classNames,
    styles,
    unstyled,
    ...others
  } = props;
  const ctx = useDatesContext();
  const stylesApiProps = {
    __staticSelector: __staticSelector || "YearLevel",
    classNames,
    styles,
    unstyled,
    size
  };
  const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, import_dayjs22.default)(year).endOf("year").isBefore(maxDate) : false;
  const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, import_dayjs22.default)(year).startOf("year").isAfter(minDate) : false;
  return /* @__PURE__ */ jsxs(Box, { "data-year-level": true, size, ref, ...others, children: [
    /* @__PURE__ */ jsx(
      CalendarHeader,
      {
        label: typeof yearLabelFormat === "function" ? yearLabelFormat(year) : (0, import_dayjs22.default)(year).locale(locale3 || ctx.locale).format(yearLabelFormat),
        __preventFocus,
        __stopPropagation,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel,
        levelControlAriaLabel,
        withNext,
        withPrevious,
        ...stylesApiProps
      }
    ),
    /* @__PURE__ */ jsx(
      MonthsList,
      {
        year,
        locale: locale3,
        minDate,
        maxDate,
        monthsListFormat,
        getMonthControlProps,
        __getControlRef,
        __onControlKeyDown,
        __onControlClick,
        __onControlMouseEnter,
        __preventFocus,
        __stopPropagation,
        withCellSpacing,
        ...stylesApiProps
      }
    )
  ] });
});
YearLevel.classes = { ...CalendarHeader.classes, ...MonthsList.classes };
YearLevel.displayName = "@mantine/dates/YearLevel";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthLevel/MonthLevel.mjs
var import_dayjs23 = __toESM(require_dayjs_min(), 1);
var defaultProps10 = {
  monthLabelFormat: "MMMM YYYY"
};
var MonthLevel = factory((_props, ref) => {
  const props = useProps("MonthLevel", defaultProps10, _props);
  const {
    // Month settings
    month,
    locale: locale3,
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    __getDayRef,
    __onDayKeyDown,
    __onDayClick,
    __onDayMouseEnter,
    withCellSpacing,
    highlightToday,
    withWeekNumbers,
    // CalendarHeader settings
    __preventFocus,
    __stopPropagation,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    // Other props
    monthLabelFormat,
    classNames,
    styles,
    unstyled,
    __staticSelector,
    size,
    static: isStatic,
    ...others
  } = props;
  const ctx = useDatesContext();
  const stylesApiProps = {
    __staticSelector: __staticSelector || "MonthLevel",
    classNames,
    styles,
    unstyled,
    size
  };
  const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, import_dayjs23.default)(month).endOf("month").isBefore(maxDate) : false;
  const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, import_dayjs23.default)(month).startOf("month").isAfter(minDate) : false;
  return /* @__PURE__ */ jsxs(Box, { "data-month-level": true, size, ref, ...others, children: [
    /* @__PURE__ */ jsx(
      CalendarHeader,
      {
        label: typeof monthLabelFormat === "function" ? monthLabelFormat(month) : (0, import_dayjs23.default)(month).locale(locale3 || ctx.locale).format(monthLabelFormat),
        __preventFocus,
        __stopPropagation,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel,
        levelControlAriaLabel,
        withNext,
        withPrevious,
        ...stylesApiProps
      }
    ),
    /* @__PURE__ */ jsx(
      Month,
      {
        month,
        locale: locale3,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        minDate,
        maxDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        getDayAriaLabel,
        __getDayRef,
        __onDayKeyDown,
        __onDayClick,
        __onDayMouseEnter,
        __preventFocus,
        __stopPropagation,
        static: isStatic,
        withCellSpacing,
        highlightToday,
        withWeekNumbers,
        ...stylesApiProps
      }
    )
  ] });
});
MonthLevel.classes = { ...Month.classes, ...CalendarHeader.classes };
MonthLevel.displayName = "@mantine/dates/MonthLevel";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/LevelsGroup/LevelsGroup.module.css.mjs
var classes8 = { "levelsGroup": "m_30b26e33" };

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/LevelsGroup/LevelsGroup.mjs
var defaultProps11 = {};
var LevelsGroup = factory((_props, ref) => {
  const props = useProps("LevelsGroup", defaultProps11, _props);
  const { classNames, className, style, styles, unstyled, vars, __staticSelector, ...others } = props;
  const getStyles = useStyles({
    name: __staticSelector || "LevelsGroup",
    classes: classes8,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */ jsx(Box, { ref, ...getStyles("levelsGroup"), ...others });
});
LevelsGroup.classes = classes8;
LevelsGroup.displayName = "@mantine/dates/LevelsGroup";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DecadeLevelGroup/DecadeLevelGroup.mjs
var import_dayjs24 = __toESM(require_dayjs_min(), 1);
var defaultProps12 = {
  numberOfColumns: 1
};
var DecadeLevelGroup = factory((_props, ref) => {
  const props = useProps("DecadeLevelGroup", defaultProps12, _props);
  const {
    // DecadeLevel settings
    decade,
    locale: locale3,
    minDate,
    maxDate,
    yearsListFormat,
    getYearControlProps,
    __onControlClick,
    __onControlMouseEnter,
    withCellSpacing,
    // CalendarHeader settings
    __preventFocus,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    nextDisabled,
    previousDisabled,
    // Other settings
    classNames,
    styles,
    unstyled,
    __staticSelector,
    __stopPropagation,
    numberOfColumns,
    levelControlAriaLabel,
    decadeLabelFormat,
    size,
    vars,
    ...others
  } = props;
  const controlsRef = useRef([]);
  const decades = Array(numberOfColumns).fill(0).map((_, decadeIndex) => {
    const currentDecade = (0, import_dayjs24.default)(decade).add(decadeIndex * 10, "years").toDate();
    return /* @__PURE__ */ jsx(
      DecadeLevel,
      {
        size,
        yearsListFormat,
        decade: currentDecade,
        withNext: decadeIndex === numberOfColumns - 1,
        withPrevious: decadeIndex === 0,
        decadeLabelFormat,
        __onControlClick,
        __onControlMouseEnter,
        __onControlKeyDown: (event, payload) => handleControlKeyDown({
          levelIndex: decadeIndex,
          rowIndex: payload.rowIndex,
          cellIndex: payload.cellIndex,
          event,
          controlsRef
        }),
        __getControlRef: (rowIndex, cellIndex, node) => {
          if (!Array.isArray(controlsRef.current[decadeIndex])) {
            controlsRef.current[decadeIndex] = [];
          }
          if (!Array.isArray(controlsRef.current[decadeIndex][rowIndex])) {
            controlsRef.current[decadeIndex][rowIndex] = [];
          }
          controlsRef.current[decadeIndex][rowIndex][cellIndex] = node;
        },
        levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentDecade) : levelControlAriaLabel,
        locale: locale3,
        minDate,
        maxDate,
        __preventFocus,
        __stopPropagation,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        nextDisabled,
        previousDisabled,
        getYearControlProps,
        __staticSelector: __staticSelector || "DecadeLevelGroup",
        classNames,
        styles,
        unstyled,
        withCellSpacing
      },
      decadeIndex
    );
  });
  return /* @__PURE__ */ jsx(
    LevelsGroup,
    {
      classNames,
      styles,
      __staticSelector: __staticSelector || "DecadeLevelGroup",
      ref,
      size,
      unstyled,
      ...others,
      children: decades
    }
  );
});
DecadeLevelGroup.classes = { ...LevelsGroup.classes, ...DecadeLevel.classes };
DecadeLevelGroup.displayName = "@mantine/dates/DecadeLevelGroup";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/YearLevelGroup/YearLevelGroup.mjs
var import_dayjs25 = __toESM(require_dayjs_min(), 1);
var defaultProps13 = {
  numberOfColumns: 1
};
var YearLevelGroup = factory((_props, ref) => {
  const props = useProps("YearLevelGroup", defaultProps13, _props);
  const {
    // YearLevel settings
    year,
    locale: locale3,
    minDate,
    maxDate,
    monthsListFormat,
    getMonthControlProps,
    __onControlClick,
    __onControlMouseEnter,
    withCellSpacing,
    // CalendarHeader settings
    __preventFocus,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    // Other settings
    classNames,
    styles,
    unstyled,
    __staticSelector,
    __stopPropagation,
    numberOfColumns,
    levelControlAriaLabel,
    yearLabelFormat,
    size,
    vars,
    ...others
  } = props;
  const controlsRef = useRef([]);
  const years = Array(numberOfColumns).fill(0).map((_, yearIndex) => {
    const currentYear = (0, import_dayjs25.default)(year).add(yearIndex, "years").toDate();
    return /* @__PURE__ */ jsx(
      YearLevel,
      {
        size,
        monthsListFormat,
        year: currentYear,
        withNext: yearIndex === numberOfColumns - 1,
        withPrevious: yearIndex === 0,
        yearLabelFormat,
        __stopPropagation,
        __onControlClick,
        __onControlMouseEnter,
        __onControlKeyDown: (event, payload) => handleControlKeyDown({
          levelIndex: yearIndex,
          rowIndex: payload.rowIndex,
          cellIndex: payload.cellIndex,
          event,
          controlsRef
        }),
        __getControlRef: (rowIndex, cellIndex, node) => {
          if (!Array.isArray(controlsRef.current[yearIndex])) {
            controlsRef.current[yearIndex] = [];
          }
          if (!Array.isArray(controlsRef.current[yearIndex][rowIndex])) {
            controlsRef.current[yearIndex][rowIndex] = [];
          }
          controlsRef.current[yearIndex][rowIndex][cellIndex] = node;
        },
        levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentYear) : levelControlAriaLabel,
        locale: locale3,
        minDate,
        maxDate,
        __preventFocus,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled,
        previousDisabled,
        hasNextLevel,
        getMonthControlProps,
        classNames,
        styles,
        unstyled,
        __staticSelector: __staticSelector || "YearLevelGroup",
        withCellSpacing
      },
      yearIndex
    );
  });
  return /* @__PURE__ */ jsx(
    LevelsGroup,
    {
      classNames,
      styles,
      __staticSelector: __staticSelector || "YearLevelGroup",
      ref,
      size,
      unstyled,
      ...others,
      children: years
    }
  );
});
YearLevelGroup.classes = { ...YearLevel.classes, ...LevelsGroup.classes };
YearLevelGroup.displayName = "@mantine/dates/YearLevelGroup";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/MonthLevelGroup/MonthLevelGroup.mjs
var import_dayjs26 = __toESM(require_dayjs_min(), 1);
var defaultProps14 = {
  numberOfColumns: 1
};
var MonthLevelGroup = factory((_props, ref) => {
  const props = useProps("MonthLevelGroup", defaultProps14, _props);
  const {
    // Month settings
    month,
    locale: locale3,
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    __onDayClick,
    __onDayMouseEnter,
    withCellSpacing,
    highlightToday,
    withWeekNumbers,
    // CalendarHeader settings
    __preventFocus,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    // Other settings
    classNames,
    styles,
    unstyled,
    numberOfColumns,
    levelControlAriaLabel,
    monthLabelFormat,
    __staticSelector,
    __stopPropagation,
    size,
    static: isStatic,
    vars,
    ...others
  } = props;
  const daysRefs = useRef([]);
  const months = Array(numberOfColumns).fill(0).map((_, monthIndex) => {
    const currentMonth = (0, import_dayjs26.default)(month).add(monthIndex, "months").toDate();
    return /* @__PURE__ */ jsx(
      MonthLevel,
      {
        month: currentMonth,
        withNext: monthIndex === numberOfColumns - 1,
        withPrevious: monthIndex === 0,
        monthLabelFormat,
        __stopPropagation,
        __onDayClick,
        __onDayMouseEnter,
        __onDayKeyDown: (event, payload) => handleControlKeyDown({
          levelIndex: monthIndex,
          rowIndex: payload.rowIndex,
          cellIndex: payload.cellIndex,
          event,
          controlsRef: daysRefs
        }),
        __getDayRef: (rowIndex, cellIndex, node) => {
          if (!Array.isArray(daysRefs.current[monthIndex])) {
            daysRefs.current[monthIndex] = [];
          }
          if (!Array.isArray(daysRefs.current[monthIndex][rowIndex])) {
            daysRefs.current[monthIndex][rowIndex] = [];
          }
          daysRefs.current[monthIndex][rowIndex][cellIndex] = node;
        },
        levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentMonth) : levelControlAriaLabel,
        locale: locale3,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        minDate,
        maxDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        getDayAriaLabel,
        __preventFocus,
        nextIcon,
        previousIcon,
        nextLabel,
        previousLabel,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled,
        previousDisabled,
        hasNextLevel,
        classNames,
        styles,
        unstyled,
        __staticSelector: __staticSelector || "MonthLevelGroup",
        size,
        static: isStatic,
        withCellSpacing,
        highlightToday,
        withWeekNumbers
      },
      monthIndex
    );
  });
  return /* @__PURE__ */ jsx(
    LevelsGroup,
    {
      classNames,
      styles,
      __staticSelector: __staticSelector || "MonthLevelGroup",
      ref,
      size,
      ...others,
      children: months
    }
  );
});
MonthLevelGroup.classes = { ...LevelsGroup.classes, ...MonthLevel.classes };
MonthLevelGroup.displayName = "@mantine/dates/MonthLevelGroup";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Calendar/Calendar.mjs
var import_dayjs28 = __toESM(require_dayjs_min(), 1);
__toESM(require_dayjs_min(), 1);
var getEmptyValue = (type) => type === "range" ? [null, null] : type === "multiple" ? [] : null;
function useUncontrolledDates({
  type,
  value: value2,
  defaultValue,
  onChange,
  applyTimezone = true
}) {
  const storedType = useRef(type);
  const ctx = useDatesContext();
  const [_value, _setValue, controlled] = useUncontrolled({
    value: shiftTimezone("add", value2, ctx.getTimezone(), !applyTimezone),
    defaultValue: shiftTimezone("add", defaultValue, ctx.getTimezone(), !applyTimezone),
    finalValue: getEmptyValue(type),
    onChange: (newDate2) => {
      onChange?.(shiftTimezone("remove", newDate2, ctx.getTimezone(), !applyTimezone));
    }
  });
  let _finalValue = _value;
  if (storedType.current !== type) {
    storedType.current = type;
    if (value2 === void 0) {
      _finalValue = defaultValue !== void 0 ? defaultValue : getEmptyValue(type);
      _setValue(_finalValue);
    } else if (process.env.NODE_ENV === "development") {
      switch (type) {
        case "default":
          if (value2 !== null && typeof value2 !== "string") {
            console.error(
              "[@mantine/dates/use-uncontrolled-dates] Value must be type of `null` or `string`"
            );
          }
          break;
        case "multiple":
          if (!(value2 instanceof Array)) {
            console.error(
              "[@mantine/dates/use-uncontrolled-dates] Value must be type of `string[]`"
            );
          }
          break;
        case "range":
          if (!(value2 instanceof Array) || value2.length !== 2) {
            console.error(
              "[@mantine/dates/use-uncontrolled-dates] Value must be type of `[string, string]`"
            );
          }
          break;
      }
    }
  }
  return [_finalValue, _setValue, controlled];
}
function levelToNumber(level, fallback) {
  if (!level) {
    return fallback || 0;
  }
  return level === "month" ? 0 : level === "year" ? 1 : 2;
}
function levelNumberToLevel(levelNumber) {
  return levelNumber === 0 ? "month" : levelNumber === 1 ? "year" : "decade";
}
function clampLevel(level, minLevel, maxLevel) {
  return levelNumberToLevel(
    clamp(
      levelToNumber(level, 0),
      levelToNumber(minLevel, 0),
      levelToNumber(maxLevel, 2)
    )
  );
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Calendar/Calendar.mjs
var defaultProps15 = {
  maxLevel: "decade",
  minLevel: "month",
  __updateDateOnYearSelect: true,
  __updateDateOnMonthSelect: true
};
var Calendar = factory((_props, ref) => {
  const props = useProps("Calendar", defaultProps15, _props);
  const {
    vars,
    // CalendarLevel props
    maxLevel,
    minLevel,
    defaultLevel,
    level,
    onLevelChange,
    date: date2,
    defaultDate,
    onDateChange,
    numberOfColumns,
    columnsToScroll,
    ariaLabels,
    nextLabel,
    previousLabel,
    onYearSelect,
    onMonthSelect,
    onYearMouseEnter,
    onMonthMouseEnter,
    __updateDateOnYearSelect,
    __updateDateOnMonthSelect,
    // MonthLevelGroup props
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    monthLabelFormat,
    nextIcon,
    previousIcon,
    __onDayClick,
    __onDayMouseEnter,
    withCellSpacing,
    highlightToday,
    withWeekNumbers,
    // YearLevelGroup props
    monthsListFormat,
    getMonthControlProps,
    yearLabelFormat,
    // DecadeLevelGroup props
    yearsListFormat,
    getYearControlProps,
    decadeLabelFormat,
    // Other props
    classNames,
    styles,
    unstyled,
    minDate,
    maxDate,
    locale: locale3,
    __staticSelector,
    size,
    __preventFocus,
    __stopPropagation,
    onNextDecade,
    onPreviousDecade,
    onNextYear,
    onPreviousYear,
    onNextMonth,
    onPreviousMonth,
    static: isStatic,
    __timezoneApplied,
    ...others
  } = props;
  const { resolvedClassNames, resolvedStyles } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  const [_level, setLevel] = useUncontrolled({
    value: level ? clampLevel(level, minLevel, maxLevel) : void 0,
    defaultValue: defaultLevel ? clampLevel(defaultLevel, minLevel, maxLevel) : void 0,
    finalValue: clampLevel(void 0, minLevel, maxLevel),
    onChange: onLevelChange
  });
  const [_date, setDate] = useUncontrolledDates({
    type: "default",
    value: date2,
    defaultValue: defaultDate,
    onChange: onDateChange,
    applyTimezone: !__timezoneApplied
  });
  const stylesApiProps = {
    __staticSelector: __staticSelector || "Calendar",
    styles: resolvedStyles,
    classNames: resolvedClassNames,
    unstyled,
    size
  };
  const ctx = useDatesContext();
  const _columnsToScroll = columnsToScroll || numberOfColumns || 1;
  const now = /* @__PURE__ */ new Date();
  const fallbackDate = minDate && minDate > now ? minDate : now;
  const currentDate = _date || shiftTimezone("add", fallbackDate, ctx.getTimezone());
  const handleNextMonth = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).add(_columnsToScroll, "month").toDate();
    onNextMonth?.(nextDate);
    setDate(nextDate);
  };
  const handlePreviousMonth = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).subtract(_columnsToScroll, "month").toDate();
    onPreviousMonth?.(nextDate);
    setDate(nextDate);
  };
  const handleNextYear = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).add(_columnsToScroll, "year").toDate();
    onNextYear?.(nextDate);
    setDate(nextDate);
  };
  const handlePreviousYear = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).subtract(_columnsToScroll, "year").toDate();
    onPreviousYear?.(nextDate);
    setDate(nextDate);
  };
  const handleNextDecade = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).add(10 * _columnsToScroll, "year").toDate();
    onNextDecade?.(nextDate);
    setDate(nextDate);
  };
  const handlePreviousDecade = () => {
    const nextDate = (0, import_dayjs28.default)(currentDate).subtract(10 * _columnsToScroll, "year").toDate();
    onPreviousDecade?.(nextDate);
    setDate(nextDate);
  };
  return /* @__PURE__ */ jsxs(Box, { ref, size, "data-calendar": true, ...others, children: [
    _level === "month" && /* @__PURE__ */ jsx(
      MonthLevelGroup,
      {
        month: currentDate,
        minDate,
        maxDate,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        getDayAriaLabel,
        onNext: handleNextMonth,
        onPrevious: handlePreviousMonth,
        hasNextLevel: maxLevel !== "month",
        onLevelClick: () => setLevel("year"),
        numberOfColumns,
        locale: locale3,
        levelControlAriaLabel: ariaLabels?.monthLevelControl,
        nextLabel: ariaLabels?.nextMonth ?? nextLabel,
        nextIcon,
        previousLabel: ariaLabels?.previousMonth ?? previousLabel,
        previousIcon,
        monthLabelFormat,
        __onDayClick,
        __onDayMouseEnter,
        __preventFocus,
        __stopPropagation,
        static: isStatic,
        withCellSpacing,
        highlightToday,
        withWeekNumbers,
        ...stylesApiProps
      }
    ),
    _level === "year" && /* @__PURE__ */ jsx(
      YearLevelGroup,
      {
        year: currentDate,
        numberOfColumns,
        minDate,
        maxDate,
        monthsListFormat,
        getMonthControlProps,
        locale: locale3,
        onNext: handleNextYear,
        onPrevious: handlePreviousYear,
        hasNextLevel: maxLevel !== "month" && maxLevel !== "year",
        onLevelClick: () => setLevel("decade"),
        levelControlAriaLabel: ariaLabels?.yearLevelControl,
        nextLabel: ariaLabels?.nextYear ?? nextLabel,
        nextIcon,
        previousLabel: ariaLabels?.previousYear ?? previousLabel,
        previousIcon,
        yearLabelFormat,
        __onControlMouseEnter: onMonthMouseEnter,
        __onControlClick: (_event, payload) => {
          __updateDateOnMonthSelect && setDate(payload);
          setLevel(clampLevel("month", minLevel, maxLevel));
          onMonthSelect?.(payload);
        },
        __preventFocus,
        __stopPropagation,
        withCellSpacing,
        ...stylesApiProps
      }
    ),
    _level === "decade" && /* @__PURE__ */ jsx(
      DecadeLevelGroup,
      {
        decade: currentDate,
        minDate,
        maxDate,
        yearsListFormat,
        getYearControlProps,
        locale: locale3,
        onNext: handleNextDecade,
        onPrevious: handlePreviousDecade,
        numberOfColumns,
        nextLabel: ariaLabels?.nextDecade ?? nextLabel,
        nextIcon,
        previousLabel: ariaLabels?.previousDecade ?? previousLabel,
        previousIcon,
        decadeLabelFormat,
        __onControlMouseEnter: onYearMouseEnter,
        __onControlClick: (_event, payload) => {
          __updateDateOnYearSelect && setDate(payload);
          setLevel(clampLevel("year", minLevel, maxLevel));
          onYearSelect?.(payload);
        },
        __preventFocus,
        __stopPropagation,
        withCellSpacing,
        ...stylesApiProps
      }
    )
  ] });
});
Calendar.classes = {
  ...DecadeLevelGroup.classes,
  ...YearLevelGroup.classes,
  ...MonthLevelGroup.classes
};
Calendar.displayName = "@mantine/dates/Calendar";

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/Calendar/pick-calendar-levels-props/pick-calendar-levels-props.mjs
function pickCalendarProps(props) {
  const {
    maxLevel,
    minLevel,
    defaultLevel,
    level,
    onLevelChange,
    nextIcon,
    previousIcon,
    date: date2,
    defaultDate,
    onDateChange,
    numberOfColumns,
    columnsToScroll,
    ariaLabels,
    nextLabel,
    previousLabel,
    onYearSelect,
    onMonthSelect,
    onYearMouseEnter,
    onMonthMouseEnter,
    onNextMonth,
    onPreviousMonth,
    onNextYear,
    onPreviousYear,
    onNextDecade,
    onPreviousDecade,
    withCellSpacing,
    highlightToday,
    __updateDateOnYearSelect,
    __updateDateOnMonthSelect,
    withWeekNumbers,
    // MonthLevelGroup props
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    monthLabelFormat,
    // YearLevelGroup props
    monthsListFormat,
    getMonthControlProps,
    yearLabelFormat,
    // DecadeLevelGroup props
    yearsListFormat,
    getYearControlProps,
    decadeLabelFormat,
    // External picker props
    allowSingleDateInRange,
    allowDeselect,
    // Other props
    minDate,
    maxDate,
    locale: locale3,
    ...others
  } = props;
  return {
    calendarProps: {
      maxLevel,
      minLevel,
      defaultLevel,
      level,
      onLevelChange,
      nextIcon,
      previousIcon,
      date: date2,
      defaultDate,
      onDateChange,
      numberOfColumns,
      columnsToScroll,
      ariaLabels,
      nextLabel,
      previousLabel,
      onYearSelect,
      onMonthSelect,
      onYearMouseEnter,
      onMonthMouseEnter,
      onNextMonth,
      onPreviousMonth,
      onNextYear,
      onPreviousYear,
      onNextDecade,
      onPreviousDecade,
      withCellSpacing,
      highlightToday,
      __updateDateOnYearSelect,
      __updateDateOnMonthSelect,
      withWeekNumbers,
      // MonthLevelGroup props
      firstDayOfWeek,
      weekdayFormat,
      weekendDays,
      getDayProps,
      excludeDate,
      renderDay,
      hideOutsideDates,
      hideWeekdays,
      getDayAriaLabel,
      monthLabelFormat,
      // YearLevelGroup props
      monthsListFormat,
      getMonthControlProps,
      yearLabelFormat,
      // DecadeLevelGroup props
      yearsListFormat,
      getYearControlProps,
      decadeLabelFormat,
      // External picker props
      allowSingleDateInRange,
      allowDeselect,
      // Other props
      minDate,
      maxDate,
      locale: locale3
    },
    others
  };
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DateInput/DateInput.mjs
var import_dayjs31 = __toESM(require_dayjs_min(), 1);

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DateInput/date-string-parser/date-string-parser.mjs
__toESM(require_dayjs_min(), 1);
function dateStringParser(dateString, timezone) {
  if (dateString === null) {
    return null;
  }
  const date2 = shiftTimezone("add", new Date(dateString), timezone);
  if (Number.isNaN(date2.getTime()) || !dateString) {
    return null;
  }
  return date2;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DateInput/is-date-valid/is-date-valid.mjs
var import_dayjs30 = __toESM(require_dayjs_min(), 1);
function isDateValid({ date: date2, maxDate, minDate }) {
  if (date2 == null) {
    return false;
  }
  if (Number.isNaN(date2.getTime())) {
    return false;
  }
  if (maxDate && (0, import_dayjs30.default)(date2).isAfter(maxDate, "date")) {
    return false;
  }
  if (minDate && (0, import_dayjs30.default)(date2).isBefore(minDate, "date")) {
    return false;
  }
  return true;
}

// node_modules/.pnpm/@mantine+dates@7.17.1_@mantine+core@7.17.1_@mantine+hooks@7.17.1_dayjs@1.11.13_react-dom@19.0.0_react@19.0.0/node_modules/@mantine/dates/esm/components/DateInput/DateInput.mjs
var defaultProps16 = {
  valueFormat: "MMMM D, YYYY",
  fixOnBlur: true,
  preserveTime: true
};
var DateInput = factory((_props, ref) => {
  const props = useInputProps("DateInput", defaultProps16, _props);
  const {
    inputProps,
    wrapperProps,
    value: value2,
    defaultValue,
    onChange,
    clearable,
    clearButtonProps,
    popoverProps,
    getDayProps,
    locale: locale3,
    valueFormat,
    dateParser,
    minDate,
    maxDate,
    fixOnBlur,
    onFocus,
    onBlur,
    onClick,
    readOnly,
    name: name2,
    form,
    rightSection,
    unstyled,
    classNames,
    styles,
    allowDeselect,
    preserveTime,
    date: date2,
    defaultDate,
    onDateChange,
    ...rest
  } = props;
  const _wrapperRef = useRef(null);
  const _dropdownRef = useRef(null);
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const { calendarProps, others } = pickCalendarProps(rest);
  const ctx = useDatesContext();
  const defaultDateParser = (val2) => {
    const parsedDate = (0, import_dayjs31.default)(val2, valueFormat, ctx.getLocale(locale3)).toDate();
    return Number.isNaN(parsedDate.getTime()) ? dateStringParser(val2, ctx.getTimezone()) : parsedDate;
  };
  const _dateParser = dateParser || defaultDateParser;
  const _allowDeselect = allowDeselect !== void 0 ? allowDeselect : clearable;
  const formatValue2 = (val2) => val2 ? (0, import_dayjs31.default)(val2).locale(ctx.getLocale(locale3)).format(valueFormat) : "";
  const [_value, setValue, controlled] = useUncontrolledDates({
    type: "default",
    value: value2,
    defaultValue,
    onChange
  });
  const [_date, setDate] = useUncontrolledDates({
    type: "default",
    value: date2,
    defaultValue: defaultValue || defaultDate,
    onChange: onDateChange
  });
  useEffect(() => {
    if (controlled && value2 !== null) {
      setDate(value2);
    }
  }, [controlled, value2]);
  const [inputValue, setInputValue] = useState(formatValue2(_value));
  useEffect(() => {
    setInputValue(formatValue2(_value));
  }, [ctx.getLocale(locale3)]);
  const handleInputChange = (event) => {
    const val2 = event.currentTarget.value;
    setInputValue(val2);
    setDropdownOpened(true);
    if (val2.trim() === "" && clearable) {
      setValue(null);
    } else {
      const dateValue = _dateParser(val2);
      if (isDateValid({ date: dateValue, minDate, maxDate })) {
        setValue(dateValue);
        setDate(dateValue);
      }
    }
  };
  const handleInputBlur = (event) => {
    onBlur?.(event);
    setDropdownOpened(false);
    fixOnBlur && setInputValue(formatValue2(_value));
  };
  const handleInputFocus = (event) => {
    onFocus?.(event);
    setDropdownOpened(true);
  };
  const handleInputClick = (event) => {
    onClick?.(event);
    setDropdownOpened(true);
  };
  const _getDayProps = (day) => ({
    ...getDayProps?.(day),
    selected: (0, import_dayjs31.default)(_value).isSame(day, "day"),
    onClick: (event) => {
      getDayProps?.(day).onClick?.(event);
      const valueWithTime = preserveTime ? assignTime(_value, day) : day;
      const val2 = clearable && _allowDeselect ? (0, import_dayjs31.default)(_value).isSame(day, "day") ? null : valueWithTime : valueWithTime;
      setValue(val2);
      !controlled && setInputValue(formatValue2(val2));
      setDropdownOpened(false);
    }
  });
  const _rightSection = rightSection || (clearable && _value && !readOnly ? /* @__PURE__ */ jsx(
    CloseButton,
    {
      variant: "transparent",
      onMouseDown: (event) => event.preventDefault(),
      tabIndex: -1,
      onClick: () => {
        setValue(null);
        !controlled && setInputValue("");
        setDropdownOpened(false);
      },
      unstyled,
      size: inputProps.size || "sm",
      ...clearButtonProps
    }
  ) : null);
  useDidUpdate(() => {
    _value !== void 0 && !dropdownOpened && setInputValue(formatValue2(_value));
  }, [_value]);
  useClickOutside(() => setDropdownOpened(false), void 0, [
    _wrapperRef.current,
    _dropdownRef.current
  ]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Input.Wrapper, { ...wrapperProps, __staticSelector: "DateInput", ref: _wrapperRef, children: /* @__PURE__ */ jsxs(
      Popover,
      {
        opened: dropdownOpened,
        trapFocus: false,
        position: "bottom-start",
        disabled: readOnly,
        withRoles: false,
        unstyled,
        ...popoverProps,
        children: [
          /* @__PURE__ */ jsx(Popover.Target, { children: /* @__PURE__ */ jsx(
            Input,
            {
              "data-dates-input": true,
              "data-read-only": readOnly || void 0,
              autoComplete: "off",
              ref,
              value: inputValue,
              onChange: handleInputChange,
              onBlur: handleInputBlur,
              onFocus: handleInputFocus,
              onClick: handleInputClick,
              readOnly,
              rightSection: _rightSection,
              ...inputProps,
              ...others,
              __staticSelector: "DateInput"
            }
          ) }),
          /* @__PURE__ */ jsx(
            Popover.Dropdown,
            {
              onMouseDown: (event) => event.preventDefault(),
              "data-dates-dropdown": true,
              ref: _dropdownRef,
              children: /* @__PURE__ */ jsx(
                Calendar,
                {
                  __staticSelector: "DateInput",
                  __timezoneApplied: true,
                  ...calendarProps,
                  classNames,
                  styles,
                  unstyled,
                  __preventFocus: true,
                  minDate,
                  maxDate,
                  locale: locale3,
                  getDayProps: _getDayProps,
                  size: inputProps.size,
                  date: _date,
                  onDateChange: setDate
                }
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(HiddenDatesInput, { name: name2, form, value: _value, type: "default" })
  ] });
});
DateInput.classes = { ...Input.classes, ...Calendar.classes };
DateInput.displayName = "@mantine/dates/DateInput";
function TimeRange({
  range: range6,
  onChangeRange,
  selectYear = false
}) {
  return /* @__PURE__ */ jsx("div", { children: selectYear ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    Select,
    {
      className: "w-32",
      placeholder: "Select year",
      data: Array.from({ length: (/* @__PURE__ */ new Date()).getFullYear() - 2010 }, (_, i) => {
        const year = (/* @__PURE__ */ new Date()).getFullYear() - i;
        return {
          label: year.toString(),
          value: year.toString()
        };
      }),
      onChange: (value2) => {
        if (value2 && onChangeRange) {
          onChangeRange({
            startDate: /* @__PURE__ */ new Date(`${value2}-01-01`),
            endDate: /* @__PURE__ */ new Date(`${value2}-12-31`)
          });
        }
      },
      value: range6?.startDate?.getFullYear().toString()
    }
  ) }) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "rounded-md gap-1 flex items-center max-w-[150px]", children: [
      /* @__PURE__ */ jsx(InputLabel, { className: "text-sm text-gray-600 font-medium shrink-0", children: "From :" }),
      /* @__PURE__ */ jsx(
        DateInput,
        {
          placeholder: "YYYY-MM-DD",
          valueFormat: "YYYY-MM-DD",
          size: "sm",
          value: range6?.startDate || null,
          onChange: (date2) => {
            if (onChangeRange && date2) {
              onChangeRange({ startDate: date2 });
            }
          },
          minDate: new Date(2012, 0, 1),
          maxDate: range6?.endDate || /* @__PURE__ */ new Date(),
          classNames: {
            input: "focus:outline-none",
            root: "w-auto"
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "rounded-md gap-1 flex items-center max-w-[150px]", children: [
      /* @__PURE__ */ jsx(InputLabel, { className: "text-sm text-gray-600 font-medium shrink-0", children: "To :" }),
      /* @__PURE__ */ jsx(
        DateInput,
        {
          placeholder: "YYYY-MM-DD",
          valueFormat: "YYYY-MM-DD",
          size: "sm",
          value: range6?.endDate || null,
          onChange: (date2) => {
            if (onChangeRange && date2) {
              const endDate = new Date(date2);
              endDate.setHours(23, 59, 59, 999);
              onChangeRange({ endDate });
            }
          },
          minDate: range6?.startDate || new Date(2012, 0, 1),
          maxDate: new Date((/* @__PURE__ */ new Date()).getFullYear() + 5, 11, 31),
          classNames: {
            input: "focus:outline-none",
            root: "w-auto"
          }
        }
      )
    ] })
  ] }) });
}
function sortData(data2, payload) {
  const { sortBy: sortBy4, reversed, search } = payload;
  const { dateRange } = payload;
  if (search) {
    data2 = data2.filter((item) => {
      const values = Object.values(item);
      return values.some((value2) => {
        return JSON.stringify(value2).toLowerCase().includes(search.toLowerCase());
      });
    });
  }
  if (dateRange) {
    const [from, to] = dateRange;
    if (from) {
      data2 = data2.filter((item) => {
        const date2 = new Date(item.createdAt);
        return date2 >= from;
      });
    }
    if (to) {
      data2 = data2.filter((item) => {
        const date2 = new Date(item.createdAt);
        return date2 <= to;
      });
    }
  }
  if (!sortBy4) {
    return data2;
  }
  return [...data2].sort((a2, b) => {
    return reversed ? String(JSON.stringify(getObjValue(sortBy4, b))).localeCompare(String(JSON.stringify(getObjValue(sortBy4, a2)))) : String(JSON.stringify(getObjValue(sortBy4, a2))).localeCompare(String(JSON.stringify(getObjValue(sortBy4, b))));
  });
}
function TableWrapper({
  columns,
  data: originalData,
  className,
  title,
  actions,
  loading,
  error,
  refresh,
  errorFetching = false,
  paginated,
  pagination,
  size,
  accent = "primary",
  search,
  setSearch,
  page,
  setPage,
  onApplyFilters,
  onClearFilters,
  onFiltersChange,
  filters,
  range: range6,
  onChangeRange,
  selectYear = false
}) {
  const [localSearch, setLocalSearch] = useState("");
  const [selection, setSelection] = useState([]);
  const [sortBy4, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [localPage, setLocalPage] = useState(1);
  const [data2, setData] = useState([]);
  useEffect(() => {
    setData(originalData ?? []);
  }, [originalData]);
  useEffect(() => {
    if (setPage) {
      setPage(1);
    } else {
      setLocalPage(1);
    }
    setSortBy(null);
    setReverseSortDirection(false);
  }, [localSearch]);
  const sortedData = useMemo(() => {
    return sortData(data2, { sortBy: sortBy4, reversed: reverseSortDirection, search: localSearch });
  }, [sortBy4, reverseSortDirection, data2, localSearch]);
  const onSort = (key2) => {
    if (sortBy4 === key2 && reverseSortDirection) {
      setSortBy(null);
      setReverseSortDirection(false);
      return;
    }
    if (sortBy4 === key2) {
      setReverseSortDirection((current) => !current);
    } else {
      setSortBy(key2);
      setReverseSortDirection(false);
    }
  };
  return /* @__PURE__ */ jsxs(Card, { withBorder: true, className: "flex flex-col gap-0 pt-2 pb-8 px-4 bg-white", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col flex-wrap lg:flex-row lg:justify-between gap-2 items-center", children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-row gap-2 items-center", children: /* @__PURE__ */ jsx("h1", { className: `font-bold text-2xl ${accent === "primary" ? "text-[#518DC8]" : "text-gray-500"} `, children: title }) }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-row flex-wrap items-center gap-2 h-fit", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center rounded-md h-full max-h-[40px] bg-color-a4 px-4 lg:py-4 gap-2", children: [
          /* @__PURE__ */ jsx(IoSearchOutline, { className: "stroke-[#5D6E8B]" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "text",
              placeholder: "Search here...",
              onChange: (e) => {
                if (setSearch)
                  setSearch(e.target.value);
                else setLocalSearch(e.target.value);
              },
              value: search || localSearch,
              className: "grow border-none outline-none bg-transparent h-full py-3"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:flex-row gap-2 md:items-center", children: [
          filters && /* @__PURE__ */ jsx(
            FiltersDropdown,
            {
              filters,
              onApplyFilters,
              onClearFilters,
              onFiltersChange
            }
          ),
          range6 && /* @__PURE__ */ jsx(
            TimeRange,
            {
              range: range6,
              onChangeRange,
              selectYear
            }
          ),
          refresh && /* @__PURE__ */ jsx(
            IoIosRefresh,
            {
              className: `h-6 w-6 text-gray-600 cursor-pointer ${loading !== void 0 && loading ? "animate-spin" : ""}`,
              onClick: () => refresh()
            }
          ),
          actions && actions
        ] })
      ] })
    ] }),
    loading ? /* @__PURE__ */ jsx(LoadingView, { message: "Loading data ..." }) : error ? /* @__PURE__ */ jsx(EmptyView, { message: "Error fetching data", size }) : /* @__PURE__ */ jsx(
      CustomTable,
      {
        errorFetching,
        data: data2,
        loading,
        columns,
        className,
        selection,
        setSelection,
        sortedData,
        sortBy: sortBy4,
        reverseSortDirection,
        onSort,
        page: page ?? localPage,
        setPage: setPage ?? setLocalPage,
        paginated,
        pagination,
        size,
        accent
      }
    )
  ] });
}
function RadioSelect(props) {
  const { data: data2, value: value2, onChange, containerClassName } = props;
  const [_value, _setValue] = React43.useState(value2);
  const getItemValue = (item) => {
    if (typeof item === "string")
      return item;
    return item.value;
  };
  const getItemLabel = (item) => {
    if (typeof item === "string")
      return item;
    return item.label;
  };
  const handleChange = (value3) => {
    _setValue(value3);
    onChange && onChange(value3);
  };
  return /* @__PURE__ */ jsx(Input.Wrapper, { label: props.label, description: props.description, className: "", children: /* @__PURE__ */ jsx("div", { role: "radiogroup", className: containerClassName ?? "grid grid-cols-2 mt-1 w-full gap-2", children: data2?.map((item, index2) => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-start space-x-2", children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "radio",
        name: "radio",
        value: getItemValue(item),
        checked: _value === getItemValue(item),
        onChange: (e) => handleChange(e.target.value),
        id: getItemValue(item) + index2,
        hidden: true
      }
    ),
    /* @__PURE__ */ jsxs(
      "label",
      {
        htmlFor: getItemValue(item) + index2,
        className: `flex gap-1 items-center justify-center w-full py-4 px-4 text-lg font-medium text-gray-500 border rounded-lg p-2 cursor-pointer ${value2 === getItemValue(item) ? "border-dark-blue bg-dark-blue/10" : "border-gray-300"}`,
        children: [
          /* @__PURE__ */ jsx("span", { className: " text-sm font-semibold flex-1", children: getItemLabel(item) }),
          item?.info && /* @__PURE__ */ jsx(Tooltip, { label: item?.info, children: /* @__PURE__ */ jsx("div", { role: "tooltip", className: "", children: /* @__PURE__ */ jsx(PiWarningCircle, { className: "w-5 h-5 text-color-a2" }) }) })
        ]
      }
    )
  ] }, index2)) }) });
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/hi/index.mjs
function HiOutlineMenuAlt2(props) {
  return GenIcon({ "attr": { "fill": "none", "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "aria-hidden": "true" }, "child": [{ "tag": "path", "attr": { "strokeLinecap": "round", "strokeLinejoin": "round", "d": "M4 6h16M4 12h16M4 18h7" }, "child": [] }] })(props);
}
function NotificationsPopup({ close, markAllAsRead, markNotificationAsRead, notifications }) {
  const popupRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        close();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { ref: popupRef, className: "flex sm:w-[500px] w-full flex-col p-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between border-b mb-3", children: [
      /* @__PURE__ */ jsx("span", { children: "Notifications" }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "transparent",
          leftSection: /* @__PURE__ */ jsx(IoCheckmarkDone, {}),
          size: "sm",
          onClick: markAllAsRead,
          children: "Mark all as read"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col text-sm gap-3", children: notifications.length === 0 ? /* @__PURE__ */ jsx("div", { className: "text-center text-gray-500", children: "No notifications" }) : notifications.map((notification) => /* @__PURE__ */ jsxs("div", { className: "flex w-full justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "font-bold", children: notification.title }),
        /* @__PURE__ */ jsx("span", { className: "text-xs", children: notification.description })
      ] }),
      /* @__PURE__ */ jsx(Button, { variant: "transparent", size: "xs", onClick: () => markNotificationAsRead(notification.id), children: "Mark as read" })
    ] }, notification.id)) })
  ] }) });
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/md/index.mjs
function MdOutlinePerson(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" }, "child": [] }] })(props);
}
function ProfileBox({
  email,
  username,
  profilePicture
}) {
  return /* @__PURE__ */ jsxs("div", { className: "flex bg-white gap-x-2 items-center", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-10 h-10 rounded-full bg-[#f5f9fe]", children: profilePicture ? /* @__PURE__ */ jsx("img", { src: profilePicture, alt: "Profile", className: "w-full h-full rounded-full object-contain" }) : /* @__PURE__ */ jsx(MdOutlinePerson, { className: "text-dark-blue", size: 20 }) }),
    /* @__PURE__ */ jsxs("div", { className: "leading-4", children: [
      /* @__PURE__ */ jsx("p", { className: "font-medium text-md", children: email }),
      /* @__PURE__ */ jsx("p", { className: "text-[#5D6E8B] text-sm", children: username })
    ] })
  ] });
}
function Topbar({
  user,
  notificationProps,
  profileDropdownItems,
  logoProps,
  onToggleSidebar
}) {
  const [isOpen, { close, toggle }] = useDisclosure(false);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "bg-white p-4 border border-white rounded-md flex justify-between w-full items-center", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-3", children: [
      onToggleSidebar && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "subtle",
          className: "text-dark-blue",
          p: "xs",
          onClick: onToggleSidebar,
          children: /* @__PURE__ */ jsx(HiOutlineMenuAlt2, { size: 20 })
        }
      ),
      /* @__PURE__ */ jsx(Logo, { ...logoProps })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-center gap-x-4 items-center", children: [
      /* @__PURE__ */ jsxs(Popover, { closeOnClickOutside: true, onClose: close, opened: isOpen, radius: "lg", position: "bottom", withArrow: true, shadow: "md", children: [
        /* @__PURE__ */ jsx(Popover.Target, { children: /* @__PURE__ */ jsx(Button, { onClick: toggle, p: 0, py: 0, px: 3, variant: "transparent", children: /* @__PURE__ */ jsx(IoNotificationsOutline, { size: 23, className: "block cursor-pointer" }) }) }),
        /* @__PURE__ */ jsx(Popover.Dropdown, { children: /* @__PURE__ */ jsx(NotificationsPopup, { close, ...notificationProps }) })
      ] }),
      /* @__PURE__ */ jsxs(Menu, { width: 230, position: "bottom", withArrow: true, shadow: "md", children: [
        /* @__PURE__ */ jsx(Menu.Target, { children: /* @__PURE__ */ jsx("div", { className: "flex cursor-pointer items-center gap-x-4", children: /* @__PURE__ */ jsx(ProfileBox, { username: user?.username ?? "N/A", email: user?.email ?? "N/A", profilePicture: user.profilePicture }) }) }),
        profileDropdownItems && /* @__PURE__ */ jsx(Menu.Dropdown, { children: profileDropdownItems.map((item, index2) => /* @__PURE__ */ jsx(Menu.Item, { onClick: item.onClick, leftSection: item.icon, children: item.label }, index2)) })
      ] })
    ] })
  ] }) });
}

// src/providers/ui-config.ts
var FONT_SIZE = 16;
var default_user_settings = {
  fontSize: FONT_SIZE
};
var DefaultLink = ({ href, children, className, ...rest }) => /* @__PURE__ */ jsx("a", { href, className, ...rest, children });
var UIContext = React43.createContext({
  theme: "light",
  setTheme: () => {
  },
  userSettings: default_user_settings,
  LinkComponent: DefaultLink
});
var useMohUI = () => useContext(UIContext);
function UIProvider({ children, LinkComponent = DefaultLink }) {
  const [theme, setTheme] = React43.useState("light");
  const [userSettings, setUserSettings] = React43.useState(default_user_settings);
  useEffect(() => {
    const html = document.querySelector("html");
    html?.style.setProperty("--font-size-root", `${userSettings.fontSize}px`);
  }, [userSettings.fontSize]);
  return /* @__PURE__ */ jsxs(
    MantineProvider,
    {
      theme: {
        fontFamily: "Urbanist, sans-serif",
        colors: {
          brand: [
            "#F0BBDD",
            "#ED9BCF",
            "#EC7CC3",
            "#ED5DB8",
            "#F13EAF",
            "#F71FA7",
            "#518DC8",
            "#3F91F6",
            "#518DC8",
            "#C50E82",
            "#AD1374"
          ]
        },
        primaryColor: "brand",
        components: {
          Anchor: Anchor.extend({
            defaultProps: {
              underline: "never"
            }
          })
        }
      },
      defaultColorScheme: "light",
      children: [
        /* @__PURE__ */ jsx(Notifications, { position: "top-right" }),
        /* @__PURE__ */ jsx(
          UIContext.Provider,
          {
            value: {
              theme,
              setTheme,
              userSettings,
              setUserSettings,
              LinkComponent
            },
            children
          }
        )
      ]
    }
  );
}
function Breadcrumb({ items, ...rest }) {
  const { LinkComponent } = useMohUI();
  const breadcrumbItems = items.map((item, index2) => /* @__PURE__ */ jsx(LinkComponent, { to: item.href, href: item.href, className: "text-[#5D6E8B] text-base", children: item.title }, index2));
  return /* @__PURE__ */ jsx(
    Breadcrumbs,
    {
      separator: /* @__PURE__ */ jsx(FaChevronRight, { className: "w-3 h-3 fill-[#3F91F6]" }),
      mt: "xs",
      ...rest,
      children: breadcrumbItems
    }
  );
}

// node_modules/.pnpm/react-icons@5.5.0_react@19.0.0/node_modules/react-icons/bi/index.mjs
function BiChevronUp(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z" }, "child": [] }] })(props);
}
var Navigation = ({
  routes,
  isItemActive,
  variant = "horizontal",
  collapsed = false
}) => {
  const { LinkComponent } = useMohUI();
  const [opened, setOpened] = useState("");
  const isVertical = variant === "vertical";
  const isRouteActive = (route) => {
    if (route.hasSubRoutes && route.routes) {
      return route.routes.some((subRoute) => isItemActive(subRoute.path));
    }
    return isItemActive(route.path);
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `
      styled-scrollbar bg-white
      ${isVertical ? "flex flex-col h-full border-r border-gray-200" : "w-full flex gap-x-2 px-4 border-b border-dark-blue overflow-x-auto"}
    `,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: `
        font-medium 
        ${isVertical ? "flex flex-col w-full gap-y-1 py-2" : "grid grid-flow-col w-full items-end gap-x-2 fontSize"}
      `,
          children: isVertical ? /* @__PURE__ */ jsx(
            Accordion,
            {
              chevronPosition: "right",
              classNames: {
                control: "p-0",
                item: "border-0",
                panel: "pl-2"
              },
              children: routes.map((route, idx) => {
                if (route.hasSubRoutes && route.routes) {
                  return /* @__PURE__ */ jsxs(Accordion.Item, { value: route.path, children: [
                    /* @__PURE__ */ jsx(
                      Accordion.Control,
                      {
                        className: `
                        ${isRouteActive(route) ? "text-white bg-dark-blue border-medium-blue hover:bg-dark-blue hover:text-white" : "text-[#008dd4] hover:bg-dark-blue hover:text-white"}  pl-4 pr-2
                      `,
                        icon: /* @__PURE__ */ jsx(route.icon, { size: route.iconSize ?? 20 }),
                        children: /* @__PURE__ */ jsx("div", { className: "max-w-[180px] overflow-x-auto scrollbar-hidden", children: /* @__PURE__ */ jsx("span", { className: "whitespace-nowrap", children: route.name }) })
                      }
                    ),
                    /* @__PURE__ */ jsx(Accordion.Panel, { children: route.routes?.map((subRoute, i) => /* @__PURE__ */ jsxs(
                      LinkComponent,
                      {
                        to: subRoute.path,
                        href: subRoute.path,
                        className: `
                           ${isItemActive(subRoute.path) ? "flex flex-row gap-2 items-center py-2.5 text-white bg-dark-blue" : "flex flex-row gap-2 items-center py-2.5 text-[#008dd4]"}
                           hover:bg-dark-blue hover:text-white px-3 w-full rounded-md my-1
                           transition-all duration-200
                         `,
                        children: [
                          /* @__PURE__ */ jsx(subRoute.icon, { size: subRoute.iconSize ?? 20 }),
                          !collapsed && /* @__PURE__ */ jsx("div", { className: "max-w-[150px] overflow-x-auto scrollbar-hidden", children: /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap", children: subRoute.name }) })
                        ]
                      },
                      i
                    )) })
                  ] }, idx);
                }
                return /* @__PURE__ */ jsxs(
                  LinkComponent,
                  {
                    to: route.path,
                    href: route.path,
                    className: `
                    pl-4 pr-2
                    ${isItemActive(route.path) ? "flex flex-row gap-2 items-center bg-dark-blue text-white py-2" : "flex flex-row gap-2 items-center hover:bg-dark-blue duration-300 text-[#008dd4] hover:text-white py-2"} whitespace-nowrap
                  `,
                    children: [
                      /* @__PURE__ */ jsx(route.icon, { isActive: isItemActive(route.path), size: route.iconSize ?? 20 }),
                      !collapsed && /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap", children: route.name })
                    ]
                  },
                  idx
                );
              })
            }
          ) : (
            // Horizontal navigation remains the same
            routes.map((route, idx) => {
              if (route.hasSubRoutes && route.routes) {
                return /* @__PURE__ */ jsx(
                  WithSubRoutes,
                  {
                    route,
                    path: location.pathname,
                    opened,
                    setOpened,
                    LinkComponent,
                    variant,
                    isItemActive
                  },
                  idx
                );
              }
              return /* @__PURE__ */ jsxs(
                LinkComponent,
                {
                  to: route.path,
                  href: route.path,
                  className: `
                  px-4
                  ${isItemActive(route.path) ? "w-full flex flex-row gap-2 items-center rounded-t-lg bg-dark-blue duration-300 border-t border-l border-r border-medium-blue text-white py-3" : "w-full flex flex-row gap-2 items-center rounded-t-lg hover:bg-dark-blue duration-300 bg-white text-[#008dd4] hover:text-white py-3"} whitespace-nowrap
                `,
                  children: [
                    /* @__PURE__ */ jsx(route.icon, { isActive: isItemActive(route.path), size: route.iconSize ?? 20 }),
                    /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap", children: route.name })
                  ]
                },
                idx
              );
            })
          )
        }
      )
    }
  );
};
var WithSubRoutes = ({
  route,
  path: path2,
  opened,
  setOpened,
  LinkComponent = "a",
  isItemActive
}) => {
  const isActiveLink = (linkPath) => path2.startsWith(linkPath);
  const isOpen = opened === route.name;
  return /* @__PURE__ */ jsx("div", { className: "w-full relative flex flex-col", children: /* @__PURE__ */ jsxs(Menu, { width: 220, withArrow: true, shadow: "lg", position: "bottom", children: [
    /* @__PURE__ */ jsx(Menu.Target, { children: /* @__PURE__ */ jsxs(
      "button",
      {
        className: `
                ${isItemActive(route.path) ? "border-t border-l border-r gap-2 text-white rounded-t-xl bg-dark-blue border-medium-blue py-3 px-4" : "w-full flex flex-row gap-2 items-center px-4 rounded-t-xl hover:bg-dark-blue duration-300 bg-white text-[#008dd4] hover:text-white py-3"}
                w-full h-full whitespace-nowrap flex flex-row justify-between items-center
              `,
        onClick: () => setOpened(isOpen ? "" : route.name),
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(route.icon, { size: route.iconSize ?? 20 }),
            /* @__PURE__ */ jsx("span", { children: route.name })
          ] }),
          /* @__PURE__ */ jsx(
            BiChevronUp,
            {
              size: 25,
              className: `ml-auto duration-300 ${isOpen ? "rotate-180" : "rotate-0"} hover:rotate-180`
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(Menu.Dropdown, { p: 0, children: route.routes?.map((subRoute, i) => /* @__PURE__ */ jsx(Menu.Item, { p: 0, children: /* @__PURE__ */ jsxs(
      LinkComponent,
      {
        to: subRoute.path,
        href: subRoute.path,
        className: `${isActiveLink(subRoute.path) ? "flex flex-row gap-5 items-center py-3 rounded-lg bg-color-a4 text-medium-blue" : "flex flex-row gap-5 items-center py-3 rounded-lg text-[#008dd4]"} hover:bg-dark-blue hover:text-white px-4`,
        children: [
          /* @__PURE__ */ jsx(subRoute.icon, { size: subRoute.iconSize ?? 20 }),
          /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap transition-all duration-200", children: subRoute.name })
        ]
      }
    ) }, i)) })
  ] }) }, route.name);
};
function DashboardLayout({
  children,
  navigationProps,
  topbarProps,
  layoutMode = "horizontal",
  collapsibleSidebar = false
}) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const showSidebar = layoutMode === "vertical" || layoutMode === "combined";
  const showTopNavigation = layoutMode === "horizontal" || layoutMode === "combined";
  const toggleSidebar = () => {
    if (collapsibleSidebar) {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "w-full h-screen flex flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsxs("div", { className: "sticky top-0 z-10", children: [
      /* @__PURE__ */ jsx(Topbar, { ...topbarProps, onToggleSidebar: collapsibleSidebar ? toggleSidebar : void 0 }),
      showTopNavigation && /* @__PURE__ */ jsx(Navigation, { ...navigationProps, variant: "horizontal" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-1 overflow-hidden", children: [
      showSidebar && /* @__PURE__ */ jsx(
        "div",
        {
          className: `
            h-full transition-all duration-300 bg-white
            ${sidebarCollapsed ? "w-[70px]" : "w-[250px]"}
          `,
          children: /* @__PURE__ */ jsx(
            Navigation,
            {
              ...navigationProps,
              variant: "vertical",
              condensed: sidebarCollapsed,
              collapsed: sidebarCollapsed
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `
          flex-1 overflow-auto styled-scrollbar min-h-[80vh]
          ${showSidebar ? "ml-0" : ""}
        `,
          children: /* @__PURE__ */ jsx("div", { className: "max-w-[90rem] h-full my-4 mx-auto rounded-md bg-[#F6F9FF] p-4 overflow-y-auto styled-scrollbar", children })
        }
      )
    ] })
  ] });
}

// src/tailwind-preset.ts
var import_colors = __toESM(require_colors2(), 1);

// src/lib/constants/index.ts
var COLORS = {
  "light-blue": "#3F91F6",
  "headers": "#031432",
  "dark-blue": "#518DC8",
  "medium-blue": "#518DC8",
  "sky-blue": "#70baff33",
  "color-a2": "#5D6E8B",
  "color-a3": "#EAEFF2",
  "color-a4": "#F6F9FF",
  "main-green": "#60D065",
  "main-orange": "#FFB155",
  "main-purple": "#895CFF",
  "min-red": "#FF6258",
  "pink-1": "#FF47D7"
};

// src/tailwind-preset.ts
var tailwind_preset_default = {
  darkMode: ["class"],
  content: [
    "./src/**/*.{ts,tsx}",
    "./src/components/**/*.{ts,tsx}",
    "./.storybook/**/*.{js,ts}"
  ],
  theme: {
    colors: {
      ...import_colors.default,
      ...COLORS
    }
  },
  plugins: []
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ReactUtils.js
var import_get2 = __toESM(require_get());
var import_isNil = __toESM(require_isNil());
var import_isString2 = __toESM(require_isString());
var import_isFunction = __toESM(require_isFunction());
var import_isObject2 = __toESM(require_isObject());
var import_react_is = __toESM(require_react_is());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/DataUtils.js
var import_isString = __toESM(require_isString());
var import_isNaN = __toESM(require_isNaN());
var import_get = __toESM(require_get());
var import_isNumber = __toESM(require_isNumber());
var mathSign = function mathSign2(value2) {
  if (value2 === 0) {
    return 0;
  }
  if (value2 > 0) {
    return 1;
  }
  return -1;
};
var isPercent = function isPercent2(value2) {
  return (0, import_isString.default)(value2) && value2.indexOf("%") === value2.length - 1;
};
var isNumber = function isNumber2(value2) {
  return (0, import_isNumber.default)(value2) && !(0, import_isNaN.default)(value2);
};
var isNumOrStr = function isNumOrStr2(value2) {
  return isNumber(value2) || (0, import_isString.default)(value2);
};
var idCounter = 0;
var uniqueId = function uniqueId2(prefix2) {
  var id = ++idCounter;
  return "".concat(prefix2 || "").concat(id);
};
var getPercentValue = function getPercentValue2(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (!isNumber(percent) && !(0, import_isString.default)(percent)) {
    return defaultValue;
  }
  var value2;
  if (isPercent(percent)) {
    var index2 = percent.indexOf("%");
    value2 = totalValue * parseFloat(percent.slice(0, index2)) / 100;
  } else {
    value2 = +percent;
  }
  if ((0, import_isNaN.default)(value2)) {
    value2 = defaultValue;
  }
  if (validate && value2 > totalValue) {
    value2 = totalValue;
  }
  return value2;
};
var getAnyElementOfObject = function getAnyElementOfObject2(obj) {
  if (!obj) {
    return null;
  }
  var keys2 = Object.keys(obj);
  if (keys2 && keys2.length) {
    return obj[keys2[0]];
  }
  return null;
};
var hasDuplicate = function hasDuplicate2(ary) {
  if (!Array.isArray(ary)) {
    return false;
  }
  var len = ary.length;
  var cache = {};
  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }
  return false;
};
var interpolateNumber = function interpolateNumber2(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function(t) {
      return numberA + t * (numberB - numberA);
    };
  }
  return function() {
    return numberB;
  };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }
  return ary.find(function(entry) {
    return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, import_get.default)(entry, specifiedKey)) === specifiedValue;
  });
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ShallowEqual.js
function shallowEqual(a2, b) {
  for (var key2 in a2) {
    if ({}.hasOwnProperty.call(a2, key2) && (!{}.hasOwnProperty.call(b, key2) || a2[key2] !== b[key2])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a2, _key)) {
      return false;
    }
  }
  return true;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/types.js
var import_isObject = __toESM(require_isObject());
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var SVGContainerPropKeys = ["viewBox", "children"];
var SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
];
var PolyElementKeys = ["points", "pathLength"];
var FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
};
var EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
var adaptEventHandlers = function adaptEventHandlers2(props, newHandler) {
  if (!props || typeof props === "function" || typeof props === "boolean") {
    return null;
  }
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props)) {
    inputProps = props.props;
  }
  if (!(0, import_isObject.default)(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function(key2) {
    if (EventKeys.includes(key2)) {
      out[key2] = newHandler || function(e) {
        return inputProps[key2](inputProps, e);
      };
    }
  });
  return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild2(originalHandler, data2, index2) {
  return function(e) {
    originalHandler(data2, index2, e);
    return null;
  };
};
var adaptEventsOfChild = function adaptEventsOfChild2(props, data2, index2) {
  if (!(0, import_isObject.default)(props) || _typeof2(props) !== "object") {
    return null;
  }
  var out = null;
  Object.keys(props).forEach(function(key2) {
    var item = props[key2];
    if (EventKeys.includes(key2) && typeof item === "function") {
      if (!out) out = {};
      out[key2] = getEventHandlerOfChild(item, data2, index2);
    }
  });
  return out;
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ReactUtils.js
var _excluded3 = ["children"];
var _excluded22 = ["children"];
function _objectWithoutProperties3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
var REACT_BROWSER_EVENT_MAP = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
};
var getDisplayName = function getDisplayName2(Comp) {
  if (typeof Comp === "string") {
    return Comp;
  }
  if (!Comp) {
    return "";
  }
  return Comp.displayName || Comp.name || "Component";
};
var lastChildren = null;
var lastResult = null;
var toArray = function toArray2(children) {
  if (children === lastChildren && Array.isArray(lastResult)) {
    return lastResult;
  }
  var result = [];
  Children.forEach(children, function(child) {
    if ((0, import_isNil.default)(child)) return;
    if ((0, import_react_is.isFragment)(child)) {
      result = result.concat(toArray2(child.props.children));
    } else {
      result.push(child);
    }
  });
  lastResult = result;
  lastChildren = children;
  return result;
};
function findAllByType(children, type) {
  var result = [];
  var types = [];
  if (Array.isArray(type)) {
    types = type.map(function(t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }
  toArray(children).forEach(function(child) {
    var childType = (0, import_get2.default)(child, "type.displayName") || (0, import_get2.default)(child, "type.name");
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
}
function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
}
var validateWidthHeight = function validateWidthHeight2(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props, width2 = _el$props.width, height2 = _el$props.height;
  if (!isNumber(width2) || width2 <= 0 || !isNumber(height2) || height2 <= 0) {
    return false;
  }
  return true;
};
var SVG_TAGS = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"];
var isSvgElement = function isSvgElement2(child) {
  return child && child.type && (0, import_isString2.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var hasClipDot = function hasClipDot2(dot) {
  return dot && _typeof3(dot) === "object" && "clipDot" in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp2(property2, key2, includeEvents, svgElementType) {
  var _FilteredElementKeyMa;
  var matchingElementTypeKeys = (_FilteredElementKeyMa = FilteredElementKeyMap === null || FilteredElementKeyMap === void 0 ? void 0 : FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
  return !(0, import_isFunction.default)(property2) && (svgElementType && matchingElementTypeKeys.includes(key2) || SVGElementPropKeys.includes(key2)) || includeEvents && EventKeys.includes(key2);
};
var filterProps = function filterProps2(props, includeEvents, svgElementType) {
  if (!props || typeof props === "function" || typeof props === "boolean") {
    return null;
  }
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props)) {
    inputProps = props.props;
  }
  if (!(0, import_isObject2.default)(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function(key2) {
    var _inputProps;
    if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key2], key2, includeEvents, svgElementType)) {
      out[key2] = inputProps[key2];
    }
  });
  return out;
};
var isChildrenEqual = function isChildrenEqual2(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }
  var count = Children.count(nextChildren);
  if (count !== Children.count(prevChildren)) {
    return false;
  }
  if (count === 0) {
    return true;
  }
  if (count === 1) {
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
  }
  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];
    if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
      if (!isChildrenEqual2(nextChild, prevChild)) {
        return false;
      }
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }
  return true;
};
var isSingleChildEqual = function isSingleChildEqual2(nextChild, prevChild) {
  if ((0, import_isNil.default)(nextChild) && (0, import_isNil.default)(prevChild)) {
    return true;
  }
  if (!(0, import_isNil.default)(nextChild) && !(0, import_isNil.default)(prevChild)) {
    var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties3(_ref, _excluded3);
    var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties3(_ref2, _excluded22);
    if (nextChildren && prevChildren) {
      return shallowEqual(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }
    if (!nextChildren && !prevChildren) {
      return shallowEqual(nextProps, prevProps);
    }
    return false;
  }
  return false;
};
var renderByOrder = function renderByOrder2(children, renderMap) {
  var elements = [];
  var record = {};
  toArray(children).forEach(function(child, index2) {
    if (isSvgElement(child)) {
      elements.push(child);
    } else if (child) {
      var displayName = getDisplayName(child.type);
      var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
      if (handler && (!once || !record[displayName])) {
        var results = handler(child, displayName, index2);
        elements.push(results);
        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType2(e) {
  var type = e && e.type;
  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }
  return null;
};
var parseChildIndex = function parseChildIndex2(child, children) {
  return toArray(children).indexOf(child);
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/container/Surface.js
var _excluded4 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
function _objectWithoutProperties4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function Surface(props) {
  var children = props.children, width2 = props.width, height2 = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties4(props, _excluded4);
  var svgView = viewBox || {
    width: width2,
    height: height2,
    x: 0,
    y: 0
  };
  var layerClass = clsx_default("recharts-surface", className);
  return /* @__PURE__ */ React43.createElement("svg", _extends2({}, filterProps(others, true, "svg"), {
    className: layerClass,
    width: width2,
    height: height2,
    style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
  }), /* @__PURE__ */ React43.createElement("title", null, title), /* @__PURE__ */ React43.createElement("desc", null, desc), children);
}
var _excluded5 = ["children", "className"];
function _extends3() {
  _extends3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
function _objectWithoutProperties5(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var Layer = /* @__PURE__ */ React43.forwardRef(function(props, ref) {
  var children = props.children, className = props.className, others = _objectWithoutProperties5(props, _excluded5);
  var layerClass = clsx_default("recharts-layer", className);
  return /* @__PURE__ */ React43.createElement("g", _extends3({
    className: layerClass
  }, filterProps(others, true), {
    ref
  }), children);
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/DefaultLegendContent.js
var import_isFunction2 = __toESM(require_isFunction());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/LogUtils.js
var isDev = process.env.NODE_ENV !== "production";
var warn = function warn2(condition, format2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (isDev && typeof console !== "undefined" && console.warn) {
    if (format2 === void 0) {
      console.warn("LogUtils requires an error message argument");
    }
    if (!condition) {
      if (format2 === void 0) {
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        var argIndex = 0;
        console.warn(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
      }
    }
  }
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/shape/Symbols.js
var import_upperFirst = __toESM(require_upperFirst());

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js
function constant_default(x2) {
  return function constant() {
    return x2;
  };
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js
var cos = Math.cos;
var sin = Math.sin;
var sqrt = Math.sqrt;
var pi = Math.PI;
var tau = 2 * pi;

// node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js
var pi2 = Math.PI;
var tau2 = 2 * pi2;
var epsilon = 1e-6;
var tauEpsilon = tau2 - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d > 15) return append;
  const k2 = 10 ** d;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k2) / k2 + strings[i];
    }
  };
}
var Path = class {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r2) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r2 = +r2;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon)) ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r2) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r2 * Math.tan((pi2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r2) return;
    if (da < 0) da = da % tau2 + tau2;
    if (da > tauEpsilon) {
      this._append`A${r2},${r2},0,1,${cw},${x2 - dx},${y2 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r2},${r2},0,${+(da >= pi2)},${cw},${this._x1 = x2 + r2 * Math.cos(a1)},${this._y1 = y2 + r2 * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w, h) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w = +w}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path(digits);
}
function array_default(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function linear_default(context) {
  return new Linear(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/point.js
function x(p) {
  return p[0];
}
function y(p) {
  return p[1];
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/line.js
function line_default(x2, y2) {
  var defined3 = constant_default(true), context = null, curve = linear_default, output = null, path2 = withPath(line);
  x2 = typeof x2 === "function" ? x2 : x2 === void 0 ? x : constant_default(x2);
  y2 = typeof y2 === "function" ? y2 : y2 === void 0 ? y : constant_default(y2);
  function line(data2) {
    var i, n = (data2 = array_default(data2)).length, d, defined0 = false, buffer;
    if (context == null) output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined3(d = data2[i], i, data2)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x2(d, i, data2), +y2(d, i, data2));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line.x = function(_) {
    return arguments.length ? (x2 = typeof _ === "function" ? _ : constant_default(+_), line) : x2;
  };
  line.y = function(_) {
    return arguments.length ? (y2 = typeof _ === "function" ? _ : constant_default(+_), line) : y2;
  };
  line.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ === "function" ? _ : constant_default(!!_), line) : defined3;
  };
  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };
  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };
  return line;
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/area.js
function area_default(x0, y0, y1) {
  var x1 = null, defined3 = constant_default(true), context = null, curve = linear_default, output = null, path2 = withPath(area);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x : constant_default(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant_default(0) : constant_default(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y : constant_default(+y1);
  function area(data2) {
    var i, j, k2, n = (data2 = array_default(data2)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
    if (context == null) output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined3(d = data2[i], i, data2)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i - 1; k2 >= j; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data2), y0z[i] = +y0(d, i, data2);
        output.point(x1 ? +x1(d, i, data2) : x0z[i], y1 ? +y1(d, i, data2) : y0z[i]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return line_default().defined(defined3).curve(curve).context(context);
  }
  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant_default(+_), x1 = null, area) : x0;
  };
  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant_default(+_), area) : x0;
  };
  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant_default(+_), area) : x1;
  };
  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant_default(+_), y1 = null, area) : y0;
  };
  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant_default(+_), area) : y0;
  };
  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant_default(+_), area) : y1;
  };
  area.lineX0 = area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ === "function" ? _ : constant_default(!!_), area) : defined3;
  };
  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/bump.js
var Bump = class {
  constructor(context, x2) {
    this._context = context;
    this._x = x2;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  }
  point(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0: {
        this._point = 1;
        if (this._line) this._context.lineTo(x2, y2);
        else this._context.moveTo(x2, y2);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x2) / 2, this._y0, this._x0, y2, x2, y2);
        else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y2) / 2, x2, this._y0, x2, y2);
        break;
      }
    }
    this._x0 = x2, this._y0 = y2;
  }
};
function bumpX(context) {
  return new Bump(context, true);
}
function bumpY(context) {
  return new Bump(context, false);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/circle.js
var circle_default = {
  draw(context, size) {
    const r2 = sqrt(size / pi);
    context.moveTo(r2, 0);
    context.arc(0, 0, r2, 0, tau);
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/cross.js
var cross_default = {
  draw(context, size) {
    const r2 = sqrt(size / 5) / 2;
    context.moveTo(-3 * r2, -r2);
    context.lineTo(-r2, -r2);
    context.lineTo(-r2, -3 * r2);
    context.lineTo(r2, -3 * r2);
    context.lineTo(r2, -r2);
    context.lineTo(3 * r2, -r2);
    context.lineTo(3 * r2, r2);
    context.lineTo(r2, r2);
    context.lineTo(r2, 3 * r2);
    context.lineTo(-r2, 3 * r2);
    context.lineTo(-r2, r2);
    context.lineTo(-3 * r2, r2);
    context.closePath();
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/diamond.js
var tan30 = sqrt(1 / 3);
var tan30_2 = tan30 * 2;
var diamond_default = {
  draw(context, size) {
    const y2 = sqrt(size / tan30_2);
    const x2 = y2 * tan30;
    context.moveTo(0, -y2);
    context.lineTo(x2, 0);
    context.lineTo(0, y2);
    context.lineTo(-x2, 0);
    context.closePath();
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/square.js
var square_default = {
  draw(context, size) {
    const w = sqrt(size);
    const x2 = -w / 2;
    context.rect(x2, x2, w, w);
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/star.js
var ka = 0.8908130915292852;
var kr = sin(pi / 10) / sin(7 * pi / 10);
var kx = sin(tau / 10) * kr;
var ky = -cos(tau / 10) * kr;
var star_default = {
  draw(context, size) {
    const r2 = sqrt(size * ka);
    const x2 = kx * r2;
    const y2 = ky * r2;
    context.moveTo(0, -r2);
    context.lineTo(x2, y2);
    for (let i = 1; i < 5; ++i) {
      const a2 = tau * i / 5;
      const c2 = cos(a2);
      const s2 = sin(a2);
      context.lineTo(s2 * r2, -c2 * r2);
      context.lineTo(c2 * x2 - s2 * y2, s2 * x2 + c2 * y2);
    }
    context.closePath();
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/triangle.js
var sqrt3 = sqrt(3);
var triangle_default = {
  draw(context, size) {
    const y2 = -sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y2 * 2);
    context.lineTo(-sqrt3 * y2, -y2);
    context.lineTo(sqrt3 * y2, -y2);
    context.closePath();
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol/wye.js
var c = -0.5;
var s = sqrt(3) / 2;
var k = 1 / sqrt(12);
var a = (k / 2 + 1) * 3;
var wye_default = {
  draw(context, size) {
    const r2 = sqrt(size / a);
    const x0 = r2 / 2, y0 = r2 * k;
    const x1 = x0, y1 = r2 * k + r2;
    const x2 = -x1, y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/symbol.js
function Symbol2(type, size) {
  let context = null, path2 = withPath(symbol);
  type = typeof type === "function" ? type : constant_default(type || circle_default);
  size = typeof size === "function" ? size : constant_default(size === void 0 ? 64 : +size);
  function symbol() {
    let buffer;
    if (!context) context = buffer = path2();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }
  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant_default(_), symbol) : type;
  };
  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant_default(+_), symbol) : size;
  };
  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };
  return symbol;
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/noop.js
function noop_default() {
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basis.js
function point(that, x2, y2) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x2) / 6,
    (that._y0 + 4 * that._y1 + y2) / 6
  );
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        point(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basis_default(context) {
  return new Basis(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisClosed.js
function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop_default,
  areaEnd: noop_default,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x2, this._y2 = y2;
        break;
      case 1:
        this._point = 2;
        this._x3 = x2, this._y3 = y2;
        break;
      case 2:
        this._point = 3;
        this._x4 = x2, this._y4 = y2;
        this._context.moveTo((this._x0 + 4 * this._x1 + x2) / 6, (this._y0 + 4 * this._y1 + y2) / 6);
        break;
      default:
        point(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisClosed_default(context) {
  return new BasisClosed(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basisOpen.js
function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x2) / 6, y0 = (this._y0 + 4 * this._y1 + y2) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisOpen_default(context) {
  return new BasisOpen(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linearClosed.js
function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop_default,
  areaEnd: noop_default,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) this._context.lineTo(x2, y2);
    else this._point = 1, this._context.moveTo(x2, y2);
  }
};
function linearClosed_default(context) {
  return new LinearClosed(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/monotone.js
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
function point2(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point2(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t12 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1) return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point2(this, slope2(this, t12 = slope3(this, x2, y2)), t12);
        break;
      default:
        point2(this, this._t0, t12 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x2, y2) {
  MonotoneX.prototype.point.call(this, y2, x2);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y3, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/natural.js
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, n = x2.length;
    if (n) {
      this._line ? this._context.lineTo(x2[0], y2[0]) : this._context.moveTo(x2[0], y2[0]);
      if (n === 2) {
        this._context.lineTo(x2[1], y2[1]);
      } else {
        var px = controlPoints(x2), py = controlPoints(y2);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x2[i1], y2[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
function controlPoints(x2) {
  var i, n = x2.length - 1, m, a2 = new Array(n), b = new Array(n), r2 = new Array(n);
  a2[0] = 0, b[0] = 2, r2[0] = x2[0] + 2 * x2[1];
  for (i = 1; i < n - 1; ++i) a2[i] = 1, b[i] = 4, r2[i] = 4 * x2[i] + 2 * x2[i + 1];
  a2[n - 1] = 2, b[n - 1] = 7, r2[n - 1] = 8 * x2[n - 1] + x2[n];
  for (i = 1; i < n; ++i) m = a2[i] / b[i - 1], b[i] -= m, r2[i] -= m * r2[i - 1];
  a2[n - 1] = r2[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a2[i] = (r2[i] - a2[i + 1]) / b[i];
  b[n - 1] = (x2[n] + a2[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x2[i + 1] - a2[i + 1];
  return [a2, b];
}
function natural_default(context) {
  return new Natural(context);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
  this._context = context;
  this._t = t;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x1 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function step_default(context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/none.js
function none_default(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/order/none.js
function none_default2(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/stack.js
function stackValue(d, key2) {
  return d[key2];
}
function stackSeries(key2) {
  const series = [];
  series.key = key2;
  return series;
}
function stack_default() {
  var keys2 = constant_default([]), order = none_default2, offset = none_default, value2 = stackValue;
  function stack(data2) {
    var sz = Array.from(keys2.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
    for (const d of data2) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value2(d, sz[i].key, j, data2)]).data = d;
      }
    }
    for (i = 0, oz = array_default(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }
    offset(sz, oz);
    return sz;
  }
  stack.keys = function(_) {
    return arguments.length ? (keys2 = typeof _ === "function" ? _ : constant_default(Array.from(_)), stack) : keys2;
  };
  stack.value = function(_) {
    return arguments.length ? (value2 = typeof _ === "function" ? _ : constant_default(+_), stack) : value2;
  };
  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none_default2 : typeof _ === "function" ? _ : constant_default(Array.from(_)), stack) : order;
  };
  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none_default : _, stack) : offset;
  };
  return stack;
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/expand.js
function expand_default(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y2; j < m; ++j) {
    for (y2 = i = 0; i < n; ++i) y2 += series[i][j][1] || 0;
    if (y2) for (i = 0; i < n; ++i) series[i][j][1] /= y2;
  }
  none_default(series, order);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/silhouette.js
function silhouette_default(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y2 = 0; i < n; ++i) y2 += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y2 / 2;
  }
  none_default(series, order);
}

// node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/offset/wiggle.js
function wiggle_default(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y2 = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
      for (var k2 = 0; k2 < i; ++k2) {
        var sk = series[order[k2]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y2;
    if (s1) y2 -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y2;
  none_default(series, order);
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/shape/Symbols.js
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
var _excluded6 = ["type", "size", "sizeType"];
function _extends4() {
  _extends4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
function ownKeys3(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread3(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys3(Object(t), true).forEach(function(r3) {
      _defineProperty3(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys3(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty3(obj, key2, value2) {
  key2 = _toPropertyKey3(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof4(i) ? i : i + "";
}
function _toPrimitive3(t, r2) {
  if ("object" != _typeof4(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof4(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _objectWithoutProperties6(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var symbolFactories = {
  symbolCircle: circle_default,
  symbolCross: cross_default,
  symbolDiamond: diamond_default,
  symbolSquare: square_default,
  symbolStar: star_default,
  symbolTriangle: triangle_default,
  symbolWye: wye_default
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory2(type) {
  var name2 = "symbol".concat((0, import_upperFirst.default)(type));
  return symbolFactories[name2] || circle_default;
};
var calculateAreaSize = function calculateAreaSize2(size, sizeType, type) {
  if (sizeType === "area") {
    return size;
  }
  switch (type) {
    case "cross":
      return 5 * size * size / 9;
    case "diamond":
      return 0.5 * size * size / Math.sqrt(3);
    case "square":
      return size * size;
    case "star": {
      var angle = 18 * RADIAN;
      return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
    }
    case "triangle":
      return Math.sqrt(3) * size * size / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
};
var registerSymbol = function registerSymbol2(key2, factory17) {
  symbolFactories["symbol".concat((0, import_upperFirst.default)(key2))] = factory17;
};
var Symbols = function Symbols2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = _objectWithoutProperties6(_ref, _excluded6);
  var props = _objectSpread3(_objectSpread3({}, rest), {}, {
    type,
    size,
    sizeType
  });
  var getPath5 = function getPath6() {
    var symbolFactory = getSymbolFactory(type);
    var symbol = Symbol2().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
    return symbol();
  };
  var className = props.className, cx = props.cx, cy = props.cy;
  var filteredProps = filterProps(props, true);
  if (cx === +cx && cy === +cy && size === +size) {
    return /* @__PURE__ */ React43.createElement("path", _extends4({}, filteredProps, {
      className: clsx_default("recharts-symbols", className),
      transform: "translate(".concat(cx, ", ").concat(cy, ")"),
      d: getPath5()
    }));
  }
  return null;
};
Symbols.registerSymbol = registerSymbol;

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/DefaultLegendContent.js
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
function _extends5() {
  _extends5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
function ownKeys4(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread4(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys4(Object(t), true).forEach(function(r3) {
      _defineProperty4(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys4(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey4(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof5(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty4(obj, key2, value2) {
  key2 = _toPropertyKey4(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey4(t) {
  var i = _toPrimitive4(t, "string");
  return "symbol" == _typeof5(i) ? i : i + "";
}
function _toPrimitive4(t, r2) {
  if ("object" != _typeof5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var SIZE = 32;
var DefaultLegendContent = /* @__PURE__ */ function(_PureComponent) {
  function DefaultLegendContent2() {
    _classCallCheck(this, DefaultLegendContent2);
    return _callSuper(this, DefaultLegendContent2, arguments);
  }
  _inherits(DefaultLegendContent2, _PureComponent);
  return _createClass(DefaultLegendContent2, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function renderIcon(data2) {
        var inactiveColor = this.props.inactiveColor;
        var halfSize = SIZE / 2;
        var sixthSize = SIZE / 6;
        var thirdSize = SIZE / 3;
        var color2 = data2.inactive ? inactiveColor : data2.color;
        if (data2.type === "plainline") {
          return /* @__PURE__ */ React43.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            strokeDasharray: data2.payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
          });
        }
        if (data2.type === "line") {
          return /* @__PURE__ */ React43.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
            className: "recharts-legend-icon"
          });
        }
        if (data2.type === "rect") {
          return /* @__PURE__ */ React43.createElement("path", {
            stroke: "none",
            fill: color2,
            d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        }
        if (/* @__PURE__ */ React43.isValidElement(data2.legendIcon)) {
          var iconProps = _objectSpread4({}, data2);
          delete iconProps.legendIcon;
          return /* @__PURE__ */ React43.cloneElement(data2.legendIcon, iconProps);
        }
        return /* @__PURE__ */ React43.createElement(Symbols, {
          fill: color2,
          cx: halfSize,
          cy: halfSize,
          size: SIZE,
          sizeType: "diameter",
          type: data2.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;
      var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      };
      var svgStyle = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return payload.map(function(entry, i) {
        var finalFormatter = entry.formatter || formatter;
        var className = clsx_default(_defineProperty4(_defineProperty4({
          "recharts-legend-item": true
        }, "legend-item-".concat(i), true), "inactive", entry.inactive));
        if (entry.type === "none") {
          return null;
        }
        var entryValue = !(0, import_isFunction2.default)(entry.value) ? entry.value : null;
        warn(
          !(0, import_isFunction2.default)(entry.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var color2 = entry.inactive ? inactiveColor : entry.color;
        return /* @__PURE__ */ React43.createElement("li", _extends5({
          className,
          style: itemStyle,
          key: "legend-item-".concat(i)
        }, adaptEventsOfChild(_this.props, entry, i)), /* @__PURE__ */ React43.createElement(Surface, {
          width: iconSize,
          height: iconSize,
          viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /* @__PURE__ */ React43.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color2
          }
        }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
      if (!payload || !payload.length) {
        return null;
      }
      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === "horizontal" ? align : "left"
      };
      return /* @__PURE__ */ React43.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);
}(PureComponent);
_defineProperty4(DefaultLegendContent, "displayName", "Legend");
_defineProperty4(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/payload/getUniqPayload.js
var import_uniqBy = __toESM(require_uniqBy());
var import_isFunction3 = __toESM(require_isFunction());
function getUniqPayload(payload, option, defaultUniqBy3) {
  if (option === true) {
    return (0, import_uniqBy.default)(payload, defaultUniqBy3);
  }
  if ((0, import_isFunction3.default)(option)) {
    return (0, import_uniqBy.default)(payload, option);
  }
  return payload;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Legend.js
function _typeof6(o) {
  "@babel/helpers - typeof";
  return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof6(o);
}
var _excluded7 = ["ref"];
function ownKeys5(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread5(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys5(Object(t), true).forEach(function(r3) {
      _defineProperty5(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys5(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey5(descriptor.key), descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper2(t, o, e) {
  return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn2(self2, call) {
  if (call && (_typeof6(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized2(self2);
}
function _assertThisInitialized2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct2 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf2(o) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf2(o);
}
function _inherits2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf2(subClass, superClass);
}
function _setPrototypeOf2(o, p) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf2(o, p);
}
function _defineProperty5(obj, key2, value2) {
  key2 = _toPropertyKey5(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey5(t) {
  var i = _toPrimitive5(t, "string");
  return "symbol" == _typeof6(i) ? i : i + "";
}
function _toPrimitive5(t, r2) {
  if ("object" != _typeof6(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof6(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function defaultUniqBy(entry) {
  return entry.value;
}
function renderContent(content2, props) {
  if (/* @__PURE__ */ React43.isValidElement(content2)) {
    return /* @__PURE__ */ React43.cloneElement(content2, props);
  }
  if (typeof content2 === "function") {
    return /* @__PURE__ */ React43.createElement(content2, props);
  }
  props.ref; var otherProps = _objectWithoutProperties7(props, _excluded7);
  return /* @__PURE__ */ React43.createElement(DefaultLegendContent, otherProps);
}
var EPS = 1;
var Legend = /* @__PURE__ */ function(_PureComponent) {
  function Legend2() {
    var _this;
    _classCallCheck2(this, Legend2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper2(this, Legend2, [].concat(args));
    _defineProperty5(_this, "lastBoundingBox", {
      width: -1,
      height: -1
    });
    return _this;
  }
  _inherits2(Legend2, _PureComponent);
  return _createClass2(Legend2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        box.height = this.wrapperNode.offsetHeight;
        box.width = this.wrapperNode.offsetWidth;
        return box;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var onBBoxUpdate = this.props.onBBoxUpdate;
      var box = this.getBBox();
      if (box) {
        if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
          this.lastBoundingBox.width = box.width;
          this.lastBoundingBox.height = box.height;
          if (onBBoxUpdate) {
            onBBoxUpdate(box);
          }
        }
      } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
        this.lastBoundingBox.width = -1;
        this.lastBoundingBox.height = -1;
        if (onBBoxUpdate) {
          onBBoxUpdate(null);
        }
      }
    }
  }, {
    key: "getBBoxSnapshot",
    value: function getBBoxSnapshot() {
      if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) {
        return _objectSpread5({}, this.lastBoundingBox);
      }
      return {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
      var hPos, vPos;
      if (!style || (style.left === void 0 || style.left === null) && (style.right === void 0 || style.right === null)) {
        if (align === "center" && layout === "vertical") {
          var box = this.getBBoxSnapshot();
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === "right" ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }
      if (!style || (style.top === void 0 || style.top === null) && (style.bottom === void 0 || style.bottom === null)) {
        if (verticalAlign === "middle") {
          var _box = this.getBBoxSnapshot();
          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === "bottom" ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }
      return _objectSpread5(_objectSpread5({}, hPos), vPos);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props, content2 = _this$props2.content, width2 = _this$props2.width, height2 = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
      var outerStyle = _objectSpread5(_objectSpread5({
        position: "absolute",
        width: width2 || "auto",
        height: height2 || "auto"
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
      return /* @__PURE__ */ React43.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content2, _objectSpread5(_objectSpread5({}, this.props), {}, {
        payload: getUniqPayload(payload, payloadUniqBy, defaultUniqBy)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var _this$defaultProps$it = _objectSpread5(_objectSpread5({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
      if (layout === "vertical" && isNumber(item.props.height)) {
        return {
          height: item.props.height
        };
      }
      if (layout === "horizontal") {
        return {
          width: item.props.width || chartWidth
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_defineProperty5(Legend, "displayName", "Legend");
_defineProperty5(Legend, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/DefaultTooltipContent.js
var import_sortBy = __toESM(require_sortBy());
var import_isNil2 = __toESM(require_isNil());
function _typeof7(o) {
  "@babel/helpers - typeof";
  return _typeof7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof7(o);
}
function _extends6() {
  _extends6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit2(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys6(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread6(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys6(Object(t), true).forEach(function(r3) {
      _defineProperty6(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys6(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty6(obj, key2, value2) {
  key2 = _toPropertyKey6(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey6(t) {
  var i = _toPrimitive6(t, "string");
  return "symbol" == _typeof7(i) ? i : i + "";
}
function _toPrimitive6(t, r2) {
  if ("object" != _typeof7(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof7(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function defaultFormatter(value2) {
  return Array.isArray(value2) && isNumOrStr(value2[0]) && isNumOrStr(value2[1]) ? value2.join(" ~ ") : value2;
}
var DefaultTooltipContent = function DefaultTooltipContent2(props) {
  var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
  var renderContent3 = function renderContent4() {
    if (payload && payload.length) {
      var listStyle = {
        padding: 0,
        margin: 0
      };
      var items = (itemSorter ? (0, import_sortBy.default)(payload, itemSorter) : payload).map(function(entry, i) {
        if (entry.type === "none") {
          return null;
        }
        var finalItemStyle = _objectSpread6({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: entry.color || "#000"
        }, itemStyle);
        var finalFormatter = entry.formatter || formatter || defaultFormatter;
        var value2 = entry.value, name2 = entry.name;
        var finalValue = value2;
        var finalName = name2;
        if (finalFormatter && finalValue != null && finalName != null) {
          var formatted = finalFormatter(value2, name2, entry, i, payload);
          if (Array.isArray(formatted)) {
            var _formatted = _slicedToArray2(formatted, 2);
            finalValue = _formatted[0];
            finalName = _formatted[1];
          } else {
            finalValue = formatted;
          }
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React43.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(i),
            style: finalItemStyle
          }, isNumOrStr(finalName) ? /* @__PURE__ */ React43.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, finalName) : null, isNumOrStr(finalName) ? /* @__PURE__ */ React43.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, separator) : null, /* @__PURE__ */ React43.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, finalValue), /* @__PURE__ */ React43.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, entry.unit || ""))
        );
      });
      return /* @__PURE__ */ React43.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: listStyle
      }, items);
    }
    return null;
  };
  var finalStyle = _objectSpread6({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, contentStyle);
  var finalLabelStyle = _objectSpread6({
    margin: 0
  }, labelStyle);
  var hasLabel = !(0, import_isNil2.default)(label);
  var finalLabel = hasLabel ? label : "";
  var wrapperCN = clsx_default("recharts-default-tooltip", wrapperClassName);
  var labelCN = clsx_default("recharts-tooltip-label", labelClassName);
  if (hasLabel && labelFormatter && payload !== void 0 && payload !== null) {
    finalLabel = labelFormatter(label, payload);
  }
  var accessibilityAttributes = accessibilityLayer ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ React43.createElement("div", _extends6({
    className: wrapperCN,
    style: finalStyle
  }, accessibilityAttributes), /* @__PURE__ */ React43.createElement("p", {
    className: labelCN,
    style: finalLabelStyle
  }, /* @__PURE__ */ React43.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent3());
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/tooltip/translate.js
function _typeof8(o) {
  "@babel/helpers - typeof";
  return _typeof8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof8(o);
}
function _defineProperty7(obj, key2, value2) {
  key2 = _toPropertyKey7(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey7(t) {
  var i = _toPrimitive7(t, "string");
  return "symbol" == _typeof8(i) ? i : i + "";
}
function _toPrimitive7(t, r2) {
  if ("object" != _typeof8(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof8(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var TOOLTIP_HIDDEN = {
  visibility: "hidden"
};
function getTooltipCSSClassName(_ref) {
  var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
  return clsx_default(CSS_CLASS_PREFIX, _defineProperty7(_defineProperty7(_defineProperty7(_defineProperty7({}, "".concat(CSS_CLASS_PREFIX, "-right"), isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
  var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key2 = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position2 = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
  if (position2 && isNumber(position2[key2])) {
    return position2[key2];
  }
  var negative = coordinate[key2] - tooltipDimension - offsetTopLeft;
  var positive = coordinate[key2] + offsetTopLeft;
  if (allowEscapeViewBox[key2]) {
    return reverseDirection[key2] ? negative : positive;
  }
  if (reverseDirection[key2]) {
    var _tooltipBoundary = negative;
    var _viewBoxBoundary = viewBox[key2];
    if (_tooltipBoundary < _viewBoxBoundary) {
      return Math.max(positive, viewBox[key2]);
    }
    return Math.max(negative, viewBox[key2]);
  }
  var tooltipBoundary = positive + tooltipDimension;
  var viewBoxBoundary = viewBox[key2] + viewBoxDimension;
  if (tooltipBoundary > viewBoxBoundary) {
    return Math.max(negative, viewBox[key2]);
  }
  return Math.max(positive, viewBox[key2]);
}
function getTransformStyle(_ref3) {
  var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
  return {
    transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
  };
}
function getTooltipTranslate(_ref4) {
  var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position2 = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
  var cssProperties, translateX, translateY;
  if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
    translateX = getTooltipTranslateXY({
      allowEscapeViewBox,
      coordinate,
      key: "x",
      offsetTopLeft,
      position: position2,
      reverseDirection,
      tooltipDimension: tooltipBox.width,
      viewBox,
      viewBoxDimension: viewBox.width
    });
    translateY = getTooltipTranslateXY({
      allowEscapeViewBox,
      coordinate,
      key: "y",
      offsetTopLeft,
      position: position2,
      reverseDirection,
      tooltipDimension: tooltipBox.height,
      viewBox,
      viewBoxDimension: viewBox.height
    });
    cssProperties = getTransformStyle({
      translateX,
      translateY,
      useTranslate3d
    });
  } else {
    cssProperties = TOOLTIP_HIDDEN;
  }
  return {
    cssProperties,
    cssClasses: getTooltipCSSClassName({
      translateX,
      translateY,
      coordinate
    })
  };
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/TooltipBoundingBox.js
function _typeof9(o) {
  "@babel/helpers - typeof";
  return _typeof9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof9(o);
}
function ownKeys7(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread7(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys7(Object(t), true).forEach(function(r3) {
      _defineProperty8(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys7(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey8(descriptor.key), descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties3(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper3(t, o, e) {
  return o = _getPrototypeOf3(o), _possibleConstructorReturn3(t, _isNativeReflectConstruct3() ? Reflect.construct(o, e || [], _getPrototypeOf3(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn3(self2, call) {
  if (call && (_typeof9(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized3(self2);
}
function _assertThisInitialized3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct3() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct3 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf3(o) {
  _getPrototypeOf3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf3(o);
}
function _inherits3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf3(subClass, superClass);
}
function _setPrototypeOf3(o, p) {
  _setPrototypeOf3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf3(o, p);
}
function _defineProperty8(obj, key2, value2) {
  key2 = _toPropertyKey8(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey8(t) {
  var i = _toPrimitive8(t, "string");
  return "symbol" == _typeof9(i) ? i : i + "";
}
function _toPrimitive8(t, r2) {
  if ("object" != _typeof9(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof9(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
var EPSILON = 1;
var TooltipBoundingBox = /* @__PURE__ */ function(_PureComponent) {
  function TooltipBoundingBox2() {
    var _this;
    _classCallCheck3(this, TooltipBoundingBox2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper3(this, TooltipBoundingBox2, [].concat(args));
    _defineProperty8(_this, "state", {
      dismissed: false,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    });
    _defineProperty8(_this, "handleKeyDown", function(event) {
      if (event.key === "Escape") {
        var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
        _this.setState({
          dismissed: true,
          dismissedAtCoordinate: {
            x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
            y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
          }
        });
      }
    });
    return _this;
  }
  _inherits3(TooltipBoundingBox2, _PureComponent);
  return _createClass3(TooltipBoundingBox2, [{
    key: "updateBBox",
    value: function updateBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) {
          this.setState({
            lastBoundingBox: {
              width: box.width,
              height: box.height
            }
          });
        }
      } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) {
        this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
      this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props$coordinat5, _this$props$coordinat6;
      if (this.props.active) {
        this.updateBBox();
      }
      if (!this.state.dismissed) {
        return;
      }
      if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) {
        this.state.dismissed = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props, active2 = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position2 = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
      var _getTooltipTranslate = getTooltipTranslate({
        allowEscapeViewBox,
        coordinate,
        offsetTopLeft: offset,
        position: position2,
        reverseDirection,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d,
        viewBox
      }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
      var outerStyle = _objectSpread7(_objectSpread7({
        transition: isAnimationActive && active2 ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : void 0
      }, cssProperties), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && active2 && hasPayload ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, wrapperStyle);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ React43.createElement("div", {
          tabIndex: -1,
          className: cssClasses,
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        }, children)
      );
    }
  }]);
}(PureComponent);

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/Global.js
var parseIsSsrByDefault = function parseIsSsrByDefault2() {
  return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
  isSsr: parseIsSsrByDefault()};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Tooltip.js
function _typeof10(o) {
  "@babel/helpers - typeof";
  return _typeof10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof10(o);
}
function ownKeys8(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread8(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys8(Object(t), true).forEach(function(r3) {
      _defineProperty9(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys8(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey9(descriptor.key), descriptor);
  }
}
function _createClass4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties4(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper4(t, o, e) {
  return o = _getPrototypeOf4(o), _possibleConstructorReturn4(t, _isNativeReflectConstruct4() ? Reflect.construct(o, e || [], _getPrototypeOf4(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn4(self2, call) {
  if (call && (_typeof10(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized4(self2);
}
function _assertThisInitialized4(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct4 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf4(o) {
  _getPrototypeOf4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf4(o);
}
function _inherits4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf4(subClass, superClass);
}
function _setPrototypeOf4(o, p) {
  _setPrototypeOf4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf4(o, p);
}
function _defineProperty9(obj, key2, value2) {
  key2 = _toPropertyKey9(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey9(t) {
  var i = _toPrimitive9(t, "string");
  return "symbol" == _typeof10(i) ? i : i + "";
}
function _toPrimitive9(t, r2) {
  if ("object" != _typeof10(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof10(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function defaultUniqBy2(entry) {
  return entry.dataKey;
}
function renderContent2(content2, props) {
  if (/* @__PURE__ */ React43.isValidElement(content2)) {
    return /* @__PURE__ */ React43.cloneElement(content2, props);
  }
  if (typeof content2 === "function") {
    return /* @__PURE__ */ React43.createElement(content2, props);
  }
  return /* @__PURE__ */ React43.createElement(DefaultTooltipContent, props);
}
var Tooltip2 = /* @__PURE__ */ function(_PureComponent) {
  function Tooltip3() {
    _classCallCheck4(this, Tooltip3);
    return _callSuper4(this, Tooltip3, arguments);
  }
  _inherits4(Tooltip3, _PureComponent);
  return _createClass4(Tooltip3, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props, active2 = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content2 = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position2 = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
      var finalPayload = payload !== null && payload !== void 0 ? payload : [];
      if (filterNull && finalPayload.length) {
        finalPayload = getUniqPayload(payload.filter(function(entry) {
          return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
        }), payloadUniqBy, defaultUniqBy2);
      }
      var hasPayload = finalPayload.length > 0;
      return /* @__PURE__ */ React43.createElement(TooltipBoundingBox, {
        allowEscapeViewBox,
        animationDuration,
        animationEasing,
        isAnimationActive,
        active: active2,
        coordinate,
        hasPayload,
        offset,
        position: position2,
        reverseDirection,
        useTranslate3d,
        viewBox,
        wrapperStyle
      }, renderContent2(content2, _objectSpread8(_objectSpread8({}, this.props), {}, {
        payload: finalPayload
      })));
    }
  }]);
}(PureComponent);
_defineProperty9(Tooltip2, "displayName", "Tooltip");
_defineProperty9(Tooltip2, "defaultProps", {
  accessibilityLayer: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: true,
  cursorStyle: {},
  filterNull: true,
  isAnimationActive: !Global.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: false,
    y: false
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: false,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/ResponsiveContainer.js
var import_throttle = __toESM(require_throttle());
function _typeof11(o) {
  "@babel/helpers - typeof";
  return _typeof11 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof11(o);
}
function ownKeys9(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread9(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys9(Object(t), true).forEach(function(r3) {
      _defineProperty10(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys9(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty10(obj, key2, value2) {
  key2 = _toPropertyKey10(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey10(t) {
  var i = _toPrimitive10(t, "string");
  return "symbol" == _typeof11(i) ? i : i + "";
}
function _toPrimitive10(t, r2) {
  if ("object" != _typeof11(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof11(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _slicedToArray3(arr, i) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i) || _unsupportedIterableToArray3(arr, i) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit3(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
    width: -1,
    height: -1
  } : _ref$initialDimension, _ref$width = _ref.width, width2 = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
  var containerRef = useRef(null);
  var onResizeRef = useRef();
  onResizeRef.current = onResize;
  useImperativeHandle(ref, function() {
    return Object.defineProperty(containerRef.current, "current", {
      get: function get8() {
        console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
        return containerRef.current;
      },
      configurable: true
    });
  });
  var _useState = useState({
    containerWidth: initialDimension.width,
    containerHeight: initialDimension.height
  }), _useState2 = _slicedToArray3(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
  var setContainerSize = useCallback(function(newWidth, newHeight) {
    setSizes(function(prevState) {
      var roundedWidth = Math.round(newWidth);
      var roundedHeight = Math.round(newHeight);
      if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) {
        return prevState;
      }
      return {
        containerWidth: roundedWidth,
        containerHeight: roundedHeight
      };
    });
  }, []);
  useEffect(function() {
    var callback = function callback2(entries) {
      var _onResizeRef$current;
      var _entries$0$contentRec = entries[0].contentRect, containerWidth2 = _entries$0$contentRec.width, containerHeight2 = _entries$0$contentRec.height;
      setContainerSize(containerWidth2, containerHeight2);
      (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth2, containerHeight2);
    };
    if (debounce > 0) {
      callback = (0, import_throttle.default)(callback, debounce, {
        trailing: true,
        leading: false
      });
    }
    var observer = new ResizeObserver(callback);
    var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
    setContainerSize(containerWidth, containerHeight);
    observer.observe(containerRef.current);
    return function() {
      observer.disconnect();
    };
  }, [setContainerSize, debounce]);
  var chartContent = useMemo(function() {
    var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
    if (containerWidth < 0 || containerHeight < 0) {
      return null;
    }
    warn(isPercent(width2) || isPercent(height2), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width2, height2);
    warn(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
    var calculatedWidth = isPercent(width2) ? containerWidth : width2;
    var calculatedHeight = isPercent(height2) ? containerHeight : height2;
    if (aspect && aspect > 0) {
      if (calculatedWidth) {
        calculatedHeight = calculatedWidth / aspect;
      } else if (calculatedHeight) {
        calculatedWidth = calculatedHeight * aspect;
      }
      if (maxHeight && calculatedHeight > maxHeight) {
        calculatedHeight = maxHeight;
      }
    }
    warn(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width2, height2, minWidth, minHeight, aspect);
    var isCharts = !Array.isArray(children) && getDisplayName(children.type).endsWith("Chart");
    return React43.Children.map(children, function(child) {
      if (/* @__PURE__ */ React43.isValidElement(child)) {
        return /* @__PURE__ */ cloneElement(child, _objectSpread9({
          width: calculatedWidth,
          height: calculatedHeight
        }, isCharts ? {
          style: _objectSpread9({
            height: "100%",
            width: "100%",
            maxHeight: calculatedHeight,
            maxWidth: calculatedWidth
          }, child.props.style)
        } : {}));
      }
      return child;
    });
  }, [aspect, children, height2, maxHeight, minHeight, minWidth, sizes, width2]);
  return /* @__PURE__ */ React43.createElement("div", {
    id: id ? "".concat(id) : void 0,
    className: clsx_default("recharts-responsive-container", className),
    style: _objectSpread9(_objectSpread9({}, style), {}, {
      width: width2,
      height: height2,
      minWidth,
      minHeight,
      maxHeight
    }),
    ref: containerRef
  }, chartContent);
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Cell.js
var Cell = function Cell2(_props) {
  return null;
};
Cell.displayName = "Cell";

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Text.js
var import_isNil3 = __toESM(require_isNil());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/DOMUtils.js
function _typeof12(o) {
  "@babel/helpers - typeof";
  return _typeof12 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof12(o);
}
function ownKeys10(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread10(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys10(Object(t), true).forEach(function(r3) {
      _defineProperty11(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys10(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty11(obj, key2, value2) {
  key2 = _toPropertyKey11(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey11(t) {
  var i = _toPrimitive11(t, "string");
  return "symbol" == _typeof12(i) ? i : i + "";
}
function _toPrimitive11(t, r2) {
  if ("object" != _typeof12(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof12(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2e3;
var SPAN_STYLE = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
};
var MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function removeInvalidKeys(obj) {
  var copyObj = _objectSpread10({}, obj);
  Object.keys(copyObj).forEach(function(key2) {
    if (!copyObj[key2]) {
      delete copyObj[key2];
    }
  });
  return copyObj;
}
var getStringSize = function getStringSize2(text2) {
  var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (text2 === void 0 || text2 === null || Global.isSsr) {
    return {
      width: 0,
      height: 0
    };
  }
  var copyStyle = removeInvalidKeys(style);
  var cacheKey = JSON.stringify({
    text: text2,
    copyStyle
  });
  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }
  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement("span");
      measurementSpan.setAttribute("id", MEASUREMENT_SPAN_ID);
      measurementSpan.setAttribute("aria-hidden", "true");
      document.body.appendChild(measurementSpan);
    }
    var measurementSpanStyle = _objectSpread10(_objectSpread10({}, SPAN_STYLE), copyStyle);
    Object.assign(measurementSpan.style, measurementSpanStyle);
    measurementSpan.textContent = "".concat(text2);
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;
    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }
    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0
    };
  }
};
var getOffset = function getOffset2(rect) {
  return {
    top: rect.top + window.scrollY - document.documentElement.clientTop,
    left: rect.left + window.scrollX - document.documentElement.clientLeft
  };
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ReduceCSSCalc.js
function _typeof13(o) {
  "@babel/helpers - typeof";
  return _typeof13 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof13(o);
}
function _slicedToArray4(arr, i) {
  return _arrayWithHoles4(arr) || _iterableToArrayLimit4(arr, i) || _unsupportedIterableToArray4(arr, i) || _nonIterableRest4();
}
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit4(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles4(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey12(descriptor.key), descriptor);
  }
}
function _createClass5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey12(t) {
  var i = _toPrimitive12(t, "string");
  return "symbol" == _typeof13(i) ? i : i + "";
}
function _toPrimitive12(t, r2) {
  if ("object" != _typeof13(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof13(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  "in": 96,
  Q: 96 / (2.54 * 40),
  px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = "NaN";
function convertToPx(value2, unit2) {
  return value2 * CONVERSION_RATES[unit2];
}
var DecimalCSS = /* @__PURE__ */ function() {
  function DecimalCSS2(num, unit2) {
    _classCallCheck5(this, DecimalCSS2);
    this.num = num;
    this.unit = unit2;
    this.num = num;
    this.unit = unit2;
    if (Number.isNaN(num)) {
      this.unit = "";
    }
    if (unit2 !== "" && !CSS_LENGTH_UNIT_REGEX.test(unit2)) {
      this.num = NaN;
      this.unit = "";
    }
    if (FIXED_CSS_LENGTH_UNITS.includes(unit2)) {
      this.num = convertToPx(num, unit2);
      this.unit = "px";
    }
  }
  return _createClass5(DecimalCSS2, [{
    key: "add",
    value: function add3(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num + other.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function subtract2(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num - other.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function multiply(other) {
      if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num * other.num, this.unit || other.unit);
    }
  }, {
    key: "divide",
    value: function divide2(other) {
      if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num / other.num, this.unit || other.unit);
    }
  }, {
    key: "toString",
    value: function toString2() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function parse(str) {
      var _NUM_SPLIT_REGEX$exec;
      var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray4(_ref, 3), numStr = _ref2[1], unit2 = _ref2[2];
      return new DecimalCSS2(parseFloat(numStr), unit2 !== null && unit2 !== void 0 ? unit2 : "");
    }
  }]);
}();
function calculateArithmetic(expr) {
  if (expr.includes(STR_NAN)) {
    return STR_NAN;
  }
  var newExpr = expr;
  while (newExpr.includes("*") || newExpr.includes("/")) {
    var _MULTIPLY_OR_DIVIDE_R;
    var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray4(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
    var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
    var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
    var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
    if (result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
  }
  while (newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)) {
    var _ADD_OR_SUBTRACT_REGE;
    var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray4(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
    var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
    var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
    var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
    if (_result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
  }
  return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
  var newExpr = expr;
  while (newExpr.includes("(")) {
    var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray4(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
    newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
  }
  return newExpr;
}
function evaluateExpression(expression) {
  var newExpr = expression.replace(/\s+/g, "");
  newExpr = calculateParentheses(newExpr);
  newExpr = calculateArithmetic(newExpr);
  return newExpr;
}
function safeEvaluateExpression(expression) {
  try {
    return evaluateExpression(expression);
  } catch (e) {
    return STR_NAN;
  }
}
function reduceCSSCalc(expression) {
  var result = safeEvaluateExpression(expression.slice(5, -1));
  if (result === STR_NAN) {
    return "";
  }
  return result;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Text.js
var _excluded8 = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"];
var _excluded23 = ["dx", "dy", "angle", "className", "breakAll"];
function _extends7() {
  _extends7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends7.apply(this, arguments);
}
function _objectWithoutProperties8(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose8(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose8(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _slicedToArray5(arr, i) {
  return _arrayWithHoles5(arr) || _iterableToArrayLimit5(arr, i) || _unsupportedIterableToArray5(arr, i) || _nonIterableRest5();
}
function _nonIterableRest5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray5(o, minLen);
}
function _arrayLikeToArray5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit5(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles5(arr) {
  if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths2(_ref) {
  var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
  try {
    var words = [];
    if (!(0, import_isNil3.default)(children)) {
      if (breakAll) {
        words = children.toString().split("");
      } else {
        words = children.toString().split(BREAKING_SPACES);
      }
    }
    var wordsWithComputedWidth = words.map(function(word) {
      return {
        word,
        width: getStringSize(word, style).width
      };
    });
    var spaceWidth = breakAll ? 0 : getStringSize("\xA0", style).width;
    return {
      wordsWithComputedWidth,
      spaceWidth
    };
  } catch (e) {
    return null;
  }
};
var calculateWordsByLines = function calculateWordsByLines2(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
  var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
  var shouldLimitLines = isNumber(maxLines);
  var text2 = children;
  var calculate = function calculate2() {
    var words = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return words.reduce(function(result2, _ref3) {
      var word = _ref3.word, width2 = _ref3.width;
      var currentLine = result2[result2.length - 1];
      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width2 + spaceWidth < Number(lineWidth))) {
        currentLine.words.push(word);
        currentLine.width += width2 + spaceWidth;
      } else {
        var newLine = {
          words: [word],
          width: width2
        };
        result2.push(newLine);
      }
      return result2;
    }, []);
  };
  var originalResult = calculate(initialWordsWithComputedWith);
  var findLongestLine = function findLongestLine2(words) {
    return words.reduce(function(a2, b) {
      return a2.width > b.width ? a2 : b;
    });
  };
  if (!shouldLimitLines) {
    return originalResult;
  }
  var suffix = "\u2026";
  var checkOverflow = function checkOverflow2(index2) {
    var tempText = text2.slice(0, index2);
    var words = calculateWordWidths({
      breakAll,
      style,
      children: tempText + suffix
    }).wordsWithComputedWidth;
    var result2 = calculate(words);
    var doesOverflow = result2.length > maxLines || findLongestLine(result2).width > Number(lineWidth);
    return [doesOverflow, result2];
  };
  var start = 0;
  var end = text2.length - 1;
  var iterations = 0;
  var trimmedResult;
  while (start <= end && iterations <= text2.length - 1) {
    var middle = Math.floor((start + end) / 2);
    var prev = middle - 1;
    var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray5(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
    var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray5(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
    if (!doesPrevOverflow && !doesMiddleOverflow) {
      start = middle + 1;
    }
    if (doesPrevOverflow && doesMiddleOverflow) {
      end = middle - 1;
    }
    if (!doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result;
      break;
    }
    iterations++;
  }
  return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate2(children) {
  var words = !(0, import_isNil3.default)(children) ? children.toString().split(BREAKING_SPACES) : [];
  return [{
    words
  }];
};
var getWordsByLines = function getWordsByLines2(_ref4) {
  var width2 = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
  if ((width2 || scaleToFit) && !Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth;
    var wordWidths = calculateWordWidths({
      breakAll,
      children,
      style
    });
    if (wordWidths) {
      var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
      wordsWithComputedWidth = wcw;
      spaceWidth = sw;
    } else {
      return getWordsWithoutCalculate(children);
    }
    return calculateWordsByLines({
      breakAll,
      children,
      maxLines,
      style
    }, wordsWithComputedWidth, spaceWidth, width2, scaleToFit);
  }
  return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = "#808080";
var Text = function Text2(_ref5) {
  var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties8(_ref5, _excluded8);
  var wordsByLines = useMemo(function() {
    return getWordsByLines({
      breakAll: props.breakAll,
      children: props.children,
      maxLines: props.maxLines,
      scaleToFit,
      style: props.style,
      width: props.width
    });
  }, [props.breakAll, props.children, props.maxLines, scaleToFit, props.style, props.width]);
  var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties8(props, _excluded23);
  if (!isNumOrStr(propsX) || !isNumOrStr(propsY)) {
    return null;
  }
  var x2 = propsX + (isNumber(dx) ? dx : 0);
  var y2 = propsY + (isNumber(dy) ? dy : 0);
  var startDy;
  switch (verticalAnchor) {
    case "start":
      startDy = reduceCSSCalc("calc(".concat(capHeight, ")"));
      break;
    case "middle":
      startDy = reduceCSSCalc("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
      break;
    default:
      startDy = reduceCSSCalc("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
      break;
  }
  var transforms = [];
  if (scaleToFit) {
    var lineWidth = wordsByLines[0].width;
    var width2 = props.width;
    transforms.push("scale(".concat((isNumber(width2) ? width2 / lineWidth : 1) / lineWidth, ")"));
  }
  if (angle) {
    transforms.push("rotate(".concat(angle, ", ").concat(x2, ", ").concat(y2, ")"));
  }
  if (transforms.length) {
    textProps.transform = transforms.join(" ");
  }
  return /* @__PURE__ */ React43.createElement("text", _extends7({}, filterProps(textProps, true), {
    x: x2,
    y: y2,
    className: clsx_default("recharts-text", className),
    textAnchor,
    fill: fill.includes("url") ? DEFAULT_FILL : fill
  }), wordsByLines.map(function(line, index2) {
    var words = line.words.join(breakAll ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React43.createElement("tspan", {
        x: x2,
        dy: index2 === 0 ? startDy : lineHeight,
        key: "".concat(words, "-").concat(index2)
      }, words)
    );
  }));
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Label.js
var import_isNil6 = __toESM(require_isNil());
var import_isFunction6 = __toESM(require_isFunction());
var import_isObject3 = __toESM(require_isObject());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/PolarUtils.js
var import_isNil5 = __toESM(require_isNil());
var import_isFunction5 = __toESM(require_isFunction());

// node_modules/.pnpm/victory-vendor@36.9.2/node_modules/victory-vendor/es/d3-scale.js
var d3_scale_exports = {};
__export(d3_scale_exports, {
  scaleBand: () => band,
  scaleDiverging: () => diverging,
  scaleDivergingLog: () => divergingLog,
  scaleDivergingPow: () => divergingPow,
  scaleDivergingSqrt: () => divergingSqrt,
  scaleDivergingSymlog: () => divergingSymlog,
  scaleIdentity: () => identity2,
  scaleImplicit: () => implicit,
  scaleLinear: () => linear3,
  scaleLog: () => log,
  scaleOrdinal: () => ordinal,
  scalePoint: () => point3,
  scalePow: () => pow,
  scaleQuantile: () => quantile2,
  scaleQuantize: () => quantize,
  scaleRadial: () => radial,
  scaleSequential: () => sequential,
  scaleSequentialLog: () => sequentialLog,
  scaleSequentialPow: () => sequentialPow,
  scaleSequentialQuantile: () => sequentialQuantile,
  scaleSequentialSqrt: () => sequentialSqrt,
  scaleSequentialSymlog: () => sequentialSymlog,
  scaleSqrt: () => sqrt2,
  scaleSymlog: () => symlog,
  scaleThreshold: () => threshold,
  scaleTime: () => time2,
  scaleUtc: () => utcTime,
  tickFormat: () => tickFormat
});

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js
function ascending(a2, b) {
  return a2 == null || b == null ? NaN : a2 < b ? -1 : a2 > b ? 1 : a2 >= b ? 0 : NaN;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js
function descending(a2, b) {
  return a2 == null || b == null ? NaN : b < a2 ? -1 : b > a2 ? 1 : b >= a2 ? 0 : NaN;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js
function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x2) => ascending(f(d), x2);
    delta = (d, x2) => f(d) - x2;
  } else {
    compare1 = f === ascending || f === descending ? f : zero;
    compare2 = f;
    delta = f;
  }
  function left(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a2, x2, lo = 0, hi = a2.length) {
    const i = left(a2, x2, lo, hi - 1);
    return i > lo && delta(a2[i - 1], x2) > -delta(a2[i], x2) ? i - 1 : i;
  }
  return { left, center, right };
}
function zero() {
  return 0;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js
function number(x2) {
  return x2 === null ? NaN : +x2;
}
function* numbers(values, valueof) {
  {
    for (let value2 of values) {
      if (value2 != null && (value2 = +value2) >= value2) {
        yield value2;
      }
    }
  }
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js
var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
bisector(number).center;
var bisect_default = bisectRight;

// node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js
var InternMap = class extends Map {
  constructor(entries, key2 = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key2 } });
    if (entries != null) for (const [key3, value2] of entries) this.set(key3, value2);
  }
  get(key2) {
    return super.get(intern_get(this, key2));
  }
  has(key2) {
    return super.has(intern_get(this, key2));
  }
  set(key2, value2) {
    return super.set(intern_set(this, key2), value2);
  }
  delete(key2) {
    return super.delete(intern_delete(this, key2));
  }
};
function intern_get({ _intern, _key }, value2) {
  const key2 = _key(value2);
  return _intern.has(key2) ? _intern.get(key2) : value2;
}
function intern_set({ _intern, _key }, value2) {
  const key2 = _key(value2);
  if (_intern.has(key2)) return _intern.get(key2);
  _intern.set(key2, value2);
  return value2;
}
function intern_delete({ _intern, _key }, value2) {
  const key2 = _key(value2);
  if (_intern.has(key2)) {
    value2 = _intern.get(key2);
    _intern.delete(key2);
  }
  return value2;
}
function keyof(value2) {
  return value2 !== null && typeof value2 === "object" ? value2.valueOf() : value2;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/sort.js
function compareDefined(compare = ascending) {
  if (compare === ascending) return ascendingDefined;
  if (typeof compare !== "function") throw new TypeError("compare is not a function");
  return (a2, b) => {
    const x2 = compare(a2, b);
    if (x2 || x2 === 0) return x2;
    return (compare(b, b) === 0) - (compare(a2, a2) === 0);
  };
}
function ascendingDefined(a2, b) {
  return (a2 == null || !(a2 >= a2)) - (b == null || !(b >= b)) || (a2 < b ? -1 : a2 > b ? 1 : 0);
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
  return [i1, i2, inc];
}
function ticks(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  if (!(count > 0)) return [];
  if (start === stop) return [start];
  const reverse3 = stop < start, [i1, i2, inc] = reverse3 ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1, ticks2 = new Array(n);
  if (reverse3) {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks2[i] = (i2 - i) / -inc;
    else for (let i = 0; i < n; ++i) ticks2[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks2[i] = (i1 + i) / -inc;
    else for (let i = 0; i < n; ++i) ticks2[i] = (i1 + i) * inc;
  }
  return ticks2;
}
function tickIncrement(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  const reverse3 = stop < start, inc = reverse3 ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse3 ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/max.js
function max(values, valueof) {
  let max4;
  {
    for (const value2 of values) {
      if (value2 != null && (max4 < value2 || max4 === void 0 && value2 >= value2)) {
        max4 = value2;
      }
    }
  }
  return max4;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/min.js
function min(values, valueof) {
  let min3;
  {
    for (const value2 of values) {
      if (value2 != null && (min3 > value2 || min3 === void 0 && value2 >= value2)) {
        min3 = value2;
      }
    }
  }
  return min3;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quickselect.js
function quickselect(array, k2, left = 0, right = Infinity, compare) {
  k2 = Math.floor(k2);
  left = Math.floor(Math.max(0, left));
  right = Math.floor(Math.min(array.length - 1, right));
  if (!(left <= k2 && k2 <= right)) return array;
  compare = compare === void 0 ? ascendingDefined : compareDefined(compare);
  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k2 - left + 1;
      const z = Math.log(n);
      const s2 = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s2 * (n - s2) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k2 - m * s2 / n + sd));
      const newRight = Math.min(right, Math.floor(k2 + (n - m) * s2 / n + sd));
      quickselect(array, k2, newLeft, newRight, compare);
    }
    const t = array[k2];
    let i = left;
    let j = right;
    swap(array, left, k2);
    if (compare(array[right], t) > 0) swap(array, left, right);
    while (i < j) {
      swap(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }
    if (compare(array[left], t) === 0) swap(array, left, j);
    else ++j, swap(array, j, right);
    if (j <= k2) left = j + 1;
    if (k2 <= j) right = j - 1;
  }
  return array;
}
function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/quantile.js
function quantile(values, p, valueof) {
  values = Float64Array.from(numbers(values));
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return min(values);
  if (p >= 1) return max(values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = number) {
  if (!(n = values.length) || isNaN(p = +p)) return;
  if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

// node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range6 = new Array(n);
  while (++i < n) {
    range6[i] = start + i * step;
  }
  return range6;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js
function initRange(domain, range6) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range6).domain(domain);
      break;
  }
  return this;
}
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js
var implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain = [], range6 = [], unknown = implicit;
  function scale2(d) {
    let i = index2.get(d);
    if (i === void 0) {
      if (unknown !== implicit) return unknown;
      index2.set(d, i = domain.push(d) - 1);
    }
    return range6[i % range6.length];
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index2 = new InternMap();
    for (const value2 of _) {
      if (index2.has(value2)) continue;
      index2.set(value2, domain.push(value2) - 1);
    }
    return scale2;
  };
  scale2.range = function(_) {
    return arguments.length ? (range6 = Array.from(_), scale2) : range6.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return ordinal(domain, range6).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return scale2;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js
function band() {
  var scale2 = ordinal().unknown(void 0), domain = scale2.domain, ordinalRange = scale2.range, r0 = 0, r1 = 1, step, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale2.unknown;
  function rescale() {
    var n = domain().length, reverse3 = r1 < r0, start = reverse3 ? r1 : r0, stop = reverse3 ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round2) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round2) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = range(n).map(function(i) {
      return start + step * i;
    });
    return ordinalRange(reverse3 ? values.reverse() : values);
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale2.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale2.bandwidth = function() {
    return bandwidth;
  };
  scale2.step = function() {
    return step;
  };
  scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, rescale()) : round2;
  };
  scale2.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale2.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale2.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale2.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale2.copy = function() {
    return band(domain(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale2) {
  var copy3 = scale2.copy;
  scale2.padding = scale2.paddingOuter;
  delete scale2.paddingInner;
  delete scale2.paddingOuter;
  scale2.copy = function() {
    return pointish(copy3());
  };
  return scale2;
}
function point3() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

// node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js
function define_default(constructor, factory17, prototype) {
  constructor.prototype = factory17.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent2, definition) {
  var prototype = Object.create(parent2.prototype);
  for (var key2 in definition) prototype[key2] = definition[key2];
  return prototype;
}

// node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex = /^#([0-9a-f]{3,8})$/;
var reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`);
var reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`);
var reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`);
var reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`);
var reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`);
var reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define_default(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m = reHex.exec(format2)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format2)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format2)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format2)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format2)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r2, g, b, a2) {
  if (a2 <= 0) r2 = g = b = NaN;
  return new Rgb(r2, g, b, a2);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r2, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r2, g, b, opacity) {
  this.r = +r2;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define_default(Rgb, rgb, extend(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a2 = clampa(this.opacity);
  return `${a2 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a2 === 1 ? ")" : `, ${a2})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value2) {
  return Math.max(0, Math.min(255, Math.round(value2) || 0));
}
function hex(value2) {
  value2 = clampi(value2);
  return (value2 < 16 ? "0" : "") + value2.toString(16);
}
function hsla(h, s2, l, a2) {
  if (a2 <= 0) h = s2 = l = NaN;
  else if (l <= 0 || l >= 1) h = s2 = NaN;
  else if (s2 <= 0) h = NaN;
  return new Hsl(h, s2, l, a2);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r2 = o.r / 255, g = o.g / 255, b = o.b / 255, min3 = Math.min(r2, g, b), max4 = Math.max(r2, g, b), h = NaN, s2 = max4 - min3, l = (max4 + min3) / 2;
  if (s2) {
    if (r2 === max4) h = (g - b) / s2 + (g < b) * 6;
    else if (g === max4) h = (b - r2) / s2 + 2;
    else h = (r2 - g) / s2 + 4;
    s2 /= l < 0.5 ? max4 + min3 : 2 - max4 - min3;
    h *= 60;
  } else {
    s2 = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s2, l, o.opacity);
}
function hsl(h, s2, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s2, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s2, l, opacity) {
  this.h = +h;
  this.s = +s2;
  this.l = +l;
  this.opacity = +opacity;
}
define_default(Hsl, hsl, extend(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s2, m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a2 = clampa(this.opacity);
    return `${a2 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a2 === 1 ? ")" : `, ${a2})`}`;
  }
}));
function clamph(value2) {
  value2 = (value2 || 0) % 360;
  return value2 < 0 ? value2 + 360 : value2;
}
function clampt(value2) {
  return Math.max(0, Math.min(1, value2 || 0));
}
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js
var constant_default2 = (x2) => () => x2;

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js
function linear2(a2, d) {
  return function(t) {
    return a2 + t * d;
  };
}
function exponential(a2, b, y2) {
  return a2 = Math.pow(a2, y2), b = Math.pow(b, y2) - a2, y2 = 1 / y2, function(t) {
    return Math.pow(a2 + t * b, y2);
  };
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a2, b) {
    return b - a2 ? exponential(a2, b, y2) : constant_default2(isNaN(a2) ? b : a2);
  };
}
function nogamma(a2, b) {
  var d = b - a2;
  return d ? linear2(a2, d) : constant_default2(isNaN(a2) ? b : a2);
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js
var rgb_default = function rgbGamma(y2) {
  var color2 = gamma(y2);
  function rgb2(start, end) {
    var r2 = color2((start = rgb(start)).r, (end = rgb(end)).r), g = color2(start.g, end.g), b = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r2(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js
function numberArray_default(a2, b) {
  if (!b) b = [];
  var n = a2 ? Math.min(b.length, a2.length) : 0, c2 = b.slice(), i;
  return function(t) {
    for (i = 0; i < n; ++i) c2[i] = a2[i] * (1 - t) + b[i] * t;
    return c2;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js
function genericArray(a2, b) {
  var nb = b ? b.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i) x2[i] = value_default(a2[i], b[i]);
  for (; i < nb; ++i) c2[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i) c2[i] = x2[i](t);
    return c2;
  };
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js
function date_default(a2, b) {
  var d = /* @__PURE__ */ new Date();
  return a2 = +a2, b = +b, function(t) {
    return d.setTime(a2 * (1 - t) + b * t), d;
  };
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js
function number_default(a2, b) {
  return a2 = +a2, b = +b, function(t) {
    return a2 * (1 - t) + b * t;
  };
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js
function object_default(a2, b) {
  var i = {}, c2 = {}, k2;
  if (a2 === null || typeof a2 !== "object") a2 = {};
  if (b === null || typeof b !== "object") b = {};
  for (k2 in b) {
    if (k2 in a2) {
      i[k2] = value_default(a2[k2], b[k2]);
    } else {
      c2[k2] = b[k2];
    }
  }
  return function(t) {
    for (k2 in i) c2[k2] = i[k2](t);
    return c2;
  };
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");
function zero2(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function string_default(a2, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q = [];
  a2 = a2 + "", b = b + "";
  while ((am = reA.exec(a2)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s2[i]) s2[i] += bs;
      else s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i]) s2[i] += bm;
      else s2[++i] = bm;
    } else {
      s2[++i] = null;
      q.push({ i, x: number_default(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s2[i]) s2[i] += bs;
    else s2[++i] = bs;
  }
  return s2.length < 2 ? q[0] ? one(q[0].x) : zero2(b) : (b = q.length, function(t) {
    for (var i2 = 0, o; i2 < b; ++i2) s2[(o = q[i2]).i] = o.x(t);
    return s2.join("");
  });
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js
function value_default(a2, b) {
  var t = typeof b, c2;
  return b == null || t === "boolean" ? constant_default2(b) : (t === "number" ? number_default : t === "string" ? (c2 = color(b)) ? (b = c2, rgb_default) : string_default : b instanceof color ? rgb_default : b instanceof Date ? date_default : isNumberArray(b) ? numberArray_default : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object_default : number_default)(a2, b);
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js
function round_default(a2, b) {
  return a2 = +a2, b = +b, function(t) {
    return Math.round(a2 * (1 - t) + b * t);
  };
}

// node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/piecewise.js
function piecewise(interpolate, values) {
  if (values === void 0) values = interpolate, interpolate = value_default;
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i2 = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i2](t - i2);
  };
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js
function constants(x2) {
  return function() {
    return x2;
  };
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js
function number2(x2) {
  return +x2;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js
var unit = [0, 1];
function identity(x2) {
  return x2;
}
function normalize2(a2, b) {
  return (b -= a2 = +a2) ? function(x2) {
    return (x2 - a2) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a2, b) {
  var t;
  if (a2 > b) t = a2, a2 = b, b = t;
  return function(x2) {
    return Math.max(a2, Math.min(b, x2));
  };
}
function bimap(domain, range6, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range6[0], r1 = range6[1];
  if (d1 < d0) d0 = normalize2(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize2(d0, d1), r0 = interpolate(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain, range6, interpolate) {
  var j = Math.min(domain.length, range6.length) - 1, d = new Array(j), r2 = new Array(j), i = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range6 = range6.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize2(domain[i], domain[i + 1]);
    r2[i] = interpolate(range6[i], range6[i + 1]);
  }
  return function(x2) {
    var i2 = bisect_default(domain, x2, 1, j) - 1;
    return r2[i2](d[i2](x2));
  };
}
function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
  var domain = unit, range6 = unit, interpolate = value_default, transform2, untransform, unknown, clamp3 = identity, piecewise2, output, input;
  function rescale() {
    var n = Math.min(domain.length, range6.length);
    if (clamp3 !== identity) clamp3 = clamper(domain[0], domain[n - 1]);
    piecewise2 = n > 2 ? polymap : bimap;
    output = input = null;
    return scale2;
  }
  function scale2(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : (output || (output = piecewise2(domain.map(transform2), range6, interpolate)))(transform2(clamp3(x2)));
  }
  scale2.invert = function(y2) {
    return clamp3(untransform((input || (input = piecewise2(range6, domain.map(transform2), number_default)))(y2)));
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number2), rescale()) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range6 = Array.from(_), rescale()) : range6.slice();
  };
  scale2.rangeRound = function(_) {
    return range6 = Array.from(_), interpolate = round_default, rescale();
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp3 = _ ? true : identity, rescale()) : clamp3 !== identity;
  };
  scale2.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t, u) {
    transform2 = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity, identity);
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatDecimal.js
function formatDecimal_default(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p) {
  if ((i = (x2 = p ? x2.toExponential(p - 1) : x2.toExponential()).indexOf("e")) < 0) return null;
  var i, coefficient = x2.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i + 1)
  ];
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/exponent.js
function exponent_default(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatGroup.js
function formatGroup_default(grouping, thousands) {
  return function(value2, width2) {
    var i = value2.length, t = [], j = 0, g = grouping[0], length2 = 0;
    while (i > 0 && g > 0) {
      if (length2 + g + 1 > width2) g = Math.max(1, width2 - length2);
      t.push(value2.substring(i -= g, i + g));
      if ((length2 += g + 1) > width2) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatNumerals.js
function formatNumerals_default(numerals) {
  return function(value2) {
    return value2.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatSpecifier.js
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatTrim.js
function formatTrim_default(s2) {
  out: for (var n = s2.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s2[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s2[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatPrefixAuto.js
var prefixExponent;
function formatPrefixAuto_default(x2, p) {
  var d = formatDecimalParts(x2, p);
  if (!d) return x2 + "";
  var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x2, Math.max(0, p + i - 1))[0];
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatRounded.js
function formatRounded_default(x2, p) {
  var d = formatDecimalParts(x2, p);
  if (!d) return x2 + "";
  var coefficient = d[0], exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/formatTypes.js
var formatTypes_default = {
  "%": (x2, p) => (x2 * 100).toFixed(p),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal_default,
  "e": (x2, p) => x2.toExponential(p),
  "f": (x2, p) => x2.toFixed(p),
  "g": (x2, p) => x2.toPrecision(p),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p) => formatRounded_default(x2 * 100, p),
  "r": formatRounded_default,
  "s": formatPrefixAuto_default,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/identity.js
function identity_default(x2) {
  return x2;
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/locale.js
var map = Array.prototype.map;
var prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function locale_default(locale3) {
  var group = locale3.grouping === void 0 || locale3.thousands === void 0 ? identity_default : formatGroup_default(map.call(locale3.grouping, Number), locale3.thousands + ""), currencyPrefix = locale3.currency === void 0 ? "" : locale3.currency[0] + "", currencySuffix = locale3.currency === void 0 ? "" : locale3.currency[1] + "", decimal = locale3.decimal === void 0 ? "." : locale3.decimal + "", numerals = locale3.numerals === void 0 ? identity_default : formatNumerals_default(map.call(locale3.numerals, String)), percent = locale3.percent === void 0 ? "%" : locale3.percent + "", minus = locale3.minus === void 0 ? "\u2212" : locale3.minus + "", nan = locale3.nan === void 0 ? "NaN" : locale3.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero3 = specifier.zero, width2 = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
    if (type === "n") comma = true, type = "g";
    else if (!formatTypes_default[type]) precision === void 0 && (precision = 12), trim = true, type = "g";
    if (zero3 || fill === "0" && align === "=") zero3 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes_default[type], maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value2) {
      var valuePrefix = prefix2, valueSuffix = suffix, i, n, c2;
      if (type === "c") {
        valueSuffix = formatType(value2) + valueSuffix;
        value2 = "";
      } else {
        value2 = +value2;
        var valueNegative = value2 < 0 || 1 / value2 < 0;
        value2 = isNaN(value2) ? nan : formatType(Math.abs(value2), precision);
        if (trim) value2 = formatTrim_default(value2);
        if (valueNegative && +value2 === 0 && sign2 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value2.length;
          while (++i < n) {
            if (c2 = value2.charCodeAt(i), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value2.slice(i + 1) : value2.slice(i)) + valueSuffix;
              value2 = value2.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero3) value2 = group(value2, Infinity);
      var length2 = valuePrefix.length + value2.length + valueSuffix.length, padding = length2 < width2 ? new Array(width2 - length2 + 1).join(fill) : "";
      if (comma && zero3) value2 = group(padding + value2, padding.length ? width2 - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value2 = valuePrefix + value2 + valueSuffix + padding;
          break;
        case "=":
          value2 = valuePrefix + padding + value2 + valueSuffix;
          break;
        case "^":
          value2 = padding.slice(0, length2 = padding.length >> 1) + valuePrefix + value2 + valueSuffix + padding.slice(length2);
          break;
        default:
          value2 = padding + valuePrefix + value2 + valueSuffix;
          break;
      }
      return numerals(value2);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value2) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent_default(value2) / 3))) * 3, k2 = Math.pow(10, -e), prefix2 = prefixes[8 + e / 3];
    return function(value3) {
      return f(k2 * value3) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/defaultLocale.js
var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = locale_default(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/precisionFixed.js
function precisionFixed_default(step) {
  return Math.max(0, -exponent_default(Math.abs(step)));
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/precisionPrefix.js
function precisionPrefix_default(step, value2) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent_default(value2) / 3))) * 3 - exponent_default(Math.abs(step)));
}

// node_modules/.pnpm/d3-format@3.1.0/node_modules/d3-format/src/precisionRound.js
function precisionRound_default(step, max4) {
  step = Math.abs(step), max4 = Math.abs(max4) - step;
  return Math.max(0, exponent_default(max4) - exponent_default(step)) + 1;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/tickFormat.js
function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value2 = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix_default(step, value2))) specifier.precision = precision;
      return formatPrefix(specifier, value2);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound_default(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed_default(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/linear.js
function linearish(scale2) {
  var domain = scale2.domain;
  scale2.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale2.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale2.nice = function(count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale2;
  };
  return scale2;
}
function linear3() {
  var scale2 = continuous();
  scale2.copy = function() {
    return copy(scale2, linear3());
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/identity.js
function identity2(domain) {
  var unknown;
  function scale2(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : x2;
  }
  scale2.invert = scale2;
  scale2.domain = scale2.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number2), scale2) : domain.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return identity2(domain).unknown(unknown);
  };
  domain = arguments.length ? Array.from(domain, number2) : [0, 1];
  return linearish(scale2);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/nice.js
function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }
  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/log.js
function transformLog(x2) {
  return Math.log(x2);
}
function transformExp(x2) {
  return Math.exp(x2);
}
function transformLogn(x2) {
  return -Math.log(-x2);
}
function transformExpn(x2) {
  return -Math.exp(-x2);
}
function pow10(x2) {
  return isFinite(x2) ? +("1e" + x2) : x2 < 0 ? 0 : x2;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x2) => Math.pow(base, x2);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x2) => Math.log(x2) / base);
}
function reflect(f) {
  return (x2, k2) => -f(-x2, k2);
}
function loggish(transform2) {
  const scale2 = transform2(transformLog, transformExp);
  const domain = scale2.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform2(transformLogn, transformExpn);
    } else {
      transform2(transformLog, transformExp);
    }
    return scale2;
  }
  scale2.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.ticks = (count) => {
    const d = domain();
    let u = d[0];
    let v = d[d.length - 1];
    const r2 = v < u;
    if (r2) [u, v] = [v, u];
    let i = logs(u);
    let j = logs(v);
    let k2;
    let t;
    const n = count == null ? 10 : +count;
    let z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k2 = 1; k2 < base; ++k2) {
          t = i < 0 ? k2 / pows(-i) : k2 * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      else for (; i <= j; ++i) {
        for (k2 = base - 1; k2 >= 1; --k2) {
          t = i > 0 ? k2 / pows(-i) : k2 * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r2 ? z.reverse() : z;
  };
  scale2.tickFormat = (count, specifier) => {
    if (count == null) count = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format(specifier);
    }
    if (count === Infinity) return specifier;
    const k2 = Math.max(1, base * count / scale2.ticks().length);
    return (d) => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k2 ? specifier(d) : "";
    };
  };
  scale2.nice = () => {
    return domain(nice(domain(), {
      floor: (x2) => pows(Math.floor(logs(x2))),
      ceil: (x2) => pows(Math.ceil(logs(x2)))
    }));
  };
  return scale2;
}
function log() {
  const scale2 = loggish(transformer()).domain([1, 10]);
  scale2.copy = () => copy(scale2, log()).base(scale2.base());
  initRange.apply(scale2, arguments);
  return scale2;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/symlog.js
function transformSymlog(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.log1p(Math.abs(x2 / c2));
  };
}
function transformSymexp(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.expm1(Math.abs(x2)) * c2;
  };
}
function symlogish(transform2) {
  var c2 = 1, scale2 = transform2(transformSymlog(c2), transformSymexp(c2));
  scale2.constant = function(_) {
    return arguments.length ? transform2(transformSymlog(c2 = +_), transformSymexp(c2)) : c2;
  };
  return linearish(scale2);
}
function symlog() {
  var scale2 = symlogish(transformer());
  scale2.copy = function() {
    return copy(scale2, symlog()).constant(scale2.constant());
  };
  return initRange.apply(scale2, arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/pow.js
function transformPow(exponent) {
  return function(x2) {
    return x2 < 0 ? -Math.pow(-x2, exponent) : Math.pow(x2, exponent);
  };
}
function transformSqrt(x2) {
  return x2 < 0 ? -Math.sqrt(-x2) : Math.sqrt(x2);
}
function transformSquare(x2) {
  return x2 < 0 ? -x2 * x2 : x2 * x2;
}
function powish(transform2) {
  var scale2 = transform2(identity, identity), exponent = 1;
  function rescale() {
    return exponent === 1 ? transform2(identity, identity) : exponent === 0.5 ? transform2(transformSqrt, transformSquare) : transform2(transformPow(exponent), transformPow(1 / exponent));
  }
  scale2.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };
  return linearish(scale2);
}
function pow() {
  var scale2 = powish(transformer());
  scale2.copy = function() {
    return copy(scale2, pow()).exponent(scale2.exponent());
  };
  initRange.apply(scale2, arguments);
  return scale2;
}
function sqrt2() {
  return pow.apply(null, arguments).exponent(0.5);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/radial.js
function square(x2) {
  return Math.sign(x2) * x2 * x2;
}
function unsquare(x2) {
  return Math.sign(x2) * Math.sqrt(Math.abs(x2));
}
function radial() {
  var squared = continuous(), range6 = [0, 1], round2 = false, unknown;
  function scale2(x2) {
    var y2 = unsquare(squared(x2));
    return isNaN(y2) ? unknown : round2 ? Math.round(y2) : y2;
  }
  scale2.invert = function(y2) {
    return squared.invert(square(y2));
  };
  scale2.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale2) : squared.domain();
  };
  scale2.range = function(_) {
    return arguments.length ? (squared.range((range6 = Array.from(_, number2)).map(square)), scale2) : range6.slice();
  };
  scale2.rangeRound = function(_) {
    return scale2.range(_).round(true);
  };
  scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, scale2) : round2;
  };
  scale2.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale2) : squared.clamp();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return radial(squared.domain(), range6).round(round2).clamp(squared.clamp()).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantile.js
function quantile2() {
  var domain = [], range6 = [], thresholds = [], unknown;
  function rescale() {
    var i = 0, n = Math.max(1, range6.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);
    return scale2;
  }
  function scale2(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : range6[bisect_default(thresholds, x2)];
  }
  scale2.invertExtent = function(y2) {
    var i = range6.indexOf(y2);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };
  scale2.range = function(_) {
    return arguments.length ? (range6 = Array.from(_), rescale()) : range6.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.quantiles = function() {
    return thresholds.slice();
  };
  scale2.copy = function() {
    return quantile2().domain(domain).range(range6).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/quantize.js
function quantize() {
  var x0 = 0, x1 = 1, n = 1, domain = [0.5], range6 = [0, 1], unknown;
  function scale2(x2) {
    return x2 != null && x2 <= x2 ? range6[bisect_default(domain, x2, 0, n)] : unknown;
  }
  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale2;
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };
  scale2.range = function(_) {
    return arguments.length ? (n = (range6 = Array.from(_)).length - 1, rescale()) : range6.slice();
  };
  scale2.invertExtent = function(y2) {
    var i = range6.indexOf(y2);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : scale2;
  };
  scale2.thresholds = function() {
    return domain.slice();
  };
  scale2.copy = function() {
    return quantize().domain([x0, x1]).range(range6).unknown(unknown);
  };
  return initRange.apply(linearish(scale2), arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/threshold.js
function threshold() {
  var domain = [0.5], range6 = [0, 1], unknown, n = 1;
  function scale2(x2) {
    return x2 != null && x2 <= x2 ? range6[bisect_default(domain, x2, 0, n)] : unknown;
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range6.length - 1), scale2) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range6 = Array.from(_), n = Math.min(domain.length, range6.length - 1), scale2) : range6.slice();
  };
  scale2.invertExtent = function(y2) {
    var i = range6.indexOf(y2);
    return [domain[i - 1], domain[i]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return threshold().domain(domain).range(range6).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/interval.js
var t0 = /* @__PURE__ */ new Date();
var t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count, field) {
  function interval(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval.round = (date2) => {
    const d0 = interval(date2), d1 = interval.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval.offset = (date2, step) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2;
  };
  interval.range = (start, stop, step) => {
    const range6 = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range6;
    let previous;
    do
      range6.push(previous = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range6;
  };
  interval.filter = (test) => {
    return timeInterval((date2) => {
      if (date2 >= date2) while (floori(date2), !test(date2)) date2.setTime(date2 - 1);
    }, (date2, step) => {
      if (date2 >= date2) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date2, -1), !test(date2)) {
          }
        }
        else while (--step >= 0) {
          while (offseti(date2, 1), !test(date2)) {
          }
        }
      }
    });
  };
  if (count) {
    interval.count = (start, end) => {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };
    interval.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d) => field(d) % step === 0 : (d) => interval.count(0, d) % step === 0);
    };
  }
  return interval;
}

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/millisecond.js
var millisecond = timeInterval(() => {
}, (date2, step) => {
  date2.setTime(+date2 + step);
}, (start, end) => {
  return end - start;
});
millisecond.every = (k2) => {
  k2 = Math.floor(k2);
  if (!isFinite(k2) || !(k2 > 0)) return null;
  if (!(k2 > 1)) return millisecond;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k2) * k2);
  }, (date2, step) => {
    date2.setTime(+date2 + step * k2);
  }, (start, end) => {
    return (end - start) / k2;
  });
};
millisecond.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/duration.js
var durationSecond = 1e3;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/second.js
var second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step) => {
  date2.setTime(+date2 + step * durationSecond);
}, (start, end) => {
  return (end - start) / durationSecond;
}, (date2) => {
  return date2.getUTCSeconds();
});
second.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/minute.js
var timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date2) => {
  return date2.getMinutes();
});
timeMinute.range;
var utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date2) => {
  return date2.getUTCMinutes();
});
utcMinute.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/hour.js
var timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date2) => {
  return date2.getHours();
});
timeHour.range;
var utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date2) => {
  return date2.getUTCHours();
});
utcHour.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/day.js
var timeDay = timeInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step) => date2.setDate(date2.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  (date2) => date2.getDate() - 1
);
timeDay.range;
var utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
utcDay.range;
var unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date2) => {
  return Math.floor(date2 / durationDay);
});
unixDay.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/week.js
function timeWeekday(i) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start, end) => {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
var timeSunday = timeWeekday(0);
var timeMonday = timeWeekday(1);
var timeTuesday = timeWeekday(2);
var timeWednesday = timeWeekday(3);
var timeThursday = timeWeekday(4);
var timeFriday = timeWeekday(5);
var timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start, end) => {
    return (end - start) / durationWeek;
  });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/month.js
var timeMonth = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setMonth(date2.getMonth() + step);
}, (start, end) => {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
timeMonth.range;
var utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCMonth(date2.getUTCMonth() + step);
}, (start, end) => {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
utcMonth.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/year.js
var timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step);
}, (start, end) => {
  return end.getFullYear() - start.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear.every = (k2) => {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k2) * k2);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setFullYear(date2.getFullYear() + step * k2);
  });
};
timeYear.range;
var utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step);
}, (start, end) => {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear.every = (k2) => {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k2) * k2);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step * k2);
  });
};
utcYear.range;

// node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/ticks.js
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear]
  ];
  function ticks2(start, stop, count) {
    const reverse3 = stop < start;
    if (reverse3) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks3 = interval ? interval.range(start, +stop + 1) : [];
    return reverse3 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([, , step2]) => step2).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }
  return [ticks2, tickInterval];
}
var [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
var [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);

// node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/locale.js
function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date2.setFullYear(d.y);
    return date2;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date2.setUTCFullYear(d.y);
    return date2;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y2, m, d) {
  return { y: y2, m, d, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale3) {
  var locale_dateTime = locale3.dateTime, locale_date = locale3.date, locale_time = locale3.time, locale_periods = locale3.periods, locale_weekdays = locale3.days, locale_shortWeekdays = locale3.shortDays, locale_months = locale3.months, locale_shortMonths = locale3.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string = [], i = -1, j = 0, n = specifier.length, c2, pad2, format2;
      if (!(date2 instanceof Date)) date2 = /* @__PURE__ */ new Date(+date2);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad2 = pads[c2 = specifier.charAt(++i)]) != null) c2 = specifier.charAt(++i);
          else pad2 = c2 === "e" ? " " : "0";
          if (format2 = formats2[c2]) c2 = format2(date2, pad2);
          string.push(c2);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
      if (i != string.length) return null;
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
      if (Z && !("Z" in d)) d.Z = 0;
      if ("p" in d) d.H = d.H % 12 + d.p * 12;
      if (d.m === void 0) d.m = "q" in d ? d.q : 0;
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0, n = specifier.length, m = string.length, c2, parse;
    while (i < n) {
      if (j >= m) return -1;
      c2 = specifier.charCodeAt(i++);
      if (c2 === 37) {
        c2 = specifier.charAt(i++);
        parse = parses[c2 in pads ? specifier.charAt(i++) : c2];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c2 != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() {
        return specifier;
      };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() {
        return specifier;
      };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() {
        return specifier;
      };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() {
        return specifier;
      };
      return p;
    }
  };
}
var pads = { "-": "", "_": " ", "0": "0" };
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value2, fill, width2) {
  var sign2 = value2 < 0 ? "-" : "", string = (sign2 ? -value2 : value2) + "", length2 = string.length;
  return sign2 + (length2 < width2 ? new Array(width2 - length2 + 1).join(fill) + string : string);
}
function requote(s2) {
  return s2.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name2, i) => [name2.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
}
function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad(d.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad(d.getFullYear() % 1e4, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1e3);
}

// node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/defaultLocale.js
var locale2;
var timeFormat;
var utcFormat;
defaultLocale2({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale2(definition) {
  locale2 = formatLocale(definition);
  timeFormat = locale2.format;
  locale2.parse;
  utcFormat = locale2.utcFormat;
  locale2.utcParse;
  return locale2;
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/time.js
function date(t) {
  return new Date(t);
}
function number3(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale2 = continuous(), invert = scale2.invert, domain = scale2.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale2.invert = function(y2) {
    return new Date(invert(y2));
  };
  scale2.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number3)) : domain().map(date);
  };
  scale2.ticks = function(interval) {
    var d = domain();
    return ticks2(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };
  scale2.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale2.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale2;
  };
  scale2.copy = function() {
    return copy(scale2, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale2;
}
function time2() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/utcTime.js
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequential.js
function transformer2() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform2, interpolator = identity, clamp3 = false, unknown;
  function scale2(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : interpolator(k10 === 0 ? 0.5 : (x2 = (transform2(x2) - t02) * k10, clamp3 ? Math.max(0, Math.min(1, x2)) : x2));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t02 = transform2(x0 = +x0), t12 = transform2(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale2) : [x0, x1];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp3 = !!_, scale2) : clamp3;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range6(interpolate) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale2) : [interpolator(0), interpolator(1)];
    };
  }
  scale2.range = range6(value_default);
  scale2.rangeRound = range6(round_default);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t) {
    transform2 = t, t02 = t(x0), t12 = t(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale2;
  };
}
function copy2(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale2 = linearish(transformer2()(identity));
  scale2.copy = function() {
    return copy2(scale2, sequential());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialLog() {
  var scale2 = loggish(transformer2()).domain([1, 10]);
  scale2.copy = function() {
    return copy2(scale2, sequentialLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSymlog() {
  var scale2 = symlogish(transformer2());
  scale2.copy = function() {
    return copy2(scale2, sequentialSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialPow() {
  var scale2 = powish(transformer2());
  scale2.copy = function() {
    return copy2(scale2, sequentialPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequentialQuantile.js
function sequentialQuantile() {
  var domain = [], interpolator = identity;
  function scale2(x2) {
    if (x2 != null && !isNaN(x2 = +x2)) return interpolator((bisect_default(domain, x2, 1) - 1) / (domain.length - 1));
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return scale2;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  scale2.range = function() {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };
  scale2.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (_, i) => quantile(domain, i / n));
  };
  scale2.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };
  return initInterpolator.apply(scale2, arguments);
}

// node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/diverging.js
function transformer3() {
  var x0 = 0, x1 = 0.5, x2 = 1, s2 = 1, t02, t12, t2, k10, k21, interpolator = identity, transform2, clamp3 = false, unknown;
  function scale2(x3) {
    return isNaN(x3 = +x3) ? unknown : (x3 = 0.5 + ((x3 = +transform2(x3)) - t12) * (s2 * x3 < s2 * t12 ? k10 : k21), interpolator(clamp3 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1, x2] = _, t02 = transform2(x0 = +x0), t12 = transform2(x1 = +x1), t2 = transform2(x2 = +x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t2 ? 0 : 0.5 / (t2 - t12), s2 = t12 < t02 ? -1 : 1, scale2) : [x0, x1, x2];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp3 = !!_, scale2) : clamp3;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range6(interpolate) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [r0, r1, r2]), scale2) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale2.range = range6(value_default);
  scale2.rangeRound = range6(round_default);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t) {
    transform2 = t, t02 = t(x0), t12 = t(x1), t2 = t(x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t2 ? 0 : 0.5 / (t2 - t12), s2 = t12 < t02 ? -1 : 1;
    return scale2;
  };
}
function diverging() {
  var scale2 = linearish(transformer3()(identity));
  scale2.copy = function() {
    return copy2(scale2, diverging());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingLog() {
  var scale2 = loggish(transformer3()).domain([0.1, 1, 10]);
  scale2.copy = function() {
    return copy2(scale2, divergingLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSymlog() {
  var scale2 = symlogish(transformer3());
  scale2.copy = function() {
    return copy2(scale2, divergingSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingPow() {
  var scale2 = powish(transformer3());
  scale2.copy = function() {
    return copy2(scale2, divergingPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ChartUtils.js
var import_max2 = __toESM(require_max());
var import_min2 = __toESM(require_min());
var import_isNil4 = __toESM(require_isNil());
var import_isFunction4 = __toESM(require_isFunction());
var import_isString3 = __toESM(require_isString());
var import_get3 = __toESM(require_get());
var import_flatMap = __toESM(require_flatMap());
var import_isNaN2 = __toESM(require_isNaN());
var import_upperFirst2 = __toESM(require_upperFirst());
var import_isEqual = __toESM(require_isEqual());
var import_sortBy2 = __toESM(require_sortBy());

// node_modules/.pnpm/decimal.js-light@2.5.1/node_modules/decimal.js-light/decimal.mjs
var MAX_DIGITS = 1e9;
var defaults = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
};
var Decimal;
var external = true;
var decimalError = "[DecimalError] ";
var invalidArgument = decimalError + "Invalid argument: ";
var exponentOutOfRange = decimalError + "Exponent out of range: ";
var mathfloor = Math.floor;
var mathpow = Math.pow;
var isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
var ONE;
var BASE = 1e7;
var LOG_BASE = 7;
var MAX_SAFE_INTEGER = 9007199254740991;
var MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE);
var P = {};
P.absoluteValue = P.abs = function() {
  var x2 = new this.constructor(this);
  if (x2.s) x2.s = 1;
  return x2;
};
P.comparedTo = P.cmp = function(y2) {
  var i, j, xdL, ydL, x2 = this;
  y2 = new x2.constructor(y2);
  if (x2.s !== y2.s) return x2.s || -y2.s;
  if (x2.e !== y2.e) return x2.e > y2.e ^ x2.s < 0 ? 1 : -1;
  xdL = x2.d.length;
  ydL = y2.d.length;
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (x2.d[i] !== y2.d[i]) return x2.d[i] > y2.d[i] ^ x2.s < 0 ? 1 : -1;
  }
  return xdL === ydL ? 0 : xdL > ydL ^ x2.s < 0 ? 1 : -1;
};
P.decimalPlaces = P.dp = function() {
  var x2 = this, w = x2.d.length - 1, dp = (w - x2.e) * LOG_BASE;
  w = x2.d[w];
  if (w) for (; w % 10 == 0; w /= 10) dp--;
  return dp < 0 ? 0 : dp;
};
P.dividedBy = P.div = function(y2) {
  return divide(this, new this.constructor(y2));
};
P.dividedToIntegerBy = P.idiv = function(y2) {
  var x2 = this, Ctor = x2.constructor;
  return round(divide(x2, new Ctor(y2), 0, 1), Ctor.precision);
};
P.equals = P.eq = function(y2) {
  return !this.cmp(y2);
};
P.exponent = function() {
  return getBase10Exponent(this);
};
P.greaterThan = P.gt = function(y2) {
  return this.cmp(y2) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y2) {
  return this.cmp(y2) >= 0;
};
P.isInteger = P.isint = function() {
  return this.e > this.d.length - 2;
};
P.isNegative = P.isneg = function() {
  return this.s < 0;
};
P.isPositive = P.ispos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return this.s === 0;
};
P.lessThan = P.lt = function(y2) {
  return this.cmp(y2) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y2) {
  return this.cmp(y2) < 1;
};
P.logarithm = P.log = function(base) {
  var r2, x2 = this, Ctor = x2.constructor, pr = Ctor.precision, wpr = pr + 5;
  if (base === void 0) {
    base = new Ctor(10);
  } else {
    base = new Ctor(base);
    if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
  }
  if (x2.s < 1) throw Error(decimalError + (x2.s ? "NaN" : "-Infinity"));
  if (x2.eq(ONE)) return new Ctor(0);
  external = false;
  r2 = divide(ln(x2, wpr), ln(base, wpr), wpr);
  external = true;
  return round(r2, pr);
};
P.minus = P.sub = function(y2) {
  var x2 = this;
  y2 = new x2.constructor(y2);
  return x2.s == y2.s ? subtract(x2, y2) : add2(x2, (y2.s = -y2.s, y2));
};
P.modulo = P.mod = function(y2) {
  var q, x2 = this, Ctor = x2.constructor, pr = Ctor.precision;
  y2 = new Ctor(y2);
  if (!y2.s) throw Error(decimalError + "NaN");
  if (!x2.s) return round(new Ctor(x2), pr);
  external = false;
  q = divide(x2, y2, 0, 1).times(y2);
  external = true;
  return x2.minus(q);
};
P.naturalExponential = P.exp = function() {
  return exp(this);
};
P.naturalLogarithm = P.ln = function() {
  return ln(this);
};
P.negated = P.neg = function() {
  var x2 = new this.constructor(this);
  x2.s = -x2.s || 0;
  return x2;
};
P.plus = P.add = function(y2) {
  var x2 = this;
  y2 = new x2.constructor(y2);
  return x2.s == y2.s ? add2(x2, y2) : subtract(x2, (y2.s = -y2.s, y2));
};
P.precision = P.sd = function(z) {
  var e, sd, w, x2 = this;
  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
  e = getBase10Exponent(x2) + 1;
  w = x2.d.length - 1;
  sd = w * LOG_BASE + 1;
  w = x2.d[w];
  if (w) {
    for (; w % 10 == 0; w /= 10) sd--;
    for (w = x2.d[0]; w >= 10; w /= 10) sd++;
  }
  return z && e > sd ? e : sd;
};
P.squareRoot = P.sqrt = function() {
  var e, n, pr, r2, s2, t, wpr, x2 = this, Ctor = x2.constructor;
  if (x2.s < 1) {
    if (!x2.s) return new Ctor(0);
    throw Error(decimalError + "NaN");
  }
  e = getBase10Exponent(x2);
  external = false;
  s2 = Math.sqrt(+x2);
  if (s2 == 0 || s2 == 1 / 0) {
    n = digitsToString(x2.d);
    if ((n.length + e) % 2 == 0) n += "0";
    s2 = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
    if (s2 == 1 / 0) {
      n = "5e" + e;
    } else {
      n = s2.toExponential();
      n = n.slice(0, n.indexOf("e") + 1) + e;
    }
    r2 = new Ctor(n);
  } else {
    r2 = new Ctor(s2.toString());
  }
  pr = Ctor.precision;
  s2 = wpr = pr + 3;
  for (; ; ) {
    t = r2;
    r2 = t.plus(divide(x2, t, wpr + 2)).times(0.5);
    if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r2.d)).slice(0, wpr)) {
      n = n.slice(wpr - 3, wpr + 1);
      if (s2 == wpr && n == "4999") {
        round(t, pr + 1, 0);
        if (t.times(t).eq(x2)) {
          r2 = t;
          break;
        }
      } else if (n != "9999") {
        break;
      }
      wpr += 4;
    }
  }
  external = true;
  return round(r2, pr);
};
P.times = P.mul = function(y2) {
  var carry, e, i, k2, r2, rL, t, xdL, ydL, x2 = this, Ctor = x2.constructor, xd = x2.d, yd = (y2 = new Ctor(y2)).d;
  if (!x2.s || !y2.s) return new Ctor(0);
  y2.s *= x2.s;
  e = x2.e + y2.e;
  xdL = xd.length;
  ydL = yd.length;
  if (xdL < ydL) {
    r2 = xd;
    xd = yd;
    yd = r2;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }
  r2 = [];
  rL = xdL + ydL;
  for (i = rL; i--; ) r2.push(0);
  for (i = ydL; --i >= 0; ) {
    carry = 0;
    for (k2 = xdL + i; k2 > i; ) {
      t = r2[k2] + yd[i] * xd[k2 - i - 1] + carry;
      r2[k2--] = t % BASE | 0;
      carry = t / BASE | 0;
    }
    r2[k2] = (r2[k2] + carry) % BASE | 0;
  }
  for (; !r2[--rL]; ) r2.pop();
  if (carry) ++e;
  else r2.shift();
  y2.d = r2;
  y2.e = e;
  return external ? round(y2, Ctor.precision) : y2;
};
P.toDecimalPlaces = P.todp = function(dp, rm) {
  var x2 = this, Ctor = x2.constructor;
  x2 = new Ctor(x2);
  if (dp === void 0) return x2;
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  return round(x2, dp + getBase10Exponent(x2) + 1, rm);
};
P.toExponential = function(dp, rm) {
  var str, x2 = this, Ctor = x2.constructor;
  if (dp === void 0) {
    str = toString(x2, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x2 = round(new Ctor(x2), dp + 1, rm);
    str = toString(x2, true, dp + 1);
  }
  return str;
};
P.toFixed = function(dp, rm) {
  var str, y2, x2 = this, Ctor = x2.constructor;
  if (dp === void 0) return toString(x2);
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  y2 = round(new Ctor(x2), dp + getBase10Exponent(x2) + 1, rm);
  str = toString(y2.abs(), false, dp + getBase10Exponent(y2) + 1);
  return x2.isneg() && !x2.isZero() ? "-" + str : str;
};
P.toInteger = P.toint = function() {
  var x2 = this, Ctor = x2.constructor;
  return round(new Ctor(x2), getBase10Exponent(x2) + 1, Ctor.rounding);
};
P.toNumber = function() {
  return +this;
};
P.toPower = P.pow = function(y2) {
  var e, k2, pr, r2, sign2, yIsInt, x2 = this, Ctor = x2.constructor, guard = 12, yn = +(y2 = new Ctor(y2));
  if (!y2.s) return new Ctor(ONE);
  x2 = new Ctor(x2);
  if (!x2.s) {
    if (y2.s < 1) throw Error(decimalError + "Infinity");
    return x2;
  }
  if (x2.eq(ONE)) return x2;
  pr = Ctor.precision;
  if (y2.eq(ONE)) return round(x2, pr);
  e = y2.e;
  k2 = y2.d.length - 1;
  yIsInt = e >= k2;
  sign2 = x2.s;
  if (!yIsInt) {
    if (sign2 < 0) throw Error(decimalError + "NaN");
  } else if ((k2 = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r2 = new Ctor(ONE);
    e = Math.ceil(pr / LOG_BASE + 4);
    external = false;
    for (; ; ) {
      if (k2 % 2) {
        r2 = r2.times(x2);
        truncate(r2.d, e);
      }
      k2 = mathfloor(k2 / 2);
      if (k2 === 0) break;
      x2 = x2.times(x2);
      truncate(x2.d, e);
    }
    external = true;
    return y2.s < 0 ? new Ctor(ONE).div(r2) : round(r2, pr);
  }
  sign2 = sign2 < 0 && y2.d[Math.max(e, k2)] & 1 ? -1 : 1;
  x2.s = 1;
  external = false;
  r2 = y2.times(ln(x2, pr + guard));
  external = true;
  r2 = exp(r2);
  r2.s = sign2;
  return r2;
};
P.toPrecision = function(sd, rm) {
  var e, str, x2 = this, Ctor = x2.constructor;
  if (sd === void 0) {
    e = getBase10Exponent(x2);
    str = toString(x2, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x2 = round(new Ctor(x2), sd, rm);
    e = getBase10Exponent(x2);
    str = toString(x2, sd <= e || e <= Ctor.toExpNeg, sd);
  }
  return str;
};
P.toSignificantDigits = P.tosd = function(sd, rm) {
  var x2 = this, Ctor = x2.constructor;
  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }
  return round(new Ctor(x2), sd, rm);
};
P.toString = P.valueOf = P.val = P.toJSON = P[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var x2 = this, e = getBase10Exponent(x2), Ctor = x2.constructor;
  return toString(x2, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};
function add2(x2, y2) {
  var carry, d, e, i, k2, len, xd, yd, Ctor = x2.constructor, pr = Ctor.precision;
  if (!x2.s || !y2.s) {
    if (!y2.s) y2 = new Ctor(x2);
    return external ? round(y2, pr) : y2;
  }
  xd = x2.d;
  yd = y2.d;
  k2 = x2.e;
  e = y2.e;
  xd = xd.slice();
  i = k2 - e;
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k2;
      len = xd.length;
    }
    k2 = Math.ceil(pr / LOG_BASE);
    len = k2 > len ? k2 + 1 : len + 1;
    if (i > len) {
      i = len;
      d.length = 1;
    }
    d.reverse();
    for (; i--; ) d.push(0);
    d.reverse();
  }
  len = xd.length;
  i = yd.length;
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }
  for (carry = 0; i; ) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }
  if (carry) {
    xd.unshift(carry);
    ++e;
  }
  for (len = xd.length; xd[--len] == 0; ) xd.pop();
  y2.d = xd;
  y2.e = e;
  return external ? round(y2, pr) : y2;
}
function checkInt32(i, min3, max4) {
  if (i !== ~~i || i < min3 || i > max4) {
    throw Error(invalidArgument + i);
  }
}
function digitsToString(d) {
  var i, k2, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + "";
      k2 = LOG_BASE - ws.length;
      if (k2) str += getZeroString(k2);
      str += ws;
    }
    w = d[i];
    ws = w + "";
    k2 = LOG_BASE - ws.length;
    if (k2) str += getZeroString(k2);
  } else if (w === 0) {
    return "0";
  }
  for (; w % 10 === 0; ) w /= 10;
  return str + w;
}
var divide = /* @__PURE__ */ function() {
  function multiplyInteger(x2, k2) {
    var temp, carry = 0, i = x2.length;
    for (x2 = x2.slice(); i--; ) {
      temp = x2[i] * k2 + carry;
      x2[i] = temp % BASE | 0;
      carry = temp / BASE | 0;
    }
    if (carry) x2.unshift(carry);
    return x2;
  }
  function compare(a2, b, aL, bL) {
    var i, r2;
    if (aL != bL) {
      r2 = aL > bL ? 1 : -1;
    } else {
      for (i = r2 = 0; i < aL; i++) {
        if (a2[i] != b[i]) {
          r2 = a2[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }
    return r2;
  }
  function subtract2(a2, b, aL) {
    var i = 0;
    for (; aL--; ) {
      a2[aL] -= i;
      i = a2[aL] < b[aL] ? 1 : 0;
      a2[aL] = i * BASE + a2[aL] - b[aL];
    }
    for (; !a2[0] && a2.length > 1; ) a2.shift();
  }
  return function(x2, y2, pr, dp) {
    var cmp, e, i, k2, prod, prodL, q, qd, rem3, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x2.constructor, sign2 = x2.s == y2.s ? 1 : -1, xd = x2.d, yd = y2.d;
    if (!x2.s) return new Ctor(x2);
    if (!y2.s) throw Error(decimalError + "Division by zero");
    e = x2.e - y2.e;
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign2);
    qd = q.d = [];
    for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
    if (yd[i] > (xd[i] || 0)) --e;
    if (pr == null) {
      sd = pr = Ctor.precision;
    } else if (dp) {
      sd = pr + (getBase10Exponent(x2) - getBase10Exponent(y2)) + 1;
    } else {
      sd = pr;
    }
    if (sd < 0) return new Ctor(0);
    sd = sd / LOG_BASE + 2 | 0;
    i = 0;
    if (yL == 1) {
      k2 = 0;
      yd = yd[0];
      sd++;
      for (; (i < xL || k2) && sd--; i++) {
        t = k2 * BASE + (xd[i] || 0);
        qd[i] = t / yd | 0;
        k2 = t % yd | 0;
      }
    } else {
      k2 = BASE / (yd[0] + 1) | 0;
      if (k2 > 1) {
        yd = multiplyInteger(yd, k2);
        xd = multiplyInteger(xd, k2);
        yL = yd.length;
        xL = xd.length;
      }
      xi = yL;
      rem3 = xd.slice(0, yL);
      remL = rem3.length;
      for (; remL < yL; ) rem3[remL++] = 0;
      yz = yd.slice();
      yz.unshift(0);
      yd0 = yd[0];
      if (yd[1] >= BASE / 2) ++yd0;
      do {
        k2 = 0;
        cmp = compare(yd, rem3, yL, remL);
        if (cmp < 0) {
          rem0 = rem3[0];
          if (yL != remL) rem0 = rem0 * BASE + (rem3[1] || 0);
          k2 = rem0 / yd0 | 0;
          if (k2 > 1) {
            if (k2 >= BASE) k2 = BASE - 1;
            prod = multiplyInteger(yd, k2);
            prodL = prod.length;
            remL = rem3.length;
            cmp = compare(prod, rem3, prodL, remL);
            if (cmp == 1) {
              k2--;
              subtract2(prod, yL < prodL ? yz : yd, prodL);
            }
          } else {
            if (k2 == 0) cmp = k2 = 1;
            prod = yd.slice();
          }
          prodL = prod.length;
          if (prodL < remL) prod.unshift(0);
          subtract2(rem3, prod, remL);
          if (cmp == -1) {
            remL = rem3.length;
            cmp = compare(yd, rem3, yL, remL);
            if (cmp < 1) {
              k2++;
              subtract2(rem3, yL < remL ? yz : yd, remL);
            }
          }
          remL = rem3.length;
        } else if (cmp === 0) {
          k2++;
          rem3 = [0];
        }
        qd[i++] = k2;
        if (cmp && rem3[0]) {
          rem3[remL++] = xd[xi] || 0;
        } else {
          rem3 = [xd[xi]];
          remL = 1;
        }
      } while ((xi++ < xL || rem3[0] !== void 0) && sd--);
    }
    if (!qd[0]) qd.shift();
    q.e = e;
    return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
  };
}();
function exp(x2, sd) {
  var denominator, guard, pow2, sum2, t, wpr, i = 0, k2 = 0, Ctor = x2.constructor, pr = Ctor.precision;
  if (getBase10Exponent(x2) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x2));
  if (!x2.s) return new Ctor(ONE);
  {
    external = false;
    wpr = pr;
  }
  t = new Ctor(0.03125);
  while (x2.abs().gte(0.1)) {
    x2 = x2.times(t);
    k2 += 5;
  }
  guard = Math.log(mathpow(2, k2)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow2 = sum2 = new Ctor(ONE);
  Ctor.precision = wpr;
  for (; ; ) {
    pow2 = round(pow2.times(x2), wpr);
    denominator = denominator.times(++i);
    t = sum2.plus(divide(pow2, denominator, wpr));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      while (k2--) sum2 = round(sum2.times(sum2), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum2, pr)) : sum2;
    }
    sum2 = t;
  }
}
function getBase10Exponent(x2) {
  var e = x2.e * LOG_BASE, w = x2.d[0];
  for (; w >= 10; w /= 10) e++;
  return e;
}
function getLn10(Ctor, sd, pr) {
  if (sd > Ctor.LN10.sd()) {
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(decimalError + "LN10 precision limit exceeded");
  }
  return round(new Ctor(Ctor.LN10), sd);
}
function getZeroString(k2) {
  var zs = "";
  for (; k2--; ) zs += "0";
  return zs;
}
function ln(y2, sd) {
  var c2, c0, denominator, e, numerator, sum2, t, wpr, x2, n = 1, guard = 10, x3 = y2, xd = x3.d, Ctor = x3.constructor, pr = Ctor.precision;
  if (x3.s < 1) throw Error(decimalError + (x3.s ? "NaN" : "-Infinity"));
  if (x3.eq(ONE)) return new Ctor(0);
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  if (x3.eq(10)) {
    if (sd == null) external = true;
    return getLn10(Ctor, wpr);
  }
  wpr += guard;
  Ctor.precision = wpr;
  c2 = digitsToString(xd);
  c0 = c2.charAt(0);
  e = getBase10Exponent(x3);
  if (Math.abs(e) < 15e14) {
    while (c0 < 7 && c0 != 1 || c0 == 1 && c2.charAt(1) > 3) {
      x3 = x3.times(y2);
      c2 = digitsToString(x3.d);
      c0 = c2.charAt(0);
      n++;
    }
    e = getBase10Exponent(x3);
    if (c0 > 1) {
      x3 = new Ctor("0." + c2);
      e++;
    } else {
      x3 = new Ctor(c0 + "." + c2.slice(1));
    }
  } else {
    t = getLn10(Ctor, wpr + 2, pr).times(e + "");
    x3 = ln(new Ctor(c0 + "." + c2.slice(1)), wpr - guard).plus(t);
    Ctor.precision = pr;
    return sd == null ? (external = true, round(x3, pr)) : x3;
  }
  sum2 = numerator = x3 = divide(x3.minus(ONE), x3.plus(ONE), wpr);
  x2 = round(x3.times(x3), wpr);
  denominator = 3;
  for (; ; ) {
    numerator = round(numerator.times(x2), wpr);
    t = sum2.plus(divide(numerator, new Ctor(denominator), wpr));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      sum2 = sum2.times(2);
      if (e !== 0) sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
      sum2 = divide(sum2, new Ctor(n), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum2, pr)) : sum2;
    }
    sum2 = t;
    denominator += 2;
  }
}
function parseDecimal(x2, str) {
  var e, i, len;
  if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
  if ((i = str.search(/e/i)) > 0) {
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {
    e = str.length;
  }
  for (i = 0; str.charCodeAt(i) === 48; ) ++i;
  for (len = str.length; str.charCodeAt(len - 1) === 48; ) --len;
  str = str.slice(i, len);
  if (str) {
    len -= i;
    e = e - i - 1;
    x2.e = mathfloor(e / LOG_BASE);
    x2.d = [];
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;
    if (i < len) {
      if (i) x2.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len; ) x2.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }
    for (; i--; ) str += "0";
    x2.d.push(+str);
    if (external && (x2.e > MAX_E || x2.e < -MAX_E)) throw Error(exponentOutOfRange + e);
  } else {
    x2.s = 0;
    x2.e = 0;
    x2.d = [0];
  }
  return x2;
}
function round(x2, sd, rm) {
  var i, j, k2, n, rd, doRound, w, xdi, xd = x2.d;
  for (n = 1, k2 = xd[0]; k2 >= 10; k2 /= 10) n++;
  i = sd - n;
  if (i < 0) {
    i += LOG_BASE;
    j = sd;
    w = xd[xdi = 0];
  } else {
    xdi = Math.ceil((i + 1) / LOG_BASE);
    k2 = xd.length;
    if (xdi >= k2) return x2;
    w = k2 = xd[xdi];
    for (n = 1; k2 >= 10; k2 /= 10) n++;
    i %= LOG_BASE;
    j = i - LOG_BASE + n;
  }
  if (rm !== void 0) {
    k2 = mathpow(10, n - j - 1);
    rd = w / k2 % 10 | 0;
    doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k2;
    doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x2.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x2.s < 0 ? 8 : 7));
  }
  if (sd < 1 || !xd[0]) {
    if (doRound) {
      k2 = getBase10Exponent(x2);
      xd.length = 1;
      sd = sd - k2 - 1;
      xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
      x2.e = mathfloor(-sd / LOG_BASE) || 0;
    } else {
      xd.length = 1;
      xd[0] = x2.e = x2.s = 0;
    }
    return x2;
  }
  if (i == 0) {
    xd.length = xdi;
    k2 = 1;
    xdi--;
  } else {
    xd.length = xdi + 1;
    k2 = mathpow(10, LOG_BASE - i);
    xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k2 : 0;
  }
  if (doRound) {
    for (; ; ) {
      if (xdi == 0) {
        if ((xd[0] += k2) == BASE) {
          xd[0] = 1;
          ++x2.e;
        }
        break;
      } else {
        xd[xdi] += k2;
        if (xd[xdi] != BASE) break;
        xd[xdi--] = 0;
        k2 = 1;
      }
    }
  }
  for (i = xd.length; xd[--i] === 0; ) xd.pop();
  if (external && (x2.e > MAX_E || x2.e < -MAX_E)) {
    throw Error(exponentOutOfRange + getBase10Exponent(x2));
  }
  return x2;
}
function subtract(x2, y2) {
  var d, e, i, j, k2, len, xd, xe, xLTy, yd, Ctor = x2.constructor, pr = Ctor.precision;
  if (!x2.s || !y2.s) {
    if (y2.s) y2.s = -y2.s;
    else y2 = new Ctor(x2);
    return external ? round(y2, pr) : y2;
  }
  xd = x2.d;
  yd = y2.d;
  e = y2.e;
  xe = x2.e;
  xd = xd.slice();
  k2 = xe - e;
  if (k2) {
    xLTy = k2 < 0;
    if (xLTy) {
      d = xd;
      k2 = -k2;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
    if (k2 > i) {
      k2 = i;
      d.length = 1;
    }
    d.reverse();
    for (i = k2; i--; ) d.push(0);
    d.reverse();
  } else {
    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;
    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }
    k2 = 0;
  }
  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y2.s = -y2.s;
  }
  len = xd.length;
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
  for (i = yd.length; i > k2; ) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0; ) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }
    xd[i] -= yd[i];
  }
  for (; xd[--len] === 0; ) xd.pop();
  for (; xd[0] === 0; xd.shift()) --e;
  if (!xd[0]) return new Ctor(0);
  y2.d = xd;
  y2.e = e;
  return external ? round(y2, pr) : y2;
}
function toString(x2, isExp, sd) {
  var k2, e = getBase10Exponent(x2), str = digitsToString(x2.d), len = str.length;
  if (isExp) {
    if (sd && (k2 = sd - len) > 0) {
      str = str.charAt(0) + "." + str.slice(1) + getZeroString(k2);
    } else if (len > 1) {
      str = str.charAt(0) + "." + str.slice(1);
    }
    str = str + (e < 0 ? "e" : "e+") + e;
  } else if (e < 0) {
    str = "0." + getZeroString(-e - 1) + str;
    if (sd && (k2 = sd - len) > 0) str += getZeroString(k2);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k2 = sd - e - 1) > 0) str = str + "." + getZeroString(k2);
  } else {
    if ((k2 = e + 1) < len) str = str.slice(0, k2) + "." + str.slice(k2);
    if (sd && (k2 = sd - len) > 0) {
      if (e + 1 === len) str += ".";
      str += getZeroString(k2);
    }
  }
  return x2.s < 0 ? "-" + str : str;
}
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}
function clone(obj) {
  var i, p, ps;
  function Decimal2(value2) {
    var x2 = this;
    if (!(x2 instanceof Decimal2)) return new Decimal2(value2);
    x2.constructor = Decimal2;
    if (value2 instanceof Decimal2) {
      x2.s = value2.s;
      x2.e = value2.e;
      x2.d = (value2 = value2.d) ? value2.slice() : value2;
      return;
    }
    if (typeof value2 === "number") {
      if (value2 * 0 !== 0) {
        throw Error(invalidArgument + value2);
      }
      if (value2 > 0) {
        x2.s = 1;
      } else if (value2 < 0) {
        value2 = -value2;
        x2.s = -1;
      } else {
        x2.s = 0;
        x2.e = 0;
        x2.d = [0];
        return;
      }
      if (value2 === ~~value2 && value2 < 1e7) {
        x2.e = 0;
        x2.d = [value2];
        return;
      }
      return parseDecimal(x2, value2.toString());
    } else if (typeof value2 !== "string") {
      throw Error(invalidArgument + value2);
    }
    if (value2.charCodeAt(0) === 45) {
      value2 = value2.slice(1);
      x2.s = -1;
    } else {
      x2.s = 1;
    }
    if (isDecimal.test(value2)) parseDecimal(x2, value2);
    else throw Error(invalidArgument + value2);
  }
  Decimal2.prototype = P;
  Decimal2.ROUND_UP = 0;
  Decimal2.ROUND_DOWN = 1;
  Decimal2.ROUND_CEIL = 2;
  Decimal2.ROUND_FLOOR = 3;
  Decimal2.ROUND_HALF_UP = 4;
  Decimal2.ROUND_HALF_DOWN = 5;
  Decimal2.ROUND_HALF_EVEN = 6;
  Decimal2.ROUND_HALF_CEIL = 7;
  Decimal2.ROUND_HALF_FLOOR = 8;
  Decimal2.clone = clone;
  Decimal2.config = Decimal2.set = config;
  if (obj === void 0) obj = {};
  if (obj) {
    ps = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"];
    for (i = 0; i < ps.length; ) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
  }
  Decimal2.config(obj);
  return Decimal2;
}
function config(obj) {
  if (!obj || typeof obj !== "object") {
    throw Error(decimalError + "Object expected");
  }
  var i, p, v, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (i = 0; i < ps.length; i += 3) {
    if ((v = obj[p = ps[i]]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ": " + v);
    }
  }
  if ((v = obj[p = "LN10"]) !== void 0) {
    if (v == Math.LN10) this[p] = new this(v);
    else throw Error(invalidArgument + p + ": " + v);
  }
  return this;
}
var Decimal = clone(defaults);
ONE = new Decimal(1);
var decimal_default = Decimal;

// node_modules/.pnpm/recharts-scale@0.4.5/node_modules/recharts-scale/es6/util/utils.js
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray6(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray6(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray6(arr);
}
function _arrayLikeToArray6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var identity3 = function identity4(i) {
  return i;
};
var PLACE_HOLDER = {
  };
var isPlaceHolder = function isPlaceHolder2(val2) {
  return val2 === PLACE_HOLDER;
};
var curry0 = function curry02(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? void 0 : arguments[0])) {
      return _curried;
    }
    return fn.apply(void 0, arguments);
  };
};
var curryN = function curryN2(n, fn) {
  if (n === 1) {
    return fn;
  }
  return curry0(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var argsLength = args.filter(function(arg) {
      return arg !== PLACE_HOLDER;
    }).length;
    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }
    return curryN2(n - argsLength, curry0(function() {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }
      var newArgs = args.map(function(arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
    }));
  });
};
var curry = function curry2(fn) {
  return curryN(fn.length, fn);
};
var range2 = function range3(begin, end) {
  var arr = [];
  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }
  return arr;
};
var map2 = curry(function(fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }
  return Object.keys(arr).map(function(key2) {
    return arr[key2];
  }).map(fn);
});
var compose = function compose2() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  if (!args.length) {
    return identity3;
  }
  var fns = args.reverse();
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function() {
    return tailsFn.reduce(function(res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var reverse = function reverse2(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  }
  return arr.split("").reverse.join("");
};
var memoize = function memoize2(fn) {
  var lastArgs = null;
  var lastResult2 = null;
  return function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    if (lastArgs && args.every(function(val2, i) {
      return val2 === lastArgs[i];
    })) {
      return lastResult2;
    }
    lastArgs = args;
    lastResult2 = fn.apply(void 0, args);
    return lastResult2;
  };
};

// node_modules/.pnpm/recharts-scale@0.4.5/node_modules/recharts-scale/es6/util/arithmetic.js
function getDigitCount(value2) {
  var result;
  if (value2 === 0) {
    result = 1;
  } else {
    result = Math.floor(new decimal_default(value2).abs().log(10).toNumber()) + 1;
  }
  return result;
}
function rangeStep(start, end, step) {
  var num = new decimal_default(start);
  var i = 0;
  var result = [];
  while (num.lt(end) && i < 1e5) {
    result.push(num.toNumber());
    num = num.add(step);
    i++;
  }
  return result;
}
var interpolateNumber3 = curry(function(a2, b, t) {
  var newA = +a2;
  var newB = +b;
  return newA + t * (newB - newA);
});
var uninterpolateNumber = curry(function(a2, b, x2) {
  var diff = b - +a2;
  diff = diff || Infinity;
  return (x2 - a2) / diff;
});
var uninterpolateTruncation = curry(function(a2, b, x2) {
  var diff = b - +a2;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x2 - a2) / diff));
});
var arithmetic_default = {
  rangeStep,
  getDigitCount,
  interpolateNumber: interpolateNumber3,
  uninterpolateNumber,
  uninterpolateTruncation
};

// node_modules/.pnpm/recharts-scale@0.4.5/node_modules/recharts-scale/es6/getNiceTickValues.js
function _toConsumableArray2(arr) {
  return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray7(arr) || _nonIterableSpread2();
}
function _nonIterableSpread2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray2(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray7(arr);
}
function _slicedToArray6(arr, i) {
  return _arrayWithHoles6(arr) || _iterableToArrayLimit6(arr, i) || _unsupportedIterableToArray7(arr, i) || _nonIterableRest6();
}
function _nonIterableRest6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray7(o, minLen);
}
function _arrayLikeToArray7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit6(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles6(arr) {
  if (Array.isArray(arr)) return arr;
}
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray6(_ref, 2), min3 = _ref2[0], max4 = _ref2[1];
  var validMin = min3, validMax = max4;
  if (min3 > max4) {
    validMin = max4;
    validMax = min3;
  }
  return [validMin, validMax];
}
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new decimal_default(0);
  }
  var digitCount = arithmetic_default.getDigitCount(roughStep.toNumber());
  var digitCountValue = new decimal_default(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue);
  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new decimal_default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new decimal_default(Math.ceil(formatStep));
}
function getTickOfSingleValue(value2, tickCount, allowDecimals) {
  var step = 1;
  var middle = new decimal_default(value2);
  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value2);
    if (absVal < 1) {
      step = new decimal_default(10).pow(arithmetic_default.getDigitCount(value2) - 1);
      middle = new decimal_default(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      middle = new decimal_default(Math.floor(value2));
    }
  } else if (value2 === 0) {
    middle = new decimal_default(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new decimal_default(Math.floor(value2));
  }
  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = compose(map2(function(n) {
    return middle.add(new decimal_default(n - middleIndex).mul(step)).toNumber();
  }), range2);
  return fn(0, tickCount);
}
function calculateStep(min3, max4, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((max4 - min3) / (tickCount - 1))) {
    return {
      step: new decimal_default(0),
      tickMin: new decimal_default(0),
      tickMax: new decimal_default(0)
    };
  }
  var step = getFormatStep(new decimal_default(max4).sub(min3).div(tickCount - 1), allowDecimals, correctionFactor);
  var middle;
  if (min3 <= 0 && max4 >= 0) {
    middle = new decimal_default(0);
  } else {
    middle = new decimal_default(min3).add(max4).div(2);
    middle = middle.sub(new decimal_default(middle).mod(step));
  }
  var belowCount = Math.ceil(middle.sub(min3).div(step).toNumber());
  var upCount = Math.ceil(new decimal_default(max4).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;
  if (scaleCount > tickCount) {
    return calculateStep(min3, max4, tickCount, allowDecimals, correctionFactor + 1);
  }
  if (scaleCount < tickCount) {
    upCount = max4 > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max4 > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }
  return {
    step,
    tickMin: middle.sub(new decimal_default(belowCount).mul(step)),
    tickMax: middle.add(new decimal_default(upCount).mul(step))
  };
}
function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray6(_ref3, 2), min3 = _ref4[0], max4 = _ref4[1];
  var tickCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var count = Math.max(tickCount, 2);
  var _getValidInterval = getValidInterval([min3, max4]), _getValidInterval2 = _slicedToArray6(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray2(range2(0, tickCount - 1).map(function() {
      return Infinity;
    }))) : [].concat(_toConsumableArray2(range2(0, tickCount - 1).map(function() {
      return -Infinity;
    })), [cormax]);
    return min3 > max4 ? reverse(_values) : _values;
  }
  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }
  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
  var values = arithmetic_default.rangeStep(tickMin, tickMax.add(new decimal_default(0.1).mul(step)), step);
  return min3 > max4 ? reverse(values) : values;
}
function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray6(_ref7, 2), min3 = _ref8[0], max4 = _ref8[1];
  var allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var _getValidInterval5 = getValidInterval([min3, max4]), _getValidInterval6 = _slicedToArray6(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
  if (cormin === -Infinity || cormax === Infinity) {
    return [min3, max4];
  }
  if (cormin === cormax) {
    return [cormin];
  }
  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new decimal_default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray2(arithmetic_default.rangeStep(new decimal_default(cormin), new decimal_default(cormax).sub(new decimal_default(0.99).mul(step)), step)), [cormax]);
  return min3 > max4 ? reverse(values) : values;
}
var getNiceTickValues = memoize(getNiceTickValuesFn);
var getTickValuesFixedDomain = memoize(getTickValuesFixedDomainFn);

// node_modules/.pnpm/tiny-invariant@1.3.3/node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var isProduction = process.env.NODE_ENV === "production";
var prefix = "Invariant failed";
function invariant(condition, message) {
  if (isProduction) {
    throw new Error(prefix);
  }
  var provided = typeof message === "function" ? message() : message;
  var value2 = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
  throw new Error(value2);
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/ErrorBar.js
var _excluded9 = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _typeof14(o) {
  "@babel/helpers - typeof";
  return _typeof14 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof14(o);
}
function _extends8() {
  _extends8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends8.apply(this, arguments);
}
function _slicedToArray7(arr, i) {
  return _arrayWithHoles7(arr) || _iterableToArrayLimit7(arr, i) || _unsupportedIterableToArray8(arr, i) || _nonIterableRest7();
}
function _nonIterableRest7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray8(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray8(o, minLen);
}
function _arrayLikeToArray8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit7(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles7(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties9(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose9(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose9(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _classCallCheck6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey13(descriptor.key), descriptor);
  }
}
function _createClass6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties6(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper5(t, o, e) {
  return o = _getPrototypeOf5(o), _possibleConstructorReturn5(t, _isNativeReflectConstruct5() ? Reflect.construct(o, e || [], _getPrototypeOf5(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn5(self2, call) {
  if (call && (_typeof14(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized5(self2);
}
function _assertThisInitialized5(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct5 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf5(o) {
  _getPrototypeOf5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf5(o);
}
function _inherits5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf5(subClass, superClass);
}
function _setPrototypeOf5(o, p) {
  _setPrototypeOf5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf5(o, p);
}
function _defineProperty12(obj, key2, value2) {
  key2 = _toPropertyKey13(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey13(t) {
  var i = _toPrimitive13(t, "string");
  return "symbol" == _typeof14(i) ? i : i + "";
}
function _toPrimitive13(t, r2) {
  if ("object" != _typeof14(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof14(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var ErrorBar = /* @__PURE__ */ function(_React$Component) {
  function ErrorBar2() {
    _classCallCheck6(this, ErrorBar2);
    return _callSuper5(this, ErrorBar2, arguments);
  }
  _inherits5(ErrorBar2, _React$Component);
  return _createClass6(ErrorBar2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width2 = _this$props.width, dataKey = _this$props.dataKey, data2 = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = _objectWithoutProperties9(_this$props, _excluded9);
      var svgProps = filterProps(others, false);
      !!(this.props.direction === "x" && xAxis.type !== "number") ? process.env.NODE_ENV !== "production" ? invariant(false, 'ErrorBar requires Axis type property to be "number".') : invariant() : void 0;
      var errorBars = data2.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x2 = _dataPointFormatter.x, y2 = _dataPointFormatter.y, value2 = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) {
          return null;
        }
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
          var _errorVal = _slicedToArray7(errorVal, 2);
          lowBound = _errorVal[0];
          highBound = _errorVal[1];
        } else {
          lowBound = highBound = errorVal;
        }
        if (layout === "vertical") {
          var scale2 = xAxis.scale;
          var yMid = y2 + offset;
          var yMin = yMid + width2;
          var yMax = yMid - width2;
          var xMin = scale2(value2 - lowBound);
          var xMax = scale2(value2 + highBound);
          lineCoordinates.push({
            x1: xMax,
            y1: yMin,
            x2: xMax,
            y2: yMax
          });
          lineCoordinates.push({
            x1: xMin,
            y1: yMid,
            x2: xMax,
            y2: yMid
          });
          lineCoordinates.push({
            x1: xMin,
            y1: yMin,
            x2: xMin,
            y2: yMax
          });
        } else if (layout === "horizontal") {
          var _scale = yAxis.scale;
          var xMid = x2 + offset;
          var _xMin = xMid - width2;
          var _xMax = xMid + width2;
          var _yMin = _scale(value2 - lowBound);
          var _yMax = _scale(value2 + highBound);
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMax,
            x2: _xMax,
            y2: _yMax
          });
          lineCoordinates.push({
            x1: xMid,
            y1: _yMin,
            x2: xMid,
            y2: _yMax
          });
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMin,
            x2: _xMax,
            y2: _yMin
          });
        }
        return /* @__PURE__ */ React43.createElement(Layer, _extends8({
          className: "recharts-errorBar",
          key: "bar-".concat(lineCoordinates.map(function(c2) {
            return "".concat(c2.x1, "-").concat(c2.x2, "-").concat(c2.y1, "-").concat(c2.y2);
          }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
          return /* @__PURE__ */ React43.createElement("line", _extends8({}, coordinates, {
            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
          }));
        }));
      });
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-errorBars"
      }, errorBars);
    }
  }]);
}(React43.Component);
_defineProperty12(ErrorBar, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
_defineProperty12(ErrorBar, "displayName", "ErrorBar");

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/getLegendProps.js
function _typeof15(o) {
  "@babel/helpers - typeof";
  return _typeof15 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof15(o);
}
function ownKeys11(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread11(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys11(Object(t), true).forEach(function(r3) {
      _defineProperty13(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys11(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty13(obj, key2, value2) {
  key2 = _toPropertyKey14(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey14(t) {
  var i = _toPrimitive14(t, "string");
  return "symbol" == _typeof15(i) ? i : i + "";
}
function _toPrimitive14(t, r2) {
  if ("object" != _typeof15(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof15(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getLegendProps = function getLegendProps2(_ref) {
  var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
  var legendItem = findChildByType(children, Legend);
  if (!legendItem) {
    return null;
  }
  var legendDefaultProps = Legend.defaultProps;
  var legendProps = legendDefaultProps !== void 0 ? _objectSpread11(_objectSpread11({}, legendDefaultProps), legendItem.props) : {};
  var legendData;
  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === "children") {
    legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
      var item = _ref2.item, props = _ref2.props;
      var data2 = props.sectors || props.data || [];
      return result.concat(data2.map(function(entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formattedGraphicalItems || []).map(function(_ref3) {
      var item = _ref3.item;
      var itemDefaultProps = item.type.defaultProps;
      var itemProps = itemDefaultProps !== void 0 ? _objectSpread11(_objectSpread11({}, itemDefaultProps), item.props) : {};
      var dataKey = itemProps.dataKey, name2 = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
      return {
        inactive: hide,
        dataKey,
        type: legendProps.iconType || legendType || "square",
        color: getMainColorOfGraphicItem(item),
        value: name2 || dataKey,
        // @ts-expect-error property strokeDasharray is required in Payload but optional in props
        payload: itemProps
      };
    });
  }
  return _objectSpread11(_objectSpread11(_objectSpread11({}, legendProps), Legend.getWithHeight(legendItem, legendWidth)), {}, {
    payload: legendData,
    item: legendItem
  });
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ChartUtils.js
function _typeof16(o) {
  "@babel/helpers - typeof";
  return _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof16(o);
}
function _toConsumableArray3(arr) {
  return _arrayWithoutHoles3(arr) || _iterableToArray3(arr) || _unsupportedIterableToArray9(arr) || _nonIterableSpread3();
}
function _nonIterableSpread3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray9(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray9(o, minLen);
}
function _iterableToArray3(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles3(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray9(arr);
}
function _arrayLikeToArray9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys12(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread12(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys12(Object(t), true).forEach(function(r3) {
      _defineProperty14(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys12(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty14(obj, key2, value2) {
  key2 = _toPropertyKey15(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey15(t) {
  var i = _toPrimitive15(t, "string");
  return "symbol" == _typeof16(i) ? i : i + "";
}
function _toPrimitive15(t, r2) {
  if ("object" != _typeof16(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof16(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function getValueByDataKey(obj, dataKey, defaultValue) {
  if ((0, import_isNil4.default)(obj) || (0, import_isNil4.default)(dataKey)) {
    return defaultValue;
  }
  if (isNumOrStr(dataKey)) {
    return (0, import_get3.default)(obj, dataKey, defaultValue);
  }
  if ((0, import_isFunction4.default)(dataKey)) {
    return dataKey(obj);
  }
  return defaultValue;
}
function getDomainOfDataByKey(data2, key2, type, filterNil) {
  var flattenData = (0, import_flatMap.default)(data2, function(entry) {
    return getValueByDataKey(entry, key2);
  });
  if (type === "number") {
    var domain = flattenData.filter(function(entry) {
      return isNumber(entry) || parseFloat(entry);
    });
    return domain.length ? [(0, import_min2.default)(domain), (0, import_max2.default)(domain)] : [Infinity, -Infinity];
  }
  var validateData = filterNil ? flattenData.filter(function(entry) {
    return !(0, import_isNil4.default)(entry);
  }) : flattenData;
  return validateData.map(function(entry) {
    return isNumOrStr(entry) || entry instanceof Date ? entry : "";
  });
}
var calculateActiveTickIndex = function calculateActiveTickIndex2(coordinate) {
  var _ticks$length;
  var ticks2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var unsortedTicks = arguments.length > 2 ? arguments[2] : void 0;
  var axis = arguments.length > 3 ? arguments[3] : void 0;
  var index2 = -1;
  var len = (_ticks$length = ticks2 === null || ticks2 === void 0 ? void 0 : ticks2.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
  if (len <= 1) {
    return 0;
  }
  if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
    var range6 = axis.range;
    for (var i = 0; i < len; i++) {
      var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
      var cur = unsortedTicks[i].coordinate;
      var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
      var sameDirectionCoord = void 0;
      if (mathSign(cur - before) !== mathSign(after - cur)) {
        var diffInterval = [];
        if (mathSign(after - cur) === mathSign(range6[1] - range6[0])) {
          sameDirectionCoord = after;
          var curInRange = cur + range6[1] - range6[0];
          diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
          diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
        } else {
          sameDirectionCoord = before;
          var afterInRange = after + range6[1] - range6[0];
          diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
          diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
        }
        var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
        if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
          index2 = unsortedTicks[i].index;
          break;
        }
      } else {
        var minValue = Math.min(before, after);
        var maxValue = Math.max(before, after);
        if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
          index2 = unsortedTicks[i].index;
          break;
        }
      }
    }
  } else {
    for (var _i = 0; _i < len; _i++) {
      if (_i === 0 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2) {
        index2 = ticks2[_i].index;
        break;
      }
    }
  }
  return index2;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem2(item) {
  var _item$type;
  var _ref = item, displayName = _ref.type.displayName;
  var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? _objectSpread12(_objectSpread12({}, item.type.defaultProps), item.props) : item.props;
  var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
  var result;
  switch (displayName) {
    case "Line":
      result = stroke;
      break;
    case "Area":
    case "Radar":
      result = stroke && stroke !== "none" ? stroke : fill;
      break;
    default:
      result = fill;
      break;
  }
  return result;
};
var getBarSizeList = function getBarSizeList2(_ref2) {
  var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
  if (!stackGroups) {
    return {};
  }
  var result = {};
  var numericAxisIds = Object.keys(stackGroups);
  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);
    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function(item) {
        return getDisplayName(item.type).indexOf("Bar") >= 0;
      });
      if (barItems && barItems.length) {
        var barItemDefaultProps = barItems[0].type.defaultProps;
        var barItemProps = barItemDefaultProps !== void 0 ? _objectSpread12(_objectSpread12({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
        var selfSize = barItemProps.barSize;
        var cateId = barItemProps[cateAxisId];
        if (!result[cateId]) {
          result[cateId] = [];
        }
        var barSize = (0, import_isNil4.default)(selfSize) ? globalSize : selfSize;
        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: (0, import_isNil4.default)(barSize) ? void 0 : getPercentValue(barSize, totalSize, 0)
        });
      }
    }
  }
  return result;
};
var getBarPosition = function getBarPosition2(_ref3) {
  var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = getPercentValue(barGap, bandSize, 0, true);
  var result;
  var initialValue = [];
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum2 = sizeList.reduce(function(res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum2 += (len - 1) * realBarGap;
    if (sum2 >= bandSize) {
      sum2 -= (len - 1) * realBarGap;
      realBarGap = 0;
    }
    if (sum2 >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum2 = len * fullBarSize;
    }
    var offset = (bandSize - sum2) / 2 >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function(res, entry) {
      var newPosition = {
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: useFull ? fullBarSize : entry.barSize
        }
      };
      var newRes = [].concat(_toConsumableArray3(res), [newPosition]);
      prev = newRes[newRes.length - 1].position;
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function(item) {
          newRes.push({
            item,
            position: prev
          });
        });
      }
      return newRes;
    }, initialValue);
  } else {
    var _offset = getPercentValue(barCategoryGap, bandSize, 0, true);
    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }
    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    if (originalSize > 1) {
      originalSize >>= 0;
    }
    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function(res, entry, i) {
      var newRes = [].concat(_toConsumableArray3(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size
        }
      }]);
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function(item) {
          newRes.push({
            item,
            position: newRes[newRes.length - 1].position
          });
        });
      }
      return newRes;
    }, initialValue);
  }
  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend2(offset, _unused, props, legendBox) {
  var children = props.children, width2 = props.width, margin = props.margin;
  var legendWidth = width2 - (margin.left || 0) - (margin.right || 0);
  var legendProps = getLegendProps({
    children,
    legendWidth
  });
  if (legendProps) {
    var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
    var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
    if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && isNumber(offset[align])) {
      return _objectSpread12(_objectSpread12({}, offset), {}, _defineProperty14({}, align, offset[align] + (boxWidth || 0)));
    }
    if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && isNumber(offset[verticalAlign])) {
      return _objectSpread12(_objectSpread12({}, offset), {}, _defineProperty14({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
  }
  return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis2(layout, axisType, direction) {
  if ((0, import_isNil4.default)(axisType)) {
    return true;
  }
  if (layout === "horizontal") {
    return axisType === "yAxis";
  }
  if (layout === "vertical") {
    return axisType === "xAxis";
  }
  if (direction === "x") {
    return axisType === "xAxis";
  }
  if (direction === "y") {
    return axisType === "yAxis";
  }
  return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars2(data2, item, dataKey, layout, axisType) {
  var children = item.props.children;
  var errorBars = findAllByType(children, ErrorBar).filter(function(errorBarChild) {
    return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
  });
  if (errorBars && errorBars.length) {
    var keys2 = errorBars.map(function(errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data2.reduce(function(result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey);
      if ((0, import_isNil4.default)(entryValue)) return result;
      var mainValue = Array.isArray(entryValue) ? [(0, import_min2.default)(entryValue), (0, import_max2.default)(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys2.reduce(function(prevErrorArr, k2) {
        var errorValue = getValueByDataKey(entry, k2, 0);
        var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis2(data2, items, dataKey, axisType, layout) {
  var domains = items.map(function(item) {
    return getDomainOfErrorBars(data2, item, dataKey, layout, axisType);
  }).filter(function(entry) {
    return !(0, import_isNil4.default)(entry);
  });
  if (domains && domains.length) {
    return domains.reduce(function(result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis2(data2, items, type, layout, filterNil) {
  var domains = items.map(function(item) {
    var dataKey = item.props.dataKey;
    if (type === "number" && dataKey) {
      return getDomainOfErrorBars(data2, item, dataKey, layout) || getDomainOfDataByKey(data2, dataKey, type, filterNil);
    }
    return getDomainOfDataByKey(data2, dataKey, type, filterNil);
  });
  if (type === "number") {
    return domains.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(result, entry) {
        return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
      },
      [Infinity, -Infinity]
    );
  }
  var tag = {};
  return domains.reduce(function(result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;
        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};
var isCategoricalAxis = function isCategoricalAxis2(layout, axisType) {
  return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid2(ticks2, minValue, maxValue, syncWithTicks) {
  if (syncWithTicks) {
    return ticks2.map(function(entry) {
      return entry.coordinate;
    });
  }
  var hasMin, hasMax;
  var values = ticks2.map(function(entry) {
    if (entry.coordinate === minValue) {
      hasMin = true;
    }
    if (entry.coordinate === maxValue) {
      hasMax = true;
    }
    return entry.coordinate;
  });
  if (!hasMin) {
    values.push(minValue);
  }
  if (!hasMax) {
    values.push(maxValue);
  }
  return values;
};
var getTicksOfAxis = function getTicksOfAxis2(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale2 = axis.scale;
  var duplicateDomain = axis.duplicateDomain, type = axis.type, range6 = axis.range;
  var offsetForBand = axis.realScaleType === "scaleBand" ? scale2.bandwidth() / 2 : 2;
  var offset = (isGrid || isAll) && type === "category" && scale2.bandwidth ? scale2.bandwidth() / offsetForBand : 0;
  offset = axis.axisType === "angleAxis" && (range6 === null || range6 === void 0 ? void 0 : range6.length) >= 2 ? mathSign(range6[0] - range6[1]) * 2 * offset : offset;
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    var result = (axis.ticks || axis.niceTicks).map(function(entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: scale2(scaleContent) + offset,
        value: entry,
        offset
      };
    });
    return result.filter(function(row) {
      return !(0, import_isNaN2.default)(row.coordinate);
    });
  }
  if (axis.isCategorical && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function(entry, index2) {
      return {
        coordinate: scale2(entry) + offset,
        value: entry,
        index: index2,
        offset
      };
    });
  }
  if (scale2.ticks && !isAll) {
    return scale2.ticks(axis.tickCount).map(function(entry) {
      return {
        coordinate: scale2(entry) + offset,
        value: entry,
        offset
      };
    });
  }
  return scale2.domain().map(function(entry, index2) {
    return {
      coordinate: scale2(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index2,
      offset
    };
  });
};
var handlerWeakMap = /* @__PURE__ */ new WeakMap();
var combineEventHandlers = function combineEventHandlers2(defaultHandler, childHandler) {
  if (typeof childHandler !== "function") {
    return defaultHandler;
  }
  if (!handlerWeakMap.has(defaultHandler)) {
    handlerWeakMap.set(defaultHandler, /* @__PURE__ */ new WeakMap());
  }
  var childWeakMap = handlerWeakMap.get(defaultHandler);
  if (childWeakMap.has(childHandler)) {
    return childWeakMap.get(childHandler);
  }
  var combineHandler = function combineHandler2() {
    defaultHandler.apply(void 0, arguments);
    childHandler.apply(void 0, arguments);
  };
  childWeakMap.set(childHandler, combineHandler);
  return combineHandler;
};
var parseScale = function parseScale2(axis, chartType, hasBar) {
  var scale2 = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
  if (scale2 === "auto") {
    if (layout === "radial" && axisType === "radiusAxis") {
      return {
        scale: band(),
        realScaleType: "band"
      };
    }
    if (layout === "radial" && axisType === "angleAxis") {
      return {
        scale: linear3(),
        realScaleType: "linear"
      };
    }
    if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) {
      return {
        scale: point3(),
        realScaleType: "point"
      };
    }
    if (type === "category") {
      return {
        scale: band(),
        realScaleType: "band"
      };
    }
    return {
      scale: linear3(),
      realScaleType: "linear"
    };
  }
  if ((0, import_isString3.default)(scale2)) {
    var name2 = "scale".concat((0, import_upperFirst2.default)(scale2));
    return {
      scale: (d3_scale_exports[name2] || point3)(),
      realScaleType: d3_scale_exports[name2] ? name2 : "point"
    };
  }
  return (0, import_isFunction4.default)(scale2) ? {
    scale: scale2
  } : {
    scale: point3(),
    realScaleType: "point"
  };
};
var EPS2 = 1e-4;
var checkDomainOfScale = function checkDomainOfScale2(scale2) {
  var domain = scale2.domain();
  if (!domain || domain.length <= 2) {
    return;
  }
  var len = domain.length;
  var range6 = scale2.range();
  var minValue = Math.min(range6[0], range6[1]) - EPS2;
  var maxValue = Math.max(range6[0], range6[1]) + EPS2;
  var first = scale2(domain[0]);
  var last2 = scale2(domain[len - 1]);
  if (first < minValue || first > maxValue || last2 < minValue || last2 > maxValue) {
    scale2.domain([domain[0], domain[len - 1]]);
  }
};
var findPositionOfBar = function findPositionOfBar2(barPosition, child) {
  if (!barPosition) {
    return null;
  }
  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }
  return null;
};
var truncateByDomain = function truncateByDomain2(value2, domain) {
  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
    return value2;
  }
  var minValue = Math.min(domain[0], domain[1]);
  var maxValue = Math.max(domain[0], domain[1]);
  var result = [value2[0], value2[1]];
  if (!isNumber(value2[0]) || value2[0] < minValue) {
    result[0] = minValue;
  }
  if (!isNumber(value2[1]) || value2[1] > maxValue) {
    result[1] = maxValue;
  }
  if (result[0] > maxValue) {
    result[0] = maxValue;
  }
  if (result[1] < minValue) {
    result[1] = minValue;
  }
  return result;
};
var offsetSign = function offsetSign2(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;
    for (var i = 0; i < n; ++i) {
      var value2 = (0, import_isNaN2.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      if (value2 >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value2;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value2;
        negative = series[i][j][1];
      }
    }
  }
};
var offsetPositive = function offsetPositive2(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    for (var i = 0; i < n; ++i) {
      var value2 = (0, import_isNaN2.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      if (value2 >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value2;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = 0;
        series[i][j][1] = 0;
      }
    }
  }
};
var STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: expand_default,
  // @ts-expect-error definitelytyped types are incorrect
  none: none_default,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: silhouette_default,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: wiggle_default,
  positive: offsetPositive
};
var getStackedData = function getStackedData2(data2, stackItems, offsetType) {
  var dataKeys = stackItems.map(function(item) {
    return item.props.dataKey;
  });
  var offsetAccessor = STACK_OFFSET_MAP[offsetType];
  var stack = stack_default().keys(dataKeys).value(function(d, key2) {
    return +getValueByDataKey(d, key2, 0);
  }).order(none_default2).offset(offsetAccessor);
  return stack(data2);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId2(data2, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data2) {
    return null;
  }
  var items = reverseStackOrder ? _items.reverse() : _items;
  var parentStackGroupsInitialValue = {};
  var stackGroups = items.reduce(function(result, item) {
    var _item$type2;
    var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? _objectSpread12(_objectSpread12({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
    if (hide) {
      return result;
    }
    var axisId = defaultedProps[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };
    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId,
        cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[uniqueId("_stackId_")] = {
        numericAxisId,
        cateAxisId,
        items: [item]
      };
    }
    return _objectSpread12(_objectSpread12({}, result), {}, _defineProperty14({}, axisId, parentGroup));
  }, parentStackGroupsInitialValue);
  var axisStackGroupsInitialValue = {};
  return Object.keys(stackGroups).reduce(function(result, axisId) {
    var group = stackGroups[axisId];
    if (group.hasStack) {
      var stackGroupsInitialValue = {};
      group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread12(_objectSpread12({}, res), {}, _defineProperty14({}, stackId, {
          numericAxisId,
          cateAxisId,
          items: g.items,
          stackedData: getStackedData(data2, g.items, offsetType)
        }));
      }, stackGroupsInitialValue);
    }
    return _objectSpread12(_objectSpread12({}, result), {}, _defineProperty14({}, axisId, group));
  }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale2(scale2, opts) {
  var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;
  if (scaleType !== "auto" && scaleType !== "linear") {
    return null;
  }
  if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
    var domain = scale2.domain();
    if (!domain.length) {
      return null;
    }
    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);
    scale2.domain([(0, import_min2.default)(tickValues), (0, import_max2.default)(tickValues)]);
    return {
      niceTicks: tickValues
    };
  }
  if (tickCount && type === "number") {
    var _domain = scale2.domain();
    var _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);
    return {
      niceTicks: _tickValues
    };
  }
  return null;
};
function getCateCoordinateOfLine(_ref5) {
  var axis = _ref5.axis, ticks2 = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index2 = _ref5.index, dataKey = _ref5.dataKey;
  if (axis.type === "category") {
    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, import_isNil4.default)(entry[axis.dataKey])) {
      var matchedTick = findEntryInArray(ticks2, "value", entry[axis.dataKey]);
      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }
    return ticks2[index2] ? ticks2[index2].coordinate + bandSize / 2 : null;
  }
  var value2 = getValueByDataKey(entry, !(0, import_isNil4.default)(dataKey) ? dataKey : axis.dataKey);
  return !(0, import_isNil4.default)(value2) ? axis.scale(value2) : null;
}
var getCateCoordinateOfBar = function getCateCoordinateOfBar2(_ref6) {
  var axis = _ref6.axis, ticks2 = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index2 = _ref6.index;
  if (axis.type === "category") {
    return ticks2[index2] ? ticks2[index2].coordinate + offset : null;
  }
  var value2 = getValueByDataKey(entry, axis.dataKey, axis.domain[index2]);
  return !(0, import_isNil4.default)(value2) ? axis.scale(value2) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar2(_ref7) {
  var numericAxis = _ref7.numericAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === "number") {
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    if (minValue <= 0 && maxValue >= 0) {
      return 0;
    }
    if (maxValue < 0) {
      return maxValue;
    }
    return minValue;
  }
  return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem2(item, stackGroups) {
  var _item$type3;
  var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? _objectSpread12(_objectSpread12({}, item.type.defaultProps), item.props) : item.props;
  var stackId = defaultedProps.stackId;
  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];
    if (group) {
      var itemIndex = group.items.indexOf(item);
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }
  return null;
};
var getDomainOfSingle = function getDomainOfSingle2(data2) {
  return data2.reduce(function(result, entry) {
    return [(0, import_min2.default)(entry.concat([result[0]]).filter(isNumber)), (0, import_max2.default)(entry.concat([result[1]]).filter(isNumber))];
  }, [Infinity, -Infinity]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups2(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function(result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function(res, entry) {
      var s2 = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s2[0]), Math.max(res[1], s2[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function(result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain2(specifiedDomain, dataDomain, allowDataOverflow) {
  if ((0, import_isFunction4.default)(specifiedDomain)) {
    return specifiedDomain(dataDomain, allowDataOverflow);
  }
  if (!Array.isArray(specifiedDomain)) {
    return dataDomain;
  }
  var domain = [];
  if (isNumber(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value2 = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value2;
  } else if ((0, import_isFunction4.default)(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }
  if (isNumber(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
    domain[1] = dataDomain[1] + _value;
  } else if ((0, import_isFunction4.default)(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis2(axis, ticks2, isBar) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    var bandWidth = axis.scale.bandwidth();
    if (!isBar || bandWidth > 0) {
      return bandWidth;
    }
  }
  if (axis && ticks2 && ticks2.length >= 2) {
    var orderedTicks = (0, import_sortBy2.default)(ticks2, function(o) {
      return o.coordinate;
    });
    var bandSize = Infinity;
    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }
    return bandSize === Infinity ? 0 : bandSize;
  }
  return isBar ? void 0 : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis2(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }
  if ((0, import_isEqual.default)(specifiedDomain, (0, import_get3.default)(axisChild, "type.defaultProps.domain"))) {
    return calculatedDomain;
  }
  return specifiedDomain;
};
var getTooltipItem = function getTooltipItem2(graphicalItem, payload) {
  var defaultedProps = graphicalItem.type.defaultProps ? _objectSpread12(_objectSpread12({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
  var dataKey = defaultedProps.dataKey, name2 = defaultedProps.name, unit2 = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
  return _objectSpread12(_objectSpread12({}, filterProps(graphicalItem, false)), {}, {
    dataKey,
    unit: unit2,
    formatter,
    name: name2 || dataKey,
    color: getMainColorOfGraphicItem(graphicalItem),
    value: getValueByDataKey(payload, dataKey),
    type: tooltipType,
    payload,
    chartType,
    hide
  });
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/PolarUtils.js
function _typeof17(o) {
  "@babel/helpers - typeof";
  return _typeof17 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof17(o);
}
function ownKeys13(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread13(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys13(Object(t), true).forEach(function(r3) {
      _defineProperty15(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys13(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty15(obj, key2, value2) {
  key2 = _toPropertyKey16(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey16(t) {
  var i = _toPrimitive16(t, "string");
  return "symbol" == _typeof17(i) ? i : i + "";
}
function _toPrimitive16(t, r2) {
  if ("object" != _typeof17(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof17(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _slicedToArray8(arr, i) {
  return _arrayWithHoles8(arr) || _iterableToArrayLimit8(arr, i) || _unsupportedIterableToArray10(arr, i) || _nonIterableRest8();
}
function _nonIterableRest8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray10(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray10(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray10(o, minLen);
}
function _arrayLikeToArray10(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit8(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles8(arr) {
  if (Array.isArray(arr)) return arr;
}
var RADIAN2 = Math.PI / 180;
var radianToDegree = function radianToDegree2(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian2(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN2 * angle) * radius,
    y: cy + Math.sin(-RADIAN2 * angle) * radius
  };
};
var getMaxRadius = function getMaxRadius2(width2, height2) {
  var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width2 - (offset.left || 0) - (offset.right || 0)), Math.abs(height2 - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var formatAxisMap = function formatAxisMap2(props, axisMap, offset, axisType, chartName) {
  var width2 = props.width, height2 = props.height;
  var startAngle = props.startAngle, endAngle = props.endAngle;
  var cx = getPercentValue(props.cx, width2, width2 / 2);
  var cy = getPercentValue(props.cy, height2, height2 / 2);
  var maxRadius = getMaxRadius(width2, height2, offset);
  var innerRadius = getPercentValue(props.innerRadius, maxRadius, 0);
  var outerRadius = getPercentValue(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);
  return ids.reduce(function(result, id) {
    var axis = axisMap[id];
    var domain = axis.domain, reversed = axis.reversed;
    var range6;
    if ((0, import_isNil5.default)(axis.range)) {
      if (axisType === "angleAxis") {
        range6 = [startAngle, endAngle];
      } else if (axisType === "radiusAxis") {
        range6 = [innerRadius, outerRadius];
      }
      if (reversed) {
        range6 = [range6[1], range6[0]];
      }
    } else {
      range6 = axis.range;
      var _range = range6;
      var _range2 = _slicedToArray8(_range, 2);
      startAngle = _range2[0];
      endAngle = _range2[1];
    }
    var _parseScale = parseScale(axis, chartName), realScaleType = _parseScale.realScaleType, scale2 = _parseScale.scale;
    scale2.domain(domain).range(range6);
    checkDomainOfScale(scale2);
    var ticks2 = getTicksOfScale(scale2, _objectSpread13(_objectSpread13({}, axis), {}, {
      realScaleType
    }));
    var finalAxis = _objectSpread13(_objectSpread13(_objectSpread13({}, axis), ticks2), {}, {
      range: range6,
      radius: outerRadius,
      realScaleType,
      scale: scale2,
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
    return _objectSpread13(_objectSpread13({}, result), {}, _defineProperty15({}, id, finalAxis));
  }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints2(point4, anotherPoint) {
  var x1 = point4.x, y1 = point4.y;
  var x2 = anotherPoint.x, y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint2(_ref, _ref2) {
  var x2 = _ref.x, y2 = _ref.y;
  var cx = _ref2.cx, cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x2,
    y: y2
  }, {
    x: cx,
    y: cy
  });
  if (radius <= 0) {
    return {
      radius
    };
  }
  var cos2 = (x2 - cx) / radius;
  var angleInRadian = Math.acos(cos2);
  if (y2 > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }
  return {
    radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian
  };
};
var formatAngleOfSector = function formatAngleOfSector2(_ref3) {
  var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min3 = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min3 * 360,
    endAngle: endAngle - min3 * 360
  };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor2(angle, _ref4) {
  var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min3 = Math.min(startCnt, endCnt);
  return angle + min3 * 360;
};
var inRangeOfSector = function inRangeOfSector2(_ref5, sector) {
  var x2 = _ref5.x, y2 = _ref5.y;
  var _getAngleOfPoint = getAngleOfPoint({
    x: x2,
    y: y2
  }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
  var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }
  if (radius === 0) {
    return true;
  }
  var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
  var formatAngle = angle;
  var inRange;
  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < startAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < endAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }
  if (inRange) {
    return _objectSpread13(_objectSpread13({}, sector), {}, {
      radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }
  return null;
};
var getTickClassName = function getTickClassName2(tick) {
  return !/* @__PURE__ */ isValidElement(tick) && !(0, import_isFunction5.default)(tick) && typeof tick !== "boolean" ? tick.className : "";
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Label.js
function _typeof18(o) {
  "@babel/helpers - typeof";
  return _typeof18 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof18(o);
}
var _excluded10 = ["offset"];
function _toConsumableArray4(arr) {
  return _arrayWithoutHoles4(arr) || _iterableToArray4(arr) || _unsupportedIterableToArray11(arr) || _nonIterableSpread4();
}
function _nonIterableSpread4() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray11(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray11(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray11(o, minLen);
}
function _iterableToArray4(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles4(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray11(arr);
}
function _arrayLikeToArray11(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _objectWithoutProperties10(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose10(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose10(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function ownKeys14(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread14(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys14(Object(t), true).forEach(function(r3) {
      _defineProperty16(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys14(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty16(obj, key2, value2) {
  key2 = _toPropertyKey17(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey17(t) {
  var i = _toPrimitive17(t, "string");
  return "symbol" == _typeof18(i) ? i : i + "";
}
function _toPrimitive17(t, r2) {
  if ("object" != _typeof18(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof18(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _extends9() {
  _extends9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends9.apply(this, arguments);
}
var getLabel = function getLabel2(props) {
  var value2 = props.value, formatter = props.formatter;
  var label = (0, import_isNil6.default)(props.children) ? value2 : props.children;
  if ((0, import_isFunction6.default)(formatter)) {
    return formatter(label);
  }
  return label;
};
var getDeltaAngle = function getDeltaAngle2(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel2(labelProps, label, attrs) {
  var position2 = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
  var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle(startAngle, endAngle);
  var sign2 = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;
  if (position2 === "insideStart") {
    labelAngle = startAngle + sign2 * offset;
    direction = clockWise;
  } else if (position2 === "insideEnd") {
    labelAngle = endAngle - sign2 * offset;
    direction = !clockWise;
  } else if (position2 === "end") {
    labelAngle = endAngle + sign2 * offset;
    direction = clockWise;
  }
  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = polarToCartesian(cx, cy, radius, labelAngle);
  var endPoint = polarToCartesian(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path2 = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id = (0, import_isNil6.default)(labelProps.id) ? uniqueId("recharts-radial-line-") : labelProps.id;
  return /* @__PURE__ */ React43.createElement("text", _extends9({}, attrs, {
    dominantBaseline: "central",
    className: clsx_default("recharts-radial-bar-label", className)
  }), /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("path", {
    id,
    d: path2
  })), /* @__PURE__ */ React43.createElement("textPath", {
    xlinkHref: "#".concat(id)
  }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel2(props) {
  var viewBox = props.viewBox, offset = props.offset, position2 = props.position;
  var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
  var midAngle = (startAngle + endAngle) / 2;
  if (position2 === "outside") {
    var _polarToCartesian = polarToCartesian(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (position2 === "center") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  }
  if (position2 === "centerTop") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  }
  if (position2 === "centerBottom") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  }
  var r2 = (innerRadius + outerRadius) / 2;
  var _polarToCartesian2 = polarToCartesian(cx, cy, r2, midAngle), x2 = _polarToCartesian2.x, y2 = _polarToCartesian2.y;
  return {
    x: x2,
    y: y2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel2(props) {
  var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position2 = props.position;
  var _ref3 = viewBox, x2 = _ref3.x, y2 = _ref3.y, width2 = _ref3.width, height2 = _ref3.height;
  var verticalSign = height2 >= 0 ? 1 : -1;
  var verticalOffset = verticalSign * offset;
  var verticalEnd = verticalSign > 0 ? "end" : "start";
  var verticalStart = verticalSign > 0 ? "start" : "end";
  var horizontalSign = width2 >= 0 ? 1 : -1;
  var horizontalOffset = horizontalSign * offset;
  var horizontalEnd = horizontalSign > 0 ? "end" : "start";
  var horizontalStart = horizontalSign > 0 ? "start" : "end";
  if (position2 === "top") {
    var attrs = {
      x: x2 + width2 / 2,
      y: y2 - verticalSign * offset,
      textAnchor: "middle",
      verticalAnchor: verticalEnd
    };
    return _objectSpread14(_objectSpread14({}, attrs), parentViewBox ? {
      height: Math.max(y2 - parentViewBox.y, 0),
      width: width2
    } : {});
  }
  if (position2 === "bottom") {
    var _attrs = {
      x: x2 + width2 / 2,
      y: y2 + height2 + verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalStart
    };
    return _objectSpread14(_objectSpread14({}, _attrs), parentViewBox ? {
      height: Math.max(parentViewBox.y + parentViewBox.height - (y2 + height2), 0),
      width: width2
    } : {});
  }
  if (position2 === "left") {
    var _attrs2 = {
      x: x2 - horizontalOffset,
      y: y2 + height2 / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: "middle"
    };
    return _objectSpread14(_objectSpread14({}, _attrs2), parentViewBox ? {
      width: Math.max(_attrs2.x - parentViewBox.x, 0),
      height: height2
    } : {});
  }
  if (position2 === "right") {
    var _attrs3 = {
      x: x2 + width2 + horizontalOffset,
      y: y2 + height2 / 2,
      textAnchor: horizontalStart,
      verticalAnchor: "middle"
    };
    return _objectSpread14(_objectSpread14({}, _attrs3), parentViewBox ? {
      width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
      height: height2
    } : {});
  }
  var sizeAttrs = parentViewBox ? {
    width: width2,
    height: height2
  } : {};
  if (position2 === "insideLeft") {
    return _objectSpread14({
      x: x2 + horizontalOffset,
      y: y2 + height2 / 2,
      textAnchor: horizontalStart,
      verticalAnchor: "middle"
    }, sizeAttrs);
  }
  if (position2 === "insideRight") {
    return _objectSpread14({
      x: x2 + width2 - horizontalOffset,
      y: y2 + height2 / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: "middle"
    }, sizeAttrs);
  }
  if (position2 === "insideTop") {
    return _objectSpread14({
      x: x2 + width2 / 2,
      y: y2 + verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position2 === "insideBottom") {
    return _objectSpread14({
      x: x2 + width2 / 2,
      y: y2 + height2 - verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position2 === "insideTopLeft") {
    return _objectSpread14({
      x: x2 + horizontalOffset,
      y: y2 + verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position2 === "insideTopRight") {
    return _objectSpread14({
      x: x2 + width2 - horizontalOffset,
      y: y2 + verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position2 === "insideBottomLeft") {
    return _objectSpread14({
      x: x2 + horizontalOffset,
      y: y2 + height2 - verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position2 === "insideBottomRight") {
    return _objectSpread14({
      x: x2 + width2 - horizontalOffset,
      y: y2 + height2 - verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if ((0, import_isObject3.default)(position2) && (isNumber(position2.x) || isPercent(position2.x)) && (isNumber(position2.y) || isPercent(position2.y))) {
    return _objectSpread14({
      x: x2 + getPercentValue(position2.x, width2),
      y: y2 + getPercentValue(position2.y, height2),
      textAnchor: "end",
      verticalAnchor: "end"
    }, sizeAttrs);
  }
  return _objectSpread14({
    x: x2 + width2 / 2,
    y: y2 + height2 / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, sizeAttrs);
};
var isPolar = function isPolar2(viewBox) {
  return "cx" in viewBox && isNumber(viewBox.cx);
};
function Label(_ref4) {
  var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties10(_ref4, _excluded10);
  var props = _objectSpread14({
    offset
  }, restProps);
  var viewBox = props.viewBox, position2 = props.position, value2 = props.value, children = props.children, content2 = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
  if (!viewBox || (0, import_isNil6.default)(value2) && (0, import_isNil6.default)(children) && !/* @__PURE__ */ isValidElement(content2) && !(0, import_isFunction6.default)(content2)) {
    return null;
  }
  if (/* @__PURE__ */ isValidElement(content2)) {
    return /* @__PURE__ */ cloneElement(content2, props);
  }
  var label;
  if ((0, import_isFunction6.default)(content2)) {
    label = /* @__PURE__ */ createElement(content2, props);
    if (/* @__PURE__ */ isValidElement(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }
  var isPolarLabel = isPolar(viewBox);
  var attrs = filterProps(props, true);
  if (isPolarLabel && (position2 === "insideStart" || position2 === "insideEnd" || position2 === "end")) {
    return renderRadialLabel(props, label, attrs);
  }
  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /* @__PURE__ */ React43.createElement(Text, _extends9({
    className: clsx_default("recharts-label", className)
  }, attrs, positionAttrs, {
    breakAll: textBreakAll
  }), label);
}
Label.displayName = "Label";
var parseViewBox = function parseViewBox2(props) {
  var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r2 = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x2 = props.x, y2 = props.y, top = props.top, left = props.left, width2 = props.width, height2 = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
  if (labelViewBox) {
    return labelViewBox;
  }
  if (isNumber(width2) && isNumber(height2)) {
    if (isNumber(x2) && isNumber(y2)) {
      return {
        x: x2,
        y: y2,
        width: width2,
        height: height2
      };
    }
    if (isNumber(top) && isNumber(left)) {
      return {
        x: top,
        y: left,
        width: width2,
        height: height2
      };
    }
  }
  if (isNumber(x2) && isNumber(y2)) {
    return {
      x: x2,
      y: y2,
      width: 0,
      height: 0
    };
  }
  if (isNumber(cx) && isNumber(cy)) {
    return {
      cx,
      cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r2 || 0,
      clockWise
    };
  }
  if (props.viewBox) {
    return props.viewBox;
  }
  return {};
};
var parseLabel = function parseLabel2(label, viewBox) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /* @__PURE__ */ React43.createElement(Label, {
      key: "label-implicit",
      viewBox
    });
  }
  if (isNumOrStr(label)) {
    return /* @__PURE__ */ React43.createElement(Label, {
      key: "label-implicit",
      viewBox,
      value: label
    });
  }
  if (/* @__PURE__ */ isValidElement(label)) {
    if (label.type === Label) {
      return /* @__PURE__ */ cloneElement(label, {
        key: "label-implicit",
        viewBox
      });
    }
    return /* @__PURE__ */ React43.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox
    });
  }
  if ((0, import_isFunction6.default)(label)) {
    return /* @__PURE__ */ React43.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox
    });
  }
  if ((0, import_isObject3.default)(label)) {
    return /* @__PURE__ */ React43.createElement(Label, _extends9({
      viewBox
    }, label, {
      key: "label-implicit"
    }));
  }
  return null;
};
var renderCallByParent = function renderCallByParent2(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChildren = findAllByType(children, Label).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      viewBox: viewBox || parentViewBox,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(index2)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray4(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/LabelList.js
var import_isNil7 = __toESM(require_isNil());
var import_isObject4 = __toESM(require_isObject());
var import_isFunction7 = __toESM(require_isFunction());
var import_last = __toESM(require_last());
function _typeof19(o) {
  "@babel/helpers - typeof";
  return _typeof19 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof19(o);
}
var _excluded11 = ["valueAccessor"];
var _excluded24 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function _toConsumableArray5(arr) {
  return _arrayWithoutHoles5(arr) || _iterableToArray5(arr) || _unsupportedIterableToArray12(arr) || _nonIterableSpread5();
}
function _nonIterableSpread5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray12(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray12(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray12(o, minLen);
}
function _iterableToArray5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray12(arr);
}
function _arrayLikeToArray12(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _extends10() {
  _extends10 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends10.apply(this, arguments);
}
function ownKeys15(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread15(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys15(Object(t), true).forEach(function(r3) {
      _defineProperty17(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys15(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty17(obj, key2, value2) {
  key2 = _toPropertyKey18(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey18(t) {
  var i = _toPrimitive18(t, "string");
  return "symbol" == _typeof19(i) ? i : i + "";
}
function _toPrimitive18(t, r2) {
  if ("object" != _typeof19(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof19(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _objectWithoutProperties11(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose11(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose11(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var defaultAccessor = function defaultAccessor2(entry) {
  return Array.isArray(entry.value) ? (0, import_last.default)(entry.value) : entry.value;
};
function LabelList(_ref) {
  var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties11(_ref, _excluded11);
  var data2 = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties11(restProps, _excluded24);
  if (!data2 || !data2.length) {
    return null;
  }
  return /* @__PURE__ */ React43.createElement(Layer, {
    className: "recharts-label-list"
  }, data2.map(function(entry, index2) {
    var value2 = (0, import_isNil7.default)(dataKey) ? valueAccessor(entry, index2) : getValueByDataKey(entry && entry.payload, dataKey);
    var idProps = (0, import_isNil7.default)(id) ? {} : {
      id: "".concat(id, "-").concat(index2)
    };
    return /* @__PURE__ */ React43.createElement(Label, _extends10({}, filterProps(entry, true), others, idProps, {
      parentViewBox: entry.parentViewBox,
      value: value2,
      textBreakAll,
      viewBox: Label.parseViewBox((0, import_isNil7.default)(clockWise) ? entry : _objectSpread15(_objectSpread15({}, entry), {}, {
        clockWise
      })),
      key: "label-".concat(index2),
      index: index2
    }));
  }));
}
LabelList.displayName = "LabelList";
function parseLabelList(label, data2) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /* @__PURE__ */ React43.createElement(LabelList, {
      key: "labelList-implicit",
      data: data2
    });
  }
  if (/* @__PURE__ */ React43.isValidElement(label) || (0, import_isFunction7.default)(label)) {
    return /* @__PURE__ */ React43.createElement(LabelList, {
      key: "labelList-implicit",
      data: data2,
      content: label
    });
  }
  if ((0, import_isObject4.default)(label)) {
    return /* @__PURE__ */ React43.createElement(LabelList, _extends10({
      data: data2
    }, label, {
      key: "labelList-implicit"
    }));
  }
  return null;
}
function renderCallByParent3(parentProps, data2) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var explicitChildren = findAllByType(children, LabelList).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      data: data2,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(index2)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabelList = parseLabelList(parentProps.label, data2);
  return [implicitLabelList].concat(_toConsumableArray5(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent3;
function _typeof20(o) {
  "@babel/helpers - typeof";
  return _typeof20 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof20(o);
}
function _extends11() {
  _extends11 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends11.apply(this, arguments);
}
function ownKeys16(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread16(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys16(Object(t), true).forEach(function(r3) {
      _defineProperty18(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys16(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty18(obj, key2, value2) {
  key2 = _toPropertyKey19(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey19(t) {
  var i = _toPrimitive19(t, "string");
  return "symbol" == _typeof20(i) ? i : i + "";
}
function _toPrimitive19(t, r2) {
  if ("object" != _typeof20(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof20(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getDeltaAngle3 = function getDeltaAngle4(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign2 * deltaAngle;
};
var getTangentCircle = function getTangentCircle2(_ref) {
  var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign2 = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / RADIAN2;
  var centerAngle = cornerIsExternal ? angle : angle + sign2 * theta;
  var center = polarToCartesian(cx, cy, centerRadius, centerAngle);
  var circleTangency = polarToCartesian(cx, cy, radius, centerAngle);
  var lineTangencyAngle = cornerIsExternal ? angle - sign2 * theta : angle;
  var lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN2), lineTangencyAngle);
  return {
    center,
    circleTangency,
    lineTangency,
    theta
  };
};
var getSectorPath = function getSectorPath2(_ref2) {
  var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
  var angle = getDeltaAngle3(startAngle, endAngle);
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle);
  var outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle);
  var path2 = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle);
    var innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path2 += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path2 += "L ".concat(cx, ",").concat(cy, " Z");
  }
  return path2;
};
var getSectorWithCorner = function getSectorWithCorner2(_ref3) {
  var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
  var sign2 = mathSign(endAngle - startAngle);
  var _getTangentCircle = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign2,
    cornerRadius,
    cornerIsExternal
  }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
  var _getTangentCircle2 = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign2,
    cornerRadius,
    cornerIsExternal
  }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
  var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }
    return getSectorPath({
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
  }
  var path2 = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign2 < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign2,
      isExternal: true,
      cornerRadius,
      cornerIsExternal
    }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
    var _getTangentCircle4 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign2,
      isExternal: true,
      cornerRadius,
      cornerIsExternal
    }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
    var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
    if (innerArcAngle < 0 && cornerRadius === 0) {
      return "".concat(path2, "L").concat(cx, ",").concat(cy, "Z");
    }
    path2 += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign2 > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path2 += "L".concat(cx, ",").concat(cy, "Z");
  }
  return path2;
};
var defaultProps17 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};
var Sector = function Sector2(sectorProps) {
  var props = _objectSpread16(_objectSpread16({}, defaultProps17), sectorProps);
  var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
  if (outerRadius < innerRadius || startAngle === endAngle) {
    return null;
  }
  var layerClass = clsx_default("recharts-sector", className);
  var deltaRadius = outerRadius - innerRadius;
  var cr = getPercentValue(cornerRadius, deltaRadius, 0, true);
  var path2;
  if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
    path2 = getSectorWithCorner({
      cx,
      cy,
      innerRadius,
      outerRadius,
      cornerRadius: Math.min(cr, deltaRadius / 2),
      forceCornerRadius,
      cornerIsExternal,
      startAngle,
      endAngle
    });
  } else {
    path2 = getSectorPath({
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
  }
  return /* @__PURE__ */ React43.createElement("path", _extends11({}, filterProps(props, true), {
    className: layerClass,
    d: path2,
    role: "img"
  }));
};
var import_upperFirst3 = __toESM(require_upperFirst());
var import_isFunction8 = __toESM(require_isFunction());
function _typeof21(o) {
  "@babel/helpers - typeof";
  return _typeof21 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof21(o);
}
function _extends12() {
  _extends12 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends12.apply(this, arguments);
}
function ownKeys17(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread17(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys17(Object(t), true).forEach(function(r3) {
      _defineProperty19(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys17(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty19(obj, key2, value2) {
  key2 = _toPropertyKey20(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey20(t) {
  var i = _toPrimitive20(t, "string");
  return "symbol" == _typeof21(i) ? i : i + "";
}
function _toPrimitive20(t, r2) {
  if ("object" != _typeof21(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof21(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var CURVE_FACTORIES = {
  curveBasisClosed: basisClosed_default,
  curveBasisOpen: basisOpen_default,
  curveBasis: basis_default,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveLinearClosed: linearClosed_default,
  curveLinear: linear_default,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: natural_default,
  curveStep: step_default,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
};
var defined = function defined2(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX2(p) {
  return p.x;
};
var getY = function getY2(p) {
  return p.y;
};
var getCurveFactory = function getCurveFactory2(type, layout) {
  if ((0, import_isFunction8.default)(type)) {
    return type;
  }
  var name2 = "curve".concat((0, import_upperFirst3.default)(type));
  if ((name2 === "curveMonotone" || name2 === "curveBump") && layout) {
    return CURVE_FACTORIES["".concat(name2).concat(layout === "vertical" ? "Y" : "X")];
  }
  return CURVE_FACTORIES[name2] || linear_default;
};
var getPath = function getPath2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
  var curveFactory = getCurveFactory(type, layout);
  var formatPoints = connectNulls ? points.filter(function(entry) {
    return defined(entry);
  }) : points;
  var lineFunction;
  if (Array.isArray(baseLine)) {
    var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
      return defined(base);
    }) : baseLine;
    var areaPoints = formatPoints.map(function(entry, index2) {
      return _objectSpread17(_objectSpread17({}, entry), {}, {
        base: formatBaseLine[index2]
      });
    });
    if (layout === "vertical") {
      lineFunction = area_default().y(getY).x1(getX).x0(function(d) {
        return d.base.x;
      });
    } else {
      lineFunction = area_default().x(getX).y1(getY).y0(function(d) {
        return d.base.y;
      });
    }
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(areaPoints);
  }
  if (layout === "vertical" && isNumber(baseLine)) {
    lineFunction = area_default().y(getY).x1(getX).x0(baseLine);
  } else if (isNumber(baseLine)) {
    lineFunction = area_default().x(getX).y1(getY).y0(baseLine);
  } else {
    lineFunction = line_default().x(getX).y(getY);
  }
  lineFunction.defined(defined).curve(curveFactory);
  return lineFunction(formatPoints);
};
var Curve = function Curve2(props) {
  var className = props.className, points = props.points, path2 = props.path, pathRef = props.pathRef;
  if ((!points || !points.length) && !path2) {
    return null;
  }
  var realPath = points && points.length ? getPath(props) : path2;
  return /* @__PURE__ */ React43.createElement("path", _extends12({}, filterProps(props, false), adaptEventHandlers(props), {
    className: clsx_default("recharts-curve", className),
    d: realPath,
    ref: pathRef
  }));
};

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/Animate.js
var import_prop_types = __toESM(require_prop_types());

// node_modules/.pnpm/fast-equals@5.2.2/node_modules/fast-equals/dist/esm/index.mjs
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function combineComparators(comparatorA, comparatorB) {
  return function isEqual7(a2, b, state) {
    return comparatorA(a2, b, state) && comparatorB(a2, b, state);
  };
}
function createIsCircular(areItemsEqual) {
  return function isCircular(a2, b, state) {
    if (!a2 || !b || typeof a2 !== "object" || typeof b !== "object") {
      return areItemsEqual(a2, b, state);
    }
    var cache = state.cache;
    var cachedA = cache.get(a2);
    var cachedB = cache.get(b);
    if (cachedA && cachedB) {
      return cachedA === b && cachedB === a2;
    }
    cache.set(a2, b);
    cache.set(b, a2);
    var result = areItemsEqual(a2, b, state);
    cache.delete(a2);
    cache.delete(b);
    return result;
  };
}
function getStrictProperties(object) {
  return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
}
var hasOwn = Object.hasOwn || function(object, property2) {
  return hasOwnProperty.call(object, property2);
};
function sameValueZeroEqual(a2, b) {
  return a2 === b || !a2 && !b && a2 !== a2 && b !== b;
}
var PREACT_VNODE = "__v";
var PREACT_OWNER = "__o";
var REACT_OWNER = "_owner";
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var keys = Object.keys;
function areArraysEqual(a2, b, state) {
  var index2 = a2.length;
  if (b.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!state.equals(a2[index2], b[index2], index2, index2, a2, b, state)) {
      return false;
    }
  }
  return true;
}
function areDatesEqual(a2, b) {
  return sameValueZeroEqual(a2.getTime(), b.getTime());
}
function areErrorsEqual(a2, b) {
  return a2.name === b.name && a2.message === b.message && a2.cause === b.cause && a2.stack === b.stack;
}
function areFunctionsEqual(a2, b) {
  return a2 === b;
}
function areMapsEqual(a2, b, state) {
  var size = a2.size;
  if (size !== b.size) {
    return false;
  }
  if (!size) {
    return true;
  }
  var matchedIndices = new Array(size);
  var aIterable = a2.entries();
  var aResult;
  var bResult;
  var index2 = 0;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    var bIterable = b.entries();
    var hasMatch = false;
    var matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (matchedIndices[matchIndex]) {
        matchIndex++;
        continue;
      }
      var aEntry = aResult.value;
      var bEntry = bResult.value;
      if (state.equals(aEntry[0], bEntry[0], index2, matchIndex, a2, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a2, b, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
    index2++;
  }
  return true;
}
var areNumbersEqual = sameValueZeroEqual;
function areObjectsEqual(a2, b, state) {
  var properties = keys(a2);
  var index2 = properties.length;
  if (keys(b).length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!isPropertyEqual(a2, b, state, properties[index2])) {
      return false;
    }
  }
  return true;
}
function areObjectsEqualStrict(a2, b, state) {
  var properties = getStrictProperties(a2);
  var index2 = properties.length;
  if (getStrictProperties(b).length !== index2) {
    return false;
  }
  var property2;
  var descriptorA;
  var descriptorB;
  while (index2-- > 0) {
    property2 = properties[index2];
    if (!isPropertyEqual(a2, b, state, property2)) {
      return false;
    }
    descriptorA = getOwnPropertyDescriptor(a2, property2);
    descriptorB = getOwnPropertyDescriptor(b, property2);
    if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) {
      return false;
    }
  }
  return true;
}
function arePrimitiveWrappersEqual(a2, b) {
  return sameValueZeroEqual(a2.valueOf(), b.valueOf());
}
function areRegExpsEqual(a2, b) {
  return a2.source === b.source && a2.flags === b.flags;
}
function areSetsEqual(a2, b, state) {
  var size = a2.size;
  if (size !== b.size) {
    return false;
  }
  if (!size) {
    return true;
  }
  var matchedIndices = new Array(size);
  var aIterable = a2.values();
  var aResult;
  var bResult;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    var bIterable = b.values();
    var hasMatch = false;
    var matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a2, b, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
  }
  return true;
}
function areTypedArraysEqual(a2, b) {
  var index2 = a2.length;
  if (b.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (a2[index2] !== b[index2]) {
      return false;
    }
  }
  return true;
}
function areUrlsEqual(a2, b) {
  return a2.hostname === b.hostname && a2.pathname === b.pathname && a2.protocol === b.protocol && a2.port === b.port && a2.hash === b.hash && a2.username === b.username && a2.password === b.password;
}
function isPropertyEqual(a2, b, state, property2) {
  if ((property2 === REACT_OWNER || property2 === PREACT_OWNER || property2 === PREACT_VNODE) && (a2.$$typeof || b.$$typeof)) {
    return true;
  }
  return hasOwn(b, property2) && state.equals(a2[property2], b[property2], property2, property2, a2, b, state);
}
var ARGUMENTS_TAG = "[object Arguments]";
var BOOLEAN_TAG = "[object Boolean]";
var DATE_TAG = "[object Date]";
var ERROR_TAG = "[object Error]";
var MAP_TAG = "[object Map]";
var NUMBER_TAG = "[object Number]";
var OBJECT_TAG = "[object Object]";
var REG_EXP_TAG = "[object RegExp]";
var SET_TAG = "[object Set]";
var STRING_TAG = "[object String]";
var URL_TAG = "[object URL]";
var isArray = Array.isArray;
var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
var assign = Object.assign;
var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
function createEqualityComparator(_a) {
  var areArraysEqual2 = _a.areArraysEqual, areDatesEqual2 = _a.areDatesEqual, areErrorsEqual2 = _a.areErrorsEqual, areFunctionsEqual2 = _a.areFunctionsEqual, areMapsEqual2 = _a.areMapsEqual, areNumbersEqual2 = _a.areNumbersEqual, areObjectsEqual2 = _a.areObjectsEqual, arePrimitiveWrappersEqual2 = _a.arePrimitiveWrappersEqual, areRegExpsEqual2 = _a.areRegExpsEqual, areSetsEqual2 = _a.areSetsEqual, areTypedArraysEqual2 = _a.areTypedArraysEqual, areUrlsEqual2 = _a.areUrlsEqual;
  return function comparator(a2, b, state) {
    if (a2 === b) {
      return true;
    }
    if (a2 == null || b == null) {
      return false;
    }
    var type = typeof a2;
    if (type !== typeof b) {
      return false;
    }
    if (type !== "object") {
      if (type === "number") {
        return areNumbersEqual2(a2, b, state);
      }
      if (type === "function") {
        return areFunctionsEqual2(a2, b, state);
      }
      return false;
    }
    var constructor = a2.constructor;
    if (constructor !== b.constructor) {
      return false;
    }
    if (constructor === Object) {
      return areObjectsEqual2(a2, b, state);
    }
    if (isArray(a2)) {
      return areArraysEqual2(a2, b, state);
    }
    if (isTypedArray != null && isTypedArray(a2)) {
      return areTypedArraysEqual2(a2, b, state);
    }
    if (constructor === Date) {
      return areDatesEqual2(a2, b, state);
    }
    if (constructor === RegExp) {
      return areRegExpsEqual2(a2, b, state);
    }
    if (constructor === Map) {
      return areMapsEqual2(a2, b, state);
    }
    if (constructor === Set) {
      return areSetsEqual2(a2, b, state);
    }
    var tag = getTag(a2);
    if (tag === DATE_TAG) {
      return areDatesEqual2(a2, b, state);
    }
    if (tag === REG_EXP_TAG) {
      return areRegExpsEqual2(a2, b, state);
    }
    if (tag === MAP_TAG) {
      return areMapsEqual2(a2, b, state);
    }
    if (tag === SET_TAG) {
      return areSetsEqual2(a2, b, state);
    }
    if (tag === OBJECT_TAG) {
      return typeof a2.then !== "function" && typeof b.then !== "function" && areObjectsEqual2(a2, b, state);
    }
    if (tag === URL_TAG) {
      return areUrlsEqual2(a2, b, state);
    }
    if (tag === ERROR_TAG) {
      return areErrorsEqual2(a2, b, state);
    }
    if (tag === ARGUMENTS_TAG) {
      return areObjectsEqual2(a2, b, state);
    }
    if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) {
      return arePrimitiveWrappersEqual2(a2, b, state);
    }
    return false;
  };
}
function createEqualityComparatorConfig(_a) {
  var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
  var config2 = {
    areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
    areDatesEqual,
    areErrorsEqual,
    areFunctionsEqual,
    areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
    areNumbersEqual,
    areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
    arePrimitiveWrappersEqual,
    areRegExpsEqual,
    areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
    areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
    areUrlsEqual
  };
  if (createCustomConfig) {
    config2 = assign({}, config2, createCustomConfig(config2));
  }
  if (circular) {
    var areArraysEqual$1 = createIsCircular(config2.areArraysEqual);
    var areMapsEqual$1 = createIsCircular(config2.areMapsEqual);
    var areObjectsEqual$1 = createIsCircular(config2.areObjectsEqual);
    var areSetsEqual$1 = createIsCircular(config2.areSetsEqual);
    config2 = assign({}, config2, {
      areArraysEqual: areArraysEqual$1,
      areMapsEqual: areMapsEqual$1,
      areObjectsEqual: areObjectsEqual$1,
      areSetsEqual: areSetsEqual$1
    });
  }
  return config2;
}
function createInternalEqualityComparator(compare) {
  return function(a2, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
    return compare(a2, b, state);
  };
}
function createIsEqual(_a) {
  var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
  if (createState) {
    return function isEqual7(a2, b) {
      var _a2 = createState(), _b = _a2.cache, cache = _b === void 0 ? circular ? /* @__PURE__ */ new WeakMap() : void 0 : _b, meta = _a2.meta;
      return comparator(a2, b, {
        cache,
        equals,
        meta,
        strict
      });
    };
  }
  if (circular) {
    return function isEqual7(a2, b) {
      return comparator(a2, b, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals,
        meta: void 0,
        strict
      });
    };
  }
  var state = {
    cache: void 0,
    equals,
    meta: void 0,
    strict
  };
  return function isEqual7(a2, b) {
    return comparator(a2, b, state);
  };
}
var deepEqual = createCustomEqual();
createCustomEqual({ strict: true });
createCustomEqual({ circular: true });
createCustomEqual({
  circular: true,
  strict: true
});
createCustomEqual({
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  strict: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  },
  strict: true
});
function createCustomEqual(options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
  var config2 = createEqualityComparatorConfig(options);
  var comparator = createEqualityComparator(config2);
  var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
  return createIsEqual({ circular, comparator, createState, equals, strict });
}

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/setRafTimeout.js
function safeRequestAnimationFrame(callback) {
  if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var currTime = -1;
  var shouldUpdate = function shouldUpdate2(now) {
    if (currTime < 0) {
      currTime = now;
    }
    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      safeRequestAnimationFrame(shouldUpdate2);
    }
  };
  requestAnimationFrame(shouldUpdate);
}

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/AnimateManager.js
function _typeof22(o) {
  "@babel/helpers - typeof";
  return _typeof22 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof22(o);
}
function _toArray(arr) {
  return _arrayWithHoles9(arr) || _iterableToArray6(arr) || _unsupportedIterableToArray13(arr) || _nonIterableRest9();
}
function _nonIterableRest9() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray13(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray13(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray13(o, minLen);
}
function _arrayLikeToArray13(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArray6(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles9(arr) {
  if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange2() {
    return null;
  };
  var shouldStop = false;
  var setStyle = function setStyle2(_style) {
    if (shouldStop) {
      return;
    }
    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }
      var styles = _style;
      var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
      if (typeof curr === "number") {
        setRafTimeout(setStyle2.bind(null, restStyles), curr);
        return;
      }
      setStyle2(curr);
      setRafTimeout(setStyle2.bind(null, restStyles));
      return;
    }
    if (_typeof22(_style) === "object") {
      currStyle = _style;
      handleChange(currStyle);
    }
    if (typeof _style === "function") {
      _style();
    }
  };
  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function() {
        handleChange = function handleChange2() {
          return null;
        };
      };
    }
  };
}

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/util.js
function _typeof23(o) {
  "@babel/helpers - typeof";
  return _typeof23 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof23(o);
}
function ownKeys18(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread18(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys18(Object(t), true).forEach(function(r3) {
      _defineProperty20(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys18(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty20(obj, key2, value2) {
  key2 = _toPropertyKey21(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey21(arg) {
  var key2 = _toPrimitive21(arg, "string");
  return _typeof23(key2) === "symbol" ? key2 : String(key2);
}
function _toPrimitive21(input, hint) {
  if (_typeof23(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof23(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var getIntersectionKeys = function getIntersectionKeys2(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function(a2, b) {
    return a2.filter(function(c2) {
      return b.includes(c2);
    });
  });
};
var identity5 = function identity6(param) {
  return param;
};
var getDashCase = function getDashCase2(name2) {
  return name2.replace(/([A-Z])/g, function(v) {
    return "-".concat(v.toLowerCase());
  });
};
var mapObject = function mapObject2(fn, obj) {
  return Object.keys(obj).reduce(function(res, key2) {
    return _objectSpread18(_objectSpread18({}, res), {}, _defineProperty20({}, key2, fn(key2, obj[key2])));
  }, {});
};
var getTransitionVal = function getTransitionVal2(props, duration, easing) {
  return props.map(function(prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(",");
};
var isDev2 = process.env.NODE_ENV !== "production";
var warn3 = function warn4(condition, format2, a2, b, c2, d, e, f) {
  if (isDev2 && typeof console !== "undefined" && console.warn) {
    if (format2 === void 0) {
      console.warn("LogUtils requires an error message argument");
    }
    if (!condition) {
      if (format2 === void 0) {
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        var args = [a2, b, c2, d, e, f];
        var argIndex = 0;
        console.warn(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
      }
    }
  }
};

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/easing.js
function _slicedToArray9(arr, i) {
  return _arrayWithHoles10(arr) || _iterableToArrayLimit9(arr, i) || _unsupportedIterableToArray14(arr, i) || _nonIterableRest10();
}
function _nonIterableRest10() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit9(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles10(arr) {
  if (Array.isArray(arr)) return arr;
}
function _toConsumableArray6(arr) {
  return _arrayWithoutHoles6(arr) || _iterableToArray7(arr) || _unsupportedIterableToArray14(arr) || _nonIterableSpread6();
}
function _nonIterableSpread6() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray14(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray14(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray14(o, minLen);
}
function _iterableToArray7(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles6(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray14(arr);
}
function _arrayLikeToArray14(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor2(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};
var multyTime = function multyTime2(params, t) {
  return params.map(function(param, i) {
    return param * Math.pow(t, i);
  }).reduce(function(pre, curr) {
    return pre + curr;
  });
};
var cubicBezier = function cubicBezier2(c1, c2) {
  return function(t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};
var derivativeCubicBezier = function derivativeCubicBezier2(c1, c2) {
  return function(t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(_toConsumableArray6(params.map(function(param, i) {
      return param * i;
    }).slice(1)), [0]);
    return multyTime(newParams, t);
  };
};
var configBezier = function configBezier2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
  if (args.length === 1) {
    switch (args[0]) {
      case "linear":
        x1 = 0;
        y1 = 0;
        x2 = 1;
        y2 = 1;
        break;
      case "ease":
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1;
        break;
      case "ease-in":
        x1 = 0.42;
        y1 = 0;
        x2 = 1;
        y2 = 1;
        break;
      case "ease-out":
        x1 = 0.42;
        y1 = 0;
        x2 = 0.58;
        y2 = 1;
        break;
      case "ease-in-out":
        x1 = 0;
        y1 = 0;
        x2 = 0.58;
        y2 = 1;
        break;
      default: {
        var easing = args[0].split("(");
        if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
          var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x3) {
            return parseFloat(x3);
          });
          var _easing$1$split$0$spl2 = _slicedToArray9(_easing$1$split$0$spl, 4);
          x1 = _easing$1$split$0$spl2[0];
          y1 = _easing$1$split$0$spl2[1];
          x2 = _easing$1$split$0$spl2[2];
          y2 = _easing$1$split$0$spl2[3];
        } else {
          warn3(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
        }
      }
    }
  }
  warn3([x1, x2, y1, y2].every(function(num) {
    return typeof num === "number" && num >= 0 && num <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue2(value2) {
    if (value2 > 1) {
      return 1;
    }
    if (value2 < 0) {
      return 0;
    }
    return value2;
  };
  var bezier = function bezier2(_t) {
    var t = _t > 1 ? 1 : _t;
    var x3 = t;
    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x3) - t;
      var derVal = derCurveX(x3);
      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x3);
      }
      x3 = rangeValue(x3 - evalT / derVal);
    }
    return curveY(x3);
  };
  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring2() {
  var config2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _config$stiff = config2.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config2.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config2.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
  var stepper = function stepper2(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1e3;
    var newX = currV * dt / 1e3 + currX;
    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };
  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing2() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var easing = args[0];
  if (typeof easing === "string") {
    switch (easing) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return configBezier(easing);
      case "spring":
        return configSpring();
      default:
        if (easing.split("(")[0] === "cubic-bezier") {
          return configBezier(easing);
        }
        warn3(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
  }
  if (typeof easing === "function") {
    return easing;
  }
  warn3(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
  return null;
};

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/configUpdate.js
function _typeof24(o) {
  "@babel/helpers - typeof";
  return _typeof24 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof24(o);
}
function _toConsumableArray7(arr) {
  return _arrayWithoutHoles7(arr) || _iterableToArray8(arr) || _unsupportedIterableToArray15(arr) || _nonIterableSpread7();
}
function _nonIterableSpread7() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray8(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles7(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray15(arr);
}
function ownKeys19(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread19(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys19(Object(t), true).forEach(function(r3) {
      _defineProperty21(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys19(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty21(obj, key2, value2) {
  key2 = _toPropertyKey22(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey22(arg) {
  var key2 = _toPrimitive22(arg, "string");
  return _typeof24(key2) === "symbol" ? key2 : String(key2);
}
function _toPrimitive22(input, hint) {
  if (_typeof24(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof24(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray10(arr, i) {
  return _arrayWithHoles11(arr) || _iterableToArrayLimit10(arr, i) || _unsupportedIterableToArray15(arr, i) || _nonIterableRest11();
}
function _nonIterableRest11() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray15(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray15(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray15(o, minLen);
}
function _arrayLikeToArray15(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit10(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles11(arr) {
  if (Array.isArray(arr)) return arr;
}
var alpha = function alpha2(begin, end, k2) {
  return begin + (end - begin) * k2;
};
var needContinue = function needContinue2(_ref) {
  var from = _ref.from, to = _ref.to;
  return from !== to;
};
var calStepperVals = function calStepperVals2(easing, preVals, steps) {
  var nextStepVals = mapObject(function(key2, val2) {
    if (needContinue(val2)) {
      var _easing = easing(val2.from, val2.to, val2.velocity), _easing2 = _slicedToArray10(_easing, 2), newX = _easing2[0], newV = _easing2[1];
      return _objectSpread19(_objectSpread19({}, val2), {}, {
        from: newX,
        velocity: newV
      });
    }
    return val2;
  }, preVals);
  if (steps < 1) {
    return mapObject(function(key2, val2) {
      if (needContinue(val2)) {
        return _objectSpread19(_objectSpread19({}, val2), {}, {
          velocity: alpha(val2.velocity, nextStepVals[key2].velocity, steps),
          from: alpha(val2.from, nextStepVals[key2].from, steps)
        });
      }
      return val2;
    }, preVals);
  }
  return calStepperVals2(easing, nextStepVals, steps - 1);
};
var configUpdate_default = function(from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to);
  var timingStyle = interKeys.reduce(function(res, key2) {
    return _objectSpread19(_objectSpread19({}, res), {}, _defineProperty21({}, key2, [from[key2], to[key2]]));
  }, {});
  var stepperStyle = interKeys.reduce(function(res, key2) {
    return _objectSpread19(_objectSpread19({}, res), {}, _defineProperty21({}, key2, {
      from: from[key2],
      velocity: 0,
      to: to[key2]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;
  var update = function update2() {
    return null;
  };
  var getCurrStyle = function getCurrStyle2() {
    return mapObject(function(key2, val2) {
      return val2.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation2() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  };
  var stepperUpdate = function stepperUpdate2(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    render(_objectSpread19(_objectSpread19(_objectSpread19({}, from), to), getCurrStyle()));
    preTime = now;
    if (!shouldStopAnimation()) {
      cafId = requestAnimationFrame(update);
    }
  };
  var timingUpdate = function timingUpdate2(now) {
    if (!beginTime) {
      beginTime = now;
    }
    var t = (now - beginTime) / duration;
    var currStyle = mapObject(function(key2, val2) {
      return alpha.apply(void 0, _toConsumableArray7(val2).concat([easing(t)]));
    }, timingStyle);
    render(_objectSpread19(_objectSpread19(_objectSpread19({}, from), to), currStyle));
    if (t < 1) {
      cafId = requestAnimationFrame(update);
    } else {
      var finalStyle = mapObject(function(key2, val2) {
        return alpha.apply(void 0, _toConsumableArray7(val2).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread19(_objectSpread19(_objectSpread19({}, from), to), finalStyle));
    }
  };
  update = easing.isStepper ? stepperUpdate : timingUpdate;
  return function() {
    requestAnimationFrame(update);
    return function() {
      cancelAnimationFrame(cafId);
    };
  };
};

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/Animate.js
function _typeof25(o) {
  "@babel/helpers - typeof";
  return _typeof25 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof25(o);
}
var _excluded12 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function _objectWithoutProperties12(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose12(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose12(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _toConsumableArray8(arr) {
  return _arrayWithoutHoles8(arr) || _iterableToArray9(arr) || _unsupportedIterableToArray16(arr) || _nonIterableSpread8();
}
function _nonIterableSpread8() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray16(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray16(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray16(o, minLen);
}
function _iterableToArray9(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles8(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray16(arr);
}
function _arrayLikeToArray16(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys20(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread20(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys20(Object(t), true).forEach(function(r3) {
      _defineProperty22(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys20(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty22(obj, key2, value2) {
  key2 = _toPropertyKey23(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _classCallCheck7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey23(descriptor.key), descriptor);
  }
}
function _createClass7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties7(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey23(arg) {
  var key2 = _toPrimitive23(arg, "string");
  return _typeof25(key2) === "symbol" ? key2 : String(key2);
}
function _toPrimitive23(input, hint) {
  if (_typeof25(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof25(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf6(subClass, superClass);
}
function _setPrototypeOf6(o, p) {
  _setPrototypeOf6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf6(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf6(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf6(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn6(this, result);
  };
}
function _possibleConstructorReturn6(self2, call) {
  if (call && (_typeof25(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized6(self2);
}
function _assertThisInitialized6(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct6() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf6(o) {
  _getPrototypeOf6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf6(o);
}
var Animate = /* @__PURE__ */ function(_PureComponent) {
  _inherits6(Animate2, _PureComponent);
  var _super = _createSuper(Animate2);
  function Animate2(props, context) {
    var _this;
    _classCallCheck7(this, Animate2);
    _this = _super.call(this, props, context);
    var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized6(_this));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized6(_this));
    if (!isActive || duration <= 0) {
      _this.state = {
        style: {}
      };
      if (typeof children === "function") {
        _this.state = {
          style: to
        };
      }
      return _possibleConstructorReturn6(_this);
    }
    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style
      };
    } else if (from) {
      if (typeof children === "function") {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn6(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty22({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }
    return _this;
  }
  _createClass7(Animate2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
      this.mounted = true;
      if (!isActive || !canBegin) {
        return;
      }
      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
      var style = this.state.style;
      if (!canBegin) {
        return;
      }
      if (!isActive) {
        var newState = {
          style: attributeName ? _defineProperty22({}, attributeName, to) : to
        };
        if (this.state && style) {
          if (attributeName && style[attributeName] !== to || !attributeName && style !== to) {
            this.setState(newState);
          }
        }
        return;
      }
      if (deepEqual(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }
      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
      if (this.manager) {
        this.manager.stop();
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
      if (this.state && style) {
        var _newState = {
          style: attributeName ? _defineProperty22({}, attributeName, from) : from
        };
        if (attributeName && style[attributeName] !== from || !attributeName && style !== from) {
          this.setState(_newState);
        }
      }
      this.runAnimation(_objectSpread20(_objectSpread20({}, this.props), {}, {
        from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      var onAnimationEnd2 = this.props.onAnimationEnd;
      if (this.unSubscribe) {
        this.unSubscribe();
      }
      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      if (onAnimationEnd2) {
        onAnimationEnd2();
      }
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style
        });
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;
      var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd2 = props.onAnimationEnd, onAnimationStart2 = props.onAnimationStart;
      var startAnimation = configUpdate_default(from, to, configEasing(easing), duration, this.changeStyle);
      var finalStartAnimation = function finalStartAnimation2() {
        _this2.stopJSAnimation = startAnimation();
      };
      this.manager.start([onAnimationStart2, begin, finalStartAnimation, duration, onAnimationEnd2]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;
      var steps = props.steps, begin = props.begin, onAnimationStart2 = props.onAnimationStart;
      var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
      var addStyle = function addStyle2(sequence, nextItem, index2) {
        if (index2 === 0) {
          return sequence;
        }
        var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd2 = nextItem.onAnimationEnd;
        var preItem = index2 > 0 ? steps[index2 - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);
        if (typeof easing === "function" || easing === "spring") {
          return [].concat(_toConsumableArray8(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration,
            easing
          }), duration]);
        }
        var transition = getTransitionVal(properties, duration, easing);
        var newStyle = _objectSpread20(_objectSpread20(_objectSpread20({}, preItem.style), style), {}, {
          transition
        });
        return [].concat(_toConsumableArray8(sequence), [newStyle, duration, onAnimationEnd2]).filter(identity5);
      };
      return this.manager.start([onAnimationStart2].concat(_toConsumableArray8(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = createAnimateManager();
      }
      var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart2 = props.onAnimationStart, onAnimationEnd2 = props.onAnimationEnd, steps = props.steps, children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);
      if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
        this.runJSAnimation(props);
        return;
      }
      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }
      var to = attributeName ? _defineProperty22({}, attributeName, propsTo) : propsTo;
      var transition = getTransitionVal(Object.keys(to), duration, easing);
      manager.start([onAnimationStart2, begin, _objectSpread20(_objectSpread20({}, to), {}, {
        transition
      }), duration, onAnimationEnd2]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, children = _this$props4.children; _this$props4.begin; var duration = _this$props4.duration; _this$props4.attributeName; _this$props4.easing; var isActive = _this$props4.isActive; _this$props4.steps; _this$props4.from; _this$props4.to; _this$props4.canBegin; _this$props4.onAnimationEnd; _this$props4.shouldReAnimate; _this$props4.onAnimationReStart; var others = _objectWithoutProperties12(_this$props4, _excluded12);
      var count = Children.count(children);
      var stateStyle = this.state.style;
      if (typeof children === "function") {
        return children(stateStyle);
      }
      if (!isActive || count === 0 || duration <= 0) {
        return children;
      }
      var cloneContainer = function cloneContainer2(container) {
        var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
        var res = /* @__PURE__ */ cloneElement(container, _objectSpread20(_objectSpread20({}, others), {}, {
          style: _objectSpread20(_objectSpread20({}, style), stateStyle),
          className
        }));
        return res;
      };
      if (count === 1) {
        return cloneContainer(Children.only(children));
      }
      return /* @__PURE__ */ React43.createElement("div", null, Children.map(children, function(child) {
        return cloneContainer(child);
      }));
    }
  }]);
  return Animate2;
}(PureComponent);
Animate.displayName = "Animate";
Animate.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {
  },
  onAnimationStart: function onAnimationStart() {
  }
};
Animate.propTypes = {
  from: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.string]),
  to: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.string]),
  attributeName: import_prop_types.default.string,
  // animation duration
  duration: import_prop_types.default.number,
  begin: import_prop_types.default.number,
  easing: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.func]),
  steps: import_prop_types.default.arrayOf(import_prop_types.default.shape({
    duration: import_prop_types.default.number.isRequired,
    style: import_prop_types.default.object.isRequired,
    easing: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), import_prop_types.default.func]),
    // transition css properties(dash case), optional
    properties: import_prop_types.default.arrayOf("string"),
    onAnimationEnd: import_prop_types.default.func
  })),
  children: import_prop_types.default.oneOfType([import_prop_types.default.node, import_prop_types.default.func]),
  isActive: import_prop_types.default.bool,
  canBegin: import_prop_types.default.bool,
  onAnimationEnd: import_prop_types.default.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: import_prop_types.default.bool,
  onAnimationStart: import_prop_types.default.func,
  onAnimationReStart: import_prop_types.default.func
};
var Animate_default = Animate;

// node_modules/.pnpm/react-smooth@4.0.4_react-dom@19.0.0_react@19.0.0/node_modules/react-smooth/es6/index.js
var es6_default = Animate_default;

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/shape/Rectangle.js
function _typeof26(o) {
  "@babel/helpers - typeof";
  return _typeof26 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof26(o);
}
function _extends13() {
  _extends13 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends13.apply(this, arguments);
}
function _slicedToArray11(arr, i) {
  return _arrayWithHoles12(arr) || _iterableToArrayLimit11(arr, i) || _unsupportedIterableToArray17(arr, i) || _nonIterableRest12();
}
function _nonIterableRest12() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray17(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray17(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray17(o, minLen);
}
function _arrayLikeToArray17(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit11(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles12(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys21(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread21(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys21(Object(t), true).forEach(function(r3) {
      _defineProperty23(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys21(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty23(obj, key2, value2) {
  key2 = _toPropertyKey24(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey24(t) {
  var i = _toPrimitive24(t, "string");
  return "symbol" == _typeof26(i) ? i : i + "";
}
function _toPrimitive24(t, r2) {
  if ("object" != _typeof26(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof26(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getRectanglePath = function getRectanglePath2(x2, y2, width2, height2, radius) {
  var maxRadius = Math.min(Math.abs(width2) / 2, Math.abs(height2) / 2);
  var ySign = height2 >= 0 ? 1 : -1;
  var xSign = width2 >= 0 ? 1 : -1;
  var clockWise = height2 >= 0 && width2 >= 0 || height2 < 0 && width2 < 0 ? 1 : 0;
  var path2;
  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [0, 0, 0, 0];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }
    path2 = "M".concat(x2, ",").concat(y2 + ySign * newRadius[0]);
    if (newRadius[0] > 0) {
      path2 += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x2 + xSign * newRadius[0], ",").concat(y2);
    }
    path2 += "L ".concat(x2 + width2 - xSign * newRadius[1], ",").concat(y2);
    if (newRadius[1] > 0) {
      path2 += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x2 + width2, ",").concat(y2 + ySign * newRadius[1]);
    }
    path2 += "L ".concat(x2 + width2, ",").concat(y2 + height2 - ySign * newRadius[2]);
    if (newRadius[2] > 0) {
      path2 += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x2 + width2 - xSign * newRadius[2], ",").concat(y2 + height2);
    }
    path2 += "L ".concat(x2 + xSign * newRadius[3], ",").concat(y2 + height2);
    if (newRadius[3] > 0) {
      path2 += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x2, ",").concat(y2 + height2 - ySign * newRadius[3]);
    }
    path2 += "Z";
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);
    path2 = "M ".concat(x2, ",").concat(y2 + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x2 + xSign * _newRadius, ",").concat(y2, "\n            L ").concat(x2 + width2 - xSign * _newRadius, ",").concat(y2, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x2 + width2, ",").concat(y2 + ySign * _newRadius, "\n            L ").concat(x2 + width2, ",").concat(y2 + height2 - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x2 + width2 - xSign * _newRadius, ",").concat(y2 + height2, "\n            L ").concat(x2 + xSign * _newRadius, ",").concat(y2 + height2, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x2, ",").concat(y2 + height2 - ySign * _newRadius, " Z");
  } else {
    path2 = "M ".concat(x2, ",").concat(y2, " h ").concat(width2, " v ").concat(height2, " h ").concat(-width2, " Z");
  }
  return path2;
};
var isInRectangle = function isInRectangle2(point4, rect) {
  if (!point4 || !rect) {
    return false;
  }
  var px = point4.x, py = point4.y;
  var x2 = rect.x, y2 = rect.y, width2 = rect.width, height2 = rect.height;
  if (Math.abs(width2) > 0 && Math.abs(height2) > 0) {
    var minX = Math.min(x2, x2 + width2);
    var maxX = Math.max(x2, x2 + width2);
    var minY = Math.min(y2, y2 + height2);
    var maxY = Math.max(y2, y2 + height2);
    return px >= minX && px <= maxX && py >= minY && py <= maxY;
  }
  return false;
};
var defaultProps18 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
var Rectangle = function Rectangle2(rectangleProps) {
  var props = _objectSpread21(_objectSpread21({}, defaultProps18), rectangleProps);
  var pathRef = useRef();
  var _useState = useState(-1), _useState2 = _slicedToArray11(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
      }
    }
  }, []);
  var x2 = props.x, y2 = props.y, width2 = props.width, height2 = props.height, radius = props.radius, className = props.className;
  var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
  if (x2 !== +x2 || y2 !== +y2 || width2 !== +width2 || height2 !== +height2 || width2 === 0 || height2 === 0) {
    return null;
  }
  var layerClass = clsx_default("recharts-rectangle", className);
  if (!isUpdateAnimationActive) {
    return /* @__PURE__ */ React43.createElement("path", _extends13({}, filterProps(props, true), {
      className: layerClass,
      d: getRectanglePath(x2, y2, width2, height2, radius)
    }));
  }
  return /* @__PURE__ */ React43.createElement(es6_default, {
    canBegin: totalLength > 0,
    from: {
      width: width2,
      height: height2,
      x: x2,
      y: y2
    },
    to: {
      width: width2,
      height: height2,
      x: x2,
      y: y2
    },
    duration: animationDuration,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React43.createElement(es6_default, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      isActive: isAnimationActive,
      easing: animationEasing
    }, /* @__PURE__ */ React43.createElement("path", _extends13({}, filterProps(props, true), {
      className: layerClass,
      d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
      ref: pathRef
    })));
  });
};
var _excluded13 = ["points", "className", "baseLinePoints", "connectNulls"];
function _extends14() {
  _extends14 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends14.apply(this, arguments);
}
function _objectWithoutProperties13(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose13(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose13(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _toConsumableArray9(arr) {
  return _arrayWithoutHoles9(arr) || _iterableToArray10(arr) || _unsupportedIterableToArray18(arr) || _nonIterableSpread9();
}
function _nonIterableSpread9() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray18(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray18(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray18(o, minLen);
}
function _iterableToArray10(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles9(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray18(arr);
}
function _arrayLikeToArray18(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var isValidatePoint = function isValidatePoint2(point4) {
  return point4 && point4.x === +point4.x && point4.y === +point4.y;
};
var getParsedPoints = function getParsedPoints2() {
  var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var segmentPoints = [[]];
  points.forEach(function(entry) {
    if (isValidatePoint(entry)) {
      segmentPoints[segmentPoints.length - 1].push(entry);
    } else if (segmentPoints[segmentPoints.length - 1].length > 0) {
      segmentPoints.push([]);
    }
  });
  if (isValidatePoint(points[0])) {
    segmentPoints[segmentPoints.length - 1].push(points[0]);
  }
  if (segmentPoints[segmentPoints.length - 1].length <= 0) {
    segmentPoints = segmentPoints.slice(0, -1);
  }
  return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath2(points, connectNulls) {
  var segmentPoints = getParsedPoints(points);
  if (connectNulls) {
    segmentPoints = [segmentPoints.reduce(function(res, segPoints) {
      return [].concat(_toConsumableArray9(res), _toConsumableArray9(segPoints));
    }, [])];
  }
  var polygonPath = segmentPoints.map(function(segPoints) {
    return segPoints.reduce(function(path2, point4, index2) {
      return "".concat(path2).concat(index2 === 0 ? "M" : "L").concat(point4.x, ",").concat(point4.y);
    }, "");
  }).join("");
  return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath2(points, baseLinePoints, connectNulls) {
  var outerPath = getSinglePolygonPath(points, connectNulls);
  return "".concat(outerPath.slice(-1) === "Z" ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = function Polygon2(props) {
  var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties13(props, _excluded13);
  if (!points || !points.length) {
    return null;
  }
  var layerClass = clsx_default("recharts-polygon", className);
  if (baseLinePoints && baseLinePoints.length) {
    var hasStroke = others.stroke && others.stroke !== "none";
    var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
    return /* @__PURE__ */ React43.createElement("g", {
      className: layerClass
    }, /* @__PURE__ */ React43.createElement("path", _extends14({}, filterProps(others, true), {
      fill: rangePath.slice(-1) === "Z" ? others.fill : "none",
      stroke: "none",
      d: rangePath
    })), hasStroke ? /* @__PURE__ */ React43.createElement("path", _extends14({}, filterProps(others, true), {
      fill: "none",
      d: getSinglePolygonPath(points, connectNulls)
    })) : null, hasStroke ? /* @__PURE__ */ React43.createElement("path", _extends14({}, filterProps(others, true), {
      fill: "none",
      d: getSinglePolygonPath(baseLinePoints, connectNulls)
    })) : null);
  }
  var singlePath = getSinglePolygonPath(points, connectNulls);
  return /* @__PURE__ */ React43.createElement("path", _extends14({}, filterProps(others, true), {
    fill: singlePath.slice(-1) === "Z" ? others.fill : "none",
    className: layerClass,
    d: singlePath
  }));
};
function _extends15() {
  _extends15 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends15.apply(this, arguments);
}
var Dot = function Dot2(props) {
  var cx = props.cx, cy = props.cy, r2 = props.r, className = props.className;
  var layerClass = clsx_default("recharts-dot", className);
  if (cx === +cx && cy === +cy && r2 === +r2) {
    return /* @__PURE__ */ React43.createElement("circle", _extends15({}, filterProps(props, false), adaptEventHandlers(props), {
      className: layerClass,
      cx,
      cy,
      r: r2
    }));
  }
  return null;
};
function _typeof27(o) {
  "@babel/helpers - typeof";
  return _typeof27 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof27(o);
}
var _excluded14 = ["x", "y", "top", "left", "width", "height", "className"];
function _extends16() {
  _extends16 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends16.apply(this, arguments);
}
function ownKeys22(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread22(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys22(Object(t), true).forEach(function(r3) {
      _defineProperty24(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys22(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty24(obj, key2, value2) {
  key2 = _toPropertyKey25(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey25(t) {
  var i = _toPrimitive25(t, "string");
  return "symbol" == _typeof27(i) ? i : i + "";
}
function _toPrimitive25(t, r2) {
  if ("object" != _typeof27(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof27(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _objectWithoutProperties14(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose14(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose14(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var getPath3 = function getPath4(x2, y2, width2, height2, top, left) {
  return "M".concat(x2, ",").concat(top, "v").concat(height2, "M").concat(left, ",").concat(y2, "h").concat(width2);
};
var Cross = function Cross2(_ref) {
  var _ref$x = _ref.x, x2 = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y2 = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width2 = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties14(_ref, _excluded14);
  var props = _objectSpread22({
    x: x2,
    y: y2,
    top,
    left,
    width: width2,
    height: height2
  }, rest);
  if (!isNumber(x2) || !isNumber(y2) || !isNumber(width2) || !isNumber(height2) || !isNumber(top) || !isNumber(left)) {
    return null;
  }
  return /* @__PURE__ */ React43.createElement("path", _extends16({}, filterProps(props, true), {
    className: clsx_default("recharts-cross", className),
    d: getPath3(x2, y2, width2, height2, top, left)
  }));
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/polar/PolarRadiusAxis.js
var import_maxBy = __toESM(require_maxBy());
var import_minBy = __toESM(require_minBy());
var import_isFunction9 = __toESM(require_isFunction());
var _excluded15 = ["cx", "cy", "angle", "ticks", "axisLine"];
var _excluded25 = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function _typeof28(o) {
  "@babel/helpers - typeof";
  return _typeof28 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof28(o);
}
function _extends17() {
  _extends17 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends17.apply(this, arguments);
}
function ownKeys23(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread23(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys23(Object(t), true).forEach(function(r3) {
      _defineProperty25(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys23(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _objectWithoutProperties15(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose15(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose15(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _classCallCheck8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey26(descriptor.key), descriptor);
  }
}
function _createClass8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties8(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties8(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper6(t, o, e) {
  return o = _getPrototypeOf7(o), _possibleConstructorReturn7(t, _isNativeReflectConstruct7() ? Reflect.construct(o, e || [], _getPrototypeOf7(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn7(self2, call) {
  if (call && (_typeof28(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized7(self2);
}
function _assertThisInitialized7(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct7() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct7 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf7(o) {
  _getPrototypeOf7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf7(o);
}
function _inherits7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf7(subClass, superClass);
}
function _setPrototypeOf7(o, p) {
  _setPrototypeOf7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf7(o, p);
}
function _defineProperty25(obj, key2, value2) {
  key2 = _toPropertyKey26(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey26(t) {
  var i = _toPrimitive26(t, "string");
  return "symbol" == _typeof28(i) ? i : i + "";
}
function _toPrimitive26(t, r2) {
  if ("object" != _typeof28(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof28(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var PolarRadiusAxis = /* @__PURE__ */ function(_PureComponent) {
  function PolarRadiusAxis2() {
    _classCallCheck8(this, PolarRadiusAxis2);
    return _callSuper6(this, PolarRadiusAxis2, arguments);
  }
  _inherits7(PolarRadiusAxis2, _PureComponent);
  return _createClass8(PolarRadiusAxis2, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function getTickValueCoord(_ref) {
        var coordinate = _ref.coordinate;
        var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
        return polarToCartesian(cx, cy, coordinate, angle);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;
      var textAnchor;
      switch (orientation) {
        case "left":
          textAnchor = "end";
          break;
        case "right":
          textAnchor = "start";
          break;
        default:
          textAnchor = "middle";
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getViewBox",
    value: function getViewBox() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks2 = _this$props2.ticks;
      var maxRadiusTick = (0, import_maxBy.default)(ticks2, function(entry) {
        return entry.coordinate || 0;
      });
      var minRadiusTick = (0, import_minBy.default)(ticks2, function(entry) {
        return entry.coordinate || 0;
      });
      return {
        cx,
        cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks2 = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties15(_this$props3, _excluded15);
      var extent = ticks2.reduce(function(result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = polarToCartesian(cx, cy, extent[0], angle);
      var point1 = polarToCartesian(cx, cy, extent[1], angle);
      var props = _objectSpread23(_objectSpread23(_objectSpread23({}, filterProps(others, false)), {}, {
        fill: "none"
      }, filterProps(axisLine, false)), {}, {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });
      return /* @__PURE__ */ React43.createElement("line", _extends17({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props4 = this.props, ticks2 = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = _objectWithoutProperties15(_this$props4, _excluded25);
      var textAnchor = this.getTickTextAnchor();
      var axisProps = filterProps(others, false);
      var customTickProps = filterProps(tick, false);
      var items = ticks2.map(function(entry, i) {
        var coord = _this.getTickValueCoord(entry);
        var tickProps = _objectSpread23(_objectSpread23(_objectSpread23(_objectSpread23({
          textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke
        }, customTickProps), {}, {
          index: i
        }, coord), {}, {
          payload: entry
        });
        return /* @__PURE__ */ React43.createElement(Layer, _extends17({
          className: clsx_default("recharts-polar-radius-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i)), PolarRadiusAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
      });
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props, ticks2 = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
      if (!ticks2 || !ticks2.length) {
        return null;
      }
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: clsx_default("recharts-polar-radius-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), Label.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value2) {
      var tickItem;
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React43.cloneElement(option, props);
      } else if ((0, import_isFunction9.default)(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React43.createElement(Text, _extends17({}, props, {
          className: "recharts-polar-radius-axis-tick-value"
        }), value2);
      }
      return tickItem;
    }
  }]);
}(PureComponent);
_defineProperty25(PolarRadiusAxis, "displayName", "PolarRadiusAxis");
_defineProperty25(PolarRadiusAxis, "axisType", "radiusAxis");
_defineProperty25(PolarRadiusAxis, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: true,
  tick: true,
  tickCount: 5,
  allowDataOverflow: false,
  scale: "auto",
  allowDuplicatedCategory: true
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/polar/PolarAngleAxis.js
var import_isFunction10 = __toESM(require_isFunction());
function _typeof29(o) {
  "@babel/helpers - typeof";
  return _typeof29 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof29(o);
}
function _extends18() {
  _extends18 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends18.apply(this, arguments);
}
function ownKeys24(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread24(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys24(Object(t), true).forEach(function(r3) {
      _defineProperty26(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys24(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties9(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey27(descriptor.key), descriptor);
  }
}
function _createClass9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties9(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties9(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper7(t, o, e) {
  return o = _getPrototypeOf8(o), _possibleConstructorReturn8(t, _isNativeReflectConstruct8() ? Reflect.construct(o, e || [], _getPrototypeOf8(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn8(self2, call) {
  if (call && (_typeof29(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized8(self2);
}
function _assertThisInitialized8(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct8() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct8 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf8(o) {
  _getPrototypeOf8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf8(o);
}
function _inherits8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf8(subClass, superClass);
}
function _setPrototypeOf8(o, p) {
  _setPrototypeOf8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf8(o, p);
}
function _defineProperty26(obj, key2, value2) {
  key2 = _toPropertyKey27(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey27(t) {
  var i = _toPrimitive27(t, "string");
  return "symbol" == _typeof29(i) ? i : i + "";
}
function _toPrimitive27(t, r2) {
  if ("object" != _typeof29(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof29(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var RADIAN3 = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /* @__PURE__ */ function(_PureComponent) {
  function PolarAngleAxis2() {
    _classCallCheck9(this, PolarAngleAxis2);
    return _callSuper7(this, PolarAngleAxis2, arguments);
  }
  _inherits8(PolarAngleAxis2, _PureComponent);
  return _createClass9(PolarAngleAxis2, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function getTickLineCoord(data2) {
        var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
        var tickLineSize = tickSize || 8;
        var p1 = polarToCartesian(cx, cy, radius, data2.coordinate);
        var p2 = polarToCartesian(cx, cy, radius + (orientation === "inner" ? -1 : 1) * tickLineSize, data2.coordinate);
        return {
          x1: p1.x,
          y1: p1.y,
          x2: p2.x,
          y2: p2.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor(data2) {
      var orientation = this.props.orientation;
      var cos2 = Math.cos(-data2.coordinate * RADIAN3);
      var textAnchor;
      if (cos2 > eps) {
        textAnchor = orientation === "outer" ? "start" : "end";
      } else if (cos2 < -1e-5) {
        textAnchor = orientation === "outer" ? "end" : "start";
      } else {
        textAnchor = "middle";
      }
      return textAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
      var props = _objectSpread24(_objectSpread24({}, filterProps(this.props, false)), {}, {
        fill: "none"
      }, filterProps(axisLine, false));
      if (axisLineType === "circle") {
        return /* @__PURE__ */ React43.createElement(Dot, _extends18({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx,
          cy,
          r: radius
        }));
      }
      var ticks2 = this.props.ticks;
      var points = ticks2.map(function(entry) {
        return polarToCartesian(cx, cy, radius, entry.coordinate);
      });
      return /* @__PURE__ */ React43.createElement(Polygon, _extends18({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points
      }));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props3 = this.props, ticks2 = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
      var axisProps = filterProps(this.props, false);
      var customTickProps = filterProps(tick, false);
      var tickLineProps = _objectSpread24(_objectSpread24({}, axisProps), {}, {
        fill: "none"
      }, filterProps(tickLine, false));
      var items = ticks2.map(function(entry, i) {
        var lineCoord = _this.getTickLineCoord(entry);
        var textAnchor = _this.getTickTextAnchor(entry);
        var tickProps = _objectSpread24(_objectSpread24(_objectSpread24({
          textAnchor
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke
        }, customTickProps), {}, {
          index: i,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });
        return /* @__PURE__ */ React43.createElement(Layer, _extends18({
          className: clsx_default("recharts-polar-angle-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i)), tickLine && /* @__PURE__ */ React43.createElement("line", _extends18({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && PolarAngleAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
      });
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, ticks2 = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
      if (radius <= 0 || !ticks2 || !ticks2.length) {
        return null;
      }
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: clsx_default("recharts-polar-angle-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value2) {
      var tickItem;
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React43.cloneElement(option, props);
      } else if ((0, import_isFunction10.default)(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React43.createElement(Text, _extends18({}, props, {
          className: "recharts-polar-angle-axis-tick-value"
        }), value2);
      }
      return tickItem;
    }
  }]);
}(PureComponent);
_defineProperty26(PolarAngleAxis, "displayName", "PolarAngleAxis");
_defineProperty26(PolarAngleAxis, "axisType", "angleAxis");
_defineProperty26(PolarAngleAxis, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: true,
  tickLine: true,
  tickSize: 8,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
});
var import_get4 = __toESM(require_get());
var import_isEqual3 = __toESM(require_isEqual());
var import_isNil8 = __toESM(require_isNil());
var import_isFunction12 = __toESM(require_isFunction());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ActiveShapeUtils.js
var import_isFunction11 = __toESM(require_isFunction());
var import_isPlainObject = __toESM(require_isPlainObject());
var import_isBoolean = __toESM(require_isBoolean());
var import_isEqual2 = __toESM(require_isEqual());
function _typeof30(o) {
  "@babel/helpers - typeof";
  return _typeof30 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof30(o);
}
function _extends19() {
  _extends19 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends19.apply(this, arguments);
}
function _slicedToArray12(arr, i) {
  return _arrayWithHoles13(arr) || _iterableToArrayLimit12(arr, i) || _unsupportedIterableToArray19(arr, i) || _nonIterableRest13();
}
function _nonIterableRest13() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray19(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray19(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray19(o, minLen);
}
function _arrayLikeToArray19(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit12(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles13(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys25(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread25(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys25(Object(t), true).forEach(function(r3) {
      _defineProperty27(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys25(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty27(obj, key2, value2) {
  key2 = _toPropertyKey28(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey28(t) {
  var i = _toPrimitive28(t, "string");
  return "symbol" == _typeof30(i) ? i : i + "";
}
function _toPrimitive28(t, r2) {
  if ("object" != _typeof30(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof30(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getTrapezoidPath = function getTrapezoidPath2(x2, y2, upperWidth, lowerWidth, height2) {
  var widthGap = upperWidth - lowerWidth;
  var path2;
  path2 = "M ".concat(x2, ",").concat(y2);
  path2 += "L ".concat(x2 + upperWidth, ",").concat(y2);
  path2 += "L ".concat(x2 + upperWidth - widthGap / 2, ",").concat(y2 + height2);
  path2 += "L ".concat(x2 + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y2 + height2);
  path2 += "L ".concat(x2, ",").concat(y2, " Z");
  return path2;
};
var defaultProps19 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
var Trapezoid = function Trapezoid2(props) {
  var trapezoidProps = _objectSpread25(_objectSpread25({}, defaultProps19), props);
  var pathRef = useRef();
  var _useState = useState(-1), _useState2 = _slicedToArray12(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
      }
    }
  }, []);
  var x2 = trapezoidProps.x, y2 = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height2 = trapezoidProps.height, className = trapezoidProps.className;
  var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
  if (x2 !== +x2 || y2 !== +y2 || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height2 !== +height2 || upperWidth === 0 && lowerWidth === 0 || height2 === 0) {
    return null;
  }
  var layerClass = clsx_default("recharts-trapezoid", className);
  if (!isUpdateAnimationActive) {
    return /* @__PURE__ */ React43.createElement("g", null, /* @__PURE__ */ React43.createElement("path", _extends19({}, filterProps(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(x2, y2, upperWidth, lowerWidth, height2)
    })));
  }
  return /* @__PURE__ */ React43.createElement(es6_default, {
    canBegin: totalLength > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: height2,
      x: x2,
      y: y2
    },
    to: {
      upperWidth,
      lowerWidth,
      height: height2,
      x: x2,
      y: y2
    },
    duration: animationDuration,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React43.createElement(es6_default, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      easing: animationEasing
    }, /* @__PURE__ */ React43.createElement("path", _extends19({}, filterProps(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
      ref: pathRef
    })));
  });
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/ActiveShapeUtils.js
var _excluded16 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _typeof31(o) {
  "@babel/helpers - typeof";
  return _typeof31 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof31(o);
}
function _objectWithoutProperties16(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose16(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose16(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function ownKeys26(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread26(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys26(Object(t), true).forEach(function(r3) {
      _defineProperty28(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys26(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty28(obj, key2, value2) {
  key2 = _toPropertyKey29(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey29(t) {
  var i = _toPrimitive29(t, "string");
  return "symbol" == _typeof31(i) ? i : i + "";
}
function _toPrimitive29(t, r2) {
  if ("object" != _typeof31(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof31(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function defaultPropTransformer(option, props) {
  return _objectSpread26(_objectSpread26({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
  return shapeType === "symbols";
}
function ShapeSelector(_ref) {
  var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
  switch (shapeType) {
    case "rectangle":
      return /* @__PURE__ */ React43.createElement(Rectangle, elementProps);
    case "trapezoid":
      return /* @__PURE__ */ React43.createElement(Trapezoid, elementProps);
    case "sector":
      return /* @__PURE__ */ React43.createElement(Sector, elementProps);
    case "symbols":
      if (isSymbolsProps(shapeType)) {
        return /* @__PURE__ */ React43.createElement(Symbols, elementProps);
      }
      break;
    default:
      return null;
  }
}
function getPropsFromShapeOption(option) {
  if (/* @__PURE__ */ isValidElement(option)) {
    return option.props;
  }
  return option;
}
function Shape(_ref2) {
  var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties16(_ref2, _excluded16);
  var shape;
  if (/* @__PURE__ */ isValidElement(option)) {
    shape = /* @__PURE__ */ cloneElement(option, _objectSpread26(_objectSpread26({}, props), getPropsFromShapeOption(option)));
  } else if ((0, import_isFunction11.default)(option)) {
    shape = option(props);
  } else if ((0, import_isPlainObject.default)(option) && !(0, import_isBoolean.default)(option)) {
    var nextProps = propTransformer(option, props);
    shape = /* @__PURE__ */ React43.createElement(ShapeSelector, {
      shapeType,
      elementProps: nextProps
    });
  } else {
    var elementProps = props;
    shape = /* @__PURE__ */ React43.createElement(ShapeSelector, {
      shapeType,
      elementProps
    });
  }
  if (isActive) {
    return /* @__PURE__ */ React43.createElement(Layer, {
      className: activeClassName
    }, shape);
  }
  return shape;
}
function isFunnel(graphicalItem, _item) {
  return _item != null && "trapezoids" in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
  return _item != null && "sectors" in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
  return _item != null && "points" in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
  var _activeTooltipItem$la, _activeTooltipItem$la2;
  var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
  return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
  var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
  var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
  return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
  var xMatches = shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === activeTooltipItem.y;
  var zMatches = shapeData.z === activeTooltipItem.z;
  return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
  var comparison;
  if (isFunnel(graphicalItem, activeItem)) {
    comparison = compareFunnel;
  } else if (isPie(graphicalItem, activeItem)) {
    comparison = comparePie;
  } else if (isScatter(graphicalItem, activeItem)) {
    comparison = compareScatter;
  }
  return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
  var shapeKey;
  if (isFunnel(graphicalItem, activeItem)) {
    shapeKey = "trapezoids";
  } else if (isPie(graphicalItem, activeItem)) {
    shapeKey = "sectors";
  } else if (isScatter(graphicalItem, activeItem)) {
    shapeKey = "points";
  }
  return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
  if (isFunnel(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa;
    return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
  }
  if (isPie(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa2;
    return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
  }
  if (isScatter(graphicalItem, activeItem)) {
    return activeItem.payload;
  }
  return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
  var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
  var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
  var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
  var activeItemMatches = itemData.filter(function(datum, dataIndex) {
    var valuesMatch = (0, import_isEqual2.default)(tooltipPayload, datum);
    var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
      var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
      return comparison(shapeData, activeTooltipItem);
    });
    var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
    var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
    return valuesMatch && coordinatesMatch;
  });
  var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
  return activeIndex;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/polar/Pie.js
var _Pie;
function _typeof32(o) {
  "@babel/helpers - typeof";
  return _typeof32 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof32(o);
}
function _extends20() {
  _extends20 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends20.apply(this, arguments);
}
function ownKeys27(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread27(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys27(Object(t), true).forEach(function(r3) {
      _defineProperty29(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys27(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck10(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties10(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey30(descriptor.key), descriptor);
  }
}
function _createClass10(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties10(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties10(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper8(t, o, e) {
  return o = _getPrototypeOf9(o), _possibleConstructorReturn9(t, _isNativeReflectConstruct9() ? Reflect.construct(o, e || [], _getPrototypeOf9(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn9(self2, call) {
  if (call && (_typeof32(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized9(self2);
}
function _assertThisInitialized9(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct9() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct9 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf9(o) {
  _getPrototypeOf9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf9(o);
}
function _inherits9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf9(subClass, superClass);
}
function _setPrototypeOf9(o, p) {
  _setPrototypeOf9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf9(o, p);
}
function _defineProperty29(obj, key2, value2) {
  key2 = _toPropertyKey30(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey30(t) {
  var i = _toPrimitive30(t, "string");
  return "symbol" == _typeof32(i) ? i : i + "";
}
function _toPrimitive30(t, r2) {
  if ("object" != _typeof32(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof32(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var Pie = /* @__PURE__ */ function(_PureComponent) {
  function Pie2(props) {
    var _this;
    _classCallCheck10(this, Pie2);
    _this = _callSuper8(this, Pie2, [props]);
    _defineProperty29(_this, "pieRef", null);
    _defineProperty29(_this, "sectorRefs", []);
    _defineProperty29(_this, "id", uniqueId("recharts-pie-"));
    _defineProperty29(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, import_isFunction12.default)(onAnimationEnd2)) {
        onAnimationEnd2();
      }
    });
    _defineProperty29(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, import_isFunction12.default)(onAnimationStart2)) {
        onAnimationStart2();
      }
    });
    _this.state = {
      isAnimationFinished: !props.isAnimationActive,
      prevIsAnimationActive: props.isAnimationActive,
      prevAnimationId: props.animationId,
      sectorToFocus: 0
    };
    return _this;
  }
  _inherits9(Pie2, _PureComponent);
  return _createClass10(Pie2, [{
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;
      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }
      return i === activeIndex;
    }
  }, {
    key: "hasActiveIndex",
    value: function hasActiveIndex() {
      var activeIndex = this.props.activeIndex;
      return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels(sectors) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
      var pieProps = filterProps(this.props, false);
      var customLabelProps = filterProps(label, false);
      var customLabelLineProps = filterProps(labelLine, false);
      var offsetRadius = label && label.offsetRadius || 20;
      var labels = sectors.map(function(entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = polarToCartesian(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = _objectSpread27(_objectSpread27(_objectSpread27(_objectSpread27({}, pieProps), entry), {}, {
          stroke: "none"
        }, customLabelProps), {}, {
          index: i,
          textAnchor: Pie2.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = _objectSpread27(_objectSpread27(_objectSpread27(_objectSpread27({}, pieProps), entry), {}, {
          fill: "none",
          stroke: entry.fill
        }, customLabelLineProps), {}, {
          index: i,
          points: [polarToCartesian(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
        });
        var realDataKey = dataKey;
        if ((0, import_isNil8.default)(dataKey) && (0, import_isNil8.default)(valueKey)) {
          realDataKey = "value";
        } else if ((0, import_isNil8.default)(dataKey)) {
          realDataKey = valueKey;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React43.createElement(Layer, {
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
          }, labelLine && Pie2.renderLabelLineItem(labelLine, lineProps, "line"), Pie2.renderLabelItem(label, labelProps, getValueByDataKey(entry, realDataKey)))
        );
      });
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-pie-labels"
      }, labels);
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;
      var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
      return sectors.map(function(entry, i) {
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        var isActive = _this2.isActiveIndex(i);
        var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
        var sectorOptions = isActive ? activeShape : inactiveShape;
        var sectorProps = _objectSpread27(_objectSpread27({}, entry), {}, {
          stroke: blendStroke ? entry.fill : entry.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ React43.createElement(Layer, _extends20({
          ref: function ref(_ref) {
            if (_ref && !_this2.sectorRefs.includes(_ref)) {
              _this2.sectorRefs.push(_ref);
            }
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, adaptEventsOfChild(_this2.props, entry, i), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
        }), /* @__PURE__ */ React43.createElement(Shape, _extends20({
          option: sectorOptions,
          isActive,
          shapeType: "sector"
        }, sectorProps)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;
      var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
      var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
      return /* @__PURE__ */ React43.createElement(es6_default, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(_ref2) {
        var t = _ref2.t;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first.startAngle;
        sectors.forEach(function(entry, index2) {
          var prev = prevSectors && prevSectors[index2];
          var paddingAngle = index2 > 0 ? (0, import_get4.default)(entry, "paddingAngle", 0) : 0;
          if (prev) {
            var angleIp = interpolateNumber(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
            var latest = _objectSpread27(_objectSpread27({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t) + paddingAngle
            });
            stepData.push(latest);
            curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle, startAngle = entry.startAngle;
            var interpolatorAngle = interpolateNumber(0, endAngle - startAngle);
            var deltaAngle = interpolatorAngle(t);
            var _latest = _objectSpread27(_objectSpread27({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });
            stepData.push(_latest);
            curAngle = _latest.endAngle;
          }
        });
        return /* @__PURE__ */ React43.createElement(Layer, null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function attachKeyboardHandlers(pieRef) {
      var _this4 = this;
      pieRef.onkeydown = function(e) {
        if (!e.altKey) {
          switch (e.key) {
            case "ArrowLeft": {
              var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[next].focus();
              _this4.setState({
                sectorToFocus: next
              });
              break;
            }
            case "ArrowRight": {
              var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[_next].focus();
              _this4.setState({
                sectorToFocus: _next
              });
              break;
            }
            case "Escape": {
              _this4.sectorRefs[_this4.state.sectorToFocus].blur();
              _this4.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
        }
      };
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
      var prevSectors = this.state.prevSectors;
      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, import_isEqual3.default)(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }
      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.pieRef) {
        this.attachKeyboardHandlers(this.pieRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (hide || !sectors || !sectors.length || !isNumber(cx) || !isNumber(cy) || !isNumber(innerRadius) || !isNumber(outerRadius)) {
        return null;
      }
      var layerClass = clsx_default("recharts-pie", className);
      return /* @__PURE__ */ React43.createElement(Layer, {
        tabIndex: this.props.rootTabIndex,
        className: layerClass,
        ref: function ref(_ref3) {
          _this5.pieRef = _ref3;
        }
      }, this.renderSectors(), label && this.renderLabels(sectors), Label.renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, sectors, false));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) {
        return {
          prevIsAnimationActive: nextProps.isAnimationActive,
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: [],
          isAnimationFinished: true
        };
      }
      if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: prevState.curSectors,
          isAnimationFinished: true
        };
      }
      if (nextProps.sectors !== prevState.curSectors) {
        return {
          curSectors: nextProps.sectors,
          isAnimationFinished: true
        };
      }
      return null;
    }
  }, {
    key: "getTextAnchor",
    value: function getTextAnchor(x2, cx) {
      if (x2 > cx) {
        return "start";
      }
      if (x2 < cx) {
        return "end";
      }
      return "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function renderLabelLineItem(option, props, key2) {
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        return /* @__PURE__ */ React43.cloneElement(option, props);
      }
      if ((0, import_isFunction12.default)(option)) {
        return option(props);
      }
      var className = clsx_default("recharts-pie-label-line", typeof option !== "boolean" ? option.className : "");
      return /* @__PURE__ */ React43.createElement(Curve, _extends20({}, props, {
        key: key2,
        type: "linear",
        className
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function renderLabelItem(option, props, value2) {
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        return /* @__PURE__ */ React43.cloneElement(option, props);
      }
      var label = value2;
      if ((0, import_isFunction12.default)(option)) {
        label = option(props);
        if (/* @__PURE__ */ React43.isValidElement(label)) {
          return label;
        }
      }
      var className = clsx_default("recharts-pie-label-text", typeof option !== "boolean" && !(0, import_isFunction12.default)(option) ? option.className : "");
      return /* @__PURE__ */ React43.createElement(Text, _extends20({}, props, {
        alignmentBaseline: "middle",
        className
      }), label);
    }
  }]);
}(PureComponent);
_Pie = Pie;
_defineProperty29(Pie, "displayName", "Pie");
_defineProperty29(Pie, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: false,
  rootTabIndex: 0
});
_defineProperty29(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
});
_defineProperty29(Pie, "getRealPieData", function(itemProps) {
  var data2 = itemProps.data, children = itemProps.children;
  var presentationProps = filterProps(itemProps, false);
  var cells = findAllByType(children, Cell);
  if (data2 && data2.length) {
    return data2.map(function(entry, index2) {
      return _objectSpread27(_objectSpread27(_objectSpread27({
        payload: entry
      }, presentationProps), entry), cells && cells[index2] && cells[index2].props);
    });
  }
  if (cells && cells.length) {
    return cells.map(function(cell) {
      return _objectSpread27(_objectSpread27({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty29(Pie, "parseCoordinateOfPie", function(itemProps, offset) {
  var top = offset.top, left = offset.left, width2 = offset.width, height2 = offset.height;
  var maxPieRadius = getMaxRadius(width2, height2);
  var cx = left + getPercentValue(itemProps.cx, width2, width2 / 2);
  var cy = top + getPercentValue(itemProps.cy, height2, height2 / 2);
  var innerRadius = getPercentValue(itemProps.innerRadius, maxPieRadius, 0);
  var outerRadius = getPercentValue(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = itemProps.maxRadius || Math.sqrt(width2 * width2 + height2 * height2) / 2;
  return {
    cx,
    cy,
    innerRadius,
    outerRadius,
    maxRadius
  };
});
_defineProperty29(Pie, "getComposedData", function(_ref4) {
  var item = _ref4.item, offset = _ref4.offset;
  var itemProps = item.type.defaultProps !== void 0 ? _objectSpread27(_objectSpread27({}, item.type.defaultProps), item.props) : item.props;
  var pieData = _Pie.getRealPieData(itemProps);
  if (!pieData || !pieData.length) {
    return null;
  }
  var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
  var minAngle = Math.abs(itemProps.minAngle);
  var coordinate = _Pie.parseCoordinateOfPie(itemProps, offset);
  var deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle);
  var absDeltaAngle = Math.abs(deltaAngle);
  var realDataKey = dataKey;
  if ((0, import_isNil8.default)(dataKey) && (0, import_isNil8.default)(valueKey)) {
    warn(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = "value";
  } else if ((0, import_isNil8.default)(dataKey)) {
    warn(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = valueKey;
  }
  var notZeroItemCount = pieData.filter(function(entry) {
    return getValueByDataKey(entry, realDataKey, 0) !== 0;
  }).length;
  var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
  var sum2 = pieData.reduce(function(result, entry) {
    var val2 = getValueByDataKey(entry, realDataKey, 0);
    return result + (isNumber(val2) ? val2 : 0);
  }, 0);
  var sectors;
  if (sum2 > 0) {
    var prev;
    sectors = pieData.map(function(entry, i) {
      var val2 = getValueByDataKey(entry, realDataKey, 0);
      var name2 = getValueByDataKey(entry, nameKey, i);
      var percent = (isNumber(val2) ? val2 : 0) / sum2;
      var tempStartAngle;
      if (i) {
        tempStartAngle = prev.endAngle + mathSign(deltaAngle) * paddingAngle * (val2 !== 0 ? 1 : 0);
      } else {
        tempStartAngle = startAngle;
      }
      var tempEndAngle = tempStartAngle + mathSign(deltaAngle) * ((val2 !== 0 ? minAngle : 0) + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{
        name: name2,
        value: val2,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }];
      var tooltipPosition = polarToCartesian(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread27(_objectSpread27(_objectSpread27({
        percent,
        cornerRadius,
        name: name2,
        tooltipPayload,
        midAngle,
        middleRadius,
        tooltipPosition
      }, entry), coordinate), {}, {
        value: getValueByDataKey(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: mathSign(deltaAngle) * paddingAngle
      });
      return prev;
    });
  }
  return _objectSpread27(_objectSpread27({}, coordinate), {}, {
    sectors,
    data: pieData
  });
});
var import_isFunction13 = __toESM(require_isFunction());
var import_range2 = __toESM(require_range());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/CssPrefixUtils.js
function _typeof33(o) {
  "@babel/helpers - typeof";
  return _typeof33 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof33(o);
}
function ownKeys28(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread28(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys28(Object(t), true).forEach(function(r3) {
      _defineProperty30(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys28(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty30(obj, key2, value2) {
  key2 = _toPropertyKey31(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey31(t) {
  var i = _toPrimitive31(t, "string");
  return "symbol" == _typeof33(i) ? i : i + "";
}
function _toPrimitive31(t, r2) {
  if ("object" != _typeof33(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof33(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var PREFIX_LIST = ["Webkit", "Moz", "O", "ms"];
var generatePrefixStyle = function generatePrefixStyle2(name2, value2) {
  var camelName = name2.replace(/(\w)/, function(v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function(res, entry) {
    return _objectSpread28(_objectSpread28({}, res), {}, _defineProperty30({}, entry + camelName, value2));
  }, {});
  result[name2] = value2;
  return result;
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/Brush.js
function _typeof34(o) {
  "@babel/helpers - typeof";
  return _typeof34 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof34(o);
}
function _extends21() {
  _extends21 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends21.apply(this, arguments);
}
function ownKeys29(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread29(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys29(Object(t), true).forEach(function(r3) {
      _defineProperty31(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys29(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck11(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties11(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey32(descriptor.key), descriptor);
  }
}
function _createClass11(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties11(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties11(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper9(t, o, e) {
  return o = _getPrototypeOf10(o), _possibleConstructorReturn10(t, _isNativeReflectConstruct10() ? Reflect.construct(o, e || [], _getPrototypeOf10(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn10(self2, call) {
  if (call && (_typeof34(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized10(self2);
}
function _assertThisInitialized10(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct10() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct10 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf10(o) {
  _getPrototypeOf10 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf10(o);
}
function _inherits10(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf10(subClass, superClass);
}
function _setPrototypeOf10(o, p) {
  _setPrototypeOf10 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf10(o, p);
}
function _defineProperty31(obj, key2, value2) {
  key2 = _toPropertyKey32(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey32(t) {
  var i = _toPrimitive32(t, "string");
  return "symbol" == _typeof34(i) ? i : i + "";
}
function _toPrimitive32(t, r2) {
  if ("object" != _typeof34(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof34(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var createScale = function createScale2(_ref) {
  var data2 = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x2 = _ref.x, width2 = _ref.width, travellerWidth = _ref.travellerWidth;
  if (!data2 || !data2.length) {
    return {};
  }
  var len = data2.length;
  var scale2 = point3().domain((0, import_range2.default)(0, len)).range([x2, x2 + width2 - travellerWidth]);
  var scaleValues = scale2.domain().map(function(entry) {
    return scale2(entry);
  });
  return {
    isTextActive: false,
    isSlideMoving: false,
    isTravellerMoving: false,
    isTravellerFocused: false,
    startX: scale2(startIndex),
    endX: scale2(endIndex),
    scale: scale2,
    scaleValues
  };
};
var isTouch = function isTouch2(e) {
  return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /* @__PURE__ */ function(_PureComponent) {
  function Brush2(props) {
    var _this;
    _classCallCheck11(this, Brush2);
    _this = _callSuper9(this, Brush2, [props]);
    _defineProperty31(_this, "handleDrag", function(e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }
      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    });
    _defineProperty31(_this, "handleTouchMove", function(e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    });
    _defineProperty31(_this, "handleDragEnd", function() {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      }, function() {
        var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd({
          endIndex,
          startIndex
        });
      });
      _this.detachDragEndListener();
    });
    _defineProperty31(_this, "handleLeaveWrapper", function() {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    });
    _defineProperty31(_this, "handleEnterSlideOrTraveller", function() {
      _this.setState({
        isTextActive: true
      });
    });
    _defineProperty31(_this, "handleLeaveSlideOrTraveller", function() {
      _this.setState({
        isTextActive: false
      });
    });
    _defineProperty31(_this, "handleSlideDragStart", function(e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
      _this.attachDragEndListener();
    });
    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, "startX"),
      endX: _this.handleTravellerDragStart.bind(_this, "endX")
    };
    _this.state = {};
    return _this;
  }
  _inherits10(Brush2, _PureComponent);
  return _createClass11(Brush2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
      this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref2) {
      var startX = _ref2.startX, endX = _ref2.endX;
      var scaleValues = this.state.scaleValues;
      var _this$props2 = this.props, gap = _this$props2.gap, data2 = _this$props2.data;
      var lastIndex = data2.length - 1;
      var min3 = Math.min(startX, endX);
      var max4 = Math.max(startX, endX);
      var minIndex = Brush2.getIndexInRange(scaleValues, min3);
      var maxIndex = Brush2.getIndexInRange(scaleValues, max4);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index2) {
      var _this$props3 = this.props, data2 = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
      var text2 = getValueByDataKey(data2[index2], dataKey, index2);
      return (0, import_isFunction13.default)(tickFormatter) ? tickFormatter(text2, index2) : text2;
    }
  }, {
    key: "attachDragEndListener",
    value: function attachDragEndListener() {
      window.addEventListener("mouseup", this.handleDragEnd, true);
      window.addEventListener("touchend", this.handleDragEnd, true);
      window.addEventListener("mousemove", this.handleDrag, true);
    }
  }, {
    key: "detachDragEndListener",
    value: function detachDragEndListener() {
      window.removeEventListener("mouseup", this.handleDragEnd, true);
      window.removeEventListener("touchend", this.handleDragEnd, true);
      window.removeEventListener("mousemove", this.handleDrag, true);
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e) {
      var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
      var _this$props4 = this.props, x2 = _this$props4.x, width2 = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
      var delta = e.pageX - slideMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x2 + width2 - travellerWidth - endX, x2 + width2 - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x2 - startX, x2 - endX);
      }
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });
      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }
      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id, e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
      this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e) {
      var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props5 = this.props, x2 = _this$props5.x, width2 = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data2 = _this$props5.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e.pageX - brushMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x2 + width2 - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x2 - prevValue);
      }
      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
      var isFullGap = function isFullGap2() {
        var lastIndex = data2.length - 1;
        if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }
        return false;
      };
      this.setState(_defineProperty31(_defineProperty31({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function handleTravellerMoveKeyboard(direction, id) {
      var _this2 = this;
      var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
      var currentScaleValue = this.state[id];
      var currentIndex = scaleValues.indexOf(currentScaleValue);
      if (currentIndex === -1) {
        return;
      }
      var newIndex = currentIndex + direction;
      if (newIndex === -1 || newIndex >= scaleValues.length) {
        return;
      }
      var newScaleValue = scaleValues[newIndex];
      if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) {
        return;
      }
      this.setState(_defineProperty31({}, id, newScaleValue), function() {
        _this2.props.onChange(_this2.getIndex({
          startX: _this2.state.startX,
          endX: _this2.state.endX
        }));
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props6 = this.props, x2 = _this$props6.x, y2 = _this$props6.y, width2 = _this$props6.width, height2 = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
      return /* @__PURE__ */ React43.createElement("rect", {
        stroke,
        fill,
        x: x2,
        y: y2,
        width: width2,
        height: height2
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props7 = this.props, x2 = _this$props7.x, y2 = _this$props7.y, width2 = _this$props7.width, height2 = _this$props7.height, data2 = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
      var chartElement = Children.only(children);
      if (!chartElement) {
        return null;
      }
      return /* @__PURE__ */ React43.cloneElement(chartElement, {
        x: x2,
        y: y2,
        width: width2,
        height: height2,
        margin: padding,
        compact: true,
        data: data2
      });
    }
  }, {
    key: "renderTravellerLayer",
    value: function renderTravellerLayer(travellerX, id) {
      var _data$startIndex, _data$endIndex, _this3 = this;
      var _this$props8 = this.props, y2 = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height2 = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data2 = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
      var x2 = Math.max(travellerX, this.props.x);
      var travellerProps = _objectSpread29(_objectSpread29({}, filterProps(this.props, false)), {}, {
        x: x2,
        y: y2,
        width: travellerWidth,
        height: height2
      });
      var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data2[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data2[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
      return /* @__PURE__ */ React43.createElement(Layer, {
        tabIndex: 0,
        role: "slider",
        "aria-label": ariaLabelBrush,
        "aria-valuenow": travellerX,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        onKeyDown: function onKeyDown(e) {
          if (!["ArrowLeft", "ArrowRight"].includes(e.key)) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
        },
        onFocus: function onFocus() {
          _this3.setState({
            isTravellerFocused: true
          });
        },
        onBlur: function onBlur() {
          _this3.setState({
            isTravellerFocused: false
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, Brush2.renderTraveller(traveller, travellerProps));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props9 = this.props, y2 = _this$props9.y, height2 = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
      var x2 = Math.min(startX, endX) + travellerWidth;
      var width2 = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
      return /* @__PURE__ */ React43.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: x2,
        y: y2,
        width: width2,
        height: height2
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y2 = _this$props10.y, height2 = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
      var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
      var offset = 5;
      var attrs = {
        pointerEvents: "none",
        fill: stroke
      };
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ React43.createElement(Text, _extends21({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y2 + height2 / 2
      }, attrs), this.getTextOfTick(startIndex)), /* @__PURE__ */ React43.createElement(Text, _extends21({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y2 + height2 / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props, data2 = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x2 = _this$props11.x, y2 = _this$props11.y, width2 = _this$props11.width, height2 = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
      var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
      if (!data2 || !data2.length || !isNumber(x2) || !isNumber(y2) || !isNumber(width2) || !isNumber(height2) || width2 <= 0 || height2 <= 0) {
        return null;
      }
      var layerClass = clsx_default("recharts-brush", className);
      var isPanoramic = React43.Children.count(children) === 1;
      var style = generatePrefixStyle("userSelect", "none");
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: layerClass,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function renderDefaultTraveller(props) {
      var x2 = props.x, y2 = props.y, width2 = props.width, height2 = props.height, stroke = props.stroke;
      var lineY = Math.floor(y2 + height2 / 2) - 1;
      return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement("rect", {
        x: x2,
        y: y2,
        width: width2,
        height: height2,
        fill: stroke,
        stroke: "none"
      }), /* @__PURE__ */ React43.createElement("line", {
        x1: x2 + 1,
        y1: lineY,
        x2: x2 + width2 - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ React43.createElement("line", {
        x1: x2 + 1,
        y1: lineY + 2,
        x2: x2 + width2 - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(option, props) {
      var rectangle;
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        rectangle = /* @__PURE__ */ React43.cloneElement(option, props);
      } else if ((0, import_isFunction13.default)(option)) {
        rectangle = option(props);
      } else {
        rectangle = Brush2.renderDefaultTraveller(props);
      }
      return rectangle;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var data2 = nextProps.data, width2 = nextProps.width, x2 = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
      if (data2 !== prevState.prevData || updateId !== prevState.prevUpdateId) {
        return _objectSpread29({
          prevData: data2,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x2,
          prevWidth: width2
        }, data2 && data2.length ? createScale({
          data: data2,
          width: width2,
          x: x2,
          travellerWidth,
          startIndex,
          endIndex
        }) : {
          scale: null,
          scaleValues: null
        });
      }
      if (prevState.scale && (width2 !== prevState.prevWidth || x2 !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
        prevState.scale.range([x2, x2 + width2 - travellerWidth]);
        var scaleValues = prevState.scale.domain().map(function(entry) {
          return prevState.scale(entry);
        });
        return {
          prevData: data2,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x2,
          prevWidth: width2,
          startX: prevState.scale(nextProps.startIndex),
          endX: prevState.scale(nextProps.endIndex),
          scaleValues
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function getIndexInRange(valueRange, x2) {
      var len = valueRange.length;
      var start = 0;
      var end = len - 1;
      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);
        if (valueRange[middle] > x2) {
          end = middle;
        } else {
          start = middle;
        }
      }
      return x2 >= valueRange[end] ? end : start;
    }
  }]);
}(PureComponent);
_defineProperty31(Brush, "displayName", "Brush");
_defineProperty31(Brush, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: false
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/ReferenceLine.js
var import_isFunction14 = __toESM(require_isFunction());
var import_some = __toESM(require_some());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/IfOverflowMatches.js
var ifOverflowMatches = function ifOverflowMatches2(props, value2) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = "extendDomain";
  }
  return ifOverflow === value2;
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/CartesianUtils.js
var import_mapValues = __toESM(require_mapValues());
var import_every = __toESM(require_every());
var import_isEqual4 = __toESM(require_isEqual());
var import_isNil9 = __toESM(require_isNil());
var _excluded17 = ["x", "y"];
function _typeof35(o) {
  "@babel/helpers - typeof";
  return _typeof35 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof35(o);
}
function _extends22() {
  _extends22 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends22.apply(this, arguments);
}
function ownKeys30(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread30(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys30(Object(t), true).forEach(function(r3) {
      _defineProperty32(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys30(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty32(obj, key2, value2) {
  key2 = _toPropertyKey33(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey33(t) {
  var i = _toPrimitive33(t, "string");
  return "symbol" == _typeof35(i) ? i : i + "";
}
function _toPrimitive33(t, r2) {
  if ("object" != _typeof35(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof35(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _objectWithoutProperties17(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose17(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose17(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function typeguardBarRectangleProps(_ref, props) {
  var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties17(_ref, _excluded17);
  var xValue = "".concat(xProp);
  var x2 = parseInt(xValue, 10);
  var yValue = "".concat(yProp);
  var y2 = parseInt(yValue, 10);
  var heightValue = "".concat(props.height || option.height);
  var height2 = parseInt(heightValue, 10);
  var widthValue = "".concat(props.width || option.width);
  var width2 = parseInt(widthValue, 10);
  return _objectSpread30(_objectSpread30(_objectSpread30(_objectSpread30(_objectSpread30({}, props), option), x2 ? {
    x: x2
  } : {}), y2 ? {
    y: y2
  } : {}), {}, {
    height: height2,
    width: width2,
    name: props.name,
    radius: props.radius
  });
}
function BarRectangle(props) {
  return /* @__PURE__ */ React43.createElement(Shape, _extends22({
    shapeType: "rectangle",
    propTransformer: typeguardBarRectangleProps,
    activeClassName: "recharts-active-bar"
  }, props));
}
var minPointSizeCallback = function minPointSizeCallback2(minPointSize) {
  var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(value2, index2) {
    if (typeof minPointSize === "number") return minPointSize;
    var isValueNumber = typeof value2 === "number";
    if (isValueNumber) {
      return minPointSize(value2, index2);
    }
    !isValueNumber ? process.env.NODE_ENV !== "production" ? invariant(false, "minPointSize callback function received a value with type of ".concat(_typeof35(value2), ". Currently only numbers are supported.")) : invariant() : void 0;
    return defaultValue;
  };
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/Bar.js
var _excluded18 = ["value", "background"];
var _Bar;
function _typeof36(o) {
  "@babel/helpers - typeof";
  return _typeof36 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof36(o);
}
function _objectWithoutProperties18(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose18(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose18(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _extends23() {
  _extends23 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends23.apply(this, arguments);
}
function ownKeys31(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread31(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys31(Object(t), true).forEach(function(r3) {
      _defineProperty33(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys31(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck12(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties12(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey34(descriptor.key), descriptor);
  }
}
function _createClass12(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties12(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties12(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper10(t, o, e) {
  return o = _getPrototypeOf11(o), _possibleConstructorReturn11(t, _isNativeReflectConstruct11() ? Reflect.construct(o, e || [], _getPrototypeOf11(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn11(self2, call) {
  if (call && (_typeof36(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized11(self2);
}
function _assertThisInitialized11(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct11() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct11 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf11(o) {
  _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf11(o);
}
function _inherits11(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf11(subClass, superClass);
}
function _setPrototypeOf11(o, p) {
  _setPrototypeOf11 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf11(o, p);
}
function _defineProperty33(obj, key2, value2) {
  key2 = _toPropertyKey34(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey34(t) {
  var i = _toPrimitive34(t, "string");
  return "symbol" == _typeof36(i) ? i : i + "";
}
function _toPrimitive34(t, r2) {
  if ("object" != _typeof36(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof36(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var Bar = /* @__PURE__ */ function(_PureComponent) {
  function Bar2() {
    var _this;
    _classCallCheck12(this, Bar2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper10(this, Bar2, [].concat(args));
    _defineProperty33(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty33(_this, "id", uniqueId("recharts-bar-"));
    _defineProperty33(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if (onAnimationEnd2) {
        onAnimationEnd2();
      }
    });
    _defineProperty33(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if (onAnimationStart2) {
        onAnimationStart2();
      }
    });
    return _this;
  }
  _inherits11(Bar2, _PureComponent);
  return _createClass12(Bar2, [{
    key: "renderRectanglesStatically",
    value: function renderRectanglesStatically(data2) {
      var _this2 = this;
      var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
      var baseProps = filterProps(this.props, false);
      return data2 && data2.map(function(entry, i) {
        var isActive = i === activeIndex;
        var option = isActive ? activeBar : shape;
        var props = _objectSpread31(_objectSpread31(_objectSpread31({}, baseProps), entry), {}, {
          isActive,
          option,
          index: i,
          dataKey,
          onAnimationStart: _this2.handleAnimationStart,
          onAnimationEnd: _this2.handleAnimationEnd
        });
        return /* @__PURE__ */ React43.createElement(Layer, _extends23({
          className: "recharts-bar-rectangle"
        }, adaptEventsOfChild(_this2.props, entry, i), {
          key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
        }), /* @__PURE__ */ React43.createElement(BarRectangle, props));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;
      var _this$props2 = this.props, data2 = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
      var prevData = this.state.prevData;
      return /* @__PURE__ */ React43.createElement(es6_default, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t = _ref.t;
        var stepData = data2.map(function(entry, index2) {
          var prev = prevData && prevData[index2];
          if (prev) {
            var interpolatorX = interpolateNumber(prev.x, entry.x);
            var interpolatorY = interpolateNumber(prev.y, entry.y);
            var interpolatorWidth = interpolateNumber(prev.width, entry.width);
            var interpolatorHeight = interpolateNumber(prev.height, entry.height);
            return _objectSpread31(_objectSpread31({}, entry), {}, {
              x: interpolatorX(t),
              y: interpolatorY(t),
              width: interpolatorWidth(t),
              height: interpolatorHeight(t)
            });
          }
          if (layout === "horizontal") {
            var _interpolatorHeight = interpolateNumber(0, entry.height);
            var h = _interpolatorHeight(t);
            return _objectSpread31(_objectSpread31({}, entry), {}, {
              y: entry.y + entry.height - h,
              height: h
            });
          }
          var interpolator = interpolateNumber(0, entry.width);
          var w = interpolator(t);
          return _objectSpread31(_objectSpread31({}, entry), {}, {
            width: w
          });
        });
        return /* @__PURE__ */ React43.createElement(Layer, null, _this3.renderRectanglesStatically(stepData));
      });
    }
  }, {
    key: "renderRectangles",
    value: function renderRectangles() {
      var _this$props3 = this.props, data2 = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
      var prevData = this.state.prevData;
      if (isAnimationActive && data2 && data2.length && (!prevData || !(0, import_isEqual4.default)(prevData, data2))) {
        return this.renderRectanglesWithAnimation();
      }
      return this.renderRectanglesStatically(data2);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this4 = this;
      var _this$props4 = this.props, data2 = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
      var backgroundProps = filterProps(this.props.background, false);
      return data2.map(function(entry, i) {
        entry.value; var background = entry.background, rest = _objectWithoutProperties18(entry, _excluded18);
        if (!background) {
          return null;
        }
        var props = _objectSpread31(_objectSpread31(_objectSpread31(_objectSpread31(_objectSpread31({}, rest), {}, {
          fill: "#eee"
        }, background), backgroundProps), adaptEventsOfChild(_this4.props, entry, i)), {}, {
          onAnimationStart: _this4.handleAnimationStart,
          onAnimationEnd: _this4.handleAnimationEnd,
          dataKey,
          index: i,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ React43.createElement(BarRectangle, _extends23({
          key: "background-bar-".concat(i),
          option: _this4.props.background,
          isActive: i === activeIndex
        }, props));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props5 = this.props, data2 = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
      var errorBarItems = findAllByType(children, ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var offset = layout === "vertical" ? data2[0].height / 2 : data2[0].width / 2;
      var dataPointFormatter = function dataPointFormatter2(dataPoint, dataKey) {
        var value2 = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: value2,
          errorVal: getValueByDataKey(dataPoint, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React43.createElement(Layer, errorBarProps, errorBarItems.map(function(item) {
        return /* @__PURE__ */ React43.cloneElement(item, {
          key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
          data: data2,
          xAxis,
          yAxis,
          layout,
          offset,
          dataPointFormatter
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props, hide = _this$props6.hide, data2 = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width2 = _this$props6.width, height2 = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
      if (hide || !data2 || !data2.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = clsx_default("recharts-bar", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, import_isNil9.default)(id) ? this.id : id;
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React43.createElement("rect", {
        x: needClipX ? left : left - width2 / 2,
        y: needClipY ? top : top - height2 / 2,
        width: needClipX ? width2 : width2 * 2,
        height: needClipY ? height2 : height2 * 2
      }))) : null, /* @__PURE__ */ React43.createElement(Layer, {
        className: "recharts-bar-rectangles",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, data2));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curData: nextProps.data,
          prevData: prevState.curData
        };
      }
      if (nextProps.data !== prevState.curData) {
        return {
          curData: nextProps.data
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_Bar = Bar;
_defineProperty33(Bar, "displayName", "Bar");
_defineProperty33(Bar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: false,
  data: [],
  layout: "vertical",
  activeBar: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
_defineProperty33(Bar, "getComposedData", function(_ref2) {
  var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
  var pos = findPositionOfBar(barPosition, item);
  if (!pos) {
    return null;
  }
  var layout = props.layout;
  var itemDefaultProps = item.type.defaultProps;
  var itemProps = itemDefaultProps !== void 0 ? _objectSpread31(_objectSpread31({}, itemDefaultProps), item.props) : item.props;
  var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
  var numericAxis = layout === "horizontal" ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = getBaseValueOfBar({
    numericAxis
  });
  var cells = findAllByType(children, Cell);
  var rects = displayedData.map(function(entry, index2) {
    var value2, x2, y2, width2, height2, background;
    if (stackedData) {
      value2 = truncateByDomain(stackedData[dataStartIndex + index2], stackedDomain);
    } else {
      value2 = getValueByDataKey(entry, dataKey);
      if (!Array.isArray(value2)) {
        value2 = [baseValue, value2];
      }
    }
    var minPointSize = minPointSizeCallback(minPointSizeProp, _Bar.defaultProps.minPointSize)(value2[1], index2);
    if (layout === "horizontal") {
      var _ref4;
      var _ref3 = [yAxis.scale(value2[0]), yAxis.scale(value2[1])], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
      x2 = getCateCoordinateOfBar({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize,
        offset: pos.offset,
        entry,
        index: index2
      });
      y2 = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : void 0;
      width2 = pos.size;
      var computedHeight = baseValueScale - currentValueScale;
      height2 = Number.isNaN(computedHeight) ? 0 : computedHeight;
      background = {
        x: x2,
        y: yAxis.y,
        width: width2,
        height: yAxis.height
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(height2) < Math.abs(minPointSize)) {
        var delta = mathSign(height2 || minPointSize) * (Math.abs(minPointSize) - Math.abs(height2));
        y2 -= delta;
        height2 += delta;
      }
    } else {
      var _ref5 = [xAxis.scale(value2[0]), xAxis.scale(value2[1])], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
      x2 = _baseValueScale;
      y2 = getCateCoordinateOfBar({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        offset: pos.offset,
        entry,
        index: index2
      });
      width2 = _currentValueScale - _baseValueScale;
      height2 = pos.size;
      background = {
        x: xAxis.x,
        y: y2,
        width: xAxis.width,
        height: height2
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(width2) < Math.abs(minPointSize)) {
        var _delta = mathSign(width2 || minPointSize) * (Math.abs(minPointSize) - Math.abs(width2));
        width2 += _delta;
      }
    }
    return _objectSpread31(_objectSpread31(_objectSpread31({}, entry), {}, {
      x: x2,
      y: y2,
      width: width2,
      height: height2,
      value: stackedData ? value2 : value2[1],
      payload: entry,
      background
    }, cells && cells[index2] && cells[index2].props), {}, {
      tooltipPayload: [getTooltipItem(item, entry)],
      tooltipPosition: {
        x: x2 + width2 / 2,
        y: y2 + height2 / 2
      }
    });
  });
  return _objectSpread31({
    data: rects,
    layout
  }, offset);
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/CartesianUtils.js
function _typeof37(o) {
  "@babel/helpers - typeof";
  return _typeof37 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof37(o);
}
function _classCallCheck13(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties13(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey35(descriptor.key), descriptor);
  }
}
function _createClass13(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties13(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties13(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function ownKeys32(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread32(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys32(Object(t), true).forEach(function(r3) {
      _defineProperty34(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys32(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty34(obj, key2, value2) {
  key2 = _toPropertyKey35(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey35(t) {
  var i = _toPrimitive35(t, "string");
  return "symbol" == _typeof37(i) ? i : i + "";
}
function _toPrimitive35(t, r2) {
  if ("object" != _typeof37(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof37(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var formatAxisMap3 = function formatAxisMap4(props, axisMap, offset, axisType, chartName) {
  var width2 = props.width, height2 = props.height, layout = props.layout, children = props.children;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width2 - offset.right,
    rightMirror: width2 - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height2 - offset.bottom,
    bottomMirror: height2 - offset.bottom
  };
  var hasBar = !!findChildByType(children, Bar);
  return ids.reduce(function(result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
    var calculatedPadding, range6, x2, y2, needSpace;
    if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
      var diff = domain[1] - domain[0];
      var smallestDistanceBetweenValues = Infinity;
      var sortedValues = axis.categoricalDomain.sort();
      sortedValues.forEach(function(value2, index2) {
        if (index2 > 0) {
          smallestDistanceBetweenValues = Math.min((value2 || 0) - (sortedValues[index2 - 1] || 0), smallestDistanceBetweenValues);
        }
      });
      if (Number.isFinite(smallestDistanceBetweenValues)) {
        var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
        var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
        if (axis.padding === "gap") {
          calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
        }
        if (axis.padding === "no-gap") {
          var gap = getPercentValue(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
          var halfBand = smallestDistanceInPercent * rangeWidth / 2;
          calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
        }
      }
    }
    if (axisType === "xAxis") {
      range6 = [offset.left + (padding.left || 0) + (calculatedPadding || 0), offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)];
    } else if (axisType === "yAxis") {
      range6 = layout === "horizontal" ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0) + (calculatedPadding || 0), offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)];
    } else {
      range6 = axis.range;
    }
    if (reversed) {
      range6 = [range6[1], range6[0]];
    }
    var _parseScale = parseScale(axis, chartName, hasBar), scale2 = _parseScale.scale, realScaleType = _parseScale.realScaleType;
    scale2.domain(domain).range(range6);
    checkDomainOfScale(scale2);
    var ticks2 = getTicksOfScale(scale2, _objectSpread32(_objectSpread32({}, axis), {}, {
      realScaleType
    }));
    if (axisType === "xAxis") {
      needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
      x2 = offset.left;
      y2 = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === "yAxis") {
      needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
      x2 = steps[offsetKey] - needSpace * axis.width;
      y2 = offset.top;
    }
    var finalAxis = _objectSpread32(_objectSpread32(_objectSpread32({}, axis), ticks2), {}, {
      realScaleType,
      x: x2,
      y: y2,
      scale: scale2,
      width: axisType === "xAxis" ? offset.width : axis.width,
      height: axisType === "yAxis" ? offset.height : axis.height
    });
    finalAxis.bandSize = getBandSizeOfAxis(finalAxis, ticks2);
    if (!axis.hide && axisType === "xAxis") {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }
    return _objectSpread32(_objectSpread32({}, result), {}, _defineProperty34({}, id, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints2(_ref, _ref2) {
  var x1 = _ref.x, y1 = _ref.y;
  var x2 = _ref2.x, y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
};
var rectWithCoords = function rectWithCoords2(_ref3) {
  var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  });
};
var ScaleHelper = /* @__PURE__ */ function() {
  function ScaleHelper2(scale2) {
    _classCallCheck13(this, ScaleHelper2);
    this.scale = scale2;
  }
  return _createClass13(ScaleHelper2, [{
    key: "domain",
    get: function get8() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get8() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get8() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get8() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get8() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function apply(value2) {
      var _ref4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref4.bandAware, position2 = _ref4.position;
      if (value2 === void 0) {
        return void 0;
      }
      if (position2) {
        switch (position2) {
          case "start": {
            return this.scale(value2);
          }
          case "middle": {
            var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value2) + offset;
          }
          case "end": {
            var _offset = this.bandwidth ? this.bandwidth() : 0;
            return this.scale(value2) + _offset;
          }
          default: {
            return this.scale(value2);
          }
        }
      }
      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
        return this.scale(value2) + _offset2;
      }
      return this.scale(value2);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value2) {
      var range6 = this.range();
      var first = range6[0];
      var last2 = range6[range6.length - 1];
      return first <= last2 ? value2 >= first && value2 <= last2 : value2 >= last2 && value2 <= first;
    }
  }], [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper2(obj);
    }
  }]);
}();
_defineProperty34(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales2(options) {
  var scales = Object.keys(options).reduce(function(res, key2) {
    return _objectSpread32(_objectSpread32({}, res), {}, _defineProperty34({}, key2, ScaleHelper.create(options[key2])));
  }, {});
  return _objectSpread32(_objectSpread32({}, scales), {}, {
    apply: function apply(coord) {
      var _ref5 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref5.bandAware, position2 = _ref5.position;
      return (0, import_mapValues.default)(coord, function(value2, label) {
        return scales[label].apply(value2, {
          bandAware,
          position: position2
        });
      });
    },
    isInRange: function isInRange(coord) {
      return (0, import_every.default)(coord, function(value2, label) {
        return scales[label].isInRange(value2);
      });
    }
  });
};
function normalizeAngle(angle) {
  return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth2(_ref6) {
  var width2 = _ref6.width, height2 = _ref6.height;
  var angle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var normalizedAngle = normalizeAngle(angle);
  var angleRadians = normalizedAngle * Math.PI / 180;
  var angleThreshold = Math.atan(height2 / width2);
  var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height2 / Math.sin(angleRadians) : width2 / Math.cos(angleRadians);
  return Math.abs(angledWidth);
};
var import_find = __toESM(require_find());
var import_every2 = __toESM(require_every());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/calculateViewBox.js
var import_memoize = __toESM(require_memoize());
var calculateViewBox = (0, import_memoize.default)(function(offset) {
  return {
    x: offset.left,
    y: offset.top,
    width: offset.width,
    height: offset.height
  };
}, function(offset) {
  return ["l", offset.left, "t", offset.top, "w", offset.width, "h", offset.height].join("");
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/context/chartLayoutContext.js
function _typeof38(o) {
  "@babel/helpers - typeof";
  return _typeof38 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof38(o);
}
var XAxisContext = /* @__PURE__ */ createContext(void 0);
var YAxisContext = /* @__PURE__ */ createContext(void 0);
var ViewBoxContext = /* @__PURE__ */ createContext(void 0);
var OffsetContext = /* @__PURE__ */ createContext({});
var ClipPathIdContext = /* @__PURE__ */ createContext(void 0);
var ChartHeightContext = /* @__PURE__ */ createContext(0);
var ChartWidthContext = /* @__PURE__ */ createContext(0);
var ChartLayoutContextProvider = function ChartLayoutContextProvider2(props) {
  var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width2 = props.width, height2 = props.height;
  var viewBox = calculateViewBox(offset);
  return /* @__PURE__ */ React43.createElement(XAxisContext.Provider, {
    value: xAxisMap
  }, /* @__PURE__ */ React43.createElement(YAxisContext.Provider, {
    value: yAxisMap
  }, /* @__PURE__ */ React43.createElement(OffsetContext.Provider, {
    value: offset
  }, /* @__PURE__ */ React43.createElement(ViewBoxContext.Provider, {
    value: viewBox
  }, /* @__PURE__ */ React43.createElement(ClipPathIdContext.Provider, {
    value: clipPathId
  }, /* @__PURE__ */ React43.createElement(ChartHeightContext.Provider, {
    value: height2
  }, /* @__PURE__ */ React43.createElement(ChartWidthContext.Provider, {
    value: width2
  }, children)))))));
};
var useClipPathId = function useClipPathId2() {
  return useContext(ClipPathIdContext);
};
function getKeysForDebug(object) {
  var keys2 = Object.keys(object);
  if (keys2.length === 0) {
    return "There are no available ids.";
  }
  return "Available ids are: ".concat(keys2, ".");
}
var useXAxisOrThrow = function useXAxisOrThrow2(xAxisId) {
  var xAxisMap = useContext(XAxisContext);
  !(xAxisMap != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant() : void 0;
  var xAxis = xAxisMap[xAxisId];
  !(xAxis != null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find xAxis by id "'.concat(xAxisId, '" [').concat(_typeof38(xAxisId), "]. ").concat(getKeysForDebug(xAxisMap))) : invariant() : void 0;
  return xAxis;
};
var useArbitraryXAxis = function useArbitraryXAxis2() {
  var xAxisMap = useContext(XAxisContext);
  return getAnyElementOfObject(xAxisMap);
};
var useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom2() {
  var yAxisMap = useContext(YAxisContext);
  var yAxisWithFiniteDomain = (0, import_find.default)(yAxisMap, function(axis) {
    return (0, import_every2.default)(axis.domain, Number.isFinite);
  });
  return yAxisWithFiniteDomain || getAnyElementOfObject(yAxisMap);
};
var useYAxisOrThrow = function useYAxisOrThrow2(yAxisId) {
  var yAxisMap = useContext(YAxisContext);
  !(yAxisMap != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant() : void 0;
  var yAxis = yAxisMap[yAxisId];
  !(yAxis != null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find yAxis by id "'.concat(yAxisId, '" [').concat(_typeof38(yAxisId), "]. ").concat(getKeysForDebug(yAxisMap))) : invariant() : void 0;
  return yAxis;
};
var useViewBox = function useViewBox2() {
  var viewBox = useContext(ViewBoxContext);
  return viewBox;
};
var useOffset = function useOffset2() {
  return useContext(OffsetContext);
};
var useChartWidth = function useChartWidth2() {
  return useContext(ChartWidthContext);
};
var useChartHeight = function useChartHeight2() {
  return useContext(ChartHeightContext);
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/ReferenceLine.js
function _typeof39(o) {
  "@babel/helpers - typeof";
  return _typeof39 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof39(o);
}
function _classCallCheck14(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties14(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey36(descriptor.key), descriptor);
  }
}
function _createClass14(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties14(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper11(t, o, e) {
  return o = _getPrototypeOf12(o), _possibleConstructorReturn12(t, _isNativeReflectConstruct12() ? Reflect.construct(o, e || [], _getPrototypeOf12(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn12(self2, call) {
  if (call && (_typeof39(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized12(self2);
}
function _assertThisInitialized12(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct12() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct12 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf12(o) {
  _getPrototypeOf12 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf12(o);
}
function _inherits12(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf12(subClass, superClass);
}
function _setPrototypeOf12(o, p) {
  _setPrototypeOf12 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf12(o, p);
}
function ownKeys33(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread33(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys33(Object(t), true).forEach(function(r3) {
      _defineProperty35(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys33(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty35(obj, key2, value2) {
  key2 = _toPropertyKey36(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey36(t) {
  var i = _toPrimitive36(t, "string");
  return "symbol" == _typeof39(i) ? i : i + "";
}
function _toPrimitive36(t, r2) {
  if ("object" != _typeof39(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof39(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _slicedToArray13(arr, i) {
  return _arrayWithHoles14(arr) || _iterableToArrayLimit13(arr, i) || _unsupportedIterableToArray20(arr, i) || _nonIterableRest14();
}
function _nonIterableRest14() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray20(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray20(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray20(o, minLen);
}
function _arrayLikeToArray20(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit13(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles14(arr) {
  if (Array.isArray(arr)) return arr;
}
function _extends24() {
  _extends24 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends24.apply(this, arguments);
}
var renderLine = function renderLine2(option, props) {
  var line;
  if (/* @__PURE__ */ React43.isValidElement(option)) {
    line = /* @__PURE__ */ React43.cloneElement(option, props);
  } else if ((0, import_isFunction14.default)(option)) {
    line = option(props);
  } else {
    line = /* @__PURE__ */ React43.createElement("line", _extends24({}, props, {
      className: "recharts-reference-line-line"
    }));
  }
  return line;
};
var getEndPoints = function getEndPoints2(scales, isFixedX, isFixedY, isSegment, viewBox, position2, xAxisOrientation, yAxisOrientation, props) {
  var x2 = viewBox.x, y2 = viewBox.y, width2 = viewBox.width, height2 = viewBox.height;
  if (isFixedY) {
    var yCoord = props.y;
    var coord = scales.y.apply(yCoord, {
      position: position2
    });
    if (ifOverflowMatches(props, "discard") && !scales.y.isInRange(coord)) {
      return null;
    }
    var points = [{
      x: x2 + width2,
      y: coord
    }, {
      x: x2,
      y: coord
    }];
    return yAxisOrientation === "left" ? points.reverse() : points;
  }
  if (isFixedX) {
    var xCoord = props.x;
    var _coord = scales.x.apply(xCoord, {
      position: position2
    });
    if (ifOverflowMatches(props, "discard") && !scales.x.isInRange(_coord)) {
      return null;
    }
    var _points = [{
      x: _coord,
      y: y2 + height2
    }, {
      x: _coord,
      y: y2
    }];
    return xAxisOrientation === "top" ? _points.reverse() : _points;
  }
  if (isSegment) {
    var segment = props.segment;
    var _points2 = segment.map(function(p) {
      return scales.apply(p, {
        position: position2
      });
    });
    if (ifOverflowMatches(props, "discard") && (0, import_some.default)(_points2, function(p) {
      return !scales.isInRange(p);
    })) {
      return null;
    }
    return _points2;
  }
  return null;
};
function ReferenceLineImpl(props) {
  var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
  var clipPathId = useClipPathId();
  var xAxis = useXAxisOrThrow(xAxisId);
  var yAxis = useYAxisOrThrow(yAxisId);
  var viewBox = useViewBox();
  if (!clipPathId || !viewBox) {
    return null;
  }
  warn(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var isX = isNumOrStr(fixedX);
  var isY = isNumOrStr(fixedY);
  var isSegment = segment && segment.length === 2;
  var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
  if (!endPoints) {
    return null;
  }
  var _endPoints = _slicedToArray13(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
  var clipPath = ifOverflowMatches(props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
  var lineProps = _objectSpread33(_objectSpread33({
    clipPath
  }, filterProps(props, true)), {}, {
    x1,
    y1,
    x2,
    y2
  });
  return /* @__PURE__ */ React43.createElement(Layer, {
    className: clsx_default("recharts-reference-line", className)
  }, renderLine(shape, lineProps), Label.renderCallByParent(props, rectWithCoords({
    x1,
    y1,
    x2,
    y2
  })));
}
var ReferenceLine = /* @__PURE__ */ function(_React$Component) {
  function ReferenceLine2() {
    _classCallCheck14(this, ReferenceLine2);
    return _callSuper11(this, ReferenceLine2, arguments);
  }
  _inherits12(ReferenceLine2, _React$Component);
  return _createClass14(ReferenceLine2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React43.createElement(ReferenceLineImpl, this.props);
    }
  }]);
}(React43.Component);
_defineProperty35(ReferenceLine, "displayName", "ReferenceLine");
_defineProperty35(ReferenceLine, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/ReferenceDot.js
var import_isFunction15 = __toESM(require_isFunction());
function _extends25() {
  _extends25 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends25.apply(this, arguments);
}
function _typeof40(o) {
  "@babel/helpers - typeof";
  return _typeof40 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof40(o);
}
function ownKeys34(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread34(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys34(Object(t), true).forEach(function(r3) {
      _defineProperty36(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys34(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck15(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties15(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey37(descriptor.key), descriptor);
  }
}
function _createClass15(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties15(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper12(t, o, e) {
  return o = _getPrototypeOf13(o), _possibleConstructorReturn13(t, _isNativeReflectConstruct13() ? Reflect.construct(o, e || [], _getPrototypeOf13(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn13(self2, call) {
  if (call && (_typeof40(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized13(self2);
}
function _assertThisInitialized13(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct13() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct13 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf13(o) {
  _getPrototypeOf13 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf13(o);
}
function _inherits13(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf13(subClass, superClass);
}
function _setPrototypeOf13(o, p) {
  _setPrototypeOf13 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf13(o, p);
}
function _defineProperty36(obj, key2, value2) {
  key2 = _toPropertyKey37(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey37(t) {
  var i = _toPrimitive37(t, "string");
  return "symbol" == _typeof40(i) ? i : i + "";
}
function _toPrimitive37(t, r2) {
  if ("object" != _typeof40(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof40(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getCoordinate = function getCoordinate2(props) {
  var x2 = props.x, y2 = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var result = scales.apply({
    x: x2,
    y: y2
  }, {
    bandAware: true
  });
  if (ifOverflowMatches(props, "discard") && !scales.isInRange(result)) {
    return null;
  }
  return result;
};
var ReferenceDot = /* @__PURE__ */ function(_React$Component) {
  function ReferenceDot2() {
    _classCallCheck15(this, ReferenceDot2);
    return _callSuper12(this, ReferenceDot2, arguments);
  }
  _inherits13(ReferenceDot2, _React$Component);
  return _createClass15(ReferenceDot2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, x2 = _this$props.x, y2 = _this$props.y, r2 = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
      var isX = isNumOrStr(x2);
      var isY = isNumOrStr(y2);
      warn(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      if (!isX || !isY) {
        return null;
      }
      var coordinate = getCoordinate(this.props);
      if (!coordinate) {
        return null;
      }
      var cx = coordinate.x, cy = coordinate.y;
      var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
      var clipPath = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
      var dotProps = _objectSpread34(_objectSpread34({
        clipPath
      }, filterProps(this.props, true)), {}, {
        cx,
        cy
      });
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: clsx_default("recharts-reference-dot", className)
      }, ReferenceDot2.renderDot(shape, dotProps), Label.renderCallByParent(this.props, {
        x: cx - r2,
        y: cy - r2,
        width: 2 * r2,
        height: 2 * r2
      }));
    }
  }]);
}(React43.Component);
_defineProperty36(ReferenceDot, "displayName", "ReferenceDot");
_defineProperty36(ReferenceDot, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
_defineProperty36(ReferenceDot, "renderDot", function(option, props) {
  var dot;
  if (/* @__PURE__ */ React43.isValidElement(option)) {
    dot = /* @__PURE__ */ React43.cloneElement(option, props);
  } else if ((0, import_isFunction15.default)(option)) {
    dot = option(props);
  } else {
    dot = /* @__PURE__ */ React43.createElement(Dot, _extends25({}, props, {
      cx: props.cx,
      cy: props.cy,
      className: "recharts-reference-dot-dot"
    }));
  }
  return dot;
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/ReferenceArea.js
var import_isFunction16 = __toESM(require_isFunction());
function _extends26() {
  _extends26 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends26.apply(this, arguments);
}
function _typeof41(o) {
  "@babel/helpers - typeof";
  return _typeof41 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof41(o);
}
function ownKeys35(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread35(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys35(Object(t), true).forEach(function(r3) {
      _defineProperty37(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys35(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck16(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties16(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey38(descriptor.key), descriptor);
  }
}
function _createClass16(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties16(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper13(t, o, e) {
  return o = _getPrototypeOf14(o), _possibleConstructorReturn14(t, _isNativeReflectConstruct14() ? Reflect.construct(o, e || [], _getPrototypeOf14(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn14(self2, call) {
  if (call && (_typeof41(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized14(self2);
}
function _assertThisInitialized14(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct14() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct14 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf14(o) {
  _getPrototypeOf14 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf14(o);
}
function _inherits14(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf14(subClass, superClass);
}
function _setPrototypeOf14(o, p) {
  _setPrototypeOf14 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf14(o, p);
}
function _defineProperty37(obj, key2, value2) {
  key2 = _toPropertyKey38(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey38(t) {
  var i = _toPrimitive38(t, "string");
  return "symbol" == _typeof41(i) ? i : i + "";
}
function _toPrimitive38(t, r2) {
  if ("object" != _typeof41(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof41(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var getRect = function getRect2(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
  if (!xAxis || !yAxis) return null;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var p1 = {
    x: hasX1 ? scales.x.apply(xValue1, {
      position: "start"
    }) : scales.x.rangeMin,
    y: hasY1 ? scales.y.apply(yValue1, {
      position: "start"
    }) : scales.y.rangeMin
  };
  var p2 = {
    x: hasX2 ? scales.x.apply(xValue2, {
      position: "end"
    }) : scales.x.rangeMax,
    y: hasY2 ? scales.y.apply(yValue2, {
      position: "end"
    }) : scales.y.rangeMax
  };
  if (ifOverflowMatches(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) {
    return null;
  }
  return rectWithPoints(p1, p2);
};
var ReferenceArea = /* @__PURE__ */ function(_React$Component) {
  function ReferenceArea2() {
    _classCallCheck16(this, ReferenceArea2);
    return _callSuper13(this, ReferenceArea2, arguments);
  }
  _inherits14(ReferenceArea2, _React$Component);
  return _createClass16(ReferenceArea2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
      warn(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var hasX1 = isNumOrStr(x1);
      var hasX2 = isNumOrStr(x2);
      var hasY1 = isNumOrStr(y1);
      var hasY2 = isNumOrStr(y2);
      var shape = this.props.shape;
      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
        return null;
      }
      var rect = getRect(hasX1, hasX2, hasY1, hasY2, this.props);
      if (!rect && !shape) {
        return null;
      }
      var clipPath = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: clsx_default("recharts-reference-area", className)
      }, ReferenceArea2.renderRect(shape, _objectSpread35(_objectSpread35({
        clipPath
      }, filterProps(this.props, true)), rect)), Label.renderCallByParent(this.props, rect));
    }
  }]);
}(React43.Component);
_defineProperty37(ReferenceArea, "displayName", "ReferenceArea");
_defineProperty37(ReferenceArea, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
_defineProperty37(ReferenceArea, "renderRect", function(option, props) {
  var rect;
  if (/* @__PURE__ */ React43.isValidElement(option)) {
    rect = /* @__PURE__ */ React43.cloneElement(option, props);
  } else if ((0, import_isFunction16.default)(option)) {
    rect = option(props);
  } else {
    rect = /* @__PURE__ */ React43.createElement(Rectangle, _extends26({}, props, {
      className: "recharts-reference-area-rect"
    }));
  }
  return rect;
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/CartesianAxis.js
var import_isFunction18 = __toESM(require_isFunction());
var import_get5 = __toESM(require_get());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/getTicks.js
var import_isFunction17 = __toESM(require_isFunction());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/getEveryNthWithCondition.js
function getEveryNthWithCondition(array, n, isValid) {
  if (n < 1) {
    return [];
  }
  if (n === 1 && isValid === void 0) {
    return array;
  }
  var result = [];
  for (var i = 0; i < array.length; i += n) {
    {
      result.push(array[i]);
    }
  }
  return result;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/TickUtils.js
function getAngledTickWidth(contentSize, unitSize, angle) {
  var size = {
    width: contentSize.width + unitSize.width,
    height: contentSize.height + unitSize.height
  };
  return getAngledRectangleWidth(size, angle);
}
function getTickBoundaries(viewBox, sign2, sizeKey) {
  var isWidth = sizeKey === "width";
  var x2 = viewBox.x, y2 = viewBox.y, width2 = viewBox.width, height2 = viewBox.height;
  if (sign2 === 1) {
    return {
      start: isWidth ? x2 : y2,
      end: isWidth ? x2 + width2 : y2 + height2
    };
  }
  return {
    start: isWidth ? x2 + width2 : y2 + height2,
    end: isWidth ? x2 : y2
  };
}
function isVisible(sign2, tickPosition, getSize5, start, end) {
  if (sign2 * tickPosition < sign2 * start || sign2 * tickPosition > sign2 * end) {
    return false;
  }
  var size = getSize5();
  return sign2 * (tickPosition - sign2 * size / 2 - start) >= 0 && sign2 * (tickPosition + sign2 * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks2, interval) {
  return getEveryNthWithCondition(ticks2, interval + 1);
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/getEquidistantTicks.js
function getEquidistantTicks(sign2, boundaries, getTickSize, ticks2, minTickGap) {
  var result = (ticks2 || []).slice();
  var initialStart = boundaries.start, end = boundaries.end;
  var index2 = 0;
  var stepsize = 1;
  var start = initialStart;
  var _loop = function _loop2() {
    var entry = ticks2 === null || ticks2 === void 0 ? void 0 : ticks2[index2];
    if (entry === void 0) {
      return {
        v: getEveryNthWithCondition(ticks2, stepsize)
      };
    }
    var i = index2;
    var size;
    var getSize5 = function getSize6() {
      if (size === void 0) {
        size = getTickSize(entry, i);
      }
      return size;
    };
    var tickCoord = entry.coordinate;
    var isShow = index2 === 0 || isVisible(sign2, tickCoord, getSize5, start, end);
    if (!isShow) {
      index2 = 0;
      start = initialStart;
      stepsize += 1;
    }
    if (isShow) {
      start = tickCoord + sign2 * (getSize5() / 2 + minTickGap);
      index2 += stepsize;
    }
  }, _ret;
  while (stepsize <= result.length) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return [];
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/getTicks.js
function _typeof42(o) {
  "@babel/helpers - typeof";
  return _typeof42 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof42(o);
}
function ownKeys36(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread36(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys36(Object(t), true).forEach(function(r3) {
      _defineProperty38(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys36(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty38(obj, key2, value2) {
  key2 = _toPropertyKey39(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey39(t) {
  var i = _toPrimitive39(t, "string");
  return "symbol" == _typeof42(i) ? i : i + "";
}
function _toPrimitive39(t, r2) {
  if ("object" != _typeof42(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof42(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function getTicksEnd(sign2, boundaries, getTickSize, ticks2, minTickGap) {
  var result = (ticks2 || []).slice();
  var len = result.length;
  var start = boundaries.start;
  var end = boundaries.end;
  var _loop = function _loop2(i2) {
    var entry = result[i2];
    var size;
    var getSize5 = function getSize6() {
      if (size === void 0) {
        size = getTickSize(entry, i2);
      }
      return size;
    };
    if (i2 === len - 1) {
      var gap = sign2 * (entry.coordinate + sign2 * getSize5() / 2 - end);
      result[i2] = entry = _objectSpread36(_objectSpread36({}, entry), {}, {
        tickCoord: gap > 0 ? entry.coordinate - gap * sign2 : entry.coordinate
      });
    } else {
      result[i2] = entry = _objectSpread36(_objectSpread36({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = isVisible(sign2, entry.tickCoord, getSize5, start, end);
    if (isShow) {
      end = entry.tickCoord - sign2 * (getSize5() / 2 + minTickGap);
      result[i2] = _objectSpread36(_objectSpread36({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i = len - 1; i >= 0; i--) {
    _loop(i);
  }
  return result;
}
function getTicksStart(sign2, boundaries, getTickSize, ticks2, minTickGap, preserveEnd) {
  var result = (ticks2 || []).slice();
  var len = result.length;
  var start = boundaries.start, end = boundaries.end;
  if (preserveEnd) {
    var tail = ticks2[len - 1];
    var tailSize = getTickSize(tail, len - 1);
    var tailGap = sign2 * (tail.coordinate + sign2 * tailSize / 2 - end);
    result[len - 1] = tail = _objectSpread36(_objectSpread36({}, tail), {}, {
      tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign2 : tail.coordinate
    });
    var isTailShow = isVisible(sign2, tail.tickCoord, function() {
      return tailSize;
    }, start, end);
    if (isTailShow) {
      end = tail.tickCoord - sign2 * (tailSize / 2 + minTickGap);
      result[len - 1] = _objectSpread36(_objectSpread36({}, tail), {}, {
        isShow: true
      });
    }
  }
  var count = preserveEnd ? len - 1 : len;
  var _loop2 = function _loop22(i2) {
    var entry = result[i2];
    var size;
    var getSize5 = function getSize6() {
      if (size === void 0) {
        size = getTickSize(entry, i2);
      }
      return size;
    };
    if (i2 === 0) {
      var gap = sign2 * (entry.coordinate - sign2 * getSize5() / 2 - start);
      result[i2] = entry = _objectSpread36(_objectSpread36({}, entry), {}, {
        tickCoord: gap < 0 ? entry.coordinate - gap * sign2 : entry.coordinate
      });
    } else {
      result[i2] = entry = _objectSpread36(_objectSpread36({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = isVisible(sign2, entry.tickCoord, getSize5, start, end);
    if (isShow) {
      start = entry.tickCoord + sign2 * (getSize5() / 2 + minTickGap);
      result[i2] = _objectSpread36(_objectSpread36({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i = 0; i < count; i++) {
    _loop2(i);
  }
  return result;
}
function getTicks(props, fontSize, letterSpacing) {
  var tick = props.tick, ticks2 = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit2 = props.unit, angle = props.angle;
  if (!ticks2 || !ticks2.length || !tick) {
    return [];
  }
  if (isNumber(interval) || Global.isSsr) {
    return getNumberIntervalTicks(ticks2, typeof interval === "number" && isNumber(interval) ? interval : 0);
  }
  var candidates = [];
  var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
  var unitSize = unit2 && sizeKey === "width" ? getStringSize(unit2, {
    fontSize,
    letterSpacing
  }) : {
    width: 0,
    height: 0
  };
  var getTickSize = function getTickSize2(content2, index2) {
    var value2 = (0, import_isFunction17.default)(tickFormatter) ? tickFormatter(content2.value, index2) : content2.value;
    return sizeKey === "width" ? getAngledTickWidth(getStringSize(value2, {
      fontSize,
      letterSpacing
    }), unitSize, angle) : getStringSize(value2, {
      fontSize,
      letterSpacing
    })[sizeKey];
  };
  var sign2 = ticks2.length >= 2 ? mathSign(ticks2[1].coordinate - ticks2[0].coordinate) : 1;
  var boundaries = getTickBoundaries(viewBox, sign2, sizeKey);
  if (interval === "equidistantPreserveStart") {
    return getEquidistantTicks(sign2, boundaries, getTickSize, ticks2, minTickGap);
  }
  if (interval === "preserveStart" || interval === "preserveStartEnd") {
    candidates = getTicksStart(sign2, boundaries, getTickSize, ticks2, minTickGap, interval === "preserveStartEnd");
  } else {
    candidates = getTicksEnd(sign2, boundaries, getTickSize, ticks2, minTickGap);
  }
  return candidates.filter(function(entry) {
    return entry.isShow;
  });
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/CartesianAxis.js
var _excluded19 = ["viewBox"];
var _excluded26 = ["viewBox"];
var _excluded32 = ["ticks"];
function _typeof43(o) {
  "@babel/helpers - typeof";
  return _typeof43 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof43(o);
}
function _extends27() {
  _extends27 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends27.apply(this, arguments);
}
function ownKeys37(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread37(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys37(Object(t), true).forEach(function(r3) {
      _defineProperty39(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys37(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _objectWithoutProperties19(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose19(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose19(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _classCallCheck17(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties17(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey40(descriptor.key), descriptor);
  }
}
function _createClass17(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties17(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties17(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper14(t, o, e) {
  return o = _getPrototypeOf15(o), _possibleConstructorReturn15(t, _isNativeReflectConstruct15() ? Reflect.construct(o, e || [], _getPrototypeOf15(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn15(self2, call) {
  if (call && (_typeof43(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized15(self2);
}
function _assertThisInitialized15(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct15() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct15 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf15(o) {
  _getPrototypeOf15 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf15(o);
}
function _inherits15(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf15(subClass, superClass);
}
function _setPrototypeOf15(o, p) {
  _setPrototypeOf15 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf15(o, p);
}
function _defineProperty39(obj, key2, value2) {
  key2 = _toPropertyKey40(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey40(t) {
  var i = _toPrimitive40(t, "string");
  return "symbol" == _typeof43(i) ? i : i + "";
}
function _toPrimitive40(t, r2) {
  if ("object" != _typeof43(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof43(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var CartesianAxis = /* @__PURE__ */ function(_Component) {
  function CartesianAxis2(props) {
    var _this;
    _classCallCheck17(this, CartesianAxis2);
    _this = _callSuper14(this, CartesianAxis2, [props]);
    _this.state = {
      fontSize: "",
      letterSpacing: ""
    };
    return _this;
  }
  _inherits15(CartesianAxis2, _Component);
  return _createClass17(CartesianAxis2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, nextState) {
      var viewBox = _ref.viewBox, restProps = _objectWithoutProperties19(_ref, _excluded19);
      var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties19(_this$props, _excluded26);
      return !shallowEqual(viewBox, viewBoxOld) || !shallowEqual(restProps, restPropsOld) || !shallowEqual(nextState, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var htmlLayer = this.layerReference;
      if (!htmlLayer) return;
      var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
      if (tick) {
        this.setState({
          fontSize: window.getComputedStyle(tick).fontSize,
          letterSpacing: window.getComputedStyle(tick).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data2) {
      var _this$props2 = this.props, x2 = _this$props2.x, y2 = _this$props2.y, width2 = _this$props2.width, height2 = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
      var x1, x22, y1, y22, tx, ty;
      var sign2 = mirror ? -1 : 1;
      var finalTickSize = data2.tickSize || tickSize;
      var tickCoord = isNumber(data2.tickCoord) ? data2.tickCoord : data2.coordinate;
      switch (orientation) {
        case "top":
          x1 = x22 = data2.coordinate;
          y22 = y2 + +!mirror * height2;
          y1 = y22 - sign2 * finalTickSize;
          ty = y1 - sign2 * tickMargin;
          tx = tickCoord;
          break;
        case "left":
          y1 = y22 = data2.coordinate;
          x22 = x2 + +!mirror * width2;
          x1 = x22 - sign2 * finalTickSize;
          tx = x1 - sign2 * tickMargin;
          ty = tickCoord;
          break;
        case "right":
          y1 = y22 = data2.coordinate;
          x22 = x2 + +mirror * width2;
          x1 = x22 + sign2 * finalTickSize;
          tx = x1 + sign2 * tickMargin;
          ty = tickCoord;
          break;
        default:
          x1 = x22 = data2.coordinate;
          y22 = y2 + +mirror * height2;
          y1 = y22 + sign2 * finalTickSize;
          ty = y1 + sign2 * tickMargin;
          tx = tickCoord;
          break;
      }
      return {
        line: {
          x1,
          y1,
          x2: x22,
          y2: y22
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
      var textAnchor;
      switch (orientation) {
        case "left":
          textAnchor = mirror ? "start" : "end";
          break;
        case "right":
          textAnchor = mirror ? "end" : "start";
          break;
        default:
          textAnchor = "middle";
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
      var verticalAnchor = "end";
      switch (orientation) {
        case "left":
        case "right":
          verticalAnchor = "middle";
          break;
        case "top":
          verticalAnchor = mirror ? "start" : "end";
          break;
        default:
          verticalAnchor = mirror ? "end" : "start";
          break;
      }
      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props, x2 = _this$props5.x, y2 = _this$props5.y, width2 = _this$props5.width, height2 = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
      var props = _objectSpread37(_objectSpread37(_objectSpread37({}, filterProps(this.props, false)), filterProps(axisLine, false)), {}, {
        fill: "none"
      });
      if (orientation === "top" || orientation === "bottom") {
        var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
        props = _objectSpread37(_objectSpread37({}, props), {}, {
          x1: x2,
          y1: y2 + needHeight * height2,
          x2: x2 + width2,
          y2: y2 + needHeight * height2
        });
      } else {
        var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
        props = _objectSpread37(_objectSpread37({}, props), {}, {
          x1: x2 + needWidth * width2,
          y1: y2,
          x2: x2 + needWidth * width2,
          y2: y2 + height2
        });
      }
      return /* @__PURE__ */ React43.createElement("line", _extends27({}, props, {
        className: clsx_default("recharts-cartesian-axis-line", (0, import_get5.default)(axisLine, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function renderTicks(ticks2, fontSize, letterSpacing) {
        var _this2 = this;
        var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit2 = _this$props6.unit;
        var finalTicks = getTicks(_objectSpread37(_objectSpread37({}, this.props), {}, {
          ticks: ticks2
        }), fontSize, letterSpacing);
        var textAnchor = this.getTickTextAnchor();
        var verticalAnchor = this.getTickVerticalAnchor();
        var axisProps = filterProps(this.props, false);
        var customTickProps = filterProps(tick, false);
        var tickLineProps = _objectSpread37(_objectSpread37({}, axisProps), {}, {
          fill: "none"
        }, filterProps(tickLine, false));
        var items = finalTicks.map(function(entry, i) {
          var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
          var tickProps = _objectSpread37(_objectSpread37(_objectSpread37(_objectSpread37({
            textAnchor,
            verticalAnchor
          }, axisProps), {}, {
            stroke: "none",
            fill: stroke
          }, customTickProps), tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter
          });
          return /* @__PURE__ */ React43.createElement(Layer, _extends27({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
          }, adaptEventsOfChild(_this2.props, entry, i)), tickLine && /* @__PURE__ */ React43.createElement("line", _extends27({}, tickLineProps, lineCoord, {
            className: clsx_default("recharts-cartesian-axis-tick-line", (0, import_get5.default)(tickLine, "className"))
          })), tick && CartesianAxis2.renderTickItem(tick, tickProps, "".concat((0, import_isFunction18.default)(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit2 || "")));
        });
        return /* @__PURE__ */ React43.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, items);
      }
    )
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props7 = this.props, axisLine = _this$props7.axisLine, width2 = _this$props7.width, height2 = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
      if (hide) {
        return null;
      }
      var _this$props8 = this.props, ticks2 = _this$props8.ticks, noTicksProps = _objectWithoutProperties19(_this$props8, _excluded32);
      var finalTicks = ticks2;
      if ((0, import_isFunction18.default)(ticksGenerator)) {
        finalTicks = ticks2 && ticks2.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }
      if (width2 <= 0 || height2 <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: clsx_default("recharts-cartesian-axis", className),
        ref: function ref(_ref2) {
          _this3.layerReference = _ref2;
        }
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), Label.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value2) {
      var tickItem;
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React43.cloneElement(option, props);
      } else if ((0, import_isFunction18.default)(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React43.createElement(Text, _extends27({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value2);
      }
      return tickItem;
    }
  }]);
}(Component);
_defineProperty39(CartesianAxis, "displayName", "CartesianAxis");
_defineProperty39(CartesianAxis, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/cartesian/CartesianGrid.js
var import_isFunction19 = __toESM(require_isFunction());
var _excluded20 = ["x1", "y1", "x2", "y2", "key"];
var _excluded27 = ["offset"];
function _typeof44(o) {
  "@babel/helpers - typeof";
  return _typeof44 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof44(o);
}
function ownKeys38(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread38(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys38(Object(t), true).forEach(function(r3) {
      _defineProperty40(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys38(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty40(obj, key2, value2) {
  key2 = _toPropertyKey41(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey41(t) {
  var i = _toPrimitive41(t, "string");
  return "symbol" == _typeof44(i) ? i : i + "";
}
function _toPrimitive41(t, r2) {
  if ("object" != _typeof44(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof44(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _extends28() {
  _extends28 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends28.apply(this, arguments);
}
function _objectWithoutProperties20(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose20(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose20(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var Background = function Background2(props) {
  var fill = props.fill;
  if (!fill || fill === "none") {
    return null;
  }
  var fillOpacity = props.fillOpacity, x2 = props.x, y2 = props.y, width2 = props.width, height2 = props.height, ry = props.ry;
  return /* @__PURE__ */ React43.createElement("rect", {
    x: x2,
    y: y2,
    ry,
    width: width2,
    height: height2,
    stroke: "none",
    fill,
    fillOpacity,
    className: "recharts-cartesian-grid-bg"
  });
};
function renderLineItem(option, props) {
  var lineItem;
  if (/* @__PURE__ */ React43.isValidElement(option)) {
    lineItem = /* @__PURE__ */ React43.cloneElement(option, props);
  } else if ((0, import_isFunction19.default)(option)) {
    lineItem = option(props);
  } else {
    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key2 = props.key, others = _objectWithoutProperties20(props, _excluded20);
    var _filterProps = filterProps(others, false); _filterProps.offset; var restOfFilteredProps = _objectWithoutProperties20(_filterProps, _excluded27);
    lineItem = /* @__PURE__ */ React43.createElement("line", _extends28({}, restOfFilteredProps, {
      x1,
      y1,
      x2,
      y2,
      fill: "none",
      key: key2
    }));
  }
  return lineItem;
}
function HorizontalGridLines(props) {
  var x2 = props.x, width2 = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
  if (!horizontal || !horizontalPoints || !horizontalPoints.length) {
    return null;
  }
  var items = horizontalPoints.map(function(entry, i) {
    var lineItemProps = _objectSpread38(_objectSpread38({}, props), {}, {
      x1: x2,
      y1: entry,
      x2: x2 + width2,
      y2: entry,
      key: "line-".concat(i),
      index: i
    });
    return renderLineItem(horizontal, lineItemProps);
  });
  return /* @__PURE__ */ React43.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, items);
}
function VerticalGridLines(props) {
  var y2 = props.y, height2 = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
  if (!vertical || !verticalPoints || !verticalPoints.length) {
    return null;
  }
  var items = verticalPoints.map(function(entry, i) {
    var lineItemProps = _objectSpread38(_objectSpread38({}, props), {}, {
      x1: entry,
      y1: y2,
      x2: entry,
      y2: y2 + height2,
      key: "line-".concat(i),
      index: i
    });
    return renderLineItem(vertical, lineItemProps);
  });
  return /* @__PURE__ */ React43.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, items);
}
function HorizontalStripes(props) {
  var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x2 = props.x, y2 = props.y, width2 = props.width, height2 = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
  if (!horizontal || !horizontalFill || !horizontalFill.length) {
    return null;
  }
  var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
    return Math.round(e + y2 - y2);
  }).sort(function(a2, b) {
    return a2 - b;
  });
  if (y2 !== roundedSortedHorizontalPoints[0]) {
    roundedSortedHorizontalPoints.unshift(0);
  }
  var items = roundedSortedHorizontalPoints.map(function(entry, i) {
    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
    var lineHeight = lastStripe ? y2 + height2 - entry : roundedSortedHorizontalPoints[i + 1] - entry;
    if (lineHeight <= 0) {
      return null;
    }
    var colorIndex = i % horizontalFill.length;
    return /* @__PURE__ */ React43.createElement("rect", {
      key: "react-".concat(i),
      y: entry,
      x: x2,
      height: lineHeight,
      width: width2,
      stroke: "none",
      fill: horizontalFill[colorIndex],
      fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React43.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, items);
}
function VerticalStripes(props) {
  var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x2 = props.x, y2 = props.y, width2 = props.width, height2 = props.height, verticalPoints = props.verticalPoints;
  if (!vertical || !verticalFill || !verticalFill.length) {
    return null;
  }
  var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
    return Math.round(e + x2 - x2);
  }).sort(function(a2, b) {
    return a2 - b;
  });
  if (x2 !== roundedSortedVerticalPoints[0]) {
    roundedSortedVerticalPoints.unshift(0);
  }
  var items = roundedSortedVerticalPoints.map(function(entry, i) {
    var lastStripe = !roundedSortedVerticalPoints[i + 1];
    var lineWidth = lastStripe ? x2 + width2 - entry : roundedSortedVerticalPoints[i + 1] - entry;
    if (lineWidth <= 0) {
      return null;
    }
    var colorIndex = i % verticalFill.length;
    return /* @__PURE__ */ React43.createElement("rect", {
      key: "react-".concat(i),
      x: entry,
      y: y2,
      width: lineWidth,
      height: height2,
      stroke: "none",
      fill: verticalFill[colorIndex],
      fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React43.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator2(_ref, syncWithTicks) {
  var xAxis = _ref.xAxis, width2 = _ref.width, height2 = _ref.height, offset = _ref.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread38(_objectSpread38(_objectSpread38({}, CartesianAxis.defaultProps), xAxis), {}, {
    ticks: getTicksOfAxis(xAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width: width2,
      height: height2
    }
  })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator2(_ref2, syncWithTicks) {
  var yAxis = _ref2.yAxis, width2 = _ref2.width, height2 = _ref2.height, offset = _ref2.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread38(_objectSpread38(_objectSpread38({}, CartesianAxis.defaultProps), yAxis), {}, {
    ticks: getTicksOfAxis(yAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width: width2,
      height: height2
    }
  })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultProps20 = {
  horizontal: true,
  vertical: true,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function CartesianGrid(props) {
  var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
  var chartWidth = useChartWidth();
  var chartHeight = useChartHeight();
  var offset = useOffset();
  var propsIncludingDefaults = _objectSpread38(_objectSpread38({}, props), {}, {
    stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps20.stroke,
    fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps20.fill,
    horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps20.horizontal,
    horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps20.horizontalFill,
    vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps20.vertical,
    verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps20.verticalFill,
    x: isNumber(props.x) ? props.x : offset.left,
    y: isNumber(props.y) ? props.y : offset.top,
    width: isNumber(props.width) ? props.width : offset.width,
    height: isNumber(props.height) ? props.height : offset.height
  });
  var x2 = propsIncludingDefaults.x, y2 = propsIncludingDefaults.y, width2 = propsIncludingDefaults.width, height2 = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
  var xAxis = useArbitraryXAxis();
  var yAxis = useYAxisWithFiniteDomainOrRandom();
  if (!isNumber(width2) || width2 <= 0 || !isNumber(height2) || height2 <= 0 || !isNumber(x2) || x2 !== +x2 || !isNumber(y2) || y2 !== +y2) {
    return null;
  }
  var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
  var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
  var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
  if ((!horizontalPoints || !horizontalPoints.length) && (0, import_isFunction19.default)(horizontalCoordinatesGenerator)) {
    var isHorizontalValues = horizontalValues && horizontalValues.length;
    var generatorResult = horizontalCoordinatesGenerator({
      yAxis: yAxis ? _objectSpread38(_objectSpread38({}, yAxis), {}, {
        ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
      }) : void 0,
      width: chartWidth,
      height: chartHeight,
      offset
    }, isHorizontalValues ? true : syncWithTicks);
    warn(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof44(generatorResult), "]"));
    if (Array.isArray(generatorResult)) {
      horizontalPoints = generatorResult;
    }
  }
  if ((!verticalPoints || !verticalPoints.length) && (0, import_isFunction19.default)(verticalCoordinatesGenerator)) {
    var isVerticalValues = verticalValues && verticalValues.length;
    var _generatorResult = verticalCoordinatesGenerator({
      xAxis: xAxis ? _objectSpread38(_objectSpread38({}, xAxis), {}, {
        ticks: isVerticalValues ? verticalValues : xAxis.ticks
      }) : void 0,
      width: chartWidth,
      height: chartHeight,
      offset
    }, isVerticalValues ? true : syncWithTicks);
    warn(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof44(_generatorResult), "]"));
    if (Array.isArray(_generatorResult)) {
      verticalPoints = _generatorResult;
    }
  }
  return /* @__PURE__ */ React43.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ React43.createElement(Background, {
    fill: propsIncludingDefaults.fill,
    fillOpacity: propsIncludingDefaults.fillOpacity,
    x: propsIncludingDefaults.x,
    y: propsIncludingDefaults.y,
    width: propsIncludingDefaults.width,
    height: propsIncludingDefaults.height,
    ry: propsIncludingDefaults.ry
  }), /* @__PURE__ */ React43.createElement(HorizontalGridLines, _extends28({}, propsIncludingDefaults, {
    offset,
    horizontalPoints,
    xAxis,
    yAxis
  })), /* @__PURE__ */ React43.createElement(VerticalGridLines, _extends28({}, propsIncludingDefaults, {
    offset,
    verticalPoints,
    xAxis,
    yAxis
  })), /* @__PURE__ */ React43.createElement(HorizontalStripes, _extends28({}, propsIncludingDefaults, {
    horizontalPoints
  })), /* @__PURE__ */ React43.createElement(VerticalStripes, _extends28({}, propsIncludingDefaults, {
    verticalPoints
  })));
}
CartesianGrid.displayName = "CartesianGrid";
var import_isFunction20 = __toESM(require_isFunction());
var import_isNil10 = __toESM(require_isNil());
var import_isEqual5 = __toESM(require_isEqual());
var _excluded21 = ["type", "layout", "connectNulls", "ref"];
var _excluded28 = ["key"];
function _typeof45(o) {
  "@babel/helpers - typeof";
  return _typeof45 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof45(o);
}
function _objectWithoutProperties21(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose21(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose21(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _extends29() {
  _extends29 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends29.apply(this, arguments);
}
function ownKeys39(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread39(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys39(Object(t), true).forEach(function(r3) {
      _defineProperty41(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys39(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _toConsumableArray10(arr) {
  return _arrayWithoutHoles10(arr) || _iterableToArray11(arr) || _unsupportedIterableToArray21(arr) || _nonIterableSpread10();
}
function _nonIterableSpread10() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray21(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray21(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray21(o, minLen);
}
function _iterableToArray11(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles10(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray21(arr);
}
function _arrayLikeToArray21(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck18(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties18(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey42(descriptor.key), descriptor);
  }
}
function _createClass18(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties18(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties18(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper15(t, o, e) {
  return o = _getPrototypeOf16(o), _possibleConstructorReturn16(t, _isNativeReflectConstruct16() ? Reflect.construct(o, e || [], _getPrototypeOf16(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn16(self2, call) {
  if (call && (_typeof45(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized16(self2);
}
function _assertThisInitialized16(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct16() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct16 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf16(o) {
  _getPrototypeOf16 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf16(o);
}
function _inherits16(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf16(subClass, superClass);
}
function _setPrototypeOf16(o, p) {
  _setPrototypeOf16 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf16(o, p);
}
function _defineProperty41(obj, key2, value2) {
  key2 = _toPropertyKey42(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey42(t) {
  var i = _toPrimitive42(t, "string");
  return "symbol" == _typeof45(i) ? i : i + "";
}
function _toPrimitive42(t, r2) {
  if ("object" != _typeof45(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof45(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var Line = /* @__PURE__ */ function(_PureComponent) {
  function Line2() {
    var _this;
    _classCallCheck18(this, Line2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper15(this, Line2, [].concat(args));
    _defineProperty41(_this, "state", {
      isAnimationFinished: true,
      totalLength: 0
    });
    _defineProperty41(_this, "generateSimpleStrokeDasharray", function(totalLength, length2) {
      return "".concat(length2, "px ").concat(totalLength - length2, "px");
    });
    _defineProperty41(_this, "getStrokeDasharray", function(length2, totalLength, lines) {
      var lineLength = lines.reduce(function(pre, next) {
        return pre + next;
      });
      if (!lineLength) {
        return _this.generateSimpleStrokeDasharray(totalLength, length2);
      }
      var count = Math.floor(length2 / lineLength);
      var remainLength = length2 % lineLength;
      var restLength = totalLength - length2;
      var remainLines = [];
      for (var i = 0, sum2 = 0; i < lines.length; sum2 += lines[i], ++i) {
        if (sum2 + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray10(lines.slice(0, i)), [remainLength - sum2]);
          break;
        }
      }
      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray10(Line2.repeat(lines, count)), _toConsumableArray10(remainLines), emptyLines).map(function(line) {
        return "".concat(line, "px");
      }).join(", ");
    });
    _defineProperty41(_this, "id", uniqueId("recharts-line-"));
    _defineProperty41(_this, "pathRef", function(node) {
      _this.mainCurve = node;
    });
    _defineProperty41(_this, "handleAnimationEnd", function() {
      _this.setState({
        isAnimationFinished: true
      });
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd();
      }
    });
    _defineProperty41(_this, "handleAnimationStart", function() {
      _this.setState({
        isAnimationFinished: false
      });
      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    });
    return _this;
  }
  _inherits16(Line2, _PureComponent);
  return _createClass18(Line2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      this.setState({
        totalLength
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      if (totalLength !== this.state.totalLength) {
        this.setState({
          totalLength
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;
      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
      var errorBarItems = findAllByType(children, ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var dataPointFormatter = function dataPointFormatter2(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: getValueByDataKey(dataPoint.payload, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React43.createElement(Layer, errorBarProps, errorBarItems.map(function(item) {
        return /* @__PURE__ */ React43.cloneElement(item, {
          key: "bar-".concat(item.props.dataKey),
          data: points,
          xAxis,
          yAxis,
          layout,
          dataPointFormatter
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
      var lineProps = filterProps(this.props, false);
      var customDotProps = filterProps(dot, true);
      var dots = points.map(function(entry, i) {
        var dotProps = _objectSpread39(_objectSpread39(_objectSpread39({
          key: "dot-".concat(i),
          r: 3
        }, lineProps), customDotProps), {}, {
          value: entry.value,
          dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry.payload
        });
        return Line2.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React43.createElement(Layer, _extends29({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls; _this$props3.ref; var others = _objectWithoutProperties21(_this$props3, _excluded21);
      var curveProps = _objectSpread39(_objectSpread39(_objectSpread39({}, filterProps(others, true)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points
      }, props), {}, {
        type,
        layout,
        connectNulls
      });
      return /* @__PURE__ */ React43.createElement(Curve, _extends29({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width2 = _this$props4.width, height2 = _this$props4.height;
      var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
      return /* @__PURE__ */ React43.createElement(es6_default, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function(entry, index2) {
            var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = interpolateNumber(prev.x, entry.x);
              var interpolatorY = interpolateNumber(prev.y, entry.y);
              return _objectSpread39(_objectSpread39({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }
            if (animateNewValues) {
              var _interpolatorX = interpolateNumber(width2 * 2, entry.x);
              var _interpolatorY = interpolateNumber(height2 / 2, entry.y);
              return _objectSpread39(_objectSpread39({}, entry), {}, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }
            return _objectSpread39(_objectSpread39({}, entry), {}, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this2.renderCurveStatically(stepData, needClip, clipPathId);
        }
        var interpolator = interpolateNumber(0, totalLength);
        var curLength = interpolator(t);
        var currentStrokeDasharray;
        if (strokeDasharray) {
          var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
        }
        return _this2.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
      var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, import_isEqual5.default)(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }
      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width2 = _this$props6.width, height2 = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = clsx_default("recharts-line", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, import_isNil10.default)(id) ? this.id : id;
      var _ref2 = (_filterProps = filterProps(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
        r: 3,
        strokeWidth: 2
      }, _ref2$r = _ref2.r, r2 = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = hasClipDot(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r2 * 2 + strokeWidth;
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React43.createElement("rect", {
        x: needClipX ? left : left - width2 / 2,
        y: needClipY ? top : top - height2 / 2,
        width: needClipX ? width2 : width2 * 2,
        height: needClipY ? height2 : height2 * 2
      })), !clipDot && /* @__PURE__ */ React43.createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /* @__PURE__ */ React43.createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width2 + dotSize,
        height: height2 + dotSize
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }
      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }
      return null;
    }
  }, {
    key: "repeat",
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray10(lines), [0]) : lines;
      var result = [];
      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray10(result), _toConsumableArray10(linesUnit));
      }
      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;
      if (/* @__PURE__ */ React43.isValidElement(option)) {
        dotItem = /* @__PURE__ */ React43.cloneElement(option, props);
      } else if ((0, import_isFunction20.default)(option)) {
        dotItem = option(props);
      } else {
        var key2 = props.key, dotProps = _objectWithoutProperties21(props, _excluded28);
        var className = clsx_default("recharts-line-dot", typeof option !== "boolean" ? option.className : "");
        dotItem = /* @__PURE__ */ React43.createElement(Dot, _extends29({
          key: key2
        }, dotProps, {
          className
        }));
      }
      return dotItem;
    }
  }]);
}(PureComponent);
_defineProperty41(Line, "displayName", "Line");
_defineProperty41(Line, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Global.isSsr,
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: false,
  label: false
});
_defineProperty41(Line, "getComposedData", function(_ref4) {
  var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
  var layout = props.layout;
  var points = displayedData.map(function(entry, index2) {
    var value2 = getValueByDataKey(entry, dataKey);
    if (layout === "horizontal") {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize,
          entry,
          index: index2
        }),
        y: (0, import_isNil10.default)(value2) ? null : yAxis.scale(value2),
        value: value2,
        payload: entry
      };
    }
    return {
      x: (0, import_isNil10.default)(value2) ? null : xAxis.scale(value2),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        entry,
        index: index2
      }),
      value: value2,
      payload: entry
    };
  });
  return _objectSpread39({
    points,
    layout
  }, offset);
});
var import_isFunction21 = __toESM(require_isFunction());
var import_max3 = __toESM(require_max());
var import_isNil11 = __toESM(require_isNil());
var import_isNaN3 = __toESM(require_isNaN());
var import_isEqual6 = __toESM(require_isEqual());
var _excluded29 = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"];
var _excluded210 = ["key"];
var _Area;
function _typeof46(o) {
  "@babel/helpers - typeof";
  return _typeof46 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof46(o);
}
function _objectWithoutProperties22(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose22(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose22(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _extends30() {
  _extends30 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends30.apply(this, arguments);
}
function ownKeys40(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread40(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys40(Object(t), true).forEach(function(r3) {
      _defineProperty42(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys40(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _classCallCheck19(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties19(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey43(descriptor.key), descriptor);
  }
}
function _createClass19(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties19(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties19(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper16(t, o, e) {
  return o = _getPrototypeOf17(o), _possibleConstructorReturn17(t, _isNativeReflectConstruct17() ? Reflect.construct(o, e || [], _getPrototypeOf17(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn17(self2, call) {
  if (call && (_typeof46(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized17(self2);
}
function _assertThisInitialized17(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct17() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct17 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf17(o) {
  _getPrototypeOf17 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf17(o);
}
function _inherits17(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf17(subClass, superClass);
}
function _setPrototypeOf17(o, p) {
  _setPrototypeOf17 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf17(o, p);
}
function _defineProperty42(obj, key2, value2) {
  key2 = _toPropertyKey43(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey43(t) {
  var i = _toPrimitive43(t, "string");
  return "symbol" == _typeof46(i) ? i : i + "";
}
function _toPrimitive43(t, r2) {
  if ("object" != _typeof46(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof46(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var Area = /* @__PURE__ */ function(_PureComponent) {
  function Area2() {
    var _this;
    _classCallCheck19(this, Area2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper16(this, Area2, [].concat(args));
    _defineProperty42(_this, "state", {
      isAnimationFinished: true
    });
    _defineProperty42(_this, "id", uniqueId("recharts-area-"));
    _defineProperty42(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, import_isFunction21.default)(onAnimationEnd2)) {
        onAnimationEnd2();
      }
    });
    _defineProperty42(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, import_isFunction21.default)(onAnimationStart2)) {
        onAnimationStart2();
      }
    });
    return _this;
  }
  _inherits17(Area2, _PureComponent);
  return _createClass19(Area2, [{
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
      var areaProps = filterProps(this.props, false);
      var customDotProps = filterProps(dot, true);
      var dots = points.map(function(entry, i) {
        var dotProps = _objectSpread40(_objectSpread40(_objectSpread40({
          key: "dot-".concat(i),
          r: 3
        }, areaProps), customDotProps), {}, {
          index: i,
          cx: entry.x,
          cy: entry.y,
          dataKey,
          value: entry.value,
          payload: entry.payload,
          points
        });
        return Area2.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React43.createElement(Layer, _extends30({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha3) {
      var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width2 = alpha3 * Math.abs(startX - endX);
      var maxY = (0, import_max3.default)(points.map(function(entry) {
        return entry.y || 0;
      }));
      if (isNumber(baseLine) && typeof baseLine === "number") {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxY = Math.max((0, import_max3.default)(baseLine.map(function(entry) {
          return entry.y || 0;
        })), maxY);
      }
      if (isNumber(maxY)) {
        return /* @__PURE__ */ React43.createElement("rect", {
          x: startX < endX ? startX : startX - width2,
          y: 0,
          width: width2,
          height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
        });
      }
      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha3) {
      var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height2 = alpha3 * Math.abs(startY - endY);
      var maxX = (0, import_max3.default)(points.map(function(entry) {
        return entry.x || 0;
      }));
      if (isNumber(baseLine) && typeof baseLine === "number") {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxX = Math.max((0, import_max3.default)(baseLine.map(function(entry) {
          return entry.x || 0;
        })), maxX);
      }
      if (isNumber(maxX)) {
        return /* @__PURE__ */ React43.createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height2,
          width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
          height: Math.floor(height2)
        });
      }
      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha3) {
      var layout = this.props.layout;
      if (layout === "vertical") {
        return this.renderVerticalRect(alpha3);
      }
      return this.renderHorizontalRect(alpha3);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange; _this$props4.ref; var others = _objectWithoutProperties22(_this$props4, _excluded29);
      return /* @__PURE__ */ React43.createElement(Layer, {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, /* @__PURE__ */ React43.createElement(Curve, _extends30({}, filterProps(others, true), {
        points,
        connectNulls,
        type,
        baseLine,
        layout,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== "none" && /* @__PURE__ */ React43.createElement(Curve, _extends30({}, filterProps(this.props, false), {
        className: "recharts-area-curve",
        layout,
        type,
        connectNulls,
        fill: "none",
        points
      })), stroke !== "none" && isRange && /* @__PURE__ */ React43.createElement(Curve, _extends30({}, filterProps(this.props, false), {
        className: "recharts-area-curve",
        layout,
        type,
        connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
      var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
      return /* @__PURE__ */ React43.createElement(es6_default, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepPoints = points.map(function(entry, index2) {
            var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = interpolateNumber(prev.x, entry.x);
              var interpolatorY = interpolateNumber(prev.y, entry.y);
              return _objectSpread40(_objectSpread40({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }
            return entry;
          });
          var stepBaseLine;
          if (isNumber(baseLine) && typeof baseLine === "number") {
            var interpolator = interpolateNumber(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t);
          } else if ((0, import_isNil11.default)(baseLine) || (0, import_isNaN3.default)(baseLine)) {
            var _interpolator = interpolateNumber(prevBaseLine, 0);
            stepBaseLine = _interpolator(t);
          } else {
            stepBaseLine = baseLine.map(function(entry, index2) {
              var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = interpolateNumber(prev.x, entry.x);
                var interpolatorY = interpolateNumber(prev.y, entry.y);
                return _objectSpread40(_objectSpread40({}, entry), {}, {
                  x: interpolatorX(t),
                  y: interpolatorY(t)
                });
              }
              return entry;
            });
          }
          return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }
        return /* @__PURE__ */ React43.createElement(Layer, null, /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this2.renderClipRect(t))), /* @__PURE__ */ React43.createElement(Layer, {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, import_isEqual6.default)(prevPoints, points) || !(0, import_isEqual6.default)(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }
      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width2 = _this$props7.width, height2 = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = clsx_default("recharts-area", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, import_isNil11.default)(id) ? this.id : id;
      var _ref2 = (_filterProps = filterProps(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
        r: 3,
        strokeWidth: 2
      }, _ref2$r = _ref2.r, r2 = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = hasClipDot(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r2 * 2 + strokeWidth;
      return /* @__PURE__ */ React43.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React43.createElement("rect", {
        x: needClipX ? left : left - width2 / 2,
        y: needClipY ? top : top - height2 / 2,
        width: needClipX ? width2 : width2 * 2,
        height: needClipY ? height2 : height2 * 2
      })), !clipDot && /* @__PURE__ */ React43.createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /* @__PURE__ */ React43.createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width2 + dotSize,
        height: height2 + dotSize
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine,
          prevPoints: prevState.curPoints,
          prevBaseLine: prevState.curBaseLine
        };
      }
      if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) {
        return {
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_Area = Area;
_defineProperty42(Area, "displayName", "Area");
_defineProperty42(Area, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
_defineProperty42(Area, "getBaseValue", function(props, item, xAxis, yAxis) {
  var layout = props.layout, chartBaseValue = props.baseValue;
  var itemBaseValue = item.props.baseValue;
  var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
  if (isNumber(baseValue) && typeof baseValue === "number") {
    return baseValue;
  }
  var numericAxis = layout === "horizontal" ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === "number") {
    var domainMax = Math.max(domain[0], domain[1]);
    var domainMin = Math.min(domain[0], domain[1]);
    if (baseValue === "dataMin") {
      return domainMin;
    }
    if (baseValue === "dataMax") {
      return domainMax;
    }
    return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
  }
  if (baseValue === "dataMin") {
    return domain[0];
  }
  if (baseValue === "dataMax") {
    return domain[1];
  }
  return domain[0];
});
_defineProperty42(Area, "getComposedData", function(_ref4) {
  var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = _Area.getBaseValue(props, item, xAxis, yAxis);
  var isHorizontalLayout = layout === "horizontal";
  var isRange = false;
  var points = displayedData.map(function(entry, index2) {
    var value2;
    if (hasStack) {
      value2 = stackedData[dataStartIndex + index2];
    } else {
      value2 = getValueByDataKey(entry, dataKey);
      if (!Array.isArray(value2)) {
        value2 = [baseValue, value2];
      } else {
        isRange = true;
      }
    }
    var isBreakPoint = value2[1] == null || hasStack && getValueByDataKey(entry, dataKey) == null;
    if (isHorizontalLayout) {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize,
          entry,
          index: index2
        }),
        y: isBreakPoint ? null : yAxis.scale(value2[1]),
        value: value2,
        payload: entry
      };
    }
    return {
      x: isBreakPoint ? null : xAxis.scale(value2[1]),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        entry,
        index: index2
      }),
      value: value2,
      payload: entry
    };
  });
  var baseLine;
  if (hasStack || isRange) {
    baseLine = points.map(function(entry) {
      var x2 = Array.isArray(entry.value) ? entry.value[0] : null;
      if (isHorizontalLayout) {
        return {
          x: entry.x,
          y: x2 != null && entry.y != null ? yAxis.scale(x2) : null
        };
      }
      return {
        x: x2 != null ? xAxis.scale(x2) : null,
        y: entry.y
      };
    });
  } else {
    baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
  }
  return _objectSpread40({
    points,
    baseLine,
    layout,
    isRange
  }, offset);
});
_defineProperty42(Area, "renderDotItem", function(option, props) {
  var dotItem;
  if (/* @__PURE__ */ React43.isValidElement(option)) {
    dotItem = /* @__PURE__ */ React43.cloneElement(option, props);
  } else if ((0, import_isFunction21.default)(option)) {
    dotItem = option(props);
  } else {
    var className = clsx_default("recharts-area-dot", typeof option !== "boolean" ? option.className : "");
    var key2 = props.key, rest = _objectWithoutProperties22(props, _excluded210);
    dotItem = /* @__PURE__ */ React43.createElement(Dot, _extends30({}, rest, {
      key: key2,
      className
    }));
  }
  return dotItem;
});
function _typeof47(o) {
  "@babel/helpers - typeof";
  return _typeof47 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof47(o);
}
function _classCallCheck20(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties20(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey44(descriptor.key), descriptor);
  }
}
function _createClass20(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties20(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper17(t, o, e) {
  return o = _getPrototypeOf18(o), _possibleConstructorReturn18(t, _isNativeReflectConstruct18() ? Reflect.construct(o, e || [], _getPrototypeOf18(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn18(self2, call) {
  if (call && (_typeof47(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized18(self2);
}
function _assertThisInitialized18(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct18() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct18 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf18(o) {
  _getPrototypeOf18 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf18(o);
}
function _inherits18(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf18(subClass, superClass);
}
function _setPrototypeOf18(o, p) {
  _setPrototypeOf18 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf18(o, p);
}
function _defineProperty43(obj, key2, value2) {
  key2 = _toPropertyKey44(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey44(t) {
  var i = _toPrimitive44(t, "string");
  return "symbol" == _typeof47(i) ? i : i + "";
}
function _toPrimitive44(t, r2) {
  if ("object" != _typeof47(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof47(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _extends31() {
  _extends31 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends31.apply(this, arguments);
}
function XAxisImpl(_ref) {
  var xAxisId = _ref.xAxisId;
  var width2 = useChartWidth();
  var height2 = useChartHeight();
  var axisOptions = useXAxisOrThrow(xAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React43.createElement(CartesianAxis, _extends31({}, axisOptions, {
      className: clsx_default("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width: width2,
        height: height2
      },
      ticksGenerator: function ticksGenerator(axis) {
        return getTicksOfAxis(axis, true);
      }
    }))
  );
}
var XAxis = /* @__PURE__ */ function(_React$Component) {
  function XAxis2() {
    _classCallCheck20(this, XAxis2);
    return _callSuper17(this, XAxis2, arguments);
  }
  _inherits18(XAxis2, _React$Component);
  return _createClass20(XAxis2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React43.createElement(XAxisImpl, this.props);
    }
  }]);
}(React43.Component);
_defineProperty43(XAxis, "displayName", "XAxis");
_defineProperty43(XAxis, "defaultProps", {
  allowDecimals: true,
  hide: false,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: "auto",
  reversed: false,
  allowDuplicatedCategory: true
});
function _typeof48(o) {
  "@babel/helpers - typeof";
  return _typeof48 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof48(o);
}
function _classCallCheck21(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties21(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey45(descriptor.key), descriptor);
  }
}
function _createClass21(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties21(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper18(t, o, e) {
  return o = _getPrototypeOf19(o), _possibleConstructorReturn19(t, _isNativeReflectConstruct19() ? Reflect.construct(o, e || [], _getPrototypeOf19(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn19(self2, call) {
  if (call && (_typeof48(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized19(self2);
}
function _assertThisInitialized19(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct19() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct19 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf19(o) {
  _getPrototypeOf19 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf19(o);
}
function _inherits19(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf19(subClass, superClass);
}
function _setPrototypeOf19(o, p) {
  _setPrototypeOf19 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf19(o, p);
}
function _defineProperty44(obj, key2, value2) {
  key2 = _toPropertyKey45(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey45(t) {
  var i = _toPrimitive45(t, "string");
  return "symbol" == _typeof48(i) ? i : i + "";
}
function _toPrimitive45(t, r2) {
  if ("object" != _typeof48(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof48(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function _extends32() {
  _extends32 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends32.apply(this, arguments);
}
var YAxisImpl = function YAxisImpl2(_ref) {
  var yAxisId = _ref.yAxisId;
  var width2 = useChartWidth();
  var height2 = useChartHeight();
  var axisOptions = useYAxisOrThrow(yAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React43.createElement(CartesianAxis, _extends32({}, axisOptions, {
      className: clsx_default("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width: width2,
        height: height2
      },
      ticksGenerator: function ticksGenerator(axis) {
        return getTicksOfAxis(axis, true);
      }
    }))
  );
};
var YAxis = /* @__PURE__ */ function(_React$Component) {
  function YAxis2() {
    _classCallCheck21(this, YAxis2);
    return _callSuper18(this, YAxis2, arguments);
  }
  _inherits19(YAxis2, _React$Component);
  return _createClass21(YAxis2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React43.createElement(YAxisImpl, this.props);
    }
  }]);
}(React43.Component);
_defineProperty44(YAxis, "displayName", "YAxis");
_defineProperty44(YAxis, "defaultProps", {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: "auto",
  reversed: false
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/generateCategoricalChart.js
var import_isNil12 = __toESM(require_isNil());
var import_isFunction22 = __toESM(require_isFunction());
var import_range3 = __toESM(require_range());
var import_get6 = __toESM(require_get());
var import_sortBy3 = __toESM(require_sortBy());
var import_throttle2 = __toESM(require_throttle());

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/DetectReferenceElementsDomain.js
function _toConsumableArray11(arr) {
  return _arrayWithoutHoles11(arr) || _iterableToArray12(arr) || _unsupportedIterableToArray22(arr) || _nonIterableSpread11();
}
function _nonIterableSpread11() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray22(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray22(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray22(o, minLen);
}
function _iterableToArray12(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles11(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray22(arr);
}
function _arrayLikeToArray22(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain2(children, domain, axisId, axisType, specifiedTicks) {
  var lines = findAllByType(children, ReferenceLine);
  var dots = findAllByType(children, ReferenceDot);
  var elements = [].concat(_toConsumableArray11(lines), _toConsumableArray11(dots));
  var areas = findAllByType(children, ReferenceArea);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;
  if (elements.length) {
    finalDomain = elements.reduce(function(result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[valueKey])) {
        var value2 = el.props[valueKey];
        return [Math.min(result[0], value2), Math.max(result[1], value2)];
      }
      return result;
    }, finalDomain);
  }
  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function(result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[key1]) && isNumber(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }
      return result;
    }, finalDomain);
  }
  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function(result, tick) {
      if (isNumber(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }
      return result;
    }, finalDomain);
  }
  return finalDomain;
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/Events.js
var import_eventemitter3 = __toESM(require_eventemitter3());
var eventCenter = new import_eventemitter3.default();
var SYNC_EVENT = "recharts.syncMouseEvents";

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/AccessibilityManager.js
function _typeof49(o) {
  "@babel/helpers - typeof";
  return _typeof49 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof49(o);
}
function _classCallCheck22(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties22(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey46(descriptor.key), descriptor);
  }
}
function _createClass22(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties22(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty45(obj, key2, value2) {
  key2 = _toPropertyKey46(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey46(t) {
  var i = _toPrimitive46(t, "string");
  return "symbol" == _typeof49(i) ? i : i + "";
}
function _toPrimitive46(t, r2) {
  if ("object" != _typeof49(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof49(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
var AccessibilityManager = /* @__PURE__ */ function() {
  function AccessibilityManager2() {
    _classCallCheck22(this, AccessibilityManager2);
    _defineProperty45(this, "activeIndex", 0);
    _defineProperty45(this, "coordinateList", []);
    _defineProperty45(this, "layout", "horizontal");
  }
  return _createClass22(AccessibilityManager2, [{
    key: "setDetails",
    value: function setDetails(_ref) {
      var _ref2;
      var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
      this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
      this.container = container !== null && container !== void 0 ? container : this.container;
      this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
      this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
      this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
      this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function keyboardEvent(e) {
      if (this.coordinateList.length === 0) {
        return;
      }
      switch (e.key) {
        case "ArrowRight": {
          if (this.layout !== "horizontal") {
            return;
          }
          this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
          this.spoofMouse();
          break;
        }
        case "ArrowLeft": {
          if (this.layout !== "horizontal") {
            return;
          }
          this.activeIndex = Math.max(this.activeIndex - 1, 0);
          this.spoofMouse();
          break;
        }
      }
    }
  }, {
    key: "setIndex",
    value: function setIndex(newIndex) {
      this.activeIndex = newIndex;
    }
  }, {
    key: "spoofMouse",
    value: function spoofMouse() {
      var _window, _window2;
      if (this.layout !== "horizontal") {
        return;
      }
      if (this.coordinateList.length === 0) {
        return;
      }
      var _this$container$getBo = this.container.getBoundingClientRect(), x2 = _this$container$getBo.x, y2 = _this$container$getBo.y, height2 = _this$container$getBo.height;
      var coordinate = this.coordinateList[this.activeIndex].coordinate;
      var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
      var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
      var pageX = x2 + coordinate + scrollOffsetX;
      var pageY = y2 + this.offset.top + height2 / 2 + scrollOffsetY;
      this.mouseHandlerCallback({
        pageX,
        pageY
      });
    }
  }]);
}();

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/isDomainSpecifiedByUser.js
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
  if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
    var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
    var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
    if (!!domainStart && !!domainEnd && isNumber(domainStart) && isNumber(domainEnd)) {
      return true;
    }
  }
  return false;
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/cursor/getCursorRectangle.js
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
  var halfSize = tooltipAxisBandSize / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
    y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
    width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
    height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
  };
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/cursor/getRadialCursorPoints.js
function getRadialCursorPoints(activeCoordinate) {
  var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
  var startPoint = polarToCartesian(cx, cy, radius, startAngle);
  var endPoint = polarToCartesian(cx, cy, radius, endAngle);
  return {
    points: [startPoint, endPoint],
    cx,
    cy,
    radius,
    startAngle,
    endAngle
  };
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/util/cursor/getCursorPoints.js
function getCursorPoints(layout, activeCoordinate, offset) {
  var x1, y1, x2, y2;
  if (layout === "horizontal") {
    x1 = activeCoordinate.x;
    x2 = x1;
    y1 = offset.top;
    y2 = offset.top + offset.height;
  } else if (layout === "vertical") {
    y1 = activeCoordinate.y;
    y2 = y1;
    x1 = offset.left;
    x2 = offset.left + offset.width;
  } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
    if (layout === "centric") {
      var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
      var innerPoint = polarToCartesian(cx, cy, innerRadius, angle);
      var outerPoint = polarToCartesian(cx, cy, outerRadius, angle);
      x1 = innerPoint.x;
      y1 = innerPoint.y;
      x2 = outerPoint.x;
      y2 = outerPoint.y;
    } else {
      return getRadialCursorPoints(activeCoordinate);
    }
  }
  return [{
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  }];
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/component/Cursor.js
function _typeof50(o) {
  "@babel/helpers - typeof";
  return _typeof50 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof50(o);
}
function ownKeys41(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread41(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys41(Object(t), true).forEach(function(r3) {
      _defineProperty46(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys41(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty46(obj, key2, value2) {
  key2 = _toPropertyKey47(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey47(t) {
  var i = _toPrimitive47(t, "string");
  return "symbol" == _typeof50(i) ? i : i + "";
}
function _toPrimitive47(t, r2) {
  if ("object" != _typeof50(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof50(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function Cursor(props) {
  var _element$props$cursor, _defaultProps;
  var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
  var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
  if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") {
    return null;
  }
  var restProps;
  var cursorComp = Curve;
  if (chartName === "ScatterChart") {
    restProps = activeCoordinate;
    cursorComp = Cross;
  } else if (chartName === "BarChart") {
    restProps = getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize);
    cursorComp = Rectangle;
  } else if (layout === "radial") {
    var _getRadialCursorPoint = getRadialCursorPoints(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
    restProps = {
      cx,
      cy,
      startAngle,
      endAngle,
      innerRadius: radius,
      outerRadius: radius
    };
    cursorComp = Sector;
  } else {
    restProps = {
      points: getCursorPoints(layout, activeCoordinate, offset)
    };
    cursorComp = Curve;
  }
  var cursorProps = _objectSpread41(_objectSpread41(_objectSpread41(_objectSpread41({
    stroke: "#ccc",
    pointerEvents: "none"
  }, offset), restProps), filterProps(elementPropsCursor, false)), {}, {
    payload: activePayload,
    payloadIndex: activeTooltipIndex,
    className: clsx_default("recharts-tooltip-cursor", elementPropsCursor.className)
  });
  return /* @__PURE__ */ isValidElement(elementPropsCursor) ? /* @__PURE__ */ cloneElement(elementPropsCursor, cursorProps) : /* @__PURE__ */ createElement(cursorComp, cursorProps);
}

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/generateCategoricalChart.js
var _excluded30 = ["item"];
var _excluded211 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _typeof51(o) {
  "@babel/helpers - typeof";
  return _typeof51 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof51(o);
}
function _extends33() {
  _extends33 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends33.apply(this, arguments);
}
function _slicedToArray14(arr, i) {
  return _arrayWithHoles15(arr) || _iterableToArrayLimit14(arr, i) || _unsupportedIterableToArray23(arr, i) || _nonIterableRest15();
}
function _nonIterableRest15() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit14(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a2 = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a2.push(e.value), a2.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles15(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties23(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose23(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose23(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _classCallCheck23(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties23(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey48(descriptor.key), descriptor);
  }
}
function _createClass23(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties23(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper19(t, o, e) {
  return o = _getPrototypeOf20(o), _possibleConstructorReturn20(t, _isNativeReflectConstruct20() ? Reflect.construct(o, e || [], _getPrototypeOf20(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn20(self2, call) {
  if (call && (_typeof51(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized20(self2);
}
function _assertThisInitialized20(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct20() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct20 = function _isNativeReflectConstruct21() {
    return !!t;
  })();
}
function _getPrototypeOf20(o) {
  _getPrototypeOf20 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf21(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf20(o);
}
function _inherits20(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf20(subClass, superClass);
}
function _setPrototypeOf20(o, p) {
  _setPrototypeOf20 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf21(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf20(o, p);
}
function _toConsumableArray12(arr) {
  return _arrayWithoutHoles12(arr) || _iterableToArray13(arr) || _unsupportedIterableToArray23(arr) || _nonIterableSpread12();
}
function _nonIterableSpread12() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray23(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray23(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray23(o, minLen);
}
function _iterableToArray13(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles12(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray23(arr);
}
function _arrayLikeToArray23(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys42(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread42(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys42(Object(t), true).forEach(function(r3) {
      _defineProperty47(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys42(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty47(obj, key2, value2) {
  key2 = _toPropertyKey48(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value2;
  }
  return obj;
}
function _toPropertyKey48(t) {
  var i = _toPrimitive48(t, "string");
  return "symbol" == _typeof51(i) ? i : i + "";
}
function _toPrimitive48(t, r2) {
  if ("object" != _typeof51(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof51(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
var ORIENT_MAP = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
};
var FULL_WIDTH_AND_HEIGHT = {
  width: "100%",
  height: "100%"
};
var originCoordinate = {
  x: 0,
  y: 0
};
function renderAsIs(element) {
  return element;
}
var calculateTooltipPos = function calculateTooltipPos2(rangeObj, layout) {
  if (layout === "horizontal") {
    return rangeObj.x;
  }
  if (layout === "vertical") {
    return rangeObj.y;
  }
  if (layout === "centric") {
    return rangeObj.angle;
  }
  return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate2(layout, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function(tick) {
    return tick && tick.index === activeIndex;
  });
  if (entry) {
    if (layout === "horizontal") {
      return {
        x: entry.coordinate,
        y: rangeObj.y
      };
    }
    if (layout === "vertical") {
      return {
        x: rangeObj.x,
        y: entry.coordinate
      };
    }
    if (layout === "centric") {
      var _angle = entry.coordinate;
      var _radius = rangeObj.radius;
      return _objectSpread42(_objectSpread42(_objectSpread42({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
        angle: _angle,
        radius: _radius
      });
    }
    var radius = entry.coordinate;
    var angle = rangeObj.angle;
    return _objectSpread42(_objectSpread42(_objectSpread42({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
      angle,
      radius
    });
  }
  return originCoordinate;
};
var getDisplayedData = function getDisplayedData2(data2, _ref) {
  var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
  var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
    var itemData = child.props.data;
    if (itemData && itemData.length) {
      return [].concat(_toConsumableArray12(result), _toConsumableArray12(itemData));
    }
    return result;
  }, []);
  if (itemsData.length > 0) {
    return itemsData;
  }
  if (data2 && data2.length && isNumber(dataStartIndex) && isNumber(dataEndIndex)) {
    return data2.slice(dataStartIndex, dataEndIndex + 1);
  }
  return [];
};
function getDefaultDomainByAxisType(axisType) {
  return axisType === "number" ? [0, "auto"] : void 0;
}
var getTooltipContent = function getTooltipContent2(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
  var displayedData = getDisplayedData(chartData, state);
  if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
    return null;
  }
  return graphicalItems.reduce(function(result, child) {
    var _child$props$data;
    var data2 = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
    if (data2 && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    state.dataEndIndex - state.dataStartIndex >= activeIndex) {
      data2 = data2.slice(state.dataStartIndex, state.dataEndIndex + 1);
    }
    var payload;
    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      var entries = data2 === void 0 ? displayedData : data2;
      payload = findEntryInArray(entries, tooltipAxis.dataKey, activeLabel);
    } else {
      payload = data2 && data2[activeIndex] || displayedData[activeIndex];
    }
    if (!payload) {
      return result;
    }
    return [].concat(_toConsumableArray12(result), [getTooltipItem(child, payload)]);
  }, []);
};
var getTooltipData = function getTooltipData2(state, chartData, layout, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY
  };
  var pos = calculateTooltipPos(rangeData, layout);
  var ticks2 = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
  var activeIndex = calculateActiveTickIndex(pos, ticks2, tooltipTicks, axis);
  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
    var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
    var activeCoordinate = getActiveCoordinate(layout, ticks2, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel,
      activePayload,
      activeCoordinate
    };
  }
  return null;
};
var getAxisMapByAxes = function getAxisMapByAxes2(props, _ref2) {
  var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
  var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
  var isCategorical = isCategoricalAxis(layout, axisType);
  return axes.reduce(function(result, child) {
    var _childProps$domain2;
    var childProps = child.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, child.type.defaultProps), child.props) : child.props;
    var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale2 = childProps.scale, ticks2 = childProps.ticks, includeHidden = childProps.includeHidden;
    var axisId = childProps[axisIdKey];
    if (result[axisId]) {
      return result;
    }
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function(item) {
        var _defaultProps;
        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
        return itemAxisId === axisId;
      }),
      dataStartIndex,
      dataEndIndex
    });
    var len = displayedData.length;
    var domain, duplicateDomain, categoricalDomain;
    if (isDomainSpecifiedByUser(childProps.domain, allowDataOverflow, type)) {
      domain = parseSpecifiedDomain(childProps.domain, null, allowDataOverflow);
      if (isCategorical && (type === "number" || scale2 !== "auto")) {
        categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category");
      }
    }
    var defaultDomain = getDefaultDomainByAxisType(type);
    if (!domain || domain.length === 0) {
      var _childProps$domain;
      var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
      if (dataKey) {
        domain = getDomainOfDataByKey(displayedData, dataKey, type);
        if (type === "category" && isCategorical) {
          var duplicate = hasDuplicate(domain);
          if (allowDuplicatedCategory && duplicate) {
            duplicateDomain = domain;
            domain = (0, import_range3.default)(0, len);
          } else if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray12(finalDomain), [entry]);
            }, []);
          }
        } else if (type === "category") {
          if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, import_isNil12.default)(entry) ? finalDomain : [].concat(_toConsumableArray12(finalDomain), [entry]);
            }, []);
          } else {
            domain = domain.filter(function(entry) {
              return entry !== "" && !(0, import_isNil12.default)(entry);
            });
          }
        } else if (type === "number") {
          var errorBarsDomain = parseErrorBarsOfAxis(displayedData, graphicalItems.filter(function(item) {
            var _defaultProps2, _defaultProps3;
            var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
            var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
            return itemAxisId === axisId && (includeHidden || !itemHide);
          }), dataKey, axisType, layout);
          if (errorBarsDomain) {
            domain = errorBarsDomain;
          }
        }
        if (isCategorical && (type === "number" || scale2 !== "auto")) {
          categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category");
        }
      } else if (isCategorical) {
        domain = (0, import_range3.default)(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") {
        domain = stackOffset === "expand" ? [0, 1] : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
      } else {
        domain = getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
          var itemHide = "hide" in item.props ? item.props.hide : item.type.defaultProps.hide;
          return itemAxisId === axisId && (includeHidden || !itemHide);
        }), type, layout, true);
      }
      if (type === "number") {
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType, ticks2);
        if (childDomain) {
          domain = parseSpecifiedDomain(childDomain, domain, allowDataOverflow);
        }
      } else if (type === "category" && childDomain) {
        var axisDomain = childDomain;
        var isDomainValid = domain.every(function(entry) {
          return axisDomain.indexOf(entry) >= 0;
        });
        if (isDomainValid) {
          domain = axisDomain;
        }
      }
    }
    return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47({}, axisId, _objectSpread42(_objectSpread42({}, childProps), {}, {
      axisType,
      domain,
      categoricalDomain,
      duplicateDomain,
      originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
      isCategorical,
      layout
    })));
  }, {});
};
var getAxisMapByItems = function getAxisMapByItems2(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
  var layout = props.layout, children = props.children;
  var displayedData = getDisplayedData(props.data, {
    graphicalItems,
    dataStartIndex,
    dataEndIndex
  });
  var len = displayedData.length;
  var isCategorical = isCategoricalAxis(layout, axisType);
  var index2 = -1;
  return graphicalItems.reduce(function(result, child) {
    var childProps = child.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, child.type.defaultProps), child.props) : child.props;
    var axisId = childProps[axisIdKey];
    var originalDomain = getDefaultDomainByAxisType("number");
    if (!result[axisId]) {
      index2++;
      var domain;
      if (isCategorical) {
        domain = (0, import_range3.default)(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
        domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      } else {
        domain = parseSpecifiedDomain(originalDomain, getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
          var _defaultProps4, _defaultProps5;
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
          var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
          return itemAxisId === axisId && !itemHide;
        }), "number", layout), Axis.defaultProps.allowDataOverflow);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      }
      return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47({}, axisId, _objectSpread42(_objectSpread42({
        axisType
      }, Axis.defaultProps), {}, {
        hide: true,
        orientation: (0, import_get6.default)(ORIENT_MAP, "".concat(axisType, ".").concat(index2 % 2), null),
        domain,
        originalDomain,
        isCategorical,
        layout
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return result;
  }, {});
};
var getAxisMap = function getAxisMap2(props, _ref4) {
  var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
  var children = props.children;
  var axisIdKey = "".concat(axisType, "Id");
  var axes = findAllByType(children, AxisComp);
  var axisMap = {};
  if (axes && axes.length) {
    axisMap = getAxisMapByAxes(props, {
      axes,
      graphicalItems,
      axisType,
      axisIdKey,
      stackGroups,
      dataStartIndex,
      dataEndIndex
    });
  } else if (graphicalItems && graphicalItems.length) {
    axisMap = getAxisMapByItems(props, {
      Axis: AxisComp,
      graphicalItems,
      axisType,
      axisIdKey,
      stackGroups,
      dataStartIndex,
      dataEndIndex
    });
  }
  return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator2(axisMap) {
  var axis = getAnyElementOfObject(axisMap);
  var tooltipTicks = getTicksOfAxis(axis, false, true);
  return {
    tooltipTicks,
    orderedTooltipTicks: (0, import_sortBy3.default)(tooltipTicks, function(o) {
      return o.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: getBandSizeOfAxis(axis, tooltipTicks)
  };
};
var createDefaultState = function createDefaultState2(props) {
  var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
  var brushItem = findChildByType(children, Brush);
  var startIndex = 0;
  var endIndex = 0;
  if (props.data && props.data.length !== 0) {
    endIndex = props.data.length - 1;
  }
  if (brushItem && brushItem.props) {
    if (brushItem.props.startIndex >= 0) {
      startIndex = brushItem.props.startIndex;
    }
    if (brushItem.props.endIndex >= 0) {
      endIndex = brushItem.props.endIndex;
    }
  }
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: Boolean(defaultShowTooltip)
  };
};
var hasGraphicalBarItem = function hasGraphicalBarItem2(graphicalItems) {
  if (!graphicalItems || !graphicalItems.length) {
    return false;
  }
  return graphicalItems.some(function(item) {
    var name2 = getDisplayName(item && item.type);
    return name2 && name2.indexOf("Bar") >= 0;
  });
};
var getAxisNameByLayout = function getAxisNameByLayout2(layout) {
  if (layout === "horizontal") {
    return {
      numericAxisName: "yAxis",
      cateAxisName: "xAxis"
    };
  }
  if (layout === "vertical") {
    return {
      numericAxisName: "xAxis",
      cateAxisName: "yAxis"
    };
  }
  if (layout === "centric") {
    return {
      numericAxisName: "radiusAxis",
      cateAxisName: "angleAxis"
    };
  }
  return {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
};
var calculateOffset = function calculateOffset2(_ref5, prevLegendBBox) {
  var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
  var width2 = props.width, height2 = props.height, children = props.children;
  var margin = props.margin || {};
  var brushItem = findChildByType(children, Brush);
  var legendItem = findChildByType(children, Legend);
  var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
    var entry = yAxisMap[id];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47({}, orientation, result[orientation] + entry.width));
    }
    return result;
  }, {
    left: margin.left || 0,
    right: margin.right || 0
  });
  var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
    var entry = xAxisMap[id];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47({}, orientation, (0, import_get6.default)(result, "".concat(orientation)) + entry.height));
    }
    return result;
  }, {
    top: margin.top || 0,
    bottom: margin.bottom || 0
  });
  var offset = _objectSpread42(_objectSpread42({}, offsetV), offsetH);
  var brushBottom = offset.bottom;
  if (brushItem) {
    offset.bottom += brushItem.props.height || Brush.defaultProps.height;
  }
  if (legendItem && prevLegendBBox) {
    offset = appendOffsetOfLegend(offset, graphicalItems, props, prevLegendBBox);
  }
  var offsetWidth = width2 - offset.left - offset.right;
  var offsetHeight = height2 - offset.top - offset.bottom;
  return _objectSpread42(_objectSpread42({
    brushBottom
  }, offset), {}, {
    // never return negative values for height and width
    width: Math.max(offsetWidth, 0),
    height: Math.max(offsetHeight, 0)
  });
};
var getCartesianAxisSize = function getCartesianAxisSize2(axisObj, axisName) {
  if (axisName === "xAxis") {
    return axisObj[axisName].width;
  }
  if (axisName === "yAxis") {
    return axisObj[axisName].height;
  }
  return void 0;
};
var generateCategoricalChart = function generateCategoricalChart2(_ref6) {
  var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ["axis"] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap5 = _ref6.formatAxisMap, defaultProps21 = _ref6.defaultProps;
  var getFormatItems = function getFormatItems2(props, currentState) {
    var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
    var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
    var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
    var hasBar = hasGraphicalBarItem(graphicalItems);
    var formattedItems = [];
    graphicalItems.forEach(function(item, index2) {
      var displayedData = getDisplayedData(props.data, {
        graphicalItems: [item],
        dataStartIndex,
        dataEndIndex
      });
      var itemProps = item.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, item.type.defaultProps), item.props) : item.props;
      var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
      var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
      var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
      var axisObjInitialValue = {};
      var axisObj = axisComponents.reduce(function(result, entry) {
        var _item$type$displayNam, _item$type;
        var axisMap = currentState["".concat(entry.axisType, "Map")];
        var id = itemProps["".concat(entry.axisType, "Id")];
        !(axisMap && axisMap[id] || entry.axisType === "zAxis") ? process.env.NODE_ENV !== "production" ? invariant(false, "Specifying a(n) ".concat(entry.axisType, "Id requires a corresponding ").concat(
          entry.axisType,
          "Id on the targeted graphical component "
        ).concat((_item$type$displayNam = item === null || item === void 0 || (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.displayName) !== null && _item$type$displayNam !== void 0 ? _item$type$displayNam : "")) : invariant() : void 0;
        var axis = axisMap[id];
        return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47(_defineProperty47({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), getTicksOfAxis(axis)));
      }, axisObjInitialValue);
      var cateAxis = axisObj[cateAxisName];
      var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
      var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups);
      var itemIsBar = getDisplayName(item.type).indexOf("Bar") >= 0;
      var bandSize = getBandSizeOfAxis(cateAxis, cateTicks);
      var barPosition = [];
      var sizeList = hasBar && getBarSizeList({
        barSize,
        stackGroups,
        totalSize: getCartesianAxisSize(axisObj, cateAxisName)
      });
      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis;
        var maxBarSize = (0, import_isNil12.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
        var barBandSize = (_ref7 = (_getBandSizeOfAxis = getBandSizeOfAxis(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
        barPosition = getBarPosition({
          barGap,
          barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize
        });
        if (barBandSize !== bandSize) {
          barPosition = barPosition.map(function(pos) {
            return _objectSpread42(_objectSpread42({}, pos), {}, {
              position: _objectSpread42(_objectSpread42({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
              })
            });
          });
        }
      }
      var composedFn = item && item.type && item.type.getComposedData;
      if (composedFn) {
        formattedItems.push({
          props: _objectSpread42(_objectSpread42({}, composedFn(_objectSpread42(_objectSpread42({}, axisObj), {}, {
            displayedData,
            props,
            dataKey,
            item,
            bandSize,
            barPosition,
            offset,
            stackedData,
            layout,
            dataStartIndex,
            dataEndIndex
          }))), {}, _defineProperty47(_defineProperty47(_defineProperty47({
            key: item.key || "item-".concat(index2)
          }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
          childIndex: parseChildIndex(item, props.children),
          item
        });
      }
    });
    return formattedItems;
  };
  var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups2(_ref8, prevState) {
    var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
    if (!validateWidthHeight({
      props
    })) {
      return null;
    }
    var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data2 = props.data, reverseStackOrder = props.reverseStackOrder;
    var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
    var graphicalItems = findAllByType(children, GraphicalChild);
    var stackGroups = getStackGroupsByAxisId(data2, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
    var axisObj = axisComponents.reduce(function(result, entry) {
      var name2 = "".concat(entry.axisType, "Map");
      return _objectSpread42(_objectSpread42({}, result), {}, _defineProperty47({}, name2, getAxisMap(props, _objectSpread42(_objectSpread42({}, entry), {}, {
        graphicalItems,
        stackGroups: entry.axisType === numericAxisName && stackGroups,
        dataStartIndex,
        dataEndIndex
      }))));
    }, {});
    var offset = calculateOffset(_objectSpread42(_objectSpread42({}, axisObj), {}, {
      props,
      graphicalItems
    }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
    Object.keys(axisObj).forEach(function(key2) {
      axisObj[key2] = formatAxisMap5(props, axisObj[key2], offset, key2.replace("Map", ""), chartName);
    });
    var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
    var ticksObj = tooltipTicksGenerator(cateAxisMap);
    var formattedGraphicalItems = getFormatItems(props, _objectSpread42(_objectSpread42({}, axisObj), {}, {
      dataStartIndex,
      dataEndIndex,
      updateId,
      graphicalItems,
      stackGroups,
      offset
    }));
    return _objectSpread42(_objectSpread42({
      formattedGraphicalItems,
      graphicalItems,
      offset,
      stackGroups
    }, ticksObj), axisObj);
  };
  var CategoricalChartWrapper = /* @__PURE__ */ function(_Component) {
    function CategoricalChartWrapper2(_props) {
      var _props$id, _props$throttleDelay;
      var _this;
      _classCallCheck23(this, CategoricalChartWrapper2);
      _this = _callSuper19(this, CategoricalChartWrapper2, [_props]);
      _defineProperty47(_this, "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
      _defineProperty47(_this, "accessibilityManager", new AccessibilityManager());
      _defineProperty47(_this, "handleLegendBBoxUpdate", function(box) {
        if (box) {
          var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
          _this.setState(_objectSpread42({
            legendBBox: box
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _objectSpread42(_objectSpread42({}, _this.state), {}, {
            legendBBox: box
          }))));
        }
      });
      _defineProperty47(_this, "handleReceiveSyncEvent", function(cId, data2, emitter) {
        if (_this.props.syncId === cId) {
          if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") {
            return;
          }
          _this.applySyncEvent(data2);
        }
      });
      _defineProperty47(_this, "handleBrushChange", function(_ref9) {
        var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;
          _this.setState(function() {
            return _objectSpread42({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId
            }, _this.state));
          });
          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      });
      _defineProperty47(_this, "handleMouseEnter", function(e) {
        var mouse = _this.getMouseInfo(e);
        if (mouse) {
          var _nextState = _objectSpread42(_objectSpread42({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState);
          _this.triggerSyncEvent(_nextState);
          var onMouseEnter = _this.props.onMouseEnter;
          if ((0, import_isFunction22.default)(onMouseEnter)) {
            onMouseEnter(_nextState, e);
          }
        }
      });
      _defineProperty47(_this, "triggeredAfterMouseMove", function(e) {
        var mouse = _this.getMouseInfo(e);
        var nextState = mouse ? _objectSpread42(_objectSpread42({}, mouse), {}, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseMove = _this.props.onMouseMove;
        if ((0, import_isFunction22.default)(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      });
      _defineProperty47(_this, "handleItemMouseEnter", function(el) {
        _this.setState(function() {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      });
      _defineProperty47(_this, "handleItemMouseLeave", function() {
        _this.setState(function() {
          return {
            isTooltipActive: false
          };
        });
      });
      _defineProperty47(_this, "handleMouseMove", function(e) {
        e.persist();
        _this.throttleTriggeredAfterMouseMove(e);
      });
      _defineProperty47(_this, "handleMouseLeave", function(e) {
        _this.throttleTriggeredAfterMouseMove.cancel();
        var nextState = {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseLeave = _this.props.onMouseLeave;
        if ((0, import_isFunction22.default)(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      });
      _defineProperty47(_this, "handleOuterEvent", function(e) {
        var eventName = getReactEventByType(e);
        var event = (0, import_get6.default)(_this.props, "".concat(eventName));
        if (eventName && (0, import_isFunction22.default)(event)) {
          var _mouse;
          var mouse;
          if (/.*touch.*/i.test(eventName)) {
            mouse = _this.getMouseInfo(e.changedTouches[0]);
          } else {
            mouse = _this.getMouseInfo(e);
          }
          event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
        }
      });
      _defineProperty47(_this, "handleClick", function(e) {
        var mouse = _this.getMouseInfo(e);
        if (mouse) {
          var _nextState2 = _objectSpread42(_objectSpread42({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState2);
          _this.triggerSyncEvent(_nextState2);
          var onClick = _this.props.onClick;
          if ((0, import_isFunction22.default)(onClick)) {
            onClick(_nextState2, e);
          }
        }
      });
      _defineProperty47(_this, "handleMouseDown", function(e) {
        var onMouseDown = _this.props.onMouseDown;
        if ((0, import_isFunction22.default)(onMouseDown)) {
          var _nextState3 = _this.getMouseInfo(e);
          onMouseDown(_nextState3, e);
        }
      });
      _defineProperty47(_this, "handleMouseUp", function(e) {
        var onMouseUp = _this.props.onMouseUp;
        if ((0, import_isFunction22.default)(onMouseUp)) {
          var _nextState4 = _this.getMouseInfo(e);
          onMouseUp(_nextState4, e);
        }
      });
      _defineProperty47(_this, "handleTouchMove", function(e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
        }
      });
      _defineProperty47(_this, "handleTouchStart", function(e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseDown(e.changedTouches[0]);
        }
      });
      _defineProperty47(_this, "handleTouchEnd", function(e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseUp(e.changedTouches[0]);
        }
      });
      _defineProperty47(_this, "handleDoubleClick", function(e) {
        var onDoubleClick = _this.props.onDoubleClick;
        if ((0, import_isFunction22.default)(onDoubleClick)) {
          var _nextState5 = _this.getMouseInfo(e);
          onDoubleClick(_nextState5, e);
        }
      });
      _defineProperty47(_this, "handleContextMenu", function(e) {
        var onContextMenu = _this.props.onContextMenu;
        if ((0, import_isFunction22.default)(onContextMenu)) {
          var _nextState6 = _this.getMouseInfo(e);
          onContextMenu(_nextState6, e);
        }
      });
      _defineProperty47(_this, "triggerSyncEvent", function(data2) {
        if (_this.props.syncId !== void 0) {
          eventCenter.emit(SYNC_EVENT, _this.props.syncId, data2, _this.eventEmitterSymbol);
        }
      });
      _defineProperty47(_this, "applySyncEvent", function(data2) {
        var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
        var updateId = _this.state.updateId;
        var dataStartIndex = data2.dataStartIndex, dataEndIndex = data2.dataEndIndex;
        if (data2.dataStartIndex !== void 0 || data2.dataEndIndex !== void 0) {
          _this.setState(_objectSpread42({
            dataStartIndex,
            dataEndIndex
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _this.state)));
        } else if (data2.activeTooltipIndex !== void 0) {
          var chartX = data2.chartX, chartY = data2.chartY;
          var activeTooltipIndex = data2.activeTooltipIndex;
          var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
          if (!offset) {
            return;
          }
          if (typeof syncMethod === "function") {
            activeTooltipIndex = syncMethod(tooltipTicks, data2);
          } else if (syncMethod === "value") {
            activeTooltipIndex = -1;
            for (var i = 0; i < tooltipTicks.length; i++) {
              if (tooltipTicks[i].value === data2.activeLabel) {
                activeTooltipIndex = i;
                break;
              }
            }
          }
          var viewBox = _objectSpread42(_objectSpread42({}, offset), {}, {
            x: offset.left,
            y: offset.top
          });
          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
          var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;
          _this.setState(_objectSpread42(_objectSpread42({}, data2), {}, {
            activeLabel,
            activeCoordinate,
            activePayload,
            activeTooltipIndex
          }));
        } else {
          _this.setState(data2);
        }
      });
      _defineProperty47(_this, "renderCursor", function(element) {
        var _element$props$active;
        var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
        var tooltipEventType = _this.getTooltipEventType();
        var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
        var layout = _this.props.layout;
        var key2 = element.key || "_recharts-cursor";
        return /* @__PURE__ */ React43.createElement(Cursor, {
          key: key2,
          activeCoordinate,
          activePayload,
          activeTooltipIndex,
          chartName,
          element,
          isActive,
          layout,
          offset,
          tooltipAxisBandSize,
          tooltipEventType
        });
      });
      _defineProperty47(_this, "renderPolarAxis", function(element, displayName, index2) {
        var axisType = (0, import_get6.default)(element, "type.axisType");
        var axisMap = (0, import_get6.default)(_this.state, "".concat(axisType, "Map"));
        var elementDefaultProps = element.type.defaultProps;
        var elementProps = elementDefaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, elementDefaultProps), element.props) : element.props;
        var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
        return /* @__PURE__ */ cloneElement(element, _objectSpread42(_objectSpread42({}, axisOption), {}, {
          className: clsx_default(axisType, axisOption.className),
          key: element.key || "".concat(displayName, "-").concat(index2),
          ticks: getTicksOfAxis(axisOption, true)
        }));
      });
      _defineProperty47(_this, "renderPolarGrid", function(element) {
        var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
        var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
        var radiusAxis = getAnyElementOfObject(radiusAxisMap);
        var angleAxis = getAnyElementOfObject(angleAxisMap);
        var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
        return /* @__PURE__ */ cloneElement(element, {
          polarAngles: Array.isArray(polarAngles) ? polarAngles : getTicksOfAxis(angleAxis, true).map(function(entry) {
            return entry.coordinate;
          }),
          polarRadius: Array.isArray(polarRadius) ? polarRadius : getTicksOfAxis(radiusAxis, true).map(function(entry) {
            return entry.coordinate;
          }),
          cx,
          cy,
          innerRadius,
          outerRadius,
          key: element.key || "polar-grid",
          radialLines
        });
      });
      _defineProperty47(_this, "renderLegend", function() {
        var formattedGraphicalItems = _this.state.formattedGraphicalItems;
        var _this$props2 = _this.props, children = _this$props2.children, width2 = _this$props2.width, height2 = _this$props2.height;
        var margin = _this.props.margin || {};
        var legendWidth = width2 - (margin.left || 0) - (margin.right || 0);
        var props = getLegendProps({
          children,
          formattedGraphicalItems,
          legendWidth,
          legendContent
        });
        if (!props) {
          return null;
        }
        var item = props.item, otherProps = _objectWithoutProperties23(props, _excluded30);
        return /* @__PURE__ */ cloneElement(item, _objectSpread42(_objectSpread42({}, otherProps), {}, {
          chartWidth: width2,
          chartHeight: height2,
          margin,
          onBBoxUpdate: _this.handleLegendBBoxUpdate
        }));
      });
      _defineProperty47(_this, "renderTooltip", function() {
        var _tooltipItem$props$ac;
        var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
        var tooltipItem = findChildByType(children, Tooltip2);
        if (!tooltipItem) {
          return null;
        }
        var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
        var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
        return /* @__PURE__ */ cloneElement(tooltipItem, {
          viewBox: _objectSpread42(_objectSpread42({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }),
          active: isActive,
          label: activeLabel,
          payload: isActive ? activePayload : [],
          coordinate: activeCoordinate,
          accessibilityLayer
        });
      });
      _defineProperty47(_this, "renderBrush", function(element) {
        var _this$props4 = _this.props, margin = _this$props4.margin, data2 = _this$props4.data;
        var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
        return /* @__PURE__ */ cloneElement(element, {
          key: element.key || "_recharts-brush",
          onChange: combineEventHandlers(_this.handleBrushChange, element.props.onChange),
          data: data2,
          x: isNumber(element.props.x) ? element.props.x : offset.left,
          y: isNumber(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: isNumber(element.props.width) ? element.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      });
      _defineProperty47(_this, "renderReferenceElement", function(element, displayName, index2) {
        if (!element) {
          return null;
        }
        var _this2 = _this, clipPathId = _this2.clipPathId;
        var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
        var elementDefaultProps = element.type.defaultProps || {};
        var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
        return /* @__PURE__ */ cloneElement(element, {
          key: element.key || "".concat(displayName, "-").concat(index2),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId
        });
      });
      _defineProperty47(_this, "renderActivePoints", function(_ref10) {
        var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
        var result = [];
        var key2 = item.props.key;
        var itemItemProps = item.item.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
        var dotProps = _objectSpread42(_objectSpread42({
          index: childIndex,
          dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: getMainColorOfGraphicItem(item.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: activePoint.payload,
          value: activePoint.value
        }, filterProps(activeDot, false)), adaptEventHandlers(activeDot));
        result.push(CategoricalChartWrapper2.renderActiveDot(activeDot, dotProps, "".concat(key2, "-activePoint-").concat(childIndex)));
        if (basePoint) {
          result.push(CategoricalChartWrapper2.renderActiveDot(activeDot, _objectSpread42(_objectSpread42({}, dotProps), {}, {
            cx: basePoint.x,
            cy: basePoint.y
          }), "".concat(key2, "-basePoint-").concat(childIndex)));
        } else if (isRange) {
          result.push(null);
        }
        return result;
      });
      _defineProperty47(_this, "renderGraphicChild", function(element, displayName, index2) {
        var item = _this.filterFormatItem(element, displayName, index2);
        if (!item) {
          return null;
        }
        var tooltipEventType = _this.getTooltipEventType();
        var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = findChildByType(children, Tooltip2);
        var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
        var itemItemProps = item.item.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
        var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
        var itemEvents = {};
        if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") {
          itemEvents = {
            onClick: combineEventHandlers(_this.handleItemMouseEnter, element.props.onClick)
          };
        } else if (tooltipEventType !== "axis") {
          itemEvents = {
            onMouseLeave: combineEventHandlers(_this.handleItemMouseLeave, element.props.onMouseLeave),
            onMouseEnter: combineEventHandlers(_this.handleItemMouseEnter, element.props.onMouseEnter)
          };
        }
        var graphicalItem = /* @__PURE__ */ cloneElement(element, _objectSpread42(_objectSpread42({}, item.props), itemEvents));
        function findWithPayload(entry) {
          return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
        }
        if (hasActive) {
          if (activeTooltipIndex >= 0) {
            var activePoint, basePoint;
            if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
              var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
              activePoint = findEntryInArray(points, specifiedKey, activeLabel);
              basePoint = isRange && baseLine && findEntryInArray(baseLine, specifiedKey, activeLabel);
            } else {
              activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
              basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
            }
            if (activeShape || activeBar) {
              var activeIndex = element.props.activeIndex !== void 0 ? element.props.activeIndex : activeTooltipIndex;
              return [/* @__PURE__ */ cloneElement(element, _objectSpread42(_objectSpread42(_objectSpread42({}, item.props), itemEvents), {}, {
                activeIndex
              })), null, null];
            }
            if (!(0, import_isNil12.default)(activePoint)) {
              return [graphicalItem].concat(_toConsumableArray12(_this.renderActivePoints({
                item,
                activePoint,
                basePoint,
                childIndex: activeTooltipIndex,
                isRange
              })));
            }
          } else {
            var _this$getItemByXY;
            var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
              graphicalItem
            }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
            var elementProps = _objectSpread42(_objectSpread42(_objectSpread42({}, item.props), itemEvents), {}, {
              activeIndex: childIndex
            });
            return [/* @__PURE__ */ cloneElement(xyItem, elementProps), null, null];
          }
        }
        if (isRange) {
          return [graphicalItem, null, null];
        }
        return [graphicalItem, null];
      });
      _defineProperty47(_this, "renderCustomized", function(element, displayName, index2) {
        return /* @__PURE__ */ cloneElement(element, _objectSpread42(_objectSpread42({
          key: "recharts-customized-".concat(index2)
        }, _this.props), _this.state));
      });
      _defineProperty47(_this, "renderMap", {
        CartesianGrid: {
          handler: renderAsIs,
          once: true
        },
        ReferenceArea: {
          handler: _this.renderReferenceElement
        },
        ReferenceLine: {
          handler: renderAsIs
        },
        ReferenceDot: {
          handler: _this.renderReferenceElement
        },
        XAxis: {
          handler: renderAsIs
        },
        YAxis: {
          handler: renderAsIs
        },
        Brush: {
          handler: _this.renderBrush,
          once: true
        },
        Bar: {
          handler: _this.renderGraphicChild
        },
        Line: {
          handler: _this.renderGraphicChild
        },
        Area: {
          handler: _this.renderGraphicChild
        },
        Radar: {
          handler: _this.renderGraphicChild
        },
        RadialBar: {
          handler: _this.renderGraphicChild
        },
        Scatter: {
          handler: _this.renderGraphicChild
        },
        Pie: {
          handler: _this.renderGraphicChild
        },
        Funnel: {
          handler: _this.renderGraphicChild
        },
        Tooltip: {
          handler: _this.renderCursor,
          once: true
        },
        PolarGrid: {
          handler: _this.renderPolarGrid,
          once: true
        },
        PolarAngleAxis: {
          handler: _this.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _this.renderPolarAxis
        },
        Customized: {
          handler: _this.renderCustomized
        }
      });
      _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : uniqueId("recharts"), "-clip");
      _this.throttleTriggeredAfterMouseMove = (0, import_throttle2.default)(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1e3 / 60);
      _this.state = {};
      return _this;
    }
    _inherits20(CategoricalChartWrapper2, _Component);
    return _createClass23(CategoricalChartWrapper2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$margin$le, _this$props$margin$to;
        this.addListener();
        this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        });
        this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function displayDefaultTooltip() {
        var _this$props5 = this.props, children = _this$props5.children, data2 = _this$props5.data, height2 = _this$props5.height, layout = _this$props5.layout;
        var tooltipElem = findChildByType(children, Tooltip2);
        if (!tooltipElem) {
          return;
        }
        var defaultIndex = tooltipElem.props.defaultIndex;
        if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) {
          return;
        }
        var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
        var activePayload = getTooltipContent(this.state, data2, defaultIndex, activeLabel);
        var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
        var dependentAxisCoord = (this.state.offset.top + height2) / 2;
        var isHorizontal = layout === "horizontal";
        var activeCoordinate = isHorizontal ? {
          x: independentAxisCoord,
          y: dependentAxisCoord
        } : {
          y: independentAxisCoord,
          x: dependentAxisCoord
        };
        var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
          var item = _ref12.item;
          return item.type.name === "Scatter";
        });
        if (scatterPlotElement) {
          activeCoordinate = _objectSpread42(_objectSpread42({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
          activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
        }
        var nextState = {
          activeTooltipIndex: defaultIndex,
          isTooltipActive: true,
          activeLabel,
          activePayload,
          activeCoordinate
        };
        this.setState(nextState);
        this.renderCursor(tooltipElem);
        this.accessibilityManager.setIndex(defaultIndex);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps, prevState) {
        if (!this.props.accessibilityLayer) {
          return null;
        }
        if (this.state.tooltipTicks !== prevState.tooltipTicks) {
          this.accessibilityManager.setDetails({
            coordinateList: this.state.tooltipTicks
          });
        }
        if (this.props.layout !== prevProps.layout) {
          this.accessibilityManager.setDetails({
            layout: this.props.layout
          });
        }
        if (this.props.margin !== prevProps.margin) {
          var _this$props$margin$le2, _this$props$margin$to2;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
              top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!isChildrenEqual([findChildByType(prevProps.children, Tooltip2)], [findChildByType(this.props.children, Tooltip2)])) {
          this.displayDefaultTooltip();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeListener();
        this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function getTooltipEventType() {
        var tooltipItem = findChildByType(this.props.children, Tooltip2);
        if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
          var eventType = tooltipItem.props.shared ? "axis" : "item";
          return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
        }
        return defaultTooltipEventType;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }
        var element = this.container;
        var boundingRect = element.getBoundingClientRect();
        var containerOffset = getOffset(boundingRect);
        var e = {
          chartX: Math.round(event.pageX - containerOffset.left),
          chartY: Math.round(event.pageY - containerOffset.top)
        };
        var scale2 = boundingRect.width / element.offsetWidth || 1;
        var rangeObj = this.inRange(e.chartX, e.chartY, scale2);
        if (!rangeObj) {
          return null;
        }
        var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
        var tooltipEventType = this.getTooltipEventType();
        if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
          var xScale = getAnyElementOfObject(xAxisMap).scale;
          var yScale = getAnyElementOfObject(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
          return _objectSpread42(_objectSpread42({}, e), {}, {
            xValue,
            yValue
          });
        }
        var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
        if (toolTipData) {
          return _objectSpread42(_objectSpread42({}, e), toolTipData);
        }
        return null;
      }
    }, {
      key: "inRange",
      value: function inRange(x2, y2) {
        var scale2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        var layout = this.props.layout;
        var scaledX = x2 / scale2, scaledY = y2 / scale2;
        if (layout === "horizontal" || layout === "vertical") {
          var offset = this.state.offset;
          var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
          return isInRange ? {
            x: scaledX,
            y: scaledY
          } : null;
        }
        var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = getAnyElementOfObject(angleAxisMap);
          return inRangeOfSector({
            x: scaledX,
            y: scaledY
          }, angleAxis);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipEventType = this.getTooltipEventType();
        var tooltipItem = findChildByType(children, Tooltip2);
        var tooltipEvents = {};
        if (tooltipItem && tooltipEventType === "axis") {
          if (tooltipItem.props.trigger === "click") {
            tooltipEvents = {
              onClick: this.handleClick
            };
          } else {
            tooltipEvents = {
              onMouseEnter: this.handleMouseEnter,
              onDoubleClick: this.handleDoubleClick,
              onMouseMove: this.handleMouseMove,
              onMouseLeave: this.handleMouseLeave,
              onTouchMove: this.handleTouchMove,
              onTouchStart: this.handleTouchStart,
              onTouchEnd: this.handleTouchEnd,
              onContextMenu: this.handleContextMenu
            };
          }
        }
        var outerEvents = adaptEventHandlers(this.props, this.handleOuterEvent);
        return _objectSpread42(_objectSpread42({}, outerEvents), tooltipEvents);
      }
    }, {
      key: "addListener",
      value: function addListener() {
        eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formattedGraphicalItems = this.state.formattedGraphicalItems;
        for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
          var entry = formattedGraphicalItems[i];
          if (entry.item === item || entry.props.key === item.key || displayName === getDisplayName(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height2 = _this$state$offset.height, width2 = _this$state$offset.width;
        return /* @__PURE__ */ React43.createElement("defs", null, /* @__PURE__ */ React43.createElement("clipPath", {
          id: clipPathId
        }, /* @__PURE__ */ React43.createElement("rect", {
          x: left,
          y: top,
          height: height2,
          width: width2
        })));
      }
    }, {
      key: "getXScales",
      value: function getXScales() {
        var xAxisMap = this.state.xAxisMap;
        return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
          var _ref14 = _slicedToArray14(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
          return _objectSpread42(_objectSpread42({}, res), {}, _defineProperty47({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function getYScales() {
        var yAxisMap = this.state.yAxisMap;
        return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
          var _ref16 = _slicedToArray14(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
          return _objectSpread42(_objectSpread42({}, res), {}, _defineProperty47({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function getXScaleByAxisId(axisId) {
        var _this$state$xAxisMap;
        return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function getYScaleByAxisId(axisId) {
        var _this$state$yAxisMap;
        return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
      }
    }, {
      key: "getItemByXY",
      value: function getItemByXY(chartXY) {
        var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
        if (formattedGraphicalItems && formattedGraphicalItems.length) {
          for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
            var graphicalItem = formattedGraphicalItems[i];
            var props = graphicalItem.props, item = graphicalItem.item;
            var itemProps = item.type.defaultProps !== void 0 ? _objectSpread42(_objectSpread42({}, item.type.defaultProps), item.props) : item.props;
            var itemDisplayName = getDisplayName(item.type);
            if (itemDisplayName === "Bar") {
              var activeBarItem = (props.data || []).find(function(entry) {
                return isInRectangle(chartXY, entry);
              });
              if (activeBarItem) {
                return {
                  graphicalItem,
                  payload: activeBarItem
                };
              }
            } else if (itemDisplayName === "RadialBar") {
              var _activeBarItem = (props.data || []).find(function(entry) {
                return inRangeOfSector(chartXY, entry);
              });
              if (_activeBarItem) {
                return {
                  graphicalItem,
                  payload: _activeBarItem
                };
              }
            } else if (isFunnel(graphicalItem, activeItem) || isPie(graphicalItem, activeItem) || isScatter(graphicalItem, activeItem)) {
              var activeIndex = getActiveShapeIndexForTooltip({
                graphicalItem,
                activeTooltipItem: activeItem,
                itemData: itemProps.data
              });
              var childIndex = itemProps.activeIndex === void 0 ? activeIndex : itemProps.activeIndex;
              return {
                graphicalItem: _objectSpread42(_objectSpread42({}, graphicalItem), {}, {
                  childIndex
                }),
                payload: isScatter(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
              };
            }
          }
        }
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        if (!validateWidthHeight(this)) {
          return null;
        }
        var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width2 = _this$props6.width, height2 = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties23(_this$props6, _excluded211);
        var attrs = filterProps(others, false);
        if (compact) {
          return /* @__PURE__ */ React43.createElement(ChartLayoutContextProvider, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ React43.createElement(Surface, _extends33({}, attrs, {
            width: width2,
            height: height2,
            title,
            desc
          }), this.renderClipPath(), renderByOrder(children, this.renderMap)));
        }
        if (this.props.accessibilityLayer) {
          var _this$props$tabIndex, _this$props$role;
          attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
          attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
          attrs.onKeyDown = function(e) {
            _this3.accessibilityManager.keyboardEvent(e);
          };
          attrs.onFocus = function() {
            _this3.accessibilityManager.focus();
          };
        }
        var events = this.parseEventsOfWrapper();
        return /* @__PURE__ */ React43.createElement(ChartLayoutContextProvider, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ React43.createElement("div", _extends33({
          className: clsx_default("recharts-wrapper", className),
          style: _objectSpread42({
            position: "relative",
            cursor: "default",
            width: width2,
            height: height2
          }, style)
        }, events, {
          ref: function ref(node) {
            _this3.container = node;
          }
        }), /* @__PURE__ */ React43.createElement(Surface, _extends33({}, attrs, {
          width: width2,
          height: height2,
          title,
          desc,
          style: FULL_WIDTH_AND_HEIGHT
        }), this.renderClipPath(), renderByOrder(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Component);
  _defineProperty47(CategoricalChartWrapper, "displayName", chartName);
  _defineProperty47(CategoricalChartWrapper, "defaultProps", _objectSpread42({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false,
    syncMethod: "index"
  }, defaultProps21));
  _defineProperty47(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
    var dataKey = nextProps.dataKey, data2 = nextProps.data, children = nextProps.children, width2 = nextProps.width, height2 = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
    var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
    if (prevState.updateId === void 0) {
      var defaultState = createDefaultState(nextProps);
      return _objectSpread42(_objectSpread42(_objectSpread42({}, defaultState), {}, {
        updateId: 0
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread42(_objectSpread42({
        props: nextProps
      }, defaultState), {}, {
        updateId: 0
      }), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data2,
        prevWidth: width2,
        prevHeight: height2,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (dataKey !== prevState.prevDataKey || data2 !== prevState.prevData || width2 !== prevState.prevWidth || height2 !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !shallowEqual(margin, prevState.prevMargin)) {
      var _defaultState = createDefaultState(nextProps);
      var keepFromPrevState = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: prevState.chartX,
        chartY: prevState.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: prevState.isTooltipActive
      };
      var updatesToState = _objectSpread42(_objectSpread42({}, getTooltipData(prevState, data2, layout)), {}, {
        updateId: prevState.updateId + 1
      });
      var newState = _objectSpread42(_objectSpread42(_objectSpread42({}, _defaultState), keepFromPrevState), updatesToState);
      return _objectSpread42(_objectSpread42(_objectSpread42({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread42({
        props: nextProps
      }, newState), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data2,
        prevWidth: width2,
        prevHeight: height2,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (!isChildrenEqual(children, prevState.prevChildren)) {
      var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
      var brush = findChildByType(children, Brush);
      var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
      var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
      var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
      var hasGlobalData = !(0, import_isNil12.default)(data2);
      var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
      return _objectSpread42(_objectSpread42({
        updateId: newUpdateId
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread42(_objectSpread42({
        props: nextProps
      }, prevState), {}, {
        updateId: newUpdateId,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      }), prevState)), {}, {
        prevChildren: children,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      });
    }
    return null;
  });
  _defineProperty47(CategoricalChartWrapper, "renderActiveDot", function(option, props, key2) {
    var dot;
    if (/* @__PURE__ */ isValidElement(option)) {
      dot = /* @__PURE__ */ cloneElement(option, props);
    } else if ((0, import_isFunction22.default)(option)) {
      dot = option(props);
    } else {
      dot = /* @__PURE__ */ React43.createElement(Dot, props);
    }
    return /* @__PURE__ */ React43.createElement(Layer, {
      className: "recharts-active-dot",
      key: key2
    }, dot);
  });
  var CategoricalChart = /* @__PURE__ */ forwardRef(function CategoricalChart2(props, ref) {
    return /* @__PURE__ */ React43.createElement(CategoricalChartWrapper, _extends33({}, props, {
      ref
    }));
  });
  CategoricalChart.displayName = CategoricalChartWrapper.displayName;
  return CategoricalChart;
};

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/LineChart.js
var LineChart = generateCategoricalChart({
  chartName: "LineChart",
  GraphicalChild: Line,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap3
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/BarChart.js
var BarChart = generateCategoricalChart({
  chartName: "BarChart",
  GraphicalChild: Bar,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap3
});

// node_modules/.pnpm/recharts@2.15.1_react-dom@19.0.0_react@19.0.0/node_modules/recharts/es6/chart/PieChart.js
var PieChart = generateCategoricalChart({
  chartName: "PieChart",
  GraphicalChild: Pie,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: PolarAngleAxis
  }, {
    axisType: "radiusAxis",
    AxisComp: PolarRadiusAxis
  }],
  formatAxisMap,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
function ChartContainer({ title, subtitle, containerClassName, titleClassName, subtitleClassName, children, shadow = "xs", border = false }) {
  return /* @__PURE__ */ jsxs(Card, { shadow, className: containerClassName, withBorder: border, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col pb-2 border-b border-gray-200", children: [
      title && /* @__PURE__ */ jsx("h2", { className: `text-lg font-semibold text-gray-800${titleClassName}`, children: title }),
      subtitle && /* @__PURE__ */ jsx("p", { className: `text-sm text-gray-700 ${subtitleClassName}`, children: subtitle })
    ] }),
    /* @__PURE__ */ jsx("div", { children })
  ] });
}
function BarChart2({
  variant = "simple",
  data: data2 = [],
  yAxisKey = "value",
  height: height2 = 300,
  width: width2 = 600,
  margin = { top: 20, right: 20, left: 0, bottom: 0 },
  colors: colors2 = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088fe", "#00C49F"],
  showGrid = true,
  showTooltip = true,
  showLegend = true,
  legendPosition = "bottom",
  barSize,
  barProps = {},
  horizontal = false,
  series,
  ...rest
}) {
  const layout = horizontal ? "vertical" : "horizontal";
  if (variant === "simple" && !series) {
    series = [{ dataKey: yAxisKey }];
  }
  if ((variant === "grouped" || variant === "stacked") && !series) {
    console.warn("Series data is required for grouped and stacked bar charts");
    series = [];
  }
  return /* @__PURE__ */ jsx(ChartContainer, { ...rest, children: /* @__PURE__ */ jsx(ResponsiveContainer, { width: width2, height: height2, children: /* @__PURE__ */ jsxs(
    BarChart,
    {
      data: data2,
      layout,
      margin,
      children: [
        showGrid && /* @__PURE__ */ jsx(CartesianGrid, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ jsx(
          XAxis,
          {
            type: horizontal ? "number" : "category",
            dataKey: horizontal ? void 0 : "name",
            tick: { fontSize: 12 }
          }
        ),
        /* @__PURE__ */ jsx(
          YAxis,
          {
            type: horizontal ? "category" : "number",
            dataKey: horizontal ? "name" : void 0,
            tick: { fontSize: 12 }
          }
        ),
        showTooltip && /* @__PURE__ */ jsx(Tooltip2, {}),
        showLegend && /* @__PURE__ */ jsx(Legend, { layout: "horizontal", verticalAlign: legendPosition }),
        series && series.map((s2, index2) => /* @__PURE__ */ jsx(
          Bar,
          {
            dataKey: s2.dataKey,
            name: s2.name || s2.dataKey,
            fill: s2.color || colors2[index2 % colors2.length],
            stackId: variant === "stacked" ? "stack" : void 0,
            barSize,
            ...barProps
          },
          s2.dataKey || index2
        ))
      ]
    }
  ) }) });
}
function PieChart2({
  variant = "pie",
  data: data2 = [],
  xAxisKey = "name",
  yAxisKey = "value",
  height: height2 = 300,
  width: width2 = "100%",
  margin = { top: 20, right: 30, left: 20, bottom: 5 },
  colors: colors2 = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088fe", "#00C49F"],
  showTooltip = true,
  showLegend = true,
  legendPosition = "bottom",
  innerRadius = 0,
  outerRadius = "80%",
  paddingAngle = 0,
  showLabels = false,
  labelPosition = "outside",
  sortValues,
  ...rest
}) {
  const pieData = [...data2];
  if (sortValues) {
    pieData.sort((a2, b) => {
      const valueA = a2[yAxisKey];
      const valueB = b[yAxisKey];
      return sortValues === "ascending" ? valueA - valueB : valueB - valueA;
    });
  }
  const calculatedInnerRadius = variant === "donut" ? typeof innerRadius === "number" && innerRadius > 0 ? innerRadius : "60%" : 0;
  const labelConfig = showLabels ? {
    label: true,
    labelLine: labelPosition === "outside"
  } : {
    label: false,
    labelLine: false
  };
  return /* @__PURE__ */ jsx(ChartContainer, { ...rest, children: /* @__PURE__ */ jsx(ResponsiveContainer, { width: width2, height: height2, children: /* @__PURE__ */ jsxs(PieChart, { margin, children: [
    showTooltip && /* @__PURE__ */ jsx(Tooltip2, {}),
    showLegend && /* @__PURE__ */ jsx(
      Legend,
      {
        layout: "horizontal",
        verticalAlign: legendPosition,
        align: "center"
      }
    ),
    /* @__PURE__ */ jsx(
      Pie,
      {
        data: pieData,
        dataKey: yAxisKey,
        nameKey: xAxisKey,
        cx: "50%",
        cy: "50%",
        innerRadius: calculatedInnerRadius,
        outerRadius,
        paddingAngle,
        ...labelConfig,
        children: pieData.map((entry, index2) => /* @__PURE__ */ jsx(
          Cell,
          {
            fill: colors2[index2 % colors2.length],
            name: entry[xAxisKey]
          },
          `cell-${index2}`
        ))
      }
    )
  ] }) }) });
}
function LineChart2({
  data: data2 = [],
  xAxisKey = "name",
  yAxisKey = "value",
  height: height2 = 300,
  width: width2 = "100%",
  margin = { top: 20, right: 0, left: 0, bottom: 0 },
  colors: colors2 = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088fe", "#00C49F"],
  showGrid = true,
  showTooltip = true,
  showLegend = true,
  legendPosition = "bottom",
  lineStyle = "solid",
  showPoints = true,
  pointSize = 5,
  pointStyle = "circle",
  area = false,
  areaOpacity = 0.2,
  series,
  ...rest
}) {
  if (!series) {
    series = [{ dataKey: yAxisKey }];
  }
  const getStrokeDashArray = (style) => {
    switch (style) {
      case "dashed":
        return "5 5";
      case "dotted":
        return "2 2";
      default:
        return "0";
    }
  };
  function CustomDot(props) {
    const { cx, cy, stroke, pointStyle: pointStyle2, pointSize: pointSize2 } = props;
    if (!showPoints)
      return null;
    switch (pointStyle2) {
      case "square":
        return /* @__PURE__ */ jsx(
          "rect",
          {
            x: cx - pointSize2 / 2,
            y: cy - pointSize2 / 2,
            width: pointSize2,
            height: pointSize2,
            fill: stroke,
            stroke: "none"
          }
        );
      case "diamond":
        return /* @__PURE__ */ jsx(
          "polygon",
          {
            points: `${cx},${cy - pointSize2} ${cx + pointSize2},${cy} ${cx},${cy + pointSize2} ${cx - pointSize2},${cy}`,
            fill: stroke,
            stroke: "none"
          }
        );
      case "triangle":
        return /* @__PURE__ */ jsx(
          "polygon",
          {
            points: `${cx},${cy - pointSize2} ${cx + pointSize2},${cy + pointSize2} ${cx - pointSize2},${cy + pointSize2}`,
            fill: stroke,
            stroke: "none"
          }
        );
      case "wye":
        return /* @__PURE__ */ jsx(
          "polygon",
          {
            points: `${cx},${cy - pointSize2} ${cx + pointSize2 / 2},${cy - pointSize2 / 4} ${cx + pointSize2},${cy - pointSize2 / 2} ${cx + pointSize2 / 2},${cy + pointSize2 / 4} ${cx},${cy + pointSize2} ${cx - pointSize2 / 2},${cy + pointSize2 / 4} ${cx - pointSize2},${cy - pointSize2 / 2} ${cx - pointSize2 / 2},${cy - pointSize2 / 4}`,
            fill: stroke,
            stroke: "none"
          }
        );
      case "none":
        return null;
      case "circle":
      default:
        return /* @__PURE__ */ jsx(
          "circle",
          {
            cx,
            cy,
            r: pointSize2,
            fill: stroke,
            stroke: "none"
          }
        );
    }
  }
  return /* @__PURE__ */ jsx(ChartContainer, { ...rest, children: /* @__PURE__ */ jsx(ResponsiveContainer, { width: width2, height: height2, children: /* @__PURE__ */ jsxs(LineChart, { data: data2, margin, children: [
    showGrid && /* @__PURE__ */ jsx(CartesianGrid, { strokeDasharray: "3 3" }),
    /* @__PURE__ */ jsx(
      XAxis,
      {
        dataKey: xAxisKey,
        tick: { fontSize: 12 },
        height: 40
      }
    ),
    /* @__PURE__ */ jsx(
      YAxis,
      {
        tick: { fontSize: 12 },
        width: 50
      }
    ),
    showTooltip && /* @__PURE__ */ jsx(Tooltip2, {}),
    showLegend && /* @__PURE__ */ jsx(
      Legend,
      {
        layout: "horizontal",
        verticalAlign: legendPosition,
        align: "center"
      }
    ),
    series.map((s2, index2) => area ? /* @__PURE__ */ jsx(
      Area,
      {
        type: "monotone",
        dataKey: s2.dataKey,
        name: s2.name || s2.dataKey,
        stroke: s2.color || colors2[index2 % colors2.length],
        fill: s2.color || colors2[index2 % colors2.length],
        strokeWidth: 2,
        strokeDasharray: getStrokeDashArray(lineStyle),
        dot: /* @__PURE__ */ jsx(CustomDot, { pointStyle, pointSize }),
        activeDot: { r: pointSize + 2 },
        fillOpacity: areaOpacity
      },
      s2.dataKey || index2
    ) : /* @__PURE__ */ jsx(
      Line,
      {
        type: "monotone",
        dataKey: s2.dataKey,
        name: s2.name || s2.dataKey,
        stroke: s2.color || colors2[index2 % colors2.length],
        strokeWidth: 2,
        strokeDasharray: getStrokeDashArray(lineStyle),
        dot: /* @__PURE__ */ jsx(CustomDot, { pointStyle, pointSize }),
        activeDot: { r: pointSize + 2 }
      },
      s2.dataKey || index2
    ))
  ] }) }) });
}
/**
 * @file text-input.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Atomic text-input component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file verified-animation.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Atomic verified-animation component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file logo.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Atomic logo component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file start-card.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular start-card component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file index.ts
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file file-preview.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular file-preview component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file file-input.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular file-input component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file modal-layout.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular modal-layout component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file empty-view.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular empty-view component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file filters-dropdown.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular filters-dropdown component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file loading-view.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular loading-view component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file sortable-th.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular sortable-th component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file table.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular table component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file time-range.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular time-range component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file table-wrapper.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular table-wrapper component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file radio-select.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular radio-select component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file notifications-popup.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular notifications-popup component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file profile-box.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular profile-box component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file topbar.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular topbar component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file ui-config.ts
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Provider for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file ui-provider.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Provider for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file breadcrumb.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Molecular breadcrumb component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file navigation.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Organism navigation component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file dashboard-layout.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Organism dashboard-layout component for Ministry of Health UI
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file tailwind-preset.ts
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file chart-container.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file bar-chart.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file pie-chart.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/**
 * @file line-chart.tsx
 * @author Mutesa Cedric <mutesacedric@gmail.com>
 * @copyright Copyright (c) 2025 Mutesa Cedric
 * @description Module for Ministry of Health UI library
 * @version 1.0.0
 * @license MIT
 */
/*! Bundled license information:

lottie-web/build/player/lottie.js:
  (*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   *)

react-is/cjs/react-is.production.min.js:
  (**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

lottie-react/build/index.es.js:
  (*! goToAndStop must be relative to the start of the current segment *)
*/

export { BarChart2 as BarChart, Breadcrumb, DashboardLayout, EmptyView, FileInput, FilePreview, FiltersDropdown, LineChart2 as LineChart, LoadingView, Logo, ModalLayout, Navigation, PieChart2 as PieChart, RadioSelect, StatCard, TableWrapper, TextInput, TimeRange, Topbar, UIProvider, VerifiedAnimation, getObjValue, imageFileToBase64, tailwind_preset_default as tailwindPreset, useMohUI };
